// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/MaterialIcons-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/MaterialIcons-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/MaterialIcons-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/MaterialIcons-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/icons/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/icons/x-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/footer-arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/bg/Map-thirteen.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/footer-fift-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/map-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/search-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/location.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/search.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/banner-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/icons/header-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/bg/doctor-shape-img1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/bg/doctor-shape-img2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/app-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../assets/images/icons/down-arrow-gray-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../assets/images/icons/down-arrow-gray.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../assets/images/icons/search-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../assets/images/icons/tick-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../assets/images/flags/in.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../assets/images/flags/ng.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../assets/images/flags/gb.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../../assets/images/flags/us.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../images/banner-2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../images/specialist-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../images/featured-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../images/banner-3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../images/special-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../images/shapes/doctor-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../images/shapes/doctor-right-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../images/slider/banner-02.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../images/bg/home-10-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../images/icons/hex-shape.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../images/bg/service-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../images/bg/map.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../images/bg/pricing-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../images/bg/banner-11-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../images/bg/app-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../images/icons/test-line.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../images/bg/store-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../images/bg/header-after.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../images/check.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../images/bg/home-13-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../images/cloud-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../images/feedback-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../images/chooseus-ryt-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../images/chooseus-ryt-2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../images/banner-fifteen.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../images/book-appointment-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../images/banner-sixteen-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../images/google-map.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../images/mail-box.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../images/icons/phone.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../images/icons/password-duotone.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../images/icons/fluent-password.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/****** UTILS ******/
/*** default values ***/
/***** custom values *****/
/***** Grid Values *****/
/** Extends **/
.upload-wrap,
.login-page .login-right,
.listing-day,
.doctor-action,
.doc-times,
.css-equal-content,
.css-equal-heights {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
}

.css-equal-content {
  color: red;
  float: left;
}

.time-slot li .timing,
.consultation-types a,
.coming-soon-info,
.widget-setcount .step-icon,
.widget-setcount .step-box,
.signup-arrow,
.why-choose-icon span,
.about-contact-icon span,
.pricing-icon span,
.plan-choose-info,
.product-custom .cart-icon,
.section-search-pharmacy .banner-wrapper2 .search-box1 form,
.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two,
.facts-section-sixteen
  .facts-section-all
  .facts-content-all
  ul
  li
  .facts-sixteen-img
  .facts-content-sixteen
  .facts-content-one,
.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-sixteen-img,
.facts-section-sixteen .facts-section-all .facts-content-all ul li,
.item.item-fifteen .doctor-profile-widget .doc-pro-img .doctor-amount .fav-icon,
.doc-content-fift .rate-fifteen ul li,
.doc-content-fift .rate-fifteen ul,
.doc-content-fift .rate-fifteen .rate-four,
.Patients-section-fifteen .service-patient-inflict .clients-fifteen-span,
.Patients-section-fifteen .service-patient-inflict .service-patient-inflictimg,
.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg a .playicon span,
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content,
.section-header-thirteen,
.main-wrapper.home-twelve.home-thirteen
  .choose-us-section-thirteen
  ul
  li
  .choose-us-content-thirteen
  .chooseus-contents,
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  p
  i,
.main-wrapper.home-twelve.home-thirteen
  .services-section-thirteen
  .service-thirteen-main
  .service-thirteen-all,
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content,
.testi-img .testi-icon,
.faq-wrap ul li a span,
.count-box .count-icon,
.center-img .center-service span,
.main-wrapper.home-ten
  .specialities-section-one
  .specialities-block
  ul
  li
  .specialities-img
  .hexogen,
.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item,
.book-section .book-best-doctors .book-header .img-overlay,
.browse-section .brower-box > div .brower-img,
.clinic-specialities .special-box:hover .special-body,
.doctor-category .pop-box .body-section,
.doctor-category .pop-box .top-section i,
.doctor-category .pop-box .top-section,
.doctor-widget-one .clinic-booking .btn-primary-light,
.view-icons a,
.voice-call-avatar,
.toggle-password-sub,
.pass-group .toggle-password,
.login-content-info .account-content .social-login-btn .btn,
.increment-decrement .input-groups input[type="button"],
.profile-pic-upload .cam-col,
.step-list ul li a,
.call-box .call-wrapper .call-items,
.chat-attachment-item,
.chat-window .chat-cont-right .chat-header .media .media-img-wrap,
.chat-window .chat-cont-right .chat-header,
.chat-window,
.signature,
.btn.btn-danger.trash,
.time-slot.time-slot-blk li .timing,
.visits span.visit-rsn:before,
.hours-info .btn.btn-danger.trash,
.blogs-section .blog-wrapper .wrap-content .date-cart,
.partners-slider li a,
.work-info .work-icon span,
.specialities-section-one .specialities-img span,
.specialities-section-one .specialities-item,
.profile-widget .fav-btn,
.section-specialities .specialities-slider .speicality-item .speicality-img span,
.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul li a,
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-fift-selects
  .social-icon
  ul
  li
  a,
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .user-details-fift
  ul
  li
  .contact-fifteen
  .contact-form-fift,
.footer-contacts .footer-wrap .footer-icon,
.footer-three .social-icon ul li a,
.footer-one .footer-top .footer-widget .footer-contact-info .footer-address p,
.header.header-fourteen .header-nav .header-navbar-rht li.searchbar-fourteen a,
.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.searchbar-fourteen,
.header.header-ten .main-menu-wrapper .main-nav .register-btn,
.header.header-ten .main-menu-wrapper .main-nav li .btn.log-btn,
.header.header-ten .main-menu-wrapper .main-nav li .btn.reg-btn,
.header-one .main-menu-wrapper .main-nav .register-btn,
.header-one .main-menu-wrapper .main-nav li .btn.log-btn,
.header-one .main-menu-wrapper .main-nav li .btn.reg-btn,
.header.custom .header-navbar-rht.right-menu .header-contact-img i,
.header .header-nav,
.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone,
.brower-box a,
.clinic-slider .profile-widget .brower-box .arrow,
.browse-slider .profile-widget .brower-box .arrow,
.book-slider .profile-widget .brower-box .arrow,
.clinic-slider .profile-widget .brower-box a,
.browse-slider .profile-widget .brower-box a,
.book-slider .profile-widget .brower-box a,
.slick-dots .slick-dots li,
.dot-slider .slick-dots li,
.align-center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}

.form-group-flex,
.otp-info,
.otp-box .form-group,
.signup-option-btns .signup-btn-info,
.booking-list,
.doc-content-fift .fift-bottom-content,
.doc-content-fift .rate-fifteen,
.services-section-fifteen .doctor-profile-widget-fifteen .doc-content-bottom .doc-content-split,
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  .our-doctor-content-inner,
.store-item .store-content .price-tag,
.testi-users,
.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay,
.doctor-filter-inner,
.booking-doctor-details,
.faq-patients-count,
.doc-pro-info,
.footer-three .footer-bottom .copyright .footer-language,
.header.header-ten .header-nav,
.header-one .header-nav {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}

.terms-btn .btn,
.otp-sec p,
.testimonial-slider .slick-prev,
.testimonial-slider .slick-next,
.special-item .special-icon a,
.doctor-profile-widget.doc-grid .favourite-btn .favourite-icon,
.doctor-widget-one .favourite-btn .favourite-icon,
.doctor-filter-sort .nav li a,
.faq-info .accordion-button:after,
.reviews-ratings span,
.slide-nav-1 button.owl-next,
.slide-nav-1 button.owl-prev,
.slide-nav-2 button.owl-next,
.slide-nav-2 button.owl-prev {
  display: inline-flex;
  display: -webkit-inline-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}

.widget-setcount ul,
.onboarding-content .increment-decrement .input-groups input[type="button"],
.relative-form,
.option-set,
.select-gender-option,
.onboarding-contents,
.opt-resend,
.set-path,
.prefer-box,
.call-lable.verify-lable.verify-options,
.call-lable.verify-lable.verify-lable,
.call-lable,
.consult-option,
.save-detail,
.upload-pic.patient-photo-upload,
.upload-pic,
.onboarding-content-box.content-wrap,
.onboarding-progress,
.on-board-wizard ul li a,
#onboard-slider .owl-dots,
.right-panel,
.left-panel,
.onboard-wrapper,
.full-slide-home .slick-slide .slide-image,
.full-slide-home .slick-slide > div > .col-12,
.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul,
.banner-wrapper .search-box-3 form,
.map-listing .profile-widget,
.doctor-widget-one .doc-info-left,
.doctor-widget-one,
.clinic-services,
.doc-info-left,
.doctor-widget,
.call-timing,
.call-details,
.password-strength,
.increment-decrement .input-groups,
.login-bottom-copyright,
.custom-increment .input-group1,
chat-attachment-list,
.chat-msg-attachments,
.chat-window .chat-msg-info,
.chat-window .chat-cont-right .chat-body .media.sent .media-body,
.chat-window .chat-cont-right .chat-header .chat-options,
.chat-window .chat-cont-left .chat-users-list a.media .media-body,
.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend,
.chat-window .chat-cont-left .chat-header,
.patient-graph-col .graph-box .graph-status-result,
.patient-graph-col .graph-box,
.patient-graph-box,
.patient-dashboard-top,
.change-avatar,
.profile-info-widget,
.dash-card .dash-widget,
.upload-wrap,
.review-listing > ul li .comment .comment-body .meta-data .review-count,
.review-listing > ul li .comment,
.appointments .appointment-list,
.appointment-list .profile-info-widget,
.booking-device,
.success-page-cont,
.booking-doc-info,
.work-info,
.section-search .banner-wrapper .search-box form,
.footer-two .footer-top .footer-widget .footer-contact-info .footer-address,
.footer-one .footer-top .footer-widget .footer-contact-info .footer-address,
.footer .footer-top .footer-widget .footer-contact-info .footer-address,
.header.header-ten .main-menu-wrapper .main-nav,
.header-one .main-menu-wrapper .main-nav,
.header .header-nav .header-navbar-rht .has-arrow .user-header,
.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item,
.header .header-nav .main-nav,
.header .header-nav,
.avatar .avatar-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.success-btn .btn,
.terms-section .terms-content .terms-text.terms-list p,
.error-content .btn,
.way-inner-header .btn,
.breadcrumb-bar-two .page-breadcrumb ol,
.booking-btn .btn,
.doctor-search-section.doctor-search-eleven .banner-header .btn,
.breadcrumb-bar-one .page-breadcrumb ol,
.specialities-section-one .specialities-btn .btn,
.footer-one .social-icon ul li a,
.footer-one .social-icon ul,
.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul li a,
.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

.booking-date,
.consultation-types,
.contact-card .card-body,
.signup-info,
.testimonial-info,
.about-contact,
.pricing-header-info,
.booking-doctor-right p,
.booking-doctor-left,
.faq-wrap ul li a,
.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name,
.count-box,
.doctor-widget-one .clini-infos ul li,
.doctor-widget-one .doc-location,
.doctor-filter-sort,
.doctor-filter-option,
.doctor-filter-availability,
.filter-grid h4 a,
.booking-range .btn,
.booking-date.choose-date-book,
.articles-info,
.doc-pro-location p,
.footer-contacts .footer-wrap,
.footer-one .footer-top .footer-widget.footer-menu ul li a,
.flag-dropdown .dropdown-menu .dropdown-item,
.flag-dropdown .dropdown-toggle {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}

.success-dashboard-link a,
.custom_radio,
.booking-date-list ul li span,
.center-img .center-service,
.doctor-widget-one .doc-name,
.login-content-info .account-content .login-back a,
.back-link a,
.articles-content .articles-list li,
.reviews-ratings p {
  display: inline-flex;
  display: -webkit-inline-flex;
  align-items: center;
  -webkit-align-items: center;
}

.widget-setcount ul,
.booking-list {
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
}

.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item,
.chat-window .chat-cont-right .chat-body .media.sent .media-body,
.specialities-section-one .specialities-item {
  flex-direction: column;
}

.flag-dropdown .dropdown-toggle {
  justify-content: start;
  -webkit-justify-content: start;
}

.widget-setcount ul,
.relative-form,
.prefer-box,
.onboarding-content-box.content-wrap,
.left-panel {
  justify-content: space-between;
  -webkit-justify-content: space-between;
}

.terms-section .terms-content .terms-text.terms-list p,
.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: start;
}

.chat-window .chat-cont-right .chat-header,
.chat-window .chat-cont-left .chat-users-list a.media .media-body,
.chat-window .chat-cont-left .chat-header,
.listing-day,
.header.header-ten .menu-header,
.header-one .menu-header,
.header .header-nav .menu-header,
.header .header-nav {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

.store-tab,
.doctor-divison .pat-background,
.doctor-divison .doc-background,
.login-bottom-copyright,
.custom-increment.cart .input-group1,
.btn-file,
.chat-attachment-item,
.chat-window .chat-cont-right .chat-header .chat-options > a,
.success-cont i,
.hours-info .btn.btn-danger.trash,
.profile-widget .fav-btn,
.section-specialities .specialities-slider .speicality-item .speicality-img span,
.header .header-nav .header-navbar-rht li,
.avatar .avatar-title,
.btn-icon {
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}

.increment-decrement .input-groups,
.login-page .login-right,
.btn-file,
.chat-window .chat-msg-info,
.chat-window .chat-cont-right .chat-header .chat-options > a,
.chat-window .chat-cont-right .chat-header .media,
.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend,
.chat-window .chat-cont-left .chat-header,
.signature,
.change-avatar,
.dash-card .dash-widget,
.btn.btn-danger.trash,
.appointments .appointment-action,
.success-cont i,
.success-page-cont,
.header.header-ten .menu-header,
.header-one .menu-header,
.header .header-nav .header-navbar-rht .has-arrow.logged-item .nav-link,
.header .header-nav .header-navbar-rht .has-arrow .logged-item .nav-link,
.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item,
.header .header-nav .header-navbar-rht li,
.header .header-nav .menu-header,
table.table td h2.table-avatar,
table.table td h2 .table-avatar,
.avatar .avatar-title,
.btn-icon {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.listing-day {
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
}

.doctor-divison .pat-background,
.doctor-divison .doc-background,
.btn-file,
.chat-window .chat-cont-right .chat-header .chat-options > a,
.chat-window .chat-cont-left .chat-header .chat-compose,
.appointments .appointment-action,
.success-cont i,
.profile-widget .fav-btn,
.section-specialities .specialities-slider .speicality-item .speicality-img span,
.footer .footer-top .footer-widget .footer-about-content .social-icon ul li a,
.footer .footer-top .footer-widget .footer-about-content .social-icon ul,
.header .header-nav .header-navbar-rht .has-arrow.logged-item .nav-link,
.header .header-nav .header-navbar-rht .has-arrow .logged-item .nav-link,
.header .header-nav .header-navbar-rht li,
table.table td h2.table-avatar,
table.table td h2 .table-avatar,
.avatar-group,
.btn-icon {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

.widget-setcount ul,
.onboarding-content .increment-decrement .input-groups input[type="button"],
.relative-form,
.option-set,
.select-gender-option,
.onboarding-contents,
.opt-resend,
.set-path,
.prefer-box,
.call-lable.verify-lable.verify-options,
.call-lable.verify-lable.verify-lable,
.call-lable,
.consult-option,
.save-detail,
.upload-pic.patient-photo-upload,
.upload-pic,
.onboarding-content-box.content-wrap,
.onboarding-progress,
.on-board-wizard ul li a,
#onboard-slider .owl-dots,
.right-panel,
.left-panel,
.onboard-wrapper,
.full-slide-home .slick-slide .slide-image,
.full-slide-home .slick-slide > div > .col-12,
.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul,
.banner-wrapper .search-box-3 form,
.map-listing .profile-widget,
.doctor-widget-one .doc-info-left,
.doctor-widget-one,
.clinic-services,
.doc-info-left,
.doctor-widget,
.call-timing,
.call-details,
.password-strength,
.increment-decrement .input-groups,
.login-bottom-copyright,
.custom-increment .input-group1,
chat-attachment-list,
.chat-msg-attachments,
.chat-window .chat-msg-info,
.chat-window .chat-cont-right .chat-body .media.sent .media-body,
.chat-window .chat-cont-right .chat-header .chat-options,
.chat-window .chat-cont-left .chat-users-list a.media .media-body,
.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend,
.chat-window .chat-cont-left .chat-header,
.patient-graph-col .graph-box .graph-status-result,
.patient-graph-col .graph-box,
.patient-graph-box,
.patient-dashboard-top,
.change-avatar,
.profile-info-widget,
.dash-card .dash-widget,
.upload-wrap,
.review-listing > ul li .comment .comment-body .meta-data .review-count,
.review-listing > ul li .comment,
.appointments .appointment-list,
.appointment-list .profile-info-widget,
.booking-device,
.success-page-cont,
.booking-doc-info,
.work-info,
.section-search .banner-wrapper .search-box form,
.footer-two .footer-top .footer-widget .footer-contact-info .footer-address,
.footer-one .footer-top .footer-widget .footer-contact-info .footer-address,
.footer .footer-top .footer-widget .footer-contact-info .footer-address,
.header.header-ten .main-menu-wrapper .main-nav,
.header-one .main-menu-wrapper .main-nav,
.header .header-nav .header-navbar-rht .has-arrow .user-header,
.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item,
.header .header-nav .main-nav,
.header .header-nav,
.avatar .avatar-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.payment-radio,
.custom_radio,
.custom_check,
.slick-slider {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.right-panel,
.section-search-pharmacy .banner-wrapper2 .search-box1 form,
.full-slide-home .slick-slide > div > .col-12,
.clinic-services,
.chat-window .chat-msg-info,
.patient-graph-col .graph-box .graph-status-result,
.patient-graph-col .graph-box,
.appointments .appointment-list,
.schedule-nav .nav-tabs,
.post-left ul,
.header.header-ten .header-nav,
.header-one .header-nav,
.header .header-nav,
.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item,
.chat-window .chat-cont-right .chat-body .media.sent .media-body,
.specialities-section-one .specialities-item {
  -ms-flex-direction: column;
  flex-direction: column;
}

.chat-window .chat-cont-right .chat-body .media.sent .media-body,
.patient-graph-col .graph-box .graph-status-result {
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
}

.chat-window .chat-cont-right .chat-body .media.sent .media-body,
.patient-graph-col .graph-box .graph-status-result {
  -webkit-box-align: flex-end;
  -ms-flex-align: flex-end;
  align-items: flex-end;
}

.upload-wrap,
.day-week-month-col ul,
.payment-menthods ul,
.step-list ul,
.header-top ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

/******* BASE *******/
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  border: 0;
}

* {
  box-sizing: border-box;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  height: 100%;
  overflow-x: hidden;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after {
  content: "";
  content: none;
}

q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

@font-face {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* For IE6-8 */
  src:
    local("Material Icons"),
    local("MaterialIcons-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "liga";
}

h1 {
  font-weight: normal;
  font-size: 40px;
}
@media (max-width: 767.98px) {
  h1 {
    font-size: 27px;
  }
}

h2 {
  font-weight: normal;
  font-size: 30px;
}
@media (max-width: 767.98px) {
  h2 {
    font-size: 23px;
  }
}

h3 {
  font-weight: normal;
  font-size: 24px;
}
@media (max-width: 1023.98px) {
  h3 {
    font-size: 20px;
  }
}
@media (max-width: 767.98px) {
  h3 {
    font-size: 16px;
  }
}

h4 {
  font-weight: normal;
  font-size: 18px;
}
@media (max-width: 1023.98px) {
  h4 {
    font-size: 18px;
  }
}
@media (max-width: 767.98px) {
  h4 {
    font-size: 18px;
  }
}

h5 {
  font-weight: normal;
  font-size: 19px;
}
@media (max-width: 1023.98px) {
  h5 {
    font-size: 18px;
  }
}

h6 {
  font-weight: normal;
  font-size: 18px;
}
@media (max-width: 1023.98px) {
  h6 {
    font-size: 16px;
  }
}

.primary {
  background-color: #09e5ab;
}

html {
  height: 100%;
}

body {
  font-family: "Poppins", sans-serif;
  background-color: #ffffff;
  font-size: 0.9375rem;
  color: #6b7280;
  line-height: 1.5;
  height: 100%;
  overflow-x: hidden;
}
@media (max-width: 767.98px) {
  body {
    font-size: 14px;
  }
}
@media (max-width: 575.98px) {
  body {
    font-size: 13px;
  }
}

img {
  max-width: 100%;
  height: auto;
}

a {
  color: #2e3842;
  cursor: pointer;
  -webkit-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
  text-decoration: none;
}
a:hover {
  color: #09e5ab;
  -webkit-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
  text-decoration: none;
}
a:focus {
  outline: 0;
}

.green .intro_text a:hover {
  color: #09e5ab;
  -webkit-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

p {
  margin-top: 0;
  margin-bottom: 16px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: #272b41;
  font-weight: 500;
}

.h1,
h1 {
  font-size: 2.25rem;
}
@media (max-width: 767.98px) {
  .h1,
  h1 {
    font-size: 32px;
  }
}
@media (max-width: 575.98px) {
  .h1,
  h1 {
    font-size: 28px;
  }
}

.h2,
h2 {
  font-size: 30px;
}
@media (max-width: 767.98px) {
  .h2,
  h2 {
    font-size: 28px;
  }
}
@media (max-width: 575.98px) {
  .h2,
  h2 {
    font-size: 24px;
  }
}

.h3,
h3 {
  font-size: 1.5rem;
}
@media (max-width: 767.98px) {
  .h3,
  h3 {
    font-size: 22px;
  }
}
@media (max-width: 575.98px) {
  .h3,
  h3 {
    font-size: 20px;
  }
}

.h4,
h4 {
  font-size: 18px;
}
@media (max-width: 767.98px) {
  .h4,
  h4 {
    font-size: 16px;
  }
}
@media (max-width: 575.98px) {
  .h4,
  h4 {
    font-size: 16px;
  }
}

.h5,
h5 {
  font-size: 1rem;
}
@media (max-width: 767.98px) {
  .h5,
  h5 {
    font-size: 14px;
  }
}
@media (max-width: 575.98px) {
  .h5,
  h5 {
    font-size: 14px;
  }
}

.h6,
h6 {
  font-size: 14px;
}
@media (max-width: 767.98px) {
  .h6,
  h6 {
    font-size: 12px;
  }
}
@media (max-width: 575.98px) {
  .h6,
  h6 {
    font-size: 12px;
  }
}

.btn-primary {
  background-color: #00d0f1;
  border: 1px solid #00d0f1;
}
.btn-primary:hover {
  background-color: #09dca4;
  border: 1px solid #09dca4;
}

.container-fluid {
  padding: 0 30px;
}
@media (max-width: 1199.98px) {
  .container-fluid {
    padding: 0 20px;
  }
}
@media (max-width: 991.98px) {
  .container-fluid {
    padding: 0 20px;
  }
}
@media (max-width: 767.98px) {
  .container-fluid {
    padding: 0 15px;
  }
}

.form-group {
  margin-bottom: 20px;
}

.text-muted {
  color: #757575 !important;
}

.dropdown-menu {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 14px;
  border-radius: 3px;
  -webkit-box-shadow: inherit;
  -moz-box-shadow: inherit;
  box-shadow: inherit;
  transform-origin: left top 0;
  -webkit-transform-origin: left top 0;
  -ms-transform-origin: left top 0;
}

@media (max-width: 1399.98px) {
  .row.row-grid {
    margin-left: -8px;
    margin-right: -8px;
  }
}
@media (max-width: 1399.98px) {
  .row.row-grid > div {
    padding-right: 8px;
    padding-left: 8px;
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
}
@media (max-width: 1199.98px) {
  .row.row-grid > div {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (max-width: 849.98px) {
  .row.row-grid > div {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (max-width: 767.98px) {
  .row.row-grid > div {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (max-width: 575.98px) {
  .row.row-grid > div {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.text-sm {
  font-size: 14px !important;
}

.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "liga";
}

.small,
small {
  font-size: 80%;
  font-weight: 400;
}

a {
  color: #2e3842;
}
a:hover {
  color: #09dca4;
}
a:hover,
a:focus,
a.active {
  outline: none;
  text-decoration: none;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  box-shadow: 0 0 0px 1000px white inset !important;
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}
input[type="text"],
input[type="password"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

input,
button,
a {
  -webkit-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

button:focus {
  outline: 0;
}

.btn:focus,
.btn.focus {
  box-shadow: inherit;
}

.form-control {
  border-color: #dcdcdc;
  color: #333333;
  font-size: 15px;
  min-height: 46px;
  padding: 6px 15px;
}
.form-control:focus {
  border-color: #bbb;
  box-shadow: none;
  outline: 0 none;
}
.form-control::-webkit-input-placeholder,
.form-control::-moz-placeholder,
.form-control:-ms-input-placeholder,
.form-control::-ms-input-placeholder,
.form-control::placeholder {
  color: #858585;
  font-size: 14px;
}
.form-control::placeholder {
  color: #858585;
  font-size: 14px;
}

.table .form-control {
  font-size: 14px;
  min-height: 38px;
}

.list-group-item {
  border: 1px solid #f0f0f0;
}

@media (max-width: 991.98px) {
  .container {
    max-width: 100%;
  }
}

.form-custom {
  position: relative;
}
.form-custom i {
  color: #dd2d4e;
  position: absolute;
  top: 35%;
  right: 15px;
}

/*** default values ***/
/***** custom values *****/
/***** Grid Values *****/
/** Extends **/
.upload-wrap,
.login-page .login-right,
.listing-day,
.doctor-action,
.doc-times,
.css-equal-heights,
.css-equal-content {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
}

.css-equal-content {
  color: red;
  float: left;
}

.time-slot li .timing,
.consultation-types a,
.coming-soon-info,
.widget-setcount .step-icon,
.widget-setcount .step-box,
.signup-arrow,
.why-choose-icon span,
.about-contact-icon span,
.pricing-icon span,
.plan-choose-info,
.product-custom .cart-icon,
.section-search-pharmacy .banner-wrapper2 .search-box1 form,
.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two,
.facts-section-sixteen
  .facts-section-all
  .facts-content-all
  ul
  li
  .facts-sixteen-img
  .facts-content-sixteen
  .facts-content-one,
.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-sixteen-img,
.facts-section-sixteen .facts-section-all .facts-content-all ul li,
.item.item-fifteen .doctor-profile-widget .doc-pro-img .doctor-amount .fav-icon,
.doc-content-fift .rate-fifteen ul li,
.doc-content-fift .rate-fifteen ul,
.doc-content-fift .rate-fifteen .rate-four,
.Patients-section-fifteen .service-patient-inflict .clients-fifteen-span,
.Patients-section-fifteen .service-patient-inflict .service-patient-inflictimg,
.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg a .playicon span,
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content,
.section-header-thirteen,
.main-wrapper.home-twelve.home-thirteen
  .choose-us-section-thirteen
  ul
  li
  .choose-us-content-thirteen
  .chooseus-contents,
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  p
  i,
.main-wrapper.home-twelve.home-thirteen
  .services-section-thirteen
  .service-thirteen-main
  .service-thirteen-all,
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content,
.testi-img .testi-icon,
.faq-wrap ul li a span,
.count-box .count-icon,
.center-img .center-service span,
.main-wrapper.home-ten
  .specialities-section-one
  .specialities-block
  ul
  li
  .specialities-img
  .hexogen,
.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item,
.book-section .book-best-doctors .book-header .img-overlay,
.browse-section .brower-box > div .brower-img,
.clinic-specialities .special-box:hover .special-body,
.doctor-category .pop-box .body-section,
.doctor-category .pop-box .top-section i,
.doctor-category .pop-box .top-section,
.doctor-widget-one .clinic-booking .btn-primary-light,
.view-icons a,
.voice-call-avatar,
.toggle-password-sub,
.pass-group .toggle-password,
.login-content-info .account-content .social-login-btn .btn,
.increment-decrement .input-groups input[type="button"],
.profile-pic-upload .cam-col,
.step-list ul li a,
.call-box .call-wrapper .call-items,
.chat-attachment-item,
.chat-window .chat-cont-right .chat-header .media .media-img-wrap,
.chat-window .chat-cont-right .chat-header,
.chat-window,
.signature,
.btn.btn-danger.trash,
.time-slot.time-slot-blk li .timing,
.visits span.visit-rsn:before,
.hours-info .btn.btn-danger.trash,
.blogs-section .blog-wrapper .wrap-content .date-cart,
.partners-slider li a,
.work-info .work-icon span,
.specialities-section-one .specialities-img span,
.specialities-section-one .specialities-item,
.profile-widget .fav-btn,
.section-specialities .specialities-slider .speicality-item .speicality-img span,
.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul li a,
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-fift-selects
  .social-icon
  ul
  li
  a,
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .user-details-fift
  ul
  li
  .contact-fifteen
  .contact-form-fift,
.footer-contacts .footer-wrap .footer-icon,
.footer-three .social-icon ul li a,
.footer-one .footer-top .footer-widget .footer-contact-info .footer-address p,
.header.header-fourteen .header-nav .header-navbar-rht li.searchbar-fourteen a,
.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.searchbar-fourteen,
.header.header-ten .main-menu-wrapper .main-nav .register-btn,
.header.header-ten .main-menu-wrapper .main-nav li .btn.log-btn,
.header.header-ten .main-menu-wrapper .main-nav li .btn.reg-btn,
.header-one .main-menu-wrapper .main-nav .register-btn,
.header-one .main-menu-wrapper .main-nav li .btn.log-btn,
.header-one .main-menu-wrapper .main-nav li .btn.reg-btn,
.header.custom .header-navbar-rht.right-menu .header-contact-img i,
.header .header-nav,
.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone,
.brower-box a,
.clinic-slider .profile-widget .brower-box .arrow,
.browse-slider .profile-widget .brower-box .arrow,
.book-slider .profile-widget .brower-box .arrow,
.clinic-slider .profile-widget .brower-box a,
.browse-slider .profile-widget .brower-box a,
.book-slider .profile-widget .brower-box a,
.slick-dots .slick-dots li,
.dot-slider .slick-dots li,
.align-center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}

.form-group-flex,
.otp-info,
.otp-box .form-group,
.signup-option-btns .signup-btn-info,
.booking-list,
.doc-content-fift .fift-bottom-content,
.doc-content-fift .rate-fifteen,
.services-section-fifteen .doctor-profile-widget-fifteen .doc-content-bottom .doc-content-split,
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  .our-doctor-content-inner,
.store-item .store-content .price-tag,
.testi-users,
.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay,
.doctor-filter-inner,
.booking-doctor-details,
.faq-patients-count,
.doc-pro-info,
.footer-three .footer-bottom .copyright .footer-language,
.header.header-ten .header-nav,
.header-one .header-nav {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}

.terms-btn .btn,
.otp-sec p,
.testimonial-slider .slick-prev,
.testimonial-slider .slick-next,
.special-item .special-icon a,
.doctor-profile-widget.doc-grid .favourite-btn .favourite-icon,
.doctor-widget-one .favourite-btn .favourite-icon,
.doctor-filter-sort .nav li a,
.faq-info .accordion-button:after,
.reviews-ratings span,
.slide-nav-1 button.owl-next,
.slide-nav-1 button.owl-prev,
.slide-nav-2 button.owl-next,
.slide-nav-2 button.owl-prev {
  display: inline-flex;
  display: -webkit-inline-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}

.widget-setcount ul,
.onboarding-content .increment-decrement .input-groups input[type="button"],
.relative-form,
.option-set,
.select-gender-option,
.onboarding-contents,
.opt-resend,
.set-path,
.prefer-box,
.call-lable.verify-lable.verify-options,
.call-lable.verify-lable.verify-lable,
.call-lable,
.consult-option,
.save-detail,
.upload-pic.patient-photo-upload,
.upload-pic,
.onboarding-content-box.content-wrap,
.onboarding-progress,
.on-board-wizard ul li a,
#onboard-slider .owl-dots,
.right-panel,
.left-panel,
.onboard-wrapper,
.full-slide-home .slick-slide .slide-image,
.full-slide-home .slick-slide > div > .col-12,
.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul,
.banner-wrapper .search-box-3 form,
.map-listing .profile-widget,
.doctor-widget-one .doc-info-left,
.doctor-widget-one,
.clinic-services,
.doc-info-left,
.doctor-widget,
.call-timing,
.call-details,
.password-strength,
.increment-decrement .input-groups,
.login-bottom-copyright,
.custom-increment .input-group1,
chat-attachment-list,
.chat-msg-attachments,
.chat-window .chat-msg-info,
.chat-window .chat-cont-right .chat-body .media.sent .media-body,
.chat-window .chat-cont-right .chat-header .chat-options,
.chat-window .chat-cont-left .chat-users-list a.media .media-body,
.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend,
.chat-window .chat-cont-left .chat-header,
.patient-graph-col .graph-box .graph-status-result,
.patient-graph-col .graph-box,
.patient-graph-box,
.patient-dashboard-top,
.change-avatar,
.profile-info-widget,
.dash-card .dash-widget,
.upload-wrap,
.review-listing > ul li .comment .comment-body .meta-data .review-count,
.review-listing > ul li .comment,
.appointments .appointment-list,
.appointment-list .profile-info-widget,
.booking-device,
.success-page-cont,
.booking-doc-info,
.work-info,
.section-search .banner-wrapper .search-box form,
.footer-two .footer-top .footer-widget .footer-contact-info .footer-address,
.footer-one .footer-top .footer-widget .footer-contact-info .footer-address,
.footer .footer-top .footer-widget .footer-contact-info .footer-address,
.header.header-ten .main-menu-wrapper .main-nav,
.header-one .main-menu-wrapper .main-nav,
.header .header-nav .header-navbar-rht .has-arrow .user-header,
.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item,
.header .header-nav .main-nav,
.header .header-nav,
.avatar .avatar-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.success-btn .btn,
.terms-section .terms-content .terms-text.terms-list p,
.error-content .btn,
.way-inner-header .btn,
.breadcrumb-bar-two .page-breadcrumb ol,
.booking-btn .btn,
.doctor-search-section.doctor-search-eleven .banner-header .btn,
.breadcrumb-bar-one .page-breadcrumb ol,
.specialities-section-one .specialities-btn .btn,
.footer-one .social-icon ul li a,
.footer-one .social-icon ul,
.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul li a,
.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

.booking-date,
.consultation-types,
.contact-card .card-body,
.signup-info,
.testimonial-info,
.about-contact,
.pricing-header-info,
.booking-doctor-right p,
.booking-doctor-left,
.faq-wrap ul li a,
.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name,
.count-box,
.doctor-widget-one .clini-infos ul li,
.doctor-widget-one .doc-location,
.doctor-filter-sort,
.doctor-filter-option,
.doctor-filter-availability,
.filter-grid h4 a,
.booking-range .btn,
.booking-date.choose-date-book,
.articles-info,
.doc-pro-location p,
.footer-contacts .footer-wrap,
.footer-one .footer-top .footer-widget.footer-menu ul li a,
.flag-dropdown .dropdown-menu .dropdown-item,
.flag-dropdown .dropdown-toggle {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}

.success-dashboard-link a,
.custom_radio,
.booking-date-list ul li span,
.center-img .center-service,
.doctor-widget-one .doc-name,
.login-content-info .account-content .login-back a,
.back-link a,
.articles-content .articles-list li,
.reviews-ratings p {
  display: inline-flex;
  display: -webkit-inline-flex;
  align-items: center;
  -webkit-align-items: center;
}

.widget-setcount ul,
.booking-list {
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
}

.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item,
.chat-window .chat-cont-right .chat-body .media.sent .media-body,
.specialities-section-one .specialities-item {
  flex-direction: column;
}

.flag-dropdown .dropdown-toggle {
  justify-content: start;
  -webkit-justify-content: start;
}

.widget-setcount ul,
.relative-form,
.prefer-box,
.onboarding-content-box.content-wrap,
.left-panel {
  justify-content: space-between;
  -webkit-justify-content: space-between;
}

.terms-section .terms-content .terms-text.terms-list p,
.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: start;
}

.chat-window .chat-cont-right .chat-header,
.chat-window .chat-cont-left .chat-users-list a.media .media-body,
.chat-window .chat-cont-left .chat-header,
.listing-day,
.header.header-ten .menu-header,
.header-one .menu-header,
.header .header-nav .menu-header,
.header .header-nav {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

.store-tab,
.doctor-divison .pat-background,
.doctor-divison .doc-background,
.login-bottom-copyright,
.custom-increment.cart .input-group1,
.btn-file,
.chat-attachment-item,
.chat-window .chat-cont-right .chat-header .chat-options > a,
.success-cont i,
.hours-info .btn.btn-danger.trash,
.profile-widget .fav-btn,
.section-specialities .specialities-slider .speicality-item .speicality-img span,
.header .header-nav .header-navbar-rht li,
.avatar .avatar-title,
.btn-icon {
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}

.increment-decrement .input-groups,
.login-page .login-right,
.btn-file,
.chat-window .chat-msg-info,
.chat-window .chat-cont-right .chat-header .chat-options > a,
.chat-window .chat-cont-right .chat-header .media,
.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend,
.chat-window .chat-cont-left .chat-header,
.signature,
.change-avatar,
.dash-card .dash-widget,
.btn.btn-danger.trash,
.appointments .appointment-action,
.success-cont i,
.success-page-cont,
.header.header-ten .menu-header,
.header-one .menu-header,
.header .header-nav .header-navbar-rht .has-arrow.logged-item .nav-link,
.header .header-nav .header-navbar-rht .has-arrow .logged-item .nav-link,
.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item,
.header .header-nav .header-navbar-rht li,
.header .header-nav .menu-header,
table.table td h2.table-avatar,
table.table td h2 .table-avatar,
.avatar .avatar-title,
.btn-icon {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.listing-day {
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
}

.doctor-divison .pat-background,
.doctor-divison .doc-background,
.btn-file,
.chat-window .chat-cont-right .chat-header .chat-options > a,
.chat-window .chat-cont-left .chat-header .chat-compose,
.appointments .appointment-action,
.success-cont i,
.profile-widget .fav-btn,
.section-specialities .specialities-slider .speicality-item .speicality-img span,
.footer .footer-top .footer-widget .footer-about-content .social-icon ul li a,
.footer .footer-top .footer-widget .footer-about-content .social-icon ul,
.header .header-nav .header-navbar-rht .has-arrow.logged-item .nav-link,
.header .header-nav .header-navbar-rht .has-arrow .logged-item .nav-link,
.header .header-nav .header-navbar-rht li,
table.table td h2.table-avatar,
table.table td h2 .table-avatar,
.avatar-group,
.btn-icon {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

.widget-setcount ul,
.onboarding-content .increment-decrement .input-groups input[type="button"],
.relative-form,
.option-set,
.select-gender-option,
.onboarding-contents,
.opt-resend,
.set-path,
.prefer-box,
.call-lable.verify-lable.verify-options,
.call-lable.verify-lable.verify-lable,
.call-lable,
.consult-option,
.save-detail,
.upload-pic.patient-photo-upload,
.upload-pic,
.onboarding-content-box.content-wrap,
.onboarding-progress,
.on-board-wizard ul li a,
#onboard-slider .owl-dots,
.right-panel,
.left-panel,
.onboard-wrapper,
.full-slide-home .slick-slide .slide-image,
.full-slide-home .slick-slide > div > .col-12,
.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul,
.banner-wrapper .search-box-3 form,
.map-listing .profile-widget,
.doctor-widget-one .doc-info-left,
.doctor-widget-one,
.clinic-services,
.doc-info-left,
.doctor-widget,
.call-timing,
.call-details,
.password-strength,
.increment-decrement .input-groups,
.login-bottom-copyright,
.custom-increment .input-group1,
chat-attachment-list,
.chat-msg-attachments,
.chat-window .chat-msg-info,
.chat-window .chat-cont-right .chat-body .media.sent .media-body,
.chat-window .chat-cont-right .chat-header .chat-options,
.chat-window .chat-cont-left .chat-users-list a.media .media-body,
.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend,
.chat-window .chat-cont-left .chat-header,
.patient-graph-col .graph-box .graph-status-result,
.patient-graph-col .graph-box,
.patient-graph-box,
.patient-dashboard-top,
.change-avatar,
.profile-info-widget,
.dash-card .dash-widget,
.upload-wrap,
.review-listing > ul li .comment .comment-body .meta-data .review-count,
.review-listing > ul li .comment,
.appointments .appointment-list,
.appointment-list .profile-info-widget,
.booking-device,
.success-page-cont,
.booking-doc-info,
.work-info,
.section-search .banner-wrapper .search-box form,
.footer-two .footer-top .footer-widget .footer-contact-info .footer-address,
.footer-one .footer-top .footer-widget .footer-contact-info .footer-address,
.footer .footer-top .footer-widget .footer-contact-info .footer-address,
.header.header-ten .main-menu-wrapper .main-nav,
.header-one .main-menu-wrapper .main-nav,
.header .header-nav .header-navbar-rht .has-arrow .user-header,
.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item,
.header .header-nav .main-nav,
.header .header-nav,
.avatar .avatar-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.payment-radio,
.custom_radio,
.custom_check,
.slick-slider {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.right-panel,
.section-search-pharmacy .banner-wrapper2 .search-box1 form,
.full-slide-home .slick-slide > div > .col-12,
.clinic-services,
.chat-window .chat-msg-info,
.patient-graph-col .graph-box .graph-status-result,
.patient-graph-col .graph-box,
.appointments .appointment-list,
.schedule-nav .nav-tabs,
.post-left ul,
.header.header-ten .header-nav,
.header-one .header-nav,
.header .header-nav,
.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item,
.chat-window .chat-cont-right .chat-body .media.sent .media-body,
.specialities-section-one .specialities-item {
  -ms-flex-direction: column;
  flex-direction: column;
}

.chat-window .chat-cont-right .chat-body .media.sent .media-body,
.patient-graph-col .graph-box .graph-status-result {
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
}

.chat-window .chat-cont-right .chat-body .media.sent .media-body,
.patient-graph-col .graph-box .graph-status-result {
  -webkit-box-align: flex-end;
  -ms-flex-align: flex-end;
  align-items: flex-end;
}

.upload-wrap,
.day-week-month-col ul,
.payment-menthods ul,
.step-list ul,
.header-top ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.col {
  width: auto;
  padding-left: 15px;
  padding-right: 15px;
  float: left;
  position: relative;
  min-height: 1px;
}
@media (min-width: 320px) {
  .col.col-xs-12 {
    width: 100%;
  }
  .col.col-xs-11 {
    width: 91.66666667%;
  }
  .col.col-xs-10 {
    width: 83.33333333%;
  }
  .col.col-xs-9 {
    width: 75%;
  }
  .col.col-xs-8 {
    width: 66.66666667%;
  }
  .col.col-xs-7 {
    width: 58.33333333%;
  }
  .col.col-xs-6 {
    width: 50%;
  }
  .col.col-xs-5 {
    width: 41.66666667%;
  }
  .col.col-xs-4 {
    width: 33.33333333%;
  }
  .col.col-xs-3 {
    width: 25%;
  }
  .col.col-xs-2 {
    width: 16.66666667%;
  }
  .col.col-xs-1 {
    width: 8.33333333%;
  }
}
@media (min-width: 568px) {
  .col.col-sm-12 {
    width: 100%;
  }
  .col.col-sm-11 {
    width: 91.66666667%;
  }
  .col.col-sm-10 {
    width: 83.33333333%;
  }
  .col.col-sm-9 {
    width: 75%;
  }
  .col.col-sm-8 {
    width: 66.66666667%;
  }
  .col.col-sm-7 {
    width: 58.33333333%;
  }
  .col.col-sm-6 {
    width: 50%;
  }
  .col.col-sm-5 {
    width: 41.66666667%;
  }
  .col.col-sm-4 {
    width: 33.33333333%;
  }
  .col.col-sm-3 {
    width: 25%;
  }
  .col.col-sm-2 {
    width: 16.66666667%;
  }
  .col.col-sm-1 {
    width: 8.33333333%;
  }
}
@media (min-width: 768px) {
  .col.col-md-12 {
    width: 100%;
  }
  .col.col-md-11 {
    width: 91.66666667%;
  }
  .col.col-md-10 {
    width: 83.33333333%;
  }
  .col.col-md-9 {
    width: 75%;
  }
  .col.col-md-8 {
    width: 66.66666667%;
  }
  .col.col-md-7 {
    width: 58.33333333%;
  }
  .col.col-md-6 {
    width: 50%;
  }
  .col.col-md-5 {
    width: 41.66666667%;
  }
  .col.col-md-4 {
    width: 33.33333333%;
  }
  .col.col-md-3 {
    width: 25%;
  }
  .col.col-md-2 {
    width: 16.66666667%;
  }
  .col.col-md-1 {
    width: 8.33333333%;
  }
}
@media (min-width: 1024px) {
  .col.col-lg-12 {
    width: 100%;
  }
  .col.col-lg-11 {
    width: 91.66666667%;
  }
  .col.col-lg-10 {
    width: 83.33333333%;
  }
  .col.col-lg-9 {
    width: 75%;
  }
  .col.col-lg-8 {
    width: 66.66666667%;
  }
  .col.col-lg-7 {
    width: 58.33333333%;
  }
  .col.col-lg-6 {
    width: 50%;
  }
  .col.col-lg-5 {
    width: 41.66666667%;
  }
  .col.col-lg-4 {
    width: 33.33333333%;
  }
  .col.col-lg-3 {
    width: 25%;
  }
  .col.col-lg-2 {
    width: 16.66666667%;
  }
  .col.col-lg-1 {
    width: 8.33333333%;
  }
}

/******* COMPONENTS ******/
.view-btn {
  color: #0de0fe;
  font-size: 13px;
  border: 2px solid #0de0fe;
  text-align: center;
  display: block;
  font-weight: 500;
  padding: 6px;
}
.view-btn:hover,
.view-btn:focus {
  background-color: #0de0fe;
  color: #ffffff;
}

.book-btn {
  background-color: #0de0fe;
  border: 2px solid #0de0fe;
  color: #ffffff;
  font-size: 13px;
  text-align: center;
  display: block;
  font-weight: 500;
  padding: 6px;
}
.book-btn:hover,
.book-btn:focus {
  background-color: #01cae4;
  border-color: #01cae4;
  color: #ffffff;
}

.submit-btn-bottom {
  margin-bottom: 30px;
}
@media (max-width: 767.98px) {
  .submit-btn-bottom {
    margin-bottom: 20px;
  }
}
@media (max-width: 575.98px) {
  .submit-btn-bottom {
    margin-bottom: 0.9375rem;
  }
}

.bg-info-light {
  background-color: rgba(2, 182, 179, 0.12) !important;
  color: #1db9aa !important;
}

.bg-primary-light {
  background-color: rgba(17, 148, 247, 0.12) !important;
  color: #2196f3 !important;
}

.bg-danger-light {
  background-color: rgba(242, 17, 54, 0.12) !important;
  color: #e63c3c !important;
}

.bg-warning-light {
  background-color: rgba(255, 152, 0, 0.12) !important;
  color: #f39c12 !important;
}

.bg-success-light {
  background-color: rgba(15, 183, 107, 0.12) !important;
  color: #26af48 !important;
}

.bg-purple-light {
  background-color: rgba(197, 128, 255, 0.12) !important;
  color: #c580ff !important;
}

.bg-default-light {
  background-color: rgba(40, 52, 71, 0.12) !important;
  color: #283447 !important;
}

.change-photo-btn {
  background-color: #20c0f3;
  color: #ffffff;
  cursor: pointer;
  display: block;
  font-size: 13px;
  font-weight: 600;
  position: relative;
  text-align: center;
  width: 220px;
  -webkit-transition: 0.3s;
  -ms-transition: 0.3s;
  transition: 0.3s;
  border-radius: 50px;
  margin: 0 auto;
  padding: 10px 15px;
}

.btn-icon {
  text-align: center;
  font-size: 10px;
  width: 20px;
  height: 20px;
  padding: 0;
  position: absolute;
  top: 3px;
  right: 3px;
}

.btn-facebook {
  background-color: #3a559f;
  color: #ffffff;
  font-size: 13px;
  padding: 8px 12px;
}

.btn-google {
  background-color: #dd4b39;
  color: #ffffff;
  font-size: 13px;
  padding: 8px 12px;
}

.view-inv-btn {
  font-size: 16px;
  font-weight: 700;
  padding: 12px 30px;
}
@media (max-width: 767.98px) {
  .view-inv-btn {
    font-size: 14px;
    padding: 10px 30px;
  }
}

.banner-btn {
  background: #1c5b90;
  border-radius: 130px;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  padding: 20px 30px;
  width: 100%;
}
.banner-btn:hover {
  background: #10defd;
  color: #ffffff;
}

.book-btn1 {
  background-color: #0de0fe;
  border: 2px solid #0de0fe;
  color: #ffffff;
  font-size: 16px;
  text-align: center;
  font-weight: 500;
  padding: 6px 10px;
}
.book-btn1:hover {
  background-color: #01cae4;
  border-color: #01cae4;
  color: #ffffff;
}

.search-btn {
  width: 100%;
  margin-top: 15px;
}

.mouse-cursor {
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  border-radius: 50%;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  visibility: hidden;
}

.cursor-inner {
  margin-left: -4px;
  margin-top: -4px;
  width: 10px;
  height: 10px;
  z-index: 10000001;
  background: #0e82fd !important;
  -webkit-transition:
    width 0.3s ease-in-out,
    height 0.3s ease-in-out,
    margin 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
  transition:
    width 0.3s ease-in-out,
    height 0.3s ease-in-out,
    margin 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
}
.cursor-inner.cursor-hover {
  margin-left: -20px;
  margin-top: -20px;
  width: 40px;
  height: 40px;
  background: #0e82fd !important;
  opacity: 0.1;
}

.cursor-outer {
  margin-left: -15px;
  margin-top: -15px;
  width: 30px;
  height: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 10000000;
  opacity: 0.5;
  border: 2px solid #0e82fd;
  transform: all 0.08s ease-out;
  -webkit-transform: all 0.08s ease-out;
  -ms-transform: all 0.08s ease-out;
}
.cursor-outer.cursor-hover {
  opacity: 0;
}

.mim_tm_all_wrap[data-magic-cursor="hide"] .mouse-cursor {
  display: none;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  z-index: -1111;
}

.progress-wrap {
  position: fixed;
  right: 25px;
  bottom: 25px;
  height: 35px;
  width: 35px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  box-shadow: inset 0 0 0 2px rgba(75, 64, 237, 0.2);
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  -webkit-transition: all 200ms linear;
  transition: all 200ms linear;
  transform: translateY(15px);
  -webkit-transform: translateY(15px);
  -moz-transform: translateY(15px);
  -ms-transform: translateY(15px);
  -o-transform: translateY(15px);
}
.progress-wrap.active-progress {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.progress-wrap::after {
  position: absolute;
  content: "\\f062";
  font-family: "FontAwesome";
  text-align: center;
  line-height: 35px;
  font-size: 17px;
  color: #0e82fd;
  left: 0;
  top: 0;
  height: 35px;
  width: 35px;
  cursor: pointer;
  display: block;
  z-index: 1;
  -webkit-transition: all 200ms linear;
  transition: all 200ms linear;
}
.progress-wrap svg path {
  fill: none;
}
.progress-wrap svg.progress-circle path {
  stroke: #0e82fd;
  stroke-width: 4;
  box-sizing: border-box;
  -webkit-transition: all 200ms linear;
  transition: all 200ms linear;
}

.check {
  display: block;
  margin: 0;
  padding: 0;
  width: 0;
  height: 0;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  position: absolute;
}
.check:checked + .checktoggle {
  background-color: #008f64;
  border: 1px solid #008f64;
}
.check:checked + .checktoggle:after {
  background-color: #ffffff;
  left: 100%;
  transform: translate(calc(-100% - 5px), -50%);
  -webkit-transform: translate(calc(-100% - 5px), -50%);
  -ms-transform: translate(calc(-100% - 5px), -50%);
}

.checktoggle {
  background-color: #ff3535;
  border: 1px solid #ff3535;
  border-radius: 12px;
  cursor: pointer;
  display: block;
  font-size: 0;
  height: 24px;
  margin-bottom: 0;
  position: relative;
  width: 42px;
}
.checktoggle:after {
  content: " ";
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(5px, -50%);
  -webkit-transform: translate(5px, -50%);
  -ms-transform: translate(5px, -50%);
  width: 14px;
  height: 14px;
  background-color: #ffffff;
  border-radius: 50%;
  transition:
    left 300ms ease,
    transform 300ms ease;
}

.status-toggle .check:checked + .checktoggle {
  background-color: #28a745;
  border: 1px solid #28a745;
}
.status-toggle .check:checked + .checktoggle:after {
  transform: translate(calc(-100% - 2px), -50%);
  -webkit-transform: translate(calc(-100% - 2px), -50%);
  -ms-transform: translate(calc(-100% - 2px), -50%);
}
.status-toggle .checktoggle {
  width: 41px;
  height: 21px;
}
.status-toggle .checktoggle::after {
  width: 17px;
  height: 17px;
  transform: translate(2px, -50%);
  -webkit-transform: translate(2px, -50%);
  -ms-transform: translate(2px, -50%);
}

.status-tog .checktoggle {
  height: 28px;
  width: 50px;
  border-radius: 999px;
  background-color: #f3f4f6;
  border-color: #f3f4f6;
}
.status-tog .checktoggle:before {
  content: " ";
  display: block;
  position: absolute;
  top: 50%;
  right: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-size: 11px 20px;
  width: 20px;
  height: 20px;
  transform: translate(3px, -50%);
}
.status-tog .checktoggle:after {
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-size: 12px 21px;
  transform: translate(1px, -50%);
  background-position: center;
  box-shadow:
    0px 1px 2px rgba(0, 0, 0, 0.1),
    0px 1px 1px rgba(0, 0, 0, 0.06);
}
.status-tog .check:checked + .checktoggle:before {
  content: " ";
  display: block;
  position: absolute;
  left: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-size: 13px 21px;
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
}
.status-tog .check:checked + .checktoggle:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-size: 12px 21px;
  transform: translate(calc(-100% - 1px), -50%);
  background-position: center;
}

.bootstrap-tagsinput {
  display: block;
  border-radius: 5px;
  background: #ffffff;
  border: 1px solid #e4e4e8;
  height: 46px;
  margin: 0;
  padding: 4px 10px 0 10px;
  width: 100%;
  box-shadow: none;
  overflow-y: auto;
}
.bootstrap-tagsinput .tag {
  margin-right: 5px;
  margin-bottom: 2px;
  color: #a9a9a9;
  background: #f4f4f4 !important;
  font-size: 12px;
  font-weight: 500;
  border-radius: 5px;
}
.bootstrap-tagsinput .tag:hover {
  color: #a9a9a9;
}
.bootstrap-tagsinput .tag [data-role="remove"] {
  position: relative;
  left: 7px;
  cursor: pointer;
}
.bootstrap-tagsinput .tag [data-role="remove"]:after {
  content: "x";
  margin: 0;
  padding: 0px 2px;
}
.bootstrap-tagsinput input {
  line-height: 36px;
  border: 1px solid transparent;
  background: transparent;
}
.bootstrap-tagsinput input:focus-visible {
  border: 1px solid transparent;
}

/****** LAYOUT ******/
.btn.focus,
.btn:focus {
  box-shadow: unset;
}
.btn.btn-rounded {
  border-radius: 50px;
}

.btn-white {
  background-color: #ffffff;
  border: 1px solid #cccccc;
  color: #272b41;
}

.bg-primary,
.badge-primary {
  background-color: #09e5ab !important;
}

a.bg-primary:focus,
a.bg-primary:hover,
button.bg-primary:focus,
button.bg-primary:hover {
  background-color: #09dca4 !important;
}

.bg-success,
.badge-success {
  background-color: #00e65b !important;
}

a.bg-success:focus,
a.bg-success:hover,
button.bg-success:focus,
button.bg-success:hover {
  background-color: #00cc52 !important;
}

.bg-info,
.badge-info {
  background-color: #009efb !important;
}

a.bg-info:focus,
a.bg-info:hover,
button.bg-info:focus,
button.bg-info:hover {
  background-color: #028ee1 !important;
}

.bg-warning,
.badge-warning {
  background-color: #ffbc34 !important;
}

a.bg-warning:focus,
a.bg-warning:hover,
button.bg-warning:focus,
button.bg-warning:hover {
  background-color: #e9ab2e !important;
}

.bg-danger,
.badge-danger {
  background-color: #ff0100 !important;
}

a.bg-danger:focus,
a.bg-danger:hover,
button.bg-danger:focus,
button.bg-danger:hover {
  background-color: #e63333 !important;
}

.bg-white {
  background-color: #ffffff;
}

.bg-purple,
.badge-purple {
  background-color: #9368e9 !important;
}

.text-primary {
  color: #09e5ab !important;
}

.dropdown-menu li > a.text-primary {
  color: #09e5ab !important;
}
.dropdown-menu li > a.text-success {
  color: #00cc52 !important;
}
.dropdown-menu li > a.text-danger {
  color: #ff0100 !important;
}
.dropdown-menu li > a.text-info {
  color: #009efb !important;
}
.dropdown-menu li > a.text-warning {
  color: #ffbc34 !important;
}
.dropdown-menu li > a.text-purple {
  color: #7460ee !important;
}

.text-success {
  color: #00cc52 !important;
}

.text-danger {
  color: #ff0100 !important;
}

.text-info {
  color: #009efb !important;
}

.text-warning {
  color: #ffbc34 !important;
}

.text-purple {
  color: #7460ee !important;
}

.text-muted {
  color: #757575 !important;
}

.btn-primary {
  background-color: #00d0f1;
  border: 1px solid #00d0f1;
}
.btn-primary:focus,
.btn-primary:hover,
.btn-primary:active,
.btn-primary.active {
  color: #ffffff;
  background-color: #09dca4;
  border-color: #09dca4;
}
.btn-primary:focus .open > .dropdown-toggle.btn-primary,
.btn-primary:hover .open > .dropdown-toggle.btn-primary,
.btn-primary:active .open > .dropdown-toggle.btn-primary,
.btn-primary.active .open > .dropdown-toggle.btn-primary {
  background-color: #09dca4;
  border: 1px solid #09dca4;
}
.btn-primary.active.focus .open > .dropdown-toggle.btn-primary.focus,
.btn-primary.active.focus .open > .dropdown-toggle.btn-primary:focus,
.btn-primary.active.focus .open > .dropdown-toggle.btn-primary:hover,
.btn-primary.active:focus .open > .dropdown-toggle.btn-primary.focus,
.btn-primary.active:focus .open > .dropdown-toggle.btn-primary:focus,
.btn-primary.active:focus .open > .dropdown-toggle.btn-primary:hover,
.btn-primary.active:hover .open > .dropdown-toggle.btn-primary.focus,
.btn-primary.active:hover .open > .dropdown-toggle.btn-primary:focus,
.btn-primary.active:hover .open > .dropdown-toggle.btn-primary:hover,
.btn-primary .focus.focus .open > .dropdown-toggle.btn-primary.focus,
.btn-primary .focus.focus .open > .dropdown-toggle.btn-primary:focus,
.btn-primary .focus.focus .open > .dropdown-toggle.btn-primary:hover,
.btn-primary .focus:focus .open > .dropdown-toggle.btn-primary.focus,
.btn-primary .focus:focus .open > .dropdown-toggle.btn-primary:focus,
.btn-primary .focus:focus .open > .dropdown-toggle.btn-primary:hover,
.btn-primary .focus:hover .open > .dropdown-toggle.btn-primary.focus,
.btn-primary .focus:hover .open > .dropdown-toggle.btn-primary:focus,
.btn-primary .focus:hover .open > .dropdown-toggle.btn-primary:hover {
  background-color: #09dca4;
  border: 1px solid #09dca4;
}
.btn-primary:active:focus,
.btn-primary:active:hover {
  background-color: #09dca4;
  border: 1px solid #09dca4;
}
.btn-primary .active:not(:disabled):not(.disabled),
.btn-primary:active:not(:disabled):not(.disabled) {
  background-color: #09dca4;
  border-color: #09dca4;
  color: #ffffff;
}
.btn-primary .active:focus:not(:disabled):not(.disabled),
.btn-primary:active:focus:not(:disabled):not(.disabled) {
  box-shadow: unset;
}
.btn-primary .show > .btn-primary.dropdown-toggle {
  background-color: #09dca4;
  border-color: #09dca4;
  color: #ffffff;
}
.btn-primary .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: unset;
}
.btn-primary.disabled,
.btn-primary:disabled {
  background-color: #09e5ab;
  border-color: #09e5ab;
  color: #ffffff;
}

.btn-secondary.active:focus :not(:disabled):not(.disabled),
.btn-secondary:active:focus :not(:disabled):not(.disabled) {
  box-shadow: unset;
}

.show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: unset;
}
.show > .btn-success.dropdown-toggle {
  background-color: #00cc52;
  border-color: #00cc52;
  color: #ffffff;
}
.show > .btn-success.dropdown-toggle:focus {
  box-shadow: unset;
}
.show > .btn-info.dropdown-toggle {
  background-color: #028ee1;
  border-color: #028ee1;
  color: #ffffff;
}
.show > .btn-info.dropdown-toggle:focus {
  box-shadow: unset;
}
.show > .btn-warning.dropdown-toggle {
  background-color: #e9ab2e;
  border-color: #e9ab2e;
  color: #ffffff;
}
.show > .btn-warning.dropdown-toggle:focus {
  box-shadow: unset;
}
.show > .btn-danger.dropdown-toggle {
  background-color: #e63333;
  border-color: #e63333;
  color: #ffffff;
}
.show > .btn-danger.dropdown-toggle:focus {
  box-shadow: unset;
}
.show > .btn-light.dropdown-toggle:focus,
.show > .btn-dark.dropdown-toggle:focus {
  box-shadow: unset;
}
.show > .btn-outline-primary.dropdown-toggle {
  background-color: #09e5ab;
  border-color: #09e5ab;
}
.show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: none;
}
.show > .btn-outline-success.dropdown-toggle {
  background-color: #00e65b;
  border-color: #00e65b;
}
.show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: none;
}
.show > .btn-outline-info.dropdown-toggle {
  background-color: #009efb;
  border-color: #009efb;
}
.show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: none;
}
.show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ffbc34;
  border-color: #ffbc34;
}
.show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: none;
}
.show > .btn-outline-danger.dropdown-toggle {
  color: #212529;
  background-color: #ffbc34;
  border-color: #ffbc34;
}
.show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: none;
}

.btn-success {
  background-color: #00e65b;
  border: 1px solid #00e65b;
}
.btn-success:hover,
.btn-success:focus .btn-success.active,
.btn-success:active {
  background-color: #00cc52;
  border: 1px solid #00cc52;
  color: #ffffff;
}
.btn-success .open > .dropdown-toggle.btn-success {
  background-color: #00cc52;
  border: 1px solid #00cc52;
  color: #ffffff;
}
.btn-success .open > .dropdown-toggle.btn-success.focus,
.btn-success .open > .dropdown-toggle.btn-success:hover,
.btn-success .open > .dropdown-toggle.btn-success:focus {
  background-color: #00cc52;
  border: 1px solid #00cc52;
}
.btn-success.active:focus,
.btn-success.active.focus,
.btn-success.active:hover,
.btn-success.focus,
.btn-success:active:focus,
.btn-success:active:hover {
  background-color: #00cc52;
  border: 1px solid #00cc52;
}
.btn-success.active:not(:disabled):not(.disabled),
.btn-success:active:not(:disabled):not(.disabled) {
  background-color: #00cc52;
  border-color: #00cc52;
  color: #ffffff;
}
.btn-success.active:focus:not(:disabled):not(.disabled),
.btn-success:active:focus:not(:disabled):not(.disabled) {
  box-shadow: unset;
}
.btn-success.disabled,
.btn-success:disabled {
  background-color: #00e65b;
  border-color: #00e65b;
  color: #ffffff;
}

.btn-info {
  background-color: #009efb;
  border: 1px solid #009efb;
}
.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active {
  background-color: #028ee1;
  border: 1px solid #028ee1;
}
.btn-info.active:focus,
.btn-info.active.focus,
.btn-info.active:hover,
.btn-info.focus,
.btn-info:active:focus,
.btn-info:active:hover {
  background-color: #028ee1;
  border: 1px solid #028ee1;
}
.btn-info.active:not(:disabled):not(.disabled),
.btn-info:active:not(:disabled):not(.disabled) {
  background-color: #028ee1;
  border-color: #028ee1;
  color: #ffffff;
}
.btn-info.active:not(:disabled):not(.disabled):focus,
.btn-info:active:not(:disabled):not(.disabled):focus {
  box-shadow: unset;
}
.btn-info.disabled,
.btn-info:disabled {
  background-color: #009efb;
  border-color: #009efb;
  color: #ffffff;
}

.btn-warning {
  background-color: #ffbc34;
  border: 1px solid #ffbc34;
}
.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active {
  background-color: #e9ab2e;
  border: 1px solid #e9ab2e;
}
.btn-warning.active:focus,
.btn-warning.active.focus,
.btn-warning.active:hover,
.btn-warning.focus,
.btn-warning:active:focus,
.btn-warning:active:hover {
  background-color: #e9ab2e;
  border: 1px solid #e9ab2e;
}
.btn-warning.active:not(:disabled):not(.disabled),
.btn-warning:active:not(:disabled):not(.disabled) {
  background-color: #e9ab2e;
  border-color: #e9ab2e;
  color: #ffffff;
}
.btn-warning.active:not(:disabled):not(.disabled):focus,
.btn-warning:active:not(:disabled):not(.disabled):focus {
  box-shadow: unset;
}
.btn-warning.disabled,
.btn-warning:disabled {
  background-color: #ffbc34;
  border-color: #ffbc34;
  color: #ffffff;
}

.btn-danger {
  background-color: #ff0100;
  border: 1px solid #ff0100;
}
.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active {
  background-color: #e63333;
  border: 1px solid #e63333;
}
.btn-danger.active:focus,
.btn-danger.active.focus,
.btn-danger.active:hover,
.btn-danger.focus,
.btn-danger:active:focus,
.btn-danger:active:hover {
  background-color: #e63333;
  border: 1px solid #e63333;
}
.btn-danger.active:not(:disabled):not(.disabled),
.btn-danger:active:not(:disabled):not(.disabled) {
  background-color: #e63333;
  border-color: #e63333;
  color: #ffffff;
}
.btn-danger.active:not(:disabled):not(.disabled):focus,
.btn-danger:active:not(:disabled):not(.disabled):focus {
  box-shadow: unset;
}
.btn-danger.disabled,
.btn-danger:disabled {
  background-color: #ff0100;
  border-color: #ff0100;
  color: #ffffff;
}

.open > .dropdown-toggle.btn-info {
  background-color: #028ee1;
  border: 1px solid #028ee1;
}
.open > .dropdown-toggle.btn-info.focus,
.open > .dropdown-toggle.btn-info:focus,
.open > .dropdown-toggle.btn-info:hover {
  background-color: #028ee1;
  border: 1px solid #028ee1;
}
.open > .dropdown-toggle.btn-warning {
  background-color: #e9ab2e;
  border: 1px solid #e9ab2e;
}
.open > .dropdown-toggle.btn-warning.focus,
.open > .dropdown-toggle.btn-warning:focus,
.open > .dropdown-toggle.btn-warning:hover {
  background-color: #e9ab2e;
  border: 1px solid #e9ab2e;
}
.open > .dropdown-toggle.btn-danger {
  background-color: #e63333;
  border: 1px solid #e63333;
}
.open > .dropdown-toggle.btn-danger.focus,
.open > .dropdown-toggle.btn-danger:focus,
.open > .dropdown-toggle.btn-danger:hover {
  background-color: #e63333;
  border: 1px solid #e63333;
}

.btn-light.active:focus:not(:disabled):not(.disabled),
.btn-light:active:focus:not(:disabled):not(.disabled),
.btn-dark.active:focus:not(:disabled):not(.disabled),
.btn-dark:active:focus:not(:disabled):not(.disabled) {
  box-shadow: unset;
}

.btn-outline-primary {
  color: #09e5ab;
  border-color: #09e5ab;
}
.btn-outline-primary:hover {
  background-color: #09e5ab;
  border-color: #09e5ab;
}
.btn-outline-primary.focus,
.btn-outline-primary:focus {
  box-shadow: none;
}
.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: #09e5ab;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled).active,
.btn-outline-primary:not(:disabled):not(.disabled):active {
  background-color: #09e5ab;
  border-color: #09e5ab;
}

.btn-outline-success {
  color: #00e65b;
  border-color: #00e65b;
}
.btn-outline-success:hover {
  background-color: #00e65b;
  border-color: #00e65b;
}
.btn-outline-success.focus,
.btn-outline-success:focus {
  box-shadow: none;
}
.btn-outline-success.disabled,
.btn-outline-success:disabled {
  color: #00e65b;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled).active,
.btn-outline-success:not(:disabled):not(.disabled):active {
  background-color: #00e65b;
  border-color: #00e65b;
}
.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.btn-outline-success:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;
}

.btn-outline-info {
  color: #009efb;
  border-color: #009efb;
}
.btn-outline-info:hover {
  color: #ffffff;
  background-color: #009efb;
  border-color: #009efb;
}
.btn-outline-info.disabled,
.btn-outline-info:disabled {
  background-color: transparent;
  color: #009efb;
}
.btn-outline-info:focus,
.btn-outline-info.focus {
  box-shadow: none;
}
.btn-outline-info:not(:disabled):not(.disabled).active,
.btn-outline-info:not(:disabled):not(.disabled):active {
  background-color: #009efb;
  border-color: #009efb;
}
.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.btn-outline-info:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;
}

.btn-outline-warning {
  color: #ffbc34;
  border-color: #ffbc34;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #ffbc34;
  border-color: #ffbc34;
}
.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
  background-color: transparent;
  color: #ffbc34;
}
.btn-outline-warning:focus,
.btn-outline-warning.focus {
  box-shadow: none;
}
.btn-outline-warning:not(:disabled):not(.disabled).active,
.btn-outline-warning:not(:disabled):not(.disabled):active {
  background-color: #ffbc34;
  border-color: #ffbc34;
}
.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.btn-outline-warning:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;
}

.btn-outline-danger {
  color: #ff0100;
  border-color: #ff0100;
}
.btn-outline-danger:hover {
  color: #212529;
  background-color: #ff0100;
  border-color: #ff0100;
}
.btn-outline-danger.disabled,
.btn-outline-danger:disabled {
  background-color: transparent;
  color: #ff0100;
}
.btn-outline-danger:focus,
.btn-outline-danger.focus {
  box-shadow: none;
}
.btn-outline-danger:not(:disabled):not(.disabled).active,
.btn-outline-danger:not(:disabled):not(.disabled):active {
  background-color: #ff0100;
  border-color: #ff0100;
}
.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.btn-outline-danger:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;
}

.btn-outline-light {
  color: #ababab;
  border-color: #e6e6e6;
}
.btn-outline-light.disabled,
.btn-outline-light:disabled {
  color: #ababab;
}

.pagination > .active > a,
.pagination > .active > a:hover,
.pagination > .active > a:focus,
.pagination > .active > span,
.pagination > .active > span:hover,
.pagination > .active > span:focus {
  background-color: #20c0f3;
  border-color: #20c0f3;
}
.pagination > .active > a,
.pagination > .active > span {
  color: #20c0f3;
}
.pagination > li > a,
.pagination > li > span {
  color: #20c0f3;
}

.page-link:hover {
  color: #20c0f3;
}
.page-link:focus {
  box-shadow: unset;
}

.page-item.active .page-link {
  background-color: #20c0f3;
  border-color: #20c0f3;
}

.dropdown-menu {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: inherit;
  font-size: 14px;
  border-radius: 3px;
  transform-origin: left top 0;
  -webkit-transform-origin: left top 0;
  -ms-transform-origin: left top 0;
}

.dropdown-item.active,
.dropdown-item:active {
  background-color: #0de0fe;
}

.navbar-nav__.open--.dropdown-menu {
  border: 0;
  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}

.btn-light {
  border-color: #e6e6e6;
  color: #a6a6a6;
}

.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #20c0f3;
  text-shadow: unset;
}
.bootstrap-datetimepicker-widget table td.today::before {
  border-bottom-color: #20c0f3;
}

.bg-info-light {
  background-color: rgba(2, 182, 179, 0.12) !important;
  color: #1db9aa !important;
}

.bg-primary-light {
  background-color: rgba(17, 148, 247, 0.12) !important;
  color: #2196f3 !important;
}

.bg-danger-light {
  background-color: rgba(242, 17, 54, 0.12) !important;
  color: #e63c3c !important;
}

.bg-warning-light {
  background-color: rgba(255, 152, 0, 0.12) !important;
  color: #f39c12 !important;
}

.bg-success-light {
  background-color: rgba(15, 183, 107, 0.12) !important;
  color: #26af48 !important;
}

.bg-purple-light {
  background-color: rgba(197, 128, 255, 0.12) !important;
  color: #c580ff !important;
}

.bg-default-light {
  background-color: rgba(40, 52, 71, 0.12) !important;
  color: #283447 !important;
}

.text-xs {
  font-size: 12px !important;
}

.text-sm {
  font-size: 14px !important;
}

.text-lg {
  font-size: 20px !important;
}

.text-xl {
  font-size: 24px !important;
}

.avatar {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 3rem;
}
.avatar > img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
.avatar .avatar-title {
  width: 100%;
  height: 100%;
  background-color: #20c0f3;
  color: #ffffff;
}
.avatar.avatar-online::before {
  width: 25%;
  height: 25%;
  border-radius: 50%;
  content: "";
  border: 2px solid #ffffff;
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #00e65b;
}
.avatar.avatar-offline::before {
  width: 25%;
  height: 25%;
  border-radius: 50%;
  content: "";
  border: 2px solid #ffffff;
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #ff0100;
}
.avatar.avatar-away::before {
  width: 25%;
  height: 25%;
  border-radius: 50%;
  content: "";
  border: 2px solid #ffffff;
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #ffbc34;
}
.avatar .border {
  border-width: 3px !important;
}
.avatar .rounded {
  border-radius: 6px !important;
}
.avatar .avatar-title {
  font-size: 18px;
}
.avatar .avatar-xs {
  width: 1.65rem;
  height: 1.65rem;
}
.avatar .avatar-xs .border {
  border-width: 2px !important;
}
.avatar .avatar-xs .rounded {
  border-radius: 4px !important;
}
.avatar .avatar-xs .avatar-title {
  font-size: 12px;
}
.avatar .avatar-xs.avatar-away::before,
.avatar .avatar-xs.avatar-offline::before,
.avatar .avatar-xs.avatar-online::before {
  border-width: 1px;
}

.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}
.avatar-sm .border {
  border-width: 3px !important;
}
.avatar-sm .rounded {
  border-radius: 4px !important;
}
.avatar-sm .avatar-title {
  font-size: 15px;
}
.avatar-sm.avatar-away::before,
.avatar-sm.avatar-offline::before,
.avatar-sm.avatar-online::before {
  border-width: 2px;
}

.avatar-lg {
  width: 3.75rem;
  height: 3.75rem;
}
.avatar-lg .border {
  border-width: 3px !important;
}
.avatar-lg .rounded {
  border-radius: 8px !important;
}
.avatar-lg .avatar-title {
  font-size: 24px;
}
.avatar-lg.avatar-away::before,
.avatar-lg.avatar-offline::before,
.avatar-lg.avatar-online::before {
  border-width: 3px;
}

.avatar-xl {
  width: 5rem;
  height: 5rem;
}
.avatar-xl .border {
  border-width: 4px !important;
}
.avatar-xl .rounded {
  border-radius: 8px !important;
}
.avatar-xl .avatar-title {
  font-size: 28px;
}
.avatar-xl.avatar-away::before,
.avatar-xl.avatar-offline::before,
.avatar-xl.avatar-online::before {
  border-width: 4px;
}

.avatar-xxl {
  width: 5.125rem;
  height: 5.125rem;
}
@media (min-width: 768px) {
  .avatar-xxl {
    width: 8rem;
    height: 8rem;
  }
}
.avatar-xxl .border {
  border-width: 6px !important;
}
@media (min-width: 768px) {
  .avatar-xxl .border {
    border-width: 4px !important;
  }
}
.avatar-xxl .rounded {
  border-radius: 8px !important;
}
@media (min-width: 768px) {
  .avatar-xxl .rounded {
    border-radius: 12px !important;
  }
}
.avatar-xxl .avatar-title {
  font-size: 30px;
}
@media (min-width: 768px) {
  .avatar-xxl .avatar-title {
    font-size: 42px;
  }
}
.avatar-xxl.avatar-away::before,
.avatar-xxl.avatar-offline::before,
.avatar-xxl.avatar-online::before {
  border-width: 4px;
}
@media (min-width: 768px) {
  .avatar-xxl.avatar-away::before,
  .avatar-xxl.avatar-offline::before,
  .avatar-xxl.avatar-online::before {
    border-width: 4px;
  }
}

.avatar-group .avatar + .avatar {
  margin-left: -0.75rem;
}
.avatar-group .avatar:hover {
  z-index: 1;
}
.avatar-group .avatar-xs + .avatar-xs {
  margin-left: -0.40625rem;
}
.avatar-group .avatar-sm + .avatar-sm {
  margin-left: -0.625rem;
}
.avatar-group .avatar-lg + .avatar-lg {
  margin-left: -1rem;
}
.avatar-group .avatar-xl + .avatar-xl {
  margin-left: -1.28125rem;
}

.avatar-xs {
  width: 1.65rem;
  height: 1.65rem;
}

.react-tel-input .form-control {
  position: relative;
  font-size: 14px;
  letter-spacing: 0.01rem;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-left: 48px;
  margin-left: 0;
  background: #ffffff;
  border: 1px solid #cacaca;
  border-radius: 5px;
  line-height: 25px;
  height: 35px;
  outline: none;
  width: 350px !important;
}

.select2-results__option {
  padding: 6px 15px;
}

.select2-container .select2-selection--single {
  border: 1px solid #dcdcdc;
  height: 46px;
}
.select2-container .select2-selection--single .select2-selection__rendered {
  padding-right: 30px;
  padding-left: 15px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 44px;
  right: 7px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow b {
  border-color: #dcdcdc transparent transparent;
  border-style: solid;
  border-width: 6px 6px 0;
  height: 0;
  margin-left: -10px;
  margin-top: -2px;
  width: 0;
  position: absolute;
  top: 50%;
  left: 50%;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #272b41;
  font-size: 15px;
  font-weight: normal;
  line-height: 44px;
}
.select2-container--default.select2-container--open
  .select2-selection--single
  .select2-selection__arrow
  b {
  border-color: transparent transparent #dcdcdc;
  border-width: 0 6px 6px;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #20c0f3;
}
.select2-container--default .select2-selection--multiple {
  border: 1px solid #dcdcdc;
  min-height: 46px;
}

.select2-dropdown {
  border-color: #dcdcdc;
}

.breadcrumb-bar {
  background-color: #15558d;
  padding: 15px 0;
}
@media (max-width: 767.98px) {
  .breadcrumb-bar {
    height: auto;
  }
}
.breadcrumb-bar .breadcrumb-title {
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  margin: 5px 0 0;
}
@media (max-width: 767.98px) {
  .breadcrumb-bar .breadcrumb-title {
    font-size: 18px;
  }
}
.breadcrumb-bar .page-breadcrumb ol {
  background-color: transparent;
  font-size: 12px;
  margin-bottom: 0;
  padding: 0;
}
.breadcrumb-bar .page-breadcrumb ol li.active {
  color: #ffffff;
}
.breadcrumb-bar .page-breadcrumb ol li a {
  color: #ffffff;
}
.breadcrumb-bar .page-breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  color: #ffffff;
  font-size: 10px;
}

.form-focus {
  height: 50px;
  position: relative;
}
.form-focus .focus-label {
  font-size: 14px;
  font-weight: 400;
  pointer-events: none;
  transform: translate3d(0, 22px, 0) scale(1);
  -webkit-transform: translate3d(0, 22px, 0) scale(1);
  -ms-transform: translate3d(0, 22px, 0) scale(1);
  transform-origin: left top;
  -webkit-transform-origin: left top;
  -ms-transform-origin: left top;
  -webkit-transition: 240ms;
  -ms-transition: 240ms;
  transition: 240ms;
  z-index: 1;
  color: #b8b8b8;
  margin-bottom: 0;
  position: absolute;
  top: -8px;
  left: 12px;
}
.form-focus.focused .focus-label {
  opacity: 1;
  top: -18px;
  font-size: 12px;
  z-index: 1;
}
.form-focus.focused .form-control::-webkit-input-placeholder {
  color: #bbb;
}
.form-focus .form-control {
  height: 50px;
  padding: 21px 12px 6px;
}
.form-focus .form-control:focus ~ .focus-label,
.form-focus .form-control:-webkit-autofill ~ .focus-label {
  opacity: 1;
  font-weight: 400;
  top: -18px;
  font-size: 12px;
  z-index: 1;
}
.form-focus .form-control::-webkit-input-placeholder {
  color: transparent;
  -webkit-transition: 240ms;
  -ms-transition: 240ms;
  transition: 240ms;
}
.form-focus .form-control:focus::-webkit-input-placeholder {
  transition: none;
}
.form-focus.select-focus .focus-label {
  opacity: 1;
  font-weight: 300;
  top: -20px;
  font-size: 12px;
  z-index: 1;
}
.form-focus .select2-container .select2-selection--single {
  border: 1px solid #e3e3e3;
  height: 50px;
}
.form-focus .select2-container .select2-selection--single .select2-selection__rendered {
  padding-right: 30px;
  padding-left: 15px;
}
.form-focus .select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 48px;
  right: 7px;
}
.form-focus .select2-container--default .select2-selection--single .select2-selection__arrow b {
  border-color: #cccccc transparent transparent;
  border-style: solid;
  border-width: 6px 6px 0;
  height: 0;
  margin-left: -10px;
  margin-top: -2px;
  width: 0;
  position: absolute;
  top: 50%;
  left: 50%;
}
.form-focus .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #676767;
  font-size: 14px;
  font-weight: normal;
  line-height: 38px;
}
.form-focus
  .select2-container--default.select2-container--open
  .select2-selection--single
  .select2-selection__arrow
  b {
  border-color: transparent transparent #e3e3e3;
  border-width: 0 6px 6px;
}
.form-focus .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #fc6075;
}

#loader {
  background-color: #ffffff;
  z-index: 999999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.loader {
  display: inline-block;
  height: 50px;
  margin-left: -25px;
  margin-top: -25px;
  width: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
}
.loader span {
  -webkit-animation: loader 1.3s linear infinite;
  animation: loader 1.3s linear infinite;
  background-color: #20c0f3;
  border-radius: 100%;
  display: inline-block;
  height: 50px;
  position: absolute;
  width: 50px;
}
.loader span:last-child {
  animation-delay: -0.8s;
  -webkit-animation-delay: -0.8s;
}

@keyframes loader {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  100% {
    transform: scale(1, 1);
    opacity: 0;
  }
}
@-webkit-keyframes loader {
  0% {
    -webkit-transform: scale(0, 0);
    opacity: 0.5;
  }
  100% {
    -webkit-transform: scale(1, 1);
    opacity: 0;
  }
}
table.table {
  color: #272b41;
  max-width: 100%;
  margin-bottom: 0;
  width: 100%;
}
table.table thead {
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}
table.table thead tr th {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
table.table tbody tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
table.table tbody tr:last-child {
  border-color: transparent;
}
table.table.table-center td,
table.table.table-center th {
  vertical-align: middle;
}
table.table > tbody > tr > th {
  border-top: 0;
  padding: 10px 8px;
}
table.table .no-border > tbody > tr > th {
  border-top: 0;
  padding: 10px 8px;
}
table.table .no-border > tbody > tfoot > tr > th,
table.table .no-border > tbody > tfoot > tr > td,
table.table .no-border > tbody thead > tr > th,
table.table .no-border > tbody thead > tr > td {
  border-top: 0;
  padding: 10px 8px;
}
table.table .dataTable {
  border-collapse: collapse !important;
}
table .table-striped thead tr {
  border-color: transparent;
}
table .table-striped tbody tr {
  border-color: transparent;
}
table .table-striped tbody tr:nth-of-type(even) {
  background-color: rgba(255, 255, 255, 0.3);
}
table .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(235, 235, 235, 0.4);
}
table .table-striped > tbody > tr:nth-of-type(2n + 1) {
  background-color: #f8f9fa;
}
table .table-bordered {
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}
table .table-bordered th,
table .table-bordered td {
  border-color: rgba(0, 0, 0, 0.05);
}
table .table-nowrap td,
table .table-nowrap th {
  white-space: nowrap;
}
table.table td h2 {
  display: inline-block;
  font-size: inherit;
  font-weight: 400;
  vertical-align: middle;
  margin: 0;
  padding: 0;
}
table.table td h2 .table-avatar {
  font-size: inherit;
  font-weight: 400;
  vertical-align: middle;
  white-space: nowrap;
  margin: 0;
  padding: 0;
}
table.table td h2 a {
  color: #272b41;
}
table.table td h2 a:hover {
  color: #09dca4;
}
table.table td h2 span {
  color: #888888;
  display: block;
  font-size: 12px;
  margin-top: 3px;
}
table.table td h2.table-avatar {
  font-size: inherit;
  font-weight: 400;
  vertical-align: middle;
  white-space: nowrap;
  margin: 0;
  padding: 0;
}
table .table-hover tbody tr:hover {
  background-color: #f7f7f7;
}
table .table-hover tbody tr:hover td {
  color: #474648;
}

.table-hover tbody tr:hover {
  background-color: #f7f7f7;
}
.table-hover tbody tr:hover td {
  color: #474648;
}

.card-table card-body {
  padding: 0;
}
.card-table card-body .table > thead > tr > th {
  border-top: 0;
}
.card-table card-body .table tr th,
.card-table card-body .table tr td {
  border-top: 1px solid #e2e5e8;
  padding: 1rem 0.75rem;
  white-space: nowrap;
}
.card-table card-body .table tr th:first-child,
.card-table card-body .table tr td:first-child {
  padding-left: 1.5rem;
}
.card-table card-body .table tr th:last-child,
.card-table card-body .table tr td:last-child {
  padding-right: 1.5rem;
}

.card-table .card-body {
  padding: 0;
}
.card-table .card-body .table > thead > tr > th {
  border-top: 0;
}
.card-table .card-body .table tr th,
.card-table .card-body .table tr td {
  border-top: 1px solid #e2e5e8;
  white-space: nowrap;
  padding: 1rem 0.75rem;
}
.card-table .card-body .table tr th:first-child,
.card-table .card-body .table tr td:first-child {
  padding-left: 1.5rem;
}
.card-table .card-body .table tr th:last-child,
.card-table .card-body .table tr td:last-child {
  padding-right: 1.5rem;
}

.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-touch-callout: none;
  -ms-touch-action: pan-y;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}

.slick-list {
  position: relative;
  display: block;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
.slick-list:focus {
  outline: none;
}

.slick-list.dragging {
  cursor: pointer;
}

.slick-slider .slick-track,
.slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
}

.slick-track {
  display: block;
  margin: auto;
  position: relative;
  top: 0;
  left: 0;
}
.slick-track:before {
  display: table;
  content: "";
}
.slick-track:after {
  display: table;
  content: "";
  clear: both;
}

.slick-loading .slick-track {
  visibility: hidden;
}
.slick-loading .slick-slide {
  visibility: hidden;
}

.slick-slide {
  display: none;
  float: left;
  height: 100%;
  min-height: 1px;
}
.slick-slide img {
  display: block;
}
.slick-slide.slick-loading img {
  display: none;
}
.slick-slide.dragging img {
  pointer-events: none;
}

[dir="rtl"] .slick-slide {
  float: right;
}

.slick-initialized .slick-slide {
  display: block;
}

.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}

.slick-arrow.slick-hidden {
  display: none;
}

.slick-prev,
.slick-next {
  font-size: 0;
  line-height: 0;
  display: block;
  width: 40px;
  height: 40px;
  background: #ffffff;
  cursor: pointer;
  border: none;
  outline: none;
  background: #ffffff;
  -webkit-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
  position: absolute;
  top: 50%;
  padding: 0;
  transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -webkit-box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
.slick-prev:hover,
.slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
  background-color: #0de0fe;
  color: #ffffff;
  opacity: 1;
  outline: none;
  -webkit-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.slick-prev:hover:before,
.slick-prev:focus:before,
.slick-next:hover:before,
.slick-next:focus:before {
  color: #ffffff;
  opacity: 1;
}
.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
  opacity: 0.25;
}
.slick-prev:before,
.slick-next:before {
  font-family: "slick";
  font-size: 20px;
  line-height: 1;
  opacity: 0.75;
  color: #383838;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.slick-prev {
  left: 0;
  z-index: 1;
}
@media (max-width: 767.98px) {
  .slick-prev {
    left: -10px;
  }
}
.slick-prev:before {
  content: "←";
}

[dir="rtl"] .slick-prev {
  right: -25px;
  left: auto;
}
[dir="rtl"] .slick-prev:before {
  content: "→";
}

.slick-next {
  right: 0;
}
@media (max-width: 767.98px) {
  .slick-next {
    right: -10px;
  }
}
@media (max-width: 575.98px) {
  .slick-next {
    right: 0px;
  }
}
.slick-next:before {
  content: "→";
}

[dir="rtl"] .slick-next {
  right: auto;
  left: -25px;
}
[dir="rtl"] .slick-next:before {
  content: "←";
}

.dot-slider .slick-slide {
  height: 600px;
}
@media (max-width: 991.98px) {
  .dot-slider .slick-slide {
    height: 375px;
  }
}
@media (max-width: 767.98px) {
  .dot-slider .slick-slide {
    height: 100%;
  }
}
.dot-slider .slick-slide img {
  width: 100%;
}
.dot-slider .profile-widget {
  padding: 0;
  border: none;
}
@media (max-width: 991.98px) {
  .dot-slider .profile-widget {
    margin-bottom: 0;
  }
}
@media (max-width: 767.98px) {
  .dot-slider .profile-widget {
    margin-bottom: 0;
  }
}
.dot-slider .slick-dots {
  width: unset;
  position: absolute;
  top: 30%;
  right: 50px;
  bottom: unset;
}
.dot-slider .slick-dots li {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #ffffff;
  margin: 8px 0;
}
.dot-slider .slick-dots li.slick-active button {
  background-color: #1860ca;
}
.dot-slider .slick-dots li button {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #ffffff;
}

.slick-dots li button {
  font-size: 0;
  line-height: 0;
  display: block;
  width: 20px;
  height: 5px;
  padding: 0;
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: none;
  background: #c0c0c0;
}
.slick-dots .slick-dots {
  width: unset;
  position: absolute;
  top: 30%;
  right: 50px;
  bottom: unset;
}
.slick-dots .slick-dots li {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #ffffff;
  margin: 8px 0;
}
.slick-dots .slick-dots li button {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #ffffff;
}
.slick-dots .slick-dots li button:hover,
.slick-dots .slick-dots li button:focus {
  outline: none;
}
.slick-dots .slick-dots li button:hover::before,
.slick-dots .slick-dots li button:focus::before {
  opacity: 1;
}
.slick-dots .slick-dots li.slick-active button {
  background-color: #1860ca;
  background-color: #0de0fe;
}
.slick-dots .slick-dots li.slick-active button:before {
  opacity: 1;
  color: #0de0fe;
}

.clinic-slider .slick-prev,
.browse-slider .slick-prev,
.book-slider .slick-prev {
  right: 80px;
  left: unset;
  top: 0;
  width: 35px;
  height: 35px;
  border-radius: 5px 12px 5px 12px;
  background-color: #e74e84;
  transform: translateX(0%) rotate(-45deg);
  -webkit-transform: translateX(0%) rotate(-45deg);
  -ms-transform: translateX(0%) rotate(-45deg);
  z-index: 999;
}
.clinic-slider .slick-prev:before,
.browse-slider .slick-prev:before,
.book-slider .slick-prev:before {
  content: "";
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  font-family: "slick";
  font-size: 10px;
  line-height: 1;
  opacity: 0.75;
  color: #ffffff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: solid #ffffff;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}
.clinic-slider .slick-prev:hover,
.browse-slider .slick-prev:hover,
.book-slider .slick-prev:hover {
  background-color: #ff4877;
}
.clinic-slider .slick-next,
.browse-slider .slick-next,
.book-slider .slick-next {
  right: 15px;
  left: unset;
  top: 0;
  width: 35px;
  height: 35px;
  border-radius: 5px 12px 5px 12px;
  background-color: #e74e84;
  transform: translateX(0%) rotate(-45deg);
  -webkit-transform: translateX(0%) rotate(-45deg);
  -ms-transform: translateX(0%) rotate(-45deg);
  z-index: 999;
}
.clinic-slider .slick-next:before,
.browse-slider .slick-next:before,
.book-slider .slick-next:before {
  content: "";
  font-family: "slick";
  font-size: 10px;
  line-height: 1;
  opacity: 0.75;
  color: #ffffff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: solid #ffffff;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
}
.clinic-slider .slick-next:hover,
.browse-slider .slick-next:hover,
.book-slider .slick-next:hover {
  background-color: #ff4877;
}
.clinic-slider .slick-list,
.browse-slider .slick-list,
.book-slider .slick-list {
  padding-top: 50px;
}
.clinic-slider .slick-slide,
.browse-slider .slick-slide,
.book-slider .slick-slide {
  display: block;
  margin-left: 0;
  width: 280px;
  padding: 10px 10px 0;
}
.clinic-slider .profile-widget,
.browse-slider .profile-widget,
.book-slider .profile-widget {
  padding: 0;
  border: none;
  background-color: transparent;
  border-radius: 0;
}
.clinic-slider .profile-widget .brower-box,
.browse-slider .profile-widget .brower-box,
.book-slider .profile-widget .brower-box {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-sizing: border-box;
  box-shadow: 0px 4px 44px rgba(238, 238, 238, 0.25);
  border-radius: 10px;
  margin: 0;
  padding: 30px;
  -webkit-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.clinic-slider .profile-widget .brower-box:hover,
.browse-slider .profile-widget .brower-box:hover,
.book-slider .profile-widget .brower-box:hover {
  background-color: #1860ca;
  -webkit-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.clinic-slider .profile-widget .brower-box:hover a,
.browse-slider .profile-widget .brower-box:hover a,
.book-slider .profile-widget .brower-box:hover a {
  background-color: #ffffff;
}
.clinic-slider .profile-widget .brower-box:hover .img-fluid,
.browse-slider .profile-widget .brower-box:hover .img-fluid,
.book-slider .profile-widget .brower-box:hover .img-fluid {
  display: none;
}
.clinic-slider .profile-widget .brower-box:hover .img-fluid.hover,
.browse-slider .profile-widget .brower-box:hover .img-fluid.hover,
.book-slider .profile-widget .brower-box:hover .img-fluid.hover {
  display: block;
}
.clinic-slider .profile-widget .brower-box:hover h4,
.browse-slider .profile-widget .brower-box:hover h4,
.book-slider .profile-widget .brower-box:hover h4 {
  color: #ffffff;
}
.clinic-slider .profile-widget .brower-box:hover p,
.browse-slider .profile-widget .brower-box:hover p,
.book-slider .profile-widget .brower-box:hover p {
  color: #ffffff;
}
.clinic-slider .profile-widget .brower-box:hover p span,
.browse-slider .profile-widget .brower-box:hover p span,
.book-slider .profile-widget .brower-box:hover p span {
  color: #ffffff;
}
.clinic-slider .profile-widget .brower-box:hover a.arrow,
.browse-slider .profile-widget .brower-box:hover a.arrow,
.book-slider .profile-widget .brower-box:hover a.arrow {
  background-color: #2868c8;
}
.clinic-slider .profile-widget .brower-box a,
.browse-slider .profile-widget .brower-box a,
.book-slider .profile-widget .brower-box a {
  height: 85px;
  width: 85px;
  background-color: #1860ca;
  border-radius: 50% 50% 50% 50%/60% 60% 35% 35%;
  margin: 0 auto 15px;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}
.clinic-slider .profile-widget .brower-box img,
.browse-slider .profile-widget .brower-box img,
.book-slider .profile-widget .brower-box img {
  width: 70px;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}
.clinic-slider .profile-widget .brower-box .img-fluid.hover,
.browse-slider .profile-widget .brower-box .img-fluid.hover,
.book-slider .profile-widget .brower-box .img-fluid.hover {
  display: none;
}
.clinic-slider .profile-widget .brower-box h4,
.browse-slider .profile-widget .brower-box h4,
.book-slider .profile-widget .brower-box h4 {
  color: #000000;
  font-size: 20px;
  margin-bottom: 13px;
}
.clinic-slider .profile-widget .brower-box p,
.browse-slider .profile-widget .brower-box p,
.book-slider .profile-widget .brower-box p {
  margin-bottom: 20px;
}
.clinic-slider .profile-widget .brower-box .arrow,
.browse-slider .profile-widget .brower-box .arrow,
.book-slider .profile-widget .brower-box .arrow {
  background-color: #0ce0ff;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  transform: unset;
  margin: 0 auto;
}
.clinic-slider .profile-widget .brower-box .arrow i,
.browse-slider .profile-widget .brower-box .arrow i,
.book-slider .profile-widget .brower-box .arrow i {
  color: #ffffff;
}

.brower-box {
  text-align: center;
  border-radius: 10px;
  border: 6px solid #ffffff;
  background-color: #ffffff;
  margin-bottom: 20px;
}
.brower-box h4 {
  font-size: 16px;
  font-weight: 600;
  color: #2264c5;
}
.brower-box p {
  font-size: 14px;
  font-weight: 500;
  color: #e74e84;
  margin: 0;
}
.brower-box p span {
  color: #000000;
}
.brower-box a {
  height: 85px;
  width: 85px;
  background-color: #1860ca;
  border-radius: 50% 50% 50% 50%/60% 60% 35% 35%;
  margin: 0 auto 15px;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}

.aval-slider .slick-slide {
  display: block;
  margin-left: 0;
  padding: 10px;
  width: 280px;
}
.aval-slider .slick-list {
  padding: 50px 0;
}
@media (max-width: 767.98px) {
  .aval-slider .slick-list {
    padding: 30px 0;
  }
}
.aval-slider .slick-prev {
  left: 5px;
  width: 35px;
  height: 35px;
}
.aval-slider .slick-prev:before {
  font-family: "slick";
  font-size: 10px;
  line-height: 1;
  opacity: 0.75;
  color: #1860ca;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: solid #1860ca;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  content: "";
  transform: rotate(140deg);
  -webkit-transform: rotate(140deg);
  -ms-transform: rotate(140deg);
}
.aval-slider .slick-next {
  right: 5px;
  width: 35px;
  height: 35px;
}
.aval-slider .slick-next:before {
  font-family: "slick";
  font-size: 10px;
  line-height: 1;
  opacity: 0.75;
  color: #1860ca;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: solid #1860ca;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  content: "";
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
}

.content {
  min-height: 200px;
  padding: 80px 0 60px;
}
@media (max-width: 991.98px) {
  .content {
    padding: 60px 0 40px;
  }
}
@media (max-width: 767.98px) {
  .content {
    padding: 50px 0 30px;
  }
}

.top-space {
  padding-top: 140px;
}

.account-page .content.top-space {
  padding-top: 140px;
}

.card {
  border: 1px solid #f0f0f0;
  margin-bottom: 1.875rem;
}
@media (max-width: 767.98px) {
  .card {
    margin-bottom: 20px;
  }
}
@media (max-width: 575.98px) {
  .card {
    margin-bottom: 0.9375rem;
  }
}
.card .card-header {
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
}
@media (max-width: 575.98px) {
  .card .card-header {
    padding: 0.75rem 1.25rem;
  }
}
.card .card-header .card-title {
  margin-bottom: 0;
}

.card-body {
  padding: 1.5rem;
}
@media (max-width: 575.98px) {
  .card-body {
    padding: 1.25rem;
  }
}

.card-title {
  margin-bottom: 15px;
}

.card-header {
  border-bottom: 1px solid #f0f0f0;
  padding: 1rem 1.5rem;
}
@media (max-width: 575.98px) {
  .card-header {
    padding: 0.75rem 1.25rem;
  }
}

.card-footer {
  background-color: #ffffff;
  border-top: 1px solid #f0f0f0;
  padding: 1rem 1.5rem;
}
@media (max-width: 575.98px) {
  .card-footer {
    padding: 0.75rem 1.25rem;
  }
}

.custom-modal .modal-content {
  border: 0;
  border-radius: 10px;
}
.custom-modal .modal-content .modal-header {
  padding: 1.25rem;
}
.custom-modal .modal-content .modal-header .modal-title {
  font-size: 20px;
}
.custom-modal .close {
  background-color: #a0a0a0;
  color: #ffffff;
  font-size: 17px;
  height: 20px;
  line-height: 20px;
  opacity: 1;
  width: 20px;
  z-index: 99;
  border-radius: 50%;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 26px;
  right: 20px;
}
.custom-modal .modal-body {
  padding: 1.25rem;
}
.custom-modal .modal-footer {
  padding: 1.25rem;
}
.custom-modal .modal-footer .btn-outline {
  margin: 0.25rem auto;
}

.custom-medicalrecord-modal .modal-content .modal-header {
  border-color: #e5e5e5;
  margin: 1.5rem 1.5rem 0 1.5rem;
  padding: 0 0 1rem;
}
.custom-medicalrecord-modal .modal-content .form-control,
.custom-medicalrecord-modal .modal-content .bootstrap-tagsinput {
  background-color: #f5f5f7;
  border-color: #f5f5f7;
}
.custom-medicalrecord-modal .modal-content .select2-container .select2-selection--single {
  background-color: #f5f5f7;
  border-color: #f5f5f7;
}
.custom-medicalrecord-modal .modal-content .upload-medical-records {
  position: relative;
}
.custom-medicalrecord-modal .modal-content .upload-medical-records input[type="file"] {
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone {
  min-height: 180px;
}
.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone h5 {
  color: #7c7c7c;
  margin-bottom: 3px;
}
.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone h6 {
  color: #7c7c7c;
  margin-bottom: 3px;
}
.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone h6 span {
  text-decoration: underline;
}

.header .header-nav {
  background-color: #ffffff;
  border: 0;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
  height: 85px;
  margin-bottom: 0;
  padding: 0;
}
@media (max-width: 1199.98px) {
  .header .header-nav {
    padding: 0 20px;
  }
}
@media (max-width: 575.98px) {
  .header .header-nav {
    padding: 0 15px;
  }
}
@media (max-width: 991.98px) {
  .header .header-nav .navbar-header {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
  }
}
@media (max-width: 575.98px) {
  .header .header-nav .navbar-header {
    width: 100%;
  }
}
.header .header-nav .navbar-header .bar-icon {
  display: inline-block;
  width: 31px;
}
.header .header-nav .navbar-header .bar-icon span {
  background-color: #0de0fe;
  display: block;
  float: left;
  height: 3px;
  margin-bottom: 7px;
  width: 31px;
  border-radius: 2px;
}
.header .header-nav .navbar-header .bar-icon span:nth-child(2) {
  width: 16px;
}
.header .header-nav .navbar-header .bar-icon span:nth-child(3) {
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .header .header-nav .navbar-header {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
  }
}
@media (max-width: 575.98px) {
  .header .header-nav .navbar-header {
    width: 100%;
  }
}
@media (max-width: 991.98px) {
  .header .header-nav .main-menu-wrapper {
    order: 3;
    width: 260px;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1060;
    transform: translateX(-260px);
    -webkit-transform: translateX(-260px);
    -ms-transform: translateX(-260px);
    -webkit-transition: all 0.4s;
    -ms-transition: all 0.4s;
    transition: all 0.4s;
    background-color: #15558d;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
  }
}
.header .header-nav .menu-header {
  background-color: #ffffff;
  height: 60px;
  border-bottom: 1px solid #f0f0f0;
  display: none;
  padding: 0 20px;
}
@media (max-width: 991.98px) {
  .header .header-nav .menu-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
}
.header .header-nav .menu-header .menu-logo img {
  height: 40px;
}
.header .header-nav .menu-header .menu-close {
  font-size: 18px;
}
.header .header-nav .main-nav {
  list-style: none;
  margin: 0;
  padding: 0;
}
@media (max-width: 991.98px) {
  .header .header-nav .main-nav {
    -ms-flex-direction: column;
    flex-direction: column;
    margin-bottom: 0;
    list-style: none;
    padding: 0;
  }
}
@media (max-width: 991.98px) {
  .header .header-nav .main-nav ul {
    background-color: #3474ac;
    display: none;
    list-style: none;
    padding-left: 0;
    margin: 0;
  }
}
@media (min-width: 992px) {
  .header .header-nav .main-nav > .has-submenu > .submenu > .has-submenu > .submenu::before {
    top: 20px;
    margin-left: -35px;
    box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);
    border-color: transparent #ffffff #ffffff transparent;
  }
}
.header .header-nav .main-nav > .has-submenu.active .submenu li.active > a {
  color: #09dca4;
}
@media (min-width: 992px) {
  .header .header-nav .main-nav > .has-submenu.active .submenu li.active > a {
    color: #09dca4;
  }
}
.header .header-nav .main-nav > .has-submenu.active > a {
  color: #09dca4;
}
@media (min-width: 992px) {
  .header .header-nav .main-nav > .has-submenu.active > a {
    color: #09dca4;
  }
}
@media (max-width: 1199.98px) {
  .header .header-nav .main-nav > li {
    margin-right: 20px;
  }
}
@media (max-width: 1999.98px) {
  .header .header-nav .main-nav > li {
    margin-right: 30px;
  }
}
@media (max-width: 1399.98px) {
  .header .header-nav .main-nav > li {
    margin-right: 16px;
  }
}
@media (max-width: 991.98px) {
  .header .header-nav .main-nav > li {
    border-bottom: 1px solid #1663a6;
    margin: 0;
  }
}
@media (min-width: 992px) {
  .header .header-nav .main-nav > li > a {
    line-height: 85px;
    padding: 0 !important;
  }
}
@media (max-width: 991.98px) {
  .header .header-nav .main-nav > li > a {
    line-height: 1.5;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    padding: 15px 20px !important;
  }
}
@media (min-width: 992px) {
  .header .header-nav .main-nav > li > a > i {
    font-size: 12px;
    margin-left: 3px;
  }
}
@media (max-width: 991.98px) {
  .header .header-nav .main-nav > li > a > i {
    float: right;
    margin-top: 5px;
  }
}
.header .header-nav .main-nav > li.active > a {
  color: #09dca4;
}
.header .header-nav .main-nav > li .submenu li {
  position: relative;
}
@media (min-width: 992px) {
  .header .header-nav .main-nav > li .submenu li:first-child a {
    border-top: 0;
  }
}
.header .header-nav .main-nav > li .submenu li a {
  display: block;
  clear: both;
  white-space: nowrap;
  font-size: 14px;
  color: #2d3b48;
  width: 100%;
  border-top: 1px solid #f0f0f0;
  -webkit-transition: all 0.35s ease;
  -ms-transition: all 0.35s ease;
  transition: all 0.35s ease;
  padding: 10px 15px;
}
@media (max-width: 991.98px) {
  .header .header-nav .main-nav > li .submenu li a {
    border-top: 0;
    color: #ffffff;
    padding: 10px 15px 10px 35px;
  }
}
@media (min-width: 992px) {
  .header .header-nav .main-nav > li .submenu li .submenu {
    left: 100%;
    top: 0;
    margin-top: 10px;
  }
}
.header .header-nav .main-nav > li .submenu li .submenu li {
  position: relative;
}
.header .header-nav .main-nav > li .submenu li .submenu li a {
  display: block;
  clear: both;
  white-space: nowrap;
  font-size: 14px;
  color: #2d3b48;
  width: 100%;
  border-top: 1px solid #f0f0f0;
  padding: 10px 15px;
  -webkit-transition: all 0.35s ease;
  -ms-transition: all 0.35s ease;
  transition: all 0.35s ease;
}
@media (max-width: 991.98px) {
  .header .header-nav .main-nav > li .submenu li .submenu li a {
    border-top: 0;
    color: #ffffff;
    padding: 10px 15px 10px 45px;
  }
}
.header .header-nav .main-nav > li .submenu li .submenu li .has-submenu > a::after {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  font-size: 13px;
  position: absolute;
  top: 12px;
  right: 15px;
}
@media (min-width: 992px) {
  .header .header-nav .main-nav > li .submenu > li .submenu {
    left: 100%;
    top: 0;
    margin-top: 10px;
  }
}
.header .header-nav .main-nav > li .submenu > li.has-submenu > a::after {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  font-size: 13px;
  position: absolute;
  top: 12px;
  right: 15px;
}
@media (max-width: 991.98px) {
  .header .header-nav .main-nav > li .submenu > li.has-submenu > a::after {
    content: "\\f078";
  }
}
@media (min-width: 992px) {
  .header .header-nav .main-nav > li:last-child {
    margin-right: 0;
  }
}
@media (min-width: 992px) {
  .header
    .header-nav
    .main-nav
    > li.has-submenu:hover
    > .submenu
    > li.has-submenu:hover
    > .submenu {
    visibility: visible;
    opacity: 1;
    margin-top: -1px;
    margin-right: 0;
  }
}
@media (min-width: 992px) {
  .header .header-nav .main-nav li {
    display: block;
    position: relative;
  }
}
@media (min-width: 992px) {
  .header .header-nav .main-nav li > ul {
    background-color: #ffffff;
    display: block;
    font-size: 14px;
    min-width: 200px;
    opacity: 0;
    visibility: hidden;
    z-index: 1000;
    -webkit-transition: all 0.2s ease;
    -ms-transition: all 0.2s ease;
    transition: all 0.2s ease;
    transform: translateY(20px);
    -webkit-transform: translateY(20px);
    -ms-transform: translateY(20px);
    position: absolute;
    top: 100%;
    left: 0;
    margin: 0;
    padding: 0;
    border-radius: 5px;
    -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
  }
}
.header .header-nav .main-nav li a {
  display: block;
  font-size: 14px;
  font-weight: 500;
}
.header .header-nav .main-nav li.login-link {
  display: none;
}
@media (max-width: 575.98px) {
  .header .header-nav .main-nav li.login-link {
    display: block;
  }
}
@media (min-width: 992px) {
  .header .header-nav .main-nav li .submenu a:hover {
    color: #09dca4 !important;
    letter-spacing: 0.5px;
    padding-left: 20px !important;
  }
}
@media (min-width: 992px) {
  .header .header-nav .main-nav li .submenu::before {
    border: 7px solid #ffffff;
    border-color: transparent transparent #ffffff #ffffff;
    content: "";
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    -ms-transform: rotate(135deg);
    position: absolute;
    top: 2px;
    left: 45px;
    -webkit-box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
    box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
  }
}
@media (max-width: 991.98px) {
  .header .header-nav .main-nav li + li {
    margin-left: 0;
  }
}
@media (min-width: 992px) {
  .header .header-nav .main-nav li.has-submenu:hover > .submenu {
    visibility: visible;
    opacity: 1;
    margin-top: 0;
    transform: translateY(0);
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
  }
}
.header .header-nav .main-nav .has-submenu.active > a {
  color: #09dca4;
}
@media (min-width: 992px) {
  .header .header-nav .main-nav .has-submenu.active > a {
    color: #09dca4;
  }
}
.header .header-nav .main-nav .has-submenu.active .submenu li.active > a {
  color: #09dca4;
}
@media (min-width: 992px) {
  .header .header-nav .main-nav .has-submenu.active .submenu li.active > a {
    color: #09dca4;
  }
}
@media (min-width: 992px) {
  .header .header-nav .main-nav .has-submenu:hover > .submenu {
    visibility: visible;
    opacity: 1;
    margin-top: 0;
    transform: translateY(0);
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
  }
}
.header .header-nav .main-nav .has-submenu > .submenu__ > .has-submenu--.submenu::before {
  top: 20px;
  margin-left: -35px;
  border-color: transparent #ffffff #ffffff transparent;
  -webkit-box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);
}
.header .header-nav .logo {
  display: inline-block;
  margin-right: 30px;
  width: 160px;
}
@media (max-width: 1199.98px) {
  .header .header-nav .logo {
    margin-right: 21px;
  }
}
@media (max-width: 575.98px) {
  .header .header-nav .logo {
    width: 100%;
    text-align: center;
    margin-right: 0;
  }
}
@media (max-width: 575.98px) {
  .header .header-nav .logo img {
    height: 40px;
  }
}
.header .header-nav .header-navbar-rht {
  margin: 0 0 0 auto;
  padding: 0;
}
@media (max-width: 575.98px) {
  .header .header-nav .header-navbar-rht {
    display: none;
  }
}
.header .header-nav .header-navbar-rht li {
  padding-right: 20px;
}
.header .header-nav .header-navbar-rht li:last-child {
  padding-right: 0px;
}
.header .header-nav .header-navbar-rht li .dropdown-menu {
  border: 0;
  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
}
@media (min-width: 992px) {
  .header .header-nav .header-navbar-rht li .dropdown-menu {
    min-width: 200px;
    visibility: hidden;
    opacity: 0;
    display: block;
    margin: 0;
    padding: 0;
    border-radius: 5px;
    transform: translateY(20px);
    -webkit-transform: translateY(20px);
    -ms-transform: translateY(20px);
  }
}
.header .header-nav .header-navbar-rht li .dropdown-menu::before {
  content: "";
  border: 7px solid #ffffff;
  border-color: transparent transparent #ffffff #ffffff;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
  position: absolute;
  top: -5px;
  right: 17px;
  -webkit-box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
  box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
}
.header .header-nav .header-navbar-rht li .dropdown-menu .dropdown-item {
  border-top: 1px solid #f0f0f0;
  padding: 10px 15px;
}
.header .header-nav .header-navbar-rht li .dropdown-menu .dropdown-item:first-child {
  border-top: 0;
  border-radius: 5px 5px 0 0;
}
.header .header-nav .header-navbar-rht li .dropdown-menu .dropdown-item:last-child {
  border-radius: 0 0 5px 5px;
}
.header .header-nav .header-navbar-rht li .dropdown-menu a:hover {
  color: #09dca4;
  letter-spacing: 0.5px;
  padding-left: 20px;
  background-color: #ffffff;
}
.header .header-nav .header-navbar-rht li a.header-login {
  border: 2px solid #09e5ab;
  text-align: center;
  font-size: 15px;
  color: #09e5ab;
  text-transform: uppercase;
  font-weight: 500;
  border-radius: 4px;
  padding: 10px 15px !important;
}
.header .header-nav .header-navbar-rht li a.header-login:hover {
  background-color: #09e5ab;
  border-color: #09e5ab;
  color: #ffffff;
}
.header .header-nav .header-navbar-rht li .header-contact-img {
  display: inline-block;
}
.header .header-nav .header-navbar-rht li .header-contact-img i {
  color: rgba(0, 0, 0, 0.5);
  font-size: 30px;
}
.header .header-nav .header-navbar-rht li .header-contact-detail {
  display: inline-block;
  padding-left: 10px;
}
.header .header-nav .header-navbar-rht li .header-contact-detail p.contact-header {
  color: #484848;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 2px;
  text-align: left;
}
.header .header-nav .header-navbar-rht li .header-contact-detail p.contact-info-header {
  color: #000000;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 0;
}
.header .header-nav .header-navbar-rht li .header-contact-detail p.contact-info-header.white-font {
  color: #ffffff;
}
@media (min-width: 992px) {
  .header .header-nav .header-navbar-rht li.show > .dropdown-menu {
    visibility: visible;
    opacity: 1;
    margin-top: 0;
    transform: translateY(0);
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
  }
}
.header .header-nav .header-navbar-rht li .dropdown-menu.show {
  visibility: visible;
  opacity: 1;
  margin-top: 0;
  transform: translateY(0);
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  -webkit-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
@media (min-width: 992px) {
  .header .header-nav .header-navbar-rht li .dropdown-menu {
    min-width: 200px;
    visibility: hidden;
    opacity: 0;
    display: block;
    transform: translateY(20px);
    -webkit-transform: translateY(20px);
    -ms-transform: translateY(20px);
    border-radius: 5px;
    margin: 0;
    padding: 0;
  }
}
@media (max-width: 991.98px) {
  .header .header-nav .header-navbar-rht li.contact-item {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .header .header-nav .header-navbar-rht li.contact-item {
    display: none;
  }
}
.header .header-nav .header-navbar-rht .dropdown-toggle::after {
  display: none;
}
.header .header-nav .header-navbar-rht .dropdown-menu {
  min-width: 200px;
  padding: 0;
}
.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item {
  border-top: 1px solid #e3e3e3;
  padding: 10px 15px;
}
.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item:hover {
  color: #0e82fd;
}
.header .header-nav .header-navbar-rht .has-arrow .dropdown-toggle:after {
  border-top: 0;
  border-left: 0;
  border-bottom: 2px solid #757575;
  border-right: 2px solid #757575;
  content: "";
  height: 8px;
  display: inline-block;
  pointer-events: none;
  width: 8px;
  vertical-align: 2px;
  margin-left: 10px;
  transform-origin: 66% 66%;
  -webkit-transform-origin: 66% 66%;
  -ms-transform-origin: 66% 66%;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -webkit-transition: all 0.15s ease-in-out;
  -ms-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
}
.header .header-nav .header-navbar-rht .has-arrow .dropdown-toggle[aria-expanded="true"]:after {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  -ms-transform: rotate(-135deg);
}
.header .header-nav .header-navbar-rht .has-arrow .dropdown-toggle .user-img {
  display: inline-block;
  position: relative;
}
.header .header-nav .header-navbar-rht .has-arrow .dropdown-toggle .user-img > img {
  height: 31px;
  object-fit: cover;
  width: 31px;
}
.header .header-nav .header-navbar-rht .has-arrow .user-header {
  padding: 10px 15px;
}
.header .header-nav .header-navbar-rht .has-arrow .user-header .user-text {
  margin-left: 10px;
}
.header .header-nav .header-navbar-rht .has-arrow .user-header .user-text h6 {
  font-size: 15px;
  margin-bottom: 2px;
}
.header .header-nav .header-navbar-rht .has-arrow .logged-item .nav-link {
  font-size: 14px;
  line-height: 85px;
  padding: 0 10px;
}
.header .header-nav .header-navbar-rht .has-arrow.logged-item .nav-link {
  font-size: 14px;
  line-height: 85px;
  padding: 0 10px;
}
.header .header-nav .header-navbar-rht .view-cart-header {
  position: relative;
}
.header .header-nav .header-navbar-rht .view-cart-header a#cart {
  position: relative;
  font-size: 18px;
  color: #6b7280;
}
.header .header-nav .header-navbar-rht .view-cart-header a#cart:hover {
  color: #0e82fd;
}
.header .header-nav .header-navbar-rht .noti-nav .nav-link {
  font-size: 18px;
  color: #6b7280;
}
.header .header-nav .header-navbar-rht .noti-nav .nav-link .badge {
  background-color: #0e82fd;
  border-radius: 2px;
  color: #ffffff;
  font-size: 10px;
  font-style: normal;
  text-align: center;
  position: absolute;
  top: 19px;
  right: -6px;
  padding: 0 5px;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  font-weight: normal;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu {
  min-width: 370px;
  padding: 0;
  font-weight: normal;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .topnav-dropdown-header {
  border-bottom: 1px solid #eef1fe;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  padding-right: 15px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .noti-content {
  height: 260px;
  width: 420px;
  overflow-y: auto;
  position: relative;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .notification-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu ul.notification-list > li {
  margin-top: 0;
  border-bottom: 1px solid #f5f5f5;
  padding: 0;
  margin: 0;
  width: 100%;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu ul.notification-list > li a {
  display: block;
  padding: 10px 15px;
  border-radius: 2px;
  width: 100%;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu ul.notification-list > li a:hover {
  letter-spacing: normal;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .media:last-child {
  border-bottom: none;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .media > .avatar {
  margin-right: 10px;
  width: auto;
  height: auto;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .media > .avatar > img {
  width: 46px;
  height: 46px;
  border-radius: 5px;
  margin-right: 8px;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .media-body {
  width: 100%;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .media-body h6 {
  margin-bottom: 3px;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .noti-title {
  color: #0e82fd;
}
.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .notification-time {
  font-size: 12px;
  line-height: 1.35;
  float: right;
}
.header .nav-transparent {
  background-color: transparent !important;
  border-bottom: 0 !important;
}
@media (min-width: 992px) {
  .header .nav-transparent .white-font > li > a {
    color: #ffffff;
  }
}
.header.custom {
  background-color: transparent;
  border-bottom: 0 !important;
}
.header.custom .no-border {
  border: none !important;
}
@media (min-width: 992px) {
  .header.custom .white-font > li > a {
    color: #ffffff;
  }
}
.header.custom .header-navbar-rht.right-menu .header-contact-img i {
  width: 30px;
  background-color: #ffffff;
  height: 30px;
  border-radius: 50%;
  font-size: 11px;
  color: #1860ca;
  border: 2px solid #acc9f5;
}
.header.custom .header-navbar-rht.right-menu .header-contact-detail p.contact-info-header {
  color: #ffffff;
}
.header.custom .header-navbar-rht.right-menu li {
  border-right: 0;
}
.header.custom .header-navbar-rht.right-menu li a.header-login {
  width: 120px;
  padding: 10px !important;
}
.header.custom .header-navbar-rht.right-menu li:last-child {
  border-right: 0;
  padding: 0;
}
.header.header-five .no-border {
  border: none !important;
}
.header.header-five .main-menu-wrapper {
  margin-left: 40px !important;
}
@media (max-width: 991.98px) {
  .header.header-five .main-menu-wrapper {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .header.header-five .main-menu-wrapper .main-nav .has-submenu.active > a {
    color: #28daf4;
  }
}
.header.header-five .main-menu-wrapper .main-nav .has-submenu.active > a:after {
  content: "";
  width: 70px;
  background: #28daf4;
  height: 2px;
  z-index: 9;
  position: absolute;
  bottom: 25px;
  left: -7px;
}
.header.header-five .main-menu-wrapper .main-nav.blue-font > li > a {
  color: #2a85d1;
  text-transform: uppercase;
}
.header.header-five .header-navbar-rht li a.header-login.white-bg {
  background-color: #ffffff;
  color: #28daf4 !important;
  border: 1px solid #28daf4;
  font-size: 12px;
}
.header .user-menu {
  float: right;
  position: relative;
  z-index: 99;
  margin: 0;
}
.header .user-menu.nav li a {
  color: #ffffff;
  font-size: 14px;
  line-height: 58px;
  height: 60px;
  padding: 0 15px;
}
.header .user-menu.nav li a:hover,
.header .user-menu.nav li a:focus {
  background-color: rgba(0, 0, 0, 0.2);
}
.header .user-menu.nav li a:hover i,
.header .user-menu.nav li a:focus i {
  color: #ffffff;
}
.header .user-menu.nav li a.mobile_btn {
  border: 0;
  position: relative;
  cursor: pointer;
  margin: 0;
  padding: 0;
}
.header.header-four .header-nav {
  background-color: #2264c5;
  border: none;
}
@media (min-width: 992px) {
  .header.header-four .main-nav .has-submenu.active > a {
    color: #ffffff;
    border-top: 3px solid #e74e84;
  }
}
@media (min-width: 992px) {
  .header.header-four .main-nav > li > a {
    line-height: 80px;
    color: #ffffff;
  }
}
.header.header-four .nav-item {
  line-height: 60px;
  align-items: center;
  display: flex !important;
}
.header.header-four .nav-item a.header-login {
  border: 2px solid #ffffff;
  border-radius: 30px;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  text-transform: uppercase;
  font-weight: 500;
  line-height: 20px;
  padding: 10px 15px !important;
}
.header.header-four .nav-item a.header-login:hover {
  background-color: #10defd;
  border: 2px solid #10defd;
}
.header.header-four .nav-item a.header-login i {
  font-size: 14px;
  margin: 0;
  margin-right: 3px;
}
.header.header-trans {
  position: fixed;
  display: block;
  width: 100%;
  z-index: 9999;
  background: transparent;
}
.header.header-trans .header-nav {
  background: transparent;
  border-bottom: none;
}
.header.header-trans .main-menu-wrapper {
  margin-left: auto;
}
@media (max-width: 1399.98px) {
  .header.header-trans .main-menu-wrapper {
    margin-right: auto;
    margin-left: unset;
  }
}
.header.header-trans .header-navbar-rht li {
  height: 20px;
  padding-right: 15px;
}
@media (max-width: 1399.98px) {
  .header.header-trans .header-navbar-rht li {
    padding-right: 5px;
  }
}
.header.header-trans .header-navbar-rht li .header-contact-img i {
  color: #1c5b90;
  font-size: 14px;
}
.header.header-trans .header-navbar-rht li .header-contact-detail p.contact-info-header {
  color: #1c5b90;
}
.header.header-trans .header-navbar-rht li:last-child {
  border-right: 0;
  padding-left: 15px;
}
@media (max-width: 1199.98px) {
  .header.header-trans .header-navbar-rht li:last-child {
    padding-left: 0;
  }
}
.header.header-trans .header-navbar-rht li a.header-login {
  text-align: center;
  font-size: 13px;
  color: #ffffff;
  text-transform: uppercase;
  background: #1c5b91;
  box-shadow: 0px 4px 4px rgba(189, 189, 189, 0.25);
  border-radius: 47px;
  border: 0;
}
.header.header-trans .header-navbar-rht li a.header-login.white-bg {
  background-color: #ffffff;
  color: #2264c5;
}
.header.header-trans .header-navbar-rht li a.header-login:hover {
  background-color: #1c5b91;
  color: #ffffff;
}

.header-one {
  width: 100%;
  z-index: 1040;
  -webkit-transition: all 0.3s ease 0s;
  -ms-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  background-color: transparent;
  box-shadow: 0px 4px 4px rgba(198, 198, 198, 0.25);
}
.header-one .header-nav .main-nav .has-submenu.active .submenu li.active > a {
  color: #0e82fd;
}
.header-one.min-header {
  width: 100%;
  z-index: 1040;
  -webkit-transition: all 0.3s ease 0s;
  -ms-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  background-color: transparent;
}
.header-one.header-fixed {
  position: fixed;
  display: block;
  width: 100%;
  z-index: 9999;
  background: #f2f6f6;
  box-shadow: inherit;
}
.header-one.header-space .header-nav {
  height: 80px;
}
.header-one .header-nav {
  background-color: transparent;
  border: 0;
  position: relative;
  margin: 0;
  padding: 0;
  height: 100px;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
@media (max-width: 991.98px) {
  .header-one .header-nav {
    height: 70px;
  }
}
@media (max-width: 991.98px) {
  .header-one .header-nav {
    margin: 0;
    padding: 0 0;
  }
}
@media (max-width: 991.98px) {
  .header-one .header-nav .menu-header {
    height: 70px;
  }
}
@media (max-width: 991.98px) {
  .header-one .header-nav .main-menu-wrapper {
    background-color: #0e82fd;
  }
}
@media (max-width: 991.98px) {
  .header-one .navbar-header {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    width: 100%;
  }
}
.header-one .navbar-header #mobile_btn {
  display: none;
  margin-right: 30px;
}
@media (max-width: 991.98px) {
  .header-one .navbar-header #mobile_btn {
    display: inline-block;
    margin: 0;
    padding: 0 0;
  }
}
@media (max-width: 767.98px) {
  .header-one .navbar-header #mobile_btn {
    margin-right: 0;
  }
}
.header-one .navbar-header #mobile_btn .bar-icon {
  display: inline-block;
  width: 31px;
}
.header-one .navbar-header #mobile_btn .bar-icon span {
  background-color: #0e82fd;
  display: block;
  float: left;
  height: 3px;
  margin-bottom: 7px;
  width: 31px;
  border-radius: 2px;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  transition: ease all 0.5s;
  position: relative;
}
.header-one .navbar-header #mobile_btn .bar-icon span:nth-child(2) {
  width: 16px;
}
.header-one .navbar-header #mobile_btn .bar-icon span:nth-child(3) {
  margin-bottom: 0;
}
.header-one .main-menu-wrapper {
  margin: 0;
  padding: 0;
}
.header-one .main-menu-wrapper .main-nav {
  list-style: none;
  margin: 0;
  padding: 0;
}
@media (max-width: 991.98px) {
  .header-one .main-menu-wrapper .main-nav ul {
    background-color: #e6f1ff;
    display: none;
    list-style: none;
    margin: 0;
    padding-left: 0;
  }
}
.header-one .main-menu-wrapper .main-nav li .btn {
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  padding: 7px 8px !important;
  border: 1px solid #0e82fd;
  border-radius: 6px;
}
.header-one .main-menu-wrapper .main-nav li .btn:hover {
  color: #0e82fd;
  border: 1px solid #0e82fd;
}
.header-one .main-menu-wrapper .main-nav li .btn i {
  font-size: 15px;
  margin-right: 5px;
  margin-left: 0;
}
.header-one .main-menu-wrapper .main-nav li .btn.reg-btn {
  min-width: 108px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  color: #1f2937;
  box-shadow: inset 0 0 0 0 #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.header-one .main-menu-wrapper .main-nav li .btn.reg-btn:hover {
  color: #ffffff;
  background-color: #0e82fd;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 50px #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.header-one .main-menu-wrapper .main-nav li .btn.log-btn {
  min-width: 87px;
  color: #ffffff;
  background-color: #0e82fd;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.header-one .main-menu-wrapper .main-nav li .btn.log-btn:hover {
  color: #0e82fd;
  background-color: #ffffff;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 50px #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.header-one .main-menu-wrapper .main-nav li a {
  font-size: 15px;
  font-weight: 500;
  color: #1f2937;
  display: block;
}
@media (max-width: 1199.98px) {
  .header-one .main-menu-wrapper .main-nav li a {
    font-size: 14px;
  }
}
.header-one .main-menu-wrapper .main-nav li.login-link {
  display: none;
}
@media (max-width: 991.98px) {
  .header-one .main-menu-wrapper .main-nav li.login-link {
    display: block;
  }
}
@media (min-width: 992px) {
  .header-one .main-menu-wrapper .main-nav li > ul {
    background: #ffffff;
    box-shadow: 0px 4px 4px rgba(196, 196, 196, 0.25);
    border-radius: 0px 0px 6px 5px;
    display: block;
    font-size: 14px;
    min-width: 200px;
    opacity: 0;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 100%;
    left: 0;
    -webkit-transition: all 0.2s ease;
    -ms-transition: all 0.2s ease;
    transition: all 0.2s ease;
    transform: translateY(20px);
    -webkit-transform: translateY(20px);
    -ms-transform: translateY(20px);
    visibility: hidden;
    z-index: 1000;
  }
}
@media (min-width: 992px) {
  .header-one .main-menu-wrapper .main-nav li {
    display: block;
    position: relative;
  }
}
.header-one .main-menu-wrapper .main-nav .register-btn {
  margin-right: 10px;
}
.header-one .main-menu-wrapper .main-nav .register-btn:last-child {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .header-one .main-menu-wrapper .main-nav .register-btn {
    display: none;
  }
}
@media (min-width: 992px) {
  .header-one .main-menu-wrapper .main-nav > li {
    margin-right: 8px;
  }
}
@media (min-width: 1200.98px) {
  .header-one .main-menu-wrapper .main-nav > li {
    margin-right: 20px;
  }
}
@media (max-width: 991.98px) {
  .header-one .main-menu-wrapper .main-nav > li {
    border-bottom: 1px solid #e6f1ff;
    margin-left: 0;
    margin-right: 0;
  }
}
@media (max-width: 991.98px) {
  .header-one .main-menu-wrapper .main-nav > li > a i {
    float: right;
    margin-top: 5px;
  }
}
@media (max-width: 991.98px) {
  .header-one .main-menu-wrapper .main-nav > li > a {
    line-height: 1.5;
    padding: 15px 20px !important;
    color: #ffffff !important;
    font-size: 14px;
    background: transparent !important;
    border-radius: 0 !important;
  }
}
.header-one .main-menu-wrapper .main-nav > li:last-child {
  margin-right: 0;
}
.header-one .main-menu-wrapper .main-nav > li.active > a {
  color: #0e82fd !important;
}
@media (max-width: 991.98px) {
  .header-one .main-menu-wrapper .main-nav > li.active > a {
    color: #ffffff !important;
  }
}
.header-one .main-menu-wrapper .main-nav > li > a {
  position: relative;
}
.header-one .main-menu-wrapper .main-nav > li > a:hover {
  color: #0e82fd;
}
@media (min-width: 992px) {
  .header-one .main-menu-wrapper .main-nav > li > a {
    padding: 23px 0 28px !important;
    line-height: normal;
  }
}
.header-one .main-menu-wrapper .main-nav > li > a > i {
  font-size: 10px;
  margin-left: 6px;
}
.header-one .main-menu-wrapper .main-nav > li.searchbar a {
  color: #6b7280;
}
.header-one .main-menu-wrapper .main-nav > li.searchbar a i {
  font-size: 16px;
}
@media (max-width: 1199.98px) {
  .header-one .main-menu-wrapper .main-nav > li.searchbar {
    display: none;
  }
}
.header-one .main-menu-wrapper .main-nav > li.has-submenu .submenu .has-submenu .submenu::before {
  top: 20px;
  margin-left: -35px;
  box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);
  border-color: transparent #ffffff #ffffff transparent;
}
@media (min-width: 992px) {
  .header-one .main-menu-wrapper .main-nav > li.has-submenu:hover > .submenu {
    visibility: visible;
    opacity: 1;
    margin-top: 0;
    transform: translateY(0);
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
  }
  .header-one
    .main-menu-wrapper
    .main-nav
    > li.has-submenu:hover
    > .submenu
    > li.has-submenu:hover
    .submenu {
    visibility: visible;
    opacity: 1;
    margin-top: 0;
    margin-right: 0;
  }
}
.header-one .main-menu-wrapper .main-nav > li .submenu li {
  position: relative;
}
.header-one .main-menu-wrapper .main-nav > li .submenu li a {
  display: block;
  padding: 10px 15px;
  clear: both;
  white-space: nowrap;
  font-size: 14px;
  color: #2d3b48;
  -webkit-transition: all 0.35s ease;
  -ms-transition: all 0.35s ease;
  transition: all 0.35s ease;
  width: 100%;
  position: relative;
  border-top: 1px solid #f0f0f0;
}
.header-one .main-menu-wrapper .main-nav > li .submenu li a.active {
  color: #0e82fd;
}
.header-one .main-menu-wrapper .main-nav > li .submenu li a:hover {
  color: #0e82fd !important;
}
@media (max-width: 991.98px) {
  .header-one .main-menu-wrapper .main-nav > li .submenu li a {
    padding: 10px 15px 10px 35px;
  }
}
.header-one .main-menu-wrapper .main-nav > li .submenu > li.has-submenu > a::after {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  font-weight: 700;
  position: absolute;
  top: 12px;
  right: 15px;
  font-size: 13px;
}
@media (min-width: 992px) {
  .header-one .main-menu-wrapper .main-nav > li .submenu > li .inner-submenu {
    left: 100%;
    top: 0;
    margin-top: 10px;
  }
}
@media (min-width: 992px) {
  .header-one .main-menu-wrapper .main-nav > li .submenu::before {
    border: 7px solid #ffffff;
    border-color: transparent transparent #ffffff #ffffff;
    box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
    content: "";
    position: absolute;
    top: 2px;
    left: 45px;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    -ms-transform: rotate(135deg);
  }
}
@media (max-width: 991.98px) {
  .header-one .main-menu-wrapper .main-nav {
    padding: 0;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
  }
}
@media (max-width: 991.98px) {
  .header-one .main-menu-wrapper {
    order: 3;
    width: 260px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1060;
    -webkit-transition: all 0.4s;
    -ms-transition: all 0.4s;
    transition: all 0.4s;
    transform: translateX(-260px);
    -webkit-transform: translateX(-260px);
    -ms-transform: translateX(-260px);
    background-color: #09e5ab;
  }
}
.header-one .logo {
  display: inline-block;
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .header-one .logo.navbar-brand {
    width: 100%;
    text-align: center;
    margin: 0;
    padding: 0;
  }
}
.header-one .header-nav .header-navbar-rht {
  margin: 0;
  padding: 0;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  margin-right: 2px;
}
.header-one .header-nav .header-navbar-rht li {
  margin-right: 10px;
}
.header-one .header-nav .header-navbar-rht li .btn {
  color: #ffffff;
  font-weight: 600;
  font-size: 15px;
  padding: 6px 12px;
  border: 1px solid #09e5ab;
  border-radius: 6px;
}
.header-one .header-nav .header-navbar-rht li .btn:hover {
  color: #09e5ab;
  border: 1px solid #09e5ab;
}
.header-one .header-nav .header-navbar-rht li .btn i {
  margin-right: 5px;
}
.header-one .header-nav .header-navbar-rht li .btn.reg-btn {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  color: #1f2937;
  box-shadow: inset 0 0 0 0 #09e5ab;
}
.header-one .header-nav .header-navbar-rht li .btn.reg-btn:hover {
  color: #ffffff;
  background-color: #09e5ab;
  border: 1px solid #09e5ab;
}
.header-one .header-nav .header-navbar-rht li:last-child {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .header-one .header-nav .header-navbar-rht {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .header-one .header-nav .header-navbar-rht {
    display: none;
  }
}
.header-one .menu-header {
  background-color: #ffffff;
  height: 72px;
  padding: 0 15px;
  border-bottom: 2px solid #0e82fd;
  display: none;
}
.header-one .menu-header .menu-close {
  font-size: 20px;
}
.header-one .menu-header .menu-close i {
  color: #0e82fd;
}
.header-one .menu-header .menu-close i:hover {
  color: #000000;
}
@media (max-width: 991.98px) {
  .header-one .menu-header {
    display: flex;
  }
}

.togglesearch {
  position: absolute;
  top: 74px;
  right: 8%;
  width: 280px;
  display: none;
  z-index: 999;
  background: #ffffff;
  padding: 10px 10px;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(183, 183, 183, 0.25);
}
.togglesearch input[type="text"] {
  width: 182px;
  padding: 5px 10px;
  border: 1px solid #0e82fd;
  outline: none;
  height: 39px;
  border-radius: 5px 0 0 5px;
}
.togglesearch button {
  background: #0e82fd;
  color: #ffffff;
  border: 1px solid #0e82fd;
  outline: none;
  cursor: pointer;
  border-radius: 0 5px 5px 0;
  padding: 10px 12px;
  font-size: 14px;
}

.sidebar-overlay {
  background-color: rgba(0, 0, 0, 0.6);
  display: none;
  height: 100%;
  width: 100%;
  z-index: 1040;
  position: fixed;
  top: 0;
  left: 0;
}
@media (max-width: 991.98px) {
  .sidebar-overlay.opened {
    display: block;
  }
}

.menu-opened .main-menu-wrapper {
  transform: translateX(0) !important;
  -webkit-transform: translateX(0) !important;
  -ms-transform: translateX(0) !important;
}

html.menu-opened body {
  overflow: hidden;
}

#mobile_btn {
  display: none;
  margin-right: 30px;
}
@media (max-width: 991.98px) {
  #mobile_btn {
    display: inline-block;
  }
}
@media (max-width: 575.98px) {
  #mobile_btn {
    margin-right: 0;
    z-index: 99;
    position: absolute;
    left: 0;
    padding: 0;
  }
}

.header-two .header-nav .navbar-header #mobile_btn,
.header-eight .header-nav .navbar-header #mobile_btn,
.custom .header-nav .navbar-header #mobile_btn {
  margin-left: 15px;
}

@media (max-width: 575.98px) {
  .navbar-brand.logo {
    width: 100%;
    text-align: center;
    margin-right: 0;
  }
}
@media (max-width: 575.98px) {
  .navbar-brand.logo img {
    height: 40px;
  }
}

.header-top {
  display: flex;
  background: #09e5ab;
  color: #ffffff;
  padding: 8px 30px;
}
@media (max-width: 991.98px) {
  .header-top {
    display: none;
  }
}
.header-top ul {
  display: flex;
}
.header-top ul li {
  padding-right: 25px;
  font-size: 13px;
}
.header-top ul li .top-icon {
  margin-right: 5px;
}
.header-top ul li:last-child {
  padding-right: 0;
}
.header-top .right-top {
  margin-left: auto;
}

.login-header-info {
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: unset;
  background: #ffffff;
  border-bottom: 2px solid #f1f1f3;
  width: 100%;
  z-index: 11;
}
@media (max-width: 991.98px) {
  .login-header-info {
    display: none;
  }
}
.login-header-info .header-nav {
  height: 83px;
  margin: 0;
  padding: 0 30px;
}
@media (max-width: 991.98px) {
  .login-header-info .header-nav {
    height: 70px;
    margin: 0;
    padding: 0 20px;
  }
}
@media (max-width: 767.98px) {
  .login-header-info .header-nav {
    margin: 0;
    padding: 0 15px;
  }
}
.login-header-info .header-nav .main-nav li a {
  font-size: 15px;
  font-weight: 500;
  color: #6b7280;
}
.login-header-info .header-nav .main-nav li a:hover {
  color: #0e82fd;
}
.login-header-info .header-navbar-rht {
  display: none;
}
@media (max-width: 991.98px) {
  .login-header-info .header-navbar-rht {
    display: inherit;
  }
}
@media (max-width: 767.98px) {
  .login-header-info .header-navbar-rht {
    display: none;
  }
}
.login-header-info .flag-dropdown {
  margin: 0;
  padding: 18px 0;
}
@media (max-width: 991.98px) {
  .login-header-info .flag-dropdown {
    margin: 0;
    padding: 12px 0;
  }
}

.flag-dropdown .dropdown-toggle {
  color: #1f2937 !important;
  font-size: 14px !important;
  padding: 11px 15px;
  min-width: 146px;
  background: #ffffff;
  border: 1px solid #e4e4e8;
  border-radius: 8px;
  position: relative;
  display: flex !important;
}
.flag-dropdown .dropdown-toggle.show + .dropdown-menu {
  visibility: visible;
  opacity: 1;
  margin-top: 0;
  border-radius: 0 0 5px 5px;
  transform: translateY(0);
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
}
.flag-dropdown .dropdown-toggle:after {
  border-top: 0;
  border-left: 0;
  border-bottom: 2px solid #000000;
  border-right: 2px solid #000000;
  content: "";
  height: 8px;
  display: inline-block;
  pointer-events: none;
  -webkit-transform-origin: 66% 66%;
  -ms-transform-origin: 66% 66%;
  transform-origin: 66% 66%;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -webkit-transition: all 0.15s ease-in-out;
  -ms-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  width: 8px;
  vertical-align: 2px;
  margin-left: 0;
  position: absolute;
  top: 15px;
  right: 15px;
}
.flag-dropdown .dropdown-toggle:after:hover {
  border-bottom: 2px solid #000000;
  border-right: 2px solid #000000;
}
.flag-dropdown .dropdown-toggle .flag-img {
  margin-right: 10px;
  border-radius: 50px;
  width: 20px;
}
.flag-dropdown.show + .dropdown-menu {
  visibility: visible;
  opacity: 1;
  margin-top: 0;
  border-radius: 0 0 5px 5px;
  transform: translateY(0);
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
}
.flag-dropdown .dropdown-menu {
  border-radius: 5px;
  margin: 0;
  padding: 0;
  min-width: 200px;
  visibility: hidden;
  opacity: 0;
  top: 100%;
  left: auto !important;
  right: 0 !important;
  -webkit-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  transition: all 0.2s ease;
  display: block;
  transform: translateY(40px);
  -webkit-transform: translateY(40px);
  -ms-transform: translateY(40px);
}
.flag-dropdown .dropdown-menu .dropdown-item {
  font-size: 14px !important;
  color: #000000;
  margin: 0;
  padding: 10px 15px;
  font-weight: 600;
}
.flag-dropdown .dropdown-menu .dropdown-item img {
  margin-right: 10px;
  width: 20px;
}
.flag-dropdown .dropdown-menu .dropdown-item:hover {
  color: #000000 14px !important;
}
.flag-dropdown .dropdown-toggle[aria-expanded="true"]:after {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  -ms-transform: rotate(-135deg);
}

.main-nav li .flag-dropdown .submenu::before {
  display: none;
}

.flag-dropdown .dropdown-menu .dropdown-item.active,
.flag-dropdown .dropdown-menu .dropdown-item:active {
  color: #ffffff;
  background-color: #09e5ab;
}

.noti-nav .nav-link {
  font-size: 18px;
  color: #6b7280;
}
.noti-nav .nav-link .badge {
  background-color: #0e82fd;
  border-radius: 2px;
  color: #ffffff;
  font-size: 10px;
  font-style: normal;
  text-align: center;
  position: absolute;
  top: 19px;
  right: -6px;
  padding: 0 5px;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  font-weight: normal;
}

.noti-nav .dropdown-menu {
  min-width: 420px;
  padding: 0;
}

.main-nav li.megamenu > ul {
  width: 100%;
}

.megamenu-wrapper {
  padding: 25px 25px 0;
}

.single-demo {
  transition: 0.4s;
  margin-bottom: 25px;
}

.single-demo:hover {
  transform: translateY(-20px);
}

.header
  .main-menu-wrapper
  .main-nav
  > li
  .submenu
  li
  .single-demo.active
  .demo-info
  .inner-demo-img {
  color: #1c5b91;
}

.header.header-sixteen
  .main-menu-wrapper
  .main-nav
  > li
  .submenu
  li
  .single-demo.active
  .demo-info
  .inner-demo-img {
  color: #1c5b91;
}

.header.header-thirteen
  .main-menu-wrapper
  .main-nav
  > li
  .submenu
  li
  .single-demo.active
  .demo-info
  .inner-demo-img {
  color: #1c5b91;
}

.header.header-twelve
  .main-menu-wrapper
  .main-nav
  > li
  .submenu
  li
  .single-demo.active
  .demo-info
  .inner-demo-img {
  color: #1c5b91;
}

.single-demo.active .demo-img {
  box-shadow:
    0px 4.8px 24.4px -12px rgba(19, 16, 34, 0.1),
    0px 4px 13px -2px rgba(19, 16, 34, 0.06);
}

.single-demo:hover .demo-info {
  opacity: 1;
  bottom: -30px;
}

.demo-info {
  /* position: absolute;
  bottom: -30px; */
  width: 100%;
  margin: 0 auto;
  text-align: center;
  z-index: 1;
  /* opacity: 0; */
  transition: 0.4s;
  margin-top: 10px;
}

@media (min-width: 992px) {
  .header .header-nav .main-nav li .submenu a.inner-demo-img:hover {
    padding-left: 0 !important;
  }
}
@media (min-width: 992px) {
  .header .header-nav .main-nav > li.megamenu {
    position: unset;
  }
}

.single-demo a {
  padding: 0 !important;
}

@media (min-width: 992px) {
  .header .header-nav .main-nav li > ul.mega-submenu {
    padding: 0;
    border: 0;
    display: block;
    opacity: 0;
    visibility: hidden;
    min-width: 250px;
    transform: scaleY(0);
    -webkit-transform: scaleY(0);
    -moz-transform: scaleY(0);
    -ms-transform: scaleY(0);
    -o-transform: scaleY(0);
    transform-origin: center top 0;
    -webkit-transform-origin: center top 0;
    -moz-transform-origin: center top 0;
    -ms-transform-origin: center top 0;
    -o-transform-origin: center top 0;
    transition: all 0.3s ease-in-out 0s;
    -webkit-transition: all 0.3s ease-in-out 0s;
    -moz-transition: all 0.3s ease-in-out 0s;
    -ms-transition: all 0.3s ease-in-out 0s;
    -o-transition: all 0.3s ease-in-out 0s;
    box-shadow: 0 16px 50px rgba(0, 0, 0, 0.08);
    -webkit-box-shadow: 0 16px 50px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: 0 16px 50px rgba(0, 0, 0, 0.08);
    -ms-box-shadow: 0 16px 50px rgba(0, 0, 0, 0.08);
    -o-box-shadow: 0 16px 50px rgba(0, 0, 0, 0.08);
    border-radius: 0px;
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
  }
  .header .header-nav .main-nav li.has-submenu:hover > .submenu {
    opacity: 1;
    visibility: visible;
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
    -moz-transform: scaleY(1);
    -ms-transform: scaleY(1);
    -o-transform: scaleY(1);
  }
  .header .header-nav .main-nav li .submenu.mega-submenu::before {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .megamenu-wrapper {
    padding: 0;
  }
  .demo-img {
    display: none;
  }
  .demo-info {
    opacity: 1;
    position: relative;
    bottom: 0;
    text-align: left;
    margin-top: 0;
  }
  .single-demo a {
    padding: 10px 15px 10px 35px !important;
  }
  .single-demo:hover .demo-info {
    bottom: 0;
  }
  .single-demo .demo-info a {
    padding: 10px 15px 10px 35px;
  }
  .single-demo:hover {
    transform: translateY(0);
  }
  .single-demo:hover .demo-info {
    bottom: 0;
  }
  .single-demo {
    margin-bottom: 0;
  }
}
.header.header-ten {
  width: 100%;
  z-index: 1040;
  -webkit-transition: all 0.3s ease 0s;
  -ms-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  background-color: transparent;
  box-shadow: 0px 4px 4px rgba(198, 198, 198, 0.25);
}
.header.header-ten .header-nav .main-nav .has-submenu.active .submenu li.active > a {
  color: #0e82fd;
}
.header.header-ten.min-header {
  width: 100%;
  z-index: 1040;
  -webkit-transition: all 0.3s ease 0s;
  -ms-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  background-color: transparent;
}
.header.header-ten.header-fixed {
  display: block;
  width: 100%;
  z-index: 9999;
  background: #0e82fd;
  box-shadow: inherit;
  position: relative;
}
.header.header-ten.header-space {
  background: #0e82fd;
  position: fixed;
}
.header.header-ten.header-space .header-nav {
  height: 80px;
}
.header.header-ten .header-nav {
  background-color: transparent;
  border: 0;
  position: relative;
  margin: 0;
  padding: 0;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
@media (max-width: 991.98px) {
  .header.header-ten .header-nav {
    height: 70px;
  }
}
@media (max-width: 991.98px) {
  .header.header-ten .header-nav {
    margin: 0;
    padding: 0 0;
  }
}
@media (max-width: 991.98px) {
  .header.header-ten .header-nav .menu-header {
    height: 70px;
  }
}
@media (max-width: 991.98px) {
  .header.header-ten .header-nav .main-menu-wrapper {
    background-color: #0e82fd;
  }
}
@media (max-width: 991.98px) {
  .header.header-ten .navbar-header {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    width: 100%;
  }
}
.header.header-ten .navbar-header #mobile_btn {
  display: none;
  margin-right: 30px;
}
@media (max-width: 991.98px) {
  .header.header-ten .navbar-header #mobile_btn {
    display: inline-block;
    margin: 0;
    padding: 0 0;
  }
}
@media (max-width: 767.98px) {
  .header.header-ten .navbar-header #mobile_btn {
    margin-right: 0;
  }
}
.header.header-ten .navbar-header #mobile_btn .bar-icon {
  display: inline-block;
  width: 31px;
}
.header.header-ten .navbar-header #mobile_btn .bar-icon span {
  background-color: #ffffff;
  display: block;
  float: left;
  height: 3px;
  margin-bottom: 7px;
  width: 31px;
  border-radius: 2px;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  transition: ease all 0.5s;
  position: relative;
}
.header.header-ten .navbar-header #mobile_btn .bar-icon span:nth-child(2) {
  width: 16px;
}
.header.header-ten .navbar-header #mobile_btn .bar-icon span:nth-child(3) {
  margin-bottom: 0;
}
.header.header-ten .main-menu-wrapper {
  margin: 0;
  padding: 0;
}
.header.header-ten .main-menu-wrapper .main-nav {
  list-style: none;
  margin: 0;
  padding: 0;
}
@media (max-width: 991.98px) {
  .header.header-ten .main-menu-wrapper .main-nav ul {
    background-color: #e6f1ff;
    display: none;
    list-style: none;
    margin: 0;
    padding-left: 0;
  }
}
.header.header-ten .main-menu-wrapper .main-nav li .btn {
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  padding: 7px 8px !important;
  border: 1px solid #0e82fd;
  border-radius: 6px;
}
.header.header-ten .main-menu-wrapper .main-nav li .btn:hover {
  color: #0e82fd;
  border: 1px solid #0e82fd;
  background: transparent;
}
.header.header-ten .main-menu-wrapper .main-nav li .btn i {
  font-size: 15px;
  margin-right: 5px;
  margin-left: 0;
}
.header.header-ten .main-menu-wrapper .main-nav li .btn.reg-btn {
  min-width: 108px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  color: #1f2937;
  box-shadow: inset 0 0 0 0 #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.header.header-ten .main-menu-wrapper .main-nav li .btn.reg-btn:hover {
  color: #ffffff;
  background-color: #0e82fd;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 50px #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.header.header-ten .main-menu-wrapper .main-nav li .btn.log-btn {
  min-width: 87px;
  color: #ffffff;
  background-color: #0e82fd;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.header.header-ten .main-menu-wrapper .main-nav li .btn.log-btn:hover {
  color: #0e82fd;
  background-color: #ffffff;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 50px #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.header.header-ten .main-menu-wrapper .main-nav li a {
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  display: block;
}
@media (max-width: 1199.98px) {
  .header.header-ten .main-menu-wrapper .main-nav li a {
    font-size: 14px;
  }
}
.header.header-ten .main-menu-wrapper .main-nav li.login-link {
  display: none;
}
@media (max-width: 991.98px) {
  .header.header-ten .main-menu-wrapper .main-nav li.login-link {
    display: block;
  }
}
@media (min-width: 992px) {
  .header.header-ten .main-menu-wrapper .main-nav li > ul {
    background: #ffffff;
    box-shadow: 0px 4px 4px rgba(196, 196, 196, 0.25);
    border-radius: 0px 0px 6px 5px;
    display: block;
    font-size: 14px;
    min-width: 200px;
    opacity: 0;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 100%;
    left: 0;
    -webkit-transition: all 0.2s ease;
    -ms-transition: all 0.2s ease;
    transition: all 0.2s ease;
    transform: translateY(20px);
    -webkit-transform: translateY(20px);
    -ms-transform: translateY(20px);
    visibility: hidden;
    z-index: 1000;
  }
}
@media (min-width: 992px) {
  .header.header-ten .main-menu-wrapper .main-nav li {
    display: block;
    position: relative;
  }
}
.header.header-ten .main-menu-wrapper .main-nav .register-btn {
  margin-right: 10px;
}
.header.header-ten .main-menu-wrapper .main-nav .register-btn:last-child {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .header.header-ten .main-menu-wrapper .main-nav .register-btn {
    display: none;
  }
}
@media (min-width: 992px) {
  .header.header-ten .main-menu-wrapper .main-nav > li {
    margin-right: 8px;
  }
}
@media (min-width: 1200.98px) {
  .header.header-ten .main-menu-wrapper .main-nav > li {
    margin-right: 20px;
  }
}
@media (max-width: 991.98px) {
  .header.header-ten .main-menu-wrapper .main-nav > li {
    border-bottom: 1px solid #e6f1ff;
    margin-left: 0;
    margin-right: 0;
  }
}
@media (max-width: 991.98px) {
  .header.header-ten .main-menu-wrapper .main-nav > li > a i {
    float: right;
    margin-top: 5px;
  }
}
@media (max-width: 991.98px) {
  .header.header-ten .main-menu-wrapper .main-nav > li > a {
    line-height: 1.5;
    padding: 15px 20px !important;
    color: #ffffff !important;
    font-size: 14px;
    background: transparent !important;
    border-radius: 0 !important;
  }
}
.header.header-ten .main-menu-wrapper .main-nav > li:last-child {
  margin-right: 0;
}
.header.header-ten .main-menu-wrapper .main-nav > li.active > a {
  color: #1c5b91 !important;
}
@media (max-width: 991.98px) {
  .header.header-ten .main-menu-wrapper .main-nav > li.active > a {
    color: #ffffff !important;
  }
}
.header.header-ten .main-menu-wrapper .main-nav > li > a {
  position: relative;
}
.header.header-ten .main-menu-wrapper .main-nav > li > a:hover {
  color: #09e5ab;
}
@media (min-width: 992px) {
  .header.header-ten .main-menu-wrapper .main-nav > li > a {
    padding: 10px 0 !important;
    line-height: normal;
  }
}
.header.header-ten .main-menu-wrapper .main-nav > li > a > i {
  font-size: 10px;
  margin-left: 6px;
}
.header.header-ten .main-menu-wrapper .main-nav > li.searchbar a {
  color: #6b7280;
}
.header.header-ten .main-menu-wrapper .main-nav > li.searchbar a i {
  font-size: 20px;
  color: #ffffff;
}
@media (max-width: 1199.98px) {
  .header.header-ten .main-menu-wrapper .main-nav > li.searchbar {
    display: none;
  }
}
.header.header-ten
  .main-menu-wrapper
  .main-nav
  > li.has-submenu
  .submenu
  .has-submenu
  .submenu::before {
  top: 20px;
  margin-left: -35px;
  box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);
  border-color: transparent #ffffff #ffffff transparent;
}
@media (min-width: 992px) {
  .header.header-ten .main-menu-wrapper .main-nav > li.has-submenu:hover > .submenu {
    visibility: visible;
    opacity: 1;
    margin-top: 0;
    transform: translateY(0);
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
  }
  .header.header-ten
    .main-menu-wrapper
    .main-nav
    > li.has-submenu:hover
    > .submenu
    > li.has-submenu:hover
    .submenu {
    visibility: visible;
    opacity: 1;
    margin-top: 0;
    margin-right: 0;
  }
}
.header.header-ten .main-menu-wrapper .main-nav > li .submenu li {
  position: relative;
}
.header.header-ten .main-menu-wrapper .main-nav > li .submenu li a {
  display: block;
  padding: 10px 15px;
  clear: both;
  white-space: nowrap;
  font-size: 14px;
  color: #2d3b48;
  -webkit-transition: all 0.35s ease;
  -ms-transition: all 0.35s ease;
  transition: all 0.35s ease;
  width: 100%;
  position: relative;
  border-top: 1px solid #f0f0f0;
}
.header.header-ten .main-menu-wrapper .main-nav > li .submenu li a.active {
  color: #0e82fd;
}
.header.header-ten .main-menu-wrapper .main-nav > li .submenu li a:hover {
  color: #0e82fd !important;
}
@media (max-width: 991.98px) {
  .header.header-ten .main-menu-wrapper .main-nav > li .submenu li a {
    padding: 10px 15px 10px 35px;
  }
}
.header.header-ten .main-menu-wrapper .main-nav > li .submenu > li.has-submenu > a::after {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  font-weight: 700;
  position: absolute;
  top: 12px;
  right: 15px;
  font-size: 13px;
}
@media (min-width: 992px) {
  .header.header-ten .main-menu-wrapper .main-nav > li .submenu > li .inner-submenu {
    left: 100%;
    top: 0;
    margin-top: 10px;
  }
}
@media (min-width: 992px) {
  .header.header-ten .main-menu-wrapper .main-nav > li .submenu::before {
    border: 7px solid #ffffff;
    border-color: transparent transparent #ffffff #ffffff;
    box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
    content: "";
    position: absolute;
    top: 2px;
    left: 45px;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    -ms-transform: rotate(135deg);
  }
}
@media (max-width: 991.98px) {
  .header.header-ten .main-menu-wrapper .main-nav {
    padding: 0;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
  }
}
@media (max-width: 991.98px) {
  .header.header-ten .main-menu-wrapper {
    order: 3;
    width: 260px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1060;
    -webkit-transition: all 0.4s;
    -ms-transition: all 0.4s;
    transition: all 0.4s;
    transform: translateX(-260px);
    -webkit-transform: translateX(-260px);
    -ms-transform: translateX(-260px);
    background-color: #09e5ab;
  }
}
.header.header-ten .logo {
  display: inline-block;
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .header.header-ten .logo.navbar-brand {
    width: 100%;
    text-align: center;
    margin: 0;
    padding: 0;
  }
}
.header.header-ten .header-nav .header-navbar-rht {
  margin: 0;
  padding: 0;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  margin-right: 2px;
}
.header.header-ten .header-nav .header-navbar-rht li {
  margin-right: 10px;
  padding-right: 0;
}
.header.header-ten .header-nav .header-navbar-rht li .btn {
  color: #ffffff;
  font-weight: 600;
  font-size: 15px;
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: 35px;
  box-shadow: inset 0 0 0 0 #ffffff;
  transition: all 0.7s;
}
.header.header-ten .header-nav .header-navbar-rht li .btn:hover {
  color: #0e82fd;
  border: 1px solid #ffffff;
  box-shadow: inset 0 0 0 50px #ffffff;
}
.header.header-ten .header-nav .header-navbar-rht li .btn i {
  margin-right: 8px;
}
.header.header-ten .header-nav .header-navbar-rht li .btn.reg-btn {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  color: #1f2937;
  box-shadow: inset 0 0 0 0 #0e82fd;
}
.header.header-ten .header-nav .header-navbar-rht li .btn.reg-btn:hover {
  color: #ffffff;
  background-color: #0e82fd;
  border: 1px solid #ffffff;
  box-shadow: inset 0 0 0 50px #0e82fd;
}
.header.header-ten .header-nav .header-navbar-rht li:last-child {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .header.header-ten .header-nav .header-navbar-rht {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .header.header-ten .header-nav .header-navbar-rht {
    display: none;
  }
}
.header.header-ten .menu-header {
  background-color: #ffffff;
  height: 72px;
  padding: 0 15px;
  border-bottom: 2px solid #0e82fd;
  display: none;
}
.header.header-ten .menu-header .menu-close {
  font-size: 20px;
}
.header.header-ten .menu-header .menu-close i {
  color: #0e82fd;
}
.header.header-ten .menu-header .menu-close i:hover {
  color: #000000;
}
@media (max-width: 991.98px) {
  .header.header-ten .menu-header {
    display: flex;
  }
}

.header.header-ten .header-nav .main-nav > li.megamenu {
  position: unset;
}

.header-trans.header-eleven .header-nav {
  border-bottom: 0;
}
@media (max-width: 575.98px) {
  .header-trans.header-eleven .header-nav .navbar-header #mobile_btn {
    left: 15px;
  }
}
@media (max-width: 1199.98px) {
  .header-trans.header-eleven .header-nav .main-nav > li {
    margin-right: 17px;
  }
}
.header-trans.header-eleven .header-nav .main-nav > li > a {
  color: #ffffff;
}
.header-trans.header-eleven .header-nav .main-nav > li.has-submenu.active > a {
  color: #0ce0ff;
}
.header-trans.header-eleven .header-nav .main-nav > li.submenu a:hover {
  color: #0ce0ff;
}
.header-trans.header-eleven .header-navbar-rht li {
  border-right: 0;
  padding-right: 0;
}
.header-trans.header-eleven .header-navbar-rht li a.header-login {
  background: #0ce0ff;
  border-radius: 5px;
  font-size: 16px;
  font-weight: normal;
  padding: 13px 15px !important;
  text-transform: none;
  box-shadow: inset 0 0 0 0 #ffffff;
  -webkit-transition: all 0.7s;
  -ms-transition: all 0.7s;
  transition: all 0.7s;
}
.header-trans.header-eleven .header-navbar-rht li a.header-login:hover {
  background: #ffffff;
  color: #1c5b91;
  box-shadow: inset 0 60px 0 0 #ffffff;
  -webkit-transition: all 0.7s;
  -ms-transition: all 0.7s;
  transition: all 0.7s;
}
.header-trans.header-eleven .header-navbar-rht li a.header-login.white-bg {
  color: #1c5b91;
  box-shadow: inset 0 0 0 0 #1c5b91;
  -webkit-transition: all 0.7s;
  -ms-transition: all 0.7s;
  transition: all 0.7s;
}
.header-trans.header-eleven .header-navbar-rht li a.header-login.white-bg:hover {
  background: #1c5b91;
  color: #ffffff;
  box-shadow: inset 0 60px 0 0 #1c5b91;
  -webkit-transition: all 0.7s;
  -ms-transition: all 0.7s;
  transition: all 0.7s;
}

.header.header-fourteen.header-twelve .header-nav {
  background-color: transparent;
  border-bottom: none;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0;
}
@media (max-width: 1199.98px) {
  .header.header-fourteen.header-twelve .header-nav .logo {
    margin-right: 0;
  }
}
@media (max-width: 1199.98px) {
  .header.header-fourteen.header-twelve .header-nav {
    justify-content: start;
  }
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-twelve .header-nav {
    justify-content: space-between;
  }
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-twelve .header-nav .main-menu-wrapper {
    background-color: #f8fbff;
  }
}
@media (max-width: 1199.98px) {
  .header.header-fourteen.header-twelve .header-nav .main-menu-wrapper .main-nav li {
    margin-right: 10px;
  }
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-twelve .header-nav .main-menu-wrapper .main-nav li {
    border-bottom: 1px solid #ffffff;
  }
}
.header.header-fourteen.header-twelve .header-nav .main-menu-wrapper .main-nav li a {
  color: #1f2937;
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-twelve .header-nav .main-menu-wrapper .main-nav li .submenu {
    background-color: #f8fbff;
  }
}
.header.header-fourteen.header-twelve .header-nav .main-menu-wrapper .main-nav li .submenu a {
  color: #1f2937;
}
.header.header-fourteen.header-twelve .header-nav .main-menu-wrapper .main-nav li.active a {
  color: #0e82fd;
  font-weight: 700;
}
.header.header-fourteen.header-twelve
  .header-nav
  .main-menu-wrapper
  .main-nav
  li.active
  .submenu
  a {
  color: #1f2937;
  font-weight: 500;
}
.header.header-fourteen.header-twelve
  .header-nav
  .main-menu-wrapper
  .main-nav
  li.active
  .submenu
  a.active {
  color: #2dd4bf;
  font-weight: 500;
}
.header.header-fourteen.header-twelve
  .header-nav
  .main-menu-wrapper
  .main-nav
  li.active
  .submenu
  a {
  color: #1f2937;
}
.header.header-fourteen.header-twelve .header-nav .header-navbar-rht {
  padding: 0;
  margin: 0;
}
.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li {
  padding: 0 10px 0 0;
}
.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.login-link {
  display: none;
}
.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.searchbar-fourteen {
  background: #f6f7f5;
  border: 1px solid #e7e8e6;
  width: 38px;
  height: 38px;
  border-radius: 35px;
  padding: 0;
  transition: 0.5s;
}
.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.searchbar-fourteen:hover {
  background: #1c5b91;
  transition: 0.5s;
}
.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.searchbar-fourteen a {
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0));
}
.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.login-in-fourteen .reg-btn {
  background: transparent;
  color: #1f2937;
  box-shadow: none;
  border: none;
  font-size: 15px;
  font-weight: 600;
  padding: 10px 12px;
  transition: 0.5s;
}
@media (max-width: 1199.98px) {
  .header.header-fourteen.header-twelve
    .header-nav
    .header-navbar-rht
    li.login-in-fourteen
    .reg-btn {
    padding: 10px 5px;
  }
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-twelve
    .header-nav
    .header-navbar-rht
    li.login-in-fourteen
    .reg-btn {
    padding: 10px 12px;
  }
}
.header.header-fourteen.header-twelve
  .header-nav
  .header-navbar-rht
  li.login-in-fourteen
  .reg-btn:hover {
  background: #0e82fd;
  color: #ffffff;
  transition: 0.5s;
}
.header.header-fourteen.header-twelve
  .header-nav
  .header-navbar-rht
  li.login-in-fourteen
  .reg-btn.reg-btn-fourteen {
  background: #0e82fd;
  color: #ffffff;
  transition: 0.5s;
  border: 1px solid #0e82fd;
  font-size: 15px;
  font-weight: 600;
}
.header.header-fourteen.header-twelve
  .header-nav
  .header-navbar-rht
  li.login-in-fourteen
  .reg-btn.reg-btn-fourteen:hover {
  background: #ffffff;
  color: #0e82fd;
  transition: 0.5s;
}
.header.header-fourteen.header-fixed {
  position: fixed;
  display: block;
  width: 100%;
  z-index: 9999;
  box-shadow: inherit;
}

.header.header-fourteen.header-twelve.header-thirteen {
  background-color: #ffffff;
}
.header.header-fourteen.header-twelve.header-thirteen
  .header-nav
  .header-navbar-rht
  li.login-in-fourteen
  .reg-btn-thirteen {
  display: flex;
}
.header.header-fourteen.header-twelve.header-thirteen
  .header-nav
  .header-navbar-rht
  li.login-in-fourteen
  .reg-btn-thirteen
  span {
  padding: 8px 20px;
  border: 1px solid #0e82fd;
  background: #0e82fd;
  color: #ffffff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  transition: all 0.5s;
}
.header.header-fourteen.header-twelve.header-thirteen
  .header-nav
  .header-navbar-rht
  li.login-in-fourteen
  .reg-btn-thirteen
  .user-icon-header {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  border: 1px solid #0e82fd;
  background: #0f78e7;
  color: #ffffff;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  transition: all 0.5s;
}
.header.header-fourteen.header-twelve.header-thirteen
  .header-nav
  .header-navbar-rht
  li.login-in-fourteen
  .reg-btn-thirteen:hover
  span,
.header.header-fourteen.header-twelve.header-thirteen
  .header-nav
  .header-navbar-rht
  li.login-in-fourteen
  .reg-btn-thirteen:hover
  .user-icon-header {
  background: #ffffff;
  color: #0e82fd;
}

.header.header-fourteen .header-nav {
  background-color: transparent;
  border-bottom: none;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0;
}
@media (max-width: 1199.98px) {
  .header.header-fourteen .header-nav .logo {
    margin-right: 0;
  }
}
@media (max-width: 1199.98px) {
  .header.header-fourteen .header-nav {
    justify-content: start;
  }
}
@media (max-width: 991.98px) {
  .header.header-fourteen .header-nav {
    justify-content: space-between;
  }
}
@media (max-width: 1199.98px) {
  .header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu {
    margin-right: 10px;
  }
}
.header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu a {
  color: #ffffff;
}
.header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu .submenu a {
  color: #1f2937;
}
@media (max-width: 991.98px) {
  .header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu .submenu a {
    color: #ffffff;
  }
}
.header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu.active a {
  color: #2dd4bf;
  font-weight: 700;
}
.header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu.active .submenu a {
  color: #1f2937;
  font-weight: 500;
}
.header.header-fourteen
  .header-nav
  .main-menu-wrapper
  .main-nav
  .has-submenu.active
  .submenu
  a.active {
  color: #2dd4bf;
  font-weight: 500;
}
.header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu.active .submenu a {
  color: #1f2937;
}
@media (max-width: 991.98px) {
  .header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu.active .submenu a {
    color: #ffffff;
  }
}
.header.header-fourteen .header-nav .header-navbar-rht {
  padding: 0;
  margin: 0;
}
.header.header-fourteen .header-nav .header-navbar-rht li {
  padding: 0 10px 0 0;
}
.header.header-fourteen .header-nav .header-navbar-rht li.login-link {
  display: none;
}
.header.header-fourteen .header-nav .header-navbar-rht li.searchbar-fourteen a {
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  background: #ffffff;
  border: 1px solid #e7e8e6;
  width: 38px;
  height: 38px;
  border-radius: 35px;
  padding: 0;
  transition: 0.5s;
}
.header.header-fourteen .header-nav .header-navbar-rht li.searchbar-fourteen a:hover {
  background: #1c5b91;
  color: #ffffff;
  border: 1px solid #1c5b91;
  transition: 0.5s;
}
.header.header-fourteen .header-nav .header-navbar-rht li.searchbar-fourteen a:hover a {
  color: #ffffff;
}
.header.header-fourteen .header-nav .header-navbar-rht li.login-in-fourteen .reg-btn {
  background: transparent;
  color: #ffffff;
  box-shadow: none;
  border: none;
  font-size: 15px;
  font-weight: 600;
  padding: 10px 12px;
  transition: 0.5s;
}
@media (max-width: 1199.98px) {
  .header.header-fourteen .header-nav .header-navbar-rht li.login-in-fourteen .reg-btn {
    padding: 10px 5px;
  }
}
.header.header-fourteen .header-nav .header-navbar-rht li.login-in-fourteen .reg-btn:hover {
  background: #2dd4bf;
  color: #1e5d8a;
  transition: 0.5s;
}
.header.header-fourteen
  .header-nav
  .header-navbar-rht
  li.login-in-fourteen
  .reg-btn.reg-btn-fourteen {
  background: #2dd4bf;
  color: #1e5d8a;
  transition: 0.5s;
  font-size: 15px;
  font-weight: 600;
}
.header.header-fourteen
  .header-nav
  .header-navbar-rht
  li.login-in-fourteen
  .reg-btn.reg-btn-fourteen:hover {
  background: #ffffff;
  color: #1e5d8a;
  transition: 0.5s;
}
.header.header-fixed {
  position: fixed;
  display: block;
  width: 100%;
  z-index: 9999;
  box-shadow: inherit;
}

@media (max-width: 1199.98px) {
  .header.header-fourteen.header-fifteen .header-nav .logo {
    margin-right: 0;
  }
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-fifteen .header-nav {
    justify-content: space-between;
  }
}
@media (max-width: 1399.98px) {
  .header.header-fourteen.header-fifteen .header-nav .main-menu-wrapper .main-nav li {
    margin-right: 20px;
  }
}
@media (max-width: 1199.98px) {
  .header.header-fourteen.header-fifteen .header-nav .main-menu-wrapper .main-nav li {
    margin-right: 5px;
  }
}
.header.header-fourteen.header-fifteen .header-nav .main-menu-wrapper .main-nav li a {
  color: #1f2937;
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-fifteen .header-nav .main-menu-wrapper .main-nav li a {
    color: #ffffff;
  }
}
.header.header-fourteen.header-fifteen .header-nav .header-navbar-rht .login-in-fourteen .reg-btn {
  padding: 18px 15px;
  background: #0ce0ff;
  color: #ffffff;
  border-radius: 10px;
  font-size: 14px;
}
@media (max-width: 1399.98px) {
  .header.header-fourteen.header-fifteen
    .header-nav
    .header-navbar-rht
    .login-in-fourteen
    .reg-btn {
    padding: 13px 10px;
  }
}
@media (max-width: 1199.98px) {
  .header.header-fourteen.header-fifteen
    .header-nav
    .header-navbar-rht
    .login-in-fourteen
    .reg-btn {
    padding: 10px 5px;
  }
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-fifteen
    .header-nav
    .header-navbar-rht
    .login-in-fourteen
    .reg-btn {
    padding: 13px 10px;
  }
}
.header.header-fourteen.header-fifteen
  .header-nav
  .header-navbar-rht
  .login-in-fourteen
  .reg-btn.reg-btn-fourteen {
  background: #ffaf14;
  color: #ffffff;
}

.header.header-fourteen.header-sixteen {
  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);
}
@media (max-width: 1199.98px) {
  .header.header-fourteen.header-sixteen .header-nav .logo {
    margin-right: 30px;
  }
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-sixteen .header-nav .logo {
    margin-right: 0;
  }
}
@media (max-width: 1399.98px) {
  .header.header-fourteen.header-sixteen .header-nav {
    justify-content: start;
  }
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-sixteen .header-nav {
    justify-content: space-between;
  }
}
.header.header-fourteen.header-sixteen .header-nav .bar-icon span {
  background: #0e82fd;
}
.header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li:last-child {
  margin-right: 30px;
}
@media (max-width: 1199.98px) {
  .header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li:last-child {
    margin-right: 10px;
  }
}
@media (max-width: 1199.98px) {
  .header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li {
    margin-right: 10px;
  }
}
.header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li a {
  color: #1f2937;
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li a {
    color: #ffffff;
  }
}
.header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li .submenu a {
  color: #1f2937;
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li .submenu a {
    color: #ffffff;
  }
}
.header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li.active a {
  color: #3b9cf6;
  font-weight: 700;
}
.header.header-fourteen.header-sixteen
  .header-nav
  .main-menu-wrapper
  .main-nav
  li.active
  .submenu
  a {
  color: #1f2937;
  font-weight: 500;
}
.header.header-fourteen.header-sixteen
  .header-nav
  .main-menu-wrapper
  .main-nav
  li.active
  .submenu
  a.active {
  color: #3b9cf6;
  font-weight: 500;
}
.header.header-fourteen.header-sixteen
  .header-nav
  .main-menu-wrapper
  .main-nav
  li.active
  .submenu
  a {
  color: #1f2937;
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-sixteen
    .header-nav
    .main-menu-wrapper
    .main-nav
    li.active
    .submenu
    a {
    color: #ffffff;
  }
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav .searchbar {
    display: none;
  }
}
.header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav .searchbar a i {
  font-size: 18px;
  color: #6b7280;
}
.header.header-fourteen.header-sixteen
  .header-nav
  .main-menu-wrapper
  .main-nav
  .searchbar
  a
  i:hover {
  color: #1c5b91;
}
.header.header-fourteen.header-sixteen .header-nav .header-navbar-rht .login-in-sixteen .reg-btn {
  padding: 12px 14px;
  background: #0e82fd;
  box-shadow: inset 0 0 0 0 #0e82fd;
  color: #ffffff;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  -webkit-transition: all 0.7s;
  -ms-transition: all 0.7s;
  transition: all 0.7s;
}
.header.header-fourteen.header-sixteen
  .header-nav
  .header-navbar-rht
  .login-in-sixteen
  .reg-btn:hover {
  background: #ffffff;
  color: #1c5b91;
  -webkit-transition: all 0.7s;
  -ms-transition: all 0.7s;
  transition: all 0.7s;
  box-shadow: inset 0 60px 0 0 #ffffff;
}
@media (max-width: 1399.98px) {
  .header.header-fourteen.header-sixteen .header-nav .header-navbar-rht .login-in-sixteen .reg-btn {
    padding: 13px 10px;
  }
}
@media (max-width: 1199.98px) {
  .header.header-fourteen.header-sixteen .header-nav .header-navbar-rht .login-in-sixteen .reg-btn {
    padding: 10px 5px;
  }
}
@media (max-width: 991.98px) {
  .header.header-fourteen.header-sixteen .header-nav .header-navbar-rht .login-in-sixteen .reg-btn {
    padding: 13px 10px;
  }
}
.header.header-fourteen.header-sixteen
  .header-nav
  .header-navbar-rht
  .login-in-sixteen
  .reg-btn.reg-btn-sixteen {
  background: transparent;
  color: #1f2937;
  border: none;
  font-weight: 600;
  box-shadow: inset 0 0 0 0 #1c5b91;
  -webkit-transition: all 0.7s;
  -ms-transition: all 0.7s;
  transition: all 0.7s;
}
.header.header-fourteen.header-sixteen
  .header-nav
  .header-navbar-rht
  .login-in-sixteen
  .reg-btn.reg-btn-sixteen:hover {
  background: #1c5b91;
  color: #ffffff;
  box-shadow: inset 0 60px 0 0 #1c5b91;
  -webkit-transition: all 0.7s;
  -ms-transition: all 0.7s;
  transition: all 0.7s;
}

.nav-tabs {
  border-bottom: 1px solid #f0f0f0;
}
@media (max-width: 767.98px) {
  .nav-tabs {
    border-bottom: 0;
    position: relative;
    background-color: #ffffff;
    border: 1px solid #dddddd;
    padding: 5px 0;
    border-radius: 3px;
  }
}
.nav-tabs > li > a {
  margin-right: 0;
  color: #888888;
  border-radius: 3px;
}
@media (max-width: 767.98px) {
  .nav-tabs > li > a {
    border-width: 2px;
    border-left-color: transparent;
  }
}
.nav-tabs > li > a:hover,
.nav-tabs > li > a:focus {
  border-color: transparent;
  color: #272b41;
}
@media (max-width: 767.98px) {
  .nav-tabs > li > a:hover,
  .nav-tabs > li > a:focus {
    background-color: #fafafa;
  }
}
@media (max-width: 767.98px) {
  .nav-tabs > li > a.active {
    border-color: transparent transparent transparent #20c0f3 !important;
    border-left-width: 2px;
  }
}
.nav-tabs > li.open:not(.active) > a,
.nav-tabs > li.open:not(.active) > a:hover,
.nav-tabs > li.open:not(.active) > a:focus {
  background-color: #fafafa;
}
@media (max-width: 767.98px) {
  .nav-tabs .nav-item {
    margin-bottom: 0;
  }
}
@media (max-width: 767.98px) {
  .nav-tabs .nav-item.show .nav-link {
    border-color: transparent transparent transparent #20c0f3 !important;
    border-left-width: 2px;
  }
}
.nav-tabs .nav-link {
  border-radius: 0;
}
@media (max-width: 767.98px) {
  .nav-tabs .nav-link {
    border-width: 2px;
  }
}
.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  background-color: #eeeeee;
  border-color: transparent;
  color: #272b41;
}
@media (max-width: 767.98px) {
  .nav-tabs.nav-justified {
    border-bottom: 1px solid #dddddd;
  }
}
.nav-tabs.nav-justified > li > a {
  margin-bottom: 0;
  border-radius: 0;
}
.nav-tabs.nav-justified > li > a:hover,
.nav-tabs.nav-justified > li > a:focus {
  border-bottom-color: #dddddd;
}
@media (max-width: 767.98px) {
  .nav-tabs.nav-justified > li > a.active {
    border-color: transparent transparent transparent #20c0f3;
    border-left-width: 2px !important;
  }
}
.nav-tabs.nav-justified.nav-tabs-solid > li > a {
  color: #272b41;
}
.nav-tabs.nav-justified.nav-tabs-top {
  border-bottom: 1px solid #dddddd;
}
.nav-tabs.nav-justified.nav-tabs-top > li > a,
.nav-tabs.nav-justified.nav-tabs-top > li > a:hover,
.nav-tabs.nav-justified.nav-tabs-top > li > a:focus {
  border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-top > li {
  margin-bottom: 0;
}
.nav-tabs.nav-tabs-top > li > a {
  border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-top > li > a.open {
  border-top-color: #dddddd;
}
.nav-tabs.nav-tabs-top > li > a:hover,
.nav-tabs.nav-tabs-top > li > a:focus {
  border-width: 2px 0 0 0;
  border-top-color: #dddddd;
}
.nav-tabs.nav-tabs-top > li > a.active,
.nav-tabs.nav-tabs-top > li > a.active:hover,
.nav-tabs.nav-tabs-top > li > a.active:focus {
  border-top-color: #20c0f3;
}
.nav-tabs.nav-tabs-top > li + li > a {
  margin-left: 1px;
}
.nav-tabs.nav-tabs-bottom > li > a.active,
.nav-tabs.nav-tabs-bottom > li > a.active:hover,
.nav-tabs.nav-tabs-bottom > li > a.active:focus {
  border-bottom-width: 2px;
  border-color: transparent;
  border-bottom-color: #20c0f3;
  background-color: transparent;
  -webkit-transition: none 0s ease 0s;
  -ms-transition: none 0s ease 0s;
  transition: none 0s ease 0s;
}
@media (max-width: 767.98px) {
  .nav-tabs.nav-tabs-bottom > li > a.active,
  .nav-tabs.nav-tabs-bottom > li > a.active:hover,
  .nav-tabs.nav-tabs-bottom > li > a.active:focus {
    background-color: #f5f5f5;
  }
}
@media (max-width: 767.98px) {
  .nav-tabs .nav-tabs-justified {
    border-bottom: 1px solid #dddddd;
  }
}
.nav-tabs .nav-tabs-justified > li > a {
  border-radius: 0;
  margin-bottom: 0;
}
.nav-tabs .nav-tabs-justified > li > a:hover,
.nav-tabs .nav-tabs-justified > li > a:focus {
  border-bottom-color: #dddddd;
}
.nav-tabs .nav-tabs-justified > li > a.active,
.nav-tabs .nav-tabs-justified > li > a.active:focus,
.nav-tabs .nav-tabs-justified > li > a.active:hover {
  border-width: 0 0 0 2px;
  border-left-color: #20c0f3;
}
.nav-tabs .nav-tabs-justified.nav-tabs-solid > li > a {
  border-color: transparent;
}
.nav-tabs .nav-tabs-justified.nav-tabs-top {
  border-bottom: 1px solid #dddddd;
}
.nav-tabs .nav-tabs-justified.nav-tabs-top > li a,
.nav-tabs .nav-tabs-justified.nav-tabs-top > li a:hover,
.nav-tabs .nav-tabs-justified.nav-tabs-top > li a:focus {
  border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-solid {
  background-color: #fafafa;
  border: 0;
}
@media (max-width: 767.98px) {
  .nav-tabs.nav-tabs-solid {
    padding: 5px;
  }
}
.nav-tabs.nav-tabs-solid > li {
  margin-bottom: 0;
}
.nav-tabs.nav-tabs-solid > li a {
  color: #272b41;
}
.nav-tabs.nav-tabs-solid > li a.active,
.nav-tabs.nav-tabs-solid > li a.active:hover,
.nav-tabs.nav-tabs-solid > li a.active:focus {
  background-color: #20c0f3;
  border-color: #20c0f3;
  color: #ffffff;
}
.nav-tabs.nav-tabs-solid > li > a {
  border-color: transparent;
}
@media (max-width: 767.98px) {
  .nav-tabs.nav-tabs-solid > li > a {
    border-left-width: 0 !important;
  }
}
.nav-tabs.nav-tabs-solid > li > a:hover,
.nav-tabs.nav-tabs-solid > li > a:focus {
  background-color: #f5f5f5;
}
.nav-tabs.nav-tabs-solid > li > a.active,
.nav-tabs.nav-tabs-solid > li > a.active:hover,
.nav-tabs.nav-tabs-solid > li > a.active:focus {
  background-color: #20c0f3;
  border-color: #20c0f3;
  color: #ffffff;
}
.nav-tabs.nav-tabs-solid .active > a,
.nav-tabs.nav-tabs-solid .active a:hover,
.nav-tabs.nav-tabs-solid .active a:focus {
  background-color: #20c0f3;
  border-color: #20c0f3;
  color: #ffffff;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded {
  border-radius: 50px;
}
@media (max-width: 767.98px) {
  .nav-tabs.nav-tabs-solid.nav-tabs-rounded {
    border-radius: 5px;
  }
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a {
  border-radius: 50px;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {
  border-radius: 50px;
}
@media (max-width: 767.98px) {
  .nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,
  .nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,
  .nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {
    border-color: transparent transparent transparent #20c0f3 !important;
    border-left-width: 2px;
  }
}
@media (max-width: 767.98px) {
  .nav-tabs.nav-tabs-solid.nav-tabs-rounded {
    border-radius: 5px;
  }
}
.nav-tabs.nav-tabs-solid > .open:not(.active) > a {
  background-color: #f5f5f5;
  border-color: transparent;
}
@media (max-width: 767.98px) {
  .nav-tabs .nav-link.active {
    border-color: transparent transparent transparent #20c0f3 !important;
    border-left-width: 2px;
  }
}

.tab-content {
  padding-top: 20px;
}

.card-header-tabs {
  border-bottom: 0;
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-duration: 0.6s;
  transition-property: opacity;
}
.carousel-fade .carousel-item.active {
  opacity: 1;
}
.carousel-fade .carousel-item-next {
  transform: translateX(0);
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
}
.carousel-fade .carousel-item-next .carousel-item-left {
  opacity: 1;
}
.carousel-fade .carousel-item-prev {
  transform: translateX(0);
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
}
.carousel-fade .carousel-item-prev .carousel-item-right {
  opacity: 1;
}
.carousel-fade .active {
  transform: translateX(0);
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
}
.carousel-fade .active .carousel-item-left,
.carousel-fade .active .carousel-item-right {
  opacity: 0;
  transform: translateX(0);
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
}

.carousel-item {
  height: 75vh;
  min-height: 350px;
  background: no-repeat center center scroll;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  z-index: -1 !important;
}

.divider .carousel-caption {
  position: absolute;
  top: 110px;
  right: 0;
  bottom: 20px;
  left: 5%;
}

.carousel-caption {
  z-index: 10;
  padding-bottom: 20px;
  color: #ffffff;
  position: absolute;
  top: 110px;
  right: 0;
  bottom: 20px;
  left: 15%;
}
.carousel-caption span {
  font-size: 32px;
  font-weight: 700;
  color: rgb(46, 56, 66);
}
.carousel-caption h2 {
  font-size: 54px;
  font-weight: 700;
  color: rgb(30, 92, 146);
}
.carousel-caption p {
  font-size: 18px;
  font-weight: 700;
  color: rgb(46, 56, 66);
}

@media (max-width: 991.98px) {
  .carousel-inner {
    height: 430px;
  }
}
@media (max-width: 767.98px) {
  .carousel-inner {
    height: 200px;
  }
}

.slide-nav-1 button.owl-next,
.slide-nav-1 button.owl-prev,
.slide-nav-2 button.owl-next,
.slide-nav-2 button.owl-prev,
.slide-nav-3 button.owl-next,
.slide-nav-3 button.owl-prev,
.slide-nav-4 button.owl-next,
.slide-nav-4 button.owl-prev {
  width: 34px;
  height: 34px;
  background: #10defd;
  text-shadow: none;
  top: 4px;
  cursor: pointer;
  border: 0;
  color: #ffffff;
  margin-bottom: 15px;
  border-radius: 8px;
  transform: rotate(-44deg);
  -webkit-transform: rotate(-44deg);
  -ms-transform: rotate(-44deg);
}
@media (max-width: 767.98px) {
  .slide-nav-1 button.owl-next,
  .slide-nav-1 button.owl-prev,
  .slide-nav-2 button.owl-next,
  .slide-nav-2 button.owl-prev,
  .slide-nav-3 button.owl-next,
  .slide-nav-3 button.owl-prev,
  .slide-nav-4 button.owl-next,
  .slide-nav-4 button.owl-prev {
    width: 28px;
    height: 28px;
  }
}

.owl-theme .owl-dots,
.owl-nav button {
  margin-top: 30px;
}
@media (max-width: 767.98px) {
  .owl-theme .owl-dots,
  .owl-nav button {
    margin-top: 10px;
  }
}

.custom-arrow {
  transform: rotate(44deg);
  -webkit-transform: rotate(44deg);
  -ms-transform: rotate(44deg);
}

.owl-nav button.owl-next {
  margin-left: 20px;
}

.footer {
  background-color: #15558d;
}
.footer.footer-one .footer-bottom .copyright .copyright-text p {
  color: #6b7280;
}
@media (max-width: 767.98px) {
  .footer.footer-one .footer-bottom .copyright .copyright-text p {
    text-align: center;
  }
}
.footer .footer-top {
  padding: 40px 0;
}
@media (max-width: 991.98px) {
  .footer .footer-top {
    padding-bottom: 10px;
  }
}
.footer .footer-top .footer-title {
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 30px;
  text-transform: capitalize;
}
@media (max-width: 767.98px) {
  .footer .footer-top .footer-title {
    font-size: 18px;
  }
}
@media (max-width: 575.98px) {
  .footer .footer-top .footer-title {
    font-size: 18px;
  }
}
@media (max-width: 991.98px) {
  .footer .footer-top .footer-widget {
    margin-bottom: 30px;
  }
}
.footer .footer-top .footer-widget.footer-menu ul {
  list-style: none;
  outline: none;
  margin: 0;
  padding: 0;
}
.footer .footer-top .footer-widget.footer-menu ul li {
  margin-bottom: 10px;
  position: relative;
}
.footer .footer-top .footer-widget.footer-menu ul li:last-child {
  margin-bottom: 0;
}
.footer .footer-top .footer-widget.footer-menu ul li a {
  color: #ffffff;
  font-size: 15px;
  padding-left: 20px;
  position: relative;
  -webkit-transition: all 0.4s ease 0s;
  -ms-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;
}
.footer .footer-top .footer-widget.footer-menu ul li a:hover {
  color: #ffffff;
  letter-spacing: 0.5px;
  padding-left: 30px;
}
.footer .footer-top .footer-widget.footer-menu ul li a::before {
  content: "\\f101";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  margin-right: 5px;
  position: absolute;
  top: 0;
  left: 0;
}
.footer .footer-top .footer-widget .footer-logo {
  margin: 0 0 30px;
}
.footer .footer-top .footer-widget .footer-about-content p {
  color: #ffffff;
}
.footer .footer-top .footer-widget .footer-about-content p:last-child {
  margin-bottom: 0;
}
.footer .footer-top .footer-widget .footer-about-content .social-icon ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.footer .footer-top .footer-widget .footer-about-content .social-icon ul li {
  margin-right: 15px;
}
.footer .footer-top .footer-widget .footer-about-content .social-icon ul li:last-child {
  margin-right: 0;
}
.footer .footer-top .footer-widget .footer-about-content .social-icon ul li a {
  color: #ffffff;
  font-size: 20px;
  -webkit-transition: all 0.4s ease 0s;
  -ms-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;
}
.footer .footer-top .footer-widget .footer-about-content .social-icon ul li a:hover {
  color: #09e5ab;
}
.footer .footer-top .footer-widget .footer-contact-info {
  color: #ffffff;
  font-size: 15px;
}
.footer .footer-top .footer-widget .footer-contact-info .footer-address span {
  margin-right: 20px;
}
.footer .footer-top .footer-widget .footer-contact-info .footer-address span i.fa-map-marker-alt {
  font-size: 20px;
}
.footer .footer-top .footer-widget .footer-contact-info .footer-address p {
  margin: 0 0 1rem;
}
.footer .footer-top .footer-widget .footer-contact-info p i {
  margin-right: 15px;
}
.footer .footer-bottom .copyright {
  border-top: 1px solid #1663a6;
  padding: 30px 0;
}
.footer .footer-bottom .copyright .copyright-text p {
  font-size: 15px;
  color: #ffffff;
}
.footer .footer-bottom .copyright .copyright-text p a {
  color: #1f2937;
  font-weight: 500;
  -webkit-transition: all 0.4s ease 0s;
  -ms-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;
}
.footer .footer-bottom .copyright .copyright-text p a:hover {
  color: #0e82fd;
}
.footer .footer-bottom .copyright .copyright-text p.title {
  font-weight: 400;
  margin: 10px 0 0;
}
.footer .footer-bottom .copyright .policy-menu {
  font-size: 14px;
  text-align: right;
  margin: 0;
  padding: 0;
}
@media (max-width: 767.98px) {
  .footer .footer-bottom .copyright .policy-menu {
    margin-top: 10px;
    text-align: left;
  }
}
.footer .footer-bottom .copyright .policy-menu li {
  display: inline-block;
  margin-right: 15px;
}
.footer .footer-bottom .copyright .policy-menu li:last-child {
  margin-right: 0;
}
.footer .footer-bottom .copyright .policy-menu li a {
  color: #ffffff;
}
.footer .footer-bottom .copyright .policy-menu li a:hover,
.footer .footer-bottom .copyright .policy-menu li a:focus {
  color: #0e82fd;
}
.footer .footer-bottom .copyright .policy-menu li::after {
  color: #ffffff;
  content: "|";
  font-weight: 300;
  position: relative;
  left: 10px;
}
.footer .footer-bottom .copyright .policy-menu li:last-child::after {
  content: "";
}

.footer-one {
  background: #f2f6f6;
}
.footer-one .footer-top {
  margin: 0;
  padding: 50px 0;
}
@media (max-width: 991.98px) {
  .footer-one .footer-top {
    margin: 0;
    padding: 40px 0 10px;
  }
}
@media (max-width: 767.98px) {
  .footer-one .footer-top {
    margin: 0;
    padding: 40px 0 0;
  }
}
.footer-one .footer-top .footer-widget .footer-logo {
  margin-bottom: 20px;
}
.footer-one .footer-top .footer-widget .footer-about-content {
  max-width: 272px;
}
.footer-one .footer-top .footer-widget .footer-about-content p {
  margin-bottom: 0;
  font-size: 14px;
  color: #6b7280;
}
.footer-one .footer-top .footer-widget.footer-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.footer-one .footer-top .footer-widget .footer-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 25px;
}
@media (max-width: 991.98px) {
  .footer-one .footer-top .footer-widget {
    margin-bottom: 30px;
  }
}
@media (max-width: 767.98px) {
  .footer-one .footer-top .footer-widget {
    margin-bottom: 25px;
  }
}
.footer-one .footer-top .footer-widget.footer-menu ul li {
  margin-bottom: 15px;
}
.footer-one .footer-top .footer-widget.footer-menu ul li:last-child {
  margin-bottom: 0;
}
.footer-one .footer-top .footer-widget.footer-menu ul li a {
  color: #6b7280;
  position: relative;
  overflow: hidden;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -10px;
  -webkit-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  padding-left: 0;
  font-size: 14px;
}
.footer-one .footer-top .footer-widget.footer-menu ul li a:hover {
  color: #0e82fd;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat 4px;
  padding-left: 20px;
  -webkit-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.footer-one .footer-top .footer-widget.footer-menu ul li a::before {
  display: none;
}
.footer-one .footer-top .footer-widget .footer-contact-info .footer-address {
  margin-bottom: 15px;
}
.footer-one .footer-top .footer-widget .footer-contact-info .footer-address p {
  margin-bottom: 0;
  color: #6b7280;
  font-size: 14px;
}
.footer-one .footer-top .footer-widget .footer-contact-info .footer-address p i {
  font-size: 16px;
  color: #9ca3af;
  margin-right: 10px;
}
.footer-one .footer-bottom .copyright {
  border-top: 1px solid #e5e7eb;
  margin: 0;
  padding: 30px 0;
}
.footer-one .footer-bottom .copyright .policy-menu {
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: right;
}
.footer-one .footer-bottom .copyright .policy-menu li {
  display: inline-block;
  margin-right: 25px;
  color: #1f2937;
  font-weight: 500;
}
@media (max-width: 767.98px) {
  .footer-one .footer-bottom .copyright .policy-menu li {
    display: block;
    margin-right: 0;
    margin-bottom: 8px;
    text-align: center;
    margin-top: 10px;
  }
  .footer-one .footer-bottom .copyright .policy-menu li:last-child {
    margin-bottom: 0;
  }
}
.footer-one .footer-bottom .copyright .policy-menu li::after {
  font-size: 15px;
  color: #6b7280;
  content: "|";
  font-weight: 500;
  position: relative;
  left: 15px;
}
@media (max-width: 767.98px) {
  .footer-one .footer-bottom .copyright .policy-menu li::after {
    display: none;
  }
}
.footer-one .footer-bottom .copyright .policy-menu li:last-child::after {
  content: "";
}
.footer-one .footer-bottom .copyright .policy-menu li a {
  color: #6b7280;
}
.footer-one .footer-bottom .copyright .policy-menu li a:hover {
  color: #0e82fd;
}
@media (max-width: 991.98px) {
  .footer-one .footer-bottom .copyright {
    margin: 0;
    padding: 25px 0;
  }
}

.subscribe-form {
  position: relative;
  margin-bottom: 20px;
}
.subscribe-form .form-control {
  font-weight: 500;
  font-size: 14px;
  min-height: 46px;
  color: #6b7280;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px 0px 0px 6px;
  margin: 0;
  padding: 6px 112px 6px 15px;
}
@media (max-width: 991.98px) {
  .subscribe-form .form-control {
    padding-right: 180px;
  }
}
@media (max-width: 767.98px) {
  .subscribe-form .form-control {
    min-height: 46px;
    padding-right: 145px;
  }
}
.subscribe-form .form-control::placeholder {
  font-weight: 500;
  font-size: 14px;
  color: #6b7280;
}
.subscribe-form .btn {
  font-weight: normal;
  margin: 0;
  padding: 11px 16px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 0 6px 6px 0;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  color: #ffffff;
  background: #0e82fd;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #ffffff;
}
.subscribe-form .btn:hover {
  color: #0e82fd;
  border-color: #0e82fd;
  background: #ffffff;
  box-shadow: inset 0 0 0 50px #ffffff;
  -webkit-transition: 0.5s;
  -ms-transition: 0.5s;
  transition: 0.5s;
}
@media (max-width: 767.98px) {
  .subscribe-form .btn {
    font-size: 14px;
  }
}

.subscribe-content p {
  max-width: 360px;
  margin-bottom: 0;
  font-size: 14px;
  color: #6b7280;
}

.footer-two {
  background-color: #15558d;
}
.footer-two .footer-top {
  padding: 40px 0;
}
@media (max-width: 991.98px) {
  .footer-two .footer-top {
    padding-bottom: 10px;
  }
}
.footer-two .footer-top .footer-title {
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 30px;
  text-transform: capitalize;
}
@media (max-width: 767.98px) {
  .footer-two .footer-top .footer-title {
    font-size: 18px;
  }
}
@media (max-width: 575.98px) {
  .footer-two .footer-top .footer-title {
    font-size: 18px;
  }
}
@media (max-width: 991.98px) {
  .footer-two .footer-top .footer-widget {
    margin-bottom: 30px;
  }
}
.footer-two .footer-top .footer-widget.footer-menu ul {
  list-style: none;
  outline: none;
  margin: 0;
  padding: 0;
}
.footer-two .footer-top .footer-widget.footer-menu ul li {
  margin-bottom: 10px;
  position: relative;
}
.footer-two .footer-top .footer-widget.footer-menu ul li:last-child {
  margin-bottom: 0;
}
.footer-two .footer-top .footer-widget.footer-menu ul li a {
  color: #ffffff;
  font-size: 15px;
  padding-left: 20px;
  position: relative;
  -webkit-transition: all 0.4s ease 0s;
  -ms-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;
}
.footer-two .footer-top .footer-widget.footer-menu ul li a:hover {
  color: #ffffff;
  letter-spacing: 0.5px;
  padding-left: 30px;
}
.footer-two .footer-top .footer-widget.footer-menu ul li a::before {
  content: "\\f101";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  margin-right: 5px;
  position: absolute;
  top: 0;
  left: 0;
}
.footer-two .footer-top .footer-widget .footer-logo {
  margin: 0 0 30px;
}
.footer-two .footer-top .footer-widget .footer-about-content {
  max-width: inherit;
}
.footer-two .footer-top .footer-widget .footer-about-content p {
  color: #ffffff;
  margin-bottom: 15px;
}
.footer-two .footer-top .footer-widget .footer-about-content p:last-child {
  margin-bottom: 0;
}
.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul li {
  margin-right: 15px;
}
.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul li:last-child {
  margin-right: 0;
}
.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul li a {
  color: #ffffff;
  font-size: 20px;
  -webkit-transition: all 0.4s ease 0s;
  -ms-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;
}
.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul li a:hover {
  color: #09e5ab;
}
.footer-two .footer-top .footer-widget .footer-contact-info {
  color: #ffffff;
  font-size: 15px;
}
.footer-two .footer-top .footer-widget .footer-contact-info .footer-address span {
  margin-right: 20px;
}
.footer-two
  .footer-top
  .footer-widget
  .footer-contact-info
  .footer-address
  span
  i.fa-map-marker-alt {
  font-size: 20px;
}
.footer-two .footer-top .footer-widget .footer-contact-info .footer-address p {
  margin: 0;
}
.footer-two .footer-top .footer-widget .footer-contact-info p i {
  margin-right: 15px;
}
.footer-two .footer-bottom .copyright {
  border-top: 1px solid #1663a6;
  padding: 30px 0;
}
.footer-two .footer-bottom .copyright .copyright-text p {
  color: #ffffff;
  font-size: 15px;
}
.footer-two .footer-bottom .copyright .copyright-text p a {
  color: #09e5ab;
  -webkit-transition: all 0.4s ease 0s;
  -ms-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;
}
.footer-two .footer-bottom .copyright .copyright-text p a:hover {
  color: #ffffff;
}
.footer-two .footer-bottom .copyright .copyright-text p.title {
  font-weight: 400;
  margin: 10px 0 0;
}
.footer-two .footer-bottom .copyright .policy-menu {
  font-size: 14px;
  text-align: right;
  margin: 0;
  padding: 0;
}
@media (max-width: 767.98px) {
  .footer-two .footer-bottom .copyright .policy-menu {
    margin-top: 10px;
    text-align: left;
  }
}
.footer-two .footer-bottom .copyright .policy-menu li {
  display: inline-block;
  margin-right: 15px;
}
.footer-two .footer-bottom .copyright .policy-menu li:last-child {
  margin-right: 0;
}
.footer-two .footer-bottom .copyright .policy-menu li a {
  color: #ffffff;
}
.footer-two .footer-bottom .copyright .policy-menu li a:hover,
.footer-two .footer-bottom .copyright .policy-menu li a:focus {
  color: #09e5ab;
}
.footer-two .footer-bottom .copyright .policy-menu li::after {
  color: #ffffff;
  content: "|";
  font-weight: 300;
  position: relative;
  left: 10px;
}
.footer-two .footer-bottom .copyright .policy-menu li:last-child::after {
  content: "";
}

.footer-three {
  background: #ffffff;
}
.footer-three .footer-top {
  margin: 0;
  padding: 30px 0;
}
.footer-three .footer-widget .footer-title {
  color: #0071dc;
  margin: 0 0 15px;
}
.footer-three .footer-widget .footer-about-content p {
  font-size: 13px;
  color: #000000;
  margin-bottom: 28px;
}
.footer-three .footer-menu ul li {
  margin: 0 0 10px;
}
.footer-three .footer-menu ul li a {
  color: #000000;
  font-size: 16px;
  background: none;
}
.footer-three .footer-menu ul li a:hover {
  background: none;
  padding-left: 0;
}
@media (max-width: 1199.98px) {
  .footer-three .footer-menu ul li a {
    font-size: 15px;
  }
}
@media (max-width: 767.98px) {
  .footer-three .footer-menu ul li a {
    font-size: 14px;
  }
}
.footer-three .footer-link {
  margin-bottom: 20px !important;
}
.footer-three .social-icon ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.footer-three .social-icon ul li {
  display: inline-block;
  margin-right: 10px;
}
.footer-three .social-icon ul li:last-child {
  margin-right: 0;
}
.footer-three .social-icon ul li a {
  width: 45px;
  height: 45px;
  color: #ffffff;
  background: #0071dc;
  border: 1px solid #0071dc;
  border-radius: 50%;
  font-size: 18px;
  -webkit-transition: all 0.4s ease 0s;
  -ms-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;
}
.footer-three .social-icon ul li a:hover {
  background: #3b9cf6;
  color: #ffffff;
}
@media (max-width: 1199.98px) {
  .footer-three .social-icon ul li a {
    width: 35px;
    height: 35px;
    font-size: 14px;
  }
}
.footer-three .footer-bottom .copyright {
  border-top: 1px solid #d9d9d9;
}
.footer-three .footer-bottom .copyright .copyright-menu p {
  color: #000000;
  margin: 0;
}
@media (max-width: 991.98px) {
  .footer-three .footer-bottom .copyright .copyright-menu {
    margin: 0 0 15px;
  }
}
@media (max-width: 767.98px) {
  .footer-three .footer-bottom .copyright .footer-language > img {
    margin: 0 0 15px;
  }
}
.footer-three .footer-bottom .copyright .footer-language .footer-select {
  width: 164px;
  position: relative;
}
.footer-three .footer-bottom .copyright .footer-language .footer-select .select-icon {
  position: absolute;
  top: 55%;
  left: 14px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  z-index: 9;
  color: #999999;
}
.footer-three
  .footer-bottom
  .copyright
  .footer-language
  .footer-select
  .select2-container
  .select2-selection--single {
  border: 1px solid #d9d9d9;
  border-radius: 100px;
}
.footer-three
  .footer-bottom
  .copyright
  .footer-language
  .footer-select
  .select2-container
  .select2-selection--single
  .select2-selection__rendered {
  padding-left: 30px;
}
.footer-three
  .footer-bottom
  .copyright
  .footer-language
  .footer-select
  .select2-container--default
  .select2-selection--single
  .select2-selection__rendered {
  color: #999999;
  font-weight: 500;
}
@media (max-width: 767.98px) {
  .footer-three .footer-bottom .copyright .footer-language {
    display: block;
  }
}

.footer-one .social-icon ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.footer-one .social-icon ul li {
  margin-right: 15px;
}
.footer-one .social-icon ul li:last-child {
  margin-right: 0;
}
.footer-one .social-icon ul li a {
  color: #6b7280;
  font-size: 20px;
  -webkit-transition: all 0.4s ease 0s;
  -ms-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;
}
.footer-one .social-icon ul li a:hover {
  color: #0e82fd;
}

.footer.footer-one.footer-ten {
  background: #f8fafc;
  position: relative;
}
.footer.footer-one.footer-ten .footer-ten-bg img {
  position: absolute;
}
.footer.footer-one.footer-ten .footer-ten-bg img:nth-child(1) {
  left: 0;
}
.footer.footer-one.footer-ten .footer-ten-bg img:nth-child(2) {
  right: 0;
  bottom: 0;
}
.footer.footer-one.footer-ten .footer-ten-bg img:nth-child(3) {
  left: 50%;
  transform: translate(-50%, 100%);
}
.footer.footer-one.footer-ten .footer-details {
  padding-bottom: 50px;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 50px;
}
.footer.footer-one.footer-ten .footer-top .footer-widget.footer-menu ul {
  list-style: disc;
  padding-left: 15px;
}
.footer.footer-one.footer-ten .footer-top .footer-widget .footer-about-content p {
  padding-bottom: 24px;
}
.footer.footer-one.footer-ten .mail-note {
  color: #6b7280;
}
.footer.footer-one.footer-ten .footer-map {
  border-radius: 35px;
  overflow: hidden;
}
.footer.footer-one.footer-ten .footer-map img {
  width: 100%;
}
.footer.footer-one.footer-ten .footer-bottom {
  background: #ffffff;
}
.footer.footer-one.footer-ten .footer-bottom .copyright {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.footer.footer-one.footer-ten .footer-bottom .copyright .policy-menu li a {
  color: #6b7280;
  font-weight: 400;
}
.footer.footer-one.footer-ten .footer-bottom .copyright .policy-menu li a:hover {
  color: #0e82fd;
}

.footer.footer-eleven {
  background: #1b5a90;
}
.footer.footer-eleven .footer-top {
  padding: 50px 0 35px;
}
.footer.footer-eleven .footer-top .footer-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 10px;
}
.footer.footer-eleven .footer-top .footer-content p {
  color: #ffffff;
  margin: 0 0 25px;
}
.footer.footer-eleven .footer-top .subscribe-form {
  margin-bottom: 25px;
}
.footer.footer-eleven .footer-top .subscribe-form .form-control {
  min-height: 59px;
  margin: 0;
  padding: 10px 112px 10px 15px;
  border-radius: 10px;
}
.footer.footer-eleven .footer-top .subscribe-form .form-control::placeholder {
  color: #2b3d51;
}
.footer.footer-eleven .footer-top .subscribe-form .btn {
  margin-right: 10px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: normal;
  padding: 6px 23px;
}
@media (max-width: 767.98px) {
  .footer.footer-eleven .footer-top .footer-payment {
    margin: 0 0 15px 0;
  }
}
.footer.footer-eleven .footer-top .footer-payment h6 {
  font-size: 16px;
  margin: 0 0 15px;
  color: #ffffff;
}
.footer.footer-eleven .footer-bottom .copyright {
  border-top: 1px solid #4183bb;
  padding: 25px 0;
}
.footer.footer-eleven .footer-bottom .copyright .copyright-text p {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .footer.footer-eleven .footer-bottom .copyright .copyright-text p {
    margin-bottom: 10px;
  }
}
.footer.footer-eleven .footer-bottom .copyright .copyright-text p a {
  color: #0ce0ff;
}
.footer.footer-eleven .footer-bottom .copyright .policy-menu li {
  font-size: 16px;
}
@media (max-width: 575.98px) {
  .footer.footer-eleven .footer-bottom .copyright .policy-menu li {
    margin: 0 10px 10px 0;
  }
}
.footer.footer-eleven .footer-bottom .copyright .policy-menu li::after {
  color: rgba(255, 255, 255, 0.15);
}
.footer.footer-eleven .footer-bottom .copyright .policy-menu li a:hover {
  color: #0ce0ff;
}
@media (max-width: 1399.98px) {
  .footer.footer-eleven .footer-bottom .copyright .policy-menu li {
    font-size: 15px;
  }
}
.footer.footer-eleven .social-icon {
  margin: 0 0 25px;
}
.footer.footer-eleven .social-icon ul {
  list-style: none;
  margin: 0;
  padding: 0;
  text-align: right;
}
@media (max-width: 767.98px) {
  .footer.footer-eleven .social-icon ul {
    text-align: left !important;
  }
}
.footer.footer-eleven .social-icon ul li {
  display: inline-block;
  margin: 0 20px 0 0;
}
.footer.footer-eleven .social-icon ul li a {
  color: #ffffff;
  font-size: 20px;
}
.footer.footer-eleven .social-icon ul li a:hover {
  color: #0ce0ff;
}
.footer.footer-eleven .social-icon ul li:last-child {
  margin-right: 0;
}
.footer.footer-eleven .footer-widget.footer-menu {
  margin: 0 0 25px;
}
.footer.footer-eleven .footer-widget.footer-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.footer.footer-eleven .footer-widget.footer-menu ul li {
  display: inline-block;
  margin: 0 45px 0 0;
}
@media (max-width: 991.98px) {
  .footer.footer-eleven .footer-widget.footer-menu ul li {
    margin: 0 9px 0 0;
  }
}
@media (max-width: 575.98px) {
  .footer.footer-eleven .footer-widget.footer-menu ul li {
    margin: 0 10px 10px 0;
  }
}
.footer.footer-eleven .footer-widget.footer-menu ul li a {
  font-size: 16px;
  padding-left: 0;
  color: #ffffff;
}
.footer.footer-eleven .footer-widget.footer-menu ul li a:hover {
  color: #0ce0ff;
}
.footer.footer-eleven .footer-widget.footer-menu ul li a::before {
  content: none !important;
}
.footer.footer-eleven .footer-widget.footer-menu ul li:last-child {
  margin-right: 0;
}

.footer-language {
  position: relative;
  width: 173px;
  float: right;
}
@media (max-width: 767.98px) {
  .footer-language {
    float: left !important;
  }
}
.footer-language .select2-container .select2-selection--single {
  border: 1px solid #ffffff;
  background-color: transparent;
  border-radius: 10px;
  height: 44px;
}
.footer-language .select2-container .select2-selection--single .select2-selection__rendered {
  padding-left: 34px;
  color: #ffffff;
}
.footer-language .icon-lang {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  color: #ffffff;
  line-height: 0;
}

.footer-contacts {
  margin: 0 0 26px;
}
.footer-contacts .footer-wrap {
  background: rgba(240, 244, 246, 0.16);
  backdrop-filter: blur(50px);
  border-radius: 10px;
  margin: 0 0 24px;
  padding: 15px;
}
.footer-contacts .footer-wrap .footer-icon {
  width: 55px;
  height: 55px;
  background: #ffffff;
  border-radius: 100px;
  margin: 0 15px 0 0;
  flex-shrink: 0;
  color: #0ce0ff;
  font-size: 24px;
}
.footer-contacts .footer-wrap .footer-info h6 {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 10px;
}
.footer-contacts .footer-wrap .footer-info p {
  margin: 0;
  color: #ffffff;
}

.footer-one.footer-fourteen.footer-twelve {
  background: #f9fafb;
  padding: 0;
}
@media (max-width: 991.98px) {
  .footer-one.footer-fourteen.footer-twelve .footer-bottom .copyright .policy-menu {
    text-align: start;
  }
  .footer-one.footer-fourteen.footer-twelve .footer-bottom .copyright .policy-menu li {
    margin-right: 4px;
    font-weight: 400;
  }
  .footer-one.footer-fourteen.footer-twelve .footer-bottom .copyright .policy-menu li::after {
    left: 5px;
  }
  .footer-one.footer-fourteen.footer-twelve .footer-bottom .copyright .policy-menu li a {
    font-size: 14px;
  }
}

.footer.footer-thirteen {
  background: #ffffff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}
.footer.footer-thirteen .footer-top {
  margin: 0;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .footer.footer-thirteen .footer-top {
    margin: 0;
    padding: 50px 0;
  }
}
.footer.footer-thirteen .footer-top .footer-widget .footer-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 22px;
}
.footer.footer-thirteen .footer-top .footer-widget ul li {
  margin-bottom: 4px;
}
.footer.footer-thirteen .footer-top .footer-widget ul li a {
  color: #6b7280;
  font-size: 14px;
  font-weight: 400;
  padding-left: 0;
}
.footer.footer-thirteen .footer-top .footer-widget ul li a::before {
  content: "";
}
.footer.footer-thirteen .footer-top .footer-widget ul li a:hover {
  color: #0e82fd;
  padding-left: 10px;
}
.footer.footer-thirteen .footer-top .footer-widget ul li:first-child a {
  font-weight: 600;
}
.footer.footer-thirteen .footer-top .footer-menu-thirteen {
  margin-top: 43px;
}
.footer.footer-thirteen .footer-top .footer-menu-thirteen .footer-title {
  display: none;
}
@media (max-width: 991.98px) {
  .footer.footer-thirteen .footer-top .footer-menu-thirteen {
    margin-top: 0;
  }
  .footer.footer-thirteen .footer-top .footer-menu-thirteen .footer-title {
    display: block;
  }
}
.footer.footer-thirteen .footer-top .footer-contents-thirteen-main {
  margin: 60px 0 0 0;
}
@media (max-width: 991.98px) {
  .footer.footer-thirteen .footer-top .footer-contents-thirteen-main {
    margin: 20px 0 0 0;
  }
}
@media (max-width: 991.98px) {
  .footer.footer-thirteen .footer-top .footer-contents-thirteen-main .footer-thirt-inner {
    margin-bottom: 10px;
  }
}
.footer.footer-thirteen .footer-top .footer-contents-thirteen-main .footer-thirt-inner h4 {
  font-weight: 600;
  color: #00438a;
  margin-bottom: 6px;
}
.footer.footer-thirteen .footer-top .footer-contents-thirteen-main .footer-thirt-inner p {
  font-size: 14px;
  color: rgba(147, 163, 180, 0.8);
  font-weight: 400;
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .footer.footer-thirteen .footer-top .footer-contents-thirteen-main .footer-thirt-inner p {
    margin-bottom: 10px;
  }
}
.footer.footer-thirteen .footer-top .footer-contents-thirteen-main .subscribe-form {
  margin-bottom: 0;
  max-width: 430px;
}
@media (max-width: 1299.98px) {
  .footer.footer-thirteen .footer-top .footer-contents-thirteen-main .subscribe-form {
    max-width: 385px;
  }
}
.footer.footer-thirteen .footer-top .footer-contents-thirteen-main .subscribe-form .form-control {
  min-height: 56px;
  border: 1px solid #aab4ee;
  border-radius: 10px;
  padding: 10px 112px 10px 15px;
}
.footer.footer-thirteen
  .footer-top
  .footer-contents-thirteen-main
  .subscribe-form
  .form-control::placeholder {
  color: #bec4d9;
  font-size: 14px;
  font-weight: 600;
}
.footer.footer-thirteen .footer-top .footer-contents-thirteen-main .subscribe-form .btn {
  padding: 17px 40px;
  right: -45%;
  border-radius: 10px;
}
@media (max-width: 1299.98px) {
  .footer.footer-thirteen .footer-top .footer-contents-thirteen-main .subscribe-form .btn {
    padding: 17px 30px;
  }
}
@media (max-width: 1199.98px) {
  .footer.footer-thirteen .footer-top .footer-contents-thirteen-main .subscribe-form .btn {
    padding: 10px 19px;
    right: 6px;
  }
}
.footer.footer-thirteen .footer-bottom .copyright {
  border-top: 1px solid rgba(52, 52, 52, 0.1);
  padding: 20px 0;
}
@media (max-width: 991.98px) {
  .footer.footer-thirteen .footer-bottom .copyright {
    text-align: center;
  }
}
@media (max-width: 991.98px) {
  .footer.footer-thirteen .footer-bottom .copyright .copyright-img {
    margin-bottom: 15px;
  }
}
@media (max-width: 991.98px) {
  .footer.footer-thirteen .footer-bottom .copyright .copyright-text {
    margin-bottom: 15px;
  }
}
.footer.footer-thirteen .footer-bottom .copyright .copyright-text p {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.005em;
  text-align: center;
  color: #6b7280;
}
@media (max-width: 991.98px) {
  .footer.footer-thirteen .footer-bottom .copyright .copyright-menu {
    margin-bottom: 15px;
  }
}
@media (max-width: 991.98px) {
  .footer.footer-thirteen .footer-bottom .copyright .copyright-menu ul {
    text-align: center;
  }
}
.footer.footer-thirteen .footer-bottom .copyright .copyright-menu ul li a {
  color: #00438a;
  font-size: 18px;
}
.footer.footer-thirteen .footer-bottom .copyright .copyright-menu ul li a:hover {
  color: #0e82fd;
}
.footer.footer-thirteen .footer-bg-icon img {
  position: absolute;
  z-index: 0;
}
.footer.footer-thirteen .footer-bg-icon img:nth-child(1) {
  bottom: 20%;
  left: 0;
}
.footer.footer-thirteen .footer-bg-icon img:nth-child(2) {
  top: 20%;
  right: -7%;
}
@media (max-width: 991.98px) {
  .footer.footer-thirteen .footer-bg-icon img:nth-child(2) {
    display: none;
  }
}

.footer-one.footer-fourteen {
  background: #ffffff;
  padding: 200px 0 0 0;
}
.footer-one.footer-fourteen .footer-top {
  padding: 80px 0 50px 0;
}
@media (max-width: 991.98px) {
  .footer-one.footer-fourteen .footer-top {
    padding: 50px 0 10px 0;
  }
}
.footer-one.footer-fourteen .footer-top .footer-widget .subscribe-form .form-control {
  border: 1px solid #e5e7eb;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 6px 0px 0px 6px;
}

.footer.footer-fifteen {
  position: relative;
  padding: 52px 0 0 0;
  background-color: #ffffff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: top left;
  background-repeat: no-repeat;
  background-size: 50% 100%;
}
@media (max-width: 991.98px) {
  .footer.footer-fifteen {
    background-image: none;
    background-color: #0e82fd;
  }
}
.footer.footer-fifteen .footer-top-fifteen {
  padding: 0;
}
.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .footer-fifteen-image {
  margin-bottom: 10px;
}
.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen p {
  color: #ffffff;
  margin-bottom: 25px;
  line-height: 27px;
}
.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .subscribe-fifteen {
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 10px;
}
.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .subscribe-form-fifteen {
  width: 83%;
  margin-bottom: 25px;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-left-fifteen
  .subscribe-form-fifteen
  .form-control {
  border-radius: 10px;
  min-height: 55px;
  font-weight: 400;
  font-size: 16px;
  padding: 10px 130px 10px 10px;
}
@media (max-width: 767.98px) {
  .footer.footer-fifteen
    .footer-top-fifteen
    .footer-left-fifteen
    .subscribe-form-fifteen
    .form-control {
    font-size: 14px;
  }
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-left-fifteen
  .subscribe-form-fifteen
  .form-control::placeholder {
  color: #2b3d51;
  font-weight: 400;
  font-size: 16px;
}
@media (max-width: 767.98px) {
  .footer.footer-fifteen
    .footer-top-fifteen
    .footer-left-fifteen
    .subscribe-form-fifteen
    .form-control::placeholder {
    font-size: 14px;
  }
}
.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .subscribe-form-fifteen .btn {
  padding: 10px 15px;
  background: #0ce0ff;
  border-radius: 5px;
  border: none;
  right: 6px;
}
@media (max-width: 767.98px) {
  .footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .subscribe-form-fifteen .btn {
    padding: 10px 10px;
  }
}
.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .subscribe-form-fifteen .btn:hover {
  background: #0e82fd;
  box-shadow: inset 0 0 0 50px #0e82fd;
  color: #ffffff;
}
.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .subscribe-fifteentwo {
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 15px;
}
@media (max-width: 991.98px) {
  .footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .footer-fifteen-image-2 {
    margin-bottom: 15px;
  }
}
.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen {
  margin-left: 18px;
}
.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen .subscribe-fifteenthree {
  font-size: 18px;
  color: #1f2937;
  font-weight: 600;
  margin-bottom: 15px;
}
@media (max-width: 991.98px) {
  .footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen .subscribe-fifteenthree {
    color: #ffffff;
  }
}
.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul li {
  margin: 0 25px 25px 0;
  text-decoration: underline;
  line-height: 19px;
}
@media (max-width: 991.98px) {
  .footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul li {
    margin: 0 15px 15px 0;
    text-decoration: none;
  }
}
.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul li:last-child {
  margin-right: 0;
}
.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul li a {
  color: #6b7280;
}
.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul li a:hover {
  color: #1c5b91;
}
@media (max-width: 991.98px) {
  .footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul li a {
    color: #ffffff;
  }
}
.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen p {
  color: #6b7280;
}
@media (max-width: 991.98px) {
  .footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen p {
    color: #ffffff;
  }
}
.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen .user-details-fift ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen .user-details-fift ul li {
  text-decoration: none;
  margin: 0 15px 0 0;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .user-details-fift
  ul
  li
  .contact-fifteen {
  display: flex;
  align-items: center;
  justify-content: start;
  border: 1px solid #e5e5eb;
  border-radius: 10px;
  background: #ffffff;
  margin: 0 0 15px 0;
  padding: 10px;
  overflow: hidden;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .user-details-fift
  ul
  li
  .contact-fifteen
  .contact-form-fift {
  width: 35px;
  height: 35px;
  border-radius: 100px;
  background: #0e82fd;
  font-size: 17px;
  color: #ffffff;
  margin-right: 7px;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .user-details-fift
  ul
  li
  .contact-fifteen
  .contact-content-fift
  h6 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
}
@media (max-width: 1399.98px) {
  .footer.footer-fifteen
    .footer-top-fifteen
    .footer-right-fifteen
    .user-details-fift
    ul
    li
    .contact-fifteen
    .contact-content-fift
    h6 {
    font-size: 14px;
  }
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .user-details-fift
  ul
  li
  .contact-fifteen
  .contact-content-fift
  span {
  color: #707070;
  margin-bottom: 0;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen .footer-fift-selects {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 25px;
}
@media (max-width: 479.98px) {
  .footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen .footer-fift-selects {
    display: block;
  }
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-fift-selects
  .footer-select {
  display: inline-block;
}
@media (max-width: 479.98px) {
  .footer.footer-fifteen
    .footer-top-fifteen
    .footer-right-fifteen
    .footer-fift-selects
    .footer-select {
    margin-bottom: 15px;
  }
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-fift-selects
  .footer-select
  img {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 9;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-fift-selects
  .footer-select
  .select2-container
  .select2-selection--single {
  border: 1px solid #e5e5eb;
  border-radius: 10px;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-fift-selects
  .footer-select
  .select2-selection__rendered {
  padding-left: 43px;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-fift-selects
  .footer-select
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow {
  right: 1px;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-fift-selects
  .footer-select
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow
  b {
  border-color: #000000 transparent transparent;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-fift-selects
  .social-icon
  ul
  li {
  margin: 0 10px 0 0;
  text-decoration: none;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-fift-selects
  .social-icon
  ul
  li
  a {
  width: 44px;
  height: 43px;
  border-radius: 100px;
  background: #0e82fd;
  color: #ffffff;
  font-size: 18px;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-fift-selects
  .social-icon
  ul
  li
  a:hover {
  background: #0ce0ff;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-bottom.footer-bottom-fifteen
  .copyright {
  border-top: 1px solid #e5e5eb;
  padding: 25px 0 25px 0;
}
@media (max-width: 767.98px) {
  .footer.footer-fifteen
    .footer-top-fifteen
    .footer-right-fifteen
    .footer-bottom.footer-bottom-fifteen
    .copyright
    .copyright-text {
    text-align: center;
    margin-bottom: 10px;
  }
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-bottom.footer-bottom-fifteen
  .copyright
  .copyright-text
  p {
  margin-bottom: 0;
  font-size: 14px;
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-bottom.footer-bottom-fifteen
  .copyright
  .copyright-menu
  .policy-menu {
  justify-content: end;
}
@media (max-width: 767.98px) {
  .footer.footer-fifteen
    .footer-top-fifteen
    .footer-right-fifteen
    .footer-bottom.footer-bottom-fifteen
    .copyright
    .copyright-menu
    .policy-menu {
    justify-content: center;
  }
}
.footer.footer-fifteen
  .footer-top-fifteen
  .footer-right-fifteen
  .footer-bottom.footer-bottom-fifteen
  .copyright
  .copyright-menu
  .policy-menu
  li {
  text-decoration: none;
  margin: 0 10px 0 0;
}
@media (max-width: 1199.98px) {
  .footer.footer-fifteen
    .footer-top-fifteen
    .footer-right-fifteen
    .footer-bottom.footer-bottom-fifteen
    .copyright
    .copyright-menu
    .policy-menu
    li {
    margin: 0 15px 15px 0;
  }
}

.footer.footer-one.footer-sixteen {
  background: #ffffff;
  border-top: 1px solid #e2e2e2;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
}
.footer.footer-one.footer-sixteen .footer-top .footer-widget .footer-about-content {
  max-width: none;
  margin-bottom: 30px;
}
.footer.footer-one.footer-sixteen .footer-top .footer-widget .subscribe-form {
  margin-bottom: 0;
}
.footer.footer-one.footer-sixteen .footer-top .footer-widget .subscribe-form .btn {
  border: 1px solid #1c5b91;
  background: #1c5b91;
}
.footer.footer-one.footer-sixteen .footer-top .footer-widget .subscribe-form .btn:hover {
  border: 1px solid #0e82fd;
}
.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-text p {
  margin-bottom: 0;
}
@media (max-width: 575.98px) {
  .footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-text {
    margin-bottom: 10px;
  }
}
.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: end;
}
@media (max-width: 767.98px) {
  .footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul {
    justify-content: center;
  }
}
.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul li {
  margin-right: 10px;
}
.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul li:last-child {
  margin-right: 0;
}
.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul li a {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #1f2937;
  color: #ffffff;
  font-size: 12px;
}
.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul li a:hover {
  background: #0e82fd;
}

/****** PAGES ******/
.section-search {
  background: #f9f9f9 url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat bottom center;
  min-height: 530px;
  background-size: 100% auto;
  position: relative;
  background-blend-mode: Darken;
  padding: 160px 0 80px 0;
}
@media (max-width: 991.98px) {
  .section-search {
    min-height: 330px;
  }
}
@media (max-width: 767.98px) {
  .section-search {
    background: #f9f9f9;
    padding: 100px 0 50px 0;
  }
}
@media (max-width: 479.98px) {
  .section-search {
    min-height: 410px;
    padding: 100px 15px 30px 15px;
  }
}
.section-search .banner-wrapper {
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
}
@media (max-width: 991.98px) {
  .section-search .banner-wrapper {
    max-width: 720px;
  }
}
.section-search .banner-wrapper .banner-header {
  margin: 0 0 30px;
}
.section-search .banner-wrapper .banner-header h1 {
  font-size: 40px;
  font-weight: 600;
  margin: 0 0 10px;
}
@media (max-width: 991.98px) {
  .section-search .banner-wrapper .banner-header h1 {
    font-size: 34px;
  }
}
@media (max-width: 767.98px) {
  .section-search .banner-wrapper .banner-header h1 {
    font-size: 32px;
  }
}
@media (max-width: 575.98px) {
  .section-search .banner-wrapper .banner-header h1 {
    font-size: 28px;
  }
}
.section-search .banner-wrapper .banner-header p {
  color: #757575;
  font-size: 20px;
  margin: 0;
}
@media (max-width: 767.98px) {
  .section-search .banner-wrapper .banner-header p {
    font-size: 16px;
  }
}
@media (max-width: 767.98px) {
  .section-search .banner-wrapper .search-box {
    max-width: 535px;
    margin: 0 auto;
  }
}
@media (max-width: 767.98px) {
  .section-search .banner-wrapper .search-box form {
    -ms-flex-direction: column;
    flex-direction: column;
    word-wrap: break-word;
    background-clip: border-box;
  }
}
@media (max-width: 575.98px) {
  .section-search .banner-wrapper .search-box form {
    display: block;
  }
}
.section-search .banner-wrapper .search-box .form-control {
  border: 1px solid #cccccc;
  border-radius: 5px;
  padding-left: 35px;
  -webkit-box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.075);
}
.section-search .banner-wrapper .search-box .form-control::placeholder {
  font-size: 14px;
}
.section-search .banner-wrapper .search-box .search-location {
  -ms-flex: 0 0 240px;
  flex: 0 0 240px;
  margin-right: 12px;
  position: relative;
  width: 240px;
}
@media (max-width: 767.98px) {
  .section-search .banner-wrapper .search-box .search-location {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    width: 100%;
  }
}
@media (max-width: 575.98px) {
  .section-search .banner-wrapper .search-box .search-location {
    width: 100% !important;
    -ms-flex: none;
    flex: none;
  }
}
.section-search .banner-wrapper .search-box .search-location .form-control {
  background: #ffffff url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat 10px center;
}
.section-search .banner-wrapper .search-box .search-info {
  -ms-flex: 0 0 490px;
  flex: 0 0 490px;
  margin-right: 12px;
  position: relative;
  width: 490px;
}
@media (max-width: 991.98px) {
  .section-search .banner-wrapper .search-box .search-info {
    -ms-flex: 0 0 410px;
    flex: 0 0 410px;
    width: 410px;
  }
}
@media (max-width: 767.98px) {
  .section-search .banner-wrapper .search-box .search-info {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    width: 100%;
  }
}
@media (max-width: 575.98px) {
  .section-search .banner-wrapper .search-box .search-info {
    width: 100% !important;
    -ms-flex: none;
    flex: none;
  }
}
.section-search .banner-wrapper .search-box .search-info .form-control {
  background: #ffffff url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat 10px center;
}
.section-search .banner-wrapper .search-box .search-btn {
  width: 46px;
  -ms-flex: 0 0 46px;
  flex: 0 0 46px;
  height: 46px;
}
@media (max-width: 767.98px) {
  .section-search .banner-wrapper .search-box .search-btn {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    min-height: 46px;
    width: 100%;
  }
}
.section-search .banner-wrapper .search-box .search-btn span {
  display: none;
  font-weight: 500;
}
@media (max-width: 767.98px) {
  .section-search .banner-wrapper .search-box .search-btn span {
    display: inline-block;
    margin-left: 5px;
    text-transform: uppercase;
  }
}
.section-search .banner-wrapper .search-box .form-text {
  color: #757575;
  font-size: 13px;
}
.section-search .banner-wrapper .search-box .search-location {
  -ms-flex: 0 0 240px;
  flex: 0 0 240px;
  margin-right: 12px;
  position: relative;
  width: 240px;
}
@media (max-width: 767.98px) {
  .section-search .banner-wrapper .search-box .search-location {
    flex: auto;
  }
}
@media (max-width: 767.98px) {
  .section-search .banner-wrapper .search-box {
    max-width: 535px;
    margin: 0 auto;
  }
}

.section-header {
  margin-bottom: 60px;
}
.section-header h5 {
  font-weight: 600;
  font-size: 18px;
  color: #0e82fd;
  margin-bottom: 10px;
}
.section-header h2 {
  font-size: 36px;
  font-weight: 500;
  margin: 0;
}
@media (max-width: 767.98px) {
  .section-header h2 {
    font-size: 30px;
  }
}
@media (max-width: 575.98px) {
  .section-header h2 {
    font-size: 24px;
  }
}
.section-header .sub-title {
  color: #757575;
  font-size: 16px;
  max-width: 600px;
  margin: 15px auto 0;
}
@media (max-width: 767.98px) {
  .section-header .sub-title {
    font-size: 14px;
  }
}
@media (max-width: 575.98px) {
  .section-header .sub-title {
    font-size: 14px;
  }
}
.section-header p {
  color: #757575;
  font-size: 16px;
  margin: 15px 0 0 0;
}
@media (max-width: 767.98px) {
  .section-header p {
    font-size: 15px;
  }
}
@media (max-width: 575.98px) {
  .section-header p {
    font-size: 15px;
  }
}

.section-specialities {
  background-color: #ffffff;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .section-specialities {
    padding: 50px 0;
  }
}
@media (max-width: 479.98px) {
  .section-specialities {
    background-color: #ffffff;
    padding: 30px 0;
  }
}
.section-specialities .specialities-slider .slick-slide {
  display: block;
}
@media (max-width: 767.98px) {
  .section-specialities .specialities-slider .slick-slide {
    margin-right: 15px;
  }
}
@media (max-width: 479.98px) {
  .section-specialities .specialities-slider .slick-slide {
    margin-right: 10px;
  }
}
.section-specialities .specialities-slider .slick-dots {
  margin-top: 44px;
  position: unset;
}
.section-specialities .specialities-slider .speicality-item p {
  font-size: 16px;
  font-weight: 500;
  margin: 30px 0 0;
}
@media (max-width: 767.98px) {
  .section-specialities .specialities-slider .speicality-item p {
    font-size: 14px;
  }
}
@media (max-width: 575.98px) {
  .section-specialities .specialities-slider .speicality-item p {
    font-size: 14px;
  }
}
.section-specialities .specialities-slider .speicality-item .speicality-img {
  position: relative;
  height: 150px;
  border-radius: 100%;
  width: 150px;
  background: #ffffff;
  -webkit-box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);
  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);
}
@media (max-width: 479.98px) {
  .section-specialities .specialities-slider .speicality-item .speicality-img {
    width: 120px;
    height: 120px;
  }
}
.section-specialities .specialities-slider .speicality-item .speicality-img img {
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  margin: 0 auto;
}
@media (max-width: 479.98px) {
  .section-specialities .specialities-slider .speicality-item .speicality-img img {
    width: 50px;
  }
}
.section-specialities .specialities-slider .speicality-item .speicality-img span {
  border-radius: 50%;
  padding: 5px;
  background-color: #ffffff;
  position: absolute;
  right: 10px;
  bottom: 10px;
  -webkit-box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);
}
.section-specialities .specialities-slider .speicality-item .speicality-img span i {
  font-size: 15px;
  color: #0de0fe;
}

.section-specialities .specialities-slider .slick-slide {
  display: block;
  padding: 0 12px;
}

.slick-dots {
  display: block;
  width: 100%;
  list-style: none;
  text-align: center;
  position: absolute;
  bottom: -25px;
  margin: 0;
  padding: 0;
}
.slick-dots li {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 5px;
  cursor: pointer;
  margin: 0 5px;
  padding: 0;
}
.slick-dots li button {
  font-size: 0;
  line-height: 0;
  display: block;
  width: 20px;
  height: 5px;
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: none;
  background: #c0c0c0;
  padding: 0;
}
.slick-dots li button:hover,
.slick-dots li button:focus {
  outline: none;
}
.slick-dots li button:hover:before,
.slick-dots li button:focus:before {
  opacity: 1;
}
.slick-dots li button:before {
  display: none;
  font-family: "slick";
  font-size: 76px;
  line-height: 20px;
  width: 20px;
  height: 20px;
  content: "-";
  text-align: center;
  opacity: 0.25;
  color: #000000;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 0;
  left: 0;
}
.slick-dots li.slick-active button {
  background-color: #0de0fe;
}
.slick-dots li.slick-active button:before {
  opacity: 1;
  color: #0de0fe;
}
.slick-dots li.slick-active button .slick-slide {
  outline: none !important;
}

.section-doctor {
  background-color: #f8f9fa;
  padding: 80px 0;
}
@media (max-width: 767.98px) {
  .section-doctor {
    padding: 50px 0;
  }
}
.section-doctor .profile-widget {
  -webkit-box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);
  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
}
.section-doctor .section-header {
  margin: 0 0 30px;
}
.section-doctor .section-header p {
  margin-top: 10px;
}
@media (max-width: 991.98px) {
  .section-doctor .about-content {
    margin-bottom: 30px;
  }
}
.section-doctor .about-content p {
  font-size: 14px;
  font-weight: 400;
  line-height: 26px;
  margin: 0;
}
.section-doctor .about-content p + p {
  margin-top: 20px;
}
.section-doctor .about-content a {
  background-color: #0de0fe;
  color: #ffffff;
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  min-width: 150px;
  margin: 30px 0 0;
  padding: 15px 20px;
  text-align: center;
  border-radius: 4px;
}
@media (max-width: 767.98px) {
  .section-doctor .about-content a {
    padding: 12px 20px;
  }
}
.section-doctor .about-content a:hover,
.section-doctor .about-content a:focus {
  background-color: #01cae4;
  border-color: #01cae4;
  color: #ffffff;
}
@media (max-width: 767.98px) {
  .section-doctor .doctor-slider {
    margin-top: 25px;
  }
}
.section-doctor .doctor-slider .slick-slide {
  display: block;
  width: 280px;
  margin-bottom: 0;
  padding: 10px;
}

.profile-widget {
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  position: relative;
  margin-bottom: 30px;
  padding: 15px;
  border-radius: 4px;
  -webkit-transition: all 0.3s ease 0s;
  -ms-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.profile-widget .fav-btn {
  background-color: #ffffff;
  width: 30px;
  height: 30px;
  color: #2e3842;
  opacity: 0;
  visibility: hidden;
  z-index: 99;
  position: absolute;
  top: 5px;
  right: 5px;
  transform: translate3d(100%, 0, 0);
  -webkit-transform: translate3d(100%, 0, 0);
  -ms-transform: translate3d(100%, 0, 0);
  border-radius: 3px;
}
.profile-widget:hover .fav-btn {
  opacity: 1;
  visibility: visible;
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
}
.profile-widget:hover .fav-btn:hover {
  background-color: #fb1612;
  color: #ffffff;
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
}
.profile-widget .verified {
  color: #28a745;
  margin-left: 3px;
}
.profile-widget .rating {
  color: #757575;
  font-size: 14px;
  margin-bottom: 15px !important;
}
.profile-widget .rating i {
  font-size: 14px;
}
.profile-widget .doc-img {
  position: relative;
  overflow: hidden;
  z-index: 1;
  border-radius: 4px;
}
.profile-widget .doc-img img {
  border-radius: 4px;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  width: 100%;
}
.profile-widget .doc-img:hover img {
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}
.profile-widget .pro-content {
  padding: 15px 0 0;
}
.profile-widget .pro-content .title {
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 5px;
}
.profile-widget .pro-content .title a {
  display: inline-block;
}
.profile-widget .pro-content p.speciality {
  font-size: 13px;
  color: #757575;
  margin-bottom: 5px;
  min-height: 40px;
}
.profile-widget .pro-content .rating {
  list-style: none;
  width: 100%;
  margin: 0 0 7px;
  padding: 0;
}
.profile-widget .pro-content .rating i {
  color: #dedfe0;
}
.profile-widget .pro-content .rating i.filled {
  color: #f4c150;
}
.profile-widget .pro-content .available-info {
  font-size: 13px;
  color: #757575;
  font-weight: 400;
  list-style: none;
  margin: auto auto 15px;
  padding: 0;
}
.profile-widget .pro-content .available-info li i {
  width: 22px;
}
.profile-widget .pro-content .available-info li + li {
  margin-top: 5px;
}
.profile-widget .pro-content .row.row-sm {
  margin-left: -3px;
  margin-right: -3px;
}
.profile-widget .pro-content .row.row-sm > div {
  padding-left: 3px;
  padding-right: 3px;
}

.section-features {
  background-color: #ffffff;
  padding: 80px 0;
}
@media (max-width: 767.98px) {
  .section-features {
    padding: 50px 0;
  }
}
@media (max-width: 479.98px) {
  .section-features {
    background-color: #ffffff;
    padding: 30px 0;
  }
}
@media (max-width: 767.98px) {
  .section-features .features-img {
    text-align: center;
    margin: 0 auto;
  }
}
.section-features .features-slider .slick-slide {
  margin-right: 62px;
}
.section-features .features-slider .slick-center {
  opacity: 1;
  transform: scale(1.2);
  -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
}
.section-features .features-slider .slick-list {
  padding: 16px 50px !important;
}
.section-features .features-slider .slick-dots {
  margin-top: 44px;
  position: unset;
}
@media (max-width: 767.98px) {
  .section-features .features-slider .slick-dots {
    text-align: center;
    margin: 0 auto;
  }
}
.section-features .features-slider .feature-item img {
  box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);
  height: 115px;
  object-fit: cover;
  width: 115px;
  border-radius: 100%;
}
.section-features .features-slider .feature-item p {
  font-weight: 500;
  margin: 20px 0 0;
}

.section-blogs {
  background-color: #f8f9fa;
  padding: 80px 0;
}
@media (max-width: 767.98px) {
  .section-blogs {
    padding: 50px 0;
  }
}
@media (max-width: 479.98px) {
  .section-blogs {
    padding: 30px 0;
  }
}
.section-blogs .view-all .btn {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 700;
  padding: 12px 30px;
}

.rating {
  list-style: none;
  width: 100%;
  margin: 0 0 7px;
  padding: 0;
}
.rating i {
  color: #dedfe0;
}
.rating i.filled {
  color: #f4c150;
  padding: 0 2px;
}

.home-tile-section {
  background-color: #f8f9fa;
  padding: 80px 0;
}
@media (max-width: 767.98px) {
  .home-tile-section {
    padding: 50px 0;
  }
}
@media (max-width: 479.98px) {
  .home-tile-section {
    padding: 30px 0;
  }
}
.home-tile-section .doctor-book-card {
  position: relative;
  max-width: 100%;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.0431372549);
  overflow: hidden;
  margin: 0 auto;
}
@media (max-width: 575.98px) {
  .home-tile-section .doctor-book-card {
    margin-bottom: 0.9375rem;
  }
}
.home-tile-section .doctor-book-card img {
  vertical-align: middle;
  border-radius: 0.25rem;
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
}
.home-tile-section .doctor-book-card .doctor-book-card-content {
  color: #f1f1f1;
  width: 100%;
  height: 100%;
  border-radius: 0.25rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  padding: 20px;
}
.home-tile-section .doctor-book-card .doctor-book-card-content > div {
  width: 100%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
}
.home-tile-section .doctor-book-card .doctor-book-card-content .book-btn1 {
  font-size: 14px;
}
.home-tile-section .doctor-book-card .tile-card-content-1 {
  background: rgba(13, 13, 13, 0.33);
}
.home-tile-section .doctor-book-card h3 {
  text-shadow: 2px 4px 3px rgba(0, 0, 0, 0.3);
  color: #ffffff;
}
.home-tile-section .doctor-book-card:hover img {
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}

.banner-section {
  background: #f2f6f6;
  padding: 100px 0 30px;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.banner-section::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.banner-shapes {
  position: relative;
}
.banner-shapes .banner-shape-left {
  position: absolute;
  top: 600px;
  left: 0;
}
.banner-shapes .banner-shape-right {
  position: absolute;
  top: 30px;
  left: 0;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}

.banner-content {
  padding-bottom: 80px;
  position: relative;
}
.banner-content h1 {
  font-weight: 600;
  font-size: 48px;
  margin-bottom: 25px;
}
.banner-content h1 span {
  color: #0e82fd;
}
@media (max-width: 991.98px) {
  .banner-content h1 {
    font-size: 36px;
  }
}
@media (max-width: 767.98px) {
  .banner-content h1 {
    font-size: 28px;
    margin-bottom: 20px;
  }
}
.banner-content .header-icon {
  position: absolute;
  right: -30px;
  top: -15px;
}
@media (max-width: 1199.98px) {
  .banner-content .header-icon {
    display: none;
  }
}
.banner-content p {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 25px;
}
@media (max-width: 767.98px) {
  .banner-content p {
    font-size: 16px;
    margin-bottom: 20px;
  }
}
.banner-content .btn {
  font-weight: 500;
  border-radius: 8px;
  margin: 0;
  padding: 12px 15px;
  min-width: 200px;
  display: inline-block;
  background-color: #0e82fd;
  border: 1px solid #0e82fd;
  color: #ffffff;
  font-size: 18px;
  box-shadow: inset 0 0 0 0 #ffffff;
  -webkit-transition: 0.5s;
  -ms-transition: 0.5s;
  transition: 0.5s;
}
.banner-content .btn:hover {
  color: #0e82fd;
  border-color: #0e82fd;
  background-color: #ffffff;
  box-shadow: inset 0 0 0 50px #ffffff;
  -webkit-transition: 0.5s;
  -ms-transition: 0.5s;
  transition: 0.5s;
}
@media (max-width: 991.98px) {
  .banner-content .btn {
    font-size: 16px;
    margin: 0;
    padding: 10px 15px;
    min-width: 190px;
  }
}
@media (max-width: 767.98px) {
  .banner-content .btn {
    font-size: 15px;
    margin: 0;
    padding: 9px 15px;
    min-width: 170px;
  }
}
@media (max-width: 991.98px) {
  .banner-content {
    text-align: center;
    padding-bottom: 40px;
  }
}

.banner-arrow-img {
  position: absolute;
  left: 220px;
  top: 180px;
}
@media (max-width: 1199.98px) {
  .banner-arrow-img {
    display: none;
  }
}

.search-box-one {
  min-width: 800px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  box-shadow: 0px 3px 53px rgba(197, 197, 197, 0.2);
  border-radius: 7px;
  margin: 0;
  padding: 13px 15px;
  display: table;
  position: relative;
  z-index: 1;
}
.search-box-one form {
  float: left;
  width: 100%;
}
.search-box-one input:hover,
.search-box-one input:focus {
  background-color: #ffffff !important;
}
@media (max-width: 991.98px) {
  .search-box-one {
    min-width: 100%;
    width: 100%;
  }
}
@media (max-width: 767.98px) {
  .search-box-one {
    margin: 0;
    padding: 0px 15px 15px;
  }
}

.search-box-one .form-control:hover,
.search-box-one .form-control:focus {
  background-color: #ffffff !important;
}

.search-input {
  width: 25%;
  float: left;
  display: table-cell;
  vertical-align: middle;
  position: relative;
}
.search-input.search-line {
  width: 35%;
}
.search-input.search-line::before {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  width: 1px;
  height: 44px;
  background: #e3e4e8;
  content: "";
  z-index: 1;
}
@media (max-width: 767.98px) {
  .search-input.search-line::before {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .search-input.search-line {
    width: 100%;
  }
}
.search-input.search-map-line {
  width: 26%;
}
.search-input.search-map-line::before {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  width: 1px;
  height: 44px;
  background: #e3e4e8;
  content: "";
  z-index: 1;
}
@media (max-width: 767.98px) {
  .search-input.search-map-line::before {
    display: none;
  }
}
.search-input.search-map-line input {
  padding: 0px 36px 0px 36px;
}
@media (max-width: 767.98px) {
  .search-input.search-map-line input {
    padding: 0px 25px 0px 25px;
  }
}
.search-input.search-map-line > i {
  left: 10px;
}
@media (max-width: 767.98px) {
  .search-input.search-map-line > i {
    left: 0;
  }
}
@media (max-width: 767.98px) {
  .search-input.search-map-line {
    width: 100%;
  }
}
.search-input input {
  height: 40px;
  padding: 0 10px 0 25px;
  border: 0;
}
.search-input input::placeholder {
  color: #8c97b0;
}
.search-input.search-calendar-line input {
  padding: 0 36px 0 36px;
}
@media (max-width: 767.98px) {
  .search-input.search-calendar-line input {
    padding: 0px 25px 0px 25px;
  }
}
.search-input.search-calendar-line > i {
  left: 10px;
}
@media (max-width: 767.98px) {
  .search-input.search-calendar-line > i {
    left: 0;
  }
}
.search-input i {
  position: absolute;
  top: 50%;
  right: inherit;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  color: #8894ae;
  font-size: 18px;
}
.search-input .current-loc-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  margin-top: 0px;
  color: #8894ae;
  font-size: 18px;
  line-height: 0;
}
.search-input .current-loc-icon i {
  position: unset;
  transform: unset;
}
.search-input > i.bficon {
  right: inherit;
  left: 0;
  z-index: 1;
}
@media (max-width: 767.98px) {
  .search-input {
    width: 100%;
  }
}

.form-search-btn {
  float: right;
  padding-top: 4px;
}
.form-search-btn .btn {
  font-size: 15px;
  font-weight: 500;
  min-width: 97px;
  padding: 7px 15px;
  border-radius: 10px;
  background-color: #0e82fd;
  border: 1px solid #0e82fd;
  color: #ffffff;
  box-shadow: inset 0 0 0 0 #ffffff;
  -webkit-transition: 0.5s;
  -ms-transition: 0.5s;
  transition: 0.5s;
}
.form-search-btn .btn:hover {
  color: #0e82fd;
  border-color: #0e82fd;
  background-color: #ffffff;
  box-shadow: inset 0 0 0 50px #ffffff;
  -webkit-transition: 0.5s;
  -ms-transition: 0.5s;
  transition: 0.5s;
}
@media (max-width: 767.98px) {
  .form-search-btn {
    float: left;
  }
}

.banner-img {
  position: relative;
}
.banner-img .banner-img1 {
  position: absolute;
  top: 260px;
  left: -40px;
  -webkit-animation: float 2s ease-in-out infinite;
  animation: float 2s ease-in-out infinite;
}
.banner-img .banner-img2 {
  position: absolute;
  top: 200px;
  right: 20px;
  -webkit-animation: mover 3s infinite alternate;
  animation: mover 3s infinite alternate;
}
.banner-img .banner-img3 {
  position: absolute;
  top: 500px;
  right: -50px;
  -webkit-animation: mover 1s infinite alternate;
  animation: mover 1s infinite alternate;
}
@keyframes float {
  0% {
    transform: translateY(0px);
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
  }
  50% {
    transform: translateY(-15px);
    -webkit-transform: translateY(-15px);
    -ms-transform: translateY(-15px);
  }
  100% {
    transform: translateY(0px);
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
  }
}
@-webkit-keyframes mover {
  0% {
    transform: translateY(0px);
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
  }
  100% {
    transform: translateY(-15px);
    -webkit-transform: translateY(-15px);
    -ms-transform: translateY(-15px);
  }
}
@keyframes mover {
  0% {
    transform: translateY(0px);
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
  }
  100% {
    transform: translateY(-15px);
    -webkit-transform: translateY(-15px);
    -ms-transform: translateY(-15px);
  }
}
@media (max-width: 991.98px) {
  .banner-img {
    display: none;
  }
}

.specialities-section-one {
  background-color: #ffffff;
  margin: 0;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .specialities-section-one {
    margin: 0;
    padding: 40px 0;
  }
}
.specialities-section-one .specialities-slider-one .item {
  margin-bottom: 50px;
}
@media (max-width: 767.98px) {
  .specialities-section-one .specialities-slider-one .item {
    margin-bottom: 40px;
  }
}
.specialities-section-one .specialities-slider-one .owl-stage-outer {
  margin-left: -10px;
}
.specialities-section-one .specialities-slider-one .owl-item img {
  width: auto;
}
.specialities-section-one .specialities-item {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  height: 196px;
  margin: 15px 0 0 10px;
  padding: 30px;
  cursor: pointer;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.specialities-section-one .specialities-item:hover {
  background: #ffffff;
  border-color: #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.specialities-section-one .specialities-item:hover .specialities-img span {
  background: #0e82fd;
  border: #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.specialities-section-one .specialities-item:hover .specialities-img span img {
  filter: invert(1) brightness(100);
  transform: rotateY(360deg);
  -webkit-transform: rotateY(360deg);
  -ms-transform: rotateY(360deg);
  -webkit-transition: 0.4s;
  -ms-transition: 0.4s;
  transition: 0.4s;
}
.specialities-section-one .specialities-item p {
  font-weight: 600;
  font-size: 16px;
  color: #2f353c;
  margin-bottom: 0;
}
.specialities-section-one .specialities-img {
  padding-bottom: 18px;
}
.specialities-section-one .specialities-img span {
  background: #f2f6f6;
  border: 1px solid #f2f6f6;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.specialities-section-one .specialities-img span img {
  width: auto;
  -webkit-transition: 0.4s;
  -ms-transition: 0.4s;
  transition: 0.4s;
}
.specialities-section-one .specialities-btn {
  text-align: center;
}
.specialities-section-one .specialities-btn .btn {
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  min-width: 170px;
  padding: 11px 15px;
  background: #0e82fd;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #ffffff;
  color: #ffffff;
  -webkit-transition: 0.5s;
  -ms-transition: 0.5s;
  transition: 0.5s;
}
.specialities-section-one .specialities-btn .btn:hover {
  color: #0e82fd;
  background: #ffffff;
  border-color: #0e82fd;
  box-shadow: inset 0 0 0 50px #ffffff;
  -webkit-transition: 0.5s;
  -ms-transition: 0.5s;
  transition: 0.5s;
}
@media (max-width: 767.98px) {
  .specialities-section-one .specialities-btn .btn {
    font-size: 14px;
    min-width: 190px;
  }
}

.section-header-one {
  margin-bottom: 60px;
}
.section-header-one h2 {
  font-size: 40px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .section-header-one h2 {
    font-size: 34px;
  }
}
@media (max-width: 767.98px) {
  .section-header-one h2 {
    font-size: 26px;
  }
}
.section-header-one .section-title {
  display: inline-block;
  position: relative;
}
.section-header-one .section-title::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;
  position: absolute;
  top: -5px;
  right: -30px;
  width: 35px;
  height: 20px;
}
@media (max-width: 767.98px) {
  .section-header-one .section-title::before {
    display: none;
  }
}
.section-header-one h5 {
  font-weight: 600;
  font-size: 18px;
  color: #0e82fd;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .section-header-one {
    margin-bottom: 40px;
  }
}

.slide-nav-1 button.owl-next,
.slide-nav-1 button.owl-prev,
.slide-nav-2 button.owl-next,
.slide-nav-2 button.owl-prev {
  width: 44px;
  height: 44px;
  font-size: 18px;
  color: #1e3259;
  background: #ffffff;
  box-shadow: 0px 4px 14px rgba(141, 141, 141, 0.25);
  text-shadow: none;
  top: 0;
  cursor: pointer;
  border: 0;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 15px;
  border-radius: 50px;
}

.slide-nav-1 button.owl-next:hover,
.slide-nav-1 button.owl-prev:hover,
.slide-nav-2 button.owl-next:hover,
.slide-nav-2 button.owl-prev:hover {
  color: #ffffff;
  background: #0e82fd;
}

.doctors-section {
  background: #f2f6f6;
  margin: 0;
  padding: 80px 0;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.doctors-section::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left;
  position: absolute;
  top: 0;
  left: 0;
  width: 213px;
  height: 335px;
  opacity: 0.5;
  z-index: -1;
}
@media (max-width: 991.98px) {
  .doctors-section::after {
    display: none;
  }
}
.doctors-section::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;
  position: absolute;
  right: 0;
  bottom: 0;
  opacity: 0.5;
  width: 213px;
  height: 335px;
  z-index: -1;
}
@media (max-width: 991.98px) {
  .doctors-section::before {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .doctors-section {
    margin: 0;
    padding: 40px 0;
  }
}
@media (max-width: 767.98px) {
  .doctors-section .section-header-slider {
    margin-bottom: 20px;
  }
}

.doctor-shape-img {
  position: relative;
}
.doctor-shape-img .doctor-shape-left {
  position: absolute;
  top: 0;
  left: -35px;
}
.doctor-shape-img .doctor-shape-right {
  position: absolute;
  top: 230px;
  right: 0;
}
@media (max-width: 991.98px) {
  .doctor-shape-img {
    display: none;
  }
}

@-webkit-keyframes blinker {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.doctor-profile-widget {
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.doc-pro-img {
  position: relative;
}

.doctor-profile-img {
  position: relative;
  overflow: hidden;
  border-radius: 8px 8px 0px 0px;
}
.doctor-profile-img img {
  position: relative;
  border-radius: 8px 8px 0px 0px;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  width: 100%;
}
.doctor-profile-img:hover img {
  -webkit-transition: scale(1.15);
  -ms-transition: scale(1.15);
  transition: scale(1.15);
}
.doctor-profile-img:hover::before {
  -webkit-animation: circle 1s;
  animation: circle 1s;
}
.doctor-profile-img::before {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  display: block;
  content: "";
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  opacity: 0;
}

@-webkit-keyframes circle {
  0% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  100% {
    width: 200%;
    height: 200%;
    opacity: 0;
  }
}
@keyframes circle {
  0% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  100% {
    width: 200%;
    height: 200%;
    opacity: 0;
  }
}
.doctor-amount {
  position: absolute;
  top: 20px;
  right: 20px;
}
.doctor-amount span {
  font-weight: 500;
  font-size: 15px;
  color: #2c2c2c;
  padding: 6px 12px;
  background: #ffffff;
  border-radius: 8px;
}

.doc-content {
  padding: 20px;
}
@media (max-width: 767.98px) {
  .doc-content {
    padding: 15px;
  }
}

.doc-pro-info {
  padding-bottom: 15px;
}
.doc-pro-info .doc-pro-name a {
  font-weight: 600;
  font-size: 20px;
}
.doc-pro-info .doc-pro-name a:hover {
  color: #0e82fd;
}
@media (max-width: 1399.98px) {
  .doc-pro-info .doc-pro-name a {
    font-size: 18px;
  }
}
.doc-pro-info .doc-pro-name p {
  color: #9ca3af;
  font-size: 12px;
  margin-bottom: 0;
}

.reviews-ratings p {
  color: #9ca3af;
  font-size: 10px;
  font-weight: 500;
  margin-bottom: 0;
}
.reviews-ratings span {
  margin: 0 4px 0 0;
  padding: 2px 3px;
  min-width: 46px;
  color: #ffffff;
  font-size: 12px;
  background: #ffbc11;
  border-radius: 6px;
}
.reviews-ratings span i {
  margin-right: 6px;
}

.doc-pro-location p {
  margin-bottom: 0;
}
.doc-pro-location p i {
  margin-right: 8px;
  font-size: 20px;
  color: #d1d5db;
}

.work-section {
  background: #f2f6f6;
  margin: 0;
  padding: 80px 0 0;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.work-section::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left;
  position: absolute;
  top: 0;
  left: 0;
  width: 213px;
  height: 335px;
  opacity: 0.5;
  z-index: -1;
}
@media (max-width: 991.98px) {
  .work-section::after {
    display: none;
  }
}
.work-section::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;
  position: absolute;
  right: 0;
  bottom: 0;
  opacity: 0.5;
  width: 213px;
  height: 335px;
  z-index: -1;
}
@media (max-width: 991.98px) {
  .work-section::before {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .work-section {
    margin: 0;
    padding: 40px 0 20px;
  }
}

.work-img-info {
  position: relative;
}
@media (max-width: 991.98px) {
  .work-img-info {
    display: none;
  }
}
.work-img-info .work-img {
  position: absolute;
  bottom: 0;
}

.work-details {
  padding-left: 60px;
}
@media (max-width: 1199.98px) {
  .work-details {
    padding-left: 20px;
  }
}

.work-info {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: start;
  margin-bottom: 35px;
}
@media (max-width: 991.98px) {
  .work-info {
    margin-bottom: 20px;
  }
}
.work-info .work-icon {
  margin-right: 20px;
}
.work-info .work-icon span {
  min-width: 70px;
  height: 70px;
  background: #e0e7ff;
  border-radius: 10px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
  transform: rotate(0);
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
}
.work-info .work-icon span img {
  transform: rotate(0);
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.work-info:hover .work-icon span {
  background: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.work-info:hover .work-icon span img {
  transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.work-info .work-content h5 {
  font-weight: 600;
  font-size: 18px;
  color: #1f2937;
  margin-bottom: 14px;
}
@media (max-width: 767.98px) {
  .work-info .work-content h5 {
    margin-bottom: 10px;
  }
}
.work-info .work-content p {
  font-size: 16px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .work-info .work-content p {
    font-size: 14px;
  }
}

.work-section {
  background: #f2f6f6;
  margin: 0;
  padding: 80px 0 0;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.work-section::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left;
  position: absolute;
  top: 0;
  left: 0;
  width: 213px;
  height: 335px;
  opacity: 0.5;
  z-index: -1;
}
@media (max-width: 991.98px) {
  .work-section::after {
    display: none;
  }
}
.work-section::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;
  position: absolute;
  right: 0;
  bottom: 0;
  opacity: 0.5;
  width: 213px;
  height: 335px;
  z-index: -1;
}
@media (max-width: 991.98px) {
  .work-section::before {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .work-section {
    margin: 0;
    padding: 40px 0 20px;
  }
}

.work-img-info {
  position: relative;
}
@media (max-width: 991.98px) {
  .work-img-info {
    display: none;
  }
}
.work-img-info .work-img {
  position: absolute;
  bottom: 0;
}

.work-details {
  padding-left: 60px;
}
@media (max-width: 1199.98px) {
  .work-details {
    padding-left: 20px;
  }
}

.work-info {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: start;
  margin-bottom: 35px;
}
@media (max-width: 991.98px) {
  .work-info {
    margin-bottom: 20px;
  }
}
.work-info .work-icon {
  margin-right: 20px;
}
.work-info .work-icon span {
  min-width: 70px;
  height: 70px;
  background: #e0e7ff;
  border-radius: 10px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
  transform: rotate(0);
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
}
.work-info .work-icon span img {
  transform: rotate(0);
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.work-info:hover .work-icon span {
  background: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.work-info:hover .work-icon span img {
  transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.work-info .work-content h5 {
  font-weight: 600;
  font-size: 18px;
  color: #1f2937;
  margin-bottom: 14px;
}
@media (max-width: 767.98px) {
  .work-info .work-content h5 {
    margin-bottom: 10px;
  }
}
.work-info .work-content p {
  font-size: 16px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .work-info .work-content p {
    font-size: 14px;
  }
}

.articles-section {
  background-color: #ffffff;
  margin: 0;
  padding: 80px 0 55px;
}
@media (max-width: 991.98px) {
  .articles-section {
    margin: 0;
    padding: 40px 0 15px;
  }
}

.articles-grid {
  border: 2px solid #ededed;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 25px;
}

.articles-info .articles-left {
  margin-right: 20px;
}
.articles-info .articles-left .articles-img {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  width: 205px;
  height: 180px;
}
.articles-info .articles-left .articles-img img {
  position: relative;
  border-radius: 8px;
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  width: 100%;
}
.articles-info .articles-left .articles-img:hover img {
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}
.articles-info .articles-left .articles-img:hover::before {
  -webkit-animation: circle 1s;
  animation: circle 1s;
}
.articles-info .articles-left .articles-img::before {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  display: block;
  content: "";
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  opacity: 0;
}
@media (max-width: 1199.98px) {
  .articles-info .articles-left .articles-img {
    width: 100%;
    height: auto;
  }
}
@media (max-width: 1199.98px) {
  .articles-info .articles-left {
    margin: 0 0 20px 0;
    padding: 0;
  }
}
@media (max-width: 1199.98px) {
  .articles-info {
    display: block;
    text-align: center;
  }
}

.articles-content .articles-list {
  margin-bottom: 10px;
}
.articles-content .articles-list li {
  margin-right: 15px;
}
.articles-content .articles-list li:last-child {
  margin-right: 0;
}
.articles-content .articles-list li i {
  font-size: 18px;
  margin-right: 8px;
}
@media (max-width: 1199.98px) {
  .articles-content .articles-list {
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
  }
}
.articles-content h4 {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 10px;
  max-width: 320px;
}
@media (max-width: 991.98px) {
  .articles-content h4 {
    max-width: inherit;
  }
}
.articles-content h4 a:hover {
  color: #0e82fd;
}
.articles-content p {
  margin-bottom: 16px;
}
.articles-content .btn {
  font-weight: 500;
  font-size: 15px;
  color: #0e82fd;
  background: #ffffff;
  border: 2px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #0e82fd;
  border-radius: 6px;
  min-width: 112px;
  padding: 7px 12px;
  -webkit-transition: 0.5s;
  -ms-transition: 0.5s;
  transition: 0.5s;
}
.articles-content .btn:hover {
  color: #ffffff;
  border-color: #0e82fd;
  background: #0e82fd;
  box-shadow: inset 0 0 0 50px #0e82fd;
  -webkit-transition: 0.5s;
  -ms-transition: 0.5s;
  transition: 0.5s;
}
@media (max-width: 767.98px) {
  .articles-content .btn {
    font-size: 14px;
  }
}

.app-section {
  background-color: #ffffff;
  margin: 0;
  padding: 20px 0 80px;
}
@media (max-width: 1199.98px) {
  .app-section {
    margin: 0;
    padding: 0 0 80px;
  }
}
@media (max-width: 991.98px) {
  .app-section {
    margin: 0;
    padding: 20px 0 40px;
  }
}
@media (max-width: 767.98px) {
  .app-section {
    margin: 0;
    padding: 0px 0 40px;
  }
}

.app-bg {
  background: #0e82fd;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-position: right top;
  background-repeat: no-repeat;
  border-radius: 25px;
  padding: 40px 0 0 50px;
}
@media (max-width: 1199.98px) {
  .app-bg {
    margin: 0;
    padding: 30px;
  }
}
@media (max-width: 991.98px) {
  .app-bg {
    margin: 0;
    padding: 40px 0;
    background-image: inherit;
  }
}
@media (max-width: 767.98px) {
  .app-bg {
    margin: 0;
    padding: 30px 0;
  }
}

@media (max-width: 991.98px) {
  .app-content {
    text-align: center;
  }
}

.app-header {
  padding-bottom: 40px;
}
.app-header h5 {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .app-header h5 {
    font-size: 22px;
  }
}
@media (max-width: 767.98px) {
  .app-header h5 {
    font-size: 18px;
  }
}
.app-header h2 {
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 0;
  max-width: 565px;
}
@media (max-width: 991.98px) {
  .app-header h2 {
    font-size: 34px;
    max-width: 100%;
  }
}
@media (max-width: 767.98px) {
  .app-header h2 {
    font-size: 26px;
  }
}
@media (max-width: 991.98px) {
  .app-header {
    padding-bottom: 30px;
  }
}
@media (max-width: 767.98px) {
  .app-header {
    padding-bottom: 20px;
  }
}

.app-scan {
  padding-bottom: 40px;
}
.app-scan p {
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .app-scan {
    padding-bottom: 30px;
  }
}
@media (max-width: 767.98px) {
  .app-scan {
    padding-bottom: 20px;
  }
}

.google-imgs a {
  margin-right: 24px;
}
.google-imgs a:last-child {
  margin-right: 0;
}
@media (max-width: 767.98px) {
  .google-imgs a img {
    width: 120px;
  }
}
@media (max-width: 767.98px) {
  .google-imgs a {
    margin-right: 14px;
  }
}

.mobile-img {
  position: relative;
  bottom: 0;
}
@media (max-width: 991.98px) {
  .mobile-img {
    display: none;
  }
}
@media (max-width: 1440.98px) {
  .mobile-img img {
    max-width: 450px;
  }
}
@media (max-width: 1199.98px) {
  .mobile-img img {
    max-width: 370px;
  }
}

.faq-section {
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0 0 140px;
}
@media (max-width: 1199.98px) {
  .faq-section {
    margin: 0;
    padding: 0 0 80px;
  }
}
@media (max-width: 991.98px) {
  .faq-section {
    margin: 0;
    padding: 0 0 40px;
  }
}

.faq-img {
  position: relative;
}
@media (max-width: 991.98px) {
  .faq-img {
    text-align: center;
    margin-bottom: 80px;
  }
}
@media (max-width: 767.98px) {
  .faq-img {
    margin-bottom: 70px;
  }
}

.faq-patients-count {
  background: #ffffff;
  box-shadow:
    0px 100px 80px rgba(0, 0, 0, 0.03),
    0px 64.81px 46.85px rgba(0, 0, 0, 0.0228),
    0px 38.52px 25.48px rgba(0, 0, 0, 0.0182),
    0px 20px 13px rgba(0, 0, 0, 0.015),
    0px 8.15px 6.52px rgba(0, 0, 0, 0.0118),
    0px 1.85px 3.15px rgba(0, 0, 0, 0.0072);
  border-radius: 10px;
  padding: 15px;
  min-width: 222px;
  position: absolute;
  bottom: -40px;
  left: 50%;
  transform: translateX(-50%);
}
@media (max-width: 991.98px) {
  .faq-patients-count {
    justify-content: start;
    -webkit-justify-content: start;
    -ms-flex-pack: start;
    box-shadow: none;
    border: 1px solid #f3f3f3;
  }
}

.faq-smile-img {
  margin-right: 15px;
}

.faq-patients-content h4 {
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 3px;
}
@media (max-width: 767.98px) {
  .faq-patients-content h4 {
    font-size: 20px;
  }
}
.faq-patients-content p {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .faq-patients-content p {
    font-size: 16px;
  }
}
@media (max-width: 991.98px) {
  .faq-patients-content {
    text-align: left;
  }
}

.faq-info .accordion-item {
  background: #f8f8f8;
  border: 0;
  border-radius: 0;
  margin: 0 0 24px;
  padding: 15px;
}
.faq-info .accordion-item:last-child {
  margin-bottom: 0;
}
.faq-info .accordion-item .accordion-body {
  margin-top: 15px;
  padding: 15px 0 0;
  border-top: 1px solid #e2e8f0;
}
@media (max-width: 767.98px) {
  .faq-info .accordion-item {
    margin-bottom: 20px;
  }
}
.faq-info .accordion-header {
  position: relative;
  margin: 0;
  padding: 0;
  border: 0;
}
.faq-info .accordion-button {
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
  background: transparent;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  position: relative;
  cursor: pointer;
}
.faq-info .accordion-button:hover {
  border: 0;
}
.faq-info .accordion-button:after {
  content: "\\e9b1";
  font-family: "feather";
  font-size: 20px;
  background: none;
  color: #0e82fd;
  background: #ffffff;
  width: 32px;
  height: 32px;
  border-radius: 5px;
}
@media (max-width: 767.98px) {
  .faq-info .accordion-button:after {
    position: absolute;
    right: 0;
  }
}
.faq-info .accordion-button:not(.collapsed)::after {
  content: "\\e996";
  color: #ffffff;
  background: #0e82fd;
}
@media (max-width: 767.98px) {
  .faq-info .accordion-button {
    font-size: 14px;
    padding-right: 30px;
    line-height: 24px;
  }
}
.faq-info .accordion-content p {
  color: #6b7280;
  margin-bottom: 0;
}

.partners-section {
  background-color: #ffffff;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .partners-section {
    padding: 40px 0;
  }
}
.partners-section .owl-nav {
  display: none;
}

.partners-slider {
  list-style: none;
}
.partners-slider li a {
  background: #ffffff;
  border: 2px solid #f5f5f5;
  padding: 14px 20px;
  text-align: center;
  height: 79px;
  border-radius: 10px;
}

@media (max-width: 767.98px) {
  .partners-slider.owl-carousel .owl-item img {
    width: auto;
    margin: 0 auto;
    height: auto;
  }
}

.footer-1.footer {
  background-color: #f2f6f6;
}
.footer-1.footer .footer-top .footer-title {
  color: #1f2937;
}
.footer-1.footer .footer-top .footer-widget.footer-menu ul li a {
  color: #6b7280;
  position: relative;
  overflow: hidden;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat -20px 20px;
  -webkit-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.footer-1.footer .footer-top .footer-widget .footer-about-content p {
  color: #6b7280;
}
.footer-1.footer .footer-top .footer-widget .footer-contact-info {
  color: #6b7280;
}
.footer-1.footer .subscribe-form {
  position: relative;
}
.footer-1.footer .subscribe-form .form-control {
  font-weight: 500;
  font-size: 14px;
  min-height: 46px;
  color: #6b7280;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px 0px 0px 6px;
  margin: 0;
  padding: 6px 112px 6px 15px;
}
.footer-1.footer .subscribe-form .btn {
  font-weight: normal;
  margin: 0;
  padding: 11px 16px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 0 6px 6px 0;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

i svg {
  font-size: 16px;
  width: 16px;
}

.doctor-widget .rating i {
  padding-right: 3px;
}

.blog {
  border: 1px solid #f0f0f0;
  background-color: #ffffff;
  position: relative;
  border-radius: 4px;
  margin: 0 0 30px;
  padding: 1.5rem;
}
@media (max-width: 575.98px) {
  .blog {
    padding: 1.25rem;
  }
}
.blog .blog-image {
  margin: 0 0 30px;
  overflow: hidden;
}
.blog .blog-image img {
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
}
.blog .blog-image a:hover img {
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}
.blog .blog-title {
  font-size: 22px;
  margin: 0 0 10px;
}
@media (max-width: 767.98px) {
  .blog .blog-title {
    font-size: 20px;
  }
}
@media (max-width: 575.98px) {
  .blog .blog-title {
    font-size: 18px;
  }
}
.blog .blog-title a {
  color: #272b41;
}
.blog .blog-title a:hover {
  color: #20c0f3;
}
.blog .blog-content {
  position: relative;
}
.blog .blog-content p {
  color: #666;
  font-size: 14px;
  margin: 0 0 30px;
}
.blog .blog-content .entry-meta {
  color: #757575;
  font-size: 14px;
  list-style: none;
  margin: 0 0 15px;
  padding: 0;
}
.blog .blog-content .entry-meta li {
  display: inline-block;
  margin-right: 15px;
}
.blog .blog-content .entry-meta li:last-child {
  margin-right: 0;
}
.blog.grid-blog {
  padding: 20px;
}
.blog.grid-blog .blog-title {
  font-size: 18px;
  min-height: 43px;
  margin: 0 0 5px;
}
@media (max-width: 767.98px) {
  .blog.grid-blog .blog-title {
    min-height: inherit;
  }
}
.blog.grid-blog .blog-content p {
  margin: 0 0 15px;
}
.blog.grid-blog .blog-info {
  margin: 0 0 15px;
}
.blog.grid-blog .blog-image {
  margin: 0 0 20px;
}
.blog.grid-blog .entry-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 0 !important;
}
.blog.grid-blog .entry-meta li {
  margin: 0 0 10px;
}
.blog.grid-blog .entry-meta li:last-child {
  flex: 0 0 100px;
  max-width: 100px;
}
.blog.grid-blog .post-author {
  width: 189px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.blog.grid-blog .post-author a:hover {
  color: #20c0f3;
}

.blog-image,
.blog-image > a,
.blog-image img {
  display: block;
  position: relative;
  width: 100%;
  height: auto;
}

.read-more {
  display: inline-block;
  font-size: 16px;
  padding: 0;
  color: #20c0f3;
  text-decoration: underline;
  font-weight: 700;
}
@media (max-width: 575.98px) {
  .read-more {
    font-size: 14px;
  }
}

.blog-info {
  color: #757575;
  font-size: 14px;
  margin: 0 0 15px;
}
.blog-info a {
  color: #757575;
}
.blog-info a:hover {
  color: #757575;
}
.blog-info i {
  color: #20c0f3;
  font-size: 14px;
  margin-right: 5px;
}
@media (max-width: 575.98px) {
  .blog-info i {
    font-size: 14px;
  }
}

.blog-pagination .pagination {
  margin: 0 0 30px;
}
.blog-pagination .pagination li a {
  font-weight: 600;
  color: #2e3842;
  border-radius: inherit !important;
  border-color: #f0f0f0;
  margin: 0 10px 0 0;
  padding: 12px 20px;
}
.blog-pagination .pagination li.disabled a {
  border-color: #f0f0f0;
}
.blog-pagination .pagination li.active a {
  background: #20c0f3;
  border-color: transparent;
  color: #ffffff;
}

.post-left ul {
  list-style: none;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}
.post-left ul li {
  margin-bottom: 5px;
  margin-right: 20px;
}
@media (max-width: 575.98px) {
  .post-left ul li {
    margin-right: 10px;
  }
}
.post-left ul li:last-child {
  margin-right: 0;
}
@media (max-width: 575.98px) {
  .post-left ul li:last-child {
    margin-right: 10px;
  }
}

.post-author a {
  display: flex;
  align-items: center;
}

.video {
  position: relative;
  padding-bottom: 56%;
  height: 0;
  overflow: hidden;
}
.video iframe,
.video object,
.video embed {
  width: 100%;
  height: 100%;
  border: none;
  position: absolute;
  top: 0;
  left: 0;
}

.latest-posts {
  margin: 0;
  padding: 0;
}
.latest-posts li {
  display: table;
  width: 100%;
  margin: 0 0 20px;
}
.latest-posts li:last-child {
  padding-bottom: 0px;
  margin-bottom: 0px;
  border-bottom: none;
}

.post-thumb {
  width: 80px;
  float: left;
  overflow: hidden;
  border-radius: 4px;
}
.post-thumb a img {
  border-radius: 4px;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
}
.post-thumb a:hover img {
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}

.post-info {
  margin-left: 95px;
}
.post-info h4 {
  font-size: 15px;
  margin: 0 0 5px;
}
.post-info h4 a {
  color: #272b41;
}
.post-info h4 a:hover {
  color: #20c0f3;
}
.post-info p {
  color: #757575;
  font-size: 12px;
  margin: 0;
}
.post-info p i {
  color: #20c0f3;
  font-size: 14px;
  margin-right: 4px;
}

.category-widget .categories {
  list-style: none;
  margin: 0;
  padding: 0;
}
.category-widget .categories li {
  margin: 0 0 20px;
}
.category-widget .categories li:last-child {
  border-bottom: none;
  margin: 0;
  padding: 0;
}
.category-widget .categories li a {
  color: #2e3842;
  font-size: 15px;
  font-weight: 500;
}
.category-widget .categories li a span {
  float: right;
  color: #757575;
}
.category-widget .categories li a:hover {
  color: #20c0f3;
}

.category-widget .categories > li > a > i {
  color: #20c0f3;
  font-size: 18px;
  margin-right: 10px;
}

.tags-widget .card-body {
  padding-bottom: 1rem;
}

.tags {
  list-style: none;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
.tags li {
  float: left;
}

.tag {
  background-color: #ffffff;
  color: #272b41;
  position: relative;
  font-size: 14px;
  border: 1px solid #cccccc;
  display: inline-block;
  border-radius: 4px;
  margin: 0 0.5rem 0.5rem 0;
  padding: 5px 10px;
}
.tag:hover {
  background-color: #20c0f3;
  border-color: #20c0f3;
  color: #ffffff;
}

.comment-by {
  display: block;
  font-size: 14px;
  line-height: 21px;
  margin: 0 0 10px;
}

.comments-list .comment-block p {
  font-size: 14px;
  margin: 0 0 5px;
}

/*-----------------
	Blog Details
-----------------------*/
.blog-view .blog-title {
  font-size: 24px;
}
@media (max-width: 767.98px) {
  .blog-view .blog-title {
    font-size: 22px;
  }
}
@media (max-width: 575.98px) {
  .blog-view .blog-title {
    font-size: 20px;
  }
}
.blog-view .blog-info {
  border: 0;
  margin: 0 0 20px;
  padding: 0;
}

.blog-content p:last-child {
  margin: 0;
}

.social-share {
  float: left;
  list-style: none;
  margin: 0;
  padding: 0;
}
.social-share > li {
  display: inline-block;
  float: left;
  margin-left: 10px;
  text-align: center;
}
.social-share > li:first-child {
  margin-left: 0;
}
.social-share > li a:hover {
  background-color: #20c0f3;
  color: #ffffff;
  border-color: #20c0f3;
}
.social-share > li > a {
  border: 1px solid #dfdfdf;
  color: #666;
  display: inline-block;
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  width: 40px;
}

.blog-reply > a {
  color: #999;
  font-size: 12px;
  font-weight: 500;
}

.blog-date {
  color: #999;
  font-size: 12px;
}

.blog-comments .comments-list {
  list-style: none;
  position: relative;
  margin: 0;
  padding: 0;
}
.blog-comments .comments-list li {
  clear: both;
  padding-left: 80px;
}
@media (max-width: 575.98px) {
  .blog-comments .comments-list li {
    padding: 10px 0 0 50px;
  }
}
.blog-comments .comments-list li .comment {
  margin: 0 0 20px;
}
.blog-comments .comments-list li .comment-author {
  position: absolute;
  left: 0;
}
.blog-comments .comments-list li img.avatar {
  height: 58px;
  width: 58px;
  border-radius: 58px;
}
@media (max-width: 575.98px) {
  .blog-comments .comments-list li img.avatar {
    height: 40px;
    width: 40px;
    border-radius: 40px;
  }
}
.blog-comments .comment-btn {
  color: #20c0f3;
  display: inline-block;
  font-weight: 500;
  font-size: 15px;
}

.blog-author-name {
  color: #272b41;
  font-size: 16px;
  font-weight: 600;
}

.new-comment label {
  font-weight: 500;
}

.comment-submit .btn {
  background-color: #20c0f3;
  border-color: #20c0f3;
  font-size: 18px;
  padding: 8px 26px;
  color: #ffffff;
  border-radius: 0;
}

.about-author-img {
  background-color: #ffffff;
  height: 100px;
  overflow: hidden;
  position: absolute;
  width: 100px;
}
@media (max-width: 575.98px) {
  .about-author-img {
    height: 60px;
    width: 60px;
  }
}

.author-details {
  margin: 0 0 0 120px;
}
@media (max-width: 575.98px) {
  .author-details {
    margin-left: 80px;
  }
}
.author-details .blog-author-name {
  display: inline-block;
  margin: 0 0 10px;
}

.about-author {
  min-height: 100px;
}

.post-author img {
  width: 28px;
  margin-right: 5px;
  border-radius: 100%;
}

.blogs-section {
  padding: 50px 0;
  background-color: #ffffff;
}
@media (max-width: 767.98px) {
  .blogs-section {
    padding: 30px 0;
  }
}
.blogs-section .blog-wrapper {
  background: #ffffff;
  border: 1px solid #e8eeff;
  box-sizing: border-box;
  border-radius: 10px 10px 0px 0px;
  margin-bottom: 30px;
}
.blogs-section .blog-wrapper .wrap-image img {
  width: 100%;
  border-radius: 10px 10px 0px 0px;
}
.blogs-section .blog-wrapper .wrap-content {
  padding: 10px;
}
.blogs-section .blog-wrapper .wrap-content .sp-title {
  font-size: 13px;
  color: #2264c5;
  font-weight: 600;
  margin-right: 5px;
}
.blogs-section .blog-wrapper .wrap-content .post-author a {
  display: flex;
  align-items: center;
}
.blogs-section .blog-wrapper .wrap-content .post-author a img {
  width: 20px;
  flex: 0 0 20px;
  margin: 0 5px;
}
.blogs-section .blog-wrapper .wrap-content .post-author a span {
  font-size: 12px;
  font-weight: 600;
  color: #000000;
}
.blogs-section .blog-wrapper .wrap-content .date-cart {
  background-color: #1860ca;
  font-size: 28px;
  color: #ffffff;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  width: 65px;
  height: 60px;
  flex-direction: column;
  position: absolute;
  right: 25px;
  margin: -40px 0 0;
  padding: 10px 8px;
}
@media (max-width: 991.98px) {
  .blogs-section .blog-wrapper .wrap-content .date-cart {
    font-size: 26px;
  }
}
@media (max-width: 767.98px) {
  .blogs-section .blog-wrapper .wrap-content .date-cart {
    font-size: 22px;
    width: 60px;
    height: 55px;
    padding: 5px;
  }
}
.blogs-section .blog-wrapper .wrap-content .date-cart span {
  font-size: 11px;
  font-weight: 500;
}
@media (max-width: 767.98px) {
  .blogs-section .blog-wrapper .wrap-content .date-cart span {
    font-size: 10px;
  }
}
.blogs-section .blog-wrapper .wrap-content-body {
  margin-top: 10px;
}
@media (max-width: 767.98px) {
  .blogs-section .blog-wrapper .wrap-content-body h3 {
    font-size: 17px;
  }
}
.blogs-section .blog-wrapper .wrap-content-body h3 a {
  font-size: 18px;
  font-weight: 500;
  color: #000000;
  line-height: 1.5;
}
@media (max-width: 767.98px) {
  .blogs-section .blog-wrapper .wrap-content-body h3 a {
    font-size: 17px;
  }
}
.blogs-section .blog-wrapper .wrap-content-body p {
  font-size: 12px;
  color: #000000;
}
.blogs-section .blog-wrapper .wrap-content-body a.read-txt {
  width: 110px;
  padding: 10px;
  background: #0ce0ff;
  border-radius: 30px;
  display: block;
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
}
.blogs-section .blog-wrapper .wrap-content-body a.read-txt:hover {
  background-color: #0e82fd;
}
.blogs-section .view-btn {
  background-color: #20c0f3;
  font-size: 16px;
  color: #ffffff;
  font-weight: 700;
  border-radius: 30px;
  border: 1px solid #20c0f3;
  padding: 6px 20px;
}
@media (max-width: 767.98px) {
  .blogs-section .view-btn {
    font-size: 14px;
  }
}
.blogs-section .view-btn:hover {
  background-color: #0e82fd;
  border: 1px solid #0e82fd;
}

.our-blog-section {
  padding: 60px 0;
  background: #ffffff;
}
@media (max-width: 991.98px) {
  .our-blog-section {
    padding: 40px 0;
  }
}
@media (max-width: 767.98px) {
  .our-blog-section {
    padding: 30px 0;
  }
}
.our-blog-section .our-blogs {
  display: block;
  transition: 0.6s;
  border-radius: 10px 10px 0px 0px;
  overflow: hidden;
}
.our-blog-section .our-blogs .blogs-img {
  position: relative;
  transition: 0.6s;
}
.our-blog-section .our-blogs .blogs-img .blogs-overlay {
  align-items: center;
  background: #ffffff;
  border-radius: 30px 0px 0px 30px;
  padding: 5px;
  position: absolute;
  right: 0;
  bottom: 10px;
  transition: 0.6s;
}
.our-blog-section .our-blogs .blogs-img .blogs-overlay img {
  height: 35px;
  width: 35px !important;
  border-radius: 50%;
  margin-right: 10px;
}
.our-blog-section .our-blogs .blogs-img .blogs-overlay .blogs-writter {
  display: none;
}
.our-blog-section .our-blogs .blogs-info {
  background: #ffffff;
  border: 1px solid #e8eeff;
  padding: 15px;
}
.our-blog-section .our-blogs .blogs-info span {
  color: #20c0f3;
}
.our-blog-section .our-blogs .blogs-info h4 {
  color: #000000;
  line-height: 28px;
}
.our-blog-section .our-blogs .blogs-info h4:hover {
  color: #1c5b91;
}
.our-blog-section .our-blogs .blogs-info p {
  font-size: 13px;
}
.our-blog-section .our-blogs .blogs-nav {
  border: 1px solid #e8eeff;
  padding: 10px;
  border-top: 0;
}
.our-blog-section .our-blogs .blogs-nav .blogs-btn {
  background: #1c5b90;
  border-radius: 30px;
  color: #ffffff;
  padding: 8px 10px;
  display: block;
  width: 110px;
  text-align: center;
  font-size: 12px;
}
.our-blog-section .our-blogs .blogs-nav .blogs-btn:hover {
  background-color: #0e82fd;
}
.our-blog-section .our-blogs:hover .blogs-img .blogs-overlay .blogs-writter {
  display: block;
}

.blogs-time {
  color: #17418e !important;
}

.booking-doc-info .booking-doc-img {
  width: 80px;
  margin-right: 15px;
}
@media (max-width: 767.98px) {
  .booking-doc-info .booking-doc-img {
    width: 75px;
  }
}
@media (max-width: 575.98px) {
  .booking-doc-info .booking-doc-img {
    width: 70px;
  }
}
.booking-doc-info .booking-doc-img img {
  height: 80px;
  width: 80px;
  object-fit: cover;
  border-radius: 4px;
}
@media (max-width: 767.98px) {
  .booking-doc-info .booking-doc-img img {
    height: 75px;
    width: 75px;
  }
}
@media (max-width: 575.98px) {
  .booking-doc-info .booking-doc-img img {
    height: 70px;
    width: 70px;
  }
}

.schedule-widget {
  min-height: 100px;
  border-radius: 4px;
}
.schedule-widget .schedule-header {
  border-bottom: 1px solid #f0f0f0;
  padding: 10px 20px;
  border-radius: 4px 4px 0 0;
}
.schedule-widget .schedule-header h4 {
  font-size: 18px;
  font-weight: 600;
  margin: 3px 0 0;
}

.day-slot ul {
  float: left;
  list-style: none;
  position: relative;
  width: 100%;
  margin: auto -5px 0 -5px;
  padding: 0;
}
.day-slot ul li {
  float: left;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
  width: 14.28%;
}
.day-slot ul li span {
  display: block;
  font-size: 18px;
  text-transform: uppercase;
}
@media (max-width: 767.98px) {
  .day-slot ul li span {
    font-size: 16px;
    text-transform: unset;
  }
}
.day-slot ul li span.slot-date {
  display: block;
  color: #757575;
  font-size: 14px;
}
.day-slot ul li small.slot-year {
  color: #757575;
  font-size: 14px;
}
@media (max-width: 767.98px) {
  .day-slot ul li small.slot-year {
    display: none;
  }
}
.day-slot ul li.left-arrow {
  text-align: center;
  width: 20px !important;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  left: 0;
  padding: 0;
}
@media (max-width: 991.98px) {
  .day-slot ul li.left-arrow {
    left: -10px;
  }
}
.day-slot ul li.right-arrow {
  text-align: center;
  width: 20px !important;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: -11px;
  padding: 0;
}

.schedule-cont {
  padding: 20px;
}

.time-slot ul {
  list-style: none;
  margin: auto -5px 0 -5px;
  padding: 0;
}
.time-slot ul li {
  float: left;
  padding-left: 5px;
  padding-right: 5px;
  width: 14.28%;
}
.time-slot ul li .timing {
  background-color: #e9e9e9;
  border: 1px solid #e9e9e9;
  border-radius: 3px;
  color: #757575;
  display: block;
  font-size: 14px;
  margin-bottom: 10px;
  padding: 5px 5px;
  text-align: center;
  position: relative;
}
.time-slot ul li .timing:hover {
  background-color: #ffffff;
}
.time-slot ul li .timing:last-child {
  margin-bottom: 0;
}
.time-slot ul li .timing.selected {
  background-color: #42c0fb;
  border: 1px solid #42c0fb;
  color: #ffffff;
}
.time-slot ul li .timing.selected::before {
  color: #ffffff;
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-size: 12px;
  font-weight: 900;
  position: absolute;
  top: 6px;
  right: 6px;
}
@media (max-width: 991.98px) {
  .time-slot ul li .timing.selected::before {
    display: none;
  }
}

.schedule-list {
  border-bottom: 1px solid #cfcfcf;
  margin-bottom: 50px;
  padding-bottom: 50px;
}
.schedule-list:last-child {
  border-bottom: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}

.submit-section.proceed-btn {
  margin: 0 0 30px;
}
@media (max-width: 767.98px) {
  .submit-section.proceed-btn {
    margin-bottom: 20px;
  }
}

.tab-content.schedule-cont .card-title {
  margin-bottom: 10px;
}

.doc-slot-list {
  background-color: #d9534f;
  border: 1px solid #d43f3a;
  color: #ffffff;
  font-size: 14px;
  margin: 10px 10px 0 0;
  padding: 6px 15px;
  border-radius: 4px;
}
.doc-slot-list a {
  color: #e48784;
  display: inline-block;
  margin-left: 5px;
}
.doc-slot-list a:hover {
  color: #ffffff;
}

.schedule-nav .nav-tabs {
  border: 0 !important;
}
.schedule-nav .nav-tabs li {
  display: inline-block;
  margin: 5px 15px 5px 0;
}
@media (max-width: 479.98px) {
  .schedule-nav .nav-tabs li {
    display: block;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    margin-right: 0;
  }
}
.schedule-nav .nav-tabs li:last-child {
  margin-right: 0;
}
.schedule-nav .nav-tabs li a.active {
  background: #ff4877;
  border: 1px solid #ff4877 !important;
  color: #ffffff;
}
.schedule-nav .nav-tabs > li > a {
  border: 1px solid #dcddea;
  text-transform: uppercase;
  border-radius: 4px;
  padding: 6px 15px;
}

.hours-info .form-control {
  min-height: auto;
}
.hours-info .btn.btn-danger.trash {
  height: 38px;
  width: 100%;
}

.add-more a {
  color: #20c0f3;
}

.edit-link {
  color: #20c0f3;
  font-size: 16px;
  margin-top: 4px;
}
@media (max-width: 575.98px) {
  .edit-link {
    font-size: 14px;
    margin-top: 2px;
  }
}

.submit-section .submit-btn {
  padding: 12px 30px;
  font-weight: 600;
  font-size: 16px;
  min-width: 120px;
}
@media (max-width: 767.98px) {
  .submit-section .submit-btn {
    padding: 10px 20px;
    font-size: 15px;
    min-width: 105px;
  }
}

.success-card .card-body {
  padding: 50px 20px;
}

.success-cont {
  text-align: center;
}
.success-cont i {
  color: #ffffff;
  width: 60px;
  height: 60px;
  border: 2px solid #09e5ab;
  font-size: 30px;
  margin-bottom: 30px;
  background-color: #09e5ab;
  border-radius: 50%;
}
.success-cont h3 {
  font-size: 24px;
}
@media (max-width: 767.98px) {
  .success-cont h3 {
    font-size: 22px;
  }
}
.success-cont p {
  margin-bottom: 30px;
}
.success-cont strong {
  font-weight: 700;
}

@media (max-width: 575.98px) {
  .booking-schedule.schedule-widget {
    overflow-x: auto;
  }
}
@media (max-width: 575.98px) {
  .booking-schedule.schedule-widget > div {
    width: 730px;
  }
}
@media (max-width: 575.98px) {
  .booking-schedule .day-slot ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
}
@media (max-width: 575.98px) {
  .booking-schedule .day-slot ul li {
    -ms-flex: 0 0 100px;
    flex: 0 0 100px;
    width: 100px;
  }
}
@media (max-width: 575.98px) {
  .booking-schedule .day-slot ul li.right-arrow {
    right: -20px;
  }
}
@media (max-width: 575.98px) {
  .booking-schedule .time-slot ul {
    display: flex;
  }
}
@media (max-width: 575.98px) {
  .booking-schedule .time-slot ul li {
    -ms-flex: 0 0 100px;
    flex: 0 0 100px;
    width: 100px;
  }
}
@media (max-width: 767.98px) {
  .booking-schedule .time-slot ul li .timing span {
    display: block;
  }
}
@media (max-width: 575.98px) {
  .booking-schedule .time-slot ul li .timing span {
    display: inline-block;
  }
}

.visits .visit-btns {
  color: #272b41;
  background-color: #ffffff;
  width: 80%;
  margin-bottom: 10px;
  display: block;
  outline: unset;
  cursor: pointer;
}
.visits input:checked ~ .visit-rsn {
  background-color: #09e5ab;
  color: #ffffff;
  border-radius: 4px;
}
.visits input:checked ~ .visit-rsn:before {
  opacity: 1;
}
.visits input:disabled ~ .visit-rsn {
  background-color: #e30303;
  color: #ffffff;
  border-radius: 5px;
}
.visits input.form-check-input {
  opacity: 0;
  visibility: hidden;
  margin-left: 0;
  position: absolute;
  top: 0;
  left: 0;
}
.visits .form-check-input {
  opacity: 0;
}
.visits span.visit-rsn {
  background: #f3f9ff;
  border: 0;
  border-radius: 5px;
  color: #64627c;
  display: inline-block;
  font-size: 14px;
  margin-bottom: 0px;
  text-align: center;
  position: relative;
  font-weight: 600;
  min-width: 133px;
  width: 100%;
  padding: 13px 5px;
}
.visits span.visit-rsn:before {
  color: #09e5ab;
  background-color: #ffffff;
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-size: 10px;
  font-weight: 900;
  border-radius: 50px;
  width: 18px;
  height: 18px;
  opacity: 0;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}

.back-link {
  padding-bottom: 30px;
}
.back-link a {
  font-size: 15px;
  color: #959595;
}
.back-link a:hover {
  color: #09e5ab;
}
.back-link a i {
  margin-right: 10px;
}
@media (max-width: 767.98px) {
  .back-link {
    padding-bottom: 25px;
  }
}

.booking-header {
  padding-bottom: 25px;
}
.booking-header .booking-title {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .booking-header {
    padding-bottom: 20px;
  }
}

.booking-date.choose-date-book {
  padding-bottom: 30px;
}
.booking-date.choose-date-book p {
  color: #8c8c8c;
  margin: 0 10px 0 0;
  padding: 0;
  margin-right: 10px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .booking-date.choose-date-book p {
    margin: 0 0 10px 0;
    padding: 0;
  }
}
@media (max-width: 767.98px) {
  .booking-date.choose-date-book {
    display: block;
    padding-bottom: 20px;
  }
}

.booking-date-slider {
  padding-bottom: 30px;
}

.booking-range .btn {
  background: #ffffff;
  border: 1px solid #e4e4e8;
  border-radius: 6px;
  font-size: 14px;
  font-weight: normal;
  color: #4a4a4a;
  margin: 0;
  padding: 10px 15px;
}
@media (max-width: 767.98px) {
  .booking-range .btn {
    font-size: 13px;
    margin: 0;
    padding: 10px;
    position: relative;
  }
}
.booking-range img {
  margin-right: 10px;
}
.booking-range i {
  font-size: 16px;
  margin-left: 10px;
  color: #5b5b5b;
}

.booking-device-img {
  margin-right: 15px;
}
.booking-device-img img {
  max-width: inherit;
}

.booking-doctor-info h3 {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 5px;
}
.booking-doctor-info .device-text {
  margin-bottom: 12px;
}
.booking-doctor-info .btn {
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  padding: 4px 10px;
  min-width: 109px;
  color: #0e82fd;
  background: #ffffff;
  border: 2px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #0e82fd;
  border-radius: 6px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.booking-doctor-info .btn:hover {
  color: #ffffff;
  background: #0e82fd;
  box-shadow: inset 0 0 0 50px #0e82fd;
  border: 2px solid #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}

.time-slot.time-slot-blk {
  text-align: center;
}
.time-slot.time-slot-blk h4 {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 20px;
}
.time-slot.time-slot-blk ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.time-slot.time-slot-blk ul li {
  display: block;
  margin-bottom: 15px;
  float: inherit;
  width: 100%;
}
.time-slot.time-slot-blk li:last-child {
  margin-bottom: 0;
}
.time-slot.time-slot-blk li .timing {
  background: #f5f5f5;
  border: 2px solid #f3f3f3;
  border-radius: 8px;
  color: #595959;
  margin: 0;
  padding: 10px 15px;
  text-align: center;
  position: relative;
  box-shadow: inset 0 0 0 0 #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.time-slot.time-slot-blk li .timing:hover {
  background: #ffffff;
  box-shadow: inset 0 0 0 50px #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.time-slot.time-slot-blk li .timing.active {
  background: #0e82fd;
  border: 2px solid #0e82fd;
  color: #ffffff;
  box-shadow: inset 0 0 0 0 #0e82fd;
}
.time-slot.time-slot-blk li .timing.active:hover {
  background: #0e82fd;
  border: 2px solid #0e82fd;
  color: #ffffff;
  box-shadow: inset 0 0 0 50px #0e82fd;
}
.time-slot.time-slot-blk li .timing i {
  margin-right: 4px;
}
.time-slot.time-slot-blk li .load-more-timings a {
  font-weight: 500;
  text-decoration: underline;
  color: #0e82fd;
}
.time-slot.time-slot-blk li .load-more-timings a:hover {
  color: #000000;
}
.time-slot.time-slot-blk .time-slot-open {
  display: none;
}
@media (max-width: 991.98px) {
  .time-slot.time-slot-blk {
    padding-bottom: 15px;
  }
}

.date-slider {
  text-align: center;
  list-style: none;
  margin: 0;
  padding: 0;
}
.date-slider .slick-slide {
  display: block;
  margin: 0;
  padding: 0 5px;
}
.date-slider li h4 {
  font-weight: 500;
  font-size: 16px;
  color: #b9b9b9;
  margin-bottom: 5px;
}
@media (max-width: 1199.98px) {
  .date-slider li h4 {
    font-size: 13px;
  }
}
@media (max-width: 991.98px) {
  .date-slider li h4 {
    font-size: 16px;
  }
}
.date-slider li p {
  color: #d4d4d4;
  margin-bottom: 0;
}
.date-slider li.active h4 {
  color: #000000;
}
.date-slider li.active p {
  color: #aaaaaa;
}
.date-slider .slick-prev:before {
  content: " \\e92f";
}
.date-slider .slick-next:before {
  content: " \\e930";
}

.date-slider .slick-prev,
.date-slider .slick-next {
  background: transparent;
  color: #000000;
  line-height: normal;
  box-shadow: none;
  width: 30px;
  height: 30px;
}

.date-slider .slick-prev:hover,
.date-slider .slick-prev:focus,
.date-slider .slick-next:hover,
.date-slider .slick-next:focus {
  background-color: transparent;
  color: #09e5ab;
  opacity: 1;
}

.date-slider .slick-prev:hover:before,
.date-slider .slick-prev:focus:before,
.date-slider .slick-next:hover:before,
.date-slider .slick-next:focus:before {
  color: #09e5ab;
}

.date-slider .slick-prev:before,
.date-slider .slick-next:before {
  font-family: "feather";
  font-size: 26px;
}

.date-slider .slick-prev {
  left: -12px;
}

.date-slider .slick-next {
  right: -12px;
}

.content.content-space {
  padding: 80px 0px;
}
@media (max-width: 991.98px) {
  .content.content-space {
    padding: 50px 0px;
  }
}

.prime-btn {
  background-color: #0e82fd;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #ffffff;
}
.prime-btn:hover {
  color: #0e82fd;
  background-color: #ffffff;
  border-color: #0e82fd;
  box-shadow: inset 0 0 0 50px #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.prime-btn:hover i {
  color: #0e82fd;
}

.attachment-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  background: #ffffff;
  border: 1px solid #e4e4e8;
  border-radius: 8px;
  padding: 6px 15px;
}

.attachment-img {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.attachment-icon {
  font-size: 24px;
  color: #9d9d9d;
  margin-right: 12px;
}

.attachment-content p {
  color: #54595e;
  margin-bottom: 0;
}
.attachment-content span {
  font-size: 12px;
  color: #54595e;
}

.attachment-close a {
  font-size: 22px;
  color: #abb5be;
}
.attachment-close a:hover {
  color: #0e82fd;
}

.paitent-appointment .form-group {
  margin-bottom: 25px;
}
.paitent-appointment .form-group .form-group-title {
  font-weight: 500;
  margin-bottom: 10px;
  display: block;
}
.paitent-appointment .form-group .form-group-title i {
  font-size: 16px;
}
.paitent-appointment .form-group .form-group-title span {
  font-weight: 400;
  font-size: 12px;
  color: #a3a3a3;
}
.paitent-appointment .form-group .custom_radio {
  margin-bottom: 0;
  padding-left: 25px;
}
.paitent-appointment .form-control::placeholder {
  font-weight: 500;
  color: #9e9e9e;
}
.paitent-appointment textarea.form-control {
  resize: none;
  min-height: 100px;
}
.paitent-appointment .characters-text {
  font-size: 12px;
  color: #9e9e9e;
  text-align: right;
  margin-top: 8px;
  margin-bottom: 0;
}

.form-group-flex .btn {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 14px;
  color: #292929;
  padding: 3px 5px;
  margin-bottom: 10px;
  min-width: 60px;
  background: #e0efff;
  border: 1px solid #e0efff;
  border-radius: 4px;
  box-shadow: inset 0 0 0 0 #0e82fd;
  -webkit-transition: 0.7s;
  -moz-transition: 0.7s;
  -o-transition: 0.7s;
  transition: 0.7s;
}
.form-group-flex .btn:hover {
  color: #ffffff;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 50px #0e82fd;
  -webkit-transition: 0.7s;
  -moz-transition: 0.7s;
  -o-transition: 0.7s;
  transition: 0.7s;
}
.form-group-flex .btn i {
  font-size: 16px;
  margin-right: 2px;
}

.widget-profile {
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
}
.widget-profile .profile-info-widget {
  display: block !important;
  text-align: center !important;
}
.widget-profile .profile-info-widget .booking-doc-img {
  display: inline-block;
  width: auto;
  background-color: #f7f7f7;
  margin: 0 0 15px !important;
  padding: 8px;
  border-radius: 50%;
}
.widget-profile .profile-info-widget .booking-doc-img img {
  height: 120px !important;
  width: 120px !important;
  border-radius: 50% !important;
}
.widget-profile.pat-widget-profile .profile-info-widget .booking-doc-img {
  padding: 0;
}
.widget-profile.pat-widget-profile .profile-info-widget .booking-doc-img img {
  height: 100px !important;
  width: 100px !important;
  border-radius: 50%;
}

.appointment-list .profile-info-widget {
  margin-right: auto;
  text-align: left;
}
@media (max-width: 479.98px) {
  .appointment-list .profile-info-widget {
    text-align: center;
    -ms-flex-direction: column;
    flex-direction: column;
  }
}
@media (max-width: 479.98px) {
  .appointment-list .profile-info-widget .booking-doc-img {
    margin: 0 0 15px;
  }
}
.appointment-list .profile-info-widget .booking-doc-img img {
  height: 120px;
  object-fit: cover;
  width: 120px;
  border-radius: 4px;
}
@media (max-width: 479.98px) {
  .appointment-list .profile-info-widget .booking-doc-img img {
    height: 100px;
    width: 100px;
    border-radius: 50%;
  }
}
@media (max-width: 479.98px) {
  .appointment-list .profile-det-info {
    margin-bottom: 15px;
  }
}

.appointments .appointment-list {
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  margin: 0 0 20px;
  padding: 20px;
  border-radius: 4px;
}
.appointments .appointment-list:last-child {
  margin-bottom: 30px;
}
@media (max-width: 991.98px) {
  .appointments .appointment-list {
    display: block;
  }
}
@media (max-width: 479.98px) {
  .appointments .appointment-list {
    text-align: center;
  }
}
@media (max-width: 479.98px) {
  .appointments .appointment-list .profile-det-info {
    margin-bottom: 15px;
  }
}
@media (max-width: 991.98px) {
  .appointments .appointment-action {
    margin-top: 10px;
  }
}
@media (max-width: 479.98px) {
  .appointments .appointment-action {
    margin-top: 0;
  }
}
.appointments .appointment-action a {
  font-size: 13px;
}
.appointments .appointment-action a + a {
  margin-left: 5px;
}

.info-details {
  list-style: none;
  margin: 0;
  padding: 0;
}
.info-details li {
  margin-bottom: 10px;
}
.info-details li:last-child {
  margin-bottom: 0;
}
.info-details li .title {
  color: #272b41;
  font-weight: 500;
}
.info-details li .text {
  color: #757575;
  display: block;
  font-size: 16px;
  overflow: hidden;
}

.clinic-direction {
  color: #757575;
  font-size: 14px;
  margin-bottom: 25px;
}
.clinic-direction a {
  color: #09e5ab;
  font-weight: 500;
}

.doctor-action {
  margin-bottom: 15px;
}
@media (max-width: 767.98px) {
  .doctor-action {
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
  }
}
.doctor-action a + a {
  margin-left: 8px;
}
.doctor-action .fav-btn:hover {
  background-color: #fb1612;
  border-color: #fb1612;
  color: #ffffff;
}

.msg-btn:hover,
.msg-btn:focus {
  background-color: #09e5ab;
  border-color: #09e5ab;
  color: #ffffff;
}

call-btn:hover,
call-btn:focus {
  background-color: #09e5ab;
  border-color: #09e5ab;
  color: #ffffff;
}

@media (max-width: 767.98px) {
  .user-tabs {
    margin-top: 1.5rem;
  }
}
@media (max-width: 767.98px) {
  .user-tabs .nav-tabs {
    border-bottom: 0;
    position: relative;
    background-color: #ffffff;
    padding: 5px 0;
    border: 1px solid #dddddd;
    border-radius: 3px;
  }
}
.user-tabs .nav-tabs > li > a {
  border: 0;
  border-bottom: 3px solid transparent;
  color: #3e3e3e;
  font-weight: 700;
  padding: 20px;
}
.user-tabs .nav-tabs > li > a:hover {
  background-color: unset;
  color: #20c0f3;
}
@media (max-width: 767.98px) {
  .user-tabs .nav-tabs > li > a {
    border-left: 2px solid transparent;
    border-bottom: 0;
    padding: 0.5rem 1rem;
  }
}
@media (max-width: 767.98px) {
  .user-tabs .nav-tabs.nav-justified {
    border-bottom: 1px solid #dddddd;
  }
}
@media (max-width: 767.98px) {
  .user-tabs .nav-tabs .nav-item {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
  }
}
@media (max-width: 479.98px) {
  .user-tabs .nav-tabs .nav-item {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
  }
}
.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active,
.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:hover,
.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:focus {
  border-bottom-width: 3px;
  color: #20c0f3;
}
@media (max-width: 767.98px) {
  .user-tabs .nav-tabs.nav-tabs-bottom > li > a.active,
  .user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:hover,
  .user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:focus {
    border-left-width: 2px;
    color: #20c0f3;
  }
}
.user-tabs .med-records {
  display: inline-block;
  min-width: 130px;
}
@media (max-width: 575.98px) {
  .user-tabs .med-records {
    min-width: 110px;
  }
}

.widget {
  margin-bottom: 30px;
}

.widget-title {
  margin-bottom: 15px;
}

.experience-box {
  position: relative;
}

.experience-list {
  list-style: none;
  position: relative;
  margin: 0;
  padding: 0;
}
.experience-list::before {
  background: #dddddd;
  bottom: 0;
  content: "";
  width: 2px;
  position: absolute;
  top: 8px;
  left: 8px;
}
.experience-list li {
  position: relative;
}
.experience-list li:last-child .experience-content {
  margin-bottom: 0;
}
.experience-list > li .experience-user {
  background: #ffffff;
  height: 10px;
  width: 10px;
  position: absolute;
  top: 4px;
  left: 4px;
  margin: 0;
  padding: 0;
}
.experience-list > li .experience-content {
  background-color: #ffffff;
  position: relative;
  margin: 0 0 20px 40px;
  padding: 0;
}
.experience-list > li .experience-content .timeline-content {
  color: #757575;
}
.experience-list > li .experience-content .timeline-content a.name {
  font-weight: 500;
}
.experience-list > li .time {
  color: #757575;
  display: block;
  font-size: 13px;
}

.experience-user .avatar {
  height: 32px;
  line-height: 32px;
  width: 32px;
  margin: 0;
}

.before-circle {
  background-color: rgba(32, 192, 243, 0.2);
  height: 12px;
  width: 12px;
  border: 2px solid #20c0f3;
  border-radius: 50%;
}

.exp-year {
  color: #20c0f3;
  margin-bottom: 2px;
}

.exp-title {
  font-size: 16px;
}
@media (max-width: 767.98px) {
  .exp-title {
    font-size: 14px;
  }
}

.awards-widget .experience-list > li:last-child p {
  margin-bottom: 0;
}

.service-list {
  margin-bottom: 30px;
}
.service-list:last-child {
  border-bottom: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}
.service-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.service-list ul li {
  float: left;
  padding-left: 25px;
  position: relative;
  width: 33%;
  margin: 6px 0;
}
@media (max-width: 767.98px) {
  .service-list ul li {
    width: 50%;
  }
}
@media (max-width: 575.98px) {
  .service-list ul li {
    width: 100%;
  }
}
.service-list ul li::before {
  color: #cccccc;
  content: "\\f30b";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  position: absolute;
  left: 0;
}

.location-list {
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 20px;
}
.location-list + .location-list {
  margin-top: 20px;
}
.location-list .consult-price {
  font-size: 20px;
  font-weight: 500;
  color: #272b41;
}

.clinic-content .clinic-name {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 3px;
}
.clinic-content .clinic-direction a {
  display: inline-block;
  margin-top: 8px;
}

.timings-days {
  font-weight: 700;
  color: #272b41;
  margin-bottom: 5px;
}

.timings-times span {
  display: block;
}
.timings-times span:last-child {
  margin-bottom: 1rem;
}

.review-listing {
  border-bottom: 1px solid #f5f7fc;
  margin-top: 20px;
  padding-bottom: 30px;
}
.review-listing > ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.review-listing > ul li + li {
  margin-top: 20px;
  border-top: 1px dashed #f0f0f0;
  padding-top: 20px;
}
.review-listing > ul li .comment {
  margin-bottom: 30px;
}
.review-listing > ul li .comment:last-child {
  margin-bottom: 0;
}
.review-listing > ul li .comment .comment-body {
  margin-left: 16px;
}
.review-listing > ul li .comment .comment-body .meta-data {
  position: relative;
  margin-bottom: 10px;
}
.review-listing > ul li .comment .comment-body .meta-data span {
  display: block;
  font-size: 16px;
  color: #757575;
}
.review-listing > ul li .comment .comment-body .meta-data span.comment-author {
  font-weight: 600;
  color: #272b41;
  text-transform: capitalize;
}
.review-listing > ul li .comment .comment-body .meta-data span.comment-date {
  font-size: 14px;
}
@media (max-width: 767.98px) {
  .review-listing > ul li .comment .comment-body .meta-data span.comment-date {
    margin-bottom: 5px;
  }
}
.review-listing > ul li .comment .comment-body .meta-data .review-count {
  width: auto;
  position: absolute;
  top: 3px;
  right: 0;
}
@media (max-width: 767.98px) {
  .review-listing > ul li .comment .comment-body .meta-data .review-count {
    position: unset;
  }
}
.review-listing > ul li .comment .comment-body .comment-content {
  color: #757575;
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 14px;
}
.review-listing > ul li .comment .comment-body .comment-reply .comment-btn {
  color: #20c0f3;
  display: inline-block;
  font-weight: 500;
  font-size: 15px;
}
.review-listing > ul li .comments-reply {
  list-style: none;
  margin-left: 65px;
  padding: 0;
}
@media (max-width: 479.98px) {
  .review-listing > ul li .comments-reply {
    margin-left: 0;
  }
}
.review-listing .recommend-btn {
  float: right;
  color: #757575;
  font-size: 14px;
  padding: 5px 0;
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .review-listing .recommend-btn {
    float: none;
  }
}
.review-listing .recommend-btn a {
  border: 1px solid rgba(128, 137, 150, 0.4);
  display: inline-block;
  color: #757575;
  -webkit-transition: all 0.3s;
  -ms-transition: all 0.3s;
  transition: all 0.3s;
  border-radius: 4px;
  margin: 0 3px;
  padding: 4px 12px;
}
.review-listing .recommend-btn a.like-btn:hover {
  background-color: #28a745;
  border: 1px solid #28a745;
  color: #ffffff;
}
.review-listing .recommend-btn a.dislike-btn:hover {
  background-color: #dc3545;
  border: 1px solid #dc3545;
  color: #ffffff;
}
.review-listing .recommend-btn a i {
  font-size: 16px;
}
@media (max-width: 479.98px) {
  .review-listing .recommend-btn span {
    display: block;
    margin-bottom: 10px;
  }
}

.recommended {
  color: #28a745;
  font-size: 15px;
  font-weight: 500;
  margin: 0;
}

.all-feedback {
  margin-top: 20px;
}

.star-rating {
  direction: rtl;
}
.star-rating input[type="radio"] {
  display: none;
}
.star-rating input[type="radio"]:checked ~ label {
  color: #f2b600;
}
.star-rating label {
  color: #bbb;
  cursor: pointer;
  font-size: 18px;
  padding: 0;
  -webkit-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.star-rating label:hover,
.star-rating label:hover ~ label {
  color: #f2b600;
}

.terms-accept a {
  color: #20c0f3;
  font-weight: 500;
}

.business-widget {
  background-color: #fcfcfc;
  border: 1px solid #f0f0f0;
  margin-bottom: 0;
  padding: 20px;
}

.listing-day {
  color: #000000;
  margin-bottom: 10px;
}
.listing-day:last-child {
  margin-bottom: 0;
}
.listing-day.current {
  border-bottom: 1px solid #dddddd;
  padding-bottom: 13px;
  margin-bottom: 13px;
}
.listing-day.current .day {
  font-weight: 700;
}
.listing-day .day {
  font-weight: 500;
}
.listing-day .day span {
  display: block;
  font-weight: normal;
}

.time-items {
  color: #757575;
}
.time-items > span {
  display: block;
  text-align: right;
}
.time-items > span.open-status {
  margin-bottom: 3px;
}

.dropzone .dz-preview.dz-error:hover .dz-error-message {
  display: none;
}

.upload-wrap .upload-images + .upload-images {
  margin-left: 20px;
}

.upload-images {
  position: relative;
  width: 80px;
}
.upload-images img {
  height: 80px;
  width: auto;
  border-radius: 4px;
}

.contact-card .card-body {
  padding-bottom: 0.625rem;
}

.custom_price_cont {
  margin-top: 20px;
}

.btn.btn-danger.trash {
  height: 46px;
  width: 46px;
}
@media (max-width: 767.98px) {
  .btn.btn-danger.trash {
    margin-bottom: 20px;
  }
}

.add-more a {
  color: #20c0f3;
}

.bootstrap-tagsinput {
  border-color: #dcdcdc;
  box-shadow: inherit;
  min-height: 46px;
  width: 100%;
  border-radius: 0;
}
.bootstrap-tagsinput.focus {
  border-color: #bbb;
}
.bootstrap-tagsinput .tag {
  background-color: #20c0f3;
  color: #6b7280;
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  margin-right: 2px;
  border-radius: 0;
  padding: 8px 15px;
}

.services-card .bootstrap-tagsinput input {
  width: 160px;
}

.submit-section .submit-btn {
  font-weight: 700;
  font-size: 16px;
  min-width: 120px;
  padding: 12px 30px;
}
.submit-section .submit-btn + .submit-btn {
  margin-left: 15px;
}
@media (max-width: 767.98px) {
  .submit-section .submit-btn {
    font-size: 15px;
    min-width: 105px;
    padding: 10px 20px;
  }
}

.profile-sidebar {
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  margin-bottom: 30px;
  overflow: hidden;
  border-radius: 4px;
}
@media (max-width: 767.98px) {
  .profile-sidebar {
    margin-bottom: 20px !important;
  }
}
.profile-sidebar .pro-widget-content {
  border-bottom: 1px solid #f0f0f0;
  margin: 0;
  padding: 20px;
  text-align: center;
}
.profile-sidebar .dashboard-menu ul {
  color: #757575;
  font-size: 14px;
  line-height: 17px;
  list-style: none;
  text-transform: capitalize;
  margin: 0;
  padding: 0;
}
.profile-sidebar .dashboard-menu ul li {
  line-height: inherit;
}
.profile-sidebar .dashboard-menu ul li a i {
  font-size: 16px;
  margin-right: 10px;
  width: 16px;
}
.profile-sidebar .dashboard-menu ul li a span,
.profile-sidebar .dashboard-menu ul li a i {
  display: inline-block;
  vertical-align: middle;
}
.profile-sidebar .dashboard-menu ul li .unread-msg {
  background-color: #09e5ab;
  color: #272b41;
  font-size: 10px;
  font-style: normal;
  text-align: center;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  border-radius: 2px;
  position: absolute;
  top: 50%;
  right: 20px;
  padding: 0 5px;
}
.profile-sidebar .dashboard-menu > ul > li {
  border-bottom: 1px solid #f0f0f0;
  position: relative;
}
.profile-sidebar .dashboard-menu > ul > li:last-child {
  border-bottom: 0;
}
.profile-sidebar .dashboard-menu > ul > li a {
  color: #757575;
  display: block;
  padding: 16px 20px;
}
.profile-sidebar .dashboard-menu > ul > li:hover > a {
  color: #0de0fe;
}
.profile-sidebar .dashboard-menu > ul > li.active > a {
  color: #0de0fe;
}

@media (max-width: 1199.98px) {
  .dash-card .dash-widget {
    -ms-flex-direction: column;
    flex-direction: column;
    text-align: center;
  }
}
@media (max-width: 991.98px) {
  .dash-card .dash-widget {
    flex-direction: unset;
    text-align: left;
  }
}
.dash-card .dash-widget .circle-bar {
  margin-right: 15px;
}
@media (max-width: 1199.98px) {
  .dash-card .dash-widget .circle-bar {
    margin: 0 0 15px;
  }
}
@media (max-width: 991.98px) {
  .dash-card .dash-widget .circle-bar {
    margin: 0 15px 0 0;
  }
}
.dash-card .dash-widget .circle-bar > div {
  display: inline-block;
  position: relative;
  text-align: center;
}
.dash-card .dash-widget .circle-bar > div img {
  text-align: center;
  margin: 0 auto;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
}
.dash-card .dash-widget .circle-bar > div canvas {
  width: 90px !important;
  height: 90px !important;
}
.dash-card .dash-widget.dct-border-rht {
  border-right: 1px solid #f0f0f0;
}
@media (max-width: 991.98px) {
  .dash-card .dash-widget.dct-border-rht {
    border-bottom: 1px solid #f0f0f0;
    border-right: 0;
    margin-bottom: 20px;
    padding-bottom: 15px;
  }
}
.dash-card .dash-widget h6 {
  font-size: 16px;
  font-weight: 400;
}
@media (max-width: 767.98px) {
  .dash-card .dash-widget h6 {
    font-size: 15px;
  }
}
.dash-card .dash-widget h3 {
  font-size: 24px;
  margin-bottom: 5px;
}
@media (max-width: 767.98px) {
  .dash-card .dash-widget h3 {
    font-size: 20px;
  }
}
.dash-card .dash-widget p {
  color: #757575;
  font-size: 14px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .dash-card .dash-widget p {
    font-size: 13px;
  }
}
.dash-card .row {
  margin-left: -10px;
  margin-right: -10px;
}
.dash-card .row > div {
  padding-left: 10px;
  padding-right: 10px;
}

.appointment-tab {
  margin-bottom: 30px;
}
@media (max-width: 767.98px) {
  .appointment-tab {
    margin-bottom: 20px;
  }
}
.appointment-tab .nav-tabs {
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 0.25rem 0.25rem 0 0 !important;
  border-bottom: 0;
  padding: 1.5rem;
}
@media (max-width: 767.98px) {
  .appointment-tab .nav-tabs {
    padding: 1.5rem;
  }
}
.appointment-tab .tab-content {
  padding-top: 0;
}
.appointment-tab .card {
  border-radius: 0;
}

.profile-det-info {
  overflow: hidden;
}
.profile-det-info h3 {
  font-size: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.profile-det-info .patient-details h5 {
  color: #757575;
  font-size: 13px;
  font-weight: normal;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.profile-det-info .patient-details h5 i {
  width: 18px;
}

.profile-info-widget {
  text-align: left;
}
.profile-info-widget .booking-doc-img {
  margin-right: 15px;
}
.profile-info-widget .booking-doc-img img {
  height: 90px;
  width: 90px;
  object-fit: cover;
  border-radius: 4px;
}

.change-avatar .profile-img {
  margin-right: 15px;
}
.change-avatar .profile-img img {
  height: 100px;
  width: 100px;
  object-fit: cover;
  border-radius: 4px;
}
@media (max-width: 575.98px) {
  .change-avatar .profile-img img {
    height: 80px;
    width: 80px;
  }
}
.change-avatar .change-photo-btn {
  margin: 0 0 10px;
  width: 150px;
}
.change-avatar .change-photo-btn input.upload {
  bottom: 0;
  cursor: pointer;
  filter: alpha(opacity=0);
  opacity: 0;
  width: 220px;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}

.dropzone {
  background-color: #fbfbfb;
  border: 2px dashed rgba(0, 0, 0, 0.1);
}

.profile-image img {
  margin-bottom: 1.5rem;
}

.biller-info,
.billing-info {
  margin-bottom: 15px;
}

.add-more-item {
  margin-bottom: 10px;
}
.add-more-item a {
  color: #0de0fe;
  font-weight: 500;
}

.signature-wrap {
  float: right;
  margin-bottom: 20px;
  text-align: center;
  width: 220px;
}

.signature {
  border: 2px dashed #cccccc;
  color: #272b41;
  cursor: pointer;
  height: 85px;
  margin-bottom: 15px;
  width: 100%;
  border-radius: 4px;
}
.signature:hover {
  background-color: #fcfcfc;
}
.signature .sign-name {
  width: 100%;
  float: right;
}

.pat-widget-profile .pro-widget-content {
  padding: 0 0 20px;
}
.pat-widget-profile .booking-date li {
  font-size: 14px;
}
.pat-widget-profile .booking-date li span {
  font-size: 14px;
}

.add-new-btn {
  background-color: #0de0fe;
  color: #ffffff;
  display: inline-block;
  font-weight: 500;
  margin: 0 0 20px;
  padding: 10px 20px;
  border-radius: 30px;
}
.add-new-btn:focus,
.add-new-btn:hover,
.add-new-btn.active {
  background-color: #0de0fe;
  color: #ffffff;
}

.patient-info {
  margin-top: 15px;
}
.patient-info ul {
  list-style: none;
  font-size: 0.875rem;
  margin: 0;
  padding: 0;
}
.patient-info ul li {
  position: relative;
  font-size: 0.875rem;
  font-weight: 500;
  color: #272b41;
  text-transform: capitalize;
}
.patient-info ul li + li {
  margin-top: 15px;
}
.patient-info ul li i {
  width: 18px;
}
.patient-info ul li span {
  color: #757575;
  float: right;
  font-weight: 400;
}

.profile-sidebar {
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  margin-bottom: 30px;
  overflow: hidden;
  border-radius: 4px;
}

.pro-widget-content {
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
  padding: 20px;
}

.profile-info-widget {
  text-align: left;
}
.profile-info-widget .booking-doc-img {
  margin-right: 15px;
}
.profile-info-widget .booking-doc-img img {
  height: 90px;
  width: 90px;
  object-fit: cover;
  border-radius: 4px;
}

.profile-det-info {
  overflow: hidden;
}
.profile-det-info h3 {
  font-size: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.patient-details h5 {
  color: #757575;
  font-size: 13px;
  font-weight: normal;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.patient-details h5 i {
  width: 18px;
}

.dashboard-menu ul {
  color: #757575;
  font-size: 14px;
  line-height: 17px;
  list-style: none;
  text-transform: capitalize;
  margin: 0;
  padding: 0;
}
.dashboard-menu ul li {
  line-height: inherit;
}
.dashboard-menu ul li a i {
  font-size: 16px;
  margin-right: 10px;
  width: 16px;
  display: inline-block;
  vertical-align: middle;
}
.dashboard-menu ul li a span {
  display: inline-block;
  vertical-align: middle;
}
.dashboard-menu > ul > li {
  border-bottom: 1px solid #f0f0f0;
  position: relative;
}
.dashboard-menu > ul > li :last-child {
  border-bottom: 0;
}
.dashboard-menu > ul > li > a {
  color: #757575;
  display: block;
  padding: 16px 20px;
}
.dashboard-menu > ul > li:hover > a,
.dashboard-menu > ul > li.active > a {
  color: #0de0fe;
}

.unread-msg {
  background-color: #09e5ab;
  color: #272b41;
  font-size: 10px;
  font-style: normal;
  text-align: center;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 20px;
  padding: 0 5px;
  border-radius: 2px;
}

.patient-dashboard-top > div {
  width: 100%;
}
.patient-dashboard-top h6 {
  font-size: 18px;
  margin-bottom: 0;
}
.patient-dashboard-top h6 sub {
  font-size: 12px;
}

.patient-graph-col .graph-box {
  background: #7289de;
  border-bottom: 8px solid #6a5dee;
  width: 100%;
  margin: 15px 0;
  padding: 22px;
}
.patient-graph-col .graph-box.pink-graph {
  background-color: #ffa69e;
  border-bottom: 8px solid #ffa69e;
}
.patient-graph-col .graph-box.sky-blue-graph {
  background-color: #a9d4ff;
  border-bottom: 8px solid #8ec4ff;
}
.patient-graph-col .graph-box.orange-graph {
  background-color: #ffb88e;
  border-bottom: 8px solid #ffb88e;
}
.patient-graph-col .graph-box h4 {
  color: #ffffff;
  margin-bottom: 15px;
  text-align: center;
}
.patient-graph-col .graph-box > div {
  width: 100%;
}
.patient-graph-col .graph-box .graph-img {
  text-align: center;
  margin: 0 auto;
  width: 100%;
}
.patient-graph-col .graph-box .graph-status-result h3 {
  color: #ffffff;
  margin-bottom: 0;
  line-height: 0.9;
  width: 100%;
}
.patient-graph-col .graph-box .graph-status-result span.graph-update-date {
  color: #ffffff;
  font-weight: 500;
  opacity: 0.7;
  text-align: center;
  width: 100%;
}

.chat-page .footer {
  display: none;
}

.chat-window {
  position: relative;
}
.chat-window .chat-cont-left {
  border-right: 1px solid #f0f0f0;
  -ms-flex: 0 0 35%;
  flex: 0 0 35%;
  max-width: 35%;
  z-index: 4;
  position: relative;
  left: 0;
}
@media (max-width: 1199.98px) {
  .chat-window .chat-cont-left {
    -ms-flex: 0 0 40%;
    flex: 0 0 40%;
    max-width: 40%;
  }
}
@media (max-width: 991.98px) {
  .chat-window .chat-cont-left {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
    transition:
      left 0.3s ease-in-out 0s,
      right 0.3s ease-in-out 0s;
    width: 100%;
    border-right: 0;
  }
}
@media (max-width: 479.98px) {
  .chat-window .chat-cont-left a.media .media-body > div:first-child .user-name,
  .chat-window .chat-cont-left a.media .media-body > div:first-child .user-last-chat {
    max-width: 160px;
  }
}
.chat-window .chat-cont-left .chat-header {
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  color: #272b41;
  height: 72px;
  padding: 0 15px;
}
.chat-window .chat-cont-left .chat-header span {
  font-size: 20px;
  font-weight: 500;
  text-transform: capitalize;
}
.chat-window .chat-cont-left .chat-header .chat-compose {
  color: #8a8a8a;
}
.chat-window .chat-cont-left .chat-search {
  background-color: #f5f5f6;
  border-bottom: 1px solid #f3f3f3;
  padding: 10px 15px;
  width: 100%;
}
.chat-window .chat-cont-left .chat-search .input-group {
  width: 100%;
}
.chat-window .chat-cont-left .chat-search .input-group .form-control {
  background-color: #ffffff;
  padding-left: 36px;
  border-radius: 50px;
}
.chat-window .chat-cont-left .chat-search .input-group .form-control:focus {
  border-color: #cccccc;
  box-shadow: none;
}
.chat-window .chat-cont-left .chat-search .input-group .form-control::placeholder {
  font-size: 14px;
}
.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend {
  color: #666;
  pointer-events: none;
  z-index: 4;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 15px;
}
.chat-window .chat-cont-left .chat-users-list {
  background-color: #ffffff;
}
.chat-window .chat-cont-left .chat-users-list a.media {
  border-bottom: 1px solid #f0f0f0;
  padding: 10px 15px;
  -webkit-transition: all 0.2s ease 0s;
  -ms-transition: all 0.2s ease 0s;
  transition: all 0.2s ease 0s;
}
.chat-window .chat-cont-left .chat-users-list a.media:last-child {
  border-bottom: 0;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap {
  margin-right: 15px;
  position: relative;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap .avatar {
  height: 45px;
  width: 45px;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap .status {
  height: 10px;
  width: 10px;
  border: 2px solid #ffffff;
  position: absolute;
  right: 4px;
  bottom: 7px;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #272b41;
  text-transform: capitalize;
}
@media (max-width: 1399.98px) {
  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {
    max-width: 180px;
  }
}
@media (max-width: 1199.98px) {
  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {
    max-width: 150px;
  }
}
@media (max-width: 767.98px) {
  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {
    max-width: 250px;
  }
}
@media (max-width: 479.98px) {
  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {
    max-width: 160px;
  }
}
.chat-window
  .chat-cont-left
  .chat-users-list
  a.media
  .media-body
  > div:first-child
  .user-last-chat {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #8a8a8a;
  font-size: 14px;
  line-height: 24px;
}
@media (max-width: 1399.98px) {
  .chat-window
    .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-last-chat {
    max-width: 180px;
  }
}
@media (max-width: 1199.98px) {
  .chat-window
    .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-last-chat {
    max-width: 150px;
  }
}
@media (max-width: 767.98px) {
  .chat-window
    .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-last-chat {
    max-width: 250px;
  }
}
@media (max-width: 479.98px) {
  .chat-window
    .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-last-chat {
    max-width: 160px;
  }
}
.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:last-child {
  text-align: right;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:last-child .last-chat-time {
  color: #8a8a8a;
  font-size: 13px;
}
.chat-window .chat-cont-left .chat-users-list a.media:hover {
  background-color: #f5f5f6;
}
.chat-window
  .chat-cont-left
  .chat-users-list
  a.media.read-chat
  .media-body
  > div:last-child
  .last-chat-time {
  color: #8a8a8a;
}
.chat-window .chat-cont-left .chat-users-list a.media.active {
  background-color: #f5f5f6;
}
.chat-window .chat-scroll {
  min-height: 300px;
  max-height: calc(100vh - 224px);
  overflow-y: auto;
}
.chat-window .chat-cont-right {
  -ms-flex: 0 0 65%;
  flex: 0 0 65%;
  max-width: 65%;
}
@media (max-width: 1199.98px) {
  .chat-window .chat-cont-right {
    -ms-flex: 0 0 60%;
    flex: 0 0 60%;
    max-width: 60%;
  }
}
@media (max-width: 991.98px) {
  .chat-window .chat-cont-right {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 0;
    right: -100%;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
    transition:
      left 0.3s ease-in-out 0s,
      right 0.3s ease-in-out 0s;
    width: 100%;
  }
}
.chat-window .chat-cont-right .chat-header {
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  height: 72px;
  padding: 0 15px;
}
@media (max-width: 991.98px) {
  .chat-window .chat-cont-right .chat-header {
    justify-content: start;
    -webkit-justify-content: start;
    -ms-flex-pack: start;
  }
}
.chat-window .chat-cont-right .chat-header .back-user-list {
  display: none;
  margin-right: 5px;
  margin-left: -7px;
}
@media (max-width: 991.98px) {
  .chat-window .chat-cont-right .chat-header .back-user-list {
    display: block;
  }
}
.chat-window .chat-cont-right .chat-header .media .media-img-wrap {
  position: relative;
  margin-right: 15px;
}
.chat-window .chat-cont-right .chat-header .media .media-img-wrap .avatar {
  height: 50px;
  width: 50px;
}
.chat-window .chat-cont-right .chat-header .media .media-img-wrap .status {
  border: 2px solid #ffffff;
  height: 10px;
  width: 10px;
  position: absolute;
  right: 3px;
  bottom: 0;
}
@media (max-width: 767.98px) {
  .chat-window .chat-cont-right .chat-header .media .media-body {
    display: none;
  }
}
.chat-window .chat-cont-right .chat-header .media .media-body .user-name {
  color: #272b41;
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
}
.chat-window .chat-cont-right .chat-header .media .media-body .user-status {
  color: #666;
  font-size: 14px;
}
@media (max-width: 991.98px) {
  .chat-window .chat-cont-right .chat-header .chat-options {
    margin-left: auto;
  }
}
.chat-window .chat-cont-right .chat-header .chat-options > a {
  border-radius: 50%;
  height: 30px;
  color: #8a8a8a;
  margin-left: 10px;
  width: 30px;
}
.chat-window .chat-cont-right .chat-body {
  background-color: #f5f5f6;
}
.chat-window .chat-cont-right .chat-body ul.list-unstyled {
  width: 100%;
  margin: 0 auto;
  padding: 15px;
}
.chat-window .chat-cont-right .chat-body .media .avatar {
  height: 30px;
  width: 30px;
}
.chat-window .chat-cont-right .chat-body .media .media-body {
  margin-left: 20px;
}
.chat-window .chat-cont-right .chat-body .media .media-body .msg-box > div {
  display: inline-block;
  position: relative;
  border-radius: 0.25rem;
  padding: 10px 15px;
}
.chat-window .chat-cont-right .chat-body .media .media-body .msg-box > div p {
  color: #272b41;
  margin-bottom: 0;
}
.chat-window .chat-cont-right .chat-body .media .media-body .msg-box + .msg-box {
  margin-top: 5px;
}
.chat-window .chat-cont-right .chat-body .media.received {
  margin-bottom: 20px;
}
.chat-window .chat-cont-right .chat-body .media.received .media-body {
  position: relative;
}
.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box > div {
  background-color: #ffffff;
}
.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box > div .chat-time {
  color: rgba(50, 65, 72, 0.4);
}
.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box:first-child:before {
  border-bottom: 6px solid transparent;
  border-right: 6px solid #ffffff;
  border-top: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 8px;
  right: auto;
  left: -6px;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box {
  padding-left: 50px;
  position: relative;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box:first-child:before {
  border-bottom: 6px solid transparent;
  border-left: 6px solid #e3e3e3;
  border-top: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 8px;
  right: -6px;
  left: auto;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-time {
  color: rgba(50, 65, 72, 0.4);
}
.chat-window .chat-cont-right .chat-body .media:last-child {
  margin-bottom: 0;
}
.chat-window .chat-cont-right .chat-body .media.sent {
  margin-bottom: 20px;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body {
  margin-left: 0;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div {
  background-color: #e3e3e3;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div p {
  color: #272b41;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info {
  flex-direction: row-reverse;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info li {
  padding-left: 16px;
  padding-right: 0;
  position: relative;
}
.chat-window
  .chat-cont-right
  .chat-body
  .media.sent
  .media-body
  .msg-box
  > div
  .chat-msg-attachments {
  flex-direction: row-reverse;
}
.chat-window
  .chat-cont-right
  .chat-body
  .media.sent
  .media-body
  .msg-box
  > div:hover
  .chat-msg-actions {
  opacity: 1;
}
.chat-window .chat-cont-right .chat-body .chat-date {
  font-size: 14px;
  margin: 1.875rem 0;
  overflow: hidden;
  position: relative;
  text-align: center;
  text-transform: capitalize;
}
.chat-window .chat-cont-right .chat-body .chat-date:before {
  background-color: #eef6ff;
  content: "";
  height: 1px;
  margin-right: 28px;
  width: 100%;
  position: absolute;
  top: 50%;
  right: 50%;
}
.chat-window .chat-cont-right .chat-body .chat-date:after {
  background-color: #eef6ff;
  content: "";
  height: 1px;
  margin-left: 28px;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
}
.chat-window .chat-cont-right .chat-footer {
  background-color: #ffffff;
  position: relative;
  border-top: 1px solid #f0f0f0;
  padding: 10px 15px;
}
.chat-window .chat-cont-right .chat-footer .input-group {
  width: 100%;
}
.chat-window .chat-cont-right .chat-footer .input-group .form-control {
  background-color: #f5f5f6;
  border: none;
  border-radius: 50px;
}
.chat-window .chat-cont-right .chat-footer .input-group .form-control:focus {
  background-color: #f5f5f6;
  border: none;
  box-shadow: none;
}
.chat-window .chat-cont-right .chat-footer .input-group .form-control::placeholder {
  font-size: 14px;
}
.chat-window .chat-cont-right .chat-footer .input-group .btn {
  background-color: transparent;
  border: none;
  color: #9f9f9f;
}
.chat-window .chat-cont-right .chat-footer .input-group .btn.msg-send-btn {
  background-color: #0de0fe;
  border-color: #0de0fe;
  color: #ffffff;
  margin-left: 10px;
  min-width: 46px;
  font-size: 20px;
  border-radius: 50%;
}
.chat-window .chat-cont-right .msg-typing {
  width: auto;
  height: 24px;
  padding-top: 8px;
}
.chat-window .chat-cont-right .msg-typing span {
  height: 8px;
  width: 8px;
  float: left;
  margin: 0 1px;
  background-color: #a0a0a0;
  display: block;
  opacity: 0.4;
  border-radius: 50%;
}
.chat-window .chat-cont-right .msg-typing span:nth-of-type(1) {
  animation: 1s blink infinite 0.33333s;
}
.chat-window .chat-cont-right .msg-typing span:nth-of-type(2) {
  animation: 1s blink infinite 0.66666s;
}
.chat-window .chat-cont-right .msg-typing span:nth-of-type(3) {
  animation: 1s blink infinite 0.99999s;
}
.chat-window .chat-msg-info {
  clear: both;
  list-style: none;
  margin: 5px 0 0;
  padding: 0;
}
.chat-window .chat-msg-info li {
  font-size: 13px;
  padding-right: 16px;
  position: relative;
}
.chat-window .chat-msg-info li:not(:last-child):after {
  content: "";
  height: 4px;
  width: 4px;
  background: #d2dde9;
  border-radius: 50%;
  transform: translate(50%, -50%);
  -webkit-transform: translate(50%, -50%);
  -ms-transform: translate(50%, -50%);
  position: absolute;
  top: 50%;
  right: 8px;
}
.chat-window .chat-msg-info li a {
  color: #777;
}
.chat-window .chat-msg-info li a:hover {
  color: #2c80ff;
}
@media (max-width: 991.98px) {
  .chat-window.chat-slide .chat-cont-left {
    left: -100%;
  }
}
@media (max-width: 991.98px) {
  .chat-window.chat-slide .chat-cont-right {
    right: 0;
    opacity: 1;
    visibility: visible;
  }
}

.chat-seen i {
  color: #00d285;
  font-size: 16px;
}

.chat-msg-attachments {
  width: 100%;
  margin: 0 -1px;
  padding: 4px 0;
}
.chat-msg-attachments > div {
  margin: 0 1px;
}

.chat-attachment {
  position: relative;
  max-width: 130px;
  overflow: hidden;
  border-radius: 0.25rem;
}
.chat-attachment img {
  max-width: 100%;
}
.chat-attachment:before {
  background: #000000;
  content: "";
  opacity: 0.4;
  -webkit-transition: all 0.4s;
  -ms-transition: all 0.4s;
  transition: all 0.4s;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.chat-attachment:hover:before {
  opacity: 0.6;
}
.chat-attachment:hover .chat-attach-caption {
  opacity: 0;
}
.chat-attachment:hover .chat-attach-download {
  opacity: 1;
}

.chat-attach-caption {
  color: #ffffff;
  padding: 7px 15px;
  font-size: 13px;
  opacity: 1;
  -webkit-transition: all 0.4s;
  -ms-transition: all 0.4s;
  transition: all 0.4s;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
}

.chat-attach-download {
  opacity: 0;
  color: #ffffff;
  width: 32px;
  line-height: 32px;
  background: rgba(255, 255, 255, 0.2);
  text-align: center;
  transform: translate(-50%, -50%);
  -webkit-transition: all 0.4s;
  -ms-transition: all 0.4s;
  transition: all 0.4s;
  position: absolute;
  top: 50%;
  left: 50%;
}
.chat-attach-download:hover {
  color: #495463;
  background: #ffffff;
}

chat-attachment-list {
  margin: -5px;
}
chat-attachment-list li {
  width: 33.33%;
  padding: 5px;
}

.chat-attachment-item {
  border: 5px solid rgba(230, 239, 251, 0.5);
  height: 100%;
  min-height: 60px;
  text-align: center;
  font-size: 30px;
}

.chat-msg-actions {
  opacity: 0;
  z-index: 2;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -webkit-transition: all 0.4s;
  -ms-transition: all 0.4s;
  transition: all 0.4s;
  position: absolute;
  top: 50%;
  left: -30px;
}
.chat-msg-actions > a {
  color: #495463;
  font-size: 24px;
  padding: 0 10px;
}
.chat-msg-actions > a:hover {
  color: #2c80ff;
}

@keyframes blink {
  50% {
    opacity: 1;
  }
}
.btn-file {
  font-size: 20px;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
  padding: 0 0.75rem;
}
.btn-file input {
  cursor: pointer;
  filter: alpha(opacity=0);
  font-size: 23px;
  height: 100%;
  margin: 0;
  opacity: 0;
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
}

.incoming-btns {
  margin-top: 20px;
}

.call-wrapper {
  position: relative;
  height: calc(100vh - 145px);
}
@media (max-width: 991.98px) {
  .call-wrapper {
    height: calc(100vh - 140px);
  }
}
@media (max-width: 767.98px) {
  .call-wrapper {
    height: calc(100vh - 115px);
  }
}

.call-page .footer {
  display: none;
}

.dropdown-action .dropdown-toggle::after {
  display: none;
}

.call-modal .modal-body {
  padding: 40px;
}
.call-modal .modal-content {
  border: 0;
  border-radius: 10px;
}

/*-----------------
	Incoming call
-----------------------*/
.call-box .call-wrapper {
  height: auto;
  text-align: center;
}
.call-box .call-wrapper .call-user {
  margin-bottom: 30px;
}
.call-box .call-wrapper .call-user h4 {
  font-size: 24px;
}
.call-box .call-wrapper .call-user span {
  display: block;
  font-weight: 500;
  text-align: center;
}
.call-box .call-wrapper .call-avatar {
  margin-bottom: 30px;
  cursor: pointer;
  animation: ripple 2s infinite;
}
.call-box .call-wrapper .call-items .call-item {
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid transparent;
  border-radius: 100%;
  color: #ffffff;
  line-height: 0;
  margin: 0 5px;
  padding: 15px;
}
.call-box .call-wrapper .call-items .call-item:hover {
  opacity: 0.9;
}
.call-box .call-wrapper .call-items .call-item:first-child,
.call-box .call-wrapper .call-items .call-item:last-child {
  margin-top: -30px;
}
.call-box .call-wrapper .call-items .call-item.call-end {
  background: #f06060;
  border: 1px solid #f06060;
  color: #ffffff;
  line-height: 0;
  border-radius: 100%;
  margin: 30px 20px 0;
  padding: 20px;
}
.call-box .call-wrapper .call-items .call-item.call-start {
  background: #55ce63;
  border: 1px solid #55ce63;
  color: #ffffff;
  line-height: 0;
  border-radius: 100%;
  margin: 30px 20px 0;
  padding: 20px;
}
.call-box.incoming-box .call-wrapper .call-items .call-item.call-start,
.call-box.incoming-box .call-wrapper .call-items .call-item.call-end {
  margin: 0 10px;
}
.call-box .call-avatar {
  height: 140px;
  max-width: 140px;
  min-width: 140px;
  position: relative;
  width: 100%;
  border: 10px solid #fafafa;
  border-radius: 100%;
}
.call-box .btn {
  background: rgba(0, 0, 0, 0);
  -webkit-transition: all 0.3s ease 0s;
  -ms-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}

@-webkit-keyframes ripple {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
  }
  100% {
    -webkit-box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);
  }
}
@keyframes ripple {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
  }
  100% {
    -moz-box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);
    box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);
  }
}
.chat-cont-right
  .chat-body
  .media.sent
  .media-body
  .msg-box
  .chat-msg-info
  li:not(:last-child)::after {
  right: auto;
  left: 8px;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background: #aaa;
}

.view-cart-header {
  position: relative;
}
.view-cart-header .dropdown-menu {
  min-width: 320px !important;
}
.view-cart-header .shopping-cart {
  padding: 15px;
}
.view-cart-header .shopping-cart.show-cart {
  opacity: 1;
  visibility: visible;
}
.view-cart-header .shopping-cart:after {
  border: 7px solid #ffffff;
  border-color: transparent transparent #ffffff #ffffff;
  box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
  transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
}
.view-cart-header .shopping-cart .booking-date {
  display: block;
  padding-bottom: 0;
}
.view-cart-header .shopping-cart .booking-date li span {
  font-size: 14px;
}
.view-cart-header .shopping-cart-total {
  float: right;
}
.view-cart-header .shopping-cart-items {
  padding-top: 0px;
}
.view-cart-header .shopping-cart-items li {
  display: block !important;
  border-bottom: 1px solid #e4e4e4;
  position: relative;
  margin: 0 0 10px 0 !important;
  padding: 0 0 14px;
}
.view-cart-header .shopping-cart-items li a {
  padding-left: 0 !important;
  letter-spacing: normal !important;
}
.view-cart-header .shopping-cart-items .close-icon {
  cursor: pointer;
  color: #6b7280;
  position: absolute;
  top: 10px;
  right: 0;
}
.view-cart-header .shopping-cart-items img {
  float: left;
  width: 70px;
  margin-right: 12px;
  max-width: 100%;
  height: auto;
}
.view-cart-header .shopping-cart-items .item-name {
  display: block;
  padding-top: 10px;
  font-size: 14px;
  padding-right: 20px;
  color: #6b7280;
  font-weight: normal;
}
.view-cart-header .shopping-cart-items .item-price {
  margin-right: 8px;
  color: #0e82fd;
  font-size: 13px;
  font-weight: normal;
}
.view-cart-header .shopping-cart-items .item-quantity {
  color: #abb0be;
  font-size: 13px;
  font-weight: normal;
}
.view-cart-header .cart-icon {
  color: #515783;
  font-size: 24px;
  margin-right: 7px;
  float: left;
}
.view-cart-header .booking-date li {
  display: block !important;
  width: 100%;
  margin: 0 0 10px;
  padding: 0 !important;
}
.view-cart-header .booking-date li span {
  float: right;
}
.view-cart-header .booking-total {
  padding-top: 0;
  text-align: center;
}
.view-cart-header .apt-btn {
  font-size: 13px;
  letter-spacing: normal !important;
  padding: 7px 20px;
}
.view-cart-header .apt-btn:hover {
  border-color: #0e82fd !important;
  background-color: #0e82fd !important;
  color: #ffffff !important;
}

.unread-msg1 {
  background-color: #0e82fd;
  border-radius: 2px;
  color: #ffffff;
  font-size: 10px;
  font-style: normal;
  text-align: center;
  position: absolute;
  top: -10px;
  right: -10px;
  padding: 0 5px;
}

.custom-increment.cart button {
  font-size: 10px;
}
.custom-increment.cart input[type="text"] {
  width: 60px;
}
.custom-increment button {
  font-size: 14px;
  height: 39px;
  background: #dcdcdc;
  color: #000000;
  border: 0;
  display: inline-block;
}
.custom-increment button.btn-danger {
  border-radius: 4px 0px 0px 4px;
}
.custom-increment button:hover,
.custom-increment button:focus,
.custom-increment button:active {
  background: #dcdcdc !important;
  color: #000000 !important;
  border: 0 !important;
}
.custom-increment button.btn-success {
  border-radius: 0 4px 4px 0;
}
.custom-increment button.btn-danger {
  border-radius: 4px 0px 0px 4px;
}
.custom-increment .input-group1 {
  width: 100%;
}
.custom-increment input[type="text"] {
  border: 1px solid #dbdbdb;
  border-radius: 0;
  text-align: center;
  width: 70%;
  padding: 7px 15px;
}
.custom-increment input[type="text"]:focus {
  border-color: transparent;
}

.doc-review.review-listing {
  margin: 0;
}

.review-listing.doc-review > ul > li {
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  padding: 20px;
}

.account-page {
  background-color: #ffffff;
}
.account-page .content {
  padding: 50px 0;
}
@media (max-width: 767.98px) {
  .account-page .content {
    padding: 15px 0;
  }
}

.login-right {
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 25px;
}
@media (max-width: 767.98px) {
  .login-right {
    margin: 0 15px;
    padding: 15px;
  }
}
.login-right .dont-have {
  color: #3d3d3d;
  margin-top: 20px;
  font-size: 13px;
}
.login-right .dont-have a {
  color: #09dca4;
}
.login-right .inner-right-login {
  max-width: 355px;
  width: 100%;
  margin: 0 auto;
}
.login-right .country-select .select-col .select2-container--default .select2-selection--single {
  background-color: #ffffff;
  border-radius: 10px 0 0 10px;
  width: 79px;
}
.login-right
  .country-select
  .select-col
  .select2-container--default
  .select2-selection--single
  .select2-selection__rendered {
  color: #0de0fe;
}
.login-right
  .country-select
  .select-col
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow
  b {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

@media (max-width: 991.98px) {
  .login-left {
    display: none;
  }
}

.login-header {
  margin-bottom: 20px;
}
.login-header p {
  margin-bottom: 0;
}
.login-header h3 {
  font-size: 18px;
  margin-bottom: 3px;
}
@media (max-width: 479.98px) {
  .login-header h3 {
    text-align: center;
  }
}
.login-header h3 a {
  color: #0de0fe;
  float: right;
  font-size: 15px;
  margin-top: 2px;
}
@media (max-width: 479.98px) {
  .login-header h3 a {
    color: #0de0fe;
    float: none;
    font-size: 15px;
    margin-top: 10px;
    text-align: center;
    display: block;
  }
}
.login-header .logo-icon {
  text-align: center;
  margin: 40px auto 20px;
}

.login-btn {
  font-size: 18px;
  font-weight: 500;
}

.login-or {
  color: #d4d4d4;
  position: relative;
  margin: 20px 0;
  padding: 10px 0;
}

.or-line {
  background-color: #e5e5e5;
  height: 1px;
  margin-bottom: 0;
  margin-top: 0;
  display: block;
}

.span-or {
  background-color: #ffffff;
  display: block;
  margin-left: -20px;
  text-align: center;
  width: 42px;
  position: absolute;
  top: -3px;
  left: 50%;
}

.forgot-link {
  color: #3d3d3d;
  display: inline-block;
  font-size: 13px;
  margin-bottom: 10px;
  font-weight: 400;
}

.social-login .btn:hover,
.social-login .social-login .btn:focus {
  color: #ffffff;
}

span.agree {
  font-size: 16px;
  margin-left: 6px;
}

.terms-and-policy span.terms {
  color: #09dca4;
}

.terms-and-policy a {
  color: #09dca4;
}

.login-page .login-right {
  width: 100%;
  position: relative;
  font-family: "Poppins", sans-serif;
  height: 100vh;
  border: 0;
  border-radius: 0;
  padding: 0;
}
.login-page
  .login-right
  .select2-container--default
  .select2-selection--single
  .select2-selection__rendered {
  color: #808080;
}
.login-page
  .login-right
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow
  b {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.login-page .login-right .form-control {
  color: #808080;
}
.login-page .search-location-input-box input {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  background-position: 10px 50%;
  background-size: 16px;
  padding-left: 38px;
  color: #948ca0;
}

.login-bottom-copyright {
  color: #a4a4a4;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  padding-bottom: 25px;
  width: 100%;
  align-self: flex-end;
  -webkit-align-self: flex-end;
}

.step-list {
  text-align: center;
  padding: 10px 0;
}
.step-list ul {
  display: inline-block;
}
.step-list ul li {
  float: left;
  margin: 5px 0;
  padding: 0 30px 0 0;
}
.step-list ul li:last-child {
  padding-right: 0;
}
.step-list ul li a {
  background-color: #e9f5f7;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  font-size: 14px;
  color: #808080;
}
.step-list ul li a:hover,
.step-list ul li a.active {
  background-color: #0de0fe;
  color: #ffffff;
}
.step-list ul li a.active-done {
  background-color: #0de0fe;
  color: #ffffff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 18px;
  font-size: 0;
}

.profile-pic-col {
  padding-top: 40px;
  text-align: center;
}
.profile-pic-col h3 {
  color: #000000;
  font-size: 20px !important;
}

.profile-pic-upload {
  width: 150px;
  background: rgba(175, 213, 254, 0.4);
  border-radius: 20px;
  position: relative;
  margin: 40px auto 0;
  padding: 24px;
}
.profile-pic-upload input[type="file"] {
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
}
.profile-pic-upload .cam-col {
  width: 70px;
  height: 70px;
  background-color: #ffffff;
  border-radius: 70px;
  overflow: hidden;
  margin: 0 auto;
}
.profile-pic-upload span {
  color: #000000;
  font-size: 13px;
  list-style: none;
  display: inline-block;
  margin-top: 15px;
}

.select-gender-col [type="radio"]:checked,
.select-gender-col [type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
.select-gender-col [type="radio"]:checked + label,
.select-gender-col [type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #666;
}
.select-gender-col [type="radio"]:checked + label:before,
.select-gender-col [type="radio"]:not(:checked) + label:before {
  content: "";
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 5px 20px 60px 10px rgba(0, 4, 107, 0.07);
  position: absolute;
  top: 0;
  left: 0;
}
.select-gender-col [type="radio"]:checked + label:after,
.select-gender-col [type="radio"]:not(:checked) + label:after {
  content: "";
  width: 100%;
  height: 100%;
  background: transparent;
  border-radius: 10px;
  border: 2px solid #0de0fe;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.select-gender-col [type="radio"]:not(:checked) + label:after {
  opacity: 0;
}
.select-gender-col [type="radio"]:checked + label:after {
  opacity: 1;
}
.select-gender-col .gender-icon {
  position: relative;
}
.select-gender-col .gender-icon label {
  text-align: center;
  padding: 15px 20px !important;
}
.select-gender-col .gender-icon img {
  max-height: 90px;
}
.select-gender-col span {
  position: relative;
  color: #000000;
  display: inline-block;
  margin-top: 10px;
  font-size: 16px;
  width: 100%;
}
.select-gender-col.payment-menthods-choose label {
  min-width: 90px;
  text-align: center;
  color: #000000;
  padding: 10px !important;
}
.select-gender-col.payment-menthods-choose label span.credit-card-option {
  min-width: 192px;
  font-size: 15px;
}
.select-gender-col.payment-menthods-choose label img {
  position: relative;
  max-width: 68px;
}
.select-gender-col.payment-menthods-choose [type="radio"]:checked + label::after,
.select-gender-col.payment-menthods-choose [type="radio"]:not(:checked) + label::after {
  border: 1px solid #0de0fe;
}
.select-gender-col label {
  text-align: center;
  padding: 15px 20px !important;
}

.pregnant-col .remember-me-col {
  color: #000000;
  font-size: 16px;
}
.pregnant-col .remember-me-col .custom_check .checkmark {
  border-color: #0de0fe;
}

.step-process-col {
  text-align: left;
}

.checklist-col span {
  font-size: 16px;
}
.checklist-col .custom_check .checkmark {
  width: 24px;
  height: 24px;
}
.checklist-col .custom_check .checkmark:after {
  left: 6px;
  top: 3px;
}
.checklist-col .remember-me-col {
  position: relative;
  padding: 10px 0;
}
.checklist-col.pregnant-col .remember-me-col .custom_check {
  padding-left: 25px;
}
.checklist-col.pregnant-col .remember-me-col .custom_check .checkmark {
  border-color: #b4abca;
}

.otp-col {
  color: #ffffff;
}
.otp-col h3 {
  color: #ffffff;
  font-size: 20px;
  margin-bottom: 15px;
}

.dnt-recive-call {
  color: #ffffff;
}
.dnt-recive-call a {
  color: #ffffff;
}

.otp-box {
  margin: 25px 0;
}
.otp-box .digit-group input {
  width: 45px;
  height: 45px;
  background-color: rgba(245, 245, 245, 0.2);
  border: none;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  box-shadow: 5px 20px 60px 10px rgba(0, 4, 107, 0.07);
  border-radius: 8px;
  color: #000000;
  margin: 0 3px;
}
.otp-box .digit-group input:focus {
  background-color: #ffffff;
  border: 0;
  outline: 0;
}
.otp-box .digit-group input[type="text"].active {
  background-color: #ffffff;
  color: #000000;
}
.otp-box .splitter {
  color: #ffffff;
  font-size: 24px;
  padding: 0 5px;
}
.otp-box .prompt {
  font-size: 20px;
  color: #ffffff;
  margin: 0 0 20px;
}

.increment-decrement .input-groups {
  border: 0;
  background-color: transparent;
  height: 35px;
  margin-right: 0px;
  display: block;
}
.increment-decrement .input-groups .quantity-field {
  width: 40px;
  text-align: center;
  background-color: transparent;
  float: left;
  border: 0;
}
.increment-decrement .input-groups .quantity-field:focus {
  border: 0;
  outline: 0;
}
.increment-decrement .input-groups input[type="button"] {
  background-color: transparent;
  font-size: 20px;
  border: 1px solid #0de0fe;
  border-radius: 4px;
  height: 24px;
  width: 24px;
  margin-top: 0px;
  line-height: 0;
  padding: 0;
  color: #0de0fe;
}
.increment-decrement .input-groups input[type="button"]:focus-visible {
  outline: 0;
}
.increment-decrement .input-groups input[type="button"].button-minus {
  float: left;
}
.increment-decrement .input-groups input[type="button"].button-plus {
  float: right;
}

.country-select {
  position: relative;
}
.country-select .select-col {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.country-select .select-col .flagstrap {
  height: 100%;
}
.country-select .select-col .btn-info.dropdown-toggle {
  border: 0;
  color: #0de0fe;
  border-radius: 10px 0px 0px 10px;
  background-color: #ffffff;
  height: 100%;
  font-size: 0;
  width: 79px;
  text-align: left;
  padding: 0 12px;
}
.country-select .select-col .btn-info.dropdown-toggle:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 14px;
  height: 7px;
  border: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 10px;
}
.country-select .select-col .btn-info.dropdown-toggle span {
  font-size: 0;
}
.country-select .select-col .dropdown-menu {
  font-size: 0;
  width: 79px;
  min-width: inherit;
  margin-top: 0;
  border-radius: 10px;
  padding: 0;
}
.country-select .select-col .dropdown-menu li {
  margin: 14px 13px;
}
.country-select .select-col .dropdown-menu li:first-child {
  display: none;
}
.country-select .select-col .dropdown-menu li a {
  display: inline-block;
  cursor: pointer;
}
.country-select .select-col .flagstrap-icon.flagstrap-in,
.country-select .select-col .flagstrap-icon.flagstrap-ng,
.country-select .select-col .flagstrap-icon.flagstrap-gb,
.country-select .select-col .flagstrap-icon.flagstrap-us {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-position: center;
  width: 33px;
  height: 22px;
  background-size: cover;
  border-radius: 4px;
}
.country-select .select-col .flagstrap-icon.flagstrap-ng {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.country-select .select-col .flagstrap-icon.flagstrap-gb {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.country-select .select-col .flagstrap-icon.flagstrap-us {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.country-select .number-col input {
  padding-left: 96px;
}

.location-text h5 {
  color: #000000;
  margin-top: 5px;
}

.location-search {
  margin: 12px 0;
}

.skip-now-col {
  margin-top: 5px;
}
.skip-now-col a {
  color: #000000;
  font-size: 12px;
}

.sort-by-col .select2-container .select2-selection--single {
  border-color: #e8eeff;
  border-radius: 10px;
  width: 160px;
}
.sort-by-col .select2-container--default .select2-selection--single .select2-selection__arrow b {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.premium-text {
  font-size: 18px;
}

.plan-details {
  list-style: none;
  margin: 0;
  padding: 4px 0 0;
}
.plan-details li {
  position: relative;
  min-width: 35%;
}
.plan-details li span {
  color: #b4abca;
  display: inline-block;
  margin-bottom: 3px;
  font-size: 15px;
}

.plan-chooser-col {
  background-color: rgba(175, 213, 254, 0.4);
  border-radius: 20px;
  margin: 0 0 28px;
  padding: 5px 20px;
}
.plan-chooser-col .memeber-img {
  border-radius: 15px;
  margin-bottom: 10px;
  width: 100%;
}
.plan-chooser-col .memeber-img img {
  border-radius: 15px;
}
.plan-chooser-col .subscription-list {
  margin: 15px 0;
}

.memeber-details h4 {
  margin-bottom: 0;
}

.payment-menthods ul {
  text-align: center;
}
.payment-menthods ul li {
  display: inline-block;
  margin: 0;
  padding: 6px;
}

.card-choose-col {
  max-width: 325px;
  margin: 0 auto;
}

.day-week-month-col ul li {
  float: left;
}
.day-week-month-col ul li:first-child a {
  border-radius: 4px 0 0 4px !important;
}
.day-week-month-col ul li:last-child a {
  border-radius: 0px 4px 4px 0px !important;
}
.day-week-month-col ul li a {
  background-color: #9d9d9d;
  border: 1px solid transparent;
  color: #64627c;
  display: inline-block;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  padding: 10px 20px;
}
.day-week-month-col ul li a.active {
  border-color: #536cf1;
  color: #536cf1;
  border-radius: 0 !important;
}
.day-week-month-col ul li a:first-child.active {
  border-color: #536cf1;
}
.day-week-month-col ul li a:last-child.active {
  border-color: #536cf1;
}

.login-body {
  background: #ffffff;
}

.login-content-info {
  margin: 0;
  padding: 160px 0 60px;
}
.login-content-info .account-content {
  position: relative;
}
.login-content-info .account-content .login-shapes {
  position: relative;
}
.login-content-info .account-content .login-shapes .shape-img-left {
  position: absolute;
  top: 0;
  left: -70px;
}
.login-content-info .account-content .login-shapes .shape-img-right {
  position: absolute;
  top: 150px;
  left: -70px;
}
@media (max-width: 991.98px) {
  .login-content-info .account-content .login-shapes .shape-img-right {
    top: 67px;
  }
}
@media (max-width: 767.98px) {
  .login-content-info .account-content .login-shapes {
    display: none;
  }
}
.login-content-info .account-content .account-info {
  position: relative;
  z-index: 1;
}
.login-content-info .account-content .account-info .btn {
  width: 100%;
  color: #ffffff;
  background: #0e82fd;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
  font-weight: 600;
  padding: 10px 15px;
}
@media (max-width: 767.98px) {
  .login-content-info .account-content .account-info .btn {
    padding: 8px 15px;
  }
}
.login-content-info .account-content .account-info .btn:hover {
  color: #0e82fd;
  background: #ffffff;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 50px #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.login-content-info .account-content .account-info .form-control {
  font-size: 14px;
}
.login-content-info .account-content .account-info .back-btn-light .btn {
  color: #000000;
  background-color: #f9f9f9;
  border: 1px solid #f9f9f9;
  box-shadow: inset 0 0 0 0 #ffffff;
}
.login-content-info .account-content .account-info .back-btn-light .btn:hover {
  color: #000;
  background-color: #ffffff;
  border: 1px solid #dcdcdc;
  box-shadow: inset 0 0 0 50px #ffffff;
}
.login-content-info .account-content .account-info .back-btn-light .btn i {
  margin-right: 10px;
}
.login-content-info .account-content .login-back {
  padding-bottom: 50px;
}
.login-content-info .account-content .login-back a {
  font-size: 15px;
  color: #959595;
}
.login-content-info .account-content .login-back a:hover {
  color: #0e82fd;
}
.login-content-info .account-content .login-back a i {
  margin-right: 10px;
}
@media (max-width: 991.98px) {
  .login-content-info .account-content .login-back {
    padding-bottom: 30px;
  }
}
@media (max-width: 767.98px) {
  .login-content-info .account-content .login-back {
    padding-bottom: 20px;
  }
}
.login-content-info .account-content .login-verify-img {
  padding-bottom: 50px;
}
@media (max-width: 991.98px) {
  .login-content-info .account-content .login-verify-img {
    padding-bottom: 30px;
  }
}
@media (max-width: 767.98px) {
  .login-content-info .account-content .login-verify-img {
    padding-bottom: 20px;
  }
}
.login-content-info .account-content .login-title {
  padding-bottom: 50px;
}
.login-content-info .account-content .login-title h3 {
  font-size: 30px;
  margin-bottom: 10px;
  font-weight: 600;
  color: #1f2937;
}
@media (max-width: 991.98px) {
  .login-content-info .account-content .login-title h3 {
    font-size: 26px;
  }
}
@media (max-width: 767.98px) {
  .login-content-info .account-content .login-title h3 {
    font-size: 20px;
  }
}
.login-content-info .account-content .login-title p {
  color: #71717a;
  margin-bottom: 10px;
}
.login-content-info .account-content .login-title span {
  color: #040404;
  font-weight: 500;
}
.login-content-info .account-content .login-title span a {
  color: #0e82fd;
  text-decoration: underline;
}
.login-content-info .account-content .login-title span a:hover {
  text-decoration: none;
}
@media (max-width: 991.98px) {
  .login-content-info .account-content .login-title {
    padding-bottom: 30px;
  }
}
@media (max-width: 767.98px) {
  .login-content-info .account-content .login-title {
    padding-bottom: 20px;
  }
}
.login-content-info .account-content .login-or {
  font-size: 16px;
  color: #818181;
  margin-bottom: 20px;
  padding-bottom: 10px;
  padding-top: 10px;
  position: relative;
}
.login-content-info .account-content .or-line {
  background-color: #efefef;
  height: 1px;
  margin-bottom: 0;
  margin-top: 0;
  display: block;
}
.login-content-info .account-content .span-or {
  background-color: #ffffff;
  display: block;
  position: absolute;
  top: -3px;
  left: 50%;
  margin-left: -20px;
  text-align: center;
  width: 42px;
}
.login-content-info .account-content .social-login-btn {
  margin-bottom: 20px;
}
.login-content-info .account-content .social-login-btn .btn {
  font-weight: 500;
  font-size: 14px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e4e4e8;
  padding: 11px 15px;
  border-radius: 8px;
  box-shadow: inset 0 0 0 0 #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.login-content-info .account-content .social-login-btn .btn:hover {
  color: #ffffff;
  background: #0e82fd;
  border: 1px solid #0e82fd;
  box-shadow: inset 0 0 0 50px #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.login-content-info .account-content .social-login-btn .btn img {
  margin-right: 15px;
}
@media (max-width: 991.98px) {
  .login-content-info {
    margin: 0;
    padding: 40px 0 40px;
  }
}
.login-content-info .form-group {
  margin-bottom: 20px;
}
.login-content-info .form-group label {
  color: #000000;
  display: inline-block;
  margin-bottom: 10px;
}

.pass-group {
  position: relative;
}
.pass-group .toggle-password {
  font-size: 16px;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  color: #797979;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.pass-group .toggle-password:hover {
  background-color: #f3f3f3;
}

.toggle-password-sub {
  font-size: 16px;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  color: #797979;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.toggle-password-sub:hover {
  background-color: #f3f3f3;
}

#passwordInfo,
#passwordInfos {
  font-size: 12px;
  font-weight: normal;
  margin-top: 15px;
}

.poor-active span.active#poor,
.poor-active span.active#poors {
  background: #ff0000;
}

.avg-active span.active#poor,
.avg-active span.active#poors,
.avg-active span.active#weak,
.avg-active span.active#weaks {
  background: #ffb54a;
}

.strong-active span.active#poor,
.strong-active span.active#weak,
.strong-active span.active#strong,
.strong-active span.active#poors,
.strong-active span.active#weaks,
.strong-active span.active#strongs {
  background: #0e82fd;
}

.heavy-active span.active#poor,
.heavy-active span.active#weak,
.heavy-active span.active#strong,
.heavy-active span.active#heavy,
.heavy-active span.active#poors,
.heavy-active span.active#weaks,
.heavy-active span.active#strongs,
.heavy-active span.active#heavys {
  background: #159f46;
}

input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear {
  display: none;
}

.password-strength {
  margin-top: 15px;
}
.password-strength span {
  width: 100%;
  height: 6px;
  background: #e4e6ef;
  margin-right: 10px;
  border-radius: 30px;
}
.password-strength span:last-child {
  margin-right: 0;
}

.weak-pass .password-strength span {
  background: #ff0000;
}

.pass-checked {
  position: absolute;
  top: 55%;
  right: 46px;
  transform: translateY(-50%);
  color: #4caf50;
  opacity: 0;
}
.pass-checked.active {
  opacity: 1;
}

.password-info {
  margin-top: 15px;
}

.password-info p {
  color: #9e9e9e;
  margin-bottom: 0;
}

.login-success-icon {
  padding-bottom: 18px;
}
.login-success-icon i {
  font-size: 40px;
  color: #00cc45;
}

.modal-open .main-wrapper {
  -webkit-filter: blur(1px);
  -moz-filter: blur(1px);
  -o-filter: blur(1px);
  -ms-filter: blur(1px);
  filter: blur(1px);
}

.call-main-row {
  overflow: auto;
  padding-bottom: inherit;
  padding-top: inherit;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.call-main-wrapper {
  display: table;
  height: 100%;
  table-layout: fixed;
  width: 100%;
}

.call-view {
  display: table-cell;
  height: 100%;
  float: none;
  position: static;
  vertical-align: top;
  width: 75%;
  padding: 0;
}

.call-window {
  display: table;
  height: 100%;
  table-layout: fixed;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
}

.fixed-header {
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  padding: 10px 15px;
}
.fixed-header .navbar {
  border: 0 none;
  min-height: auto;
  margin: 0;
  padding: 0;
}
.fixed-header .user-info a {
  color: #272b41;
  font-weight: 500;
}
.fixed-header .custom-menu {
  margin: 0 0 1px;
}

.typing-text {
  color: #20c0f3;
  font-size: 12px;
  text-transform: lowercase;
}

.last-seen {
  color: #888888;
  display: block;
  font-size: 12px;
}

.custom-menu {
  margin-top: 6px;
}
.custom-menu.nav > li > a {
  color: #bbb;
  font-size: 26px;
  line-height: 32px;
  margin-left: 15px;
  padding: 0;
}
.custom-menu.navbar-nav > li > a:hover,
.custom-menu.navbar-nav > li > a:focus {
  background-color: transparent;
}
.custom-menu .dropdown-menu {
  left: auto;
  right: 0;
}

.call-contents {
  display: table-row;
  height: 100%;
}

.call-content-wrap {
  height: 100%;
  position: relative;
  width: 100%;
}

.voice-call-avatar {
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex: 2;
  flex: 2;
}
.voice-call-avatar .call-avatar {
  width: 150px;
  height: 150px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  margin: 15px;
  padding: 3px;
  border-radius: 100%;
}
@media (max-width: 767.98px) {
  .voice-call-avatar .call-avatar {
    height: 100px;
    width: 100px;
  }
}
@media (max-width: 575.98px) {
  .voice-call-avatar .call-avatar {
    height: 80px;
    width: 80px;
  }
}
.voice-call-avatar .call-timing-count {
  padding: 5px;
}
.voice-call-avatar .username {
  font-size: 20px;
  font-weight: 500;
}

.call-duration {
  display: inline-block;
  font-size: 30px;
  margin-top: 4px;
  position: absolute;
  left: 0;
}
@media (max-width: 767.98px) {
  .call-duration {
    font-size: 24px;
  }
}
@media (max-width: 575.98px) {
  .call-duration {
    display: block;
    margin-top: 0;
    margin-bottom: 10px;
    position: inherit;
  }
}

.call-footer {
  background-color: #ffffff;
  border-top: 1px solid #f0f0f0;
  padding: 15px;
}

.call-icons {
  text-align: center;
  position: relative;
}
.call-icons .call-items {
  list-style: none;
  display: inline-block;
  border-radius: 5px;
  margin: 0;
  padding: 0;
}
.call-icons .call-items .call-item {
  display: inline-block;
  text-align: center;
  margin-right: 5px;
}
.call-icons .call-items .call-item:last-child {
  margin-right: 0;
}
.call-icons .call-items .call-item a {
  color: #777;
  border: 1px solid #dddddd;
  width: 50px;
  height: 50px;
  line-height: 50px;
  display: inline-block;
  font-size: 20px;
  border-radius: 50px;
}
.call-icons .call-items .call-item a i {
  width: 18px;
  height: 18px;
}
.call-icons .call-items li.end-call-new {
  display: inline-block;
  text-align: center;
  margin-right: 5px;
}
.call-icons .call-items li.end-call-new a {
  background-color: #f06060;
  color: #ffffff;
  display: inline-block;
  line-height: 10px;
  text-transform: uppercase;
  border-radius: 50px;
  padding: 8px 25px;
}

.user-video {
  overflow: auto;
  z-index: 10;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.user-video img,
.user-video video {
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  display: block;
  margin: 0 auto;
}

.my-video {
  z-index: 99;
  position: absolute;
  bottom: 20px;
  left: 20px;
}
.my-video ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.my-video ul li {
  float: left;
  width: 120px;
  margin-right: 10px;
}
@media (max-width: 767.98px) {
  .my-video ul li {
    width: 50px;
  }
}
.my-video ul li img {
  border: 3px solid #ffffff;
  border-radius: 6px;
}

.end-call {
  position: absolute;
  top: 7px;
  right: 0;
}
@media (max-width: 575.98px) {
  .end-call {
    margin-top: 10px;
    position: inherit;
  }
}
.end-call a {
  background-color: #f06060;
  color: #ffffff;
  display: inline-block;
  line-height: 10px;
  text-transform: uppercase;
  padding: 8px 25px;
  border-radius: 50px;
}

.call-users {
  z-index: 99;
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.call-users ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.call-users ul li {
  float: left;
  width: 80px;
  margin-left: 10px;
}
@media (max-width: 767.98px) {
  .call-users ul li {
    width: 50px;
  }
}
.call-users ul li img {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 2px;
}
.call-users ul li a:hover .call-mute {
  display: block;
}

.call-mute {
  width: 80px;
  height: 80px;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
  line-height: 80px;
  font-size: 30px;
  color: #ffffff;
  display: none;
  border: 3px solid transparent;
  border-radius: 6px;
  position: absolute;
  top: 0;
}
@media (max-width: 767.98px) {
  .call-mute {
    font-size: 20px;
    height: 50px;
    line-height: 50px;
    width: 50px;
  }
}

.call-details {
  margin: 10px 0 0;
}

.call-info {
  margin-left: 10px;
  width: 100%;
}

.call-user-details,
.call-timing {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.call-description {
  white-space: nowrap;
  vertical-align: bottom;
}

.call-timing {
  color: #727272;
  font-size: 14px;
  margin-top: 1px;
  overflow: hidden;
  white-space: pre;
}

.content-full {
  height: 100%;
  position: relative;
  width: 100%;
}

.video-window .fixed-header {
  margin: 0;
  padding: 0;
}
.video-window .fixed-header .nav > li > a {
  padding: 18px 15px;
}

.user-img {
  display: inline-block;
  position: relative;
}

span.call-duration.float-end {
  display: inline-block;
  font-size: 22px;
  margin-top: 0px;
  color: #40dda4;
  position: absolute;
  right: 0;
  left: unset;
}

.toggle-voice-video {
  display: inline-block;
  font-size: 30px;
  margin-top: 4px;
  position: absolute;
  left: 0;
}
.toggle-voice-video .switch {
  position: relative;
  display: inline-block;
  width: 90px;
  height: 34px;
}
.toggle-voice-video .switch input {
  display: none;
}
.toggle-voice-video .slider {
  cursor: pointer;
  background-color: #2196f3;
  -webkit-transition: 0.4s;
  -ms-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.toggle-voice-video .slider:before {
  content: "";
  height: 26px;
  width: 26px;
  background-color: #ffffff;
  -webkit-transition: 0.4s;
  -ms-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
  position: absolute;
  bottom: 4px;
  left: 4px;
}
.toggle-voice-video .slider:after {
  content: "VOICE";
  color: #ffffff;
  display: block;
  font-size: 10px;
  font-family: Verdana, sans-serif;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
}
.toggle-voice-video input:checked + .slider {
  background-color: #2ab934;
}
.toggle-voice-video input:checked + .slider:before {
  transform: translateX(55px);
  -webkit-transform: translateX(55px);
  -ms-transform: translateX(55px);
}
.toggle-voice-video input:checked + .slider:after {
  content: "VIDEO";
}
.toggle-voice-video input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

.map-page .footer {
  display: none;
}
.map-page .header {
  z-index: 1030;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
}
.map-page .content {
  padding-top: 115px;
}
@media (max-width: 991.98px) {
  .map-page .content {
    padding-top: 100px;
  }
}

.map-right {
  height: 100%;
  min-height: 100%;
  padding-right: 30px;
  z-index: 1029;
  position: fixed;
  top: 115px;
  right: 0;
  bottom: 0;
}
@media (max-width: 1199.98px) {
  .map-right {
    height: 450px;
    position: static;
    min-height: inherit;
    margin-bottom: 30px;
    padding-right: 15px;
  }
}
.map-right .available-info {
  margin-bottom: 0;
}

.map-listing {
  height: calc(100vh - 145px);
  width: 100%;
}
@media (max-width: 1199.98px) {
  .map-listing {
    height: 450px;
  }
}
.map-listing .profile-widget {
  width: 200px !important;
  border: 0;
  margin-bottom: 0;
  padding: 0;
}

.view-icons {
  display: inline-flex;
  float: right;
}
.view-icons a {
  background-color: #ffffff;
  border: 1px solid #dddddd;
  color: #212529;
  font-size: 20px;
  text-align: center;
  margin-left: 10px;
  width: 44px;
  height: 44px;
  border-radius: 4px;
  padding: 4px 10px;
}
.view-icons a:hover {
  border-color: #20c0f3;
  color: #20c0f3;
}
.view-icons a.active {
  background-color: #20c0f3;
  border-color: #20c0f3;
  color: #ffffff;
}

.breadcrumb-bar {
  background-color: #15558d;
  padding: 15px 0;
}

.page-breadcrumb ol {
  background-color: transparent;
  font-size: 12px;
  margin-bottom: 0;
  padding: 0;
}
.page-breadcrumb ol li a {
  color: #ffffff;
}
.page-breadcrumb ol li.active {
  color: #ffffff;
}
.page-breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  color: #ffffff;
  font-size: 10px;
}

.breadcrumb-bar-one {
  background: #f2f6f6;
  background-repeat: no-repeat;
  padding-top: 70px;
  min-height: 300px;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.breadcrumb-bar-one::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.breadcrumb-bar-one .inner-banner {
  margin: 0;
  padding: 70px 0;
}
.breadcrumb-bar-one .inner-banner .breadcrumb-title {
  font-weight: 600;
  font-size: 48px;
  margin-bottom: 6px;
}
@media (max-width: 991.98px) {
  .breadcrumb-bar-one .inner-banner .breadcrumb-title {
    font-size: 36px;
  }
}
@media (max-width: 767.98px) {
  .breadcrumb-bar-one .inner-banner .breadcrumb-title {
    font-size: 26px;
  }
}
@media (max-width: 767.98px) {
  .breadcrumb-bar-one .inner-banner {
    margin: 0;
    padding: 50px 0;
  }
}
@media (max-width: 991.98px) {
  .breadcrumb-bar-one {
    padding-top: 40px;
    min-height: 260px;
  }
}
@media (max-width: 767.98px) {
  .breadcrumb-bar-one {
    min-height: auto;
  }
}
.breadcrumb-bar-one .page-breadcrumb ol {
  background-color: transparent;
  font-weight: 500;
  margin: 0;
  padding: 0;
}
.breadcrumb-bar-one .page-breadcrumb ol li a {
  font-weight: 500;
  color: #4b5563;
}
.breadcrumb-bar-one .page-breadcrumb ol li.active {
  color: #1f2937;
}
@media (max-width: 767.98px) {
  .breadcrumb-bar-one .page-breadcrumb ol {
    font-size: 15px;
  }
}
.breadcrumb-bar-one .page-breadcrumb .breadcrumb a:hover {
  color: #09e5ab;
}
.breadcrumb-bar-one .page-breadcrumb .breadcrumb-item + .breadcrumb-item {
  font-weight: 500;
  color: #1f2937;
  padding-left: 10px;
}
.breadcrumb-bar-one .breadcrumb-item + .breadcrumb-item::before {
  content: "/";
  font-family: "feather";
  float: left;
  padding-right: 10px;
  color: #9ca3af;
  font-size: 14px;
  font-weight: 600;
}

.sort-by {
  float: right;
}

.sort-title {
  color: #ffffff;
  font-size: 14px;
  margin-right: 10px;
}

.sortby-fliter {
  display: inline-block;
  width: 120px;
}

.cal-icon {
  position: relative;
  width: 100%;
}
.cal-icon:after {
  color: #979797;
  content: "\\f073";
  display: block;
  font-family: "Font Awesome 5 Free";
  font-size: 16px;
  font-weight: 400;
  margin: auto;
  position: absolute;
  top: 10px;
  right: 15px;
}

.custom_check {
  color: #666;
  display: inline-block;
  position: relative;
  font-size: 14px;
  font-size: 0.9375rem;
  padding-left: 30px;
  margin-bottom: 10px;
  cursor: pointer;
}
.custom_check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.custom_check input:checked ~ .checkmark {
  background-color: #ffffff;
}
.custom_check input:checked ~ .checkmark:after {
  display: block;
}
.custom_check .checkmark {
  height: 20px;
  width: 20px;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;
  border-radius: 3px;
  -webkit-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
}
.custom_check .checkmark::after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  display: none;
  color: #0de0fe;
  font-size: 11px;
  position: absolute;
  top: 0;
  left: 4px;
}

.custom_radio {
  color: #555;
  display: inline-block;
  position: relative;
  font-size: 14px;
  font-size: 15px;
  padding-left: 30px;
  margin-bottom: 10px;
  cursor: pointer;
}
.custom_radio input {
  position: absolute;
  opacity: 0;
}
.custom_radio input:checked ~ .checkmark:after {
  opacity: 1;
}
.custom_radio .checkmark {
  height: 20px;
  width: 20px;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
}
.custom_radio .checkmark:after {
  display: block;
  content: "";
  opacity: 0;
  width: 12px;
  height: 12px;
  background: #ff9b44;
  border-radius: 50%;
  -webkit-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  position: absolute;
  top: 3px;
  left: 3px;
}

.radio_input .custom_radio + .custom_radio {
  margin-left: 15px;
}

.filter-widget {
  margin-bottom: 20px;
}
.filter-widget h4 {
  font-size: 1rem;
  margin-bottom: 15px;
}
.filter-widget .custom_check {
  line-height: 18px;
}

.btn-search .btn {
  background-color: #0de0fe;
  border: 1px solid #0de0fe;
  color: #ffffff;
  height: 46px;
  font-weight: 500;
  font-size: 16px;
}

@media (max-width: 767.98px) {
  .doctor-widget {
    -ms-flex-direction: column;
    flex-direction: column;
    text-align: center;
  }
}
.doctor-widget .doc-name {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 3px;
}
@media (max-width: 767.98px) {
  .doctor-widget .doc-name {
    font-size: 18px;
  }
}
.doctor-widget .rating i {
  font-size: 14px;
}
.doctor-widget .average-rating {
  font-size: 14px;
  font-weight: 500;
}

@media (max-width: 767.98px) {
  .doc-info-left {
    -ms-flex-direction: column;
    flex-direction: column;
  }
}

.doc-info-right {
  margin-left: auto;
  -ms-flex: 0 0 200px;
  flex: 0 0 200px;
  max-width: 200px;
}
@media (max-width: 767.98px) {
  .doc-info-right {
    margin-left: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.doctor-img {
  -ms-flex: 0 0 150px;
  flex: 0 0 150px;
  margin-right: 20px;
  width: 150px;
}
@media (max-width: 767.98px) {
  .doctor-img {
    margin: 0 auto 20px;
  }
}
.doctor-img img {
  border-radius: 5px;
}

.doc-department {
  color: #20c0f3;
  font-size: 14px;
  margin-bottom: 8px;
}
.doc-department img {
  width: 19px;
  display: inline-block;
  margin-right: 10px;
}

.doc-location {
  color: #757575;
  font-size: 14px;
  margin-bottom: 25px;
}
.doc-location a {
  color: #09e5ab;
  font-weight: 500;
}

.doc-speciality {
  font-size: 14px;
  color: #757575;
  margin-bottom: 15px;
}

.clinic-details {
  margin-bottom: 15px;
}
.clinic-details h5 {
  font-weight: normal;
  color: #757575;
  margin-bottom: 25px;
}
.clinic-details ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.clinic-details ul li {
  display: inline-block;
  padding-right: 5px;
}
.clinic-details ul li:last-child {
  padding-right: 0;
}
.clinic-details ul li a {
  display: inline-block;
}
.clinic-details ul li a img {
  width: 40px;
  border-radius: 5px;
}

.clinic-services {
  color: #272b41;
  font-size: 13px;
}
@media (max-width: 767.98px) {
  .clinic-services {
    display: none;
  }
}
.clinic-services span {
  border: 1px solid #cccccc;
  display: inline-block;
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 4px;
}
.clinic-services span + span {
  margin-left: 5px;
}

.clini-infos {
  margin-bottom: 15px;
}
.clini-infos ul {
  font-size: 14px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.clini-infos ul li {
  display: block;
  line-height: 30px;
  color: #4e4852;
}
.clini-infos ul li i {
  font-size: 15px;
  min-width: 20px;
}

.clinic-booking a {
  background-color: #ffffff;
  border: 2px solid #20c0f3;
  color: #20c0f3;
  display: block;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  text-align: center;
  text-transform: capitalize;
  width: 100%;
  padding: 10px 15px;
  border-radius: 4px;
}
.clinic-booking a + a {
  margin-top: 15px;
}
.clinic-booking a.view-pro-btn:hover,
.clinic-booking a.view-pro-btn:focus {
  background: #20c0f3;
  color: #ffffff;
}
.clinic-booking a.apt-btn {
  background: #20c0f3;
  color: #ffffff;
}
@media (max-width: 479.98px) {
  .clinic-booking a.apt-btn {
    width: 100%;
  }
}
.clinic-booking a.apt-btn:hover,
.clinic-booking a.apt-btn:focus {
  background-color: #0db9f2;
  border-color: #0db9f2;
  color: #ffffff;
}
@media (max-width: 479.98px) {
  .clinic-booking a.view-pro-btn {
    width: 100%;
    margin-bottom: 15px;
  }
}

.load-more {
  margin-bottom: 30px;
}

.filter-contents {
  border: 2px solid #f3f4f6;
  border-radius: 10px;
}
@media (max-width: 991.98px) {
  .filter-contents {
    margin-bottom: 24px;
  }
}

.filter-header {
  background: #f2f6f6;
  border-radius: 10px 10px 0px 0px;
  padding: 15px 20px;
}
.filter-header .filter-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0;
}

.filter-details {
  padding: 20px;
}

.filter-grid {
  padding-bottom: 25px;
}
.filter-grid h4 {
  margin-bottom: 0;
}
.filter-grid h4 a {
  font-weight: 600;
  font-size: 16px;
  color: #1f2937;
  position: relative;
}
.filter-grid h4 a:hover {
  color: #272b41;
}
.filter-grid h4 a::before {
  content: "\\e92e";
  font-family: "feather";
  color: #1f2937;
  border-radius: 50%;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  position: absolute;
  right: 0;
  line-height: normal;
}
.filter-grid h4 a:not(.collapsed)::before {
  content: "\\e931";
  font-family: "feather";
  border-radius: 50%;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.filter-collapse {
  padding-top: 20px;
}
.filter-collapse ul {
  padding: 0;
  margin: 0;
  list-style: 0;
}
.filter-collapse ul li {
  display: block;
  margin-bottom: 10px;
}
.filter-collapse ul li:last-child {
  margin-bottom: 0;
}
.filter-collapse ul li .custom_check {
  padding-left: 26px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #6b7280;
  margin-bottom: 0;
}
.filter-collapse ul li .custom_check.custom_check .checkmark {
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  height: 17px;
  width: 17px;
  top: 3px;
}
.filter-collapse ul li .custom_check input:checked ~ .checkmark {
  background: #ffffff;
  border-color: #0e82fd;
}
.filter-collapse ul li .custom_check .checkmark::after {
  content: "";
  background: #0e82fd;
  width: 10px;
  height: 10px;
  top: 3px;
  left: 3px;
  border-radius: 3px;
}
.filter-collapse ul li .custom_check .online-icon {
  font-size: 20px;
  margin-right: 10px;
  margin-left: 5px;
}

.rating_custom_check {
  width: 100%;
}
.rating_custom_check .rating {
  width: 100%;
}
.rating_custom_check .rating .rating-count {
  font-weight: 500;
  float: right;
  color: #9ca3af;
}

.filter-content-slider p {
  color: #1f2937;
  margin-bottom: 15px;
}
.filter-content-slider p span {
  float: right;
}

.price-wrapper {
  margin: 15px 0 0;
  font-size: 14px;
}
.price-wrapper h6 {
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 0;
}
.price-wrapper h6 span {
  font-weight: 600;
  color: #1f2937;
}

.slider-wrapper .ui-slider-handle {
  background: #0e82fd;
  border: 0;
  border-radius: 50%;
  box-shadow: 0px 4px 4px rgba(124, 124, 124, 0.25);
  width: 18px;
  height: 18px;
  box-shadow: 0 0px 0px 4px #0e82fd;
  width: 12px;
  height: 12px;
  background: #ffffff;
  margin: 0;
}

#price-range.ui-slider-horizontal {
  height: 6px;
  border: 0;
  border-radius: 25px;
  background: #e9ecf1;
}

.ui-widget-header {
  background: #0e82fd;
}

.filter-btn .btn {
  font-weight: 600;
  font-size: 15px;
  padding: 7px 15px;
  border-radius: 6px;
}

.doctor-filter-info {
  padding-bottom: 30px;
}
@media (max-width: 767.98px) {
  .doctor-filter-info {
    display: none;
  }
}

.doctors-found {
  padding-bottom: 12px;
}
.doctors-found p {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 0;
}
.doctors-found p span {
  color: #1f2937;
}
@media (max-width: 1399.98px) {
  .doctors-found p {
    font-size: 14px;
  }
}

.doctor-filter-availability p {
  font-weight: 600;
  color: #4b5563;
  margin-right: 6px;
  margin-bottom: 0;
}

.doctor-filter-option {
  flex-shrink: 0;
}

.doctor-filter-sort {
  padding-right: 15px;
}
.doctor-filter-sort:last-child {
  padding-right: 0;
}
.doctor-filter-sort p {
  color: #8c97b0;
  margin-right: 15px;
  margin-bottom: 0;
}
.doctor-filter-sort .filter-today {
  margin-right: 0;
}
.doctor-filter-sort .filter-today i {
  font-size: 18px;
  margin-right: 10px;
}
.doctor-filter-sort .nav li {
  margin-right: 8px;
}
.doctor-filter-sort .nav li:last-child {
  margin-right: 0;
}
.doctor-filter-sort .nav li a {
  width: 32px;
  height: 32px;
  background: #ffffff;
  border: 2px solid #f3f4f6;
  border-radius: 7px;
  color: #6b7280;
}
.doctor-filter-sort .nav li a:hover {
  background: #0e82fd;
  border: 2px solid #0e82fd;
  color: #ffffff;
}
.doctor-filter-sort .nav li a:hover img {
  filter: invert(1) brightness(100);
}
.doctor-filter-sort .nav li a.active {
  background: #0e82fd;
  border: 2px solid #0e82fd;
  color: #ffffff;
}
.doctor-filter-sort .nav li a.active img {
  filter: invert(1) brightness(100);
}

.doctor-filter-select {
  width: 94px;
}
.doctor-filter-select .select2-container .select2-selection--single {
  background-color: #f2f6f6;
  border: 1px solid #f3f4f6;
  height: 32px;
}
.doctor-filter-select
  .select2-container--default
  .select2-selection--single
  .select2-selection__rendered {
  line-height: 32px;
  padding-left: 10px;
  font-weight: 600;
  color: #1f2937;
}
.doctor-filter-select
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow {
  height: 30px;
}

.doctor-card {
  border: 2px solid #f3f4f6;
  border-radius: 10px;
}

.doctor-widget-one .doc-name {
  margin-bottom: 4px;
  font-size: 20px;
}
.doctor-widget-one .doc-name a {
  color: #1f2937;
}
.doctor-widget-one .doc-name i {
  margin-left: 8px;
  font-size: 16px;
  color: #22c550;
}
@media (max-width: 991.98px) {
  .doctor-widget-one .doc-name {
    font-size: 18px;
  }
}
@media (max-width: 767.98px) {
  .doctor-widget-one {
    text-align: center;
    flex-direction: column;
  }
}
@media (max-width: 767.98px) {
  .doctor-widget-one .doc-info-left {
    flex-direction: column;
  }
}
.doctor-widget-one .doctor-img {
  -ms-flex: 0 0 164px;
  flex: 0 0 164px;
  margin-right: 20px;
  width: 164px;
  height: 164px;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
}
.doctor-widget-one .doctor-img img {
  width: 164px;
  height: 164px;
  border-radius: 10px;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
}
.doctor-widget-one .doctor-img:hover img {
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}
@media (max-width: 767.98px) {
  .doctor-widget-one .doctor-img {
    margin: 0 auto 20px;
    padding: 0;
  }
}
.doctor-widget-one .favourite-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}
.doctor-widget-one .favourite-btn .favourite-icon {
  background-color: #ffffff;
  border: 1px solid #edf1f1;
  width: 30px;
  height: 30px;
  font-size: 14px;
  border-radius: 50px;
  color: #9ca3af;
  -webkit-transition: all 0.4s ease 0s;
  -ms-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;
}
.doctor-widget-one .favourite-btn .favourite-icon:hover {
  color: #fb1612;
}
.doctor-widget-one .favourite-btn .favourite-icon.favourite {
  animation: size 0.4s;
  color: #ff3333;
}
.doctor-widget-one .doc-speciality {
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 20px;
}
.doctor-widget-one .clinic-details {
  padding-bottom: 14px;
}
.doctor-widget-one .doc-info-cont .reviews-ratings p {
  font-size: 12px;
}
.doctor-widget-one .doc-info-cont .reviews-ratings p span {
  font-size: 14px;
  margin: 0 4px 0 0;
  padding: 2px 5px;
}
.doctor-widget-one .doc-location {
  font-weight: 500;
  margin-bottom: 14px;
}
.doctor-widget-one .doc-location:last-child {
  margin-bottom: 0;
}
.doctor-widget-one .doc-location span {
  color: #1f2937;
  margin-right: 3px;
}
.doctor-widget-one .doc-location i {
  margin-right: 10px;
  font-size: 18px;
  color: #9ca3af;
}
@media (max-width: 767.98px) {
  .doctor-widget-one .doc-location i {
    margin: 0 0 5px 0;
    padding: 0;
  }
}
.doctor-widget-one .doc-location a {
  font-weight: 500;
  color: #0e82fd;
  margin-left: 8px;
}
.doctor-widget-one .doc-location a:hover {
  color: #000000;
}
@media (max-width: 767.98px) {
  .doctor-widget-one .doc-location {
    flex-direction: column;
  }
}
.doctor-widget-one .doc-info-right {
  margin-left: auto;
  -ms-flex: 0 0 240px;
  flex: 0 0 240px;
  max-width: 240px;
}
@media (max-width: 991.98px) {
  .doctor-widget-one .doc-info-right {
    -ms-flex: 0 0 270px;
    flex: 0 0 270px;
    max-width: 270px;
  }
}
@media (max-width: 767.98px) {
  .doctor-widget-one .doc-info-right {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
    margin-left: 0;
  }
}
.doctor-widget-one .doc-info-details {
  margin-left: auto;
  max-width: 230px;
}
@media (max-width: 767.98px) {
  .doctor-widget-one .doc-info-details {
    margin: 0 auto 0;
    padding: 0;
  }
}
.doctor-widget-one .clini-infos {
  margin-bottom: 15px;
}
.doctor-widget-one .clini-infos ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.doctor-widget-one .clini-infos ul li {
  color: #6b7280;
  margin-bottom: 8px;
}
.doctor-widget-one .clini-infos ul li:last-child {
  margin-bottom: 0;
}
.doctor-widget-one .clini-infos ul li .available-date {
  border-radius: 5px;
  padding: 3px 15px;
  font-weight: normal;
}
.doctor-widget-one .clini-infos ul li .available-today {
  background: #dcfce5;
  color: #22c550;
  font-weight: 500;
}
.doctor-widget-one .clini-infos ul li .available-tomorrow {
  background: #fff6d8;
  color: #f3db00;
}
.doctor-widget-one .clini-infos ul li .available-icon {
  font-size: 18px;
  color: #9ca3af;
  margin-right: 10px;
}
.doctor-widget-one .clini-infos ul li .votes {
  font-size: 12px;
  color: #9ca3af;
  margin-left: 5px;
}
.doctor-widget-one .clini-infos ul li .available-info-icon {
  font-size: 14px;
  color: #9ca3af;
  margin-left: 5px;
}
@media (max-width: 767.98px) {
  .doctor-widget-one .clini-infos ul li {
    display: block;
  }
}
@media (max-width: 767.98px) {
  .doctor-widget-one .clini-infos {
    margin: 20px 0 15px 0;
    padding: 0;
  }
}
.doctor-widget-one .clinic-booking .btn {
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  border: 2px solid #09e5ab;
  padding: 6px 15px;
}
.doctor-widget-one .clinic-booking .btn-primary-light {
  color: #09e5ab;
  background: #ffffff;
  box-shadow: inset 0 0 0 0 #09e5ab;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
  margin-top: 8px;
}
.doctor-widget-one .clinic-booking .btn-primary-light:hover {
  color: #ffffff;
  background: #09e5ab;
  box-shadow: inset 0 0 0 50px #09e5ab;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.doctor-widget-one .clinic-booking.book-appoint .btn-primary {
  color: #fff;
  background-color: #0e82fd;
  border: 2px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #fff;
}
.doctor-widget-one .clinic-booking.book-appoint .btn-primary:hover {
  color: #0e82fd;
  background-color: #ffffff;
  border-color: #0e82fd;
  box-shadow: inset 0 0 0 50px #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.doctor-widget-one .clinic-booking.book-appoint .btn-primary-light {
  color: #0e82fd;
  background: #ffffff;
  box-shadow: inset 0 0 0 0 #0e82fd;
  border: 2px solid #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.doctor-widget-one .clinic-booking.book-appoint .btn-primary-light:hover {
  color: #fff;
  background-color: #0e82fd;
  border: 2px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #fff;
}

.doctor-profile-widget.doc-grid {
  margin-bottom: 24px;
}
.doctor-profile-widget.doc-grid .doc-pro-img .doctor-profile-img {
  margin: 15px 15px 0;
}
.doctor-profile-widget.doc-grid .doc-pro-img .doctor-profile-img img {
  border-radius: 10px;
}
.doctor-profile-widget.doc-grid .doc-pro-img .favourite-btn {
  top: 15px;
  right: 25px;
}
.doctor-profile-widget.doc-grid .doc-pro-img .reviews-ratings {
  position: absolute;
  top: 15px;
  left: 25px;
}
.doctor-profile-widget.doc-grid .doc-pro-img .reviews-ratings p span {
  min-width: 52px;
  font-size: 14px;
  margin: 0;
  padding: 2px 3px;
}
.doctor-profile-widget.doc-grid .doc-content {
  padding: 15px;
}
.doctor-profile-widget.doc-grid .doc-content .review-price p {
  font-weight: 500;
  font-size: 18px;
  color: #28283c;
}
.doctor-profile-widget.doc-grid .doc-content .review-price p span {
  font-size: 13px;
  color: #6b7280;
}
@media (max-width: 1399.98px) {
  .doctor-profile-widget.doc-grid .doc-content .review-price p {
    font-size: 14px;
  }
}
.doctor-profile-widget.doc-grid .doc-content .doc-pro-name {
  width: 100%;
  overflow: hidden;
}
.doctor-profile-widget.doc-grid .doc-content .doc-pro-name h4 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 2px;
}
.doctor-profile-widget.doc-grid .doc-content .doc-pro-name h4 a {
  margin-right: 6px;
}
.doctor-profile-widget.doc-grid .doc-content .doc-pro-name h4 i {
  color: #22c550;
}
.doctor-profile-widget.doc-grid .doc-content .doc-pro-location p {
  margin-bottom: 10px;
  font-size: 14px;
}
.doctor-profile-widget.doc-grid .doc-content .doc-pro-location p:last-child {
  margin-bottom: 0;
}
.doctor-profile-widget.doc-grid .doc-content .doc-pro-location p i {
  color: #9ca3af;
  font-size: 18px;
}
.doctor-profile-widget.doc-grid .doc-content .doc-pro-location p span {
  color: #1f2937;
  margin-right: 2px;
}
.doctor-profile-widget.doc-grid .favourite-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}
.doctor-profile-widget.doc-grid .favourite-btn .favourite-icon {
  background-color: #ffffff;
  border: 1px solid #edf1f1;
  width: 30px;
  height: 30px;
  font-size: 14px;
  border-radius: 50px;
  color: #484848;
  -webkit-transition: all 0.4s ease 0s;
  -ms-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;
}
.doctor-profile-widget.doc-grid .favourite-btn .favourite-icon:hover {
  color: #fb1612;
}
.doctor-profile-widget.doc-grid .favourite-btn .favourite-icon.favourite {
  animation: size 0.4s;
  color: #ff3333;
}

.filter-collapse .more-view {
  color: #0e82fd;
}

.more-view {
  color: #0e82fd;
  font-size: 14px;
  font-weight: 500;
}

.fill-more {
  height: 97px;
  overflow: hidden;
  border-bottom: 1px solid #f3f4f6;
  margin-bottom: 10px !important;
}

.apply-btn .btn-primary {
  color: #fff;
  background-color: #0e82fd;
  border: 2px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #ffffff;
  display: grid;
}
.apply-btn .btn-primary:hover {
  color: #0e82fd;
  background-color: #ffffff;
  border-color: #0e82fd;
  box-shadow: inset 0 0 0 50px #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.apply-btn .btn-outline-primary {
  color: #0e82fd;
  background: #ffffff;
  box-shadow: inset 0 0 0 0 #0e82fd;
  border: 2px solid #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
  display: grid;
}
.apply-btn .btn-outline-primary:hover {
  color: #ffffff;
  background-color: #0e82fd;
  border: 2px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #ffffff;
}

.map-right {
  height: 100%;
  min-height: 100%;
  padding-right: 30px;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1029;
  display: none;
}
.map-right .available-info {
  margin-bottom: 0;
}
@media (max-width: 1199.98px) {
  .map-right {
    position: static;
    height: 450px;
  }
}
.map-right.grid-list-map {
  display: block;
  padding-right: 0px;
  top: 80px;
}

.map-listing {
  height: calc(100vh - 0px);
  width: 100%;
}
.map-listing .profile-widget {
  width: 320px;
  padding: 0;
  border: 0;
  margin-bottom: 0;
}
@media (max-width: 1199.98px) {
  .map-listing {
    height: 450px;
  }
}

.info-widget {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.card-label > label {
  background-color: #ffffff;
  color: #959595;
  display: inline-block;
  font-size: 13px;
  font-weight: 500;
  margin: 6px auto auto 8px;
  padding: 0 7px;
}
@media (max-width: 991.98px) {
  .card-label > label {
    font-size: 12px;
  }
}
.card-label > input {
  background-color: #ffffff;
  border: 1px solid #dbdbdb;
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  display: block;
  height: 50px;
  margin-top: -13px;
  -webkit-transition: border-color 0.3s;
  -ms-transition: border-color 0.3s;
  transition: border-color 0.3s;
  width: 100%;
  border-radius: 4px;
  padding: 5px 15px 0;
}

.exist-customer a {
  color: #20c0f3;
  font-weight: 500;
}

.payment-widget .payment-list + .payment-list {
  margin-bottom: 15px;
}

.payment-radio {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  color: #272b41;
  text-transform: capitalize;
}
.payment-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.payment-radio .checkmark {
  width: 19px;
  height: 19px;
  border: 2px solid #dddddd;
  border-radius: 50%;
  -webkit-transition: all 0.3s;
  -ms-transition: all 0.3s;
  transition: all 0.3s;
  margin: 3px 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
}
.payment-radio .checkmark::after {
  content: "";
  width: 9px;
  height: 9px;
  background-color: #20c0f3;
  opacity: 0;
  visibility: hidden;
  transform: scale(0.1);
  -webkit-transform: scale(0.1);
  -ms-transform: scale(0.1);
  border-radius: 50%;
  -webkit-transition: all 0.3s;
  -ms-transition: all 0.3s;
  transition: all 0.3s;
  position: absolute;
  top: 3px;
  left: 3px;
}
.payment-radio input:checked ~ .checkmark {
  border-color: #20c0f3;
}
.payment-radio input:checked ~ .checkmark::after {
  opacity: 1;
  visibility: visible;
  transform: scale(1);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
}

.booking-date {
  list-style: none;
  padding: 0;
}
.booking-date li {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #272b41;
  text-transform: capitalize;
  margin-bottom: 15px;
}
.booking-date li span {
  float: right;
  color: #757575;
  font-weight: 400;
  font-size: 15px;
}

.booking-fee {
  list-style: none;
  padding: 0;
}
.booking-fee li {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #272b41;
  text-transform: capitalize;
  margin-bottom: 15px;
}
.booking-fee li span {
  float: right;
  color: #757575;
  font-weight: 400;
  font-size: 15px;
}

.booking-total {
  border-top: 1px solid #e4e4e4;
  margin-top: 20px;
  padding-top: 20px;
}
.booking-total ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.booking-total ul li span {
  font-size: 18px;
  font-weight: 700;
  color: #272b41;
}
@media (max-width: 767.98px) {
  .booking-total ul li span {
    font-size: 14px;
  }
}
.booking-total ul li .total-cost {
  color: #20c0f3;
  font-size: 16px;
  float: right;
}
@media (max-width: 767.98px) {
  .booking-total ul li .total-cost {
    font-size: 14px;
  }
}

#calendar-events {
  background-color: #fcfcfc;
}

.calendar-events {
  border: 1px solid transparent;
  cursor: move;
  padding: 10px 15px;
}
.calendar-events:hover {
  border-color: #e9e9e9;
  background-color: #ffffff;
}
.calendar-events i {
  margin-right: 8px;
}

.calendar {
  float: left;
  margin-bottom: 0;
}

.fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5rem;
}
@media (max-width: 479.98px) {
  .fc-toolbar.fc-header-toolbar .fc-right {
    margin-bottom: 10px;
  }
}
@media (max-width: 479.98px) {
  .fc-toolbar.fc-header-toolbar .fc-left {
    margin-bottom: 10px;
  }
}
.fc-toolbar h2 {
  font-size: 18px;
  font-weight: 600;
  font-family: "Roboto", sans-serif;
  line-height: 30px;
  text-transform: uppercase;
}
.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar .ui-state-hover,
.fc-toolbar button:hover,
.fc-toolbar button:focus {
  z-index: 0;
}

.none-border .modal-footer {
  border-top: none;
}

.fc-day-grid-event .fc-time {
  font-family: "Roboto", sans-serif;
}

.fc-day {
  background: #ffffff;
}

.fc th.fc-widget-header {
  background: #eeeeee;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  padding: 10px 0;
}

.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #f3f3f3;
}
.fc-unthemed .fc-today {
  background: #ffffff;
}

.fc-basic-view .fc-day-number,
.fc-basic-view .fc-week-number {
  padding: 2px 5px;
}
.fc-basic-view td.fc-week-number span {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}
.fc-basic-view td.fc-day-number {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}

.fc-button {
  background: #f1f1f1;
  border: none;
  color: #797979;
  text-transform: capitalize;
  box-shadow: none !important;
  border-radius: 3px !important;
  height: auto !important;
  margin: 0 3px !important;
  padding: 6px 12px !important;
}

.fc-text-arrow {
  font-family: inherit;
  font-size: 16px;
}

.fc-state-hover {
  background: #f3f3f3;
}

.fc-state-highlight {
  background: #f0f0f0;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #20c0f3 !important;
  color: #ffffff !important;
  text-shadow: none !important;
}

.fc-cell-overlay {
  background: #f0f0f0;
}

.fc-event {
  border: none;
  color: #ffffff !important;
  cursor: move;
  font-size: 13px;
  text-align: center;
  border-radius: 2px;
  margin: 1px 7px;
  padding: 5px 5px;
}

.event-form .input-group .form-control {
  height: 40px;
}

.comp-header {
  margin-bottom: 1.875rem;
}
.comp-header .comp-title {
  color: #272b41;
}

.line {
  background-color: #20c0f3;
  height: 2px;
  margin: 0;
  width: 60px;
}

.comp-buttons .btn {
  margin-bottom: 5px;
}

.pagination-box .pagination {
  margin-top: 0;
}

.comp-dropdowns .btn-group {
  margin-bottom: 5px;
}

.progress-example .progress {
  margin-bottom: 1.5rem;
}

.progress-xs {
  height: 4px;
}

.progress-sm {
  height: 15px;
}

@media (max-width: 575.98px) {
  .progress-lg .page-link {
    font-size: 16px;
    padding: 0.5rem 0.625rem;
  }
}

.progress.progress-sm {
  height: 6px;
}
.progress.progress-md {
  height: 8px;
}
.progress.progress-lg {
  height: 18px;
}

.row.row-sm {
  margin-left: -3px;
  margin-right: -3px;
}
.row.row-sm > div {
  padding-left: 3px;
  padding-right: 3px;
}

@media (max-width: 575.98px) {
  .pagination-lg .page-link {
    font-size: 16px;
    padding: 0.5rem 0.625rem;
  }
}

.custom-edit-service textarea.form-control {
  min-height: 200px;
}
.custom-edit-service .service-upload {
  border: 1px solid #dcdcdc;
  border-radius: 0.25rem;
  text-align: center;
  background-color: #ffffff;
  position: relative;
  margin: 0 0 30px;
  padding: 70px 0;
}
.custom-edit-service .service-upload i {
  font-size: 50px;
  color: #858585;
}
.custom-edit-service .service-upload span {
  font-size: 15px;
  color: #858585;
  margin-top: 14px;
  display: block;
}
.custom-edit-service .service-upload input[type="file"] {
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
}

.upload-wrap li {
  margin: 10px;
  list-style: none;
}
.upload-wrap li:first-child {
  margin-left: 0;
}

.invoice-content {
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  margin-bottom: 30px;
  border-radius: 4px;
  padding: 30px;
}
@media (max-width: 575.98px) {
  .invoice-content {
    padding: 1.25rem;
  }
}

.invoice-item .invoice-logo {
  margin-bottom: 30px;
}
.invoice-item .invoice-logo img {
  width: auto;
  max-height: 52px;
}
.invoice-item .invoice-text {
  padding-top: 42px;
  padding-bottom: 36px;
}
.invoice-item .invoice-text h2 {
  color: #272b41;
  font-size: 36px;
  font-weight: 600;
}
.invoice-item .invoice-details {
  text-align: right;
  color: #757575;
  font-weight: 500;
}
@media (max-width: 767.98px) {
  .invoice-item .invoice-details {
    text-align: left;
  }
}
.invoice-item .invoice-details strong {
  color: #272b41;
}
.invoice-item .invoice-details-two {
  text-align: left;
}
.invoice-item .customer-text {
  font-size: 18px;
  color: #272b41;
  font-weight: 700;
  margin-bottom: 8px;
  display: block;
}
@media (max-width: 767.98px) {
  .invoice-item .customer-text {
    font-size: 16px;
  }
}

.invoice-info {
  margin-bottom: 30px;
}
.invoice-info p {
  margin-bottom: 0;
}
.invoice-info.invoice-info2 {
  text-align: right;
}
@media (max-width: 767.98px) {
  .invoice-info.invoice-info2 {
    text-align: left;
  }
}
.invoice-info h5 {
  font-size: 16px;
  font-weight: 500;
}

.invoice-table tr th,
.invoice-table tr td,
.invoice-table-two tr th,
.invoice-table-two tr td {
  color: #272b41;
  font-weight: 700;
  line-height: inherit;
  padding: 10px 20px;
}
.invoice-table tr td,
.invoice-table-two tr td {
  color: #757575;
  font-weight: 500;
}

.invoice-table-two {
  margin-bottom: 0;
}
.invoice-table-two tr th,
.invoice-table-two tr td {
  border-top: 0;
}
.invoice-table-two tr td {
  text-align: right;
}

.other-info {
  margin-top: 10px;
}

.terms-text {
  margin-bottom: 20px;
}
.terms-text h4 {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 20px;
}
.terms-text p {
  color: #666;
  display: inline-block;
  font-size: 16px;
}

.account-card {
  border-radius: 10px;
  font-size: 16px;
  text-align: center;
  margin: 0 0 30px;
  padding: 10px;
}
.account-card span {
  font-size: 24px;
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.info-list {
  margin-bottom: 10px;
}
.info-list .title {
  color: #272b41;
  font-weight: 500;
}
.info-list .text {
  color: #757575;
  display: block;
  overflow: hidden;
}

.banner-wrapper {
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
}
@media (max-width: 991.98px) {
  .banner-wrapper {
    max-width: 720px;
  }
}
.banner-wrapper .search-box-3 {
  background: #1e5c92;
  border-radius: 10px;
  position: absolute;
  margin: -50px 0 0;
  padding: 40px 20px;
}
@media (max-width: 991.98px) {
  .banner-wrapper .search-box-3 {
    display: none;
  }
}
.banner-wrapper .search-box-3 .search-location {
  -ms-flex: 0 0 240px;
  flex: 0 0 240px;
  margin-right: 12px;
  position: relative;
  width: 240px;
}
.banner-wrapper .search-box-3 .search-location .form-control {
  background: #ffffff url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat 10px center;
}
.banner-wrapper .search-box-3 .form-group {
  margin-bottom: 0px;
}
.banner-wrapper .search-box-3 .form-control {
  border: 1px solid #cccccc;
  box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  padding-left: 35px;
}
.banner-wrapper .search-box-3 .search-info {
  -ms-flex: 0 0 490px;
  flex: 0 0 490px;
  margin-right: 12px;
  position: relative;
  width: 490px;
}
.banner-wrapper .search-box-3 .search-info .form-control {
  background: #ffffff url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat 10px center;
}
.banner-wrapper .search-box-3 .form-control {
  background: #ffffff url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat 10px center;
}
.banner-wrapper .search-box-3 .search-btn {
  width: 46px;
  -ms-flex: 0 0 46px;
  flex: 0 0 46px;
  height: 46px;
}
.banner-wrapper .search-box-3 .search-btn span {
  display: none;
  font-weight: 500;
}

.btn-search {
  background: #ffffff;
  border: 1px solid #ffffff;
  color: #1e5c92;
}

.form-custom i {
  color: #dd2d4e;
  position: absolute;
  top: 35%;
  right: 15px;
}

.doctor-search-form select {
  border: 1px solid rgba(16, 222, 253, 0.1);
  box-shadow: 0px 4px 4px rgba(237, 237, 237, 0.25);
  border-radius: 5px;
}

.doctor-search-form input {
  border: 1px solid rgba(16, 222, 253, 0.1);
  box-shadow: 0px 4px 4px rgba(237, 237, 237, 0.25);
  border-radius: 5px;
}

.doctor-search-form input,
.doctor-search-form select {
  background: #ffffff;
  border-radius: 130px;
  min-height: 60px;
  border: 0;
}

.doctor-search-section {
  padding-top: 95px;
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-position: 50% 0;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 1;
}
@media (max-width: 991.98px) {
  .doctor-search-section {
    padding-top: 85px;
  }
}
.doctor-search-section .doctor-search {
  padding-bottom: 15px;
}
@media (max-width: 991.98px) {
  .doctor-search-section .doctor-search {
    padding: 30px 0;
  }
}
.doctor-search-section .banner-header h2 {
  color: #186db5;
  font-size: 32px;
  font-weight: 600;
  line-height: 54px;
}
@media (max-width: 767.98px) {
  .doctor-search-section .banner-header h2 {
    font-size: 26px;
    line-height: 40px;
  }
}
.doctor-search-section .doctor-search-form select,
.doctor-search-section .doctor-search-form input {
  border: 1px solid rgba(16, 222, 253, 0.1);
  box-shadow: 0px 4px 4px rgba(237, 237, 237, 0.25);
  border-radius: 5px;
}
@media (max-width: 991.98px) {
  .doctor-search-section .dr-img {
    display: none;
  }
}

.clinics-section {
  padding: 60px 0 40px;
  background: #ffffff;
}
@media (max-width: 991.98px) {
  .clinics-section {
    padding: 40px 0 25px;
  }
}
@media (max-width: 767.98px) {
  .clinics-section {
    padding: 30px 0 10px;
  }
}
.clinics-section .clinic-item:hover .clinics-card .clinics-img:after {
  background: rgba(45, 226, 253, 0.9);
  transition: all 0.5s;
}
.clinics-section .clinic-item:hover .clinics-icon {
  transform: translate(0, -180%);
  -webkit-transform: translate(0, -180%);
  -ms-transform: translate(0, -180%);
}
.clinics-section .clinic-item:hover .clinics-icon i {
  color: #1c5b90;
  background: #ffffff;
}
.clinics-section .clinics-card {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}
.clinics-section .clinics-card .clinics-img {
  position: relative;
}
.clinics-section .clinics-card .clinics-img:after {
  content: "";
  background: rgba(28, 91, 144, 0.9);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.clinics-section .clinics-card .clinics-info {
  margin: 0 auto;
  text-align: center;
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.clinics-section .clinics-card .clinics-info img {
  width: 60px !important;
  margin: auto;
  margin-bottom: 10px;
}
.clinics-section .clinics-card .clinics-info span {
  font-weight: 600;
  font-size: 18px;
  color: #ffffff;
}
.clinics-section .clinics-icon {
  transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -webkit-transition: all 0.3s ease 0s;
  -ms-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.clinics-section .clinics-icon i {
  border-radius: 50%;
  height: 35px;
  width: 35px;
  text-align: center;
  line-height: 35px;
  background: #10defd;
  color: #ffffff;
  margin: auto;
  display: block;
}

.section-heading {
  margin-bottom: 30px;
}
@media (max-width: 767.98px) {
  .section-heading {
    margin-bottom: 15px;
  }
}
.section-heading h2 {
  font-weight: 700;
  font-size: 26px;
  color: #1c5b90;
}
@media (max-width: 767.98px) {
  .section-heading h2 {
    font-size: 20px;
  }
}
.section-heading p {
  font-size: 14px;
  color: #757578;
  margin-bottom: 0;
}
.section-heading.bg-area h2 {
  color: #ffffff;
}
.section-heading.bg-area p {
  color: #ffffff;
}

.specialities-section {
  padding: 80px 0 55px;
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  background-position: 50% 0;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 1;
}
@media (max-width: 991.98px) {
  .specialities-section {
    padding: 60px 0 35px;
  }
}
@media (max-width: 767.98px) {
  .specialities-section {
    padding: 40px 0 15px;
  }
}
.specialities-section:after {
  content: "";
  background: rgba(25, 69, 107, 0.9);
  z-index: -1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.specialities-section .specialist-card {
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(183, 183, 183, 0.25);
  border-radius: 163px;
  align-items: center;
  margin: 0 0 25px;
  padding: 15px;
}
.specialities-section .specialist-card:hover {
  background: #e0f2ff;
}
.specialities-section .specialist-card:hover .specialist-img {
  background: #10defd;
  transition: all 0.5s;
}
.specialities-section .specialist-card:hover .specialist-nav i {
  background: #10defd;
  color: #ffffff;
}
.specialities-section .specialist-card .specialist-img {
  background: #1b5d92;
  height: 55px;
  width: 55px;
  border-radius: 50%;
  -webkit-transition: all 0.3s ease 0s;
  -ms-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  margin: 0 10px 0 0;
  padding: 10px;
}
.specialities-section .specialist-card .specialist-info p {
  font-weight: 500;
  color: #000000;
  margin-bottom: 0;
}
.specialities-section .specialist-card .specialist-info h4 {
  font-weight: 600;
  color: #274782;
  margin-bottom: 0;
}
.specialities-section .specialist-card .specialist-nav i {
  border-radius: 50%;
  height: 35px;
  width: 35px;
  text-align: center;
  line-height: 35px;
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(183, 183, 183, 0.25);
  color: #d84153;
  margin: auto;
  display: block;
  -webkit-transition: all 0.3s ease 0s;
  -ms-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}

.shapes {
  position: absolute;
  width: 100%;
}
@media (max-width: 991.98px) {
  .shapes {
    display: none;
  }
}
.shapes .shape-1 {
  position: absolute;
  top: 0;
  left: 0;
}
.shapes .shape-2 {
  position: absolute;
  top: 0;
  right: 0;
}
.shapes .shape-3 {
  position: absolute;
  top: -110px;
  left: 0;
}
.shapes .shape-4 {
  position: absolute;
  top: -110px;
  right: 0;
}

.our-doctors-section {
  padding: 60px 0;
  background: #ffffff;
}
@media (max-width: 991.98px) {
  .our-doctors-section {
    padding: 40px 0;
  }
}
@media (max-width: 767.98px) {
  .our-doctors-section {
    padding: 30px 0;
  }
}
.our-doctors-section .our-doctors-card {
  background: rgba(232, 246, 255, 0.4);
  border: 1px solid rgba(231, 237, 255, 0.5);
  border-radius: 10px;
  padding: 10px;
}
.our-doctors-section .our-doctors-card .doctors-header {
  position: relative;
}
.our-doctors-section .our-doctors-card .doctors-header img {
  border-radius: 10px 10px 0 0;
}
.our-doctors-section .our-doctors-card .doctors-header .img-overlay {
  background: #1b5d92;
  border-radius: 110px;
  padding: 5px 10px;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  position: absolute;
  top: 10px;
  right: 10px;
}
.our-doctors-section .our-doctors-card .doctors-body {
  background: #ffffff;
  border-radius: 0px 0px 10px 10px;
  padding: 10px;
}
.our-doctors-section .our-doctors-card .doctors-body .rating {
  font-size: 12px;
}
.our-doctors-section .our-doctors-card .doctors-body .rating i.filled {
  color: #ffc001;
}
.our-doctors-section .our-doctors-card .doctors-body .rating .average-ratings {
  background: #1c5b90;
  border-radius: 70px;
  color: #ffffff;
  padding: 1px 15px;
  margin-left: 10px;
}
.our-doctors-section .our-doctors-card .doctors-body h4 {
  color: #1c1c1c;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.our-doctors-section .our-doctors-card .doctors-body h4:hover {
  color: #0e82fd;
}
.our-doctors-section .our-doctors-card .doctors-body p {
  font-weight: 500;
  margin-bottom: 0;
  font-size: 11px;
}
.our-doctors-section .our-doctors-card .doctors-body .location {
  padding: 20px 0;
}
.our-doctors-section .our-doctors-card .doctors-body .location p {
  font-size: 13px;
  color: #000000;
}
.our-doctors-section .our-doctors-card .doctors-body .location p i {
  color: #1c5b90;
}
.our-doctors-section .our-doctors-card .doctors-body .view-btn {
  background: #e8f6ff;
  border: 1px solid #e8f6ff;
  box-sizing: border-box;
  border-radius: 30px;
  color: rgba(41, 68, 129, 0.9);
  padding: 10px 0;
}
.our-doctors-section .our-doctors-card .doctors-body .view-btn:hover {
  background-color: #0e82fd;
  color: #ffffff;
}
.our-doctors-section .our-doctors-card .doctors-body .book-btn {
  background: #10defd;
  border-radius: 30px;
  padding: 10px 0;
  border: 0;
}
.our-doctors-section .our-doctors-card .doctors-body .book-btn:hover {
  background-color: #0e82fd;
}

.clinic-features-section {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  background-position: 50% 0;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 60px 0;
}
@media (max-width: 991.98px) {
  .clinic-features-section {
    padding: 40px 0;
  }
}
@media (max-width: 767.98px) {
  .clinic-features-section {
    padding: 30px 0;
  }
}
.clinic-features-section .clinic-features {
  position: relative;
}
.clinic-features-section .clinic-features img {
  border-radius: 10px;
}
.clinic-features-section .clinic-feature-overlay {
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 20px;
}
.clinic-features-section .clinic-feature-overlay .img-overlay {
  background: #20c0f3;
  border-radius: 60px;
  padding: 10px 15px;
  text-transform: uppercase;
  color: #e6f4fd;
  font-weight: 600;
  min-width: 150px;
  display: inline-block;
}
.clinic-features-section .clinic-feature-overlay .img-overlay:hover {
  background-color: #0e82fd;
}

.section-search-3 {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  background-position: 50% 0;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 1;
  min-height: 450px;
  padding-top: 85px;
}
.section-search-3:after {
  content: "";
  background: rgba(24, 96, 202, 0.9);
  z-index: -1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.section-search-3 .banner-info {
  padding: 130px 0 190px;
}
@media (max-width: 991.98px) {
  .section-search-3 .banner-info {
    padding: 60px 0 130px;
  }
}
@media (max-width: 767.98px) {
  .section-search-3 .banner-info {
    padding: 20px 0 100px;
  }
}
@media (max-width: 479.98px) {
  .section-search-3 .banner-info {
    padding: 20px 0 70px;
  }
}
.section-search-3 .banner-info .header-banner h2 {
  color: #ffffff;
  font-weight: 600;
  line-height: 40px;
}
.section-search-3 .banner-info .header-banner h2 .header-highlight {
  font-weight: 700;
  color: #ffffff;
}
.section-search-3 .banner-info .header-banner p {
  font-size: 17px;
  color: #ffffff;
}
.section-search-3 .doctor-search {
  padding-bottom: 15px;
}
@media (max-width: 991.98px) {
  .section-search-3 .doctor-search {
    padding: 30px 0;
  }
}
.section-search-3 .doctor-search .doctor-search-form.trans .form-control {
  color: #ffffff;
}
.section-search-3 .doctor-search .doctor-search-form.trans input,
.section-search-3 .doctor-search .doctor-search-form.trans select {
  background-color: transparent;
  border: 2px solid #c2d6f3 !important;
  border-radius: 130px;
  min-height: 60px;
  border: 0;
  box-shadow: 0px 4px 4px rgba(237, 237, 237, 0.25);
  border-radius: 5px;
}
.section-search-3 .doctor-search .doctor-search-form.trans input::placeholder,
.section-search-3 .doctor-search .doctor-search-form.trans select::placeholder {
  color: #ffffff;
}
.section-search-3 .doctor-search .doctor-search-form.trans .form-custom i {
  color: #ffffff;
}
.section-search-3 .doctor-search .doctor-search-form.trans .banner-btn {
  background-color: #13a5e5;
}
.section-search-3 .doctor-search .doctor-search-form.trans .banner-btn:hover {
  background-color: #1c5b91;
}
@media (max-width: 991.98px) {
  .section-search-3 .doctor-search .doctor-search-form.trans .banner-btn {
    padding: 18px 30px;
  }
}

.doctor-category {
  position: relative;
  margin-top: -130px;
  z-index: 9;
  padding: 60px 0;
}
@media (max-width: 767.98px) {
  .doctor-category {
    padding: 40px 0 10px;
    margin-top: -110px;
  }
}
.doctor-category .pop-box {
  background-color: #ffffff;
  padding: 15px 15px 0;
  border-radius: 5px;
  box-shadow: 0px 4px 44px rgba(219, 219, 219, 0.25);
}
@media (max-width: 767.98px) {
  .doctor-category .pop-box {
    margin-bottom: 30px;
  }
}
.doctor-category .pop-box .top-section {
  background-color: #e5f6fd;
  padding: 20px;
  min-height: 150px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.doctor-category .pop-box .top-section i {
  background-color: #ffffff;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  font-size: 30px;
  color: #20c0f3;
  border: 5px solid #f5f8f9;
}
.doctor-category .pop-box .top-section.three {
  background-color: #ffe0e7;
}
.doctor-category .pop-box .top-section.three i {
  color: #ffaabd;
}
.doctor-category .pop-box .top-section.two {
  background-color: #fff1c9;
}
.doctor-category .pop-box .top-section.two i {
  color: #ffbd07;
}
.doctor-category .pop-box .body-section {
  padding: 20px;
  min-height: 200px;
  flex-direction: column;
}
.doctor-category .pop-box .body-section h3 {
  color: #2467ca;
  font-weight: 600;
  font-size: 24px;
}
@media (max-width: 991.98px) {
  .doctor-category .pop-box .body-section h3 {
    font-size: 20px;
  }
}
@media (max-width: 767.98px) {
  .doctor-category .pop-box .body-section h3 {
    font-size: 18px;
  }
}
.doctor-category .pop-box .body-section p {
  color: #1c5b91;
  font-weight: 500;
}
.doctor-category .pop-box .body-section .book-btn {
  width: 150px;
  margin: 0 auto;
  border-radius: 30px;
  background: #2467ca;
  border: 1px solid #2467ca;
}
.doctor-category .pop-box .body-section .book-btn:hover {
  background: #1c5b91;
  border-color: #1c5b91;
}

.section-header-three {
  margin-bottom: 60px;
}
@media (max-width: 767.98px) {
  .section-header-three {
    margin-bottom: 40px;
  }
}
@media (max-width: 479.98px) {
  .section-header-three {
    margin-bottom: 30px;
  }
}
.section-header-three h2 {
  color: #2868c8;
  font-weight: 700;
  font-size: 30px;
  position: relative;
  display: inline-block;
}
@media (max-width: 991.98px) {
  .section-header-three h2 {
    font-size: 28px;
  }
}
@media (max-width: 767.98px) {
  .section-header-three h2 {
    font-size: 24px;
  }
}
@media (max-width: 479.98px) {
  .section-header-three h2 {
    font-size: 15px;
  }
}
.section-header-three h2:before {
  content: "";
  width: 13px;
  height: 13px;
  background: #1c5b91;
  border-radius: 50%;
  box-shadow: 15px 0px 0px -2px #1c5b91;
  position: absolute;
  top: 12px;
  left: -40px;
}
.section-header-three h2:after {
  width: 13px;
  height: 13px;
  content: "";
  background: #1c5b91;
  border-radius: 50%;
  box-shadow: -15px 0px 0px -2px #1c5b91;
  position: absolute;
  top: 12px;
  right: -40px;
}
.section-header-three h2 img {
  margin: 2px 5px 5px;
}
.section-header-three p {
  color: #757575;
  font-size: 16px;
  max-width: 600px;
  margin: 15px auto 0;
}
@media (max-width: 767.98px) {
  .section-header-three p {
    font-size: 14px;
  }
}
@media (max-width: 479.98px) {
  .section-header-three p {
    font-size: 11px;
  }
}

.clinic-specialities {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  padding: 60px 0;
  background-size: cover;
  background-repeat: no-repeat;
}
@media (max-width: 767.98px) {
  .clinic-specialities {
    padding: 40px 0;
  }
}
.clinic-specialities .special-box {
  background-color: #ffffff;
  border-radius: 10px;
  height: 160px;
  cursor: pointer;
  margin-bottom: 30px;
  transition: all 0.7s;
}
.clinic-specialities .special-box .special-body {
  padding: 20px;
  transition: all 0.5s;
}
.clinic-specialities .special-box .special-body img {
  width: 50px;
  margin-bottom: 15px;
}
.clinic-specialities .special-box .special-body h4 {
  font-size: 16px;
  margin: 0;
  font-weight: 500;
}
@media (max-width: 479.98px) {
  .clinic-specialities .special-box .special-body h4 {
    font-size: 15px;
  }
}
.clinic-specialities .special-box .special-body .spc-book {
  background-color: #ffffff;
  padding: 10px 15px;
  min-width: 120px;
  color: #1c5b91;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  display: none;
}
.clinic-specialities .special-box .special-body .spc-book i {
  background-color: #1c5b91;
  color: #ffffff;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  font-size: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.clinic-specialities .special-box .special-footer {
  border-top: 1px solid #eaeaea;
  width: 100%;
  margin: 0;
  padding: 15px;
}
.clinic-specialities .special-box .special-footer .doc-count {
  font-size: 14px;
  font-weight: 700;
  color: #1c71ef;
}
@media (max-width: 479.98px) {
  .clinic-specialities .special-box .special-footer .doc-count {
    font-size: 13px;
  }
}
.clinic-specialities .special-box .special-footer .doc-count span {
  color: #6b7280;
  font-weight: 500;
}
.clinic-specialities .special-box .special-footer .clin-count {
  font-size: 14px;
  font-weight: 700;
  color: #1c71ef;
}
@media (max-width: 479.98px) {
  .clinic-specialities .special-box .special-footer .clin-count {
    font-size: 13px;
  }
}
.clinic-specialities .special-box .special-footer .clin-count span {
  color: #6b7280;
  font-weight: 500;
}
.clinic-specialities .special-box:hover {
  background-color: #1c71ef;
  -webkit-transition: all 0.7s;
  -ms-transition: all 0.7s;
  transition: all 0.7s;
}
.clinic-specialities .special-box:hover .special-body {
  height: 100%;
  flex-direction: column;
}
.clinic-specialities .special-box:hover .special-body h4 {
  color: #ffffff;
}
.clinic-specialities .special-box:hover .spc-book {
  margin-top: 10px;
  display: block;
}
.clinic-specialities .special-box:hover img {
  display: none;
}
.clinic-specialities .special-box:hover .special-footer {
  display: none;
}

.view-all-more .btn {
  background: #1b5d92;
  border-radius: 30px;
  border-color: #1b5d92;
  margin: 20px 0 0;
  padding: 9px 30px;
}
@media (max-width: 479.98px) {
  .view-all-more .btn {
    font-size: 14px;
    padding: 6px 20px;
  }
}
.view-all-more .btn:hover {
  background-color: #0e82fd;
  border: 1px solid #0e82fd;
}

.browse-section {
  background-color: #e5f6fd;
  padding: 60px 0;
}
@media (max-width: 767.98px) {
  .browse-section {
    padding: 40px 0;
  }
}
.browse-section .brower-box {
  text-align: center;
  border-radius: 10px;
  border: 6px solid #ffffff;
  background-color: #ffffff;
  margin-bottom: 20px;
}
.browse-section .brower-box > div {
  border-radius: 15px;
  background-color: #e5f6fd;
  height: 100%;
  padding: 15px;
}
.browse-section .brower-box > div .brower-img {
  background-color: #1c71ef;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: 0 auto 20px;
}
.browse-section .brower-box > div .brower-img img {
  width: auto;
}
.browse-section .brower-box > div h4 {
  font-size: 16px;
  font-weight: 600;
  color: #2264c5;
}
.browse-section .brower-box > div p {
  font-size: 14px;
  font-weight: 500;
  color: #e74e84;
  margin: 0;
}

@media (max-width: 767.98px) {
  .doctor-divison .d-flex {
    display: block !important;
  }
}
.doctor-divison .doc-background {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  background-position: center;
  min-height: 350px;
  background-size: cover;
  padding: 40px 30px;
  flex-direction: column;
  position: relative;
  z-index: 1;
}
@media (max-width: 991.98px) {
  .doctor-divison .doc-background {
    min-height: 250px;
  }
}
@media (max-width: 767.98px) {
  .doctor-divison .doc-background {
    padding: 20px 15px;
    min-height: 200px;
  }
}
.doctor-divison .doc-background::before {
  content: "";
  background: rgba(61, 59, 59, 0.84);
  z-index: -1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.doctor-divison h3 {
  font-size: 28px;
  color: #ffffff;
  font-weight: 700;
  margin-bottom: 20px;
}
@media (max-width: 991.98px) {
  .doctor-divison h3 {
    font-size: 20px;
  }
}
@media (max-width: 767.98px) {
  .doctor-divison h3 {
    font-size: 16px;
  }
}
@media (max-width: 479.98px) {
  .doctor-divison h3 {
    font-size: 14px;
    margin-bottom: 15px;
  }
}
.doctor-divison p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 30px;
}
@media (max-width: 991.98px) {
  .doctor-divison p {
    font-size: 12px;
  }
}
@media (max-width: 767.98px) {
  .doctor-divison p {
    font-size: 11px;
  }
}
@media (max-width: 479.98px) {
  .doctor-divison p {
    font-size: 10px;
    margin-bottom: 20px;
  }
}
.doctor-divison .doc-bok-btn {
  font-size: 14px;
  padding: 6px 12px;
  color: #ffffff;
  background-color: #1c71ef;
  border-radius: 30px;
  width: 100px;
  text-align: center;
}
@media (max-width: 479.98px) {
  .doctor-divison .doc-bok-btn {
    font-size: 12px;
    padding: 5px 10px;
  }
}
.doctor-divison .doc-bok-btn:hover {
  color: #1c71ef;
  background: #ffffff;
}
.doctor-divison .pat-background {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  background-position: center;
  min-height: 350px;
  background-size: cover;
  padding: 40px 30px;
  flex-direction: column;
  position: relative;
  z-index: 1;
}
@media (max-width: 991.98px) {
  .doctor-divison .pat-background {
    min-height: 250px;
  }
}
@media (max-width: 767.98px) {
  .doctor-divison .pat-background {
    padding: 20px 15px;
    min-height: 200px;
  }
}
.doctor-divison .pat-background.pat-background::before {
  content: "";
  background: rgba(28, 113, 239, 0.9);
  z-index: -1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.doctor-divison .pat-background .doc-bok-btn {
  background-color: #1b5d92;
}
.doctor-divison .pat-background .doc-bok-btn:hover {
  color: #1c71ef;
  background: #ffffff;
}

.book-section {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  padding: 60px 0;
  background-size: cover;
  background-repeat: no-repeat;
}
@media (max-width: 767.98px) {
  .book-section {
    padding: 40px 0;
  }
}
.book-section .book-best-doctors {
  margin-bottom: 30px;
}
.book-section .book-best-doctors .book-header img {
  border-radius: 10px 10px 0px 0px;
  width: 100%;
}
.book-section .book-best-doctors .book-header .img-overlay {
  background: #13a5e5;
  border-radius: 50%;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  width: 25px;
  height: 25px;
  position: absolute;
  top: 10px;
  right: 20px;
}
.book-section .book-best-doctors .book-header .img-overlay i {
  font-size: 12px;
}
.book-section .book-best-doctors .doctors-body {
  background-color: #ffffff;
  padding: 0;
  box-shadow: 0px -6px 54px rgba(152, 152, 152, 0.25);
  border-radius: 0;
}
.book-section .book-best-doctors .doctors-body .inner-section {
  padding: 15px 15px 0;
}
.book-section .book-best-doctors .doctors-body .inner-section > span {
  color: #e74e84;
  font-size: 14px;
}
@media (max-width: 767.98px) {
  .book-section .book-best-doctors .doctors-body .inner-section > span {
    font-size: 12px;
  }
}
.book-section .book-best-doctors .doctors-body .rating {
  font-size: 12px;
}
.book-section .book-best-doctors .doctors-body .rating i {
  font-size: 10px;
  color: #dfdfdf;
  margin-bottom: 10px;
}
.book-section .book-best-doctors .doctors-body .rating i.filled {
  color: #fed35d;
}
.book-section .book-best-doctors .doctors-body .rating .average-ratings {
  background-color: #fed35d;
  font-size: 11px;
  font-weight: 700;
}
@media (max-width: 991.98px) {
  .book-section .book-best-doctors .doctors-body .rating .average-ratings {
    font-size: 10px;
    margin: 0 0 0 7px;
    padding: 1px 8px;
  }
}
.book-section .book-best-doctors .doctors-body h4 {
  color: #22396b;
  text-transform: uppercase;
  font-size: 20px;
  margin-bottom: 5px;
  font-weight: 600;
}
@media (max-width: 991.98px) {
  .book-section .book-best-doctors .doctors-body h4 {
    font-size: 18px;
  }
}
@media (max-width: 479.98px) {
  .book-section .book-best-doctors .doctors-body h4 {
    font-size: 16px;
  }
}
.book-section .book-best-doctors .doctors-body p {
  font-size: 12px;
  font-weight: 600;
}
.book-section .book-best-doctors .loc-details {
  background-color: #f6faff;
  margin: 15px 0 0;
  padding: 15px 10px 0;
}
.book-section .book-best-doctors .loc-details .d-flex {
  margin-bottom: 15px;
}
.book-section .book-best-doctors .loc-details img {
  color: #22396b;
  width: auto;
  margin-right: 10px;
}
@media (max-width: 479.98px) {
  .book-section .book-best-doctors .loc-details img {
    margin-right: 6px;
  }
}
.book-section .book-best-doctors .available-info {
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  clear: both;
  display: block;
  margin: 0;
  color: #757575;
}
@media (max-width: 479.98px) {
  .book-section .book-best-doctors .available-info {
    font-size: 11px;
  }
}
.book-section .book-best-doctors .data-info {
  font-weight: 400;
  font-size: 11px;
  color: #2264c5;
}
@media (max-width: 479.98px) {
  .book-section .book-best-doctors .data-info {
    font-size: 10px;
  }
}
.book-section .book-best-doctors .amt-txt {
  color: #1c5b91;
  font-size: 18px;
  font-weight: 600;
}
@media (max-width: 991.98px) {
  .book-section .book-best-doctors .amt-txt {
    font-size: 16px;
  }
}
@media (max-width: 479.98px) {
  .book-section .book-best-doctors .amt-txt {
    font-size: 14px;
  }
}
.book-section .book-best-doctors .book-btn {
  font-size: 14px;
  padding: 6px 12px;
  color: #ffffff;
  background-color: #1c71ef;
  border-radius: 30px;
  width: 100px;
  text-align: center;
  float: right;
  border: none;
}
@media (max-width: 479.98px) {
  .book-section .book-best-doctors .book-btn {
    font-size: 12px;
    padding: 5px 10px;
    width: 80px;
  }
}
.book-section .book-best-doctors .book-btn:hover {
  background-color: #1c5b91;
}

.average-ratings {
  background: #1c5b90;
  border-radius: 70px;
  color: #ffffff;
  margin: 0 0 0 10px;
  padding: 1px 15px;
}

.latest-blog {
  background-color: #f4fcff;
  padding: 60px 0 30px;
}
@media (max-width: 767.98px) {
  .latest-blog {
    padding: 40px 0 10px;
  }
}
.latest-blog .blog-wrap {
  margin-bottom: 30px;
  background-color: #ffffff;
  border-radius: 10px 10px 0px 0px;
}
.latest-blog .blog-wrap img {
  border-radius: 10px;
  width: 100%;
}
.latest-blog .blog-wrap .blog-wrap-body {
  padding: 20px 15px;
  background-color: #ffffff;
}
.latest-blog .blog-wrap .blog-wrap-body h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
}
@media (max-width: 991.98px) {
  .latest-blog .blog-wrap .blog-wrap-body h3 {
    font-size: 18px;
  }
}
@media (max-width: 479.98px) {
  .latest-blog .blog-wrap .blog-wrap-body h3 {
    font-size: 16px;
  }
}
.latest-blog .blog-wrap .blog-wrap-body h3 a:hover {
  color: #1c5b91;
}
.latest-blog .blog-wrap .blog-wrap-body p {
  font-size: 14px;
  color: #737373;
}
@media (max-width: 479.98px) {
  .latest-blog .blog-wrap .blog-wrap-body p {
    font-size: 12px;
  }
}
.latest-blog .blog-wrap .blog-wrap-body .blog-footer {
  border-top: 1px solid #1b70ee;
  padding: 15px 0 0;
}
.latest-blog .blog-wrap .blog-wrap-body .blog-footer .read-txt {
  color: #1b70ee;
  font-size: 14px;
  font-weight: 600;
}
@media (max-width: 479.98px) {
  .latest-blog .blog-wrap .blog-wrap-body .blog-footer .read-txt {
    font-size: 12px;
  }
}
.latest-blog .blog-wrap .blog-wrap-body .blog-footer .read-txt i {
  margin: 2px 6px;
  position: absolute;
  top: 3px;
}
.latest-blog .blog-wrap .blog-wrap-body .blog-footer .cal-txt {
  color: #1b70ee;
  font-size: 14px;
  font-weight: 600;
}
@media (max-width: 479.98px) {
  .latest-blog .blog-wrap .blog-wrap-body .blog-footer .cal-txt {
    font-size: 12px;
  }
}
.latest-blog .blog-wrap .blog-wrap-body .blog-footer .cal-txt i {
  margin: 2px 6px;
}

.browse-section.brower-category {
  padding: 60px 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
@media (max-width: 991.98px) {
  .browse-section.brower-category {
    padding: 40px 0 20px;
  }
}
.browse-section.brower-category .heading-wrapper h1 {
  color: #e5f6fd;
}
.browse-section.brower-category .brower-box {
  text-align: center;
  border-radius: 10px;
  border: 6px solid #ffffff;
  background-color: #ffffff;
  margin-bottom: 20px;
}
.browse-section.brower-category .brower-box > div {
  background-color: #f2f7ff;
  border-radius: 20px 20px 0px 0px;
}
.browse-section.brower-category .brower-box > div .brower-img {
  background-color: #28daf4;
  margin-bottom: 40px;
}
.browse-section.brower-category .brower-box > div h4 {
  color: #28daf4;
}

.doctor-divison.provider-select .doc-background {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  background-size: cover;
  padding: 60px 30px;
}
.doctor-divison.provider-select .doc-background::before {
  background: rgba(242, 247, 255, 0.94);
}
@media (max-width: 991.98px) {
  .doctor-divison.provider-select .doc-background {
    padding: 40px 30px;
  }
}
.doctor-divison.provider-select .doc-background h3 {
  color: #2357a6;
}
.doctor-divison.provider-select .doc-background p {
  color: #4b4b4b;
}
.doctor-divison.provider-select .pat-background {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  background-size: cover;
  padding: 60px 30px;
}
.doctor-divison.provider-select .pat-background::before {
  background: rgba(40, 218, 244, 0.9);
}
@media (max-width: 991.98px) {
  .doctor-divison.provider-select .pat-background {
    padding: 40px 30px;
  }
}
.doctor-divison.provider-select .pat-background a {
  background-color: #0ce0ff;
}

.blogs-section.blog-container {
  padding: 60px 0;
}
@media (max-width: 991.98px) {
  .blogs-section.blog-container {
    padding: 40px 0 10px;
  }
}
.blogs-section.blog-container .blog-wrapper .date-cart {
  top: 50px;
  right: 25px;
}
.blogs-section.blog-container .blog-wrapper .wrap-content-body h3 a {
  color: #1860ca;
}
.blogs-section.blog-container .blog-wrapper .wrap-content-body .sp-title {
  color: #28daf4;
  font-size: 14px;
}

.main-wrapper.home-ten {
  font-size: 16px;
  font-family: "Inter", sans-serif;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-ten {
    font-size: 15px;
  }
}
.main-wrapper.home-ten a:hover {
  color: #0e82fd;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .faq-img {
    display: none;
  }
}
.main-wrapper.home-ten h1,
.main-wrapper.home-ten h2,
.main-wrapper.home-ten h3,
.main-wrapper.home-ten h4,
.main-wrapper.home-ten h5,
.main-wrapper.home-ten h6 {
  text-transform: capitalize;
}
.main-wrapper.home-ten .row-gap {
  row-gap: 24px;
}
.main-wrapper.home-ten .banner-section {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 101%;
  background-clip: padding-box;
  padding: 10px 0 30px;
  height: 745px;
  overflow: visible;
}
.main-wrapper.home-ten .banner-section .banner-content {
  margin-top: 60px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .banner-section .banner-content {
    margin-top: 50px;
  }
}
@media (max-width: 575.98px) {
  .main-wrapper.home-ten .banner-section .banner-content {
    margin-top: 30px;
  }
}
.main-wrapper.home-ten .banner-section::after {
  display: none;
}
.main-wrapper.home-ten .banner-section h6 {
  font-size: 16px;
  margin-bottom: 0;
  text-transform: capitalize;
  color: #ffffff;
  font-weight: 400;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .banner-section h6 {
    margin-bottom: 10px;
  }
}
.main-wrapper.home-ten .banner-section h1 {
  color: #ffffff;
  max-width: 410px;
  line-height: 70px;
  font-weight: 400;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .banner-section h1 {
    max-width: 100%;
    font-size: 30px;
    line-height: normal;
  }
}
.main-wrapper.home-ten .banner-section h1 span {
  color: #ffffff;
  font-weight: 700;
  font-size: 60px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .banner-section h1 span {
    font-size: 34px;
  }
}
.main-wrapper.home-ten .banner-section p {
  color: #ccfbf1;
  max-width: 502px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .banner-section p {
    max-width: 100%;
  }
}
.main-wrapper.home-ten .banner-section .btn {
  border-radius: 35px;
  padding: 14px 40px;
  min-width: 205px;
  border: 3px solid #ffffff;
  font-size: 20px;
}
@media (max-width: 568px) {
  .main-wrapper.home-ten .banner-section .btn {
    border-radius: 35px;
    padding: 5px 10px;
    min-width: auto;
    border: 1px solid #ffffff;
    font-size: 14px;
  }
}
.main-wrapper.home-ten .banner-section .btn.plan-btn {
  background-color: #ffffff;
  margin-right: 10px;
  color: #0e82fd;
  box-shadow: inset 0 0 0 0 #0e82fd;
}
.main-wrapper.home-ten .banner-section .btn.plan-btn:hover {
  box-shadow: inset 0 0 0 50px #0e82fd;
  color: #ffffff;
}
.main-wrapper.home-ten .banner-section .btn:hover {
  border-color: #ffffff;
}
.main-wrapper.home-ten .banner-section .banner-img {
  position: relative;
}
.main-wrapper.home-ten .banner-section .banner-img img:nth-child(2) {
  position: absolute;
  left: -228px;
  z-index: -1;
  animation: beat 2.5s ease-in-out infinite;
}
@keyframes beat {
  from {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1);
  }
  to {
    transform: scale(1.1);
  }
}
.main-wrapper.home-ten .banner-section .search-box-one.search-ten {
  border-radius: 35px;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  padding: 30px;
}
@media (max-width: 1399.98px) {
  .main-wrapper.home-ten .banner-section .search-box-one.search-ten {
    margin-top: -27px;
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .banner-section .search-box-one.search-ten {
    margin-top: 0px;
  }
}
@media (max-width: 575.98px) {
  .main-wrapper.home-ten .banner-section .search-box-one.search-ten {
    margin-top: 0px;
  }
}
.main-wrapper.home-ten .banner-section .search-box-one.search-ten .search-title {
  padding-bottom: 24px;
  display: flex;
  gap: 10px;
  align-items: center;
}
.main-wrapper.home-ten .banner-section .search-box-one.search-ten .search-title h5 {
  font-weight: 700;
}
.main-wrapper.home-ten .banner-section .search-box-one.search-ten .search-input-ten {
  display: flex;
  gap: 10px;
  align-items: center;
}
.main-wrapper.home-ten .banner-section .search-box-one.search-ten .search-input-ten .form-group {
  width: 100%;
}
.main-wrapper.home-ten
  .banner-section
  .search-box-one.search-ten
  .search-input-ten
  .form-group
  .form-control {
  min-height: 40px;
}
.main-wrapper.home-ten .banner-section .search-box-one.search-ten .search-input-ten span {
  width: 40px;
  height: 40px;
  background: #f0fdfa;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.main-wrapper.home-ten .banner-section .search-box-one.search-ten .form-search-btn.search-btn-ten {
  padding-top: 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten
    .banner-section
    .search-box-one.search-ten
    .form-search-btn.search-btn-ten {
    width: 100%;
  }
}
.main-wrapper.home-ten
  .banner-section
  .search-box-one.search-ten
  .form-search-btn.search-btn-ten
  .btn {
  min-width: 100%;
  padding: 10px 50px;
  font-size: 14px;
  border: 1px solid #0e82fd;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten
    .banner-section
    .search-box-one.search-ten
    .form-search-btn.search-btn-ten
    .btn {
    min-width: auto;
    padding: 10px 0;
    font-size: 14px;
    width: 100%;
  }
}
.main-wrapper.home-ten .section-header-one {
  margin-bottom: 50px;
  text-align: center;
}
.main-wrapper.home-ten .section-header-one h2 {
  font-size: 40px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0;
}
.main-wrapper.home-ten .section-header-one h2 span {
  color: #0e82fd;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .section-header-one h2 {
    font-size: 34px;
  }
}
@media (max-width: 767.98px) {
  .main-wrapper.home-ten .section-header-one h2 {
    font-size: 26px;
  }
}
.main-wrapper.home-ten .section-header-one .section-title {
  display: inline-block;
  position: relative;
}
.main-wrapper.home-ten .section-header-one .section-title::before {
  display: none !important;
}
.main-wrapper.home-ten .section-header-one h5 {
  font-weight: 600;
  font-size: 18px;
  color: #0e82fd;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .section-header-one {
    margin-bottom: 40px;
  }
}
.main-wrapper.home-ten .specialities-section-one {
  position: relative;
}
.main-wrapper.home-ten .specialities-section-one .floating-bg img {
  position: absolute;
  right: 10px;
  top: 50%;
  animation: beat 1.5s ease-in-out infinite;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .specialities-section-one .floating-bg img {
    display: none;
  }
}
.main-wrapper.home-ten .specialities-section-one .specialities-block ul {
  list-style: none;
  display: flex;
  padding: 0;
  flex-wrap: wrap;
}
.main-wrapper.home-ten .specialities-section-one .specialities-block ul li {
  margin-right: 24px;
  width: calc(20% - 24px);
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .specialities-section-one .specialities-block ul li {
    width: 45%;
    margin: 0 10px 20px;
  }
}
@media (max-width: 568px) {
  .main-wrapper.home-ten .specialities-section-one .specialities-block ul li {
    width: 100%;
    margin: 0 0 40px;
  }
}
.main-wrapper.home-ten .specialities-section-one .specialities-block ul li:last-child {
  margin-right: 0;
}
.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item {
  background: #ffffff;
  border: none;
  border-radius: 35px;
  height: 195px;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.03);
  margin: 0;
  padding: 20px;
  cursor: pointer;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.main-wrapper.home-ten
  .specialities-section-one
  .specialities-block
  ul
  li
  .specialities-item:hover {
  background: #ffffff;
  border-color: #0e82fd;
  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.main-wrapper.home-ten
  .specialities-section-one
  .specialities-block
  ul
  li
  .specialities-item:hover
  .specialities-img
  .hexogen {
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.main-wrapper.home-ten
  .specialities-section-one
  .specialities-block
  ul
  li
  .specialities-item:hover
  .specialities-img
  .hexogen
  img {
  transform: rotateY(360deg);
  -webkit-transform: rotateY(360deg);
  -ms-transform: rotateY(360deg);
  -webkit-transition: 0.4s;
  -ms-transition: 0.4s;
  transition: 0.4s;
}
.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item p {
  font-weight: 600;
  font-size: 16px;
  color: #2f353c;
  margin-bottom: 0;
  max-width: 180px;
  text-align: center;
}
.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-img {
  padding-bottom: 18px;
}
.main-wrapper.home-ten
  .specialities-section-one
  .specialities-block
  ul
  li
  .specialities-img
  .hexogen {
  background: #ffffff;
  border: none;
  width: 87px;
  height: 100px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 0;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.main-wrapper.home-ten
  .specialities-section-one
  .specialities-block
  ul
  li
  .specialities-img
  .hexogen
  img {
  width: auto;
  -webkit-transition: 0.4s;
  -ms-transition: 0.4s;
  transition: 0.4s;
}
.main-wrapper.home-ten .service-section {
  padding: 80px 0;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.main-wrapper.home-ten .service-section::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.main-wrapper.home-ten .listing-card {
  background-color: #ffffff;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.03);
  border-radius: 35px;
  padding: 20px;
  display: flex;
  flex-direction: column;
}
.main-wrapper.home-ten .listing-card .listing-img {
  position: relative;
  margin: 0 0 20px 0;
  overflow: hidden;
  border-radius: 20px;
}
.main-wrapper.home-ten .listing-card .listing-img img {
  position: relative;
  border-radius: 20px;
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  width: 100%;
}
.main-wrapper.home-ten .listing-card .listing-img:hover img {
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}
.main-wrapper.home-ten .listing-card .listing-img:hover::before {
  -webkit-animation: circle 1s;
  animation: circle 1s;
}
.main-wrapper.home-ten .listing-card .listing-img::before {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  display: block;
  content: "";
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  opacity: 0;
}
.main-wrapper.home-ten .listing-card .listing-img .fav-item {
  position: absolute;
  top: 10px;
  right: 10px;
}
.main-wrapper.home-ten .listing-card .listing-img .fav-item .fav-icon {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-wrapper.home-ten .listing-card .listing-img .fav-item .fav-icon i {
  color: #a29fc0;
}
.main-wrapper.home-ten .listing-card .listing-img .fav-item.selected .fav-icon {
  background-color: #0e82fd;
}
.main-wrapper.home-ten .listing-card .listing-img .fav-item.selected .fav-icon i {
  color: #ffffff;
}
.main-wrapper.home-ten .listing-card .listing-content .listing-details .listing-title h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}
.main-wrapper.home-ten .listing-card .listing-content .listing-details .listing-profile-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-ten .listing-card .listing-content .listing-details .listing-profile-details {
    align-items: start;
    flex-direction: column;
    gap: 15px;
  }
}
.main-wrapper.home-ten
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-user {
  display: flex;
  align-items: center;
}
.main-wrapper.home-ten
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-user
  .listing-profile-img {
  height: 48px;
  width: 48px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 10px;
}
.main-wrapper.home-ten
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-user
  .listing-user-details
  span {
  color: #9ca3af;
  font-size: 14px;
}
.main-wrapper.home-ten
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-user
  .listing-user-details
  h6 {
  margin-bottom: 0;
  font-weight: 400;
  font-size: 16px;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-ten
    .listing-card
    .listing-content
    .listing-details
    .listing-profile-details
    .listing-btn {
    width: 100%;
  }
}
.main-wrapper.home-ten
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-btn
  .consult-btn {
  padding: 6px 30px 6px 30px;
  background-color: #0e82fd;
  font-weight: 500;
  font-size: 16px;
  border-radius: 35px;
  box-shadow: inset 0 0 0 0 #ffffff;
  transition: all 0.7s;
  color: #ffffff;
}
.main-wrapper.home-ten
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-btn
  .consult-btn:hover {
  box-shadow: inset 0 0 0 50px #ffffff;
  color: #0e82fd;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten
    .listing-card
    .listing-content
    .listing-details
    .listing-profile-details
    .listing-btn
    .consult-btn {
    padding: 6px 12px 6px 12px;
    font-size: 17px;
  }
}
@media (max-width: 575.98px) {
  .main-wrapper.home-ten
    .listing-card
    .listing-content
    .listing-details
    .listing-profile-details
    .listing-btn
    .consult-btn {
    width: 100%;
  }
}
.main-wrapper.home-ten .need-to-know-section {
  padding: 80px 0;
  position: relative;
}
.main-wrapper.home-ten .need-to-know-section .floating-bg img {
  position: absolute;
  left: 10px;
  top: 50%;
  animation: beat 1.5s ease-in-out infinite;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .need-to-know-section .floating-bg {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .need-to-know-section {
    padding: 60px 0;
  }
}
.main-wrapper.home-ten .need-to-know-section .section-header-one {
  text-align: left;
  margin-bottom: 0;
}
.main-wrapper.home-ten .need-to-know-section .section-header-one ul {
  padding: 30px 0;
}
.main-wrapper.home-ten .need-to-know-section .section-header-one ul li {
  margin-right: 10px;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-ten .need-to-know-section .section-header-one ul li {
    margin: 0 10px 10px 0;
  }
}
.main-wrapper.home-ten .need-to-know-section .section-header-one ul li:last-child {
  margin-right: 0;
}
.main-wrapper.home-ten .need-to-know-section .section-header-one ul li .tag-list {
  padding: 10px 20px;
  border-radius: 35px;
  background: #f8fafc;
  font-weight: 600;
  color: #9ca3af;
  text-transform: capitalize;
}
.main-wrapper.home-ten .need-to-know-section .section-header-one ul li .tag-list.active {
  background: #f1f5f9;
  color: #0e82fd;
}
.main-wrapper.home-ten .need-to-know-section .section-header-one .need-to-know-content h3 {
  margin-bottom: 34px;
  font-weight: 600;
}
.main-wrapper.home-ten .need-to-know-section .section-header-one .need-to-know-content p {
  line-height: 29px;
  margin-bottom: 30px;
}
.main-wrapper.home-ten
  .need-to-know-section
  .section-header-one
  .need-to-know-content
  .need-to-know-content-btn {
  border-radius: 35px;
  padding: 10px 30px;
  border: 2px solid #0e82fd;
  font-size: 14px;
  color: #0e82fd;
  box-shadow: inset 0 0 0 0 #0e82fd;
  transition: all 0.7s;
}
.main-wrapper.home-ten
  .need-to-know-section
  .section-header-one
  .need-to-know-content
  .need-to-know-content-btn:hover {
  box-shadow: inset 0 0 0 50px #0e82fd;
  color: #ffffff;
}
.main-wrapper.home-ten .need-to-know-section .gallery-box-block {
  display: flex;
  gap: 10px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .need-to-know-section .gallery-box-block {
    display: none !important;
  }
}
.main-wrapper.home-ten .need-to-know-section .gallery-box-block .box-detail {
  width: 195px;
  height: 202px;
  border-radius: 35px;
  overflow: hidden;
  margin-bottom: 10px;
}
.main-wrapper.home-ten .need-to-know-section .gallery-box-block .box-detail:last-child {
  margin-bottom: 0;
}
.main-wrapper.home-ten .need-to-know-section .gallery-box-block .gallery-box-left {
  padding-top: 30px;
}
.main-wrapper.home-ten .need-to-know-section.steps-to-follow .floating-bg img {
  position: absolute;
  right: 10px;
  top: 50%;
  animation: beat 1.5s ease-in-out infinite;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .need-to-know-section.steps-to-follow .floating-bg {
    display: none;
  }
}
.main-wrapper.home-ten .need-to-know-section.steps-to-follow .gallery-box-block {
  display: flex;
  gap: 24px;
}
.main-wrapper.home-ten .need-to-know-section.steps-to-follow .gallery-box-block .box-detail {
  width: 240px;
  height: 223px;
  border-radius: 35px;
  overflow: hidden;
  margin-bottom: 24px;
  padding: 30px;
  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1399.98px) {
  .main-wrapper.home-ten .need-to-know-section.steps-to-follow .gallery-box-block .box-detail {
    max-width: 210px;
    max-height: 203px;
  }
}
.main-wrapper.home-ten
  .need-to-know-section.steps-to-follow
  .gallery-box-block
  .box-detail:last-child {
  margin-bottom: 0;
}
.main-wrapper.home-ten
  .need-to-know-section.steps-to-follow
  .gallery-box-block
  .box-detail
  .steps-list-box {
  position: relative;
}
.main-wrapper.home-ten
  .need-to-know-section.steps-to-follow
  .gallery-box-block
  .box-detail
  .steps-list-box
  .steps-list-img {
  width: 140px;
  height: 60px;
  margin: auto;
}
.main-wrapper.home-ten
  .need-to-know-section.steps-to-follow
  .gallery-box-block
  .box-detail
  .steps-list-box
  h6 {
  font-weight: 600;
  font-size: 18px;
  margin: 10px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.main-wrapper.home-ten
  .need-to-know-section.steps-to-follow
  .gallery-box-block
  .box-detail
  .steps-list-box
  p {
  text-align: center;
  margin-bottom: 0;
}
.main-wrapper.home-ten
  .need-to-know-section.steps-to-follow
  .gallery-box-block
  .box-detail
  .steps-list-box
  span {
  color: #0e82fd;
  font-weight: 700;
  font-size: 30px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 12%);
}
.main-wrapper.home-ten .need-to-know-section.steps-to-follow .gallery-box-block .gallery-box-left {
  padding-top: 30px;
}
.main-wrapper.home-ten
  .need-to-know-section.steps-to-follow
  .section-header-one
  .need-to-know-content {
  margin-top: 50px;
}
.main-wrapper.home-ten
  .need-to-know-section.steps-to-follow
  .section-header-one
  .need-to-know-content
  .need-to-know-content-btn {
  border-radius: 35px;
  padding: 10px 30px;
  border: 3px solid #0e82fd;
  font-size: 18px;
  font-weight: 500;
  color: #0e82fd;
  box-shadow: inset 0 0 0 0 #0e82fd;
  transition: all 0.7s;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten
    .need-to-know-section.steps-to-follow
    .section-header-one
    .need-to-know-content
    .need-to-know-content-btn {
    font-size: 16px;
  }
}
.main-wrapper.home-ten
  .need-to-know-section.steps-to-follow
  .section-header-one
  .need-to-know-content
  .need-to-know-content-btn:hover {
  box-shadow: inset 0 0 0 50px #0e82fd;
  color: #ffffff;
}
.main-wrapper.home-ten
  .need-to-know-section.steps-to-follow
  .section-header-one
  .need-to-know-content
  .need-to-know-content-btn.book-btn {
  background-color: #0e82fd;
  color: #ffffff;
  box-shadow: inset 0 0 0 0 #ffffff;
}
.main-wrapper.home-ten
  .need-to-know-section.steps-to-follow
  .section-header-one
  .need-to-know-content
  .need-to-know-content-btn.book-btn:hover {
  box-shadow: inset 0 0 0 50px #ffffff;
  color: #0e82fd;
}
.main-wrapper.home-ten .need-to-know-section.testimonial-section-ten {
  background-color: #f8fafc;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  background-repeat: no-repeat;
  background-size: cover;
}
.main-wrapper.home-ten .need-to-know-section.testimonial-section-ten .floating-bg img {
  position: absolute;
  left: 10px;
  top: 50%;
  animation: beat 1.5s ease-in-out infinite;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .need-to-know-section.testimonial-section-ten .floating-bg {
    display: none;
  }
}
.main-wrapper.home-ten .need-to-know-section.testimonial-section-ten .section-header-one h2 {
  margin-bottom: 30px;
}
.main-wrapper.home-ten
  .need-to-know-section.testimonial-section-ten
  .section-header-one
  .need-to-know-content
  p {
  margin-bottom: 30px;
}
.main-wrapper.home-ten
  .need-to-know-section.testimonial-section-ten
  .section-header-one
  .need-to-know-content
  .patient-rating-block
  .patient-rating
  .circle-rating {
  margin-bottom: 12px;
}
.main-wrapper.home-ten
  .need-to-know-section.testimonial-section-ten
  .section-header-one
  .need-to-know-content
  .patient-rating-block
  .patient-rating
  .circle-rating
  i {
  color: #ffca42;
  margin-right: 5px;
}
.main-wrapper.home-ten
  .need-to-know-section.testimonial-section-ten
  .section-header-one
  .need-to-know-content
  .patient-rating-block
  .patient-rating
  .circle-rating
  i:last-child {
  margin-right: 0px;
}
.main-wrapper.home-ten
  .need-to-know-section.testimonial-section-ten
  .section-header-one
  .need-to-know-content
  .patient-rating-block
  .patient-rating
  .circle-rating
  span {
  margin-left: 10px;
  color: #9ca3af;
  font-size: 14px;
  font-weight: 600;
}
.main-wrapper.home-ten
  .need-to-know-section.testimonial-section-ten
  .section-header-one
  .need-to-know-content
  .patient-rating-block
  .patient-rating
  h5 {
  margin-bottom: 0;
  color: #1e293b;
}
.main-wrapper.home-ten .need-to-know-section.testimonial-section-ten .testimonial-card {
  color: #ffffff;
  background-color: #ffffff;
  padding: 20px;
  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);
  border-radius: 35px;
  margin-bottom: 24px;
}
.main-wrapper.home-ten .need-to-know-section.testimonial-section-ten .testimonial-card:last-child {
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten
    .need-to-know-section.testimonial-section-ten
    .testimonial-card:last-child {
    margin-bottom: 15px;
  }
}
.main-wrapper.home-ten
  .need-to-know-section.testimonial-section-ten
  .testimonial-card
  .testimonial-user-details {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.main-wrapper.home-ten
  .need-to-know-section.testimonial-section-ten
  .testimonial-card
  .testimonial-user-details
  .testimonial-user-img {
  width: 85px;
  height: 85px;
  overflow: hidden;
  margin-right: 20px;
  border-radius: 50%;
}
.main-wrapper.home-ten
  .need-to-know-section.testimonial-section-ten
  .testimonial-card
  .testimonial-user-details
  .testimonial-user-name
  .circle-rating
  i {
  color: #ffca42;
}
.main-wrapper.home-ten
  .need-to-know-section.testimonial-section-ten
  .testimonial-card
  .testmonial-user-coments
  p {
  color: #6b7280;
  font-size: 14px;
  line-height: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.main-wrapper.home-ten .our-doctor-section {
  padding: 80px 0;
  position: relative;
  background: #f8fafc;
  z-index: 0;
}
.main-wrapper.home-ten .our-doctor-section .section-floating-bg {
  z-index: -2;
}
.main-wrapper.home-ten .our-doctor-section .section-floating-bg img {
  position: absolute;
}
.main-wrapper.home-ten .our-doctor-section .section-floating-bg img:nth-child(1) {
  top: 0;
  left: 0;
}
.main-wrapper.home-ten .our-doctor-section .section-floating-bg img:nth-child(2) {
  bottom: 0;
  right: 0;
}
.main-wrapper.home-ten .our-doctor-section .module-border-wrap {
  background: #ffffff;
  border-radius: 39px;
  padding: 3px;
  transition: all 0.5s;
  position: relative;
}
.main-wrapper.home-ten .our-doctor-section .module-border-wrap:hover {
  background-image: linear-gradient(to bottom, #8af0ff, #fff);
  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);
}
.main-wrapper.home-ten .our-doctor-section .module-border-wrap .listing-card {
  background-color: #ffffff;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.03);
  border-radius: 35px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  transition: all 0.5s;
}
.main-wrapper.home-ten .our-doctor-section .module-border-wrap .listing-card .listing-img {
  position: relative;
  margin: 0 0 20px 0;
  overflow: hidden;
  border-radius: 20px;
}
.main-wrapper.home-ten .our-doctor-section .module-border-wrap .listing-card .listing-img img {
  position: relative;
  border-radius: 20px;
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  width: 100%;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-img:hover
  img {
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-img:hover::before {
  -webkit-animation: circle 1s;
  animation: circle 1s;
}
.main-wrapper.home-ten .our-doctor-section .module-border-wrap .listing-card .listing-img::before {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  display: block;
  content: "";
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  opacity: 0;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-img
  .fav-item {
  position: absolute;
  top: 10px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-img
  .fav-item
  .featured-rating {
  background: #fbbf24;
  border-radius: 6px;
  color: #ffffff;
  padding: 3px 5px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-img
  .fav-item
  .featured-rating
  i,
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-img
  .fav-item
  .featured-rating
  span {
  font-size: 13px;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-img
  .fav-item
  .fav-icon {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-img
  .fav-item
  .fav-icon
  i {
  color: #a29fc0;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-img
  .fav-item.selected
  .fav-icon {
  background-color: #0e82fd;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-img
  .fav-item.selected
  .fav-icon
  i {
  color: #ffffff;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-title
  h3 {
  font-size: 20px;
  font-weight: 600;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-category {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten
    .our-doctor-section
    .module-border-wrap
    .listing-card
    .listing-content
    .listing-details
    .listing-category {
    flex-direction: column;
  }
}
@media (max-width: 575.98px) {
  .main-wrapper.home-ten
    .our-doctor-section
    .module-border-wrap
    .listing-card
    .listing-content
    .listing-details
    .listing-category {
    align-items: start;
  }
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-category
  .listing-category-tag {
  padding: 5px 10px;
  transition: all 0.5s;
  font-size: 14px;
  font-weight: 500;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-category
  .listing-category-tag:hover {
  transform: translateY(-5px);
  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-category
  .listing-category-tag.tag-green {
  background: #ccfbf1;
  color: #14b8a6;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-category
  .listing-category-tag.tag-purple {
  background: #ddd6fe;
  color: #7c3aed;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-category
  .listing-category-tag.tag-red {
  background: #fdf2f8;
  color: #ec4899;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details {
  display: flex;
  align-items: start;
  justify-content: start;
  flex-direction: column;
  gap: 15px;
  position: relative;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-floating-img {
  position: absolute;
  bottom: 0;
  right: 0;
}
@media (max-width: 1399.98px) {
  .main-wrapper.home-ten
    .our-doctor-section
    .module-border-wrap
    .listing-card
    .listing-content
    .listing-details
    .listing-profile-details
    .listing-floating-img {
    display: none;
  }
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-user {
  display: flex;
  align-items: center;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-user
  .listing-profile-img {
  height: 48px;
  width: 48px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 10px;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-user
  .listing-user-details
  span {
  color: #9ca3af;
  font-size: 14px;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-user
  .listing-user-details
  h6 {
  margin-bottom: 0;
  font-weight: 600;
  font-size: 20px;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-ten
    .our-doctor-section
    .module-border-wrap
    .listing-card
    .listing-content
    .listing-details
    .listing-profile-details
    .listing-user
    .listing-user-details
    h6 {
    font-size: 17px;
  }
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-btn
  .consult-btn {
  padding: 6px 30px 6px 30px;
  background-color: #0e82fd;
  font-weight: 500;
  font-size: 16px;
  border-radius: 35px;
  box-shadow: inset 0 0 0 0 #ffffff;
  transition: all 0.7s;
  color: #ffffff;
}
.main-wrapper.home-ten
  .our-doctor-section
  .module-border-wrap
  .listing-card
  .listing-content
  .listing-details
  .listing-profile-details
  .listing-btn
  .consult-btn:hover {
  box-shadow: inset 0 0 0 50px #ffffff;
  color: #0e82fd;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-ten
    .our-doctor-section
    .module-border-wrap
    .listing-card
    .listing-content
    .listing-details
    .listing-profile-details
    .listing-btn
    .consult-btn {
    font-size: 17px;
  }
}
.main-wrapper.home-ten .book-appointment-section {
  padding: 80px 0;
  position: relative;
}
.main-wrapper.home-ten .book-appointment-section .book-appointment-ten {
  padding: 50px;
  background: #0e82fd;
  border-radius: 35px;
  position: relative;
  overflow: hidden;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-ten .book-appointment-section .book-appointment-ten {
    padding: 20px;
  }
}
.main-wrapper.home-ten .book-appointment-section .book-appointment-ten .book-section-bg img {
  position: absolute;
}
.main-wrapper.home-ten
  .book-appointment-section
  .book-appointment-ten
  .book-section-bg
  img:nth-child(1) {
  left: 0;
  bottom: 0;
}
.main-wrapper.home-ten
  .book-appointment-section
  .book-appointment-ten
  .book-section-bg
  img:nth-child(2) {
  right: 0;
  bottom: 6%;
}
.main-wrapper.home-ten
  .book-appointment-section
  .book-appointment-ten
  .book-section-bg
  img:nth-child(3) {
  right: 160px;
  top: 100px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .book-appointment-section .book-appointment-ten .book-section-bg {
    display: none;
  }
}
.main-wrapper.home-ten .book-appointment-section .book-appointment-ten h2 {
  color: #ffffff;
  margin-bottom: 24px;
}
.main-wrapper.home-ten .book-appointment-section .book-appointment-ten p {
  max-width: 725px;
  margin: auto;
  margin-bottom: 50px;
  color: #ffffff;
}
.main-wrapper.home-ten .book-appointment-section .book-appointment-ten .appointment-btn-group {
  display: flex;
  gap: 10px;
  justify-content: center;
}
@media (max-width: 568px) {
  .main-wrapper.home-ten .book-appointment-section .book-appointment-ten .appointment-btn-group {
    flex-direction: column;
  }
}
.main-wrapper.home-ten .book-appointment-section .book-appointment-ten .appointment-btn-group a {
  padding: 14px 40px;
  border-radius: 35px;
  border: 2px solid #ffffff;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  box-shadow: inset 0 0 0 0 #ffffff;
  transition: all 0.7s;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .book-appointment-section .book-appointment-ten .appointment-btn-group a {
    padding: 14px 20px;
    border: 1px solid #ffffff;
    font-size: 15px;
  }
}
@media (max-width: 575.98px) {
  .main-wrapper.home-ten .book-appointment-section .book-appointment-ten .appointment-btn-group a {
    padding: 10px 20px;
  }
}
.main-wrapper.home-ten
  .book-appointment-section
  .book-appointment-ten
  .appointment-btn-group
  a:hover {
  box-shadow: inset 0 0 0 50px #ffffff;
  color: #0e82fd;
}
.main-wrapper.home-ten
  .book-appointment-section
  .book-appointment-ten
  .appointment-btn-group
  a.appointment-blue-btn {
  background-color: #ffffff;
  color: #0e82fd;
  box-shadow: inset 0 0 0 0 #0e82fd;
  border: 2px solid #ffffff;
}
.main-wrapper.home-ten
  .book-appointment-section
  .book-appointment-ten
  .appointment-btn-group
  a.appointment-blue-btn:hover {
  box-shadow: inset 0 0 0 50px #0e82fd;
  color: #ffffff;
}
.main-wrapper.home-ten .pricing-section.pricing-section-ten {
  position: relative;
  z-index: 1;
}
.main-wrapper.home-ten .pricing-section.pricing-section-ten::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.main-wrapper.home-ten .pricing-section.pricing-section-ten .section-header-one h2 {
  margin-bottom: 24px;
}
.main-wrapper.home-ten .pricing-section.pricing-section-ten .section-header-one .options-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 17px;
}
@media (max-width: 568px) {
  .main-wrapper.home-ten .pricing-section.pricing-section-ten .section-header-one .options-group {
    flex-direction: column;
  }
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .section-header-one
  .options-group
  span {
  color: #1f2937;
  font-weight: 500;
  font-size: 18px;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .section-header-one
  .options-group
  span
  .discount-plan {
  background: #ffc001;
  border-radius: 35px;
  color: #ffffff;
  padding: 5px 10px;
  font-size: 14px;
}
.main-wrapper.home-ten .pricing-section.pricing-section-ten .section-header-one .form-check {
  width: 30px;
  margin-bottom: 0;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .section-header-one
  .form-check.form-switch {
  padding: 0;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .section-header-one
  .form-check.form-switch
  .form-check-input {
  transition: all 0.5s;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .section-header-one
  .form-check
  .form-check-input {
  float: right !important;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .section-header-one
  .form-check
  .form-check-input:focus {
  box-shadow: none !important;
}
.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card {
  background: #ffffff;
  border-radius: 35px;
}
.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card .pricing-btn {
  margin-bottom: 30px;
}
.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card .pricing-btn .btn {
  color: #0e82fd;
  box-shadow: inset 0 0 0 0 #0e82fd;
  padding: 14px 40px;
  background: #ffffff;
  border-radius: 35px;
  transition: all 0.5s;
  border: 2px solid #0e82fd;
}
.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card .pricing-btn .btn:hover {
  box-shadow: inset 0 0 0 50px #0e82fd;
  color: #ffffff;
  border: 2px solid #ffffff;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card
  .pricing-info
  .pricing-amount
  span {
  font-weight: 600;
  color: #9ca3af;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card
  .pricing-info
  .pricing-list {
  padding-bottom: 30px;
  border-bottom: 1px solid #e2e8f0;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card
  .pricing-info
  .pricing-list
  ul
  li::before {
  content: "\\f21e";
  color: #0e82fd;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card
  .pricing-info
  .pricing-list.pricing-list-two {
  border-bottom: none;
  padding: 30px 0 0 0;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card
  .pricing-info
  .pricing-list.pricing-list-two
  ul
  li::before {
  content: "+";
}
.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card.pricing-card-active {
  background: #0e82fd;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card.pricing-card-active
  .card-body
  .pricing-header
  .pricing-header-info {
  position: relative;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card.pricing-card-active
  .card-body
  .pricing-header
  .pricing-header-info
  .pricing-tag
  img {
  position: absolute;
  right: 0;
  top: 0;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card.pricing-card-active
  .card-body
  .pricing-header
  .pricing-header-info
  .pricing-title
  h4 {
  font-weight: 700;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card.pricing-card-active
  .card-body
  .pricing-info
  .pricing-amount
  span {
  color: #ffffff;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card.pricing-card-active
  .card-body
  .pricing-info
  .pricing-btn {
  margin-bottom: 30px;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card.pricing-card-active
  .card-body
  .pricing-info
  .pricing-btn
  .btn {
  color: #0e82fd;
  box-shadow: inset 0 0 0 0px #0e82fd;
  padding: 14px 40px;
  border-radius: 35px;
  transition: all 0.5s;
  border: 2px solid #ffffff;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card.pricing-card-active
  .card-body
  .pricing-info
  .pricing-btn
  .btn:hover {
  box-shadow: inset 0 0 0 50px #0e82fd;
  color: #ffffff;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card.pricing-card-active
  .card-body
  .pricing-info
  .pricing-list {
  padding-bottom: 30px;
  border-bottom: 1px solid #f1f5f9;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card.pricing-card-active
  .card-body
  .pricing-info
  .pricing-list
  ul
  li {
  font-weight: 500;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card.pricing-card-active
  .card-body
  .pricing-info
  .pricing-list
  ul
  li::before {
  content: "\\f21e";
  color: #ffffff;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card.pricing-card-active
  .card-body
  .pricing-info
  .pricing-list.pricing-list-two {
  border-bottom: none;
  padding: 30px 0 0 0;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card.pricing-card-active
  .card-body
  .pricing-info
  .pricing-list.pricing-list-two
  ul
  li::before {
  content: "+";
}
.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card:hover {
  background: #0e82fd;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card:hover
  .pricing-amount
  span {
  color: #ffffff;
}
.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card:hover .pricing-list {
  border-bottom: 1px solid #f1f5f9;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card:hover
  .pricing-list
  ul
  li::before {
  color: #ffffff;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card:hover
  .pricing-list.pricing-list-two {
  border-bottom: none;
  padding: 30px 0 0 0;
}
.main-wrapper.home-ten
  .pricing-section.pricing-section-ten
  .pricing-card:hover
  .pricing-list.pricing-list-two
  ul
  li::before {
  content: "+";
}
.main-wrapper.home-ten .faq-section {
  position: relative;
}
.main-wrapper.home-ten .faq-section .floating-bg img {
  position: absolute;
  right: 10px;
  top: 50%;
  animation: beat 1.5s ease-in-out infinite;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .faq-section .floating-bg {
    display: none;
  }
}
.main-wrapper.home-ten .faq-section.faq-section-ten {
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .faq-section.faq-section-ten {
    padding: 60px 0;
  }
}
.main-wrapper.home-ten .faq-section.faq-section-ten .faq-img {
  border-radius: 35px;
  overflow: hidden;
}
.main-wrapper.home-ten .faq-section.faq-section-ten .faq-img img {
  width: 100%;
}
.main-wrapper.home-ten .faq-section.faq-section-ten .section-header-one {
  text-align: start;
}
.main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-item {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 35px;
  margin: 0 0 24px;
  padding: 20px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-item {
    padding: 10px;
  }
}
.main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-item .accordion-content {
  padding-left: 45px;
}
.main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-button {
  font-weight: 600;
}
.main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-button::after {
  display: none;
}
.main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-button::before {
  content: "\\e9b1";
  font-family: "feather";
  font-size: 20px;
  background: none;
  color: #0e82fd;
  background: #ffffff;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 20px;
  margin-right: 20px;
  border-right: 1px solid #e2e8f0;
}
.main-wrapper.home-ten
  .faq-section.faq-section-ten
  .faq-info
  .accordion-button:not(.collapsed)::after {
  display: none;
}
.main-wrapper.home-ten
  .faq-section.faq-section-ten
  .faq-info
  .accordion-button:not(.collapsed)::before {
  content: "\\e996";
  background: #ffffff;
}
.main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-button .accordion-item {
  border-radius: 35px;
}

@media (max-width: 568px) {
  .content-btn-block {
    flex-wrap: wrap;
  }
  .content-btn-block .need-to-know-content-btn {
    margin-bottom: 10px !important;
    width: 100%;
    text-align: center;
  }
  .footer.footer-one.footer-ten .footer-bottom .copyright {
    flex-direction: column;
  }
  .need-to-know-content .patient-rating {
    margin-bottom: 15px;
  }
}
.body-eleven {
  font-size: 16px;
  font-family: "Inter", sans-serif;
}
@media (max-width: 1199.98px) {
  .body-eleven {
    font-size: 15px;
  }
}

.doctor-search-section.doctor-search-eleven {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  padding: 115px 0 300px;
  background-position: bottom center;
}
.doctor-search-section.doctor-search-eleven .banner-header {
  margin: 0 0 90px;
}
.doctor-search-section.doctor-search-eleven .banner-header p {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  margin: 0 0 10px;
  padding: 0 0 0 30px;
  position: relative;
}
.doctor-search-section.doctor-search-eleven .banner-header p::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 27px;
  height: 2px;
  background-color: #ffffff;
}
@media (max-width: 767.98px) {
  .doctor-search-section.doctor-search-eleven .banner-header p {
    font-size: 14px;
  }
}
.doctor-search-section.doctor-search-eleven .banner-header h1 {
  font-size: 50px;
  color: #ffffff;
  font-weight: 700;
  margin: 0 0 25px;
}
@media (max-width: 1399.98px) {
  .doctor-search-section.doctor-search-eleven .banner-header h1 {
    font-size: 48px;
  }
}
@media (max-width: 991.98px) {
  .doctor-search-section.doctor-search-eleven .banner-header h1 {
    font-size: 36px;
  }
}
@media (max-width: 767.98px) {
  .doctor-search-section.doctor-search-eleven .banner-header h1 {
    font-size: 24px;
  }
}
@media (max-width: 991.98px) {
  .doctor-search-section.doctor-search-eleven .banner-header {
    margin: 0 0 60px;
  }
}
@media (max-width: 767.98px) {
  .doctor-search-section.doctor-search-eleven .banner-header {
    margin: 0 0 40px;
  }
}
.doctor-search-section.doctor-search-eleven .banner-users h6 {
  color: #000000;
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 15px;
}
.doctor-search-section.doctor-search-eleven .banner-users h6 img {
  margin: 0 10px 0 0;
}
@media (max-width: 767.98px) {
  .doctor-search-section.doctor-search-eleven .banner-users h6 {
    font-size: 14px;
  }
}
.doctor-search-section.doctor-search-eleven .banner-users ul {
  margin: 0;
  padding: 0;
}
.doctor-search-section.doctor-search-eleven .banner-users ul li {
  display: inline-block;
  margin: 0 0 0 -23px;
}
.doctor-search-section.doctor-search-eleven .banner-users ul li:first-child {
  margin: 0;
}
.doctor-search-section.doctor-search-eleven .banner-users ul li img {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border: 2px solid #ffffff;
}
@media (max-width: 767.98px) {
  .doctor-search-section.doctor-search-eleven .banner-users ul li img {
    width: 50px;
    height: 50px;
  }
}
@media (max-width: 767.98px) {
  .doctor-search-section.doctor-search-eleven .ban-bg .bg-01,
  .doctor-search-section.doctor-search-eleven .ban-bg .bg-02 {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .doctor-search-section.doctor-search-eleven {
    padding: 115px 0 200px;
  }
}
@media (max-width: 767.98px) {
  .doctor-search-section.doctor-search-eleven {
    padding: 115px 0 150px;
  }
}

.z-index-1 {
  z-index: -1 !important;
}

@media (max-width: 767.98px) {
  .ban-bg {
    display: none;
  }
}
.ban-bg img {
  position: absolute;
  z-index: -1;
}
.ban-bg img.bg-01 {
  left: 0;
  top: 0;
  animation: bouncing alternate infinite 2s;
}
.ban-bg img.bg-02 {
  right: 0;
  top: 0;
  animation: bounce alternate infinite 2s;
  z-index: -1;
}
.ban-bg img.bg-03 {
  right: 10%;
  bottom: 0;
  animation: bounceup alternate infinite 2s;
}
@media (max-width: 767.98px) {
  .ban-bg img.bg-03 {
    width: 150px;
  }
}
.ban-bg img.bg-04 {
  bottom: 17%;
  left: 2%;
  z-index: -1;
}
@media (max-width: 1399.98px) {
  .ban-bg img.bg-04 {
    left: 1%;
  }
}
.ban-bg img.bg-05 {
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  z-index: -1;
}

@keyframes bouncing {
  to {
    transform: translateX(5px);
  }
}
@keyframes bounce {
  to {
    transform: translateX(-5px);
  }
}
@keyframes bounceup {
  to {
    transform: translateY(-10px);
  }
}
.btn-light-blue {
  background: #0ce0ff;
  color: #ffffff;
  box-shadow: inset 0 0 0 0 #ffffff;
  border-radius: 10px;
  font-weight: 500;
  font-size: 18px;
  padding: 13px 24px;
  -webkit-transition: all 0.7s;
  -ms-transition: all 0.7s;
  transition: all 0.7s;
}
.btn-light-blue:hover {
  background: #ffffff;
  color: #1c5b91;
  box-shadow: inset 0 60px 0 0 #ffffff;
  -webkit-transition: all 0.7s;
  -ms-transition: all 0.7s;
  transition: all 0.7s;
}
@media (max-width: 767.98px) {
  .btn-light-blue {
    font-size: 15px;
    padding: 10px 20px;
  }
}

.sec-heading-eye {
  margin: 0 0 50px;
}
.sec-heading-eye img {
  margin: 0 0 15px;
}
.sec-heading-eye h2 {
  font-size: 40px;
  font-weight: 600;
  color: #1b5a90;
  margin: 0 0 15px;
}
.sec-heading-eye h2 span {
  color: #1f2937;
}
@media (max-width: 991.98px) {
  .sec-heading-eye h2 {
    font-size: 34px;
  }
}
@media (max-width: 767.98px) {
  .sec-heading-eye h2 {
    font-size: 26px;
  }
}
.sec-heading-eye p {
  font-size: 18px;
  color: #6b7280;
}
@media (max-width: 991.98px) {
  .sec-heading-eye p {
    font-size: 16px;
  }
}
@media (max-width: 991.98px) {
  .sec-heading-eye {
    margin-bottom: 30px;
  }
}

.special-section {
  position: relative;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .special-section {
    padding: 40px 0;
  }
}

.special-item {
  margin: 0 0 50px;
}
.special-item .special-icon {
  text-align: center;
  margin: 0 auto 15px;
  height: 45px;
}
.special-item .special-icon a {
  width: 110px;
  height: 110px;
  background-color: #1b5a90;
  border-radius: 100% 0px;
  transform: rotate(45deg);
  text-align: center;
  margin: -70px 0 auto;
}
.special-item .special-icon a i {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  color: #ffffff;
}
.special-item h6 {
  font-weight: 500;
  font-size: 18px;
  margin: 0;
  text-align: center;
  color: #1f2937;
}
.special-item h6 a {
  color: #1f2937;
}
.special-item h6 a:hover {
  color: #1b5a90;
}

.owl-them .owl-nav .owl-prev,
.owl-them .owl-nav .owl-next {
  width: 40px;
  height: 40px;
  background: #ffffff !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  position: absolute;
  top: 20%;
  z-index: 1;
}
.owl-them .owl-nav .owl-prev:hover,
.owl-them .owl-nav .owl-next:hover {
  background: #1c5b91 !important;
  color: #ffffff;
}
.owl-them .owl-nav .owl-prev {
  left: -20px;
}
@media (max-width: 991.98px) {
  .owl-them .owl-nav .owl-prev {
    left: -10px;
  }
}
.owl-them .owl-nav .owl-next {
  right: -20px;
}
@media (max-width: 991.98px) {
  .owl-them .owl-nav .owl-next {
    right: -10px;
  }
}

.owl-them .owl-dots {
  text-align: center;
}
.owl-them .owl-dots .owl-dot {
  margin: 0 5px 0 0;
}
.owl-them .owl-dots .owl-dot.active span {
  background: #1b5a90;
}
.owl-them .owl-dots .owl-dot span {
  width: 9px;
  height: 9px;
  line-height: 12px;
  margin: 0;
  background: #d1d5db;
  border-radius: 50%;
  display: block;
  -webkit-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.center-section {
  position: relative;
  padding: 0 0 80px;
}
@media (max-width: 991.98px) {
  .center-section {
    padding: 0 0 40px;
  }
}
@media (max-width: 767.98px) {
  .center-section {
    padding: 0 0 16px;
  }
}

.center-img {
  position: relative;
  margin: 0 20px 0 0;
}
.center-img .center-service {
  position: absolute;
  right: 0;
  bottom: 30px;
  background: #ffffff;
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);
  border-radius: 100px;
  padding: 15px;
  text-align: left;
}
.center-img .center-service span {
  width: 40px;
  height: 40px;
  background: #1b5a90;
  color: #ffffff;
  border-radius: 100px;
  margin: 0 15px 0 0;
  flex-shrink: 0;
}
.center-img .center-service h6 {
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
  margin: 0 0 5px;
}
.center-img .center-service p {
  margin: 0;
}
@media (max-width: 991.98px) {
  .center-img .center-service {
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
  }
}
@media (max-width: 575.98px) {
  .center-img .center-service {
    width: 100%;
  }
}
@media (max-width: 991.98px) {
  .center-img {
    text-align: center;
    margin: 0 0 24px 0;
  }
}

.center-info .sec-heading-eye {
  margin: 0 0 15px;
}
.center-info p {
  margin: 0 0 15px;
}
.center-info p::last-child {
  margin: 0 0 15px;
}

.care-box span img {
  margin: 0 0 15px;
}
.care-box h6 {
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
  margin: 0 0 15px;
}
.care-box a {
  font-size: 14px;
  font-weight: 500;
  color: #1b5a90;
}
.care-box a:hover {
  color: #0e82fd;
}
.care-box a i {
  margin: 0 0 0 5px;
  font-size: 12px;
}
@media (max-width: 991.98px) {
  .care-box {
    margin-bottom: 24px;
  }
}

.counter-section {
  background: linear-gradient(90deg, #1b5a90 0%, #13a0ca 66.9%, #0ce0ff 106.51%);
  padding: 80px 0 56px;
  position: relative;
}
@media (max-width: 991.98px) {
  .counter-section {
    padding: 40px 0 16px;
  }
}

.bg-06 {
  left: 0;
  bottom: 0;
}

.bg-07 {
  right: 0;
  bottom: 0;
}

.count-box {
  margin: 0 0 24px;
}
.count-box .count-icon {
  width: 80px;
  height: 80px;
  background: #ffffff;
  border-radius: 100px;
  margin: 0 26px 0 0;
  flex-shrink: 0;
}
.count-box h3 {
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 15px;
}
@media (max-width: 991.98px) {
  .count-box h3 {
    font-size: 30px;
  }
}
@media (max-width: 767.98px) {
  .count-box h3 {
    font-size: 24px;
  }
}
.count-box p {
  color: #ffffff;
  margin: 0;
}

.eyeclinics-section {
  padding: 80px 0;
  position: relative;
}
@media (max-width: 991.98px) {
  .eyeclinics-section {
    padding: 40px 0;
  }
}

.bg-08 {
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}

.our-doctors-card.eye-doc {
  margin: 0 0 50px;
}
.our-doctors-card.eye-doc .doctors-header {
  overflow: hidden;
}
.our-doctors-card.eye-doc .doctors-header img {
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
}
.our-doctors-card.eye-doc .doctors-header:hover img {
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}
.our-doctors-card.eye-doc .doctors-body {
  padding: 15px;
}
.our-doctors-card.eye-doc .doctors-body h4 {
  font-weight: 600;
  margin: 0 0 5px;
}
.our-doctors-card.eye-doc .doctors-body h4 a {
  color: #1f2937;
}
.our-doctors-card.eye-doc .doctors-body h4 a:hover {
  color: #1b5a90;
}
.our-doctors-card.eye-doc .doctors-body p {
  margin: 0 0 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.our-doctors-card.eye-doc .doctors-body h6 {
  font-size: 14px;
  margin: 0 0 15px;
}
.our-doctors-card.eye-doc .doctors-body .rating i.filled {
  color: #ffaf14;
  padding: 0 2px;
}
.our-doctors-card.eye-doc .doctors-body .rating span {
  font-size: 14px;
  color: #000000;
  margin: 0 0 0 8px;
}
@media (max-width: 991.98px) {
  .our-doctors-card.eye-doc {
    margin: 0 0 30px;
  }
}

.facilities-section {
  padding: 80px 0 56px;
}
@media (max-width: 991.98px) {
  .facilities-section {
    padding: 40px 0 16px;
  }
}

.facility-box {
  margin: 0 0 24px;
}
.facility-box .facility-img {
  margin: 0 0 15px;
}
.facility-box .facility-img img {
  width: 100%;
}

.our-blog-section.eye-blog {
  background: linear-gradient(
    88.66deg,
    #d6eeff 1.08%,
    #f9fdff 26.56%,
    #ffffff 76.5%,
    #e6fcff 98.92%
  );
}
.our-blog-section.eye-blog .our-blogs {
  border-bottom: 0;
  border-radius: 0;
  margin: 0 0 50px;
}
.our-blog-section.eye-blog .our-blogs .blogs-img {
  overflow: hidden;
}
.our-blog-section.eye-blog .our-blogs .blogs-img .blog-inner-img {
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
}
.our-blog-section.eye-blog .our-blogs .blogs-img:hover .blog-inner-img {
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}
.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay {
  background: rgba(255, 255, 255, 0.9);
  padding: 10px;
  border-radius: 0;
  bottom: 0;
  width: 100%;
}
.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name img {
  height: 40px;
  width: 40px !important;
  margin-right: 5px;
}
.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name div {
  width: 60%;
}
.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name div a {
  margin: 0 0 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  font-weight: normal;
}
.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name div a:hover {
  color: #0e82fd;
}
.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name div a a {
  color: #1f2937;
}
.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name div p {
  font-size: 13px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0;
}
.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-cat {
  background: #1b5a90;
  font-weight: 500;
  font-size: 13px;
  padding: 4px 10px;
  color: #ffffff;
}
.our-blog-section.eye-blog .our-blogs .blogs-info h4 {
  margin: 0 0 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.our-blog-section.eye-blog .our-blogs .blogs-info h4 a {
  color: #1f2937;
}
.our-blog-section.eye-blog .our-blogs .blogs-info h4 a:hover {
  color: #1b5a90;
}
.our-blog-section.eye-blog .our-blogs .blogs-info p {
  font-size: 16px;
  color: #6b7280;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.our-blog-section.eye-blog .our-blogs .blogs-info .blogs-btn {
  font-weight: 500;
  font-size: 14px;
  color: #1b5a90;
}
.our-blog-section.eye-blog .our-blogs .blogs-info .blogs-btn i {
  margin: 0 0 0 5px;
}
.our-blog-section.eye-blog .our-blogs .blogs-info .blogs-btn:hover {
  color: #0e82fd;
}

.appointment-section {
  background-color: #1b5a90;
  position: relative;
  z-index: 1;
  padding-top: 325px;
}
@media (max-width: 767.98px) {
  .appointment-section {
    padding-top: 0;
  }
}
.appointment-section::before {
  position: absolute;
  top: -1px;
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_40___}) no-repeat center top;
  content: "";
  width: 100%;
  height: 100%;
  top: -1px;
  z-index: -1;
}
@media (max-width: 767.98px) {
  .appointment-section::before {
    background: none;
  }
}

.appointment-form {
  padding: 80px 0;
  position: relative;
}
@media (max-width: 991.98px) {
  .appointment-form {
    padding: 40px 0;
  }
}

.bg-09 {
  bottom: 0;
  right: 15%;
}

.bg-10 {
  bottom: 0;
  left: 3%;
}

.appointment-form .doctor-search-form .form-group {
  margin: 0 0 15px;
}
.appointment-form .doctor-search-form .form-group .form-custom input,
.appointment-form .doctor-search-form .form-group .form-custom select {
  background: #2369a6;
  box-shadow: none;
  color: #ffffff;
  border-radius: 0;
  min-height: 50px;
}
.appointment-form .doctor-search-form .form-group .form-custom input::placeholder,
.appointment-form .doctor-search-form .form-group .form-custom select::placeholder {
  color: #ffffff;
}
.appointment-form
  .doctor-search-form
  .form-group
  .form-custom
  .select2-container
  .select2-selection--single {
  height: 50px;
  background-color: #2369a6;
  border-color: #2369a6;
}
.appointment-form
  .doctor-search-form
  .form-group
  .form-custom
  .select2-container
  .select2-selection--single
  .select2-selection__rendered {
  color: #ffffff;
}
.appointment-form
  .doctor-search-form
  .form-group
  .form-custom
  .select2-container
  .select2-selection--single
  .select2-selection__rendered
  .select2-results__option--highlighted[aria-selected] {
  background-color: #2369a6;
}
.appointment-form .doctor-search-form .form-group .form-custom i {
  color: #ffffff;
}

.app-btn {
  border-radius: 100px;
  margin: 35px 0 0;
  padding: 11px 26px;
}

.faq-eye-section {
  padding: 80px 0;
  position: relative;
}
@media (max-width: 991.98px) {
  .faq-eye-section {
    padding: 40px 0;
  }
}

.faq-wrap ul {
  display: block;
  margin: 0;
  padding: 0;
}
.faq-wrap ul li {
  list-style: none;
}
.faq-wrap ul li a {
  background: #f0f4f6;
  margin: 0 0 15px;
  padding: 15px;
  color: #1f2937;
}
.faq-wrap ul li a span {
  width: 30px;
  height: 30px;
  background: #ffffff;
  border-radius: 100px;
  margin: 0 10px 0 0;
  flex-shrink: 0;
  color: #1f2937;
}
.faq-wrap ul li a.active {
  background: #1b5a90;
  color: #ffffff;
}

.faq-content img {
  margin: 0 0 29px;
}
.faq-content p {
  margin: 0 0 15px;
}
.faq-content p:last-child {
  margin: 0;
}

.eye-testimonial-section {
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .eye-testimonial-section {
    padding: 40px 0;
  }
}

.testi-img {
  position: relative;
  margin: 43px 0 15px;
}
.testi-img img {
  padding: 0 43px 0 0;
}
.testi-img .testi-icon {
  width: 86px;
  height: 86px;
  background: #0ce0ff;
  border-radius: 100px;
  font-size: 16px;
  color: #ffffff;
  position: absolute;
  top: -43px;
  right: 0;
}

.testi-users {
  margin: 0 43px 0 0;
}
.testi-users ul {
  margin: 0;
  padding: 0;
}
.testi-users ul li {
  display: inline-block;
  margin: 0 0 0 -23px;
}
.testi-users ul li:first-child {
  margin: 0;
}
.testi-users ul li img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border: 2px solid #ffffff;
}
@media (max-width: 767.98px) {
  .testi-users ul li img {
    width: 50px;
    height: 50px;
  }
}

.testimonial-wrap {
  position: relative;
}
.testimonial-wrap h4 {
  margin: 0 0 30px;
}
.testimonial-wrap p {
  margin: 0 0 30px;
}
.testimonial-wrap .testimonial-user h6 {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 5px;
}
.testimonial-wrap .testimonial-user p {
  font-size: 14px;
  margin: 0;
}
.testimonial-wrap::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_41___}) no-repeat;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 84px;
  height: 14px;
}

.slide-11 button {
  background: transparent;
  border: 0;
  padding: 0;
}
.slide-11 button.owl-next {
  margin: 0 0 0 10px;
}

.store-section {
  padding: 80px 0;
  position: relative;
  background: #f0f4f7 url(${___CSS_LOADER_URL_REPLACEMENT_42___}) no-repeat;
  background-position: top right;
}

.store-tab {
  margin: 0 0 35px;
}
.store-tab li {
  display: inline-block;
  margin: 0 0 15px 15px;
}
.store-tab li a {
  padding: 10px 15px;
  background: #ffffff;
  border-radius: 100px;
  color: #1f2937;
  display: inline-block;
}
.store-tab li a.active,
.store-tab li a:hover {
  background: #1b5a90;
  color: #ffffff;
}

.store-item {
  margin: 0 0 50px;
  padding: 15px;
  background: #ffffff;
}
.store-item .store-img {
  position: relative;
  overflow: hidden;
  margin: 0 0 15px;
}
.store-item .store-img img {
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
}
.store-item .store-img .glass-cat {
  background: #0ce0ff;
  color: #ffffff;
  font-size: 14px;
  padding: 5px 10px;
  position: absolute;
  top: 0;
  right: 0;
}
.store-item .store-img:hover img {
  transform: scale(1.1) rotate(0);
  -webkit-transform: scale(1.1) rotate(0);
  -ms-transform: scale(1.1) rotate(0);
}
.store-item .store-content .store-cat {
  background: #1b5a90;
  display: inline-block;
  color: #ffffff;
  font-size: 12px;
  margin: 0 0 5px;
  padding: 1px 5px;
}
.store-item .store-content h4 {
  font-weight: 600;
  margin: 0 0 5px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.store-item .store-content h4 a {
  color: #1f2937;
}
.store-item .store-content h4 a:hover {
  color: #1b5a90;
}
.store-item .store-content p {
  margin: 0 0 15px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.store-item .store-content .price-tag h5 {
  font-size: 22px;
  font-weight: 600;
  margin: 0;
}
.store-item .store-content .price-tag .color-selection {
  margin: 0;
  padding: 0;
}
.store-item .store-content .price-tag .color-selection li {
  list-style: none;
  display: inline-block;
  margin-right: 5px;
}
.store-item .store-content .price-tag .color-selection li span i {
  font-size: 16px;
  outline: 1px solid #d9d9d9;
  outline-offset: 3px;
  border-radius: 50%;
}
.store-item .store-content .price-tag .color-selection li span.black-glass {
  color: #131218;
}
.store-item .store-content .price-tag .color-selection li span.blue-glass {
  color: #2369a6;
}
.store-item .store-content .price-tag .color-selection li span.gold-glass {
  color: #ddbc5b;
}
.store-item .store-content .price-tag .color-selection li span.grey-glass {
  color: #666666;
}
.store-item .store-content .price-tag .color-selection li span.sand-glass {
  color: #fdeec3;
}
.store-item .store-content .price-tag .color-selection li span.green-glass {
  color: #13c2c2;
}
.store-item .store-content .price-tag .color-selection li:last-child {
  margin-right: 0;
}

.offer-section {
  padding-top: 124px;
}
@media (max-width: 991.98px) {
  .offer-section {
    padding-top: 73px;
  }
}

.offer-wrap {
  background: radial-gradient(50% 50% at 50% 50%, #328cd9 0%, #1b5a90 100%);
  margin: 0;
  padding: 0 24px;
}
@media (max-width: 991.98px) {
  .offer-wrap {
    margin: 0 0 60px 0;
    padding: 20px 24px !important;
  }
}
.offer-wrap.flat-offer {
  background: radial-gradient(50% 50% at 50% 50%, #97f0ff 0%, #0cbcda 100%);
}
@media (max-width: 991.98px) {
  .offer-wrap.flat-offer {
    margin-bottom: 0;
  }
}
.offer-wrap.flat-offer .btn {
  background: #1c5c92;
}
.offer-wrap.flat-offer .btn:hover {
  color: #1c5c92;
}
.offer-wrap .off-img {
  margin: -45px 0 24px;
}
@media (max-width: 767.98px) {
  .offer-wrap .off-img {
    text-align: center;
  }
}
.offer-wrap .off-info {
  position: relative;
  text-align: center;
}
.offer-wrap .off-info h6 {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 5px;
}
.offer-wrap .off-info p {
  margin: 0 0 5px;
  padding: 0 17px;
  position: relative;
  color: #ffffff;
  display: inline-block;
}
.offer-wrap .off-info p::before {
  content: "";
  background: #ffffff;
  width: 15px;
  height: 1px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.offer-wrap .off-info p::after {
  content: "";
  background: #ffffff;
  width: 15px;
  height: 1px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.offer-wrap .off-info h5 {
  color: #ffffff;
  margin: 0 0 15px;
}
.offer-wrap .off-info .btn {
  font-size: 16px;
  padding: 3px 42px;
  border-radius: 100px;
}
.offer-wrap .off-info::before,
.offer-wrap .off-info::after {
  content: "";
  display: block;
  position: absolute;
  width: 18px;
  height: 85%;
  border: 1px solid;
  -webkit-transition: all 0.6s ease;
  -ms-transition: all 0.6s ease;
  transition: all 0.6s ease;
}
.offer-wrap .off-info::before {
  bottom: 0;
  left: 0;
  top: 8px;
  border-top-color: #ffffff;
  border-left-color: #ffffff;
  border-bottom-color: #ffffff;
  border-right-color: transparent;
}
.offer-wrap .off-info::after {
  bottom: 0;
  right: 0;
  top: 8px;
  border-top-color: #ffffff;
  border-left-color: transparent;
  border-bottom-color: #ffffff;
  border-right-color: #ffffff;
}

.eye-testimonial-section .eye-testislider .owl-nav {
  position: absolute;
  margin-left: -472px;
  margin-top: 26px;
}

.appointment-form .form-group .form-custom .timepicker1 {
  background: none;
  border: none;
  padding: 0;
}

.appointment-form .form-group .form-custom .timepicker1 .rc-time-picker-input {
  font-size: 15px;
}

.main-wrapper.home-twelve {
  font-size: 16px;
  font-family: "Inter", sans-serif;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-twelve {
    font-size: 15px;
  }
}
.main-wrapper.home-twelve .row-gap {
  row-gap: 24px;
}
.main-wrapper.home-twelve a:hover {
  color: #0e82fd;
}
.main-wrapper.home-twelve .banner-section-fourteen.banner-section-twelve {
  background: #f9f9f9;
  padding: 200px 0 80px 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .banner-section-fourteen.banner-section-twelve {
    padding: 150px 0 50px 0;
  }
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve .banner-section-fourteen.banner-section-twelve {
    padding: 100px 0 50px 0;
  }
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-section-twelve-bg
  img {
  position: absolute;
  z-index: -1;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-section-twelve-bg
  img:nth-child(1) {
  left: 0;
  bottom: 0;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-section-twelve-bg
  img:nth-child(2) {
  right: 0;
  top: 100px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve
    .banner-section-fourteen.banner-section-twelve
    .banner-section-twelve-bg
    img:nth-child(2) {
    display: none;
  }
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-img.banner-img-twelve {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  position: relative;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-img.banner-img-twelve
  img:nth-child(2) {
  animation: movers 1s ease infinite alternate;
  animation-delay: 1s;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-img.banner-img-twelve
  .banner-banner-img-twelve-bg
  img {
  position: absolute;
  z-index: -1;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-img.banner-img-twelve
  .banner-banner-img-twelve-bg
  img:nth-child(1) {
  bottom: 9%;
  right: 46%;
  animation: gelatine 2s infinite;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-img.banner-img-twelve
  .banner-banner-img-twelve-bg
  img:nth-child(2) {
  left: 0;
  animation: grow 2s ease infinite alternate;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-img.banner-img-twelve
  .banner-banner-img-twelve-bg
  img:nth-child(3) {
  right: 48%;
  top: -92px;
  animation: movers 2s infinite alternate;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-img.banner-img-twelve
  .banner-banner-img-twelve-bg
  img:nth-child(4) {
  bottom: 22%;
  right: 30%;
  animation: movers 2s infinite alternate;
}
@keyframes gelatine {
  from,
  to {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(0.9, 1.1);
  }
  50% {
    transform: scale(1.1, 0.9);
  }
  75% {
    transform: scale(0.95, 1.05);
  }
}
@keyframes grow {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve
    .banner-section-fourteen.banner-section-twelve
    .banner-img.banner-img-twelve {
    display: none;
  }
}
.main-wrapper.home-twelve .banner-section-fourteen.banner-section-twelve .banner-content-fourteen {
  margin: 0;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-content-fourteen
  h1 {
  color: #0e82fd;
  max-width: 460px;
  margin: 0 0 20px 0;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-content-fourteen
  h1
  span {
  color: #1f2937;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve
    .banner-section-fourteen.banner-section-twelve
    .banner-content-fourteen
    h1 {
    margin: auto;
  }
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-content-fourteen
  .banner-btns-fourteen
  .btn-primary {
  background: transparent;
  color: #0e82fd;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-content-fourteen
  .banner-btns-fourteen
  .btn-primary:hover {
  background: #0e82fd;
  color: #ffffff;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-content-fourteen
  .banner-btns-fourteen
  .btn-primary:nth-child(1) {
  background: #0e82fd;
  color: #ffffff;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-content-fourteen
  .banner-btns-fourteen
  .btn-primary:nth-child(1):hover {
  background: transparent;
  color: #0e82fd !important;
  border: 1px solid #0e82fd;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .banner-content-fourteen
  .banner-btns-fourteen
  .btn-primary:nth-child(2):hover {
  color: #ffffff;
  border-color: #0e82fd;
}
.main-wrapper.home-twelve .banner-section-fourteen.banner-section-twelve .search-box-fourteen {
  padding: 20px;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .search-box-fourteen
  .form-block {
  align-items: center;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .search-box-fourteen
  .form-block
  .search-input
  label {
  position: relative;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .search-box-fourteen
  .form-block
  .search-input
  label::after {
  position: absolute;
  content: "\\f274";
  font-family: "Font Awesome 5 Free";
  color: #0e82fd;
  font-weight: 900;
  right: -24px;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .search-box-fourteen
  .form-block
  .search-input
  label.location-icon::after {
  position: absolute;
  content: "\\f3c5";
  font-family: "Font Awesome 5 Free";
  color: #0e82fd;
  font-weight: 900;
  right: -24px;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .search-box-fourteen
  .form-block
  .search-input
  .form-control::placeholder {
  font-weight: 600;
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .search-box-fourteen
  .form-block
  .search-btn {
  margin: 0;
}
@media (max-width: 767.98px) {
  .main-wrapper.home-twelve
    .banner-section-fourteen.banner-section-twelve
    .search-box-fourteen
    .form-block
    .search-btn {
    width: 100%;
  }
}
.main-wrapper.home-twelve
  .banner-section-fourteen.banner-section-twelve
  .search-box-fourteen
  .form-block
  .search-btn
  .btn.btn-primary {
  padding: 14px 16px;
}
.main-wrapper.home-twelve .section-header-fourteen {
  text-align: center;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .section-header-fourteen {
    text-align: center !important;
  }
}
.main-wrapper.home-twelve .section-header-fourteen .service-inner-fourteen {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  justify-content: center;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .section-header-fourteen .service-inner-fourteen {
    justify-content: center !important;
  }
}
.main-wrapper.home-twelve
  .section-header-fourteen
  .service-inner-fourteen
  .service-inner-fourteen-one {
  background: #0e82fd;
  content: "";
  width: 50px;
  height: 3px;
}
.main-wrapper.home-twelve
  .section-header-fourteen
  .service-inner-fourteen
  .service-inner-fourteen-two
  h3 {
  color: #0e82fd;
  font-size: 14px;
  margin: 0 0;
  padding: 10px 20px;
  border-radius: 100px;
  font-weight: 400;
  background: #e3f2f9;
  z-index: 99;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-twelve
    .section-header-fourteen
    .service-inner-fourteen
    .service-inner-fourteen-two
    h3 {
    font-size: 14px;
  }
}
.main-wrapper.home-twelve
  .section-header-fourteen
  .service-inner-fourteen
  .service-inner-fourteen-three {
  background: #0e82fd;
  content: "";
  width: 50px;
  height: 3px;
}
.main-wrapper.home-twelve .section-header-fourteen h2 {
  color: #1f2937;
  font-size: 40px;
  font-weight: 600;
  position: relative;
  margin: 0 0 10px 0;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-twelve .section-header-fourteen h2 {
    font-size: 32px;
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .section-header-fourteen h2 {
    margin: 0 0 10px 0;
  }
}
.main-wrapper.home-twelve .section-header-fourteen h2::before {
  position: absolute;
  flex-shrink: 0;
  width: 120px;
  height: 110px;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  background-repeat: no-repeat;
  background-size: contain;
  transition: transform 0.2s ease-in-out;
  top: -36px;
  transform: translate(-50%, 0);
  left: 50%;
  z-index: -1;
}
.main-wrapper.home-twelve .section-header-fourteen p {
  color: #6b7280;
  font-size: 18px;
  font-weight: 400;
  margin: 0 0 50px 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .section-header-fourteen p {
    margin: 0 0 35px 0;
    font-size: 16px;
  }
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve .section-header-fourteen p {
    margin: 0 0 30px 0;
  }
}
.main-wrapper.home-twelve .services-section-fourteen {
  background: #f9fafb;
  position: relative;
}
.main-wrapper.home-twelve .services-section-fourteen .floating-bg img {
  position: absolute;
}
.main-wrapper.home-twelve .services-section-fourteen .floating-bg img:nth-child(1) {
  right: 0;
  top: 150px;
}
.main-wrapper.home-twelve .services-section-fourteen .floating-bg img:nth-child(2) {
  left: 0;
  bottom: 100px;
}
.main-wrapper.home-twelve .services-section-fourteen .our-services-list {
  border-radius: 30px;
  padding: 30px;
  background: #ffffff;
  text-align: center;
  transition: all 0.5s;
}
.main-wrapper.home-twelve .services-section-fourteen .our-services-list .service-icon {
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0e82fd;
  margin: auto;
  box-shadow: 0px 25px 50px rgba(14, 130, 253, 0.1);
  border-radius: 30px;
  -webkit-transition: 0.4s;
  -ms-transition: 0.4s;
  transition: 0.4s;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .services-section-fourteen .our-services-list .service-icon {
    width: 120px;
    height: 120px;
  }
}
.main-wrapper.home-twelve .services-section-fourteen .our-services-list h4 {
  margin: 0;
  padding: 20px 0;
  font-size: 24px;
  font-weight: 600;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .services-section-fourteen .our-services-list h4 {
    padding: 15px 0;
    font-size: 22px;
  }
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve .services-section-fourteen .our-services-list h4 {
    font-size: 20px;
  }
}
.main-wrapper.home-twelve .services-section-fourteen .our-services-list p {
  color: #6b7280;
  font-size: 14px;
  text-align: center;
  margin: 0;
}
.main-wrapper.home-twelve .services-section-fourteen .our-services-list:hover {
  cursor: pointer;
  background: #334155;
  box-shadow: 0px 20px 50px rgba(51, 65, 85, 0.05);
  transform: translateY(-10px);
}
.main-wrapper.home-twelve .services-section-fourteen .our-services-list:hover .service-icon {
  transform: rotateY(360deg);
  -webkit-transform: rotateY(360deg);
  -ms-transform: rotateY(360deg);
  background: #ffffff;
}
.main-wrapper.home-twelve .services-section-fourteen .our-services-list:hover .service-icon img {
  filter: invert(1) brightness(100);
}
.main-wrapper.home-twelve .services-section-fourteen .our-services-list:hover h4,
.main-wrapper.home-twelve .services-section-fourteen .our-services-list:hover p {
  color: #ffffff;
}
.main-wrapper.home-twelve .blog-section-fourteen.our-doctor-twelve {
  background: #f3f4f6;
  position: relative;
  z-index: 1;
}
.main-wrapper.home-twelve .blog-section-fourteen.our-doctor-twelve .floating-bg img {
  position: absolute;
}
.main-wrapper.home-twelve .blog-section-fourteen.our-doctor-twelve .floating-bg img:nth-child(1) {
  right: 0;
  top: 150px;
}
.main-wrapper.home-twelve .blog-section-fourteen.our-doctor-twelve .floating-bg img:nth-child(2) {
  left: 0;
  bottom: 100px;
}
.main-wrapper.home-twelve .blog-section-fourteen.our-doctor-twelve .blog-inner-fourt-all {
  border-radius: 40px;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main {
  padding: 15px;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt {
  text-align: center;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-right-img {
  position: relative;
  margin: 0 0 20px 0;
  overflow: hidden;
  border-radius: 30px;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-right-img
  img {
  position: relative;
  border-radius: 30px;
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  width: 100%;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-right-img:hover
  img {
  transform: scale(1.2);
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content {
  position: absolute;
  top: auto;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 8px 0;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50px;
  min-width: 180px;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content
  img {
  width: 35px;
  height: 35px;
  border-radius: 50px;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content
  span {
  font-size: 14px;
  color: #0e82fd;
  font-weight: 600;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content.content-pricing {
  position: absolute;
  top: 20px;
  right: 20px;
  bottom: auto;
  left: auto;
  transform: none;
  min-width: 65px;
  border-radius: 8px;
  background: #ffffff;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content.content-pricing
  span {
  color: #1f2937;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-right-fourt-care {
  display: block;
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 10px 0;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-right-fourt-care
  a:hover {
  color: #0e82fd;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-articles-list {
  margin: 0 0 20px 0;
  justify-content: center;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-articles-list
  li {
  color: #6b7280;
  font-size: 14px;
  margin: 0 0px 0 0;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-articles-list
  li
  i {
  color: #d1d5db;
  margin-right: 6px;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-articles-list-two {
  margin: 0 0 10px 0;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-articles-list-two
  li {
  background: #dbeffe;
  color: #0e82fd;
  margin: 0 10px 10px 0;
  padding: 10px 15px;
  border-radius: 8px;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-articles-list-two
  li:last-child {
  margin: 0 0 10px 0;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-list-ratings {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-list-ratings
  i {
  color: rgba(26, 84, 199, 0.15);
  margin-right: 2px;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-list-ratings
  i:last-child {
  margin-right: 0;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-list-ratings
  i.rated {
  color: #ffc001;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-list-ratings
  span {
  color: #9ca3af;
  font-size: 14px;
  margin-left: 3px;
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .btn-primary {
  background: #0e82fd;
  color: #ffffff;
  border: 1px solid #0e82fd;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve
    .blog-section-fourteen.our-doctor-twelve
    .blog-inner-fourt-all
    .blog-inner-fourt-main
    .blog-inner-right-fourt
    .btn-primary {
    width: 100%;
  }
}
.main-wrapper.home-twelve
  .blog-section-fourteen.our-doctor-twelve
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .btn-primary:hover {
  background: #ffffff;
  color: #0e82fd;
}
.main-wrapper.home-twelve .clients-section-fourteen {
  position: relative;
  z-index: 1;
  padding: 80px 0;
  background: #f9fafb;
}
.main-wrapper.home-twelve .clients-section-fourteen .floating-bg img {
  position: absolute;
}
.main-wrapper.home-twelve .clients-section-fourteen .floating-bg img:nth-child(1) {
  right: 10px;
  top: 50px;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-twelve .clients-section-fourteen {
    padding: 80px 0;
  }
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-twelve .clients-section-fourteen {
    padding: 50px 0;
  }
}
.main-wrapper.home-twelve .clients-section-fourteen .section-header-fourteen {
  text-align: start;
}
.main-wrapper.home-twelve .clients-section-fourteen .section-header-fourteen h2 {
  display: inline-block;
}
.main-wrapper.home-twelve
  .clients-section-fourteen
  .section-header-fourteen
  .service-inner-fourteen {
  justify-content: start;
}
.main-wrapper.home-twelve .clients-section-fourteen .client-inner-main {
  -webkit-animation: mover 2s infinite alternate;
  animation: mover 2s infinite alternate;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .clients-section-fourteen .client-inner-main {
    display: none;
  }
}
.main-wrapper.home-twelve .clients-section-fourteen .feedback-slider-fourteen .owl-nav {
  text-align: end;
  margin-top: 40px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .clients-section-fourteen .feedback-slider-fourteen .owl-nav {
    text-align: center;
    margin-top: 10px;
  }
}
.main-wrapper.home-twelve .clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-prev {
  background: #e2e8f0;
  border-radius: 8px;
  width: 50px;
  height: 50px;
  color: #94a3b8;
  text-shadow: none;
  font-size: 24px;
  border: none;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-prev {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
}
.main-wrapper.home-twelve
  .clients-section-fourteen
  .feedback-slider-fourteen
  .owl-nav
  .owl-prev:hover {
  background: #bfe0fe;
  color: #1d7ed8;
}
.main-wrapper.home-twelve .clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-next {
  background: #e2e8f0;
  border-radius: 8px;
  width: 50px;
  height: 50px;
  color: #94a3b8;
  text-shadow: none;
  font-size: 24px;
  border: none;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-next {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
}
.main-wrapper.home-twelve
  .clients-section-fourteen
  .feedback-slider-fourteen
  .owl-nav
  .owl-next:hover {
  background: #bfe0fe;
  color: #1d7ed8;
}
.main-wrapper.home-twelve .clients-section-fourteen .feedback-card {
  border-radius: 30px;
  margin: 0 0 0 0;
  background: transparent;
  border: none;
}
.main-wrapper.home-twelve .clients-section-fourteen .feedback-card .feedback-card-body {
  padding: 0px;
}
.main-wrapper.home-twelve
  .clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .feedback-inner-img {
  display: flex;
  align-items: center;
  justify-content: start;
  margin: 0 0 50px 0;
  border: 2px solid #10b981;
  border-radius: 40px;
  padding: 20px;
  gap: 20px;
  max-width: 660px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve
    .clients-section-fourteen
    .feedback-card
    .feedback-card-body
    .feedback-inner-main
    .feedback-inner-img {
    margin: auto;
    margin-bottom: 30px;
  }
}
.main-wrapper.home-twelve
  .clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .feedback-inner-img
  h6 {
  color: #1f2937;
  font-size: 16px;
}
.main-wrapper.home-twelve
  .clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .feedback-inner-img
  img {
  width: 100px;
  height: 100px;
  border-radius: 20px;
}
.main-wrapper.home-twelve
  .clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .feedback-inner-img
  h4 {
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 5px 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve
    .clients-section-fourteen
    .feedback-card
    .feedback-card-body
    .feedback-inner-main
    .feedback-inner-img
    h4 {
    font-size: 18px;
  }
}
.main-wrapper.home-twelve
  .clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .feedback-inner-img
  h6 {
  color: #94a3b8;
  font-size: 16px;
  margin: 0 0 20px 0;
}
.main-wrapper.home-twelve
  .clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .feedback-inner-img
  .rating-fourteen {
  margin: 0 0 0 0;
}
.main-wrapper.home-twelve
  .clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .feedback-inner-img
  .rating-fourteen
  .filled {
  color: #ffc001;
}
.main-wrapper.home-twelve
  .clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .feedback-inner-img
  .rating-fourteen
  i {
  font-size: 18px;
}
.main-wrapper.home-twelve
  .clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  p {
  color: #6b7280;
  font-size: 20px;
  margin: 0 0 0 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve
    .clients-section-fourteen
    .feedback-card
    .feedback-card-body
    .feedback-inner-main
    p {
    font-size: 20px;
    text-align: center;
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve
    .clients-section-fourteen
    .feedback-card
    .feedback-card-body
    .feedback-inner-main
    p {
    font-size: 17px;
  }
}
.main-wrapper.home-twelve .home-twelve-pricing {
  position: relative;
  z-index: 1;
  padding: 80px 0 80px 0;
  background: #f3f4f6;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve {
  height: 605px;
  background: #ffffff;
  border-radius: 30px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transition: all 0.7s;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-bg img {
  position: absolute;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-bg img:nth-child(1) {
  bottom: 0;
  left: 0;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-bg img:nth-child(2) {
  bottom: 0;
  right: 0;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-bg img:nth-child(3) {
  top: 0;
  right: 0;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .card-title {
  margin-bottom: 0;
  text-align: center;
  margin-bottom: 40px;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .card-title h3 {
  font-weight: 600;
  font-size: 30px;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .card-title span {
  color: #0e82fd;
  font-size: 14px;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .price {
  margin-bottom: 40px;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .price h2 {
  color: #0e82fd;
  font-style: 48px;
  font-weight: 600;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .price h2 span {
  font-size: 14px;
  color: #6b7280;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .pack-details {
  margin-bottom: 40px;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .pack-details ul {
  list-style: none;
  padding: 0;
}
.main-wrapper.home-twelve
  .home-twelve-pricing
  .price-card-twelve
  .price-content
  .pack-details
  ul
  li {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  color: #6b7280;
}
.main-wrapper.home-twelve
  .home-twelve-pricing
  .price-card-twelve
  .price-content
  .pack-details
  ul
  li
  i {
  margin-right: 10px;
  color: #0e82fd;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .price-btn a {
  min-width: 198px;
  background: #0e82fd;
  color: #ffffff;
  border-radius: 6px;
  text-align: center;
  border: 1px solid #0e82fd;
}
.main-wrapper.home-twelve
  .home-twelve-pricing
  .price-card-twelve
  .price-content
  .price-btn
  a:hover {
  background: #ffffff;
  color: #0e82fd;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve:hover,
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve.active {
  cursor: pointer;
  background: #1e293b;
}
.main-wrapper.home-twelve
  .home-twelve-pricing
  .price-card-twelve:hover
  .price-content
  .card-title
  h3,
.main-wrapper.home-twelve
  .home-twelve-pricing
  .price-card-twelve.active
  .price-content
  .card-title
  h3 {
  color: #ffffff;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve:hover .price h2,
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve.active .price h2 {
  color: #ffffff;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve:hover .price h2 span,
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve.active .price h2 span {
  color: #ffffff;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve:hover .pack-details,
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve.active .pack-details {
  margin-bottom: 40px;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve:hover .pack-details ul li,
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve.active .pack-details ul li {
  color: #ffffff;
}
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve:hover .pack-details ul li i,
.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve.active .pack-details ul li i {
  color: #0e82fd;
}
.main-wrapper.home-twelve .blog-section-fourteen {
  background: #f9fafb;
  position: relative;
  z-index: 1;
}
.main-wrapper.home-twelve
  .blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-right-fourt-care {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.main-wrapper.home-twelve
  .blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-right-fourt-care:hover {
  color: #0e82fd;
}
.main-wrapper.home-twelve
  .blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content {
  padding: 5px 15px 5px 5px;
}
.main-wrapper.home-twelve .blog-section-fourteen .blog-btn-sec .btn-view {
  border: 1px solid #0e82fd;
}
.main-wrapper.home-twelve .blog-section-fourteen .blog-btn-sec .btn-view:hover {
  box-shadow: inset 220px 0 0 0 #ffffff;
  color: #0e82fd;
}
.main-wrapper.home-twelve .choose-us-fourteen {
  background: #f3f4f6;
  position: relative;
  z-index: 1;
}
.main-wrapper.home-twelve .why-us-content .section-title {
  align-items: start;
}
.main-wrapper.home-twelve .why-us-content .section-title h2 {
  font-size: 60px;
  font-weight: 500;
}
.main-wrapper.home-twelve .why-us-content .section-title p {
  font-size: 18px;
  font-weight: 500;
  text-align: start;
}
@keyframes updown {
  100% {
    transform: translateY(-10px);
  }
}
.main-wrapper.home-twelve .us-title h6 {
  font-weight: 500;
  font-size: 20px;
}
.main-wrapper.home-twelve .accordion-item:first-of-type {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.main-wrapper.home-twelve .accordion-item {
  background-color: transparent;
  border: 0px solid rgba(0, 0, 0, 0.125);
  border-radius: 20px;
  margin: 5px 0px 15px 0px;
}
.main-wrapper.home-twelve .accordion-header button {
  font-weight: 600;
  font-size: 20px;
  color: #333333;
}
.main-wrapper.home-twelve .accordion-header {
  margin-bottom: 0;
}
.main-wrapper.home-twelve .accordion-item:first-of-type .accordion-button {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve .accordion-item:first-of-type .accordion-button {
    font-size: 16px;
  }
}
.main-wrapper.home-twelve .accordion-item .accordion-button {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve .accordion-item .accordion-button {
    font-size: 16px;
  }
}
.main-wrapper.home-twelve .accordion-button:not(.collapsed) {
  background-color: #ffffff;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.main-wrapper.home-twelve .accordion-button:not(.collapsed) {
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.13);
}
.main-wrapper.home-twelve .shade {
  box-shadow: -8px 13px 80px rgba(27, 41, 80, 0.1);
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}
.main-wrapper.home-twelve .accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem 1.25rem;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out,
    border-radius 0.15s ease;
}
.main-wrapper.home-twelve .accordion-button::after {
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  content: "\\f0d7";
  font-family: "Font Awesome 5 Free";
  color: #0e82fd;
  font-weight: 900;
  transition: transform 0.2s ease-in-out;
  position: absolute;
  right: 15px;
  background-size: auto;
  background-image: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dbeffe;
  border-radius: 8px;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve .accordion-button::after {
    width: 30px;
    height: 30px;
  }
}
.main-wrapper.home-twelve .accordion-button:not(.collapsed)::after {
  transform: rotateX(180deg);
  background-color: #0e82fd;
  color: #ffffff;
}
.main-wrapper.home-twelve .accordion-button:focus {
  z-index: 3;
  border-color: #fff;
  outline: 0;
  box-shadow: none;
}
.main-wrapper.home-twelve .accordion-body {
  padding: 0rem 6.25rem 1rem 6.26rem;
  background: #ffffff;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve .accordion-body {
    padding: 0rem 2rem 1rem 6.26rem;
  }
}
.main-wrapper.home-twelve .accordion-body h6 {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #6b7280;
}
.main-wrapper.home-twelve .accordion-button::before {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  margin-right: 30px;
  background-repeat: no-repeat;
  transition: transform 0.2s ease-in-out;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve .accordion-button::before {
    margin-right: 15px;
  }
}
.main-wrapper.home-twelve .slide-nav-16 button.owl-next,
.main-wrapper.home-twelve .slide-nav-16 button.owl-prev,
.main-wrapper.home-twelve .slide-nav-15 button.owl-next,
.main-wrapper.home-twelve .slide-nav-15 button.owl-prev {
  background: #e2e8f0;
  border-radius: 8px;
  width: 50px;
  height: 50px;
  color: #94a3b8;
  text-shadow: none;
  font-size: 24px;
  border: none;
  position: absolute;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .slide-nav-16 button.owl-next,
  .main-wrapper.home-twelve .slide-nav-16 button.owl-prev,
  .main-wrapper.home-twelve .slide-nav-15 button.owl-next,
  .main-wrapper.home-twelve .slide-nav-15 button.owl-prev {
    width: 40px;
    height: 40px;
    font-size: 20px;
    margin: 0 10px 30px 0;
  }
}
.main-wrapper.home-twelve .slide-nav-16 button.owl-next:hover,
.main-wrapper.home-twelve .slide-nav-16 button.owl-prev:hover,
.main-wrapper.home-twelve .slide-nav-15 button.owl-next:hover,
.main-wrapper.home-twelve .slide-nav-15 button.owl-prev:hover {
  background: #bfe0fe;
  color: #1d7ed8;
}
.main-wrapper.home-twelve .slide-nav-16 button.owl-next,
.main-wrapper.home-twelve .slide-nav-15 button.owl-next {
  right: 15px;
  top: 50%;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .slide-nav-16 button.owl-next,
  .main-wrapper.home-twelve .slide-nav-15 button.owl-next {
    z-index: 1;
  }
}
.main-wrapper.home-twelve .slide-nav-16 button.owl-prev,
.main-wrapper.home-twelve .slide-nav-15 button.owl-prev {
  left: 15px;
  top: 50%;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve .slide-nav-16 button.owl-prev,
  .main-wrapper.home-twelve .slide-nav-15 button.owl-prev {
    z-index: 1;
  }
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve .slide-nav-15 button.owl-next,
  .main-wrapper.home-twelve .slide-nav-15 button.owl-prev {
    top: 43%;
  }
}

.main-wrapper.home-twelve.home-thirteen .row-gap {
  row-gap: 24px;
}
.main-wrapper.home-twelve.home-thirteen a:hover {
  color: #0e82fd;
}
.main-wrapper.home-twelve.home-thirteen .common-padding {
  margin: 0;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .common-padding {
    margin: 0;
    padding: 50px 0;
  }
}
.main-wrapper.home-twelve.home-thirteen .banner-section-thirteen {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  background-repeat: no-repeat;
  background-size: 100% 80%;
  background-position: top;
  padding: 165px 0 0px 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .banner-section-thirteen {
    background-image: none;
    background-color: #0e82fd;
    padding: 135px 0 0px 0;
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-center-img img {
    display: none;
  }
}
.main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content {
  padding-bottom: 0;
  text-align: center;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content {
    padding-bottom: 40px;
  }
}
.main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content h4 {
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 20px;
}
@media (max-width: 767.98px) {
  .main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content h4 {
    font-size: 16px;
  }
}
.main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content h1 {
  text-transform: capitalize;
  color: #ffffff;
  margin-bottom: 20px;
}
.main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content p {
  font-size: 20px;
  color: #ffffff;
  max-width: 570px;
  margin: auto auto 20px auto;
}
@media (max-width: 767.98px) {
  .main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content p {
    font-size: 16px;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-content
  .banner-btns-fourteen
  .btn-primary {
  padding: 20px 30px;
  background: #ffffff;
  color: #0e82fd;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  transition: all 0.7s;
  box-shadow: inset 0 0 0 0 #ffffff;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .banner-content
    .banner-btns-fourteen
    .btn-primary {
    padding: 15px 20px;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-content
  .banner-btns-fourteen
  .btn-primary:hover {
  background: #1c5b91;
  color: #ffffff;
  box-shadow: inset 0 100px 0 0 #1c5b91;
  -webkit-transition: all 0.7s;
  -ms-transition: all 0.7s;
  transition: all 0.7s;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen {
  margin: 0;
  padding: 20px;
  box-shadow: 0px 19.9607px 87.3282px rgba(32, 36, 138, 0.06);
  border-radius: 10px;
  min-width: 100%;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-title {
  margin-bottom: 15px;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-title
  h5 {
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .search-title
    h5 {
    font-size: 20px;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input {
  margin-right: 24px;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .search-input {
    margin-right: 17px;
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .search-input {
    margin-bottom: 15px;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input.search-line-thirteen {
  width: 20%;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .search-input.search-line-thirteen {
    width: 100%;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input.search-map-line-thirteen {
  width: 19%;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .search-input.search-map-line-thirteen {
    width: 100%;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input.search-calendar-line-thirteen {
  width: 18%;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .search-input.search-calendar-line-thirteen {
    width: 100%;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input.search-users-line-thirteen {
  width: 18%;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .search-input.search-users-line-thirteen {
    width: 100%;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input
  .select2-container
  .select2-selection--single
  .select2-selection__rendered {
  padding-left: 46px;
  line-height: 56px;
  font-size: 16px;
  font-weight: 400;
  color: #6b7280;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .search-input
    .select2-container
    .select2-selection--single
    .select2-selection__rendered {
    font-size: 14px;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input
  .select2-container--default
  .select2-selection--single {
  background: #f8fbff;
  border: none;
  border-radius: 4px;
  height: 54px;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow {
  top: 5px;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow
  b {
  border-color: #6b7280 transparent transparent;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input
  i {
  left: 20px;
  z-index: 1;
  font-size: 14px;
  color: #d1d5db;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input
  input {
  padding: 0 10px 0 46px;
  background: #f8fbff;
  height: 54px;
  min-height: 54px;
  font-size: 15px;
  color: #6b7280;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .search-input
    input {
    font-size: 14px;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input
  input:hover,
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .search-input
  input:focus {
  background-color: #f8fbff !important;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .form-search-btn {
  padding-top: 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .form-search-btn {
    float: none;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .search-box-one.search-box-thirteen
  .form-search-btn
  .btn {
  min-width: auto;
  padding: 14px 43px;
  border-radius: 4px;
  font-size: 14px;
}
@media (max-width: 1399.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .form-search-btn
    .btn {
    padding: 14px 23px;
  }
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .form-search-btn
    .btn {
    padding: 14px 14px;
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .search-box-one.search-box-thirteen
    .form-search-btn
    .btn {
    width: 100%;
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-section-thirteen-bg {
    display: none;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-one {
  position: absolute;
  right: 50px;
  bottom: 250px;
  animation: elastic-spin 1s infinite ease;
  z-index: -1;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-two {
  position: absolute;
  bottom: 350px;
  left: 100px;
  animation: elastic-spin 1s infinite ease;
  z-index: -1;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-three {
  position: absolute;
  top: 350px;
  left: 130px;
  animation: elastic-spin 1s infinite ease;
  z-index: -1;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-four {
  position: absolute;
  right: 130px;
  bottom: 350px;
  animation: elastic-spin 1s infinite ease;
  z-index: -1;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-five {
  position: absolute;
  top: 600px;
  right: 130px;
  animation: elastic-spin 1s infinite ease;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-six {
  position: absolute;
  top: 500px;
  right: 50%;
  animation: elastic-spin 1s infinite ease;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-seven {
  position: absolute;
  top: 500px;
  left: 80%;
  animation: pulse 1s infinite ease-in-out alternate;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-eight {
  position: absolute;
  top: 350px;
  left: 30%;
  animation: pulse 1s infinite ease-in-out alternate;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-nine {
  position: absolute;
  top: 200px;
  left: 15%;
  animation: spin 3000ms linear infinite;
  z-index: -1;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-ten {
  position: absolute;
  top: 150px;
  right: 23%;
  animation: elastic-spin 1s infinite ease;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-eleven {
  position: absolute;
  top: 20%;
  right: 23%;
  animation: spin 3000ms linear infinite;
  z-index: -1;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-thirteen {
  position: absolute;
  top: 6%;
  right: 5%;
  animation: spin 3000ms linear infinite;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-fourteen {
  position: absolute;
  top: 8%;
  right: 5%;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .banner-section-thirteen
    .banner-section-thirteen-bg
    .banner-section-thirteen-bg-fourteen {
    display: none;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-fifteen {
  position: absolute;
  top: 17%;
  right: 0;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-sixteen {
  position: absolute;
  top: 12%;
  left: 0;
  z-index: -1;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-seventeen
  a {
  position: absolute;
  top: 65%;
  left: 20%;
  padding: 25px 30px;
  background: #00e3ff;
  color: #ffffff;
  box-shadow: 0px 19.9607px 87.3282px rgba(32, 36, 138, 0.06);
  border-radius: 10px;
  font-size: 20px;
  font-weight: 700;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-eighteen
  a {
  position: absolute;
  top: 45%;
  left: 23%;
  padding: 20px;
  background: rgba(255, 255, 255, 0.4);
  color: #ffffff;
  backdrop-filter: blur(8px);
  border-radius: 10px;
  font-size: 20px;
  font-weight: 700;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-ninteen
  a {
  position: absolute;
  top: 30%;
  right: 24%;
  padding: 20px;
  background: rgba(255, 255, 255, 0.4);
  color: #ffffff;
  backdrop-filter: blur(8px);
  border-radius: 10px;
  font-size: 20px;
  font-weight: 700;
  z-index: -1;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bg-twenty {
  position: absolute;
  top: 56%;
  left: 17%;
  z-index: -1;
}
.main-wrapper.home-twelve.home-thirteen
  .banner-section-thirteen
  .banner-section-thirteen-bg
  .banner-section-thirteen-bgs {
  position: absolute;
  top: 56%;
  right: 17%;
}
.main-wrapper.home-twelve.home-thirteen .services-section-thirteen {
  padding: 80px 0 56px 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .services-section-thirteen {
    margin: 0;
    padding: 50px 0 26px 0;
  }
}
.main-wrapper.home-twelve.home-thirteen .services-section-thirteen .service-thirteen-main {
  border-radius: 20px;
  margin: 0 0 24px 0;
  padding: 8px;
  transition: 0.5s;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve.home-thirteen .services-section-thirteen .service-thirteen-main {
    text-align: center;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .services-section-thirteen
  .service-thirteen-main
  .service-thirteen-all {
  padding: 20px;
  border-radius: 20px;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .services-section-thirteen
    .service-thirteen-main
    .service-thirteen-all {
    display: block;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .services-section-thirteen
  .service-thirteen-main
  .service-thirteen-all
  .service-img-thirteen {
  margin-right: 15px;
  position: relative;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .services-section-thirteen
    .service-thirteen-main
    .service-thirteen-all
    .service-img-thirteen {
    margin: 0 0 10px 0;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .services-section-thirteen
  .service-thirteen-main
  .service-thirteen-all
  .service-img-thirteen
  img {
  max-width: 120px;
  height: 120px;
  border-radius: 100%;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .services-section-thirteen
    .service-thirteen-main
    .service-thirteen-all
    .service-img-thirteen
    img {
    width: 120px;
  }
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .services-section-thirteen
    .service-thirteen-main
    .service-thirteen-all
    .service-img-thirteen
    img {
    width: 120px;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .services-section-thirteen
  .service-thirteen-main
  .service-thirteen-all
  .service-img-thirteen
  .service-inner-img-third {
  position: absolute;
  top: 0;
  right: 0;
}
.main-wrapper.home-twelve.home-thirteen
  .services-section-thirteen
  .service-thirteen-main
  .service-thirteen-all
  .service-inner-contents
  h5 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #1f2937;
  text-transform: capitalize;
}
.main-wrapper.home-twelve.home-thirteen
  .services-section-thirteen
  .service-thirteen-main
  .service-thirteen-all
  .service-inner-contents
  p {
  margin-bottom: 0;
  font-size: 14px;
  color: #6b7280;
}
.main-wrapper.home-twelve.home-thirteen .services-section-thirteen .service-thirteen-main:hover {
  background: #ffffff;
  box-shadow: 0px 11px 21px 10px rgba(14, 130, 253, 0.08);
  transition: 0.5s;
  transform: translateY(-10px);
}
.main-wrapper.home-twelve.home-thirteen
  .services-section-thirteen
  .service-thirteen-main:hover
  .service-thirteen-all {
  background: #ffffff;
  border: 1px dashed #0e82fd;
}
.main-wrapper.home-twelve.home-thirteen .our-doctor-thirteen {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  background-repeat: no-repeat;
  background-position: top center;
  position: relative;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .our-doctor-thirteen {
    background-color: #f8fbff;
    background-image: none;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-thirteen-img
  img {
  height: 438px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .our-doctor-thirteen
    .our-doctor-thirteen-all
    .our-doctor-thirteen-img
    img {
    width: 100%;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content {
  background: #ffffff;
  box-shadow: 0px 19.9607px 87.3282px rgba(32, 36, 138, 0.06);
  border-radius: 10px;
  padding: 20px;
  position: relative;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  a {
  display: inline-block;
  color: #1f2937;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  a:hover {
  color: #0e82fd;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  .our-doctor-content-inner {
  margin-bottom: 20px;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  .our-doctor-content-inner
  span {
  padding: 5px 10px;
  background: rgba(14, 130, 253, 0.1);
  border-radius: 5px;
  font-weight: 600;
  color: #0e82fd;
  font-size: 14px;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  .our-doctor-content-inner
  .reviews-ratings
  p {
  color: #d1d5db;
  font-size: 12px;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  .our-doctor-content-inner
  .reviews-ratings
  p
  span {
  background: none;
  color: #6b7280;
  font-size: 16px;
  font-weight: 400;
  margin: 0 4px 0 0;
  padding: 0;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  .our-doctor-content-inner
  .reviews-ratings
  p
  span
  i {
  color: #fbbf24;
  background: transparent;
  width: auto;
  height: auto;
  border-radius: 0;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  h6 {
  color: #6b7280;
  font-weight: 600;
  margin-bottom: 10px;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  p {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  p
  i {
  width: 24px;
  height: 24px;
  background: rgba(154, 154, 154, 0.1);
  border-radius: 5px;
  margin-right: 5px;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-all
  .our-doctor-content
  .our-doctor-thirteen-imgone {
  position: absolute;
  right: 0;
  bottom: 0;
}
.main-wrapper.home-twelve.home-thirteen .our-doctor-thirteen .our-doctor-thirteen-one img {
  position: absolute;
  z-index: 0;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-one
  img:nth-child(1) {
  left: 3%;
  top: 45%;
  animation: spin 2000ms linear infinite;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-one
  img:nth-child(2) {
  right: 7%;
  bottom: 40%;
  animation: spin 2000ms linear infinite;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-one
  img:nth-child(3) {
  right: 4%;
  top: 20%;
  animation: spin 2000ms linear infinite;
}
.main-wrapper.home-twelve.home-thirteen
  .our-doctor-thirteen
  .our-doctor-thirteen-one
  img:nth-child(4) {
  left: 5%;
  bottom: 30%;
  animation: spin 2000ms linear infinite;
}
.main-wrapper.home-twelve.home-thirteen .choose-us-section-thirteen {
  background: #f8fbff;
}
.main-wrapper.home-twelve.home-thirteen
  .choose-us-section-thirteen
  .choose-us-inner-all
  .choose-us-thirteen-img {
  text-align: center;
  position: relative;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .choose-us-section-thirteen
    .choose-us-inner-all
    .choose-us-thirteen-img {
    display: none;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .choose-us-section-thirteen
  .choose-us-inner-all
  .choose-us-thirteen-img
  img {
  border-radius: 20px;
}
.main-wrapper.home-twelve.home-thirteen
  .choose-us-section-thirteen
  .choose-us-inner-all
  .choose-us-thirteen-img
  .choose-us-thirteen-imgone
  img {
  position: absolute;
  z-index: 0;
}
.main-wrapper.home-twelve.home-thirteen
  .choose-us-section-thirteen
  .choose-us-inner-all
  .choose-us-thirteen-img
  .choose-us-thirteen-imgone
  img:nth-child(1) {
  right: 4%;
  bottom: 0%;
}
.main-wrapper.home-twelve.home-thirteen
  .choose-us-section-thirteen
  .choose-us-inner-all
  .choose-us-thirteen-img
  .choose-us-thirteen-imgone
  img:nth-child(2) {
  left: -5%;
  top: 7%;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .choose-us-section-thirteen
    .choose-us-inner-all
    .choose-us-thirteen-img
    .choose-us-thirteen-imgone
    img:nth-child(2) {
    left: -20%;
  }
}
.main-wrapper.home-twelve.home-thirteen .choose-us-section-thirteen ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.main-wrapper.home-twelve.home-thirteen .choose-us-section-thirteen ul li {
  margin-bottom: 20px;
  transition: 0.5s;
  padding: 15px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .choose-us-section-thirteen ul li {
    padding: 20px;
    margin-bottom: 20px;
  }
}
.main-wrapper.home-twelve.home-thirteen .choose-us-section-thirteen ul li:last-child {
  margin-bottom: 0;
}
.main-wrapper.home-twelve.home-thirteen
  .choose-us-section-thirteen
  ul
  li
  .choose-us-content-thirteen {
  display: flex;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .choose-us-section-thirteen
    ul
    li
    .choose-us-content-thirteen {
    display: block;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .choose-us-section-thirteen
  ul
  li
  .choose-us-content-thirteen
  .chooseus-contents {
  min-width: 50px;
  height: 50px;
  background: rgba(160, 240, 253, 0.2);
  border-radius: 10.8333px;
  font-size: 24px;
  color: #0e82fd;
  margin-right: 16px;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .choose-us-section-thirteen
    ul
    li
    .choose-us-content-thirteen
    .chooseus-contents {
    margin-bottom: 10px;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .choose-us-section-thirteen
  ul
  li
  .choose-us-content-thirteen
  .chooseus-content-ryt
  h5 {
  font-size: 20px;
  color: #1f2937;
  font-weight: 600;
  text-transform: capitalize;
  margin-bottom: 16px;
}
.main-wrapper.home-twelve.home-thirteen
  .choose-us-section-thirteen
  ul
  li
  .choose-us-content-thirteen
  .chooseus-content-ryt
  p {
  font-weight: 400;
  letter-spacing: 0.2px;
  text-transform: capitalize;
  margin-bottom: 0;
}
.main-wrapper.home-twelve.home-thirteen .choose-us-section-thirteen ul li:hover {
  transition: 0.5s;
  transform: translateY(-10px);
  box-shadow: 0px 11px 21px 10px rgba(14, 130, 253, 0.08);
}
.main-wrapper.home-twelve.home-thirteen .client-us-section-thirteen {
  position: relative;
}
.main-wrapper.home-twelve.home-thirteen .client-us-section-thirteen .client-says-all {
  display: flex;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-twelve.home-thirteen .client-us-section-thirteen .client-says-all {
    display: block;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .client-us-section-thirteen
  .client-says-all
  .clients-says-content {
  width: 50%;
  padding: 70px 50px 50px 50px;
  background: #0e82fd;
  border-radius: 35px 0px 0px 35px;
  position: relative;
  z-index: -1;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .client-us-section-thirteen
    .client-says-all
    .clients-says-content {
    width: 100%;
    border-radius: 0;
    padding: 50px 50px 50px 50px;
  }
}
@media (max-width: 767.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .client-us-section-thirteen
    .client-says-all
    .clients-says-content {
    padding: 25px;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .client-us-section-thirteen
  .client-says-all
  .clients-says-content
  p {
  color: #ffffff;
  font-size: 20px;
  line-height: 33px;
  letter-spacing: 0.2px;
  text-transform: capitalize;
  font-weight: 500;
  margin-bottom: 24px;
}
@media (max-width: 1399.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .client-us-section-thirteen
    .client-says-all
    .clients-says-content
    p {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 13px;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .client-us-section-thirteen
  .client-says-all
  .clients-says-content
  h4 {
  letter-spacing: 0.2px;
  text-transform: capitalize;
  color: #c4f7ff;
  font-size: 20px;
  font-weight: 600;
}
.main-wrapper.home-twelve.home-thirteen
  .client-us-section-thirteen
  .client-says-all
  .clients-says-content
  .location-thirteen {
  color: #f0f0f0;
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
  margin-bottom: 0;
}
.main-wrapper.home-twelve.home-thirteen
  .client-us-section-thirteen
  .client-says-all
  .clients-says-content
  .client-says-imagesone
  img {
  position: absolute;
  z-index: -1;
}
.main-wrapper.home-twelve.home-thirteen
  .client-us-section-thirteen
  .client-says-all
  .clients-says-content
  .client-says-imagesone
  img:nth-child(1) {
  right: -3%;
  bottom: -12%;
  width: auto;
}
.main-wrapper.home-twelve.home-thirteen
  .client-us-section-thirteen
  .client-says-all
  .clients-says-content
  .client-says-imagesone
  img:nth-child(2) {
  left: 0%;
  top: 0%;
  width: auto;
}
.main-wrapper.home-twelve.home-thirteen
  .client-us-section-thirteen
  .client-says-all
  .client-says-images {
  width: 50%;
}
.main-wrapper.home-twelve.home-thirteen
  .client-us-section-thirteen
  .client-says-all
  .client-says-images
  img {
  width: auto;
  border-radius: 0 35px 35px 0;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .client-us-section-thirteen
    .client-says-all
    .client-says-images {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .client-us-section-thirteen
    .client-us-section-thirteenone {
    display: none;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .client-us-section-thirteen
  .client-us-section-thirteenone
  img {
  position: absolute;
  z-index: 0;
}
.main-wrapper.home-twelve.home-thirteen
  .client-us-section-thirteen
  .client-us-section-thirteenone
  img:nth-child(1) {
  left: 0%;
  top: 15%;
  width: auto;
}
.main-wrapper.home-twelve.home-thirteen
  .client-us-section-thirteen
  .client-us-section-thirteenone
  img:nth-child(2) {
  right: -6%;
  top: 22%;
  width: auto;
}
.main-wrapper.home-twelve.home-thirteen .latest-articles-thirteen {
  padding: 80px 0 56px 0;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .latest-articles-thirteen {
    margin: 0;
    padding: 50px 0 26px 0;
  }
}
.main-wrapper.home-twelve.home-thirteen .latest-articles-thirteen .articles-thirteen {
  margin-bottom: 24px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .latest-articles-thirteen .articles-thirteen {
    text-align: center;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .latest-articles-thirteen
  .articles-thirteen
  .articles-thirteen-img {
  margin-bottom: 24px;
  overflow: hidden;
  border-radius: 20px;
}
.main-wrapper.home-twelve.home-thirteen
  .latest-articles-thirteen
  .articles-thirteen
  .articles-thirteen-img
  img {
  border-radius: 20px;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
}
.main-wrapper.home-twelve.home-thirteen
  .latest-articles-thirteen
  .articles-thirteen
  .articles-thirteen-img:hover
  img {
  border-radius: 20px;
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}
.main-wrapper.home-twelve.home-thirteen
  .latest-articles-thirteen
  .articles-thirteen
  .articles-thirteen-content
  h6 {
  padding: 2px 8px;
  border-radius: 20px;
  background: #eef6ff;
  color: #0e82fd;
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  margin-bottom: 10px;
  display: inline-block;
}
.main-wrapper.home-twelve.home-thirteen
  .latest-articles-thirteen
  .articles-thirteen
  .articles-thirteen-content
  a {
  font-size: 20px;
  font-weight: 500;
  text-transform: capitalize;
  color: #1f2937;
  margin-bottom: 10px;
  display: block;
}
.main-wrapper.home-twelve.home-thirteen
  .latest-articles-thirteen
  .articles-thirteen
  .articles-thirteen-content
  a:hover {
  color: #0e82fd;
}
.main-wrapper.home-twelve.home-thirteen
  .latest-articles-thirteen
  .articles-thirteen
  .articles-thirteen-content
  p {
  color: #6b7280;
  font-weight: 400;
  margin-bottom: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  width: 100%;
  overflow: hidden;
}
.main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  background-repeat: no-repeat;
  background-position: top center;
  position: relative;
  z-index: 1;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen {
    background-image: none;
    background-color: #f8fbff;
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-all-img {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-main-content {
    text-align: center;
  }
}
.main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-main-content h2 {
  color: #1f2937;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 20px;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-main-content h2 {
    font-size: 34px;
  }
}
.main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-main-content p {
  font-weight: 400;
  color: #6b7280;
  margin-bottom: 40px;
}
.main-wrapper.home-twelve.home-thirteen
  .feedback-section-thirteen
  .feedback-main-content
  .feedback-inner-img {
  display: flex;
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .feedback-section-thirteen
    .feedback-main-content
    .feedback-inner-img {
    justify-content: center;
  }
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .feedback-section-thirteen
    .feedback-main-content
    .feedback-inner-img {
    display: block;
  }
}
.main-wrapper.home-twelve.home-thirteen
  .feedback-section-thirteen
  .feedback-main-content
  .feedback-inner-img
  .feedback-inner-imgone {
  margin-right: 26px;
}
@media (max-width: 575.98px) {
  .main-wrapper.home-twelve.home-thirteen
    .feedback-section-thirteen
    .feedback-main-content
    .feedback-inner-img
    .feedback-inner-imgone {
    margin: 0 0 10px 0;
  }
}
@media (max-width: 991.98px) {
  .main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-bg-icons {
    display: none;
  }
}
.main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-bg-icons img {
  position: absolute;
  z-index: 0;
}
.main-wrapper.home-twelve.home-thirteen
  .feedback-section-thirteen
  .feedback-bg-icons
  img:nth-child(1) {
  right: 6%;
  top: 40%;
  width: auto;
  animation: spin 3000ms linear infinite;
}
.main-wrapper.home-twelve.home-thirteen
  .feedback-section-thirteen
  .feedback-bg-icons
  img:nth-child(2) {
  right: 11%;
  top: 55%;
  width: auto;
  animation: spin 3000ms linear infinite;
}
.main-wrapper.home-twelve.home-thirteen
  .feedback-section-thirteen
  .feedback-bg-icons
  img:nth-child(3) {
  right: 8%;
  bottom: 10%;
  width: auto;
  animation: spin 3000ms linear infinite;
}
.main-wrapper.home-twelve.home-thirteen
  .feedback-section-thirteen
  .feedback-bg-icons
  img:nth-child(4) {
  left: 15%;
  bottom: 10%;
  width: auto;
  animation: spin 3000ms linear infinite;
}
.main-wrapper.home-twelve.home-thirteen
  .feedback-section-thirteen
  .feedback-bg-icons
  img:nth-child(5) {
  left: 6%;
  top: 25%;
  width: auto;
  animation: spin 3000ms linear infinite;
}

.section-header-thirteen {
  margin-bottom: 50px;
}
@media (max-width: 991.98px) {
  .section-header-thirteen {
    margin-bottom: 40px;
  }
}
.section-header-thirteen .section-inner-thirteen {
  margin-right: 15px;
}
.section-header-thirteen h2 {
  font-size: 40px;
  color: #1f2937;
  font-weight: 700;
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .section-header-thirteen h2 {
    font-size: 34px;
  }
}
@media (max-width: 767.98px) {
  .section-header-thirteen h2 {
    font-size: 28px;
  }
}

.our-slider-thirteen .owl-dots,
.client-says-thirteen .owl-dots {
  text-align: center;
  margin-top: 50px;
}
@media (max-width: 991.98px) {
  .our-slider-thirteen .owl-dots,
  .client-says-thirteen .owl-dots {
    margin-top: 30px;
  }
}
.our-slider-thirteen .owl-dots .owl-dot,
.client-says-thirteen .owl-dots .owl-dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #f3f3f3;
  margin-right: 15px;
}
@media (max-width: 991.98px) {
  .our-slider-thirteen .owl-dots .owl-dot,
  .client-says-thirteen .owl-dots .owl-dot {
    width: 10px;
    height: 10px;
  }
}
.our-slider-thirteen .owl-dots .owl-dot.active,
.client-says-thirteen .owl-dots .owl-dot.active {
  width: 45px;
  background: #0e82fd;
  border-radius: 20px;
}

@keyframes pulse {
  from {
    transform: scale(0.8);
  }
  to {
    transform: scale(1.2);
  }
}
@keyframes elastic-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(720deg);
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.owl-theme .owl-dots .owl-dot span {
  display: none !important;
}

.main-wrapper.home-fourteen {
  font-size: 16px;
  font-family: "Inter", sans-serif;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-fourteen {
    font-size: 15px;
  }
}

.banner-section-fourteen {
  position: relative;
  padding: 100px 0 0 0;
  background: #0e82fd;
  z-index: 1;
}
@media (max-width: 1199.98px) {
  .banner-section-fourteen {
    padding: 100px 0 30px 0;
  }
}
@media (max-width: 991.98px) {
  .banner-section-fourteen {
    padding: 100px 0 50px 0;
  }
}
.banner-section-fourteen .banner-content-fourteen {
  margin: 116px 0 0 0;
  padding: 0 0 40px 0;
}
@media (max-width: 1399.98px) {
  .banner-section-fourteen .banner-content-fourteen {
    margin: 50px 0 0 0;
    padding: 0 0 40px 0;
  }
}
@media (max-width: 1199.98px) {
  .banner-section-fourteen .banner-content-fourteen {
    margin: 10px 0 0 0;
    padding: 0 0 40px 0;
  }
}
.banner-section-fourteen .banner-content-fourteen h1 {
  color: #ffffff;
  letter-spacing: 0.005rem;
  font-weight: 700;
  width: 586px;
  margin: 0 0 40px 0;
}
@media (max-width: 1199.98px) {
  .banner-section-fourteen .banner-content-fourteen h1 {
    width: auto;
  }
}
.banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen {
  display: flex;
  justify-content: start;
}
@media (max-width: 991.98px) {
  .banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen {
    justify-content: center;
  }
}
@media (max-width: 479.98px) {
  .banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen {
    flex-direction: column;
  }
}
.banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primary {
  background: #ffffff;
  color: #0e82fd;
  padding: 15px 20px;
}
@media (max-width: 991.98px) {
  .banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primary {
    padding: 15px 15px;
  }
}
@media (max-width: 479.98px) {
  .banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primary {
    width: 100%;
    margin: 0 0 10px 0;
    padding: 15px 15px;
  }
}
.banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primary:hover {
  background: transparent;
  box-shadow: none;
  color: #ffffff;
  border: 1px solid #ffffff;
}
.banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primarytwo {
  background: transparent;
  box-shadow: none;
  color: #ffffff;
  border: 1px solid #ffffff;
  padding: 15px 20px;
}
@media (max-width: 991.98px) {
  .banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primarytwo {
    padding: 15px 15px;
  }
}
.banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primarytwo:hover {
  background: #ffffff;
  color: #0e82fd;
}
.banner-section-fourteen .search-box-fourteen {
  background: #ffffff;
  box-shadow: -8px 6px 100px rgba(36, 58, 101, 0.1);
  border-radius: 20px;
  padding: 30px 41px 20px 41px;
  gap: 10px;
}
.banner-section-fourteen .search-box-fourteen .form-block {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  align-items: center;
}
@media (max-width: 768px) {
  .banner-section-fourteen .search-box-fourteen .form-block {
    flex-direction: column;
  }
}
.banner-section-fourteen .search-box-fourteen .form-block .search-input {
  margin: 0 15px 0 0;
}
@media (max-width: 768px) {
  .banner-section-fourteen .search-box-fourteen .form-block .search-input {
    width: 100%;
  }
}
.banner-section-fourteen .search-box-fourteen .form-block .search-input input {
  min-height: 40px;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}
.banner-section-fourteen .search-box-fourteen .form-block .search-input input::placeholder {
  color: #1f2937;
  font-weight: 600;
}
.banner-section-fourteen .search-box-fourteen .form-block .search-input .form-group {
  margin-bottom: 0;
}
.banner-section-fourteen .search-box-fourteen .form-block .search-input label {
  color: #6b7280;
}
.banner-section-fourteen .search-box-fourteen .search-btn {
  width: auto;
  margin: -8px 0 0 0;
}
@media (max-width: 768px) {
  .banner-section-fourteen .search-box-fourteen .search-btn {
    width: 100%;
    margin: 0 0 0 0;
  }
}
.banner-section-fourteen .search-box-fourteen .search-btn .btn-primary {
  background: #0e82fd;
  border: 1px solid #0e82fd;
  -webkit-transition: 0.5s;
  -ms-transition: 0.5s;
  transition: 0.5s;
  padding: 14px 16px;
  font-weight: 600;
}
@media (max-width: 768px) {
  .banner-section-fourteen .search-box-fourteen .search-btn .btn-primary {
    width: 100%;
  }
}
.banner-section-fourteen .search-box-fourteen .search-btn .btn-primary:hover {
  background: #1c5b91;
  box-shadow: inset 0 0 0 50px #1c5b91;
  -webkit-transition: 0.5s;
  -ms-transition: 0.5s;
  transition: 0.5s;
  border: 1px solid #1c5b91;
}
.banner-section-fourteen .banner-img-fourteen .banner-imgfourteen {
  left: 30px;
}
@media (max-width: 1199.98px) {
  .banner-section-fourteen .banner-img-fourteen .banner-imgfourteen {
    top: 50px;
  }
}
.banner-section-fourteen .banner-img-fourteen .banner-imgfourteen3 {
  top: 380px;
}
@media (max-width: 1199.98px) {
  .banner-section-fourteen .banner-img-fourteen .banner-imgfourteen3 {
    top: 250px;
  }
}
@media (max-width: 1199.98px) {
  .banner-section-fourteen .banner-img-fourteen .banner-img2 {
    top: 100px;
  }
}
.banner-section-fourteen .banner-img-fourteen .banner-imgfourteen4 {
  position: absolute;
  right: -120px;
  bottom: 100px;
  animation: spin 3000ms linear infinite;
}
@media (max-width: 1199.98px) {
  .banner-section-fourteen .banner-img-fourteen .banner-imgfourteen4 {
    top: 250px;
  }
}
.banner-section-fourteen .banner-imgfourteen5 {
  position: absolute;
  top: 250px;
  left: 86px;
  animation: spin 3000ms linear infinite;
}
.banner-section-fourteen .banner-imgfourteen6 {
  position: absolute;
  bottom: 50px;
  left: 65px;
  animation: spin 3000ms linear infinite;
  z-index: -1;
}

.services-section-fourteen {
  padding: 80px 0;
  background: #f8fafc;
}
@media (max-width: 1199.98px) {
  .services-section-fourteen {
    padding: 50px 0;
  }
}
.services-section-fourteen .service-inner-fourt-all {
  border-radius: 20px;
  margin: 0 0 24px 0;
}
.services-section-fourteen .service-inner-fourt-all .service-inner-fourt-main {
  padding: 20px;
  border-radius: 20px;
}
.services-section-fourteen
  .service-inner-fourt-all
  .service-inner-fourt-main
  .service-inner-right-fourt
  .service-inner-right-img {
  position: relative;
  margin: 0 0 13px 0;
  overflow: hidden;
  border-radius: 20px;
}
.services-section-fourteen
  .service-inner-fourt-all
  .service-inner-fourt-main
  .service-inner-right-fourt
  .service-inner-right-img
  img {
  position: relative;
  border-radius: 20px;
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  width: 100%;
}
.services-section-fourteen
  .service-inner-fourt-all
  .service-inner-fourt-main
  .service-inner-right-fourt
  .service-inner-right-img:hover
  img {
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}
.services-section-fourteen
  .service-inner-fourt-all
  .service-inner-fourt-main
  .service-inner-right-fourt
  .service-inner-right-img:hover::before {
  -webkit-animation: circle 1s;
  animation: circle 1s;
}
.services-section-fourteen
  .service-inner-fourt-all
  .service-inner-fourt-main
  .service-inner-right-fourt
  .service-inner-right-img::before {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  display: block;
  content: "";
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  opacity: 0;
}
.services-section-fourteen
  .service-inner-fourt-all
  .service-inner-fourt-main
  .service-inner-right-fourt
  .service-inner-right-fourt-care {
  color: #1f2937;
  font-size: 22px;
  font-weight: 600;
  margin: 0 0 13px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
@media (max-width: 1199.98px) {
  .services-section-fourteen
    .service-inner-fourt-all
    .service-inner-fourt-main
    .service-inner-right-fourt
    .service-inner-right-fourt-care {
    font-size: 18px;
  }
}
.services-section-fourteen
  .service-inner-fourt-all
  .service-inner-fourt-main
  .service-inner-right-fourt
  .service-inner-right-fourt-care:hover {
  color: #1c5b91;
}
.services-section-fourteen
  .service-inner-fourt-all
  .service-inner-fourt-main
  .service-inner-right-fourt
  p {
  color: #6b7280;
  font-size: 14px;
  margin: 0 0 10px 0;
}
.services-section-fourteen
  .service-inner-fourt-all
  .service-inner-fourt-main
  .service-inner-right-fourt
  .service-inner-right-fourt-caretwo {
  color: #0e82fd;
  font-size: 18px;
  font-weight: 600;
}
@media (max-width: 1199.98px) {
  .services-section-fourteen
    .service-inner-fourt-all
    .service-inner-fourt-main
    .service-inner-right-fourt
    .service-inner-right-fourt-caretwo {
    font-size: 16px;
  }
}
.services-section-fourteen
  .service-inner-fourt-all
  .service-inner-fourt-main
  .service-inner-right-fourt
  .service-inner-right-fourt-caretwo
  i {
  font-weight: 600;
}
.services-section-fourteen
  .service-inner-fourt-all
  .service-inner-fourt-main
  .service-inner-right-fourt
  .service-inner-right-fourt-caretwo:hover {
  color: #1c5b91;
}
.services-section-fourteen .service-inner-img-fourt-all {
  position: relative;
}
@media (max-width: 991.98px) {
  .services-section-fourteen .service-inner-img-fourt-all .service-inner-img-fourt {
    display: none;
  }
}
.services-section-fourteen .service-inner-img-fourt-all .service-inner-img-fourtone {
  position: absolute;
  top: 0;
  right: 65px;
  animation: spin 3000ms linear infinite;
}
.services-section-fourteen .service-inner-img-fourt-all .service-inner-img-fourttwo {
  position: absolute;
  bottom: 0;
  animation: spin 3000ms linear infinite;
}
.services-section-fourteen .service-inner-img-fourt-all .service-inner-img-fourtthree {
  position: absolute;
  top: 0;
  left: 30px;
  animation: spin 3000ms linear infinite;
}
.services-section-fourteen .btn-sec-fourteen {
  text-align: end;
}
@media (max-width: 991.98px) {
  .services-section-fourteen .btn-sec-fourteen {
    text-align: center;
  }
}
.services-section-fourteen .btn-sec-fourteen a {
  padding: 15px 20px;
  font-size: 15px;
  color: #ffffff;
  background: #0e82fd;
  transition:
    color 0.3s ease-in-out,
    box-shadow 0.3s ease-in-out;
  box-shadow: inset 0 0 0 0 #0e82fd;
  border: 1px solid #0e82fd;
  font-weight: 600;
}
@media (max-width: 991.98px) {
  .services-section-fourteen .btn-sec-fourteen a {
    padding: 12px 13px;
  }
}
.services-section-fourteen .btn-sec-fourteen a:hover {
  box-shadow: inset 165px 0 0 0 #1c5b91;
  border-color: #1c5b91;
}

.team-section-fourteen {
  position: relative;
  padding: 80px 0 56px 0;
}
@media (max-width: 1199.98px) {
  .team-section-fourteen {
    padding: 50px 0;
  }
}
.team-section-fourteen .articles-grid-fourteen {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 30px;
}
@media (max-width: 1199.98px) {
  .team-section-fourteen .articles-grid-fourteen .articles-info {
    text-align: start;
  }
}
@media (max-width: 991.98px) {
  .team-section-fourteen .articles-grid-fourteen .articles-info {
    display: flex;
    text-align: center;
    flex-direction: column;
  }
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-left
  .articles-img-fourteen {
  width: 206px;
  height: 220px;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-left
  .articles-img-fourteen
  img {
  height: 100%;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  a {
  font-size: 20px;
  font-weight: 600;
  display: block;
  margin-bottom: 10px;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  a:hover {
  color: #1c5b91;
}
@media (max-width: 1199.98px) {
  .team-section-fourteen
    .articles-grid-fourteen
    .articles-info
    .articles-right
    .articles-content-fourteen
    .articles-list {
    justify-content: start;
    -webkit-justify-content: start;
  }
}
@media (max-width: 991.98px) {
  .team-section-fourteen
    .articles-grid-fourteen
    .articles-info
    .articles-right
    .articles-content-fourteen
    .articles-list {
    justify-content: center;
    -webkit-justify-content: center;
  }
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  .articles-list
  .Qualified-doctors-fourteen {
  background: #dbeffe;
  color: #0e82fd;
  padding: 10px 15px;
  border-radius: 8px;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  .articles-list
  .Qualified-doctors-fourteentwo {
  color: #6b7280;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  .articles-list
  .Qualified-doctors-fourteenthree {
  background: #f3f4f6;
  padding: 10px 12px;
  border-radius: 6px;
  color: #1f2937;
  font-weight: 600;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  .articles-list
  .Qualified-doctors-fourteenfour
  a {
  border-radius: 6px;
  background: #0e82fd;
  color: #ffffff;
  transition:
    color 0.3s ease-in-out,
    box-shadow 0.3s ease-in-out;
  box-shadow: inset 0 0 0 0 #0e82fd;
  font-size: 15px;
  font-weight: 600;
  display: block;
  margin-bottom: 0;
  padding: 10px 12px;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  .articles-list
  .Qualified-doctors-fourteenfour
  a:hover {
  box-shadow: inset 120px 0 0 0 #1c5b91;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  .rating-fourteen
  .filled {
  color: #ffc001;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  .rating-fourteen
  i {
  font-size: 18px;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  .rating-fourteen
  .average-rating {
  font-size: 14px;
  color: #d1d5db;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  p {
  color: #6b7280;
  font-weight: 500;
  margin: 0 0 10px 0;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  p
  i {
  color: #6b7280;
  margin: 0 7px 0 0;
}
.team-section-fourteen
  .articles-grid-fourteen
  .articles-info
  .articles-right
  .articles-content-fourteen
  p
  span {
  color: #1f2937;
  font-weight: 500;
}
.team-section-fourteen .banner-imgfourteenseven {
  position: absolute;
  bottom: 50px;
  left: 30px;
  animation: spin 3000ms linear infinite;
}
.team-section-fourteen .banner-imgfourteeneight {
  position: absolute;
  top: 70px;
  right: 50%;
  animation: spin 3000ms linear infinite;
}
@media (max-width: 991.98px) {
  .team-section-fourteen .banner-imgfourteeneight {
    display: none;
  }
}
.team-section-fourteen .banner-imgfourteennine {
  position: absolute;
  right: 50px;
  bottom: 70px;
  animation: spin 3000ms linear infinite;
}

.blog-section-fourteen {
  position: relative;
  padding: 80px 0;
  background: #f2f6f6;
}
@media (max-width: 1199.98px) {
  .blog-section-fourteen {
    padding: 50px 0;
  }
}
.blog-section-fourteen .blog-inner-fourt-all {
  border-radius: 30px;
}
.blog-section-fourteen .blog-inner-fourt-all .blog-inner-fourt-main {
  padding: 20px;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-right-img {
  position: relative;
  margin: 0 0 20px 0;
  overflow: hidden;
  border-radius: 20px;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-right-img
  .blog-inner-right-inner {
  position: relative;
  border-radius: 20px;
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  width: 100%;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-right-img
  .blog-inner-right-inner:hover
  img {
  border-radius: 20px;
  transform: scale(1.15);
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content {
  position: absolute;
  top: 19px;
  left: 19px;
  padding: 5px 10px 5px 5px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50px;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content
  img {
  width: 35px;
  height: 35px;
  border-radius: 50px;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-top-content
  span {
  font-size: 14px;
  color: #1f2937;
  font-weight: 600;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-right-fourt-care {
  display: block;
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 18px 0;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-inner-right-fourt-care:hover {
  color: #1c5b91;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-articles-list {
  margin: 0 0 20px 0;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-articles-list
  li {
  color: #6b7280;
  font-size: 16px;
  margin: 0 20px 0 0;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-articles-list
  li
  i {
  color: #d1d5db;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-articles-list-two {
  margin: 0 0 10px 0;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-articles-list-two
  li {
  background: #dbeffe;
  color: #0e82fd;
  margin: 0 10px 10px 0;
  padding: 10px 15px;
  border-radius: 8px;
}
.blog-section-fourteen
  .blog-inner-fourt-all
  .blog-inner-fourt-main
  .blog-inner-right-fourt
  .blog-articles-list-two
  li:last-child {
  margin: 0 0 10px 0;
}
.blog-section-fourteen .blog-inner-fourt-all .blog-inner-fourt-main .blog-inner-right-fourt p {
  color: #6b7280;
  font-size: 14px;
  margin: 0 0 0 0;
}
.blog-section-fourteen .blog-btn-sec {
  margin: 24px 0 0 0;
}
.blog-section-fourteen .blog-btn-sec .btn-view {
  padding: 15px 20px;
  font-size: 15px;
  color: #ffffff;
  background: #0e82fd;
  transition:
    color 0.3s ease-in-out,
    box-shadow 0.3s ease-in-out;
  box-shadow: inset 0 0 0 0 #0e82fd;
  font-weight: 600;
  border: 1px solid #0e82fd;
}
@media (max-width: 991.98px) {
  .blog-section-fourteen .blog-btn-sec .btn-view {
    padding: 12px 13px;
  }
}
.blog-section-fourteen .blog-btn-sec .btn-view:hover {
  box-shadow: inset 220px 0 0 0 #1c5b91;
  border-color: #1c5b91;
}

.choose-us-fourteen {
  position: relative;
  padding: 80px 0;
}
@media (max-width: 1199.98px) {
  .choose-us-fourteen {
    padding: 50px 0;
  }
}
.choose-us-fourteen .you-get-list ul {
  list-style: none;
  padding: 0;
}
.choose-us-fourteen .you-get-list ul li {
  margin-bottom: 30px;
}
.choose-us-fourteen .you-get-list ul li:last-child {
  margin: 0;
}
.choose-us-fourteen .you-get-list ul li .get-list-content {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  background-repeat: no-repeat;
  background-size: contain;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: start;
  transition: 0.5s;
}
@media (max-width: 1399.98px) {
  .choose-us-fourteen .you-get-list ul li .get-list-content {
    padding: 22px 30px 30px 30px;
  }
}
@media (max-width: 1199.98px) {
  .choose-us-fourteen .you-get-list ul li .get-list-content {
    background: #f2f6f6;
    border-radius: 30px;
  }
}
@media (max-width: 991.98px) {
  .choose-us-fourteen .you-get-list ul li .get-list-content {
    background: #f2f6f6;
    border-radius: 30px;
  }
}
@media (max-width: 575.98px) {
  .choose-us-fourteen .you-get-list ul li .get-list-content {
    flex-direction: column;
  }
}
.choose-us-fourteen .you-get-list ul li .get-list-content.second-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}
@media (max-width: 1199.98px) {
  .choose-us-fourteen .you-get-list ul li .get-list-content.second-bg {
    background: #f2f6f6;
    border-radius: 30px;
  }
}
@media (max-width: 991.98px) {
  .choose-us-fourteen .you-get-list ul li .get-list-content.second-bg {
    background: #f2f6f6;
    border-radius: 30px;
  }
}
.choose-us-fourteen .you-get-list ul li .get-list-content:hover .get-icon {
  background: #0e82fd;
  transition: 0.5s;
}
.choose-us-fourteen .you-get-list ul li .get-list-content:hover .get-icon img {
  filter: invert(0) brightness(100);
  transition: 0.5s;
}
.choose-us-fourteen .you-get-list ul li .get-list-content .get-icon {
  margin: 0 20px 0 0;
  padding: 25px;
  background: #ffffff;
  border-radius: 20px;
  transition: 0.5s;
}
@media (max-width: 575.98px) {
  .choose-us-fourteen .you-get-list ul li .get-list-content .get-icon {
    margin: 0 0 20px 0;
    padding: 25px;
  }
}
@media (max-width: 575.98px) {
  .choose-us-fourteen .you-get-list ul li .get-list-content .get-icon-right {
    text-align: center;
  }
}
.choose-us-fourteen .you-get-list ul li .get-list-content .get-icon-right h3 {
  font-weight: 600;
  margin: 0 0 5px 0;
}
.choose-us-fourteen .you-get-list ul li .get-list-content .get-icon-right p {
  color: #6b7280;
  font-size: 14px;
  margin: 0;
  max-width: 412px;
}
.choose-us-fourteen .choose-us-right-main {
  position: relative;
}
@media (max-width: 991.98px) {
  .choose-us-fourteen .choose-us-right-main {
    display: none;
  }
}
.choose-us-fourteen .choose-us-right-main .banner-imgfourteenten {
  position: absolute;
  top: 150px;
  right: 180px;
  animation: spin 3000ms linear infinite;
}
@media (max-width: 1199.98px) {
  .choose-us-fourteen .choose-us-right-main .banner-imgfourteenten {
    right: 120px;
  }
}

.clients-section-fourteen {
  position: relative;
  padding: 80px 0 150px 0;
  background: #f2f6f6;
}
@media (max-width: 1199.98px) {
  .clients-section-fourteen {
    padding: 80px 0 100px 0;
  }
}
@media (max-width: 1199.98px) {
  .clients-section-fourteen {
    padding: 50px 0;
  }
}
.clients-section-fourteen .client-inner-main {
  -webkit-animation: mover 2s infinite alternate;
  animation: mover 2s infinite alternate;
}
@media (max-width: 991.98px) {
  .clients-section-fourteen .client-inner-main {
    display: none;
  }
}
.clients-section-fourteen .feedback-slider-fourteen .owl-nav {
  text-align: end;
  margin-top: 40px;
}
@media (max-width: 991.98px) {
  .clients-section-fourteen .feedback-slider-fourteen .owl-nav {
    text-align: center;
    margin-top: 10px;
  }
}
.clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-prev {
  background: #e2e8f0;
  border-radius: 8px;
  width: 50px;
  height: 50px;
  color: #94a3b8;
  text-shadow: none;
  font-size: 24px;
  border: none;
}
@media (max-width: 991.98px) {
  .clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-prev {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
}
.clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-prev:hover {
  background: #bfe0fe;
  color: #1d7ed8;
}
.clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-next {
  background: #e2e8f0;
  border-radius: 8px;
  width: 50px;
  height: 50px;
  color: #94a3b8;
  text-shadow: none;
  font-size: 24px;
  border: none;
}
@media (max-width: 991.98px) {
  .clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-next {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
}
.clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-next:hover {
  background: #bfe0fe;
  color: #1d7ed8;
}
.clients-section-fourteen .feedback-card {
  border-radius: 30px;
  margin: 60px 0 0 0;
}
.clients-section-fourteen .feedback-card .feedback-card-body {
  padding: 30px;
}
.clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .feedback-inner-img {
  display: flex;
  align-items: end;
  justify-content: space-between;
  margin: -85px 0 10px 0;
}
.clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .feedback-inner-img
  h6 {
  color: #1f2937;
  font-size: 16px;
}
.clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .feedback-inner-img
  img {
  width: 100px;
  height: 100px;
  border-radius: 20px;
}
.clients-section-fourteen .feedback-card .feedback-card-body .feedback-inner-main .rating-fourteen {
  margin: 0 0 15px 0;
}
.clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .rating-fourteen
  .filled {
  color: #ffc001;
}
.clients-section-fourteen
  .feedback-card
  .feedback-card-body
  .feedback-inner-main
  .rating-fourteen
  i {
  font-size: 18px;
}
.clients-section-fourteen .feedback-card .feedback-card-body .feedback-inner-main p {
  color: #6b7280;
  font-size: 16px;
  margin: 0 0 20px 0;
}
.clients-section-fourteen .feedback-card .feedback-card-body .feedback-inner-main h4 {
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 10px 0;
}
@media (max-width: 991.98px) {
  .clients-section-fourteen .feedback-card .feedback-card-body .feedback-inner-main h4 {
    font-size: 18px;
  }
}
.clients-section-fourteen .feedback-card .feedback-card-body .feedback-inner-main h6 {
  color: #94a3b8;
  font-size: 16px;
  margin: 0;
}

.contact-section-fourteen {
  background: #f2f6f6;
  margin: 0 0 -200px 0;
}
.contact-section-fourteen .contact-schedule-main {
  background: #0e82fd;
  border-radius: 30px;
  position: relative;
  box-shadow: 0px 30px 60px rgba(49, 46, 129, 0.2);
}
.contact-section-fourteen .contact-schedule-main .scheduling-left-main {
  padding: 95px 80px 95px 110px;
}
@media (max-width: 1399.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-left-main {
    padding: 75px 80px 75px 90px;
  }
}
@media (max-width: 1199.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-left-main {
    padding: 25px 40px 25px 50px;
  }
}
@media (max-width: 991.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-left-main {
    padding: 30px 10px 30px 10px;
    text-align: center;
  }
}
.contact-section-fourteen .contact-schedule-main .scheduling-left-main h2 {
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 10px 0;
}
@media (max-width: 991.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-left-main h2 {
    font-size: 36px;
  }
}
@media (max-width: 767.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-left-main h2 {
    font-size: 28px;
  }
}
.contact-section-fourteen .contact-schedule-main .scheduling-left-main p {
  font-size: 24px;
  color: #ffffff;
  margin: 0 0 55px 0;
}
@media (max-width: 991.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-left-main p {
    font-size: 20px;
    margin: 0 0 30px 0;
  }
}
.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul {
  margin: 0;
  padding: 0;
}
@media (max-width: 991.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-left-main ul {
    justify-content: center;
  }
}
@media (max-width: 575.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-left-main ul {
    flex-direction: column;
    align-items: center;
  }
}
.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li {
  list-style: none;
  margin: 0 20px 0 0;
}
.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li:last-child {
  margin: 0;
}
@media (max-width: 575.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li {
    margin: 0 0 20px 0;
    width: 100%;
  }
}
.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li a {
  background: #ffffff;
  padding: 15px 20px;
  border-radius: 6px;
  color: #0e82fd;
  border: 2px solid #ffffff;
  display: inline-block;
  font-weight: 600;
}
@media (max-width: 1399.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li a {
    padding: 13px 14px;
  }
}
@media (max-width: 1199.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li a {
    padding: 13px 8px;
  }
}
@media (max-width: 575.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li a {
    width: 100%;
  }
}
.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li a:hover {
  background: transparent;
  border: 2px solid #ffffff;
  color: #ffffff;
}
.contact-section-fourteen .contact-schedule-main .scheduling-right-main {
  position: relative;
  margin: -95px 0 0 0;
}
@media (max-width: 1399.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-right-main {
    margin: -53px 27px 0 0;
  }
}
@media (max-width: 991.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-right-main {
    display: none;
  }
}
.contact-section-fourteen .contact-schedule-main .scheduling-right-main .scheduling-right-img {
  position: absolute;
  top: 40%;
  left: 14px;
  -webkit-animation: mover 2s infinite alternate;
  animation: mover 2s infinite alternate;
}
@media (max-width: 991.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-right-main .scheduling-right-img {
    display: none;
  }
}
.contact-section-fourteen .contact-schedule-main .scheduling-right-main .scheduling-right-imgtwo {
  position: absolute;
  right: 15px;
  bottom: 10%;
  -webkit-animation: mover 2s infinite alternate;
  animation: mover 2s infinite alternate;
}
@media (max-width: 991.98px) {
  .contact-section-fourteen .contact-schedule-main .scheduling-right-main .scheduling-right-imgtwo {
    display: none;
  }
}
.contact-section-fourteen .contact-schedule-main .contact-inner-image {
  position: absolute;
  top: 0;
  left: 135px;
}
@media (max-width: 991.98px) {
  .contact-section-fourteen .contact-schedule-main .contact-inner-image {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .section-header-fourteen {
    text-align: center !important;
  }
}
.section-header-fourteen .service-inner-fourteen {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .section-header-fourteen .service-inner-fourteen {
    justify-content: center !important;
  }
}
.section-header-fourteen .service-inner-fourteen .service-inner-fourteen-one {
  background: #0e82fd;
  content: "";
  width: 50px;
  height: 3px;
}
.section-header-fourteen .service-inner-fourteen .service-inner-fourteen-two h3 {
  color: #0e82fd;
  font-size: 30px;
  margin: 0 20px;
}
@media (max-width: 1199.98px) {
  .section-header-fourteen .service-inner-fourteen .service-inner-fourteen-two h3 {
    font-size: 26px;
  }
}
@media (max-width: 767.98px) {
  .section-header-fourteen .service-inner-fourteen .service-inner-fourteen-two h3 {
    font-size: 22px;
  }
}
.section-header-fourteen .service-inner-fourteen .service-inner-fourteen-three {
  background: #0e82fd;
  content: "";
  width: 50px;
  height: 3px;
}
.section-header-fourteen h2 {
  color: #1f2937;
  font-size: 40px;
  font-weight: 600;
  margin: 0 0 50px 0;
}
@media (max-width: 1199.98px) {
  .section-header-fourteen h2 {
    font-size: 32px;
  }
}
@media (max-width: 991.98px) {
  .section-header-fourteen h2 {
    margin: 0 0 40px 0;
    font-size: 28px;
  }
}
@media (max-width: 767.98px) {
  .section-header-fourteen h2 {
    font-size: 26px;
  }
}

.slide-nav-14 button.owl-next,
.slide-nav-14 button.owl-prev,
.slide-nav-15 button.owl-next,
.slide-nav-15 button.owl-prev {
  background: #e2e8f0;
  border-radius: 8px;
  width: 50px;
  height: 50px;
  color: #94a3b8;
  text-shadow: none;
  font-size: 24px;
  border: none;
}
@media (max-width: 991.98px) {
  .slide-nav-14 button.owl-next,
  .slide-nav-14 button.owl-prev,
  .slide-nav-15 button.owl-next,
  .slide-nav-15 button.owl-prev {
    width: 40px;
    height: 40px;
    font-size: 20px;
    margin: 0 10px 30px 0;
  }
}
.slide-nav-14 button.owl-next:hover,
.slide-nav-14 button.owl-prev:hover,
.slide-nav-15 button.owl-next:hover,
.slide-nav-15 button.owl-prev:hover {
  background: #bfe0fe;
  color: #1d7ed8;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes mover {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
  }
}
.main-wrapper.home-fifteen {
  font-size: 16px;
  font-family: "Inter", sans-serif;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-fifteen {
    font-size: 15px;
  }
}

.banner-section-fifteen {
  position: relative;
  padding: 85px 0 0 0;
  background-color: #ffffff;
  z-index: 1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  background-repeat: no-repeat;
  background-position: right top;
  background-size: 36% 100%;
}
@media (max-width: 991.98px) {
  .banner-section-fifteen {
    background-image: none;
  }
}
.banner-section-fifteen .banner-content-fifteen {
  margin: 110px 0 0 0;
  padding: 0 0 47px 0;
}
@media (max-width: 991.98px) {
  .banner-section-fifteen .banner-content-fifteen {
    margin: 35px 0 0 0;
    padding: 0 0 47px 0;
  }
}
.banner-section-fifteen .banner-content-fifteen h2 {
  color: #1f2937;
  text-transform: uppercase;
  margin-bottom: 15px;
  font-size: 24px;
  font-weight: 600;
}
@media (max-width: 991.98px) {
  .banner-section-fifteen .banner-content-fifteen h2 {
    font-size: 20px;
  }
}
@media (max-width: 767.98px) {
  .banner-section-fifteen .banner-content-fifteen h2 {
    font-size: 18px;
  }
}
.banner-section-fifteen .banner-content-fifteen h1 {
  color: #0e82fd;
  margin-bottom: 15px;
}
.banner-section-fifteen .banner-content-fifteen .banner-btns-fifteen {
  margin: 0 0 35px 0;
}
.banner-section-fifteen .banner-content-fifteen .banner-btns-fifteen .btn-primary {
  font-weight: 600;
  background: #0e82fd;
  position: relative;
  padding: 15px 30px;
  margin-bottom: 15px;
}
@media (max-width: 479.98px) {
  .banner-section-fifteen .banner-content-fifteen .banner-btns-fifteen .btn-primary {
    width: 100%;
  }
}
.banner-section-fifteen .banner-content-fifteen .banner-btns-fifteen .btn-primary:hover {
  background: #0ce0ff;
  box-shadow: inset 0 100px 0 0 #0ce0ff;
  color: #ffffff;
  border: 1px solid #0ce0ff;
}
.banner-section-fifteen .banner-content-fifteen .banner-btns-fifteen .btns-primarytwo {
  background: #0ce0ff;
  border: 1px solid #0ce0ff;
}
.banner-section-fifteen .banner-content-fifteen .banner-btns-fifteen .btns-primarytwo:hover {
  background: #0e82fd;
  box-shadow: inset 0 100px 0 0 #0e82fd;
  border: 1px solid #0e82fd;
}
.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg {
  position: relative;
  display: inline-block;
  margin-bottom: 15px;
}
.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 56, 115, 0.25);
  z-index: 1;
  border-radius: 10px;
}
.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg a img {
  border-radius: 10px;
}
.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg a .playicon {
  position: absolute;
  top: 38%;
  right: 44%;
  z-index: 2;
}
.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg a .playicon span {
  width: 33px;
  height: 33px;
  background: #0e82fd;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  color: #ffffff;
  font-size: 10px;
}
.banner-section-fifteen .banner-content-fifteen .watch-video-fifteen {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
}
@media (max-width: 991.98px) {
  .banner-section-fifteen .banner-content-fifteen .watch-video-fifteen {
    justify-content: center;
  }
}
.banner-section-fifteen .banner-content-fifteen .watch-video-fifteen img {
  margin-right: 7px;
}
.banner-section-fifteen .banner-content-fifteen .watch-video-fifteen h6 {
  color: #1f2937;
  margin-bottom: 0;
}
.banner-section-fifteen .banner-content-fifteen .support-consult-main {
  display: flex;
}
@media (max-width: 991.98px) {
  .banner-section-fifteen .banner-content-fifteen .support-consult-main {
    justify-content: center;
  }
}
.banner-section-fifteen .banner-content-fifteen .support-consult-main .support-consult {
  display: flex;
  align-items: center;
  margin-right: 25px;
}
@media (max-width: 479.98px) {
  .banner-section-fifteen .banner-content-fifteen .support-consult-main .support-consult {
    display: block;
  }
}
.banner-section-fifteen .banner-content-fifteen .support-consult-main .support-consult:last-child {
  margin-right: 0;
}
@media (max-width: 479.98px) {
  .banner-section-fifteen
    .banner-content-fifteen
    .support-consult-main
    .support-consult
    .support-consult-img {
    margin-bottom: 5px;
  }
}
.banner-section-fifteen
  .banner-content-fifteen
  .support-consult-main
  .support-consult
  .support-consult-img
  img {
  padding: 10px;
  background: #0e82fd;
  border-radius: 5px;
  margin-right: 7px;
}
.banner-section-fifteen
  .banner-content-fifteen
  .support-consult-main
  .support-consult
  .support-consult-right
  h6 {
  color: #1f2937;
  margin-bottom: 0;
}
.banner-section-fifteen
  .banner-content-fifteen
  .support-consult-main
  .support-consult
  .support-consult-right
  .rating-fifteen {
  margin-bottom: 0;
}
.banner-section-fifteen
  .banner-content-fifteen
  .support-consult-main
  .support-consult
  .support-consult-right
  .rating-fifteen
  i.filled {
  color: #ffc001;
}
.banner-section-fifteen
  .banner-content-fifteen
  .support-consult-main
  .support-consult
  .support-consult-right
  span {
  font-size: 14px;
  color: #6b7280;
}
.banner-section-fifteen .banner-right-fifteen {
  position: relative;
  margin-top: 73px;
}
@media (max-width: 1399.98px) {
  .banner-section-fifteen .banner-right-fifteen {
    margin-top: 150px;
  }
}
@media (max-width: 991.98px) {
  .banner-section-fifteen .banner-right-fifteen {
    display: none;
  }
}
.banner-section-fifteen .banner-right-fifteen .banner-right-fifteenone {
  position: absolute;
  top: 100px;
  left: -130px;
  animation: mover 1s infinite alternate;
}
@media (max-width: 1399.98px) {
  .banner-section-fifteen .banner-right-fifteen .banner-right-fifteenone {
    top: 130px;
  }
}
@media (max-width: 1199.98px) {
  .banner-section-fifteen .banner-right-fifteen .banner-right-fifteenone {
    display: none;
  }
}
.banner-section-fifteen .banner-right-fifteen .banner-right-fifteentwo {
  position: absolute;
  top: 77px;
  left: 40px;
  animation: spin 3000ms linear infinite;
}
.banner-section-fifteen .banner-right-fifteen .banner-right-fifteenthree {
  position: absolute;
  top: 250px;
  right: -50px;
  animation: spin 3000ms linear infinite;
}
.banner-section-fifteen .banner-right-fifteen .banner-right-fifteenfour {
  position: absolute;
  right: -150px;
  bottom: 100px;
}
.banner-section-fifteen .banner-right-fifteen .banner-right-fifteenfive {
  position: absolute;
  top: 10px;
  right: -50px;
  animation: mover 1s infinite alternate;
}
.banner-section-fifteen .banner-right-fifteen .banner-right-fifteensix {
  position: absolute;
  bottom: 0;
  left: -30px;
}
@media (max-width: 1199.98px) {
  .banner-section-fifteen .banner-right-fifteen .banner-right-fifteensix {
    display: none;
  }
}
.banner-section-fifteen .banner-right-fifteen .banner-right-fifteenseven {
  position: absolute;
  top: 150px;
  right: -70px;
}
.banner-section-fifteen .banner-right-fifteen .banner-right-fifteeneight {
  position: absolute;
  bottom: 40px;
  left: 210px;
  animation: mover 1s infinite alternate;
}
.banner-section-fifteen .banner-right-fifteennine {
  position: absolute;
  bottom: 40px;
  left: 210px;
}

.services-section-fifteen {
  position: relative;
  padding: 80px 0 56px 0;
}
@media (max-width: 991.98px) {
  .services-section-fifteen {
    padding: 26px 0;
    background: #f4f4f4;
  }
}
.services-section-fifteen .service-bg-icon {
  position: absolute;
  top: 250px;
  right: 40px;
}
.services-section-fifteen .doctor-profile-widget-fifteen {
  margin-bottom: 24px;
}
.services-section-fifteen .doctor-profile-widget-fifteen .doc-pro-img .doctor-profile-img {
  border-radius: 10px;
  margin-bottom: 13px;
}
.services-section-fifteen .doctor-profile-widget-fifteen .doc-content-bottom .doc-content-split {
  margin-bottom: 15px;
}
.services-section-fifteen .doctor-profile-widget-fifteen .doc-content-bottom .doc-content-split a {
  color: #1f2937;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0;
}
.services-section-fifteen
  .doctor-profile-widget-fifteen
  .doc-content-bottom
  .doc-content-split
  a:hover {
  color: #1b5d92;
}
.services-section-fifteen
  .doctor-profile-widget-fifteen
  .doc-content-bottom
  .doc-content-split
  span {
  background: #0e82fd;
  padding: 5px 10px;
  border-radius: 5px;
  font-family: 600;
  font-size: 14px;
  color: #ffffff;
}
.services-section-fifteen .doctor-profile-widget-fifteen .doc-content-bottom p {
  color: #707070;
  margin-bottom: 0;
}

.Patients-section-fifteen {
  position: relative;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .Patients-section-fifteen {
    padding: 50px 0;
    text-align: center;
  }
}
.Patients-section-fifteen .patient-fifteen-icon {
  position: absolute;
  top: 100px;
  left: 0;
  z-index: -1;
}
.Patients-section-fifteen .section-header-fifteenpatient {
  margin-bottom: 25px;
}
.Patients-section-fifteen p {
  margin-bottom: 25px;
}
.Patients-section-fifteen .service-patient-inflict {
  text-align: center;
}
@media (max-width: 575.98px) {
  .Patients-section-fifteen .service-patient-inflict {
    margin-bottom: 15px;
  }
}
.Patients-section-fifteen .service-patient-inflict .service-patient-inflictimg {
  background: #e3fbff;
  width: 196px;
  height: 120px;
  border-radius: 10px;
  margin: auto auto 15px auto;
}
@media (max-width: 1399.98px) {
  .Patients-section-fifteen .service-patient-inflict .service-patient-inflictimg {
    width: 175px;
  }
}
@media (max-width: 1199.98px) {
  .Patients-section-fifteen .service-patient-inflict .service-patient-inflictimg {
    width: 150px;
  }
}
.Patients-section-fifteen .service-patient-inflict h6 {
  color: #6b7280;
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 0;
}
.Patients-section-fifteen .service-patient-inflict .clients-fifteen-span {
  margin-bottom: 5px;
}
.Patients-section-fifteen .service-patient-inflict .clients-fifteen-span h3 {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0;
}
.Patients-section-fifteen .service-patient-inflict .clients-fifteen-span span {
  font-weight: 600;
  font-size: 24px;
  color: #1f2937;
}
.Patients-section-fifteen .patients-left-front {
  animation-duration: 5s;
  animation-iteration-count: infinite;
  transform-origin: bottom;
}
@media (max-width: 991.98px) {
  .Patients-section-fifteen .patients-left-front {
    display: none;
  }
}
.Patients-section-fifteen .patients-left-front.patients-left-img {
  animation-name: bounce-1;
  animation-timing-function: linear;
}

.doctors-section-fifteen {
  position: relative;
  padding: 80px 0;
  background: #f4f4f4;
}
@media (max-width: 991.98px) {
  .doctors-section-fifteen {
    padding: 50px 0;
  }
}
.doctors-section-fifteen .doctor-fifteen-icon {
  position: absolute;
  top: 100px;
  right: 0;
}
.doctors-section-fifteen .doctors-fifteen-icon {
  position: absolute;
  right: 200px;
  bottom: 0;
}

.doc-content-fift {
  padding: 15px;
}
.doc-content-fift a {
  color: #1f2937;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 6px;
  display: inline-block;
}
.doc-content-fift a:hover {
  color: #0ce0ff;
}
.doc-content-fift p {
  color: #6b7280;
  margin-bottom: 10px;
}
.doc-content-fift p span {
  color: #1f2937;
}
.doc-content-fift .rate-fifteen {
  margin-bottom: 15px;
}
.doc-content-fift .rate-fifteen .rate-four {
  padding: 5px 10px;
  background: #0ce0ff;
  border-radius: 5px;
  color: #ffffff;
}
.doc-content-fift .rate-fifteen ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.doc-content-fift .rate-fifteen ul li {
  width: 31px;
  height: 27px;
  background: #eeeef3;
  color: #1f2937;
  border-radius: 5px;
  margin-right: 5px;
}
.doc-content-fift .rate-fifteen ul li:last-child {
  margin-right: 0;
}
.doc-content-fift .rate-fifteen ul.fift-rate li {
  padding: 5px;
  width: auto;
  height: auto;
}
.doc-content-fift .fift-bottom-content h3 {
  color: #1f2937;
  font-weight: 600;
  margin-bottom: 0;
}
.doc-content-fift .fift-bottom-content h3 span {
  color: #6b7280;
  text-decoration: line-through;
  font-size: 18px;
}
.doc-content-fift .fift-bottom-content a {
  padding: 10px 25px;
  background: #0e82fd;
  color: #ffffff;
  border-radius: 5px;
  margin-bottom: 0;
  transition:
    color 0.3s ease-in-out,
    box-shadow 0.3s ease-in-out;
  box-shadow: inset 0 0 0 0 #0e82fd;
  font-size: 16px;
}
@media (max-width: 1199.98px) {
  .doc-content-fift .fift-bottom-content a {
    padding: 10px 5px;
    font-size: 14px;
  }
}
.doc-content-fift .fift-bottom-content a:hover {
  box-shadow: inset 0 0 0 30px #2dd4bf;
}

.item.item-fifteen .doctor-profile-widget {
  border: none;
}
.item.item-fifteen .doctor-profile-widget.doctor-profile-widget-fift {
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.15);
  margin: 10px 0;
}
.item.item-fifteen .doctor-profile-widget.doctor-profile-widget-fift:first-child {
  margin-left: 10px;
}
.item.item-fifteen .doctor-profile-widget.doctor-profile-widget-fift:last-child {
  margin-right: 10px;
}
.item.item-fifteen .doctor-profile-widget .doc-pro-img .item-info {
  position: absolute;
  bottom: 15px;
  left: 15px;
}
.item.item-fifteen .doctor-profile-widget .doc-pro-img .item-info h6 {
  margin-bottom: 0;
  background: #0e82fd;
  border-radius: 5px;
  padding: 10px;
  color: #ffffff;
}
.item.item-fifteen .doctor-profile-widget .doc-pro-img .doctor-amount .fav-icon {
  width: 40px;
  height: 40px;
  background: #ffffff;
  border-radius: 50%;
  font-size: 17px;
}
.item.item-fifteen .doctor-profile-widget .doc-pro-img .doctor-amount .fav-icon.fav-icon-fifteen {
  background: #eeeef3;
}
.item.item-fifteen .doctor-profile-widget .doc-pro-img .doctor-amount .fav-icon.selected {
  background: #0ce0ff;
  color: #ffffff;
}
.item.item-fifteen .doctor-profile-widget .doc-pro-img.doc-pro-img-fifteen {
  padding: 56px 0;
  border-bottom: 1px solid #e5e5eb;
}
.item.item-fifteen
  .doctor-profile-widget
  .doc-pro-img.doc-pro-img-fifteen
  .doctor-profile-img-fifteen {
  width: 208px;
  height: 208px;
  margin: auto;
}

.pharmacy-section-fifteen {
  position: relative;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .pharmacy-section-fifteen {
    padding: 50px 0;
  }
}

.feedback-section-fifteen {
  position: relative;
  padding: 40px 0 80px 0;
}
@media (max-width: 1199.98px) {
  .feedback-section-fifteen {
    padding: 0 0 80px 0;
  }
}
@media (max-width: 991.98px) {
  .feedback-section-fifteen {
    padding: 0 0 50px 0;
  }
}
.feedback-section-fifteen .feedback-schedule-all {
  background: linear-gradient(92.16deg, #61aeff 0.85%, #0e82fd 76.47%);
  border-radius: 10px;
}
.feedback-section-fifteen .feedback-schedule-all .feedback-inner-main {
  margin: -45px 0 0 30px;
}
@media (max-width: 1399.98px) {
  .feedback-section-fifteen .feedback-schedule-all .feedback-inner-main {
    margin: 0 0 0 30px;
  }
}
@media (max-width: 991.98px) {
  .feedback-section-fifteen .feedback-schedule-all .feedback-inner-main {
    display: none;
  }
}
.feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content {
  padding: 50px 0;
}
@media (max-width: 991.98px) {
  .feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content {
    text-align: center;
  }
}
.feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content .feedback-fift-img {
  width: 66px;
  height: 17px;
  margin-bottom: 15px;
}
@media (max-width: 991.98px) {
  .feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content .feedback-fift-img {
    margin: auto auto 15px auto;
  }
}
.feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content h3 {
  color: #ffffff;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 10px;
}
@media (max-width: 767.98px) {
  .feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content h3 {
    font-size: 26px;
  }
}
.feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content p {
  color: #ffffff;
  font-size: 18px;
  margin-bottom: 15px;
}
.feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content a {
  padding: 15px 43px;
  background: #0ce0ff;
  border-radius: 5px;
  display: inline-block;
  color: #ffffff;
  transition:
    color 0.5s ease-in-out,
    box-shadow 0.3s ease-in-out;
  box-shadow: inset 0 0 0 0 #0e82fd;
}
.feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content a:hover {
  box-shadow: inset 0 0 0 30px #2dd4bf;
}

.appointment-section-fifteen {
  position: relative;
  padding: 80px 0;
  background-color: #0e82fd;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
  background-position: top left;
  background-repeat: no-repeat;
  background-size: 58% 100%;
}
@media (max-width: 991.98px) {
  .appointment-section-fifteen {
    padding: 50px 0;
    background-image: none;
    text-align: center;
  }
}
.appointment-section-fifteen .appointment-schedule-main h2 {
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .appointment-section-fifteen .appointment-schedule-main h2 {
    font-size: 34px;
  }
}
@media (max-width: 767.98px) {
  .appointment-section-fifteen .appointment-schedule-main h2 {
    font-size: 28px;
  }
}
.appointment-section-fifteen .appointment-schedule-main h6 {
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 25px;
}
.appointment-section-fifteen .appointment-schedule-main p {
  color: #b0d6ff;
}
.appointment-section-fifteen .appointment-schedule-main ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
}
@media (max-width: 991.98px) {
  .appointment-section-fifteen .appointment-schedule-main ul {
    justify-content: center;
  }
}
@media (max-width: 575.98px) {
  .appointment-section-fifteen .appointment-schedule-main ul {
    flex-wrap: wrap;
  }
}
.appointment-section-fifteen .appointment-schedule-main ul li {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 25px 25px 0;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  width: 151px;
}
@media (max-width: 575.98px) {
  .appointment-section-fifteen .appointment-schedule-main ul li {
    width: 50%;
    margin-right: 1px;
  }
}
.appointment-section-fifteen .appointment-schedule-main ul li:last-child {
  margin-right: 0;
}
.appointment-section-fifteen .appointment-schedule-main ul li .appointment-schedule-img {
  position: relative;
  margin-bottom: 20px;
}
.appointment-section-fifteen
  .appointment-schedule-main
  ul
  li
  .appointment-schedule-img
  .appoint-inner-img {
  position: absolute;
  right: -20px;
  bottom: -10px;
}
.appointment-section-fifteen .appointment-schedule-main ul li span {
  font-weight: 400;
  color: #1f2937;
  display: inline-block;
  font-size: 14px;
}
.appointment-section-fifteen .appointment-schedule-main a {
  background: #0ce0ff;
  padding: 15px 25px;
  border-radius: 5px;
  display: inline-block;
  color: #ffffff;
  transition:
    color 0.3s ease-in-out,
    box-shadow 0.3s ease-in-out;
  box-shadow: inset 0 0 0 0 #0e82fd;
}
.appointment-section-fifteen .appointment-schedule-main a:hover {
  box-shadow: inset 0 0 0 50px #2dd4bf;
}
.appointment-section-fifteen .appointment-right-image {
  animation-duration: 5s;
  animation-iteration-count: infinite;
  transform-origin: bottom;
}
@media (max-width: 991.98px) {
  .appointment-section-fifteen .appointment-right-image {
    display: none;
  }
}
.appointment-section-fifteen .appointment-right-image.appoint-fift-img {
  animation-name: bounce-1;
  animation-timing-function: linear;
}

.about-us-section-fifteen {
  position: relative;
  padding: 80px 0;
  background: #f4f4f4;
}
@media (max-width: 991.98px) {
  .about-us-section-fifteen {
    padding: 50px 0;
  }
}
.about-us-section-fifteen .aboutus-img-main {
  position: relative;
}
@media (max-width: 991.98px) {
  .about-us-section-fifteen .aboutus-img-main {
    display: none;
  }
}
.about-us-section-fifteen .aboutus-img-main .aboutus-img-one {
  position: absolute;
  right: 45px;
  bottom: 15px;
  box-shadow: 0px 1px 25px rgba(0, 0, 0, 0.15);
  animation: mover 1s infinite alternate;
}
.about-us-section-fifteen .vertical-slider {
  position: static;
}
.about-us-section-fifteen .vertical-slider .aboutus-fifteen-main {
  background: #ffffff;
  box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.15);
  padding: 15px;
  border-radius: 10px;
  margin: 0 0 15px 0;
}
.about-us-section-fifteen .vertical-slider .aboutus-fifteen-main .aboutus-profile-left {
  display: flex;
  align-items: center;
  justify-content: start;
  margin: 0 0 15px 0;
}
.about-us-section-fifteen
  .vertical-slider
  .aboutus-fifteen-main
  .aboutus-profile-left
  .aboutus-image {
  margin-right: 7px;
}
.about-us-section-fifteen
  .vertical-slider
  .aboutus-fifteen-main
  .aboutus-profile-left
  .aboutus-image
  img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.about-us-section-fifteen .vertical-slider .aboutus-fifteen-main .aboutus-profile-left h6 {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 7px;
}
.about-us-section-fifteen .vertical-slider .aboutus-fifteen-main .aboutus-profile-left span {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 0;
}
.about-us-section-fifteen .vertical-slider .aboutus-fifteen-main p {
  margin-bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.about-us-section-fifteen .vertical-slider .slick-list {
  padding: 0 !important;
}
.about-us-section-fifteen .vertical-slider .slick-dots {
  position: absolute;
  bottom: 3%;
  left: -42%;
}
@media (max-width: 991.98px) {
  .about-us-section-fifteen .vertical-slider .slick-dots {
    display: none !important;
  }
}
.about-us-section-fifteen .vertical-slider .slick-dots li {
  margin: 0;
  height: 6px;
}
.about-us-section-fifteen .vertical-slider .slick-dots li.slick-active button {
  background-color: #4c58a0;
}
.about-us-section-fifteen .vertical-slider .slick-arrow {
  position: absolute;
  bottom: 0;
}
.about-us-section-fifteen .vertical-slider .slick-prev {
  position: absolute;
  top: 95%;
  left: 84%;
  width: 45px;
  height: 45px;
  border-radius: 10px;
}
@media (max-width: 1399.98px) {
  .about-us-section-fifteen .vertical-slider .slick-prev {
    left: 80%;
  }
}
@media (max-width: 1199.98px) {
  .about-us-section-fifteen .vertical-slider .slick-prev {
    left: 76%;
  }
}
@media (max-width: 991.98px) {
  .about-us-section-fifteen .vertical-slider .slick-prev {
    top: 50%;
    left: auto;
  }
}
.about-us-section-fifteen .vertical-slider .slick-prev::before {
  content: "\\f053";
  font-family: "FontAwesome";
  font-weight: 900;
  font-size: 13px;
}
.about-us-section-fifteen .vertical-slider .slick-prev:hover {
  background: #1c5b91;
}
.about-us-section-fifteen .vertical-slider .slick-next {
  top: 95%;
  width: 45px;
  height: 45px;
  border-radius: 10px;
}
@media (max-width: 991.98px) {
  .about-us-section-fifteen .vertical-slider .slick-next {
    top: 50%;
  }
}
.about-us-section-fifteen .vertical-slider .slick-next::before {
  content: "\\f054";
  font-family: "FontAwesome";
  font-weight: 900;
  font-size: 13px;
}
.about-us-section-fifteen .vertical-slider .slick-next:hover {
  background: #1c5b91;
}
.about-us-section-fifteen .vertical-slider .slick-current.aboutus-fifteen-main {
  background: #0e82fd;
}
.about-us-section-fifteen
  .vertical-slider
  .slick-current.aboutus-fifteen-main
  .aboutus-profile-left
  h6 {
  color: #ffffff;
}
.about-us-section-fifteen
  .vertical-slider
  .slick-current.aboutus-fifteen-main
  .aboutus-profile-left
  span {
  color: #ffffff;
}
.about-us-section-fifteen .vertical-slider .slick-current.aboutus-fifteen-main p {
  color: #ffffff;
}

.frequently-section-fifteen {
  position: relative;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .frequently-section-fifteen {
    padding: 50px 0;
  }
}
.frequently-section-fifteen .items-fift {
  border: 1px solid #e5e5eb;
  border-radius: 10px;
  padding: 30px;
}
.frequently-section-fifteen .items-fift a {
  color: #1f2937;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  display: block;
}
.frequently-section-fifteen .items-fift p {
  color: #6b7280;
  font-weight: 400;
  margin-bottom: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  width: 100%;
  overflow: hidden;
}
.frequently-section-fifteen .items-fift .line-arrow {
  display: flex;
  align-items: center;
  color: #0e82fd;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 0;
}
.frequently-section-fifteen .items-fift .line-arrow:hover {
  color: #0ce0ff;
}
.frequently-section-fifteen .frequent-slider-fifteen .owl-nav {
  text-align: end;
}
.frequently-section-fifteen .frequent-slider-fifteen .owl-nav .owl-prev,
.frequently-section-fifteen .frequent-slider-fifteen .owl-nav .owl-next {
  margin-top: 24px;
}
.frequently-section-fifteen .frequent-slider-fifteen .owl-dots {
  position: absolute;
  bottom: 0;
  left: 0;
}
.frequently-section-fifteen .frequent-slider-fifteen .owl-dots .owl-dot {
  width: 50px;
  height: 6px;
  background: #d9d9d9;
}
.frequently-section-fifteen .frequent-slider-fifteen .owl-dots .owl-dot:first-child {
  border-radius: 10px 0 0 10px;
}
.frequently-section-fifteen .frequent-slider-fifteen .owl-dots .owl-dot:last-child {
  border-radius: 0 10px 10px 0;
}
.frequently-section-fifteen .frequent-slider-fifteen .owl-dots .owl-dot.active {
  background: #4c58a0;
}
@media (max-width: 575.98px) {
  .frequently-section-fifteen .frequent-slider-fifteen .owl-dots {
    display: none;
  }
}

.section-header-fifteen {
  margin-bottom: 50px;
}
.section-header-fifteen h2 {
  color: #1f2937;
  font-size: 40px;
  font-weight: 600;
}
@media (max-width: 991.98px) {
  .section-header-fifteen h2 {
    font-size: 34px;
  }
}
@media (max-width: 767.98px) {
  .section-header-fifteen h2 {
    font-size: 28px;
  }
}
.section-header-fifteen h2 span {
  color: rgb(14, 130, 253);
}
.section-header-fifteen p {
  color: #707070;
  margin-bottom: 0;
}

.doctor-slider-fifteen .owl-nav {
  text-align: center;
}
.doctor-slider-fifteen .owl-nav button.owl-prev,
.doctor-slider-fifteen .owl-nav button.owl-next {
  width: 45px;
  height: 45px;
  background: #ffffff;
  font-size: 13px;
  border-radius: 10px;
  margin-top: 50px;
}
.doctor-slider-fifteen .owl-nav button.owl-prev:hover,
.doctor-slider-fifteen .owl-nav button.owl-next:hover {
  background: #eeeef3;
}
@media (max-width: 767.98px) {
  .doctor-slider-fifteen .owl-nav button.owl-prev,
  .doctor-slider-fifteen .owl-nav button.owl-next {
    width: 35px;
    height: 35px;
  }
}

.pharmacy-slider-fifteen .owl-nav,
.frequent-slider-fifteen .owl-nav {
  text-align: center;
}
.pharmacy-slider-fifteen .owl-nav button.owl-prev,
.pharmacy-slider-fifteen .owl-nav button.owl-next,
.frequent-slider-fifteen .owl-nav button.owl-prev,
.frequent-slider-fifteen .owl-nav button.owl-next {
  width: 45px;
  height: 45px;
  background: #eeeef3;
  font-size: 13px;
  border-radius: 10px;
  margin-top: 50px;
}
.pharmacy-slider-fifteen .owl-nav button.owl-prev:hover,
.pharmacy-slider-fifteen .owl-nav button.owl-next:hover,
.frequent-slider-fifteen .owl-nav button.owl-prev:hover,
.frequent-slider-fifteen .owl-nav button.owl-next:hover {
  background: #0ce0ff;
}
@media (max-width: 767.98px) {
  .pharmacy-slider-fifteen .owl-nav button.owl-prev,
  .pharmacy-slider-fifteen .owl-nav button.owl-next,
  .frequent-slider-fifteen .owl-nav button.owl-prev,
  .frequent-slider-fifteen .owl-nav button.owl-next {
    width: 35px;
    height: 35px;
  }
}

.playicon {
  position: absolute;
  right: 61%;
  top: 37%;
}

.playicon span {
  width: 48px;
  height: 48px;
  background: #ff008a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.modal-content-video {
  padding: 0 !important;
}

.modal-content-video .modal-content {
  background: #000;
}

.modal-content-video .modal-header {
  border: 0;
}

.modal-content-video .modal-header button.close {
  color: #fff;
  opacity: 1;
}

.video-home video {
  width: 100%;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes mover {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
  }
}
@keyframes movers {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
  }
}
@keyframes bounce-1 {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-50px);
  }
  100% {
    transform: translateY(0);
  }
}
.frequent-slider-fifteen .owl-theme .owl-dots .owl-dot span {
  display: none;
}

.footer-fift-selects .footer-select .select2-container {
  width: 137.3333px !important;
}

.main-wrapper.home-sixteen {
  font-size: 16px;
  font-family: "Inter", sans-serif;
}
@media (max-width: 1199.98px) {
  .main-wrapper.home-sixteen {
    font-size: 15px;
  }
}

.banner-section-sixteen {
  position: relative;
  padding: 85px 0 0 0;
}
.banner-section-sixteen .banner-content-sixteen {
  padding: 100px 0 0 0;
  z-index: 1;
}
@media (max-width: 991.98px) {
  .banner-section-sixteen .banner-content-sixteen {
    padding: 50px 0;
  }
}
.banner-section-sixteen .banner-content-sixteen span {
  font-size: 14px;
  color: #0e82fd;
  font-weight: 500;
  text-transform: uppercase;
  padding: 5px 10px;
  background: rgba(14, 130, 253, 0.1);
  margin-bottom: 10px;
  display: inline-block;
}
.banner-section-sixteen .banner-content-sixteen h1 {
  color: #515151;
  margin-bottom: 26px;
}
.banner-section-sixteen .banner-content-sixteen p {
  color: #9f9f9f;
  font-size: 16px;
  margin-bottom: 26px;
}
.banner-section-sixteen .banner-content-sixteen .banner-btns-sixteen .btn-primary {
  padding: 10px 25px;
  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  font-size: 14px;
  font-weight: 700;
}
.banner-section-sixteen .banner-content-sixteen .banner-btns-sixteen .btn-primary:hover {
  box-shadow: 0 0.5em 0.5em -0.4em var(--hover);
  transform: translateY(-0.25em);
}
.banner-section-sixteen .banner-image-sixteen {
  padding: 41px 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  background-repeat: no-repeat;
  background-position: right top;
  background-size: 75% 100%;
}
.banner-section-sixteen .banner-image-sixteen .banner-inner-img-sixteen {
  position: relative;
  z-index: 1;
}
.banner-section-sixteen .banner-image-sixteen .banner-inner-img-sixteen img {
  margin-bottom: 20px;
}
.banner-section-sixteen .banner-image-sixteen .banner-inner-img-sixteen img:last-child {
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .banner-section-sixteen .banner-image-sixteen {
    display: none;
  }
}
.banner-section-sixteen .ban-sixteen-imgone {
  position: absolute;
  top: 100px;
  right: 100px;
  z-index: 0;
}
.banner-section-sixteen .ban-sixteen-imgtwo {
  position: absolute;
  top: 90px;
  left: 0;
  z-index: 0;
}

.services-section-sixteen {
  position: relative;
  padding: 80px 0;
  background: #f8fbff;
}
@media (max-width: 991.98px) {
  .services-section-sixteen {
    padding: 50px 0;
  }
}
.services-section-sixteen .discover-you-main {
  text-align: center;
}
.services-section-sixteen .discover-you-main .discover-you-image {
  width: 200px;
  height: 200px;
  background: rgba(14, 130, 253, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  margin: auto auto 20px auto;
}
.services-section-sixteen .discover-you-main .discover-you-image img {
  width: auto;
}
.services-section-sixteen .discover-you-main a {
  color: #1f2937;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 10px;
}
.services-section-sixteen .discover-you-main a:hover {
  color: #1c5b91;
}
.services-section-sixteen .discover-you-main p {
  font-size: 14px;
  color: #a2a2a2;
  margin-bottom: 15px;
}
.services-section-sixteen .discover-you-main .discov-innner {
  color: #0e82fd;
  font-size: 14px;
  font-weight: 500;
}
.services-section-sixteen .discover-you-main .discov-innner i {
  font-size: 10px;
}
.services-section-sixteen .discover-you-main .discov-innner:hover {
  color: #09dca4;
}
.services-section-sixteen .service-sixteen-icon {
  position: absolute;
  top: 75px;
  left: 45px;
  animation: mover 1s infinite alternate;
}

.treatment-section-sixteen {
  position: relative;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .treatment-section-sixteen {
    padding: 50px 0;
  }
}
.treatment-section-sixteen .item.item-sixteen .doctor-profile-widget {
  border: none;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.03);
  border-radius: 0;
}
.treatment-section-sixteen
  .item.item-sixteen
  .doctor-profile-widget
  .doc-pro-img
  .doctor-profile-img {
  border-radius: 6px;
}
.treatment-section-sixteen .item.item-sixteen .doctor-profile-widget .doc-pro-img .doctor-amount {
  position: absolute;
  top: 10px;
  left: 10px;
}
.treatment-section-sixteen
  .item.item-sixteen
  .doctor-profile-widget
  .doc-pro-img
  .doctor-amount
  span {
  padding: 5px 10px;
  border-radius: 0;
  color: #0e82fd;
  font-size: 14px;
  font-weight: 600;
}
.treatment-section-sixteen .item.item-sixteen .doctor-profile-widget .doc-content .doc-pro-info {
  align-items: start;
  padding-bottom: 10px;
}
.treatment-section-sixteen
  .item.item-sixteen
  .doctor-profile-widget
  .doc-content
  .doc-pro-info
  .doc-pro-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.treatment-section-sixteen
  .item.item-sixteen
  .doctor-profile-widget
  .doc-content
  .doc-pro-info
  .reviews-ratings
  p
  span {
  background: none;
  color: #ffbc11;
  font-size: 14px;
  margin: 0 5px 0 0;
}
.treatment-section-sixteen
  .item.item-sixteen
  .doctor-profile-widget
  .doc-content
  .doc-pro-info
  .reviews-ratings
  p
  span
  i {
  margin-right: 4px;
}
.treatment-section-sixteen
  .item.item-sixteen
  .doctor-profile-widget
  .doc-content
  .doc-pro-location
  p
  i {
  font-size: 17px;
}
.treatment-section-sixteen .item.item-sixteen .doctor-profile-widget .btn-primary {
  width: 100%;
  border-radius: 0;
  padding: 15px 20px;
  background: rgba(14, 130, 253, 0.1);
  color: #0e82fd;
  text-transform: capitalize;
  font-size: 20px;
  font-weight: 600;
  border: none;
  box-shadow: inset 0 0 0 0 #ffffff;
}
@media (max-width: 767.98px) {
  .treatment-section-sixteen .item.item-sixteen .doctor-profile-widget .btn-primary {
    padding: 10px 20px;
    font-size: 18px;
  }
}
.treatment-section-sixteen .item.item-sixteen .doctor-profile-widget .btn-primary:hover {
  background: #2dd4bf;
  box-shadow: inset 0 100px 0 0 #2dd4bf;
  color: #ffffff;
}
.treatment-section-sixteen .service-sixteen-icontwo {
  position: absolute;
  right: 25px;
  bottom: 150px;
  animation: mover 1s infinite alternate;
}

.features-section-sixteen {
  position: relative;
  padding: 80px 0;
  background: #f8fbff;
}
@media (max-width: 991.98px) {
  .features-section-sixteen {
    padding: 50px 0;
  }
}
.features-section-sixteen .feature-sixteen-main .feature-six-img {
  position: relative;
}
.features-section-sixteen .feature-sixteen-main .feature-six-img::after {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  transition: 0.5s;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.42) 100%);
}
.features-section-sixteen .feature-sixteen-main .feature-six-img .feature-content-six {
  position: absolute;
  bottom: 27px;
  text-align: center;
  width: 100%;
  z-index: 1;
  top: 82%;
  transition: all 0.5s ease-out;
}
.features-section-sixteen
  .feature-sixteen-main
  .feature-six-img
  .feature-content-six
  .feature-content-one {
  display: block;
}
.features-section-sixteen
  .feature-sixteen-main
  .feature-six-img
  .feature-content-six
  .feature-content-one
  h5 {
  font-size: 20px;
  color: #ffffff;
}
.features-section-sixteen
  .feature-sixteen-main
  .feature-six-img
  .feature-content-six
  .feature-content-one
  span {
  color: #ffffff;
}
.features-section-sixteen
  .feature-sixteen-main
  .feature-six-img
  .feature-content-six
  .feature-content-two {
  display: none;
}
.features-section-sixteen
  .feature-sixteen-main
  .feature-six-img
  .feature-content-six
  .feature-content-two
  p {
  color: #ffffff;
  line-height: 30px;
  font-size: 16px;
  letter-spacing: -0.36px;
  padding: 10px;
}
@media (max-width: 353.98px) {
  .features-section-sixteen
    .feature-sixteen-main
    .feature-six-img
    .feature-content-six
    .feature-content-two
    p {
    line-height: 20px;
  }
}
.features-section-sixteen
  .feature-sixteen-main
  .feature-six-img
  .feature-content-six
  .feature-content-two
  span {
  color: #ffffff;
}
.features-section-sixteen .feature-sixteen-main .feature-six-img:hover::after {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
}
.features-section-sixteen .feature-sixteen-main .feature-six-img:hover .feature-content-six {
  top: 30%;
}
@media (max-width: 1399.98px) {
  .features-section-sixteen .feature-sixteen-main .feature-six-img:hover .feature-content-six {
    top: 10%;
  }
}
.features-section-sixteen
  .feature-sixteen-main
  .feature-six-img:hover
  .feature-content-six
  .feature-content-one {
  display: none;
}
.features-section-sixteen
  .feature-sixteen-main
  .feature-six-img:hover
  .feature-content-six
  .feature-content-two {
  display: block;
}

.facts-section-sixteen {
  position: relative;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .facts-section-sixteen {
    padding: 50px 0;
  }
}
.facts-section-sixteen .facts-section-all {
  display: flex;
}
@media (max-width: 991.98px) {
  .facts-section-sixteen .facts-section-all {
    display: block;
  }
}
.facts-section-sixteen .facts-section-all .facts-main-sixteen {
  background: #0e82fd;
  padding: 100px 30px;
  width: 50%;
}
@media (max-width: 991.98px) {
  .facts-section-sixteen .facts-section-all .facts-main-sixteen {
    width: 100%;
    padding: 60px 30px;
    text-align: center;
  }
}
.facts-section-sixteen .facts-section-all .facts-main-sixteen span {
  font-size: 14px;
  color: #ffffff;
  font-weight: 500;
  text-transform: uppercase;
  padding: 5px 10px;
  background: rgba(255, 255, 255, 0.3);
  margin-bottom: 17px;
  display: inline-block;
}
.facts-section-sixteen .facts-section-all .facts-main-sixteen h2 {
  color: #ffffff;
  margin-bottom: 15px;
  font-size: 40px;
}
@media (max-width: 991.98px) {
  .facts-section-sixteen .facts-section-all .facts-main-sixteen h2 {
    font-size: 34px;
  }
}
@media (max-width: 767.98px) {
  .facts-section-sixteen .facts-section-all .facts-main-sixteen h2 {
    font-size: 28px;
  }
}
.facts-section-sixteen .facts-section-all .facts-main-sixteen p {
  color: #ffffff;
  font-size: 16px;
  margin-bottom: 15px;
}
.facts-section-sixteen .facts-section-all .facts-main-sixteen a {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}
.facts-section-sixteen .facts-section-all .facts-main-sixteen a i {
  font-size: 10px;
}
.facts-section-sixteen .facts-section-all .facts-main-sixteen a:hover {
  color: #09dca4;
}
.facts-section-sixteen .facts-section-all .facts-content-all {
  width: 50%;
}
@media (max-width: 991.98px) {
  .facts-section-sixteen .facts-section-all .facts-content-all {
    width: 100%;
  }
}
.facts-section-sixteen .facts-section-all .facts-content-all ul {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
}
.facts-section-sixteen .facts-section-all .facts-content-all ul li {
  width: 50%;
  height: 167px;
  padding: 20px 0;
  border: 2px solid #f8fbff;
  overflow: hidden;
  position: relative;
}
@media (max-width: 575.98px) {
  .facts-section-sixteen .facts-section-all .facts-content-all ul li {
    width: 100%;
  }
}
.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-sixteen-img {
  flex-direction: column;
  transition: all 0.5s;
}
.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-sixteen-img img {
  margin-bottom: 25px;
}
.facts-section-sixteen
  .facts-section-all
  .facts-content-all
  ul
  li
  .facts-sixteen-img
  .facts-content-sixteen
  .facts-content-one
  h5 {
  font-size: 18px;
  font-weight: 700;
  text-transform: capitalize;
  color: #626262;
  margin-bottom: 0;
}
.facts-section-sixteen
  .facts-section-all
  .facts-content-all
  ul
  li
  .facts-sixteen-img
  .facts-content-sixteen
  .facts-content-one
  h5
  i {
  font-size: 14px;
  color: #0e82fd;
}
.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  flex-direction: column;
  opacity: 0;
  transition: opacity 0.25s;
}
.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two p {
  color: #7d7d7d;
  font-size: 14px;
  letter-spacing: -0.36px;
  padding: 0 20px;
  text-align: center;
  line-height: 30px;
  margin-bottom: 0;
}
.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two:hover {
  opacity: 1;
}
.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two:hover > * {
  transform: translateY(0);
}
.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two > * {
  transform: translateY(20px);
  transition: transform 0.25s;
}
.facts-section-sixteen
  .facts-section-all
  .facts-content-all
  ul
  li
  .facts-content-two.facts-content-two-solid {
  background: #ffffff;
}

.experts-section-sixteen {
  position: relative;
  padding: 80px 0;
  background: linear-gradient(115.57deg, #464646 12.99%, rgba(0, 0, 0, 0.58) 66.18%);
}
@media (max-width: 991.98px) {
  .experts-section-sixteen {
    padding: 50px 0;
  }
}

.pricing-section-sixteen {
  position: relative;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .pricing-section-sixteen {
    padding: 50px 0;
  }
}

.testimonal-section-sixteen {
  position: relative;
  padding: 80px 0;
  background: #f8fbff;
}
@media (max-width: 991.98px) {
  .testimonal-section-sixteen {
    padding: 50px 0;
  }
}

.feedback-section-sixteen {
  position: relative;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .feedback-section-sixteen {
    padding: 50px 0;
  }
}
.feedback-section-sixteen .feedback-schedule-all {
  background: linear-gradient(90.79deg, #0e82fd 0%, #2cd9c5 100%);
  backdrop-filter: blur(30.5px);
  border-radius: 15px;
  padding: 19px;
}
@media (max-width: 991.98px) {
  .feedback-section-sixteen .feedback-schedule-all .feedback-inner-main {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content {
    text-align: center;
  }
}
.feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content h3 {
  color: #ffffff;
  font-size: 36px;
  font-weight: 700;
  text-transform: capitalize;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content h3 {
    font-size: 34px;
  }
}
@media (max-width: 767.98px) {
  .feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content h3 {
    font-size: 28px;
  }
}
.feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content p {
  color: #ffffff;
  font-size: 20px;
  margin-bottom: 30px;
}
@media (max-width: 991.98px) {
  .feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content p {
    font-size: 16px;
  }
}
.feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content .feedback-btns {
  display: flex;
  align-items: center;
  justify-content: start;
}
@media (max-width: 991.98px) {
  .feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content .feedback-btns {
    justify-content: center;
  }
}
@media (max-width: 575.98px) {
  .feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content .feedback-btns {
    display: block;
    width: 100%;
  }
}
.feedback-section-sixteen
  .feedback-schedule-all
  .feedback-fifteen-content
  .feedback-btns
  .btn-primary {
  padding: 10px 25px;
  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  background: #ffffff;
  color: #0e82fd;
  font-size: 16px;
  font-weight: 700;
  border: none;
  transition: 0.5s;
  margin-right: 10px;
}
.feedback-section-sixteen
  .feedback-schedule-all
  .feedback-fifteen-content
  .feedback-btns
  .btn-primary:hover {
  background: #1c5b91;
  color: #ffffff;
  transition: 0.5s;
}
@media (max-width: 575.98px) {
  .feedback-section-sixteen
    .feedback-schedule-all
    .feedback-fifteen-content
    .feedback-btns
    .btn-primary {
    width: 100%;
    margin: 0 0 10px 0;
  }
}
.feedback-section-sixteen
  .feedback-schedule-all
  .feedback-fifteen-content
  .feedback-btns
  .btn-primarytwo {
  padding: 10px 25px;
  font-size: 16px;
  margin-bottom: 0;
  font-weight: 600;
  color: #ffffff;
  border-radius: 5px;
  transition: 0.5s;
}
.feedback-section-sixteen
  .feedback-schedule-all
  .feedback-fifteen-content
  .feedback-btns
  .btn-primarytwo:hover {
  background: #1c5b91;
  color: #ffffff;
  transition: 0.5s;
}
@media (max-width: 575.98px) {
  .feedback-section-sixteen
    .feedback-schedule-all
    .feedback-fifteen-content
    .feedback-btns
    .btn-primarytwo {
    width: 100%;
  }
}

.section-header-sixteen {
  margin-bottom: 50px;
}
.section-header-sixteen.section-header-sixteentwo h2 {
  color: #ffffff;
}
.section-header-sixteen p {
  color: #0e82fd;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 7px;
}
.section-header-sixteen h2 {
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 0;
  color: #1f2937;
  text-transform: capitalize;
}
@media (max-width: 991.98px) {
  .section-header-sixteen h2 {
    font-size: 34px;
  }
}
@media (max-width: 767.98px) {
  .section-header-sixteen h2 {
    font-size: 28px;
  }
}

.discover-slider .owl-dots,
.treatment-sixteen-slider .owl-dots,
.features-slider-sixteen .owl-dots {
  text-align: center;
  margin-top: 60px;
}
.discover-slider .owl-dots .owl-dot,
.treatment-sixteen-slider .owl-dots .owl-dot,
.features-slider-sixteen .owl-dots .owl-dot {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background: #d9d9d9;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  margin-right: 7px;
}
.discover-slider .owl-dots .owl-dot.active,
.treatment-sixteen-slider .owl-dots .owl-dot.active,
.features-slider-sixteen .owl-dots .owl-dot.active {
  background: #0e82fd;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
}

@keyframes mover {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
  }
}
.testi-img {
  position: relative;
  margin: 43px 0 15px;
}
.testi-img img {
  padding: 0 43px 0 0;
}
.testi-img .testi-icon {
  width: 86px;
  height: 86px;
  background: #0ce0ff;
  border-radius: 100px;
  font-size: 16px;
  color: #ffffff;
  position: absolute;
  top: -43px;
  right: 0;
}

.testi-users {
  margin: 0 43px 0 0;
}
.testi-users ul {
  margin: 0;
  padding: 0;
}
.testi-users ul li {
  display: inline-block;
  margin: 0 0 0 -23px;
}
.testi-users ul li:first-child {
  margin: 0;
}
.testi-users ul li img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border: 2px solid #ffffff;
}
@media (max-width: 767.98px) {
  .testi-users ul li img {
    width: 50px;
    height: 50px;
  }
}

.testimonial-wrap {
  position: relative;
}
.testimonial-wrap h4 {
  margin: 0 0 30px;
}
.testimonial-wrap p {
  margin: 0 0 30px;
}
.testimonial-wrap .testimonial-user h6 {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 5px;
}
.testimonial-wrap .testimonial-user p {
  font-size: 14px;
  margin: 0;
}
.testimonial-wrap::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_41___}) no-repeat;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 84px;
  height: 14px;
}

.slide-11 button {
  background: transparent;
  border: 0;
  padding: 0;
}
.slide-11 button.owl-next {
  margin: 0 0 0 10px;
}

.slider.slider-sixteen {
  position: relative;
}
.slider.slider-sixteen .testimonal-contents {
  text-align: center;
  background: #ffffff;
  padding: 20px 0;
  border-radius: 0px 0px 5px 5px;
  opacity: 0.3;
}
.slider.slider-sixteen .testimonal-contents h5 {
  color: #1f2937;
  font-size: 20px;
  font-weight: 500;
}
.slider.slider-sixteen .testimonal-contents span {
  color: #0e82fd;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.005em;
}

.main-reviewimages {
  height: auto;
  width: 100%;
}

.main-reviewimages img {
  opacity: 0.3;
  border-radius: 5px px 0px 0px;
}

#slide-experts .active.center .main-reviewimages img,
#slide-experts .active.center .testimonal-contents {
  opacity: 1;
}

.test_img {
  position: relative;
  opacity: 1;
  -webkit-transition: 0.4s ease all;
  transition: 0.4s ease all;
  margin: 0 -48px;
  margin-top: 40px;
}

.slider.slider.slider-sixteen {
  width: 100%;
  margin: 0 auto;
}

#slide-testimonal .center .test_img:before {
  content: none;
  transition: 0.7s ease-in-out;
}

.test_img img {
  border-radius: 24px;
  overflow: hidden;
  margin: 0 auto;
  height: 100%;
  object-fit: cover;
}

.custome_slides.owl-carousel .owl-item.active.center {
  transform: scale(1);
  margin-top: 0 !important;
  position: relative;
  z-index: 999;
}

.custome_slides.owl-carousel .owl-item {
  transform: scale(0.7);
  padding: 10px 0px;
  transition: all 0.5s;
}

.services-section-sixteen .owl-theme .owl-dots .owl-dot span {
  display: none;
}

.treatment-section-sixteen .owl-theme .owl-dots .owl-dot span {
  display: none;
}

.features-section-sixteen .owl-theme .owl-dots .owl-dot span {
  display: none;
}

.testimonal-section-sixteen .owl-carousel .owl-nav {
  position: absolute;
  margin-left: -472px;
  margin-top: 26px;
}

.full-slide-home {
  background: #e3e3e3;
}
.full-slide-home .slick-prev {
  left: 30px;
}
.full-slide-home .slick-next {
  right: 30px;
}
.full-slide-home .slick-slide .slide-image {
  width: 100%;
  min-height: 358px;
  justify-content: center;
  flex-direction: column;
  padding: 70px 50px 70px 100px;
  vertical-align: middle;
  background-position: right;
  background-size: contain;
}
.full-slide-home .slick-slide .slide-image h2 {
  font-size: 36px;
  font-weight: 500;
}
.full-slide-home .slick-slide .slide-image .slide-ul li {
  color: #757575;
  font-size: 13px;
}
.full-slide-home .slick-slide .slide-image .slide-ul li:before {
  font-family: "Font Awesome 5 Free";
  display: inline-block;
  padding-right: 6px;
  vertical-align: middle;
  content: "\\f192";
  color: #a2a1a1;
  font-size: 10px;
}

.section-search-pharmacy {
  min-height: inherit !important;
  background: #ffffff;
  padding: 40px 0;
}
.section-search-pharmacy .banner-wrapper2 {
  margin: 0 auto;
  max-width: 680px;
  width: 100%;
}
.section-search-pharmacy .banner-wrapper2 .search-box1 .search-location1 {
  margin-right: 12px;
  position: relative;
  width: 400px;
  margin-bottom: 0;
}
.section-search-pharmacy .banner-wrapper2 .search-box1 .form-control {
  border: 1px solid #cccccc;
  box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  padding-left: 35px;
}
.section-search-pharmacy .banner-wrapper2 .search-box1 .search-detect {
  padding: 5px 9px 5px 28px;
  font-size: 13px;
  color: #757575;
  border-radius: 5px;
  background: #e3e3e3 url(${___CSS_LOADER_URL_REPLACEMENT_53___}) no-repeat 9px center;
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 5px;
}
.section-search-pharmacy .banner-wrapper2 .search-box1 .search-btn {
  width: 46px;
  -ms-flex: 0 0 46px;
  flex: 0 0 46px;
  height: 46px;
  margin: 0;
}
.section-search-pharmacy .banner-wrapper2 .search-box1 .search-btn span {
  display: none;
  font-weight: 500;
}

.doctor-img1 {
  margin-right: 20px;
}

.doc-info-right .clinic-booking a {
  padding: 10px 15px;
}

.pharmacy-location,
.pharmacy-title {
  color: #2e3842;
}

.custom-short-by .sort-title {
  color: #2e3842;
}
.custom-short-by > div {
  margin-right: 20px;
}
.custom-short-by > div:first-child {
  margin-right: 0;
}

.product-custom span.price {
  font-size: 20px;
  font-weight: 500;
}
.product-custom span.price-strike {
  font-weight: 400;
  text-decoration: line-through;
  color: #999;
}
.product-custom .cart-icon {
  font-size: 18px;
  width: 40px;
  height: 40px;
  border-radius: 100px;
  float: right;
}
.product-custom .profile-widget:hover .cart-icon {
  color: #ffffff;
  background-color: #0de0fe;
}

.product-description .doctor-img1 {
  width: 40%;
}
.product-description .doc-info-cont {
  width: 60%;
}

.clini-infos h2 b.strike {
  text-decoration: line-through;
  font-weight: 500;
}

.feature-product span {
  padding-bottom: 10px;
  display: inline-block;
}
.feature-product ul li {
  padding: 3px 0;
}

ul.benifits-col li i {
  font-size: 20px;
  margin-right: 20px;
  color: #20c0f3;
}

.booking-date li span {
  text-align: right;
}
.booking-date li span a {
  color: #20c0f3;
  font-size: 13px;
  width: 100%;
  display: inline-block;
}

.doctor-content {
  background-color: #ffffff;
  margin: 0;
  padding: 140px 0 60px;
}
@media (max-width: 991.98px) {
  .doctor-content {
    margin: 0;
    padding: 100px 0 40px;
  }
}
@media (max-width: 767.98px) {
  .doctor-content {
    margin: 0;
    padding: 100px 0 20px;
  }
}
.doctor-content.content {
  margin: 0;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .doctor-content.content {
    margin: 0;
    padding: 40px 0;
  }
}
@media (max-width: 767.98px) {
  .doctor-content.content {
    margin: 0;
    padding: 20px 0;
  }
}

.back-link {
  padding-bottom: 30px;
}
.back-link a {
  font-size: 15px;
  color: #959595;
}
.back-link a:hover {
  color: #09e5ab;
}
.back-link a i {
  margin-right: 10px;
}
@media (max-width: 767.98px) {
  .back-link {
    padding-bottom: 25px;
  }
}

.paitent-header {
  padding-bottom: 40px;
}
.paitent-header .paitent-title {
  font-size: 22px;
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .paitent-header .paitent-title {
    font-size: 20px;
  }
}
@media (max-width: 767.98px) {
  .paitent-header .paitent-title {
    font-size: 18px;
  }
}
@media (max-width: 991.98px) {
  .paitent-header {
    padding-bottom: 30px;
  }
}
@media (max-width: 767.98px) {
  .paitent-header {
    padding-bottom: 20px;
  }
}

.booking-header {
  padding-bottom: 25px;
}
.booking-header .booking-title {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .booking-header {
    padding-bottom: 20px;
  }
}

.payment-form-group {
  margin-bottom: 10px;
}

.payments-form .custom_radio {
  font-weight: 500;
  color: #000000;
  padding-left: 26px;
  margin-bottom: 0;
}
.payments-form .custom_radio input:checked ~ .checkmark {
  border: 5px solid #0e82fd;
}
.payments-form .custom_radio .checkmark {
  top: inherit;
  border: 2px solid #9a9a9a;
}
.payments-form .custom_radio .checkmark:after {
  top: -1px;
  left: -1px;
  background: #ffffff;
  width: 0;
  height: 0;
}

.card-label > label {
  background-color: #ffffff;
  color: #ababab;
  display: inline-block;
  font-size: 13px;
  font-weight: 500;
  margin: 6px auto auto 8px;
  padding: 0 7px;
}
.card-label > .form-control {
  margin: -13px 0 0;
  padding: 6px 15px 0;
  min-height: 48px;
}
.card-label > .form-control::placeholder {
  font-weight: 500;
  color: #3c4758;
}

.booking-btn .btn {
  min-width: 123px;
  font-weight: 500;
  margin: 0;
  padding: 8px 10px;
  border-radius: 5px;
}
.booking-btn .btn i {
  font-size: 18px;
  color: #ffffff;
  position: relative;
  left: 8px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.booking-btn .btn:hover i {
  color: #0e82fd;
  left: 12px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
@media (max-width: 767.98px) {
  .booking-btn .btn {
    min-width: 100px;
    margin: 0;
    padding: 7px 10px;
  }
}
@media (max-width: 991.98px) {
  .booking-btn {
    padding-bottom: 25px;
  }
}

.booking-card {
  border: 2px solid #f4f4f4;
  border-radius: 8px;
  margin-bottom: 25px;
}
.booking-card .booking-card-body {
  padding: 15px;
}
@media (max-width: 991.98px) {
  .booking-card {
    margin-bottom: 20px;
  }
}

.booking-doctor-img {
  width: 45px;
  height: 45px;
  margin-right: 15px;
  border-radius: 50%;
}
.booking-doctor-img img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
}

.booking-doctor-info h4 {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 5px;
}
.booking-doctor-info h4 a:hover {
  color: #0e82fd;
}
.booking-doctor-info p {
  color: #888888;
  margin-bottom: 0;
}

.booking-doctor-right p {
  margin-bottom: 0;
}
.booking-doctor-right i {
  margin-right: 18px;
  font-size: 20px;
  color: #28a745;
}
.booking-doctor-right a {
  font-weight: 500;
  text-decoration: underline;
  color: #0e82fd;
}
.booking-doctor-right a:hover {
  color: #000000;
}

.booking-list-body {
  padding-bottom: 5px !important;
}
.booking-list-body .booking-doctor-right {
  padding-bottom: 10px;
}

.booking-date-list {
  width: 300px;
}
.booking-date-list ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.booking-date-list ul li {
  font-weight: 500;
  color: #494949;
  padding-bottom: 10px;
}
.booking-date-list ul li span {
  font-weight: normal;
  color: #777777;
  float: right;
  text-align: right;
}
.booking-date-list ul li span i {
  font-size: 16px;
  margin-right: 6px;
}
@media (max-width: 1399.98px) {
  .booking-date-list {
    width: 265px;
  }
}
.booking-date-list.consultation-date-list {
  width: 100%;
}

.proceed-btn {
  text-align: right;
}
.proceed-btn .btn {
  margin: 0;
  padding: 8px 15px;
  min-width: 209px;
}
@media (max-width: 767.98px) {
  .proceed-btn .btn {
    min-width: 200px;
  }
}
@media (max-width: 991.98px) {
  .proceed-btn {
    padding-bottom: 0;
  }
}

.custom_radio {
  color: #8d8d8d;
  position: relative;
  font-size: 14px;
  padding-left: 30px;
  margin-bottom: 10px;
  cursor: pointer;
  user-select: none;
}
.custom_radio input {
  position: absolute;
  opacity: 0;
}
.custom_radio input:checked ~ .checkmark {
  border: 1px solid #0e82fd;
}
.custom_radio input:checked ~ .checkmark:after {
  transform: scale(1);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  opacity: 1;
  visibility: visible;
}
.custom_radio .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #ffffff;
  border: 1px solid #aeaeb2;
  border-radius: 50%;
  -webkit-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.custom_radio .checkmark:after {
  display: block;
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  opacity: 0;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #0e82fd;
  visibility: hidden;
  transform: scale(0.1);
  -webkit-transform: scale(0.1);
  -ms-transform: scale(0.1);
  -webkit-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.radio_input .custom_radio + .custom_radio {
  margin-left: 15px;
}

.pricing-section {
  background-color: #ffffff;
  margin: 0;
  padding: 80px 0 55px;
}
@media (max-width: 991.98px) {
  .pricing-section {
    margin: 0;
    padding: 40px 0 15px;
  }
}
@media (max-width: 767.98px) {
  .pricing-section {
    margin: 0;
    padding: 40px 0 20px;
  }
}

.pricing-inner-header {
  margin-bottom: 80px;
}
@media (max-width: 991.98px) {
  .pricing-inner-header {
    margin-bottom: 40px;
  }
}

.plan-choose-info {
  padding-top: 15px;
}
.plan-choose-info label {
  margin-bottom: 0;
}
.plan-choose-info .monthly-plan {
  color: #0a0b0d;
}
.plan-choose-info .yearly-plan {
  color: #6b7280;
}
.plan-choose-info .status-toggle {
  margin: 0 20px;
  padding: 0;
}
.plan-choose-info .checktoggle {
  background-color: #0e82fd;
  border: 1px solid #0e82fd;
}
.plan-choose-info .check:checked + .checktoggle {
  background-color: #ffffff;
  border: 1px solid #0e82fd;
}
.plan-choose-info .check:checked + .checktoggle:after {
  background-color: #0e82fd;
}
.plan-choose-info .monthly-plan,
.plan-choose-info .yearly-plan {
  font-weight: 500;
  font-size: 18px;
}
@media (max-width: 767.98px) {
  .plan-choose-info .monthly-plan,
  .plan-choose-info .yearly-plan {
    font-size: 16px;
  }
}

.pricing-card {
  background: #f2f6f6;
  border: 1px solid #e5e7eb;
  border-radius: 24px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card:hover {
  background: #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card:hover .pricing-icon span {
  background: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.pricing-card:hover .pricing-icon span img {
  transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card:hover .pricing-title p {
  color: #eff0f7;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card:hover .pricing-title h4 {
  color: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card:hover .pricing-header-text p {
  color: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card:hover .pricing-amount h2 {
  color: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card:hover .pricing-amount h2 span {
  color: #d9dbe9;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card:hover .pricing-amount h6 {
  color: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card:hover .pricing-list ul li {
  color: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card:hover .pricing-list ul li:before {
  color: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card:hover .pricing-btn .btn {
  color: #ffffff;
  border: 1px solid #3b9cf6;
  box-shadow: inset 0 0 0 50px #3b9cf6;
}
.pricing-card .card-body {
  margin: 0;
  padding: 30px;
}
@media (max-width: 991.98px) {
  .pricing-card .card-body {
    margin: 0;
    padding: 20px;
  }
}
@media (max-width: 767.98px) {
  .pricing-card .card-body {
    margin: 0;
    padding: 15px;
  }
}

.pricing-card-active {
  background: #0e82fd;
}
.pricing-card-active .pricing-icon span {
  background: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.pricing-card-active .pricing-icon span img {
  transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card-active .pricing-title p {
  color: #eff0f7;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card-active .pricing-title h4 {
  color: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card-active .pricing-tag {
  margin-left: auto;
}
.pricing-card-active .pricing-tag span {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  font-weight: 500;
  border-radius: 10px;
  padding: 12px 13px;
}
.pricing-card-active .pricing-header-text p {
  color: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card-active .pricing-amount h2 {
  color: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card-active .pricing-amount h2 span {
  color: #d9dbe9;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card-active .pricing-amount h6 {
  color: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card-active .pricing-list ul li {
  color: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card-active .pricing-list ul li:before {
  color: #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-card-active .pricing-btn .btn {
  color: #ffffff;
  border: 1px solid #3b9cf6;
  box-shadow: inset 0 0 0 50px #3b9cf6;
}

.pricing-header {
  padding-bottom: 15px;
}

.pricing-header-info {
  padding-bottom: 15px;
}

.pricing-icon {
  margin-right: 15px;
}
.pricing-icon span {
  min-width: 70px;
  height: 70px;
  background: #ffffff;
  border-radius: 16px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
  transform: rotate(0);
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
}
.pricing-icon span img {
  transform: rotate(0);
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}

.pricing-title p {
  font-weight: 500;
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 0;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
@media (max-width: 767.98px) {
  .pricing-title p {
    font-size: 15px;
  }
}
.pricing-title h4 {
  font-size: 24px;
  color: #1f2937;
  margin-bottom: 0;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
@media (max-width: 767.98px) {
  .pricing-title h4 {
    font-size: 20px;
  }
}

.pricing-header-text p {
  color: #6b7280;
  margin-bottom: 0;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}

.pricing-amount {
  padding-bottom: 20px;
}
.pricing-amount h2 {
  font-weight: 700;
  font-size: 30px;
  color: #1f2937;
  margin-bottom: 8px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-amount h2 span {
  font-weight: 400;
  font-size: 14px;
  color: #9ca3af;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
@media (max-width: 991.98px) {
  .pricing-amount h2 {
    font-size: 40px;
  }
}
@media (max-width: 767.98px) {
  .pricing-amount h2 {
    font-size: 30px;
  }
}
.pricing-amount h6 {
  font-weight: 500;
  font-size: 20px;
  color: #1f2937;
  margin-bottom: 0;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
@media (max-width: 767.98px) {
  .pricing-amount h6 {
    font-size: 16px;
  }
}

.pricing-list {
  padding-bottom: 50px;
}
.pricing-list ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.pricing-list ul li {
  position: relative;
  font-size: 16px;
  color: #6b7280;
  padding-left: 25px;
  margin-bottom: 10px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.pricing-list ul li:last-child {
  margin-bottom: 0;
}
.pricing-list ul li:before {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  content: "\\f058";
  font-family: "Font Awesome 5 Free";
  font-size: 16px;
  font-weight: 900;
  color: #0e82fd;
  border: 0;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
@media (max-width: 767.98px) {
  .pricing-list ul li {
    font-size: 14px;
  }
}
@media (max-width: 991.98px) {
  .pricing-list {
    padding-bottom: 30px;
  }
}
@media (max-width: 767.98px) {
  .pricing-list {
    padding-bottom: 20px;
  }
}

.pricing-btn {
  text-align: center;
}
.pricing-btn .btn {
  font-weight: 600;
  font-size: 14px;
  margin: 0;
  padding: 11px 15px;
  min-width: 100%;
  display: inline-block;
  color: #ffffff;
  border: 1px solid #0e82fd;
  background: #0e82fd;
}
@media (max-width: 767.98px) {
  .pricing-btn .btn {
    margin: 0;
    padding: 8px 15px;
    font-size: 14px;
  }
}

.breadcrumb-bar-two {
  background: #f2f6f6;
  background-repeat: no-repeat;
  padding-top: 70px;
  min-height: 300px;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.breadcrumb-bar-two .inner-banner {
  margin: 0;
  padding: 70px 0;
}
.breadcrumb-bar-two .inner-banner .breadcrumb-title {
  font-weight: 600;
  font-size: 48px;
  margin-bottom: 6px;
}
@media (max-width: 991.98px) {
  .breadcrumb-bar-two .inner-banner .breadcrumb-title {
    font-size: 36px;
  }
}
@media (max-width: 767.98px) {
  .breadcrumb-bar-two .inner-banner .breadcrumb-title {
    font-size: 26px;
  }
}
@media (max-width: 767.98px) {
  .breadcrumb-bar-two .inner-banner {
    margin: 0;
    padding: 50px 0;
  }
}
@media (max-width: 991.98px) {
  .breadcrumb-bar-two {
    padding-top: 40px;
    min-height: 260px;
  }
}
@media (max-width: 767.98px) {
  .breadcrumb-bar-two {
    min-height: auto;
  }
}
.breadcrumb-bar-two .page-breadcrumb ol {
  background-color: transparent;
  font-weight: 500;
  margin: 0;
  padding: 0;
}
.breadcrumb-bar-two .page-breadcrumb ol li a {
  font-weight: 500;
  color: #4b5563;
}
.breadcrumb-bar-two .page-breadcrumb ol li.active {
  color: #1f2937;
}
@media (max-width: 767.98px) {
  .breadcrumb-bar-two .page-breadcrumb ol {
    font-size: 15px;
  }
}
.breadcrumb-bar-two .page-breadcrumb .breadcrumb a:hover {
  color: #0e82fd;
}
.breadcrumb-bar-two .page-breadcrumb .breadcrumb-item + .breadcrumb-item {
  font-weight: 500;
  color: #1f2937;
  padding-left: 10px;
}
.breadcrumb-bar-two .breadcrumb-item + .breadcrumb-item::before {
  content: "/";
  font-family: "feather";
  float: left;
  padding-right: 10px;
  color: #9ca3af;
  font-size: 14px;
  font-weight: 600;
}

.about-section {
  background-color: #ffffff;
  margin: 0;
  padding: 80px 0;
}
.about-section .about-img-info {
  padding-right: 30px;
}
.about-section .about-img-info .about-img {
  border-radius: 8px;
  margin-bottom: 25px;
}
.about-section .about-img-info .about-img:last-child {
  margin-bottom: 0;
}
.about-section .about-img-info .about-img img {
  border-radius: 8px;
}
.about-section .about-img-info .about-box {
  background: #0e82fd;
  border-radius: 8px;
  margin: 15px 0 25px;
  padding: 45px 10px;
  text-align: center;
}
.about-section .about-img-info .about-box h4 {
  font-weight: 600;
  font-size: 20px;
  color: #ffffff;
  max-width: 208px;
  margin: 0 auto 0;
  padding: 0;
}
@media (max-width: 991.98px) {
  .about-section .about-img-info {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .about-section {
    margin: 0;
    padding: 40px 0;
  }
}

.section-inner-header {
  margin-bottom: 40px;
}
.section-inner-header h6 {
  font-weight: 500;
  font-size: 16px;
  color: #0e82fd;
  margin-bottom: 15px;
}
@media (max-width: 767.98px) {
  .section-inner-header h6 {
    margin-bottom: 10px;
  }
}
.section-inner-header h2 {
  font-weight: 600;
  font-size: 40px;
  color: #1f2937;
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .section-inner-header h2 {
    font-size: 32px;
    max-width: inherit;
  }
}
@media (max-width: 767.98px) {
  .section-inner-header h2 {
    font-size: 22px;
  }
}
@media (max-width: 991.98px) {
  .section-inner-header {
    margin-bottom: 40px;
  }
}

.about-inner-header {
  margin-bottom: 30px;
}
@media (max-width: 767.98px) {
  .about-inner-header {
    margin-bottom: 20px;
  }
}

.about-content-details {
  padding-bottom: 25px;
}
.about-content-details p {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 25px;
}
.about-content-details p:last-child {
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .about-content-details p {
    font-size: 15px;
    margin-bottom: 20px;
  }
}

.about-contact-icon {
  margin-right: 15px;
}
.about-contact-icon span {
  width: 47px;
  height: 47px;
  border-radius: 50px;
  color: #ffffff;
  background: #0e82fd;
}

.about-contact-text p {
  font-weight: 500;
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 5px;
}
@media (max-width: 767.98px) {
  .about-contact-text p {
    font-size: 14px;
  }
}
.about-contact-text h4 {
  color: #27272a;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .about-contact-text h4 {
    font-size: 18px;
  }
}

.why-choose-section {
  background-color: #ffffff;
  margin: 0;
  padding: 0 0 55px;
}
@media (max-width: 991.98px) {
  .why-choose-section {
    margin: 0;
    padding: 20px 0 15px;
  }
}
@media (max-width: 767.98px) {
  .why-choose-section {
    margin: 0;
    padding: 0 0 20px;
  }
}

.why-choose-card {
  border: 1px solid #f3f4f6;
  border-radius: 8px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.why-choose-card:hover {
  box-shadow: 0px 0px 111px rgba(0, 0, 0, 0.09);
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.why-choose-card:hover .why-choose-icon span img {
  transform: rotateY(360deg);
  -webkit-transform: rotateY(360deg);
  -ms-transform: rotateY(360deg);
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.why-choose-card .card-body {
  margin: 0;
  padding: 25px;
}
@media (max-width: 991.98px) {
  .why-choose-card .card-body {
    margin: 0;
    padding: 20px;
  }
}
@media (max-width: 767.98px) {
  .why-choose-card .card-body {
    margin: 0;
    padding: 15px;
  }
}

.why-choose-icon {
  padding-bottom: 24px;
}
.why-choose-icon span {
  width: 80px;
  height: 80px;
  border-radius: 50px;
  color: #ffffff;
  background: #0e82fd;
}
.why-choose-icon span img {
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
@media (max-width: 767.98px) {
  .why-choose-icon {
    padding-bottom: 20px;
  }
}

.why-choose-content h4 {
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 12px;
}
.why-choose-content p {
  font-size: 16px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .why-choose-content p {
    font-size: 14px;
  }
}

.way-section {
  background-color: #ffffff;
  margin: 0;
  padding: 0 0 80px;
}
.way-section .way-bg {
  background: #0e82fd;
  border-radius: 25px;
  position: relative;
  overflow: hidden;
}
.way-section .way-bg .way-shapes-img {
  position: relative;
}
.way-section .way-bg .way-shapes-img .way-shapes-left {
  position: absolute;
  top: 60px;
  right: 200px;
}
.way-section .way-bg .way-shapes-img .way-shapes-right {
  position: absolute;
  right: 0;
}
@media (max-width: 991.98px) {
  .way-section .way-bg .way-shapes-img {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .way-section .way-bg {
    border-radius: 10px;
  }
}
@media (max-width: 991.98px) {
  .way-section {
    margin: 0;
    padding: 0 0 40px;
  }
}

.way-inner-header {
  margin: 0;
  padding: 60px;
}
.way-inner-header h2 {
  color: #ffffff;
  margin-bottom: 29px;
}
.way-inner-header p {
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  margin-bottom: 40px;
}
@media (max-width: 767.98px) {
  .way-inner-header p {
    margin-bottom: 15px;
  }
}
.way-inner-header .btn {
  font-weight: 600;
  font-size: 15px;
  padding: 11px 16px;
  color: #3b9cf6;
  background: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 8px;
  box-shadow: inset 0 0 0 0 #0e82fd;
}
.way-inner-header .btn:hover {
  color: #ffffff;
  border: 1px solid #ffffff;
  background: #0e82fd;
  box-shadow: inset 0 0 0 50px #0e82fd;
}
@media (max-width: 767.98px) {
  .way-inner-header .btn {
    font-size: 14px;
    margin: 0;
    padding: 10px 15px;
  }
}
@media (max-width: 991.98px) {
  .way-inner-header {
    margin: 0;
    padding: 30px;
  }
}
@media (max-width: 767.98px) {
  .way-inner-header {
    margin: 0;
    padding: 20px;
  }
}

.way-img {
  position: relative;
  top: 10px;
}
@media (max-width: 991.98px) {
  .way-img {
    display: none;
  }
}

.professional-section {
  margin: 0;
  padding: 0 0 55px;
  background: #ffffff;
}
.professional-section .doctor-profile-widget {
  margin-bottom: 25px;
}
@media (max-width: 767.98px) {
  .professional-section .doctor-profile-widget {
    margin-bottom: 20px;
  }
}
@media (max-width: 991.98px) {
  .professional-section {
    margin: 0;
    padding: 0 0 15px;
  }
}
@media (max-width: 767.98px) {
  .professional-section {
    margin: 0;
    padding: 0 0 20px;
  }
}

.testimonial-section {
  background: #f2f6f6;
  margin: 0;
  padding: 80px 0;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.testimonial-section::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left;
  position: absolute;
  top: 0;
  left: 0;
  width: 213px;
  height: 335px;
  opacity: 0.5;
  z-index: -1;
}
@media (max-width: 991.98px) {
  .testimonial-section::after {
    display: none;
  }
}
.testimonial-section::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;
  position: absolute;
  right: 0;
  bottom: 0;
  opacity: 0.5;
  width: 213px;
  height: 335px;
  z-index: -1;
}
@media (max-width: 991.98px) {
  .testimonial-section::before {
    display: none;
  }
}
.testimonial-section .testimonial-shape-img {
  position: relative;
}
.testimonial-section .testimonial-shape-img .testimonial-shape-left {
  position: absolute;
  top: -30px;
  left: -40px;
  -webkit-animation-name: blinker;
  -webkit-animation-duration: 0.6s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-direction: alternate;
}
.testimonial-section .testimonial-shape-img .testimonial-shape-left img {
  width: 100px;
}
.testimonial-section .testimonial-shape-img .testimonial-shape-right {
  position: absolute;
  top: 60px;
  right: 0;
  -webkit-animation-name: blinker;
  -webkit-animation-duration: 0.6s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-direction: alternate;
}
.testimonial-section .testimonial-shape-img .testimonial-shape-right img {
  width: 100px;
}
@media (max-width: 991.98px) {
  .testimonial-section .testimonial-shape-img {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .testimonial-section {
    margin: 0;
    padding: 40px 0;
  }
}

@media (max-width: 767.98px) {
  .testimonial-info {
    flex-direction: column;
  }
}

.testimonial-img {
  border-radius: 50%;
  margin-right: 50px;
  width: 220px;
  -ms-flex: 0 0 220px;
  flex: 0 0 220px;
}
@media (max-width: 767.98px) {
  .testimonial-img {
    margin: 0 0 30px 0;
    padding: 0;
    width: 200px;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
  }
}
.testimonial-img img {
  border-radius: 50%;
  width: 100%;
}

.testimonial-header {
  margin-bottom: 25px;
}

.testimonial-details p {
  font-size: 16px;
  margin-bottom: 15px;
}
@media (max-width: 767.98px) {
  .testimonial-details p {
    font-size: 14px;
  }
}
.testimonial-details h6 {
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 0;
  color: #9ca3af;
}
.testimonial-details h6 span {
  font-weight: 500;
  font-size: 16px;
  color: #1f2937;
}

.testimonial-grid {
  margin: 0;
  padding: 0 60px;
}
@media (max-width: 767.98px) {
  .testimonial-grid {
    margin: 0;
    padding: 0 25px;
  }
}

.testimonial-slider .slick-prev,
.testimonial-slider .slick-next {
  width: 44px;
  height: 44px;
  font-size: 0;
  color: #1e3259;
  background: #ffffff;
  box-shadow: 0px 4px 14px rgba(141, 141, 141, 0.25);
}
.testimonial-slider .slick-prev:hover,
.testimonial-slider .slick-next:hover {
  color: #ffffff;
  background: #0e82fd;
}
.testimonial-slider .slick-prev:focus,
.testimonial-slider .slick-next:focus {
  color: #ffffff;
  background: #0e82fd;
  opacity: 1;
}
.testimonial-slider .slick-prev:before {
  font-family: "Font Awesome 5 Free";
  content: "\\f053";
  font-size: 16px;
  font-weight: 900;
}
.testimonial-slider .slick-next:before {
  font-family: "Font Awesome 5 Free";
  content: "\\f054";
  font-size: 16px;
  font-weight: 900;
}

.faq-section-inner {
  margin: 0;
  padding: 80px 0 80px;
}
@media (max-width: 1199.98px) {
  .faq-section-inner {
    margin: 0;
    padding: 80px 0 80px;
  }
}
@media (max-width: 991.98px) {
  .faq-section-inner {
    margin: 0;
    padding: 40px 0;
  }
}

.faq-inner-page {
  background-color: #ffffff;
  margin: 0;
  padding: 80px 0 55px;
}

.faq-inner-info .accordion-item {
  margin-bottom: 25px;
}
.faq-inner-info .accordion-item:last-child {
  margin-bottom: 25px;
}

.onboard-page {
  overflow: hidden;
}

.right-panel-title {
  background: #0c4f8a;
  padding: 10px;
  display: none;
}

.onboard-wrapper {
  overflow: hidden;
  height: 100vh;
  background: #ffffff;
}

.left-panel {
  background-color: #0c4f8a;
  width: 25%;
  padding: 45px;
  height: 100vh;
  overflow: auto;
  flex-direction: column;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.left-panel::-webkit-scrollbar {
  display: none;
}
@media (max-width: 991.98px) {
  .left-panel {
    display: none;
  }
}

.right-panel {
  width: 75%;
  height: 100vh;
  overflow: auto;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  flex-wrap: wrap;
}
.right-panel .select2-container .select2-selection--single {
  border: 1px solid #e6e9f4;
  height: 54px;
  background: #f5f6fa;
}
.right-panel .select2-container .select2-selection--single:focus {
  border-color: #09e5ab;
  background-color: #ffffff;
}
.right-panel .select2-container--default .select2-selection--single .select2-selection__rendered {
  font-size: 14px;
  font-weight: 400;
  font-weight: normal;
  line-height: 54px;
  color: #585858;
}
.right-panel .select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 54px;
  right: 7px;
}
.right-panel .accordion-item:first-of-type {
  margin-bottom: 16px;
  border-radius: 6px;
  overflow: hidden;
}
.right-panel .accordion-item:not(:first-of-type) {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  margin-bottom: 16px;
  border-radius: 6px;
  overflow: hidden;
}
.right-panel .accordion-button {
  padding: 20px;
}
.right-panel .accordion-button::after {
  transform: rotate(-90deg);
}
.right-panel .accordion-button:not(.collapsed)::after {
  transform: rotate(0deg);
}
.right-panel .accordion-button:focus {
  box-shadow: 8px 7px 14px -15px rgba(0, 0, 0, 0.4);
}
.right-panel .accordion-button:not(.collapsed) {
  background-color: #ffffff;
  color: #000000;
}
.right-panel .accordion-body {
  padding: 1rem 1rem;
}
@media (max-width: 991.98px) {
  .right-panel {
    width: 100%;
    height: auto;
    padding: 0px;
  }
}

.onboard-img {
  margin: auto;
  padding: 70px 0px 20px 0px;
  animation: mymove 1s ease-in-out infinite alternate;
  text-align: center;
  width: 240px;
}

.onboard-content h3 {
  color: #ffffff;
  font-weight: 600;
  font-size: 21px;
}
.onboard-content p {
  color: #ffffff;
  font-weight: 200;
  font-size: 13px;
}

.onboarding-slider {
  margin-top: 10px;
}

#onboard-slider .owl-dots {
  margin-top: 0px;
  justify-content: center;
}
#onboard-slider .owl-nav {
  display: none;
}
#onboard-slider.owl-theme .owl-dots .owl-dot span {
  background-color: #09e5ab;
  width: 15px;
  height: 6px;
  border-radius: 50px;
  transition: 0.5s all;
  margin: 5px 3px 0;
  display: block;
  position: relative;
}
#onboard-slider.owl-theme .owl-dots .owl-dot.active span {
  background-color: #ffffff;
  width: 50px;
  border-radius: 50px;
}

.on-board-wizard {
  position: sticky;
  top: 65px;
}
.on-board-wizard ul {
  list-style: none;
  padding: 0px;
}
.on-board-wizard ul li a {
  align-items: center;
  background: #ffffff;
  border: 1px solid #f4f4f4;
  box-shadow: 0px 4px 4px rgba(212, 237, 255, 0.25);
  border-radius: 4px;
  margin: 0 0 18px 0;
  padding: 13px 5px 13px 8px;
  transition: 0.1s ease-out;
}
.on-board-wizard ul li a:hover {
  box-shadow: 8px 7px 14px -15px rgba(0, 0, 0, 0.4);
}

.onboarding-list h6 {
  font-weight: 600;
  font-size: 16px;
  color: #000000;
}
.onboarding-list p {
  font-weight: 300;
  font-size: 13px;
  color: #585858;
  margin-bottom: 0px;
}

li:hover .onboarding-list h6 {
  color: #000000;
}

.onboarding-progress {
  margin-right: 20px;
  min-width: 35px;
  height: 35px;
  background: #f4f4f4;
  border-radius: 50px;
  justify-content: center;
  align-items: center;
  color: #000000;
}
.onboarding-progress.active {
  background: #10916f;
  color: #ffffff;
}
.onboarding-progress span {
  font-size: 13px;
}

.onboarding-title h2 {
  font-weight: 500;
  font-size: 24px;
  margin-bottom: 10px;
}
.onboarding-title h2 span {
  color: #ff0202;
}
.onboarding-title h6 {
  font-weight: 400;
  font-size: 15px;
  color: #585858;
  margin-bottom: 25px;
  line-height: 1.5;
}
.onboarding-title h6 span {
  font-weight: 600;
}
.onboarding-title.profile-title {
  margin-bottom: 35px;
}
.onboarding-title.pass-title {
  margin-bottom: 32px;
}

.onboarding-content-box {
  margin-top: 20px;
  margin: 20px 0 0 0;
  padding: 50px;
  background: #ffffff;
  box-shadow: 0px 24px 24px rgba(212, 237, 255, 0.3);
  border-radius: 4px;
  border: 1px solid #e6e9f4;
}
.onboarding-content-box.content-wrap {
  flex-direction: column;
  min-height: 580px;
}
.onboarding-content-box.lock-box {
  padding: 70px;
}

.onboarding-btn a {
  background: #09e5ab;
  border-radius: 6px;
  padding: 15px 50px;
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  display: inline-block;
  border: 1px solid #09e5ab;
  transition: all 0.5s;
}
.onboarding-btn a:hover {
  box-shadow: inset 0 60px 0 0 #10916f;
  border-color: #10916f;
}
.onboarding-btn.Personalize-btn {
  margin-top: 30px;
}
.onboarding-btn.Consultation-btn {
  margin-top: 70px;
}
.onboarding-btn.Consultation-btn a:nth-child(2) {
  background: #ffffff;
  border-radius: 6px;
  padding: 15px 50px;
  color: #0c4f8a;
  border: none;
}
.onboarding-btn.Consultation-btn a:nth-child(2):hover {
  box-shadow: none;
  color: #09e5ab;
}
.onboarding-btn.Consultation-btn.cost-btns {
  margin-top: 40px;
}
.onboarding-btn.prefer-btn {
  margin-top: 70px;
}
.onboarding-btn.pop-btn {
  margin-top: 4px;
}

.passcode-wrap input,
.passcode-wrap select,
.passcode-wrap textarea {
  background-color: #f5f6fa;
  border: 1px solid #e6e9f4;
  border-radius: 5px;
  width: 60px;
  height: 54px;
  text-align: center;
  color: #354052;
  font-size: 20px;
  font-weight: 500;
  margin-right: 23px;
}

.passcode-wrap input:focus {
  color: #354052;
  border-color: #09e5ab;
  background-color: #ffffff;
  outline: none;
}
.passcode-wrap.mail-box input {
  width: 100%;
  text-align: unset;
  font-size: 14px;
  height: 54px;
}
.passcode-wrap.mail-box select {
  width: 100%;
  text-align: unset;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #e6e9f4 !important;
  outline: none;
  color: #585858;
  padding: 0px 10px;
}
.passcode-wrap.mail-box textarea {
  width: 100%;
  height: 145px;
  text-align: unset;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #e6e9f4;
  outline: none;
  resize: none;
}
.passcode-wrap select:focus {
  color: #354052;
  border-color: #09e5ab !important;
  background-color: #ffffff;
  outline: none;
}
.passcode-wrap.form-focus.focused .focus-label {
  opacity: 1;
  top: -31px;
  font-size: 12px;
  z-index: 1;
  background: #ffffff;
  padding: 0px 5px;
  color: #5ec6cd;
  font-weight: 400;
}
.passcode-wrap.form-focus .focus-label {
  top: -4px;
  color: #585858;
}
.passcode-wrap textarea:focus {
  color: #354052;
  border-color: #09e5ab;
  background-color: #ffffff;
  outline: none;
}
.passcode-wrap.form-floating > label {
  color: #585858;
  font-size: 14px;
}

.mail-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_54___}) no-repeat 99% 50%;
}

.form-focus .focus-label span {
  color: #f0142f;
}

.placeholder-style::placeholder {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 14px;
  color: #585858;
  opacity: 1;
}
.placeholder-style:-ms-input-placeholder {
  color: #585858;
}
.placeholder-style::-ms-input-placeholder {
  color: #585858;
}

.onboarding-lable {
  font-family: "Poppins";
  font-weight: 500;
  font-size: 14px;
}
.onboarding-lable span {
  color: #ff0202;
}

.upload-pic {
  align-items: center;
  border-radius: 10px;
  height: 163px;
  width: 183px;
  position: relative;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  border: 1px dashed #8f9bba;
}
.upload-pic img {
  max-width: 100%;
  border-radius: 10px;
}
.upload-pic h6 {
  margin-top: 12px;
  font-weight: 500;
  font-size: 16px;
  color: #8f9bba;
}
.upload-pic.patient-photo-upload {
  align-items: center;
  border-radius: 10px;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  width: 265px;
  height: 235px;
  background: #f5f6fa;
  border: none;
}

.upload-pics input[type="file"] {
  opacity: 0;
  width: 40px;
  height: 63px;
  position: absolute;
  cursor: pointer;
  top: -15px;
  right: 8px;
  margin-right: 0px;
}

.photo-norms h5 {
  color: #8f9bba;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 35px;
}

.btn-profile img {
  height: 40px;
  width: 40px;
  position: absolute;
  top: 11px;
  right: 8px;
  cursor: pointer;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.tog-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f5f6fa;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.tog-slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  bottom: 4px;
  background-color: #008f64;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  top: 4px;
  left: 4px;
}
.tog-slider.round {
  border-radius: 30px;
  width: 56px;
  height: 28px;
  border: 2px solid #f3f3f3;
}
.tog-slider.round:before {
  border-radius: 50%;
}

input:checked + .tog-slider {
  background-color: #008f64;
}
input:checked + .tog-slider:before {
  -webkit-transform: translateX(32px);
  -ms-transform: translateX(32px);
  transform: translateX(32px);
  background: #ffffff;
  left: -1px;
}

.save-card {
  margin-left: 22px;
}
.save-card h5 {
  font-weight: 500;
  font-size: 14px;
}
.save-card h6 {
  font-weight: 400;
  font-size: 14px;
  color: #8f9bba;
}

.save-detail {
  padding: 25px 0 0;
}

.payment-icon {
  position: relative;
}
.payment-icon img {
  position: absolute;
  top: 250px;
}

.avail-content {
  margin-left: 15px;
  margin-top: 4px;
}
.avail-content h6 {
  color: #10916f;
}

.weekDays-selector input {
  display: none !important;
}
.weekDays-selector input[type="checkbox"] + label {
  display: inline-block;
  border-radius: 4px;
  background: #ffffff;
  padding: 8px 0px;
  width: 60px;
  margin-right: 3px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #e6e9f4;
  font-weight: 400;
  font-size: 20px;
}
.weekDays-selector input[type="checkbox"]:checked + label {
  background: #f5f6fa;
  color: #000000;
}

.consult-option {
  position: relative;
}

.call-option {
  position: relative;
  width: 33%;
  margin-right: 10px;
}
.call-option.file-option {
  margin-right: 0px;
  background: #f5f6fa;
  border-radius: 10px;
  border: 2px dashed #e6e9f4;
  width: 100%;
}
.call-option.verify-account {
  min-width: 242px;
}

.option-radio {
  appearance: none;
  display: none;
}
.option-radio:checked + .call-lable {
  box-shadow: 0 0 0 60px #0c4f8a inset;
  color: #ffffff;
}
.option-radio:checked + .call-lable img {
  filter: brightness(0) invert(1);
}

.call-lable {
  align-items: center;
  justify-content: center;
  position: relative;
  transition-duration: 0.5s;
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  min-height: 75px;
  text-align: center;
  border: 1px solid #e6e9f4;
  cursor: pointer;
}
.call-lable img {
  margin-right: 6px;
  margin-bottom: 5px;
}
.call-lable.verify-lable.verify-lable {
  width: 100%;
  height: 170px;
  font-size: 14px;
  font-weight: 400;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.call-lable.verify-lable.verify-options {
  height: 105px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0px;
  border-radius: 5px;
}

.accordion-body .onboarding-title h2 {
  font-size: 16px;
}
.accordion-body .onboarding-title h6 {
  font-size: 14px;
}

.prefer-box {
  border-radius: 4px;
  box-shadow: 0px 4px 24px rgba(227, 227, 227, 0.25);
  width: 100%;
  padding: 36px;
  color: #000000;
  font-size: 16px;
  font-weight: 400;
  border: 1px solid #e6e9f4;
}
.prefer-box .right-sec i {
  font-size: 16px;
  color: #433489;
}
.prefer-box:hover {
  box-shadow: 0px 0px 10px 3px rgb(212, 237, 255);
}

.verify-item {
  margin-bottom: 15px;
  font-size: 14px;
  line-height: 1.8;
}
.verify-item::marker {
  color: #0c4f8a;
  font-size: 120%;
}

.verify-list {
  padding: 0 0 0 20px;
  margin-bottom: 0px;
}
.verify-list li:last-child {
  margin-bottom: 0px;
}

.upload-sucess-note h6 {
  color: #10906f;
  font-weight: 400;
  font-size: 16px;
}
.upload-sucess-note h6:nth-child(2) {
  color: #3e45eb;
  font-weight: 400;
  font-size: 16px;
  margin-top: 18px;
}
.upload-sucess-note h6:nth-child(2) i {
  margin-left: 4px;
  cursor: pointer;
}

.verify-box {
  background: #fafdff;
  padding: 16px;
}

.modal-content.id-pop-content {
  border-radius: 10px;
}

.modal-header.id-pop-header {
  border-bottom: none;
  padding: 2rem 1rem 1rem 1rem;
}

.modal-footer.id-pop-footer {
  border-top: none;
  padding: 0.75rem 0rem 2rem 0rem;
}

.modal-body.id-pop-body {
  padding: 1rem 3rem;
}
.modal-body.id-pop-body h2 {
  font-weight: 500;
  font-size: 28px;
  margin-bottom: 14px;
}
.modal-body.id-pop-body p {
  font-weight: 400;
  font-size: 15px;
  color: #585858;
}
.modal-body.id-pop-body h3 {
  font-weight: 500;
  font-size: 20px;
}
.modal-body.id-pop-body span {
  font-weight: 500;
  font-size: 20px;
  color: #228fe0;
  padding-bottom: 30px;
  display: block;
}

.modal.show .modal-dialog.id-upload {
  max-width: 600px;
}

.fade.fade-custom {
  background: rgba(0, 0, 0, 0.8);
}

.set-path {
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
}

.lock-content img {
  margin-bottom: 20px;
}
.lock-content h2 {
  font-weight: 500;
  font-size: 24px;
}
.lock-content h6 {
  margin: 15px 0px 30px 0px;
  font-weight: 400;
  font-size: 16px;
  color: #585858;
}
.lock-content a {
  color: #ff0202;
  font-weight: 600;
  font-size: 16px;
}
.lock-content a:hover {
  color: #000000;
}

.mail-icon2 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_55___}) no-repeat 99% 50%;
}

.pass-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_56___}) no-repeat 99% 50%;
}

.pass-icon-1 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_57___}) no-repeat 99% 50%;
}

.form-group.pass-group {
  margin-bottom: 2rem;
}

.method-btn a {
  color: #0c4f8a;
  font-weight: 500;
  font-size: 14px;
}
.method-btn a:hover {
  color: #09e5ab;
}

.code-title {
  background: rgba(76, 218, 180, 0.1);
  border-radius: 4px;
  margin: 30px 0px;
  padding: 12px 15px;
}
.code-title h6 {
  color: #10916f;
  font-weight: 400;
  font-size: 15px;
  margin-bottom: 0px;
}

.opt-resend {
  padding-top: 30px;
  position: relative;
}
.opt-resend a {
  font-weight: 500;
  font-size: 16px;
  position: absolute;
  left: 0px;
}

.upload-patient-btn {
  position: relative;
  margin-bottom: 15px;
}
.upload-patient-btn:hover .pic-upload-btn {
  color: #09e5ab;
}

#patient-verified .modal-body.id-pop-body p {
  font-size: 16px;
  max-width: 280px;
  margin: auto;
}

.upload-patient-pic {
  padding: 10px 0px 30px 0px;
}
.upload-patient-pic input[type="file"] {
  opacity: 0;
  max-width: 468px;
  min-height: 60px;
  cursor: pointer;
  top: 0px;
  left: 87px;
  position: absolute;
}

.pic-upload-btn {
  margin: auto;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #f4f4f4;
  box-shadow: 0px 4px 10px rgba(225, 225, 225, 0.25);
  border-radius: 5px;
  cursor: pointer;
  display: block;
  max-width: 475px;
  text-align: center;
  z-index: 99999;
}

.onboarding-contents {
  justify-content: center;
}

.uploads-report {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.uploads-report a:nth-child(1) {
  margin-bottom: 20px;
}

.select-gender-option [type="radio"]:checked,
.select-gender-option [type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}

.select-gender-option [type="radio"]:checked + label,
.select-gender-col [type="radio"]:not(:checked) + label {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.select-gender-option label {
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(194, 194, 194, 0.25);
  border-radius: 5px;
  padding: 28px;
  width: 100%;
  text-align: center;
  position: relative;
}
.select-gender-option [type="radio"]:not(:checked) + label:after {
  opacity: 0;
}

.select-gender-option [type="radio"]:checked + label:after,
.select-gender-option [type="radio"]:not(:checked) + label:after {
  content: "";
  width: 100%;
  height: 100%;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(212, 237, 255, 0.25);
  border: 2px solid #228fe0;
  box-shadow: 0px 4px 24px rgba(34, 143, 224, 0.04);
  border-radius: 5px;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  border: 2px solid #0de0fe;
}

.login-header .form-focus .focus-label {
  top: -6px;
  color: #585858;
}

.relative-form {
  position: relative;
  background: #f5f6fa;
  border: 1px solid #e6e9f4;
  border-radius: 5px;
  min-height: 54px;
  padding: 6px 15px;
  align-items: center;
}
.relative-form span {
  color: #131523;
}
.relative-form .form-control::placeholder {
  color: #131523;
  font-weight: 400;
  font-size: 14px;
}
.relative-form .btn {
  border-radius: 6px;
  padding: 5px 15px;
  position: absolute;
  top: 7px;
  right: 7px;
}

.relative-file-upload {
  color: #000;
  padding: 11px 35px;
  font-size: 14px;
  margin-bottom: 0;
  cursor: pointer;
  position: absolute;
  right: 4px;
  -webkit-transition: 0.7s;
  -moz-transition: 0.7s;
  -o-transition: 0.7s;
  transition: 0.7s;
  background: #eeeeee;
  border-radius: 4px;
}
.relative-file-upload:hover {
  color: #ffffff;
  background: #bdb8b8;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
}
.relative-file-upload input[type="file"] {
  position: absolute;
  top: 0;
  right: 0;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  background: #ffffff;
  cursor: inherit;
  display: block;
}

.onboarding-content .checklist-col .custom_check .checkmark {
  width: 35px;
}
.onboarding-content .checklist-col .custom_check .checkmark:after {
  left: 10px;
  top: 3px;
}
.onboarding-content .checklist-col.pregnant-col .remember-me-col .custom_check .checkmark {
  border-color: #228fe0;
}
.onboarding-content .checklist-col .remember-me-col {
  border-bottom: 1px solid #f4f4f4;
}
.onboarding-content .custom_check .checkmark {
  left: -10px;
}
.onboarding-content .custom_check .checkmark::after {
  color: #ffffff;
}
.onboarding-content .custom_check input:checked ~ .checkmark {
  background-color: #228fe0;
}
.onboarding-content .increment-decrement .input-groups input[type="button"] {
  background-color: transparent;
  font-size: 20px;
  border: 1px solid #228fe0;
  border-radius: 4px;
  height: 24px;
  width: 35px;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  margin-top: 0px;
  line-height: 0;
  padding: 0px;
  color: #228fe0;
}

.modal-footer.id-pop-footer.text-center {
  justify-content: center;
}

@keyframes mymove {
  to {
    transform: translateY(-5px);
  }
}
@media (max-width: 991.98px) {
  .right-panel-title {
    display: block;
  }
  .right-panel-title img {
    max-width: 140px;
  }
  .onboarding-content-box.content-wrap {
    min-height: auto;
  }
  .onboarding-list h6 {
    font-size: 15px;
  }
  .onboarding-list p {
    font-size: 13px;
  }
  .onboarding-progress span {
    font-size: 12px;
  }
  .onboarding-title h2 {
    font-weight: 450;
    font-size: 22px;
  }
  .onboarding-title h6 {
    font-size: 14px;
  }
  .onboarding-lable {
    font-size: 13px;
  }
  .passcode-wrap.mail-box input {
    font-size: 14px;
    height: 50px;
  }
  .passcode-wrap.mail-box textarea {
    height: 100px;
  }
  .passcode-wrap.form-focus .focus-label {
    top: -8px;
  }
  .passcode-wrap input {
    width: 77px;
    height: 50px;
    font-size: 24px;
    font-weight: 400;
  }
  .right-panel .select2-container .select2-selection--single {
    height: 50px;
  }
  .right-panel .select2-container--default .select2-selection--single .select2-selection__rendered {
    line-height: 50px;
  }
  .right-panel .select2-container--default .select2-selection--single .select2-selection__arrow {
    height: 50px;
  }
  .onboarding-btn {
    margin-top: 75px;
  }
  .onboarding-btn a {
    padding: 13px 45px;
    font-size: 14px;
  }
  .onboarding-btn.step-2-btn {
    margin-top: 50px;
  }
  .onboarding-btn.Consultation-btn.cost-btns {
    margin-top: 10px;
  }
  .onboarding-content-box {
    margin-top: 0px;
    padding: 30px;
  }
  .method-btn a {
    font-size: 12px;
  }
  .code-title {
    padding: 10px 12px;
    margin: 22px 0px;
  }
  .code-title h6 {
    font-size: 14px;
  }
  .weekDays-selector input[type="checkbox"] + label {
    font-size: 16px;
    padding: 14px 22px;
  }
  .onboard-wrapper {
    height: auto;
  }
  .modal.show .modal-dialog.id-upload {
    max-width: 400px;
  }
  .modal-header.id-pop-header {
    padding: 5px;
  }
  .modal-body.id-pop-body {
    padding: 5px;
  }
  .modal-body.id-pop-body h2 {
    font-size: 20px;
  }
  .modal-body.id-pop-body p {
    font-size: 12px;
  }
  .modal-footer.id-pop-footer {
    border-top: none;
    padding: 2px 0px 5px 0px;
  }
  .call-lable {
    font-size: 14px;
    width: 172px;
  }
  .call-lable.verify-lable.verify-lable {
    height: 120px;
  }
  .upload-sucess-note h6 {
    font-size: 14px;
  }
  .upload-sucess-note h6:nth-child(2) {
    font-size: 14px;
  }
  .payment-icon img {
    top: -168px;
    right: 10px;
  }
  .tog-slider:before {
    height: 12px;
    width: 12px;
  }
  .tog-slider.round {
    width: 50px;
    height: 22px;
  }
  .save-card h6 {
    font-size: 13px;
    margin-bottom: 0px;
  }
  .prefer-box {
    padding: 24px;
    font-size: 14px;
  }
  .call-option {
    width: max-content;
  }
  .onboard-page {
    overflow: auto;
  }
  .on-board-wizard {
    padding-top: 25px;
    top: 50px;
  }
}
@media (max-width: 575.98px) {
  .onboarding-progress span {
    font-size: 13px;
  }
  .onboarding-title {
    text-align: center;
  }
  .onboarding-title h2 {
    font-weight: 500;
    font-size: 18px;
  }
  .onboarding-title h6 {
    font-size: 14px;
  }
  .verify-box {
    padding: 5px;
  }
  .verify-item {
    font-size: 14px;
    margin-bottom: 2px;
  }
  .onboarding-content-box {
    padding: 20px;
  }
  .btn-profile img {
    height: 30px;
    width: 30px;
  }
  .upload-pic {
    height: 100px;
    width: 120px;
  }
  .upload-pic h6 {
    font-size: 14px;
  }
  .passcode-wrap.mail-box input {
    font-size: 10px;
    height: 40px;
  }
  .passcode-wrap.mail-box textarea {
    height: 90px;
  }
  .passcode-wrap.form-focus .focus-label {
    top: -9px;
  }
  .passcode-wrap input {
    width: 48px;
    height: 43px;
    font-size: 19px;
    font-weight: 400;
  }
  .onboarding-btn {
    margin-top: 10px;
    text-align: center;
  }
  .onboarding-btn.Personalize-btn {
    margin-top: 15px;
    text-align: center;
  }
  .onboarding-btn a {
    padding: 10px 30px;
    font-size: 14px;
    margin-top: 15px;
  }
  .onboarding-btn.step-2-btn {
    margin-top: 25px;
  }
  .onboarding-btn.prefer-btn {
    margin-top: 10px;
  }
  .onboarding-btn.Consultation-btn {
    margin-top: 15px;
  }
  .on-board-wizard {
    padding-left: 0px;
  }
  .right-panel .select2-container .select2-selection--single {
    height: 43px;
  }
  .right-panel .select2-container--default .select2-selection--single .select2-selection__rendered {
    line-height: 40px;
    font-size: 14px;
  }
  .right-panel .select2-container--default .select2-selection--single .select2-selection__arrow {
    height: 42px;
  }
  .right-panel .accordion-button {
    padding: 20px;
  }
  .select2-results__option[aria-selected] {
    font-size: 11px;
  }
  .consult-option {
    flex-direction: column;
    align-items: center;
  }
  .call-option {
    margin-bottom: 20px;
    margin-right: 0px;
  }
  .call-lable {
    font-size: 14px;
  }
  .call-lable.verify-lable.verify-options {
    width: 253px;
    height: 118px;
  }
  .call-lable.verify-lable.verify-lable {
    height: 100px;
  }
  .code-title {
    margin: 10px 0px;
  }
  .code-title h6 {
    font-size: 12px;
  }
  .weekDays-selector input[type="checkbox"] + label {
    padding: 12px 22px;
    font-size: 14px;
  }
  .modal-body.id-pop-body h2 {
    font-size: 18px;
  }
  .modal-body.id-pop-body p {
    font-size: 14px;
    margin-bottom: 0px;
  }
  .modal-body.id-pop-body span {
    font-size: 18px;
    padding-bottom: 10px;
  }
  .upload-pics input[type="file"] {
    height: 60px;
  }
  .photo-norms h5 {
    margin-bottom: 0px;
  }
  .upload-sucess-note h6 {
    font-size: 13px;
  }
  .payment-icon img {
    top: -210px;
  }
  .prefer-box {
    padding: 12px;
    font-size: 14px;
  }
  .relative-file-upload {
    padding: 9px 10px;
  }
  .opt-resend {
    padding-top: 12px;
    padding-bottom: 30px;
  }
  .opt-resend a {
    font-size: 14px;
    left: auto;
    left: 0px;
  }
  .select-gender-option {
    flex-direction: column;
  }
}
.signup-option-btns .signup-btn-info {
  width: 100%;
  background: #f5f5f5;
  border: 1px solid #e4e4e8;
  border-radius: 8px;
  margin: 0;
  padding: 12px 15px;
  margin-bottom: 20px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.signup-option-btns .signup-btn-info:hover {
  background: #ffffff;
  border: 1px solid #0e82fd;
  box-shadow: 0px 22px 38px rgba(0, 0, 0, 0.12);
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.signup-option-btns .signup-btn-info:hover .signup-arrow {
  background: #0e82fd;
  color: #ffffff;
  -webkit-transition: 0.4s;
  -ms-transition: 0.4s;
  transition: 0.4s;
}
.signup-option-btns .signup-btn-info:last-child {
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .signup-option-btns .signup-btn-info {
    margin: 0;
    padding: 10px;
    margin-bottom: 20px;
  }
}

.signup-info .signup-icon {
  margin-right: 16px;
}

.signup-content {
  text-align: left;
}
.signup-content h4 {
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 6px;
}
@media (max-width: 991.98px) {
  .signup-content h4 {
    font-size: 18px;
  }
}
.signup-content p {
  color: #71717a;
  margin-bottom: 0;
  font-size: 14px;
}

.signup-arrow {
  width: 37px;
  height: 37px;
  background: #ffffff;
  color: #000000;
  font-size: 16px;
  border-radius: 50px;
  -webkit-transition: 0.4s;
  -ms-transition: 0.4s;
  transition: 0.4s;
}

.terms-check-box label {
  color: #838383;
}
.terms-check-box label a {
  color: #525252;
  text-decoration: underline;
}
.terms-check-box label a:hover {
  color: #0e82fd;
}

.account-signup {
  text-align: center;
}
.account-signup p {
  color: #696969;
  margin-bottom: 0;
}
.account-signup p a {
  font-size: 14px;
  font-weight: 500;
  color: #0e82fd;
  text-decoration: underline;
}
.account-signup p a:hover {
  color: #0e82fd;
  text-decoration: none;
}

.login-verify-img {
  padding-bottom: 50px;
}
@media (max-width: 991.98px) {
  .login-verify-img {
    padding-bottom: 30px;
  }
}
@media (max-width: 767.98px) {
  .login-verify-img {
    padding-bottom: 20px;
  }
}

.otp-box .form-group {
  margin-bottom: 30px;
}
@media (max-width: 767.98px) {
  .otp-box .form-group {
    margin-bottom: 20px;
  }
}
.otp-box input {
  width: 74px;
  height: 74px;
  background: #f9f9f9;
  border: 2px solid #acacac;
  border-radius: 8px;
  text-align: center;
  margin-right: 15px;
  font-weight: 700;
  font-size: 26px;
  color: #000000;
  outline: none;
}
.otp-box input:last-child {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .otp-box input {
    width: 68px;
    height: 68px;
  }
}
@media (max-width: 767.98px) {
  .otp-box input {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
}

.otp-info {
  padding-bottom: 20px;
}
@media (max-width: 767.98px) {
  .otp-info {
    padding-bottom: 0;
  }
}

.otp-code p {
  color: #5b5b5b;
  margin-bottom: 8px;
}
.otp-code a {
  font-weight: 500;
  color: #0e82fd;
  text-decoration: underline;
}
.otp-code a:hover {
  text-decoration: none;
}

.otp-sec p {
  background: #f9f9f9;
  border-radius: 4px;
  color: #717171;
  padding: 4px 7px;
}
.otp-sec p i {
  font-size: 16px;
  margin-right: 6px;
}

.forgot-link {
  font-weight: 500;
  color: #0e82fd;
  margin-bottom: 10px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.forgot-link:hover {
  color: #000000;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}

.signup-code {
  font-size: 11px;
  color: #9e9e9e;
  margin: 7px 0 0 0;
  padding: 0;
}

.multistep-form #first {
  display: block;
}
.multistep-form fieldset {
  display: none;
  width: 100%;
}

.widget-setcount {
  padding-bottom: 40px;
}
.widget-setcount ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.widget-setcount ul li {
  margin-right: 0;
  margin-bottom: 10px;
  position: relative;
}
.widget-setcount ul li:last-child {
  margin-right: 0;
}
.widget-setcount ul li:last-child:before {
  display: none;
}
.widget-setcount ul li:before {
  position: absolute;
  top: 50%;
  right: -66px;
  content: "";
  width: 50px;
  height: 2px;
  background: #e0e0e0;
}
.widget-setcount ul .progress-activated:before {
  background: #0e82fd;
}
.widget-setcount .step-icon {
  width: 45px;
  height: 45px;
  background: #c9e3fe;
  border-radius: 50px;
  margin-right: 15px;
}
.widget-setcount .step-content p {
  color: #e0e0e0;
  margin-bottom: 5px;
}
.widget-setcount .step-content h4 {
  font-weight: 500;
  font-size: 16px;
  color: #e0e0e0;
  margin-bottom: 0;
}
.widget-setcount .progress-activated .step-icon {
  background: #0e82fd;
}
.widget-setcount .progress-activated .step-content p {
  color: #858585;
}
.widget-setcount .progress-activated .step-content h4 {
  color: #000000;
}
.widget-setcount .progress-active .step-icon {
  background: #0e82fd;
}
.widget-setcount .progress-active .step-content p {
  color: #858585;
}
.widget-setcount .progress-active .step-content h4 {
  color: #000000;
}

.form-check-box .custom_check {
  margin-bottom: 0;
}

.form-check-box .custom_check .checkmark::after {
  content: "";
  background: #0e82fd;
  width: 12px;
  height: 12px;
  top: 3px;
  left: 3px;
  border-radius: 3px;
}

/*.custom_check {
	color: \$__congo_brown;
	display: \$__inline__block;
	position: \$__relative;
	font-size: \$__font__size__14;
	padding-left: 30px;
	margin-bottom: 10px;
	cursor: \$__pointer;
	user-select: \$__none
}
.custom_check input {
	position: \$__absolute;
	opacity: 0;
	cursor: \$__pointer;
}
.custom_check input:checked ~ .checkmark {
	background-color: \$__white;
	border-color: \$__misty_rose;
}
.custom_check .checkmark {
	@include position(\$__absolute, 0, null, null, 0);
	height: 20px;
	width: 20px;
	border: 1px solid \$__white_shade;
	background-color: \$__white;
	border-radius: 3px;
	@include transition(all 0.3s ease-in-out);
}
.custom_check .checkmark::after {
    content: "\\f00c";
    font-family: \$__fontawesome__family;
    font-weight: \$__bolder;
	@include position(\$__absolute, 50%, null, null, 4px);
    display: \$__none;
    color: \$__blue__14;
    font-size: \$__font__size__12;
}
.custom_check input:checked ~ .checkmark:after {
	display: \$__block;
}
*/
.contact-section {
  margin: 0;
  padding: 80px 0 55px;
}
@media (max-width: 991.98px) {
  .contact-section {
    margin: 0;
    padding: 40px 0 15px;
  }
}
@media (max-width: 767.98px) {
  .contact-section {
    margin: 0;
    padding: 40px 0 20px;
  }
}

.contact-inner-header {
  margin-bottom: 40px;
}
@media (max-width: 767.98px) {
  .contact-inner-header {
    margin-bottom: 30px;
  }
}

.contact-card {
  border: 2px solid #e9eaf6;
  border-radius: 0;
}
.contact-card .card-body {
  margin: 0;
  padding: 30px;
}
@media (max-width: 991.98px) {
  .contact-card .card-body {
    margin: 0;
    padding: 20px;
  }
}
@media (max-width: 767.98px) {
  .contact-card .card-body {
    margin: 0;
    padding: 15px;
  }
}

.contact-icon {
  color: #0e82fd;
  font-size: 44px;
  margin-right: 20px;
}
@media (max-width: 991.98px) {
  .contact-icon {
    font-size: 40px;
    margin-right: 15px;
  }
}

.contact-details h4 {
  font-weight: 600;
  font-size: 20px;
  color: #0a0b0d;
  margin-bottom: 8px;
}
@media (max-width: 991.98px) {
  .contact-details h4 {
    font-size: 18px;
  }
}
.contact-details p {
  font-size: 16px;
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .contact-details p {
    font-size: 14px;
  }
}

.contact-form-card {
  background: #f8fbff;
  border-radius: 10px;
  border: 0;
}
.contact-form-card .card-body {
  margin: 0;
  padding: 30px;
}
@media (max-width: 991.98px) {
  .contact-form-card .card-body {
    margin: 0;
    padding: 20px;
  }
}
@media (max-width: 767.98px) {
  .contact-form-card .card-body {
    margin: 0;
    padding: 15px;
  }
}
.contact-form-card .form-group {
  margin-bottom: 25px;
}
.contact-form-card .form-group label {
  font-size: 12px;
  color: #0a0b0d;
  margin-bottom: 8px;
}
.contact-form-card .form-group .form-control {
  font-weight: 500;
  color: #6b7280;
}
.contact-form-card .form-group .form-control::placeholder {
  font-weight: 500;
  color: #6b7280;
}
.contact-form-card .form-group textarea.form-control {
  min-height: 150px;
  resize: none;
}
.contact-form-card .form-group-btn {
  margin-top: 35px;
}
.contact-form-card .form-group-btn .btn {
  border-radius: 5px;
  min-width: 150px;
  margin: 0;
  padding: 10px 15px;
  font-weight: 500;
}

.contact-map iframe {
  width: 100%;
  border: none;
  height: 450px;
}

.error-section {
  margin: 0;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .error-section {
    margin: 0;
    padding: 40px 0;
  }
}

.error-img {
  padding-bottom: 50px;
}
@media (max-width: 767.98px) {
  .error-img {
    padding-bottom: 25px;
  }
}

.error-404-img {
  position: relative;
}

.error-404-content {
  width: 100%;
  position: absolute;
  bottom: 30px;
}
@media (max-width: 1399.98px) {
  .error-404-content {
    bottom: 0;
  }
}
@media (max-width: 767.98px) {
  .error-404-content {
    position: static;
    margin-top: 20px;
  }
}

.error-content h2 {
  font-weight: 600;
  font-size: 38px;
  color: #0a0b0d;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .error-content h2 {
    font-size: 32px;
  }
}
@media (max-width: 767.98px) {
  .error-content h2 {
    font-size: 22px;
  }
}
.error-content p {
  font-weight: 500;
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 40px;
}
@media (max-width: 767.98px) {
  .error-content p {
    font-size: 14px;
    margin-bottom: 20px;
  }
}
.error-content .btn {
  min-width: 246px;
  font-size: 18px;
  display: inline-block;
  margin: 0;
  padding: 13px 15px;
}
@media (max-width: 991.98px) {
  .error-content .btn {
    min-width: 230px;
    font-size: 16px;
    margin: 0;
    padding: 10px 15px;
  }
}
@media (max-width: 767.98px) {
  .error-content .btn {
    min-width: 150px;
    font-size: 14px;
    margin: 0;
    padding: 8px 15px;
  }
}

.coming-soon-count {
  width: 104px;
  height: 104px;
  margin: 0 16px 0 0;
  padding: 13px;
  border-radius: 50px;
  background: #0ce0ff;
  flex-shrink: 0;
}
.coming-soon-count:last-child {
  margin-right: 0;
}
.coming-soon-count h4 {
  font-weight: 600;
  font-size: 40px;
  color: #ffffff;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .coming-soon-count h4 {
    font-size: 20px;
  }
}
.coming-soon-count p {
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .coming-soon-count p {
    font-size: 13px;
  }
}
@media (max-width: 767.98px) {
  .coming-soon-count {
    width: 66px;
    height: 66px;
    margin: 0 10px 0 0;
    padding: 8px;
  }
}

.terms-section {
  margin: 0;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .terms-section {
    margin: 0;
    padding: 40px 0;
  }
}
.terms-section .terms-content {
  padding-bottom: 50px;
}
.terms-section .terms-content .terms-text {
  padding-bottom: 24px;
}
.terms-section .terms-content .terms-text:last-child {
  padding-bottom: 0;
}
.terms-section .terms-content .terms-text p {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 24px;
}
.terms-section .terms-content .terms-text p:last-child {
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .terms-section .terms-content .terms-text p {
    font-size: 14px;
    margin-bottom: 20px;
  }
}
.terms-section .terms-content .terms-text.terms-list p {
  margin-bottom: 10px;
}
.terms-section .terms-content .terms-text.terms-list p i {
  position: relative;
  top: 4px;
  margin-right: 8px;
  color: #0e82fd;
}
@media (max-width: 991.98px) {
  .terms-section .terms-content {
    padding-bottom: 30px;
  }
}

.terms-btn .btn-right-now {
  font-weight: 500;
  font-size: 16px;
  margin: 0 15px 0 0;
  padding: 5px 15px;
  min-width: 149px;
  border-radius: 8px;
  color: #3f3f3f;
  background: #f3f3f3;
  border: 1px solid #f3f3f3;
  box-shadow: inset 0 0 0 0 #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.terms-btn .btn-right-now:hover {
  color: #ffffff;
  background: #0e82fd;
  border-color: #0e82fd;
  box-shadow: inset 0 0 0 50px #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
@media (max-width: 767.98px) {
  .terms-btn .btn-right-now {
    font-size: 14px;
    min-width: 130px;
    margin-right: 0;
  }
}
.terms-btn .btn-primary {
  padding: 5px 15px;
  min-width: 166px;
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .terms-btn .btn-primary {
    min-width: 150px;
  }
}
@media (max-width: 767.98px) {
  .terms-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.consultation-info {
  padding-bottom: 25px;
}
.consultation-info p {
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  margin-bottom: 20px;
}
@media (max-width: 991.98px) {
  .consultation-info p {
    margin-bottom: 15px;
  }
}

.consultation-list ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.consultation-list ul li {
  display: block;
  margin-bottom: 15px;
}
.consultation-list ul li:last-child {
  margin-bottom: 0;
}

.consultation-types a {
  font-weight: 500;
  font-size: 16px;
  color: #6b6b6b;
  background: #ffffff;
  border: 1px solid #c2c2c2;
  border-radius: 6px;
  min-width: 413px;
  margin: 0;
  padding: 10px 15px;
}
.consultation-types a:hover {
  color: #0e82fd;
  background: #ffffff;
  border: 1px solid #0e82fd;
}
.consultation-types a i {
  font-size: 18px;
  margin-right: 10px;
}
@media (max-width: 991.98px) {
  .consultation-types a {
    min-width: 300px;
  }
}
@media (max-width: 767.98px) {
  .consultation-types a {
    font-size: 14px;
    min-width: 250px;
    margin: 0;
    padding: 7px 15px;
  }
}
.consultation-types span {
  margin-left: 18px;
  font-size: 20px;
  color: #28a745;
  display: none;
}
.consultation-types.active a {
  color: #0e82fd;
  background: #ffffff;
  border: 1px solid #0e82fd;
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.07);
}
.consultation-types.active span {
  display: block;
}

.booking-device-img {
  margin-right: 15px;
}

.booking-doctor-info h3 {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 5px;
}
.booking-doctor-info .device-text {
  margin-bottom: 12px;
}
.booking-doctor-info .btn {
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  padding: 4px 10px;
  min-width: 109px;
  color: #0e82fd;
  background: #ffffff;
  border: 2px solid #0e82fd;
  box-shadow: inset 0 0 0 0 #0e82fd;
  border-radius: 6px;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.booking-doctor-info .btn:hover {
  color: #ffffff;
  background: #0e82fd;
  box-shadow: inset 0 0 0 50px #0e82fd;
  border: 2px solid #0e82fd;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}

.app-images a {
  margin-right: 8px;
}
.app-images a:last-child {
  margin-right: 0;
}

.booking-date {
  padding-bottom: 30px;
}
.booking-date p {
  color: #8c8c8c;
  margin: 0 10px 0 0;
  padding: 0;
  margin-right: 10px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .booking-date p {
    margin: 0 0 10px 0;
    padding: 0;
  }
}
@media (max-width: 767.98px) {
  .booking-date {
    display: block;
    padding-bottom: 20px;
  }
}

@media (max-width: 767.98px) {
  .time-slot-card-body {
    padding-bottom: 0 !important;
  }
}

.booking-range .btn {
  background: #ffffff;
  border: 1px solid #e4e4e8;
  border-radius: 6px;
  font-size: 14px;
  font-weight: normal;
  color: #4a4a4a;
  margin: 0;
  padding: 10px 15px;
}
@media (max-width: 767.98px) {
  .booking-range .btn {
    font-size: 13px;
    margin: 0;
    padding: 10px;
    position: relative;
  }
}
.booking-range img {
  margin-right: 10px;
}
.booking-range i {
  font-size: 16px;
  margin-left: 10px;
  color: #5b5b5b;
}

.booking-card {
  border: 2px solid #f4f4f4;
  border-radius: 8px;
  margin-bottom: 25px;
}

.booking-date-slider {
  padding-bottom: 30px;
}

.date-slider {
  text-align: center;
  list-style: none;
  margin: 0;
  padding: 0;
}
.date-slider .slick-slide {
  display: block;
  margin: 0;
  padding: 0 5px;
}
.date-slider li h4 {
  font-weight: 500;
  font-size: 16px;
  color: #b9b9b9;
  margin-bottom: 5px;
}
@media (max-width: 1199.98px) {
  .date-slider li h4 {
    font-size: 13px;
  }
}
@media (max-width: 991.98px) {
  .date-slider li h4 {
    font-size: 16px;
  }
}
.date-slider li p {
  color: #d4d4d4;
  margin-bottom: 0;
}
.date-slider li.active h4 {
  color: #000000;
}
.date-slider li.active p {
  color: #aaaaaa;
}
.date-slider .slick-prev:before {
  content: " \\e92f";
}
.date-slider .slick-next:before {
  content: " \\e930";
}

.date-slider .slick-prev,
.date-slider .slick-next {
  background: transparent;
  color: #000000;
  line-height: normal;
}

.date-slider .slick-prev:hover,
.date-slider .slick-prev:focus,
.date-slider .slick-next:hover,
.date-slider .slick-next:focus {
  background-color: transparent;
  color: #09e5ab;
  opacity: 1;
}

.date-slider .slick-prev:hover:before,
.date-slider .slick-prev:focus:before,
.date-slider .slick-next:hover:before,
.date-slider .slick-next:focus:before {
  color: #09e5ab;
}

.date-slider .slick-prev:before,
.date-slider .slick-next:before {
  font-family: "feather";
  font-size: 26px;
}

.time-slot {
  text-align: center;
}
.time-slot h4 {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 20px;
}
.time-slot ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.time-slot ul li {
  display: block;
  margin-bottom: 15px;
}
.time-slot li:last-child {
  margin-bottom: 0;
}
.time-slot li .timing {
  background: #f5f5f5;
  border: 2px solid #f3f3f3;
  border-radius: 8px;
  color: #595959;
  margin: 0;
  padding: 10px 15px;
  text-align: center;
  position: relative;
  box-shadow: inset 0 0 0 0 #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.time-slot li .timing:hover {
  background: #ffffff;
  box-shadow: inset 0 0 0 50px #ffffff;
  -webkit-transition: 0.7s;
  -ms-transition: 0.7s;
  transition: 0.7s;
}
.time-slot li .timing.active {
  background: #09e5ab;
  border: 2px solid #09e5ab;
  color: #ffffff;
  box-shadow: inset 0 0 0 0 #09e5ab;
}
.time-slot li .timing.active:hover {
  background: #09e5ab;
  border: 2px solid #09e5ab;
  color: #ffffff;
  box-shadow: inset 0 0 0 50px #09e5ab;
}
.time-slot li .timing i {
  margin-right: 4px;
}
.time-slot li .load-more-timings a {
  font-weight: 500;
  text-decoration: underline;
  color: #09e5ab;
}
.time-slot li .load-more-timings a:hover {
  color: #000000;
}
.time-slot .time-slot-open {
  display: none;
}
@media (max-width: 991.98px) {
  .time-slot {
    padding-bottom: 15px;
  }
}

.success-content {
  text-align: center;
  padding-bottom: 40px;
}
.success-content h4 {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .success-content h4 {
    font-size: 16px;
  }
}
@media (max-width: 991.98px) {
  .success-content {
    padding-bottom: 30px;
  }
}

.success-icon {
  padding-bottom: 15px;
}
.success-icon i {
  font-size: 50px;
  color: #28a745;
}
@media (max-width: 991.98px) {
  .success-icon i {
    font-size: 36px;
  }
}

.booking-success-info {
  padding-bottom: 20px;
}
.booking-success-info .booking-doctor-img {
  width: 90px;
  height: 90px;
  border-radius: 10px;
  margin-right: 15px;
}
.booking-success-info .booking-doctor-img img {
  width: 90px;
  height: 90px;
  border-radius: 10px;
}
.booking-success-info .booking-doctor-info p {
  margin-bottom: 15px;
}

.success-btn {
  text-align: center;
  padding-bottom: 25px;
}
.success-btn .btn {
  font-weight: 500;
  padding: 8px 18px;
}
@media (max-width: 767.98px) {
  .success-btn .btn {
    display: flex;
  }
}
.success-btn .btn-primary {
  margin-right: 15px;
}
@media (max-width: 767.98px) {
  .success-btn .btn-primary {
    margin: 0 0 10px 0;
    padding: 8px 18px;
  }
}
.success-btn .btn-light {
  color: #7c7c7c;
  background: #f5f5f5;
}

.success-dashboard-link {
  text-align: center;
}
.success-dashboard-link a {
  font-weight: 500;
  font-size: 15px;
  color: #959595;
}
.success-dashboard-link a:hover {
  color: #0e82fd;
}
.success-dashboard-link a i {
  margin-right: 12px;
  font-size: 16px;
}
@media (max-width: 767.98px) {
  .success-dashboard-link a {
    font-size: 14px;
  }
}

/*# sourceMappingURL=custom.css.map */
`, "",{"version":3,"sources":["webpack://./src/normalUsers/assets/css/custom.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,oBAAoB;AACpB,uBAAuB;AACvB,0BAA0B;AAC1B,wBAAwB;AACxB,cAAc;AAId;;;;;;;EAOE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+IE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;EAuBE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;;;;;;;;;;;;;;EAcE,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0EE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;;;;;;;;;;;;;EAaE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;;;;;;;;EASE,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,uBAAuB;AACzB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;;;;EAKE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;EAeE,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0EE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;;;;EAIE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;EAcE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;;;;EAKE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA,qBAAqB;AACrB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;;;;;;EAWE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C,EAAE,cAAc;EAC5D;;;;;8DAK4D;AAC9D;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;;EAME,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;;EAEE,iBAAiB;AACnB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;;EAEE,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,4BAA4B;EAC5B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;;EAGE,iDAAiD;EACjD,yDAAyD;AAC3D;AACA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;EAGE,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;;;;;EAKE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA,uBAAuB;AACvB,0BAA0B;AAC1B,wBAAwB;AACxB,cAAc;AACd;;;;;;;EAOE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+IE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;EAuBE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;;;;;;;;;;;;;;EAcE,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0EE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;;;;;;;;;;;;;EAaE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;;;;;;;;EASE,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,uBAAuB;AACzB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;;;;EAKE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;EAeE,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0EE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;;;;EAIE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;EAcE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;;;;EAKE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B;;;;4BAI0B;EAC1B;;;;4BAI0B;AAC5B;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kDAAkD;EAClD,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,UAAU;EACV,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,6CAA6C;EAC7C,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB;;wBAEsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,6CAA6C;EAC7C,qDAAqD;EACrD,iDAAiD;AACnD;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,yDAAgD;EAChD,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,yDAAiD;EACjD,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B;;mCAEiC;AACnC;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,yDAAiD;EACjD,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,yDAAgD;EAChD,4BAA4B;EAC5B,0BAA0B;EAC1B,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;AACA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;;EAEE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;EAIE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;EAIE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;;;;;;EAkBE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;;EAME,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;;EAME,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;;EAME,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;;EAME,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,+CAA+C;EAC/C,4CAA4C;EAC5C,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE;;;IAGE,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;;;EAIE,6CAA6C;EAC7C,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;EAC3C,mDAAmD;EACnD,+CAA+C;EAC/C,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;EACV,UAAU;EACV,eAAe;EACf,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;;EAEE,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;;;;EAKE,6CAA6C;EAC7C,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,UAAU;EACZ;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;;;;EAIE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gDAAgD;AAClD;AACA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;;EAEE,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;;EAEE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,6BAA6B;EAC7B,qCAAqC;EACrC,iCAAiC;EACjC,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;;;;EAIE,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,aAAa;EACb,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;;;EAIE,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,UAAU;AACZ;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,WAAW;EACX,WAAW;EACX,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,WAAW;EACX,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,wCAAwC;EACxC,gDAAgD;EAChD,4CAA4C;EAC5C,YAAY;AACd;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,WAAW;EACX,WAAW;EACX,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,wCAAwC;EACxC,gDAAgD;EAChD,4CAA4C;EAC5C,YAAY;AACd;AACA;;;EAGE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,iBAAiB;AACnB;AACA;;;EAGE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,oBAAoB;AACtB;AACA;;;EAGE,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kDAAkD;EAClD,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,8CAA8C;EAC9C,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,8CAA8C;EAC9C,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;EACtB;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;EACtB;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,qCAAqC;IACrC,iCAAiC;IACjC,4BAA4B;IAC5B,wBAAwB;IACxB,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;EACT;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,eAAe;AACjB;AACA;EACE;IACE,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;EACf;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;EACZ;AACF;AACA;EACE;IACE,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,SAAS;EACX;AACF;AACA;EACE;IACE,SAAS;IACT,kBAAkB;IAClB,2CAA2C;IAC3C,qDAAqD;EACvD;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,gCAAgC;IAChC,SAAS;EACX;AACF;AACA;EACE;IACE,iBAAiB;IACjB,qBAAqB;EACvB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;IACb,cAAc;IACd,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,UAAU;IACV,MAAM;IACN,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE;IACE,aAAa;IACb,cAAc;IACd,4BAA4B;EAC9B;AACF;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE;IACE,UAAU;IACV,MAAM;IACN,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;;;;;;;IAOE,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;AACA;EACE;IACE,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,2BAA2B;IAC3B,mCAAmC;IACnC,+BAA+B;IAC/B,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,8CAA8C;IAC9C,2CAA2C;IAC3C,sCAAsC;EACxC;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,yBAAyB;IACzB,qDAAqD;IACrD,WAAW;IACX,qBAAqB;IACrB,6BAA6B;IAC7B,yBAAyB;IACzB,yBAAyB;IACzB,iCAAiC;IACjC,6BAA6B;IAC7B,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,wDAAwD;IACxD,qDAAqD;IACrD,gDAAgD;EAClD;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;EAC9B;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;EAC9B;AACF;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,qDAAqD;EACrD,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,8CAA8C;EAC9C,2CAA2C;EAC3C,sCAAsC;AACxC;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B,mCAAmC;IACnC,+BAA+B;EACjC;AACF;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qDAAqD;EACrD,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,wDAAwD;EACxD,qDAAqD;EACrD,gDAAgD;AAClD;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;EAC9B;AACF;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,2BAA2B;IAC3B,mCAAmC;IACnC,+BAA+B;IAC/B,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,+BAA+B;EAC/B,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,yCAAyC;EACzC,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,UAAU;EACV,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE;IACE,cAAc;IACd,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;AACF;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;EACjD,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,iDAAiD;AACnD;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,SAAS;IACT,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;IACpB,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE;IACE,qBAAqB;IACrB,SAAS;IACT,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE;IACE,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,iDAAiD;IACjD,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,2BAA2B;IAC3B,mCAAmC;IACnC,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;EACf;AACF;AACA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,gCAAgC;IAChC,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;IACf,kCAAkC;IAClC,2BAA2B;EAC7B;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,+BAA+B;IAC/B,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,qDAAqD;AACvD;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;EAC9B;EACA;;;;;;;IAOE,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,UAAU;IACV,MAAM;IACN,gBAAgB;EAClB;AACF;AACA;EACE;IACE,yBAAyB;IACzB,qDAAqD;IACrD,gDAAgD;IAChD,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,6BAA6B;IAC7B,qBAAqB;IACrB,yBAAyB;IACzB,iCAAiC;IACjC,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,UAAU;IACV,0BAA0B;IAC1B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,wBAAwB;IACxB,oBAAoB;IACpB,6BAA6B;IAC7B,qCAAqC;IACrC,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;AACF;AACA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,YAAY;EACZ,WAAW;EACX,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;AACT;AACA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;EACZ;AACF;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,YAAY;IACZ,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,0BAA0B;EAC1B,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,+BAA+B;EAC/B,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,yCAAyC;EACzC,qCAAqC;EACrC,iCAAiC;EACjC,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,0BAA0B;EAC1B,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;;;;;;EASE,cAAc;AAChB;;AAEA;;;;;;;;;EASE,cAAc;AAChB;;AAEA;;;;;;;;;EASE,cAAc;AAChB;;AAEA;;;;;;;;;EASE,cAAc;AAChB;;AAEA;EACE;;4CAE0C;AAC5C;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE;kBACgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,SAAS;IACT,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;IACvB,8BAA8B;IAC9B,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;IACtC,2CAA2C;IAC3C,mDAAmD;IACnD,gDAAgD;IAChD,+CAA+C;IAC/C,8CAA8C;IAC9C,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,uCAAuC;EACzC;EACA;IACE,SAAS;EACX;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,iDAAiD;AACnD;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,SAAS;IACT,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;IACpB,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE;IACE,qBAAqB;IACrB,SAAS;IACT,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE;IACE,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,iDAAiD;IACjD,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,2BAA2B;IAC3B,mCAAmC;IACnC,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;EACf;AACF;AACA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,gCAAgC;IAChC,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;IACf,kCAAkC;IAClC,2BAA2B;EAC7B;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;;;;;;;EAOE,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,qDAAqD;AACvD;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;EAC9B;EACA;;;;;;;IAOE,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,UAAU;IACV,MAAM;IACN,gBAAgB;EAClB;AACF;AACA;EACE;IACE,yBAAyB;IACzB,qDAAqD;IACrD,gDAAgD;IAChD,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,6BAA6B;IAC7B,qBAAqB;IACrB,yBAAyB;IACzB,iCAAiC;IACjC,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,UAAU;IACV,0BAA0B;IAC1B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,wBAAwB;IACxB,oBAAoB;IACpB,6BAA6B;IAC7B,qCAAqC;IACrC,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;AACF;AACA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,iCAAiC;EACjC,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,iCAAiC;EACjC,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,UAAU;AACZ;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,gCAAgC;EAClC;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;;EAOE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;;EAOE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iDAAiD;AACnD;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;;;;;IAKE,iBAAiB;EACnB;AACF;AACA;EACE;;;;;IAKE,kBAAkB;EACpB;AACF;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;AACA;;;;;EAKE,aAAa;AACf;AACA;;;;;;EAME,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;;;;;;;;;;;;EAYE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,UAAU;AACZ;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;;EAOE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;;;;;IAKE,kBAAkB;EACpB;AACF;AACA;EACE;;;;;IAKE,iBAAiB;EACnB;AACF;AACA;EACE;;;;;IAKE,kBAAkB;EACpB;AACF;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kDAAkD;AACpD;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;;EAOE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;;EAOE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;EACE;;;;;;;IAOE,cAAc;EAChB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,oCAAoC;AACtC;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;;;;;EAKE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;IACjB,8BAA8B;EAChC;AACF;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE;;IAEE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,oEAAoE;IACpE,sBAAsB;EACxB;AACF;AACA;;;EAGE,yBAAyB;AAC3B;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,oEAAoE;IACpE,sBAAsB;EACxB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE;IACE,gCAAgC;EAClC;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE;IACE,yDAAyD;IACzD,iCAAiC;EACnC;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;;;EAGE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE;;;IAGE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,gCAAgC;EAClC;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,4BAA4B;AAC9B;AACA;;;EAGE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA;;;EAGE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,SAAS;AACX;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,+BAA+B;EACjC;AACF;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE;;;IAGE,oEAAoE;IACpE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE;IACE,oEAAoE;IACpE,sBAAsB;EACxB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;AACrC;AACA;;EAEE,UAAU;EACV,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,0CAA0C;EAC1C,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;;;;;;;EAQE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE;;;;;;;;IAQE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;EAEE,gBAAgB;AAClB;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;AACA;EACE;IACE,SAAS;IACT,iBAAiB;EACnB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mEAA2D;EAC3D,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,iEAAyD;EACzD,kBAAkB;EAClB,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,eAAe;AACjB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,oBAAoB;EACtB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;;EAOE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,UAAU;EACV,cAAc;AAChB;AACA;;;;;;;EAOE,yBAAyB;EACzB,oBAAoB;AACtB;AACA;;;;;;;;EAQE,kBAAkB;AACpB;AACA;;;;;;;;EAQE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,yDAAoD;EACpD,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;;;;;EAKE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;AACA;EACE,2CAA2C;EAC3C,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,OAAO;AACT;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yDAAmD;EACnD,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;;;;;EAKE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE;;;;;IAKE,eAAe;EACjB;AACF;AACA;;;;;EAKE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;;;;;IAKE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE;IACE,qBAAqB;IACrB,qBAAqB;EACvB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;;;;;;EAOE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;;;;;;;;EAQE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;;;;;;;;;EASE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;;;;;;;;;IASE,eAAe;EACjB;AACF;AACA;;;;;;;;;EASE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;;;;;EAKE,qBAAqB;AACvB;AACA;EACE;;;;;IAKE,mBAAmB;EACrB;AACF;AACA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;AACA;;;;;;;EAOE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;;;;;EAME,kBAAkB;AACpB;AACA;;;;;;;;EAQE,UAAU;AACZ;AACA;;;;;;;;;EASE,6CAA6C;AAC/C;AACA;;;;;;;EAOE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;;;;;;;EAQE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;;;;;;;;EAQE,mBAAmB;AACrB;AACA;;;;;EAKE,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE;;;;;;IAME,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;;;;;;;EAOE,gBAAgB;EAChB,eAAe;AACjB;AACA;;;;;;;EAOE,oBAAoB;AACtB;AACA;EACE;;;;;;;IAOE,uBAAuB;EACzB;AACF;AACA;;;;;;;;EAQE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE;;;;;;;;IAQE,qBAAqB;EACvB;AACF;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,yDAA2C;EAC3C,4BAA4B;EAC5B,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,oFAAwE;EACxE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;AACF;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,qBAAqB;IACrB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,wDAAwD;EACxD,qDAAqD;EACrD,gDAAgD;AAClD;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;EACb;AACF;AACA;EACE;IACE,sBAAsB;IACtB,cAAc;IACd,UAAU;EACZ;AACF;AACA;EACE,kFAAqE;AACvE;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;AACF;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;EACb;AACF;AACA;EACE;IACE,sBAAsB;IACtB,cAAc;IACd,UAAU;EACZ;AACF;AACA;EACE,kFAAmE;AACrE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,yBAAyB;IACzB,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;AACA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,OAAO;EACP,cAAc;AAChB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,eAAe;EACf,aAAa;EACb,UAAU;AACZ;AACA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,UAAU;AACZ;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kCAAkC;EAClC,0CAA0C;EAC1C,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;EACzD,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,yBAAyB;IACzB,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;EACE,2CAA2C;EAC3C,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,oDAAoD;EACpD,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;AAC3D;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;EACpC,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,oDAAwC;EACxC,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;AACA;EACE;IACE,SAAS;IACT,sBAAsB;EACxB;AACF;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,OAAO;EACT;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,OAAO;EACT;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,OAAO;EACP,UAAU;AACZ;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gDAAgD;EAChD,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,8CAA8C;EAC9C,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,8CAA8C;EAC9C,sCAAsC;AACxC;AACA;EACE;IACE,0BAA0B;IAC1B,kCAAkC;IAClC,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,oCAAoC;IACpC,gCAAgC;EAClC;EACA;IACE,0BAA0B;IAC1B,kCAAkC;IAClC,8BAA8B;EAChC;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,kCAAkC;IAClC,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,oCAAoC;IACpC,gCAAgC;EAClC;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,kCAAkC;IAClC,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,oCAAoC;IACpC,gCAAgC;EAClC;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,oDAAgD;EAChD,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kDAAkD;EAClD,iBAAiB;EACjB,MAAM;EACN,eAAe;EACf,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,oDAAmD;EACnD,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,WAAW;EACX,oDAAmD;EACnD,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;EACzD,WAAW;AACb;AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,cAAc;EACd,WAAW;EACX,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,oDAAmD;EACnD,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,WAAW;EACX,oDAAmD;EACnD,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,oDAAmD;EACnD,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,WAAW;EACX,oDAAmD;EACnD,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,oBAAoB;AACtB;AACA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;EACzD,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,cAAc;EACd,WAAW;EACX,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;AACA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,qBAAqB;EACvB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,oBAAoB;AACtB;AACA;EACE;IACE,SAAS;IACT,iBAAiB;EACnB;AACF;AACA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;AACA;EACE;IACE,SAAS;IACT,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,0DAA2C;EAC3C,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE;IACE,SAAS;IACT,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;IACf,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE;IACE,SAAS;IACT,iBAAiB;EACnB;AACF;AACA;EACE;IACE,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB;;;;;;2CAMyC;EACzC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;IAClB,QAAQ;EACV;AACF;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wEAAgE;EAChE,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;AAC3D;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;AAC3D;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;wBAEwB;AACxB;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;EACd;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE;IACE,eAAe;IACf,qBAAqB;EACvB;AACF;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,UAAU;AACZ;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;EACf;AACF;AACA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;AACA;EACE;IACE,cAAc;IACd,oBAAoB;EACtB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;IACf,SAAS;IACT,aAAa;IACb,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,SAAS;EACT,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,UAAU;AACZ;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;EACjC,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,sBAAsB;EACxB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,qBAAqB;EACvB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;EACpB;AACF;AACA;EACE,SAAS;EACT,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE;IACE,kCAAkC;IAClC,gBAAgB;IAChB,oBAAoB;EACtB;AACF;AACA;EACE;IACE,gCAAgC;EAClC;AACF;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;;;EAGE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE;;;IAGE,sBAAsB;IACtB,cAAc;EAChB;AACF;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;EACd,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE,gCAAgC;EAChC,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,OAAO;AACT;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC;AACA;EACE;IACE,gCAAgC;IAChC,eAAe;IACf,mBAAmB;IACnB,oBAAoB;EACtB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,OAAO;AACT;AACA;EACE;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf;;+BAE2B;IAC3B,WAAW;IACX,eAAe;EACjB;AACF;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;;;;;;;EAOE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;;;;;;;IAOE,gBAAgB;EAClB;AACF;AACA;EACE;;;;;;;IAOE,gBAAgB;EAClB;AACF;AACA;EACE;;;;;;;IAOE,gBAAgB;EAClB;AACF;AACA;EACE;;;;;;;IAOE,gBAAgB;EAClB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;EACE;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;AACF;AACA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf;;+BAE2B;IAC3B,WAAW;EACb;AACF;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;AACA;EACE;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;EACtB;AACF;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;EACX,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;EACjC,WAAW;EACX,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;;;;EAQE,2BAA2B;AAC7B;AACA;;;;;;;;EAQE,UAAU;AACZ;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;EACnC,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,QAAQ;IACR,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;wBAEwB;AACxB;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,aAAa;EACb,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;;EAEE,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;AACF;AACA;EACE;IACE,2CAA2C;IAC3C,sCAAsC;EACxC;EACA;IACE,4CAA4C;IAC5C,uCAAuC;EACzC;AACF;AACA;;;;;;;EAOE,WAAW;EACX,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,qDAAqD;EACrD,gDAAgD;EAChD,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,8BAA8B;AAChC;AACA;;;EAGE,8BAA8B;EAC9B,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE;IACE,cAAc;IACd,aAAa;EACf;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,WAAW;AACb;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;;;EAOE,0DAAyE;AAC3E;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;;EAME,0DAAoE;AACtE;AACA;EACE,cAAc;AAChB;AACA;EACE,0DAAgE;EAChE,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,0DAA8D;EAC9D,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,oDAAoD;EACpD,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oDAAoD;EACpD,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,UAAU;EACV,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,0DAAyE;EACzE,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;;;;EAIE,0DAAuD;EACvD,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,0DAAoE;AACtE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,qCAAqC;AACvC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,WAAW;EACX,OAAO;AACT;AACA;EACE,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;IACE,aAAa;IACb,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,OAAO;AACT;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;;EAEE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;AACA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;AACR;AACA;EACE;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;EACpC,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;AACT;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,oDAAwC;EACxC,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,SAAS;EACT,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;AACA;;;;EAIE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;;;;EAIE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;AAC3D;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,iBAAiB;IACjB,UAAU;EACZ;AACF;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;EAChB;AACF;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;EACf,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;EACjC,aAAa;AACf;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;EACrC,iCAAiC;EACjC,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;;;;;EAKE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;;;;;EAOE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,eAAe;IACf,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kFAAqE;AACvE;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kFAAmE;AACrE;AACA;EACE,kFAAmE;AACrE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oDAAuC;EACvC,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;;EAEE,yCAAyC;EACzC,iDAAiD;EACjD,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;AACA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,iCAAiC;EACjC,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,oDAA4C;EAC5C,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;EAClD,cAAc;EACd,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oDAA0C;EAC1C,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oDAAuC;EACvC,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;;EAEE,6BAA6B;EAC7B,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,iDAAiD;EACjD,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;AACA;EACE;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,kDAAkD;AACpD;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oDAA6C;EAC7C,eAAe;EACf,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,oDAA+C;EAC/C,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,oDAAqD;EACrD,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;AACA;EACE,WAAW;EACX,mCAAmC;EACnC,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oDAA6C;EAC7C,eAAe;EACf,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,mDAAmD;EACnD,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,SAAS;EACT,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;AACF;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oDAA+C;EAC/C,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oDAA+C;EAC/C,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,qCAAqC;AACvC;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,oDAAqD;EACrD,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,mCAAmC;AACrC;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;;;;;;EAME,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,oDAAgD;EAChD,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;EACpB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE;;;;IAIE,WAAW;EACb;AACF;AACA;;;;;EAKE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE;;;;;IAKE,eAAe;IACf,eAAe;IACf,eAAe;IACf,WAAW;EACb;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,yCAAyC;AAC3C;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;;;;;EAME,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;EAClD,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;;;;;;;EAQE,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;;;;;;;;EASE,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;;;;;;;EAOE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,0DAAsD;EACtD,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;;;;;;;EAQE,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,oDAA4C;EAC5C,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;EACzD,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,cAAc;EACd,WAAW;EACX,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;;;;;;EAME,aAAa;EACb,mBAAmB;AACrB;AACA;;;;;;;EAOE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;;;;;EAQE,cAAc;EACd,eAAe;AACjB;AACA;;;;;;;;EAQE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;;;;;;IAME,WAAW;EACb;AACF;AACA;;;;;;;EAOE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;EACpB,cAAc;AAChB;AACA;;;;;;;EAOE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE;;;;;;;IAOE,0BAA0B;IAC1B,eAAe;EACjB;AACF;AACA;EACE;;;;;;;IAOE,WAAW;EACb;AACF;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,yCAAyC;AAC3C;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;;;;EAKE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,iCAAiC;EACjC,oBAAoB;AACtB;AACA;;;;;EAKE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,yCAAyC;AAC3C;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;;;;;;EAME,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;AACA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;;;;;EAME,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;;;;EAME,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,+BAA+B;AACjC;AACA;EACE,iBAAiB;AACnB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;;EAKE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE;;;;;IAKE,eAAe;EACjB;AACF;AACA;;;;;EAKE,oCAAoC;EACpC,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;EACzB,cAAc;EACd,iCAAiC;AACnC;AACA;;;;;EAKE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,0DAA6C;EAC7C,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,yCAAyC;AAC3C;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,mBAAmB;AACrB;AACA;;;;;EAKE,mBAAmB;AACrB;AACA;;;;;;;EAOE,mBAAmB;AACrB;AACA;;;;;;;;EAQE,cAAc;EACd,iBAAiB;AACnB;AACA;;;;;;;;EAQE,iBAAiB;AACnB;AACA;;;;;;;;EAQE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;;EAOE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kDAAkD;EAClD,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;;;IAGE,mBAAmB;EACrB;AACF;AACA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,MAAM;EACN,OAAO;AACT;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,2DAA2D;EAC3D,kDAAkD;AACpD;AACA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;EACzD,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,WAAW;AACb;AACA;;;;;;EAME,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;;;;;EAKE,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,cAAc;EACd,WAAW;EACX,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;EACpC,UAAU;AACZ;AACA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;AACA;;;;;;;EAOE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;;;;;;;;;;;;;;;;EAgBE,eAAe;AACjB;AACA;;;;;;;EAOE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;;;;;EAQE,cAAc;AAChB;AACA;;;;;;;EAOE,yBAAyB;AAC3B;AACA;;;;;;;;EAQE,cAAc;AAChB;AACA;;;;;;;;EAQE,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;;EAOE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE;;;;;;;IAOE,sBAAsB;EACxB;AACF;AACA;EACE;;;;;;;IAOE,kBAAkB;EACpB;AACF;AACA;;;;;;;;EAQE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;;;EAQE,2BAA2B;EAC3B,kDAAkD;AACpD;AACA;;;;;;;;EAQE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;;;;;EAQE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;;;;;EAQE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;;;;EAOE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;AACA;;;;;;;;EAQE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE;;;;;;;;IAQE,aAAa;EACf;AACF;AACA;;;;;;;;EAQE,aAAa;EACb,mBAAmB;AACrB;AACA;;;;;;;;;EASE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;;;;;;;EAUE,cAAc;EACd,eAAe;AACjB;AACA;;;;;;;;;;EAUE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;;;;;;;;;;IAUE,eAAe;EACjB;AACF;AACA;;;;;;;;;EASE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;EACpB,cAAc;AAChB;AACA;;;;;;;;;EASE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE;;;;;;;;;IASE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;AACpB;AACA;;;;;EAKE,OAAO;EACP,SAAS;AACX;AACA;;;;;EAKE,QAAQ;EACR,UAAU;AACZ;AACA;;;;;EAKE,YAAY;EACZ,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE;IACE,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;;;;;EAKE,oCAAoC;EACpC,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;EACzB,cAAc;EACd,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;;;;;EAKE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,oDAA4C;EAC5C,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;;;;;EAKE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;;;;;;EAME,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;;EAKE,oBAAoB;AACtB;AACA;;;;;EAKE,uBAAuB;AACzB;AACA;;;;;EAKE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,yBAAyB;AAC3B;AACA;;;;;;EAME,gBAAgB;EAChB,cAAc;AAChB;AACA;;;;;EAKE,oBAAoB;EACpB,gCAAgC;AAClC;AACA;;;;;;;EAOE,gBAAgB;EAChB,cAAc;AAChB;AACA;;;;;EAKE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;;;;;;EAOE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;EAME,kBAAkB;AACpB;AACA;;;;;;;;EAQE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;AACA;;;;;;;;EAQE,gBAAgB;AAClB;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;;;;;;EAME,mBAAmB;AACrB;AACA;;;;;;;EAOE,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;;;;;;;EAOE,oCAAoC;EACpC,cAAc;AAChB;AACA;;;;;;EAME,oBAAoB;EACpB,gCAAgC;AAClC;AACA;;;;;;;;EAQE,gBAAgB;AAClB;AACA;;;;;;;;EAQE,gBAAgB;EAChB,cAAc;AAChB;AACA;;;;;;EAME,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;;;;;;;EAQE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;EAIE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;;;;;EAME,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,yCAAyC;AAC3C;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;;;;EAIE,aAAa;AACf;AACA;;;;EAIE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oDAA8C;EAC9C,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;;IAEE,aAAa;EACf;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,OAAO;EACP,MAAM;EACN,yCAAyC;AAC3C;AACA;EACE,QAAQ;EACR,MAAM;EACN,uCAAuC;EACvC,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;EACT,yCAAyC;AAC3C;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,WAAW;EACX,QAAQ;EACR,WAAW;AACb;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,2CAA2C;EAC3C,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;;EAEE,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;EAC5C,oBAAoB;EACpB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE;IACE,SAAS;IACT,2BAA2B;IAC3B,mCAAmC;IACnC,+BAA+B;EACjC;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,8EAA8E;EAC9E,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,OAAO;EACP,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;AAC3D;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;;AAEA;EACE;;;;;;GAMC;AACH;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;AAC3D;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yEAA6D;EAC7D,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,WAAW;AACb;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;;;;;;EAME,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;;;;;;;;EAQE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,WAAW;EACX,8DAA0D;EAC1D,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sEAA8D;EAC9D,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;AAC3D;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;AACA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,yEAAyE;EACzE,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;AACF;AACA;EACE,yEAAyE;AAC3E;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;EAEE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,SAAS;EACT,QAAQ;EACR,QAAQ;EACR,yBAAyB;EACzB,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;;;;EAIE,kBAAkB;EAClB,WAAW;AACb;AACA;;;;EAIE,OAAO;EACP,SAAS;AACX;AACA;;;;EAIE,QAAQ;EACR,UAAU;AACZ;AACA;EACE;;;;IAIE,aAAa;EACf;AACF;AACA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;AACA;;;;EAIE,4CAA4C;EAC5C,mBAAmB;AACrB;AACA;;;;;EAKE,kBAAkB;EAClB,WAAW;AACb;AACA;;;;;EAKE,UAAU;EACV,UAAU;EACV,+BAA+B;AACjC;AACA;;;;;EAKE,OAAO;EACP,0CAA0C;AAC5C;AACA;;;;;EAKE,UAAU;EACV,UAAU;EACV,uCAAuC;AACzC;AACA;;;;;EAKE,WAAW;EACX,UAAU;EACV,uCAAuC;AACzC;AACA;EACE;;IAEE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;;;IAGE,aAAa;EACf;AACF;AACA;EACE,SAAS;AACX;AACA;;;;EAIE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE;;;;IAIE,YAAY;EACd;AACF;AACA;;;;;EAKE,uBAAuB;EACvB,cAAc;AAChB;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;;EAKE,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;EAKE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;;;EAME,kBAAkB;AACpB;AACA;;;;;;EAME,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;;;;;;EAME,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;;;;;EAKE,SAAS;AACX;AACA;EACE;;;;;IAKE,WAAW;EACb;AACF;AACA;;;;;;EAME,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,kCAAkC;EACpC;AACF;AACA;;;;EAIE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,WAAW;AACb;AACA;;;;;EAKE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;;;;;IAKE,eAAe;EACjB;AACF;AACA;;;;EAIE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,WAAW;EACX,0DAAsD;EACtD,4BAA4B;EAC5B,wBAAwB;EACxB,sCAAsC;EACtC,UAAU;EACV,6BAA6B;EAC7B,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,OAAO;EACP,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iDAAiD;EACjD,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;AACA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iCAAiC;AACnC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,OAAO;EACP,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;;;;EAIE,aAAa;AACf;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;;;;;;EAME,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;;;;EAOE,kBAAkB;EAClB,mBAAmB;EACnB,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;EACzD,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,WAAW;AACb;AACA;;;;;;;EAOE,qBAAqB;AACvB;AACA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;;;;;;EAOE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;;;;;;;EAOE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;EAME,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;;;;;;EAME,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;;;;;;EAME,kBAAkB;EAClB,uBAAuB;AACzB;AACA;;;;;;;EAOE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;;;;;;;;EAQE,cAAc;EACd,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;AACA;;;;;;;EAOE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;;;;EAOE,kBAAkB;AACpB;AACA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;;;EAOE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;;;;;;;EAOE,eAAe;AACjB;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;;;;;;;EAOE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;EAME,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE;;;;;;IAME,WAAW;EACb;AACF;AACA;;;;;;EAME,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;;;;EAIE,sBAAsB;AACxB;AACA;EACE,8CAA8C;EAC9C,sCAAsC;AACxC;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE;;;;;;IAME,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;;;;;;;EAOE,cAAc;EACd,eAAe;AACjB;AACA;;;;;;;EAOE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;;;;;;;EAOE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;;;;;;;IAOE,eAAe;EACjB;AACF;AACA;;;;;;;EAOE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;;;EAOE,eAAe;AACjB;AACA;;;;;;;;EAQE,cAAc;AAChB;AACA;;;;;;;;EAQE,eAAe;AACjB;AACA;;;;;;EAME,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE;;;;;;IAME,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE;;;;;;IAME,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,OAAO;AACT;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,MAAM;EACN,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;;;;;;;EAOE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;;;;;EAQE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;;;;;EAME,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,mBAAmB;AACrB;AACA;;;;;;;;;;;;EAYE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;;;EAME,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,oDAAoD;AACtD;AACA;EACE,gDAAgD;EAChD,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB;;;;;4BAK0B;AAC5B;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE;IACE,+BAA+B;EACjC;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,WAAW;EACX,0DAA4C;EAC5C,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;;;;EAIE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;;;;IAIE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;EACvB;AACF;AACA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,QAAQ;AACV;AACA;EACE;;IAEE,UAAU;EACZ;AACF;AACA;;EAEE,UAAU;EACV,QAAQ;AACV;AACA;EACE;;IAEE,UAAU;EACZ;AACF;AACA;EACE;;IAEE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,0DAAwD;EACxD,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;;;;;EAKE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,iCAAiC;AACnC;AACA;EACE;;;;;IAKE,kBAAkB;EACpB;AACF;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;;;EAGE,SAAS;EACT,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,eAAe;AACjB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;;;;;IAKE,eAAe;EACjB;AACF;AACA;;;;EAIE,kBAAkB;AACpB;AACA;EACE;;;;IAIE,kBAAkB;EACpB;AACF;AACA;EACE;;;;IAIE,mBAAmB;EACrB;AACF;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE;;;;IAIE,WAAW;EACb;AACF;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE;;;;IAIE,WAAW;EACb;AACF;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE;;;;IAIE,WAAW;EACb;AACF;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE;;;;IAIE,WAAW;EACb;AACF;AACA;;;;;;;EAOE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;;;;;;;IAOE,eAAe;EACjB;AACF;AACA;;;;;;EAME,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;;;;;;;EAOE,QAAQ;AACV;AACA;;;;;;;;EAQE,6CAA6C;AAC/C;AACA;;;;;EAKE,UAAU;EACV,UAAU;EACV,eAAe;EACf,cAAc;AAChB;AACA;;;;;EAKE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE;;;;;IAKE,eAAe;EACjB;AACF;AACA;;;;;;;;;;EAUE,oCAAoC;AACtC;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE;;;;IAIE,WAAW;EACb;AACF;AACA;;;;;EAKE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;;;;;IAKE,kBAAkB;EACpB;AACF;AACA;EACE;;;;;IAKE,kBAAkB;EACpB;AACF;AACA;EACE;;;;;IAKE,WAAW;EACb;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;;;;EAIE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,wCAAwC;EACxC,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,wCAAwC;EACxC,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,wCAAwC;EACxC,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,wCAAwC;AAC1C;AACA;;;;EAIE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,wCAAwC;AAC1C;AACA;;;;EAIE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,kDAAkD;AACpD;AACA;;;;EAIE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,kDAAkD;AACpD;AACA;;;;EAIE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,sCAAsC;EACtC,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,wCAAwC;AAC1C;AACA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,sCAAsC;EACtC,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,sCAAsC;AACxC;AACA;;;;EAIE,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;AACA;EACE;;;;IAIE,aAAa;EACf;AACF;AACA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;AACA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;AACb;AACA;;;;;EAKE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,2DAA2D;EAC3D,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;EAKE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;EAKE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,oCAAoC;EACpC,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,SAAS;IACT,sBAAsB;EACxB;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE;;;;IAIE,cAAc;EAChB;AACF;AACA;;;;;EAKE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;;;;;IAKE,kBAAkB;EACpB;AACF;AACA;;;;;;EAME,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE;;;;;;IAME,YAAY;EACd;AACF;AACA;EACE;;;;;;IAME,YAAY;EACd;AACF;AACA;;;;;;EAME,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;AACA;;;;;;EAME,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;AACA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,uDAAuD;EACvD,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;;;;EAIE,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,oDAAuC;EACvC,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE;IACE,yBAAyB;IACzB,sBAAsB;EACxB;AACF;AACA;;;;;EAKE,aAAa;AACf;AACA;EACE;;;;;IAKE,WAAW;EACb;AACF;AACA;;;;EAIE,mBAAmB;EACnB,2DAA2D;EAC3D,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;;;;;EAKE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;EAKE,mBAAmB;AACrB;AACA;;;;;;EAME,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;;;;;;;EAOE,cAAc;EACd,eAAe;AACjB;AACA;;;;;;;;EAQE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;AACA;;;;;;;;;EASE,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;;;;;EAKE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;;EAKE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;;;;EAKE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;EAIE,QAAQ;EACR,QAAQ;EACR,sCAAsC;AACxC;AACA;;;;EAIE,SAAS;EACT,WAAW;EACX,sCAAsC;AACxC;AACA;;;;EAIE,SAAS;EACT,QAAQ;EACR,sCAAsC;AACxC;AACA;;;;EAIE,QAAQ;EACR,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;;;;IAIE,aAAa;EACf;AACF;AACA;;;;;EAKE,mBAAmB;AACrB;AACA;;;;;;EAME,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;;;EAME,SAAS;EACT,UAAU;AACZ;AACA;;;;;;EAME,SAAS;EACT,OAAO;AACT;AACA;EACE;;;;;;IAME,UAAU;EACZ;AACF;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;;;;;EAKE,aAAa;AACf;AACA;EACE;;;;;IAKE,cAAc;EAChB;AACF;AACA;;;;;;EAME,eAAe;EACf,YAAY;EACZ,oCAAoC;EACpC,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;;;;;;IAME,mBAAmB;EACrB;AACF;AACA;;;;;;;EAOE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;;;;;;EAOE,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uDAAuD;AACzD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;;;;EAIE,UAAU;EACV,4BAA4B;EAC5B,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;AACb;AACA;EACE;;;;IAIE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;EAC9B;AACF;AACA;EACE;;;;IAIE,aAAa;EACf;AACF;AACA;;;;;EAKE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;;;;;IAKE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA;;;;;EAKE,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;EAKE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;;;;;;EAME,kBAAkB;EAClB,WAAW;AACb;AACA;;;;;;EAME,UAAU;EACV,YAAY;EACZ,WAAW;AACb;AACA;;;;;;EAME,QAAQ;EACR,OAAO;EACP,WAAW;AACb;AACA;;;;EAIE,UAAU;AACZ;AACA;;;;;EAKE,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE;;;;IAIE,aAAa;EACf;AACF;AACA;EACE;;;IAGE,aAAa;EACf;AACF;AACA;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;EAIE,QAAQ;EACR,QAAQ;EACR,WAAW;AACb;AACA;;;;EAIE,UAAU;EACV,QAAQ;EACR,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,SAAS;IACT,sBAAsB;EACxB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;;;;EAIE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;;EAKE,mBAAmB;EACnB,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;AAC3D;AACA;;;;;EAKE,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;;;;;EAKE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;;;;EAKE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,oDAA0C;EAC1C,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;;;;EAIE,aAAa;AACf;AACA;EACE;;;;IAIE,uBAAuB;EACzB;AACF;AACA;EACE;;;;IAIE,cAAc;EAChB;AACF;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;EACE;;;;;IAKE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;EAIE,SAAS;EACT,QAAQ;EACR,WAAW;EACX,sCAAsC;AACxC;AACA;;;;EAIE,UAAU;EACV,QAAQ;EACR,WAAW;EACX,sCAAsC;AACxC;AACA;;;;EAIE,SAAS;EACT,WAAW;EACX,WAAW;EACX,sCAAsC;AACxC;AACA;;;;EAIE,SAAS;EACT,WAAW;EACX,WAAW;EACX,sCAAsC;AACxC;AACA;;;;EAIE,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE;;IAEE,WAAW;IACX,YAAY;EACd;AACF;AACA;;EAEE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;AACF;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;AACX;AACA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sCAAsC;AACxC;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;;;;EAKE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;;;EAME,kBAAkB;EAClB,mBAAmB;EACnB,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;EACzD,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,WAAW;AACb;AACA;;;;;;EAME,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;;;;;EAKE,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;;;;;EAKE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,cAAc;EACd,WAAW;EACX,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;EACpC,UAAU;AACZ;AACA;;;;;EAKE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;;;;;IAKE,eAAe;EACjB;AACF;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;EAKE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;;;;;IAKE,eAAe;EACjB;AACF;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,sCAAsC;AACxC;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB;;+BAE6B;EAC7B,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;EACxB;AACF;AACA;;;;;EAKE,YAAY;EACZ,aAAa;AACf;AACA;;;;;;EAME,YAAY;AACd;AACA;;;;;;EAME,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE;;;;;;IAME,sBAAsB;IACtB,8BAA8B;EAChC;AACF;AACA;EACE;;;;;;IAME,uBAAuB;IACvB,+BAA+B;EACjC;AACF;AACA;;;;;;;EAOE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;;;;;;;EAOE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;;;EAQE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd;;+BAE6B;EAC7B,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;;;;EAQE,qCAAqC;AACvC;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;;;;;;;EAOE,eAAe;AACjB;AACA;;;;;;;EAOE,eAAe;EACf,cAAc;AAChB;AACA;;;;;;EAME,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;;;EAOE,cAAc;EACd,iBAAiB;AACnB;AACA;;;;;;;EAOE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,sCAAsC;AACxC;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;;;;;EAKE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;;;EAME,kBAAkB;EAClB,mBAAmB;EACnB,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;EACzD,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,WAAW;AACb;AACA;;;;;;;EAOE,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;;;;;EAKE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;;;;;;EAME,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;EAKE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;;;;;;EAME,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;;;;;;EAME,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;;;EAME,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB;;+BAE6B;EAC7B,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,0DAAmD;EACnD,4BAA4B;EAC5B,wBAAwB;EACxB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,0DAAmD;AACrD;AACA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,aAAa;EACf;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,8CAA8C;EAC9C,sCAAsC;AACxC;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;;;;;EAKE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;;;;;;EAME,cAAc;EACd,eAAe;AACjB;AACA;;;;;;EAME,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;;EAME,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8CAA8C;EAC9C,sCAAsC;AACxC;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,8CAA8C;EAC9C,sCAAsC;AACxC;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,kCAAkC;EACpC;AACF;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;;EAIE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AACA;EACE;;;;IAIE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;EACvB;AACF;AACA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,0DAAmD;EACnD,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;;;;;IAKE,kBAAkB;EACpB;AACF;AACA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;;;;;EAME,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;;;;;;EAME,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;EAKE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB;;+BAE6B;EAC7B,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;;;;EAIE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,oEAAoE;EACpE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd;;+BAE6B;EAC7B,iCAAiC;AACnC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,0DAAwD;EACxD,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE;IACE,eAAe;IACf,sBAAsB;IACtB,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;EACnB,YAAY;AACd;AACA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;;;;;EAME,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd;;+BAE6B;EAC7B,iCAAiC;AACnC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,sCAAsC;AACxC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;;;;;EAKE,iBAAiB;AACnB;AACA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,QAAQ;IACR,UAAU;EACZ;AACF;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE;;IAEE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;EAEE,kBAAkB;AACpB;AACA;;;;EAIE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;EACE;;;;IAIE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,6CAA6C;EAC7C,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,0DAAsD;EACtD,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,YAAY;EACZ,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;;;;;;EAME,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;;;;;EAME,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;;;;EAQE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;;;;;;;;;EASE,iBAAiB;AACnB;AACA;;;;;;;EAOE,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kFAAkF;AACpF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,6BAA6B;AAC/B;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;;EAME,eAAe;EACf,cAAc;AAChB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;EAKE,aAAa;AACf;AACA;;;;;;EAME,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,aAAa;AACf;AACA;EACE;;;;;;IAME,iBAAiB;EACnB;AACF;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE,sEAAsE;AACxE;AACA;EACE,QAAQ;AACV;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;;;;;EAKE,aAAa;AACf;AACA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;AACA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;;;;EASE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;;;;;EAUE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kFAAkF;AACpF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,+DAA+D;EAC/D,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,cAAc;IACd,WAAW;EACb;AACF;AACA;;;;;EAKE,kBAAkB;EAClB,kDAAkD;EAClD,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;;;;;IAKE,WAAW;IACX,kBAAkB;EACpB;AACF;AACA;;;;;EAKE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;;;EAKE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;;;;;IAKE,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,iBAAiB;AACnB;AACA;;;EAGE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,WAAW;EACX,8DAA0D;EAC1D,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iFAAsE;EACtE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,SAAS;AACX;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,qBAAqB;AACvB;AACA;EACE;IACE,SAAS;IACT,qBAAqB;EACvB;AACF;AACA;EACE;IACE,SAAS;IACT,qBAAqB;EACvB;AACF;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,UAAU;EACV,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;IAChB,SAAS;IACT,iBAAiB;EACnB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;EACzB,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,oBAAoB;AACtB;AACA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;AACA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,SAAS;EACT,aAAa;AACf;AACA;EACE;IACE,SAAS;IACT,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;IACT,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE;IACE,SAAS;IACT,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;AACA;EACE;IACE,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,6CAA6C;EAC7C,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,aAAa;AACf;AACA;EACE;IACE,SAAS;IACT,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;IACT,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,SAAS;EACT,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE;IACE,eAAe;IACf,SAAS;IACT,kBAAkB;EACpB;AACF;AACA;EACE;IACE,SAAS;IACT,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;IACT,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,SAAS;IACT,iBAAiB;EACnB;AACF;AACA;EACE;IACE,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,oDAAmD;EACnD,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,WAAW;EACX,oDAAmD;EACnD,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,gCAAgC;EAChC,2CAA2C;EAC3C,8CAA8C;EAC9C,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,+BAA+B;EAC/B,gCAAgC;EAChC,2CAA2C;EAC3C,8CAA8C;EAC9C,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kDAAkD;AACpD;AACA;;EAEE,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;AACA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,UAAU;EACV,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iDAAiD;AACnD;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,mDAAmD;EACnD,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,UAAU;EACV,UAAU;EACV,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sEAA2D;AAC7D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,QAAQ;EACR,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,WAAW;EACX,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,sEAA4D;AAC9D;;AAEA;EACE,sEAAuE;AACzE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;EAClD,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,qCAAqC;EACrC,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,SAAS;EACX;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,UAAU;IACV,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAwCC;AACD;EACE,SAAS;EACT,oBAAoB;AACtB;AACA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;AACA;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,aAAa;AACf;AACA;EACE;IACE,SAAS;IACT,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;IACT,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,aAAa;AACf;AACA;EACE;IACE,SAAS;IACT,aAAa;EACf;AACF;AACA;EACE;IACE,SAAS;IACT,aAAa;EACf;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,kBAAkB;EACpB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,iBAAiB;EACnB;AACF;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;AAC9C;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;AACA;EACE;IACE,cAAc;IACd,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;IACf,SAAS;IACT,aAAa;IACb,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,SAAS;EACT,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;EAIE,6BAA6B;EAC7B,cAAc;EACd,UAAU;AACZ;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,qCAAqC","sourcesContent":["@charset \"UTF-8\";\n/****** UTILS ******/\n/*** default values ***/\n/***** custom values *****/\n/***** Grid Values *****/\n/** Extends **/\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n.upload-wrap,\n.login-page .login-right,\n.listing-day,\n.doctor-action,\n.doc-times,\n.css-equal-content,\n.css-equal-heights {\n  display: flex;\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n}\n\n.css-equal-content {\n  color: red;\n  float: left;\n}\n\n.time-slot li .timing,\n.consultation-types a,\n.coming-soon-info,\n.widget-setcount .step-icon,\n.widget-setcount .step-box,\n.signup-arrow,\n.why-choose-icon span,\n.about-contact-icon span,\n.pricing-icon span,\n.plan-choose-info,\n.product-custom .cart-icon,\n.section-search-pharmacy .banner-wrapper2 .search-box1 form,\n.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two,\n.facts-section-sixteen\n  .facts-section-all\n  .facts-content-all\n  ul\n  li\n  .facts-sixteen-img\n  .facts-content-sixteen\n  .facts-content-one,\n.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-sixteen-img,\n.facts-section-sixteen .facts-section-all .facts-content-all ul li,\n.item.item-fifteen .doctor-profile-widget .doc-pro-img .doctor-amount .fav-icon,\n.doc-content-fift .rate-fifteen ul li,\n.doc-content-fift .rate-fifteen ul,\n.doc-content-fift .rate-fifteen .rate-four,\n.Patients-section-fifteen .service-patient-inflict .clients-fifteen-span,\n.Patients-section-fifteen .service-patient-inflict .service-patient-inflictimg,\n.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg a .playicon span,\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content,\n.section-header-thirteen,\n.main-wrapper.home-twelve.home-thirteen\n  .choose-us-section-thirteen\n  ul\n  li\n  .choose-us-content-thirteen\n  .chooseus-contents,\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  p\n  i,\n.main-wrapper.home-twelve.home-thirteen\n  .services-section-thirteen\n  .service-thirteen-main\n  .service-thirteen-all,\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content,\n.testi-img .testi-icon,\n.faq-wrap ul li a span,\n.count-box .count-icon,\n.center-img .center-service span,\n.main-wrapper.home-ten\n  .specialities-section-one\n  .specialities-block\n  ul\n  li\n  .specialities-img\n  .hexogen,\n.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item,\n.book-section .book-best-doctors .book-header .img-overlay,\n.browse-section .brower-box > div .brower-img,\n.clinic-specialities .special-box:hover .special-body,\n.doctor-category .pop-box .body-section,\n.doctor-category .pop-box .top-section i,\n.doctor-category .pop-box .top-section,\n.doctor-widget-one .clinic-booking .btn-primary-light,\n.view-icons a,\n.voice-call-avatar,\n.toggle-password-sub,\n.pass-group .toggle-password,\n.login-content-info .account-content .social-login-btn .btn,\n.increment-decrement .input-groups input[type=\"button\"],\n.profile-pic-upload .cam-col,\n.step-list ul li a,\n.call-box .call-wrapper .call-items,\n.chat-attachment-item,\n.chat-window .chat-cont-right .chat-header .media .media-img-wrap,\n.chat-window .chat-cont-right .chat-header,\n.chat-window,\n.signature,\n.btn.btn-danger.trash,\n.time-slot.time-slot-blk li .timing,\n.visits span.visit-rsn:before,\n.hours-info .btn.btn-danger.trash,\n.blogs-section .blog-wrapper .wrap-content .date-cart,\n.partners-slider li a,\n.work-info .work-icon span,\n.specialities-section-one .specialities-img span,\n.specialities-section-one .specialities-item,\n.profile-widget .fav-btn,\n.section-specialities .specialities-slider .speicality-item .speicality-img span,\n.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul li a,\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-fift-selects\n  .social-icon\n  ul\n  li\n  a,\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .user-details-fift\n  ul\n  li\n  .contact-fifteen\n  .contact-form-fift,\n.footer-contacts .footer-wrap .footer-icon,\n.footer-three .social-icon ul li a,\n.footer-one .footer-top .footer-widget .footer-contact-info .footer-address p,\n.header.header-fourteen .header-nav .header-navbar-rht li.searchbar-fourteen a,\n.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.searchbar-fourteen,\n.header.header-ten .main-menu-wrapper .main-nav .register-btn,\n.header.header-ten .main-menu-wrapper .main-nav li .btn.log-btn,\n.header.header-ten .main-menu-wrapper .main-nav li .btn.reg-btn,\n.header-one .main-menu-wrapper .main-nav .register-btn,\n.header-one .main-menu-wrapper .main-nav li .btn.log-btn,\n.header-one .main-menu-wrapper .main-nav li .btn.reg-btn,\n.header.custom .header-navbar-rht.right-menu .header-contact-img i,\n.header .header-nav,\n.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone,\n.brower-box a,\n.clinic-slider .profile-widget .brower-box .arrow,\n.browse-slider .profile-widget .brower-box .arrow,\n.book-slider .profile-widget .brower-box .arrow,\n.clinic-slider .profile-widget .brower-box a,\n.browse-slider .profile-widget .brower-box a,\n.book-slider .profile-widget .brower-box a,\n.slick-dots .slick-dots li,\n.dot-slider .slick-dots li,\n.align-center {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n\n.form-group-flex,\n.otp-info,\n.otp-box .form-group,\n.signup-option-btns .signup-btn-info,\n.booking-list,\n.doc-content-fift .fift-bottom-content,\n.doc-content-fift .rate-fifteen,\n.services-section-fifteen .doctor-profile-widget-fifteen .doc-content-bottom .doc-content-split,\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  .our-doctor-content-inner,\n.store-item .store-content .price-tag,\n.testi-users,\n.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay,\n.doctor-filter-inner,\n.booking-doctor-details,\n.faq-patients-count,\n.doc-pro-info,\n.footer-three .footer-bottom .copyright .footer-language,\n.header.header-ten .header-nav,\n.header-one .header-nav {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n}\n\n.terms-btn .btn,\n.otp-sec p,\n.testimonial-slider .slick-prev,\n.testimonial-slider .slick-next,\n.special-item .special-icon a,\n.doctor-profile-widget.doc-grid .favourite-btn .favourite-icon,\n.doctor-widget-one .favourite-btn .favourite-icon,\n.doctor-filter-sort .nav li a,\n.faq-info .accordion-button:after,\n.reviews-ratings span,\n.slide-nav-1 button.owl-next,\n.slide-nav-1 button.owl-prev,\n.slide-nav-2 button.owl-next,\n.slide-nav-2 button.owl-prev {\n  display: inline-flex;\n  display: -webkit-inline-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n\n.widget-setcount ul,\n.onboarding-content .increment-decrement .input-groups input[type=\"button\"],\n.relative-form,\n.option-set,\n.select-gender-option,\n.onboarding-contents,\n.opt-resend,\n.set-path,\n.prefer-box,\n.call-lable.verify-lable.verify-options,\n.call-lable.verify-lable.verify-lable,\n.call-lable,\n.consult-option,\n.save-detail,\n.upload-pic.patient-photo-upload,\n.upload-pic,\n.onboarding-content-box.content-wrap,\n.onboarding-progress,\n.on-board-wizard ul li a,\n#onboard-slider .owl-dots,\n.right-panel,\n.left-panel,\n.onboard-wrapper,\n.full-slide-home .slick-slide .slide-image,\n.full-slide-home .slick-slide > div > .col-12,\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul,\n.banner-wrapper .search-box-3 form,\n.map-listing .profile-widget,\n.doctor-widget-one .doc-info-left,\n.doctor-widget-one,\n.clinic-services,\n.doc-info-left,\n.doctor-widget,\n.call-timing,\n.call-details,\n.password-strength,\n.increment-decrement .input-groups,\n.login-bottom-copyright,\n.custom-increment .input-group1,\nchat-attachment-list,\n.chat-msg-attachments,\n.chat-window .chat-msg-info,\n.chat-window .chat-cont-right .chat-body .media.sent .media-body,\n.chat-window .chat-cont-right .chat-header .chat-options,\n.chat-window .chat-cont-left .chat-users-list a.media .media-body,\n.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend,\n.chat-window .chat-cont-left .chat-header,\n.patient-graph-col .graph-box .graph-status-result,\n.patient-graph-col .graph-box,\n.patient-graph-box,\n.patient-dashboard-top,\n.change-avatar,\n.profile-info-widget,\n.dash-card .dash-widget,\n.upload-wrap,\n.review-listing > ul li .comment .comment-body .meta-data .review-count,\n.review-listing > ul li .comment,\n.appointments .appointment-list,\n.appointment-list .profile-info-widget,\n.booking-device,\n.success-page-cont,\n.booking-doc-info,\n.work-info,\n.section-search .banner-wrapper .search-box form,\n.footer-two .footer-top .footer-widget .footer-contact-info .footer-address,\n.footer-one .footer-top .footer-widget .footer-contact-info .footer-address,\n.footer .footer-top .footer-widget .footer-contact-info .footer-address,\n.header.header-ten .main-menu-wrapper .main-nav,\n.header-one .main-menu-wrapper .main-nav,\n.header .header-nav .header-navbar-rht .has-arrow .user-header,\n.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item,\n.header .header-nav .main-nav,\n.header .header-nav,\n.avatar .avatar-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.success-btn .btn,\n.terms-section .terms-content .terms-text.terms-list p,\n.error-content .btn,\n.way-inner-header .btn,\n.breadcrumb-bar-two .page-breadcrumb ol,\n.booking-btn .btn,\n.doctor-search-section.doctor-search-eleven .banner-header .btn,\n.breadcrumb-bar-one .page-breadcrumb ol,\n.specialities-section-one .specialities-btn .btn,\n.footer-one .social-icon ul li a,\n.footer-one .social-icon ul,\n.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul li a,\n.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.booking-date,\n.consultation-types,\n.contact-card .card-body,\n.signup-info,\n.testimonial-info,\n.about-contact,\n.pricing-header-info,\n.booking-doctor-right p,\n.booking-doctor-left,\n.faq-wrap ul li a,\n.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name,\n.count-box,\n.doctor-widget-one .clini-infos ul li,\n.doctor-widget-one .doc-location,\n.doctor-filter-sort,\n.doctor-filter-option,\n.doctor-filter-availability,\n.filter-grid h4 a,\n.booking-range .btn,\n.booking-date.choose-date-book,\n.articles-info,\n.doc-pro-location p,\n.footer-contacts .footer-wrap,\n.footer-one .footer-top .footer-widget.footer-menu ul li a,\n.flag-dropdown .dropdown-menu .dropdown-item,\n.flag-dropdown .dropdown-toggle {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n}\n\n.success-dashboard-link a,\n.custom_radio,\n.booking-date-list ul li span,\n.center-img .center-service,\n.doctor-widget-one .doc-name,\n.login-content-info .account-content .login-back a,\n.back-link a,\n.articles-content .articles-list li,\n.reviews-ratings p {\n  display: inline-flex;\n  display: -webkit-inline-flex;\n  align-items: center;\n  -webkit-align-items: center;\n}\n\n.widget-setcount ul,\n.booking-list {\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n}\n\n.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item,\n.chat-window .chat-cont-right .chat-body .media.sent .media-body,\n.specialities-section-one .specialities-item {\n  flex-direction: column;\n}\n\n.flag-dropdown .dropdown-toggle {\n  justify-content: start;\n  -webkit-justify-content: start;\n}\n\n.widget-setcount ul,\n.relative-form,\n.prefer-box,\n.onboarding-content-box.content-wrap,\n.left-panel {\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n}\n\n.terms-section .terms-content .terms-text.terms-list p,\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: start;\n}\n\n.chat-window .chat-cont-right .chat-header,\n.chat-window .chat-cont-left .chat-users-list a.media .media-body,\n.chat-window .chat-cont-left .chat-header,\n.listing-day,\n.header.header-ten .menu-header,\n.header-one .menu-header,\n.header .header-nav .menu-header,\n.header .header-nav {\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n\n.store-tab,\n.doctor-divison .pat-background,\n.doctor-divison .doc-background,\n.login-bottom-copyright,\n.custom-increment.cart .input-group1,\n.btn-file,\n.chat-attachment-item,\n.chat-window .chat-cont-right .chat-header .chat-options > a,\n.success-cont i,\n.hours-info .btn.btn-danger.trash,\n.profile-widget .fav-btn,\n.section-specialities .specialities-slider .speicality-item .speicality-img span,\n.header .header-nav .header-navbar-rht li,\n.avatar .avatar-title,\n.btn-icon {\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n\n.increment-decrement .input-groups,\n.login-page .login-right,\n.btn-file,\n.chat-window .chat-msg-info,\n.chat-window .chat-cont-right .chat-header .chat-options > a,\n.chat-window .chat-cont-right .chat-header .media,\n.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend,\n.chat-window .chat-cont-left .chat-header,\n.signature,\n.change-avatar,\n.dash-card .dash-widget,\n.btn.btn-danger.trash,\n.appointments .appointment-action,\n.success-cont i,\n.success-page-cont,\n.header.header-ten .menu-header,\n.header-one .menu-header,\n.header .header-nav .header-navbar-rht .has-arrow.logged-item .nav-link,\n.header .header-nav .header-navbar-rht .has-arrow .logged-item .nav-link,\n.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item,\n.header .header-nav .header-navbar-rht li,\n.header .header-nav .menu-header,\ntable.table td h2.table-avatar,\ntable.table td h2 .table-avatar,\n.avatar .avatar-title,\n.btn-icon {\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n}\n\n.listing-day {\n  -webkit-box-align: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n}\n\n.doctor-divison .pat-background,\n.doctor-divison .doc-background,\n.btn-file,\n.chat-window .chat-cont-right .chat-header .chat-options > a,\n.chat-window .chat-cont-left .chat-header .chat-compose,\n.appointments .appointment-action,\n.success-cont i,\n.profile-widget .fav-btn,\n.section-specialities .specialities-slider .speicality-item .speicality-img span,\n.footer .footer-top .footer-widget .footer-about-content .social-icon ul li a,\n.footer .footer-top .footer-widget .footer-about-content .social-icon ul,\n.header .header-nav .header-navbar-rht .has-arrow.logged-item .nav-link,\n.header .header-nav .header-navbar-rht .has-arrow .logged-item .nav-link,\n.header .header-nav .header-navbar-rht li,\ntable.table td h2.table-avatar,\ntable.table td h2 .table-avatar,\n.avatar-group,\n.btn-icon {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.widget-setcount ul,\n.onboarding-content .increment-decrement .input-groups input[type=\"button\"],\n.relative-form,\n.option-set,\n.select-gender-option,\n.onboarding-contents,\n.opt-resend,\n.set-path,\n.prefer-box,\n.call-lable.verify-lable.verify-options,\n.call-lable.verify-lable.verify-lable,\n.call-lable,\n.consult-option,\n.save-detail,\n.upload-pic.patient-photo-upload,\n.upload-pic,\n.onboarding-content-box.content-wrap,\n.onboarding-progress,\n.on-board-wizard ul li a,\n#onboard-slider .owl-dots,\n.right-panel,\n.left-panel,\n.onboard-wrapper,\n.full-slide-home .slick-slide .slide-image,\n.full-slide-home .slick-slide > div > .col-12,\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul,\n.banner-wrapper .search-box-3 form,\n.map-listing .profile-widget,\n.doctor-widget-one .doc-info-left,\n.doctor-widget-one,\n.clinic-services,\n.doc-info-left,\n.doctor-widget,\n.call-timing,\n.call-details,\n.password-strength,\n.increment-decrement .input-groups,\n.login-bottom-copyright,\n.custom-increment .input-group1,\nchat-attachment-list,\n.chat-msg-attachments,\n.chat-window .chat-msg-info,\n.chat-window .chat-cont-right .chat-body .media.sent .media-body,\n.chat-window .chat-cont-right .chat-header .chat-options,\n.chat-window .chat-cont-left .chat-users-list a.media .media-body,\n.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend,\n.chat-window .chat-cont-left .chat-header,\n.patient-graph-col .graph-box .graph-status-result,\n.patient-graph-col .graph-box,\n.patient-graph-box,\n.patient-dashboard-top,\n.change-avatar,\n.profile-info-widget,\n.dash-card .dash-widget,\n.upload-wrap,\n.review-listing > ul li .comment .comment-body .meta-data .review-count,\n.review-listing > ul li .comment,\n.appointments .appointment-list,\n.appointment-list .profile-info-widget,\n.booking-device,\n.success-page-cont,\n.booking-doc-info,\n.work-info,\n.section-search .banner-wrapper .search-box form,\n.footer-two .footer-top .footer-widget .footer-contact-info .footer-address,\n.footer-one .footer-top .footer-widget .footer-contact-info .footer-address,\n.footer .footer-top .footer-widget .footer-contact-info .footer-address,\n.header.header-ten .main-menu-wrapper .main-nav,\n.header-one .main-menu-wrapper .main-nav,\n.header .header-nav .header-navbar-rht .has-arrow .user-header,\n.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item,\n.header .header-nav .main-nav,\n.header .header-nav,\n.avatar .avatar-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.payment-radio,\n.custom_radio,\n.custom_check,\n.slick-slider {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.right-panel,\n.section-search-pharmacy .banner-wrapper2 .search-box1 form,\n.full-slide-home .slick-slide > div > .col-12,\n.clinic-services,\n.chat-window .chat-msg-info,\n.patient-graph-col .graph-box .graph-status-result,\n.patient-graph-col .graph-box,\n.appointments .appointment-list,\n.schedule-nav .nav-tabs,\n.post-left ul,\n.header.header-ten .header-nav,\n.header-one .header-nav,\n.header .header-nav,\n.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone {\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item,\n.chat-window .chat-cont-right .chat-body .media.sent .media-body,\n.specialities-section-one .specialities-item {\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent .media-body,\n.patient-graph-col .graph-box .graph-status-result {\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent .media-body,\n.patient-graph-col .graph-box .graph-status-result {\n  -webkit-box-align: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n}\n\n.upload-wrap,\n.day-week-month-col ul,\n.payment-menthods ul,\n.step-list ul,\n.header-top ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n/******* BASE *******/\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  border: 0;\n}\n\n* {\n  box-sizing: border-box;\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  height: 100%;\n  overflow-x: hidden;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after {\n  content: \"\";\n  content: none;\n}\n\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n@font-face {\n  font-family: \"Material Icons\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(../fonts/MaterialIcons-Regular.eot); /* For IE6-8 */\n  src:\n    local(\"Material Icons\"),\n    local(\"MaterialIcons-Regular\"),\n    url(../fonts/MaterialIcons-Regular.woff2) format(\"woff2\"),\n    url(../fonts/MaterialIcons-Regular.woff) format(\"woff\"),\n    url(../fonts/MaterialIcons-Regular.ttf) format(\"truetype\");\n}\n.material-icons {\n  font-family: \"Material Icons\";\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  display: inline-block;\n  line-height: 1;\n  text-transform: none;\n  letter-spacing: normal;\n  word-wrap: normal;\n  white-space: nowrap;\n  direction: ltr;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  -moz-osx-font-smoothing: grayscale;\n  font-feature-settings: \"liga\";\n}\n\nh1 {\n  font-weight: normal;\n  font-size: 40px;\n}\n@media (max-width: 767.98px) {\n  h1 {\n    font-size: 27px;\n  }\n}\n\nh2 {\n  font-weight: normal;\n  font-size: 30px;\n}\n@media (max-width: 767.98px) {\n  h2 {\n    font-size: 23px;\n  }\n}\n\nh3 {\n  font-weight: normal;\n  font-size: 24px;\n}\n@media (max-width: 1023.98px) {\n  h3 {\n    font-size: 20px;\n  }\n}\n@media (max-width: 767.98px) {\n  h3 {\n    font-size: 16px;\n  }\n}\n\nh4 {\n  font-weight: normal;\n  font-size: 18px;\n}\n@media (max-width: 1023.98px) {\n  h4 {\n    font-size: 18px;\n  }\n}\n@media (max-width: 767.98px) {\n  h4 {\n    font-size: 18px;\n  }\n}\n\nh5 {\n  font-weight: normal;\n  font-size: 19px;\n}\n@media (max-width: 1023.98px) {\n  h5 {\n    font-size: 18px;\n  }\n}\n\nh6 {\n  font-weight: normal;\n  font-size: 18px;\n}\n@media (max-width: 1023.98px) {\n  h6 {\n    font-size: 16px;\n  }\n}\n\n.primary {\n  background-color: #09e5ab;\n}\n\nhtml {\n  height: 100%;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  background-color: #ffffff;\n  font-size: 0.9375rem;\n  color: #6b7280;\n  line-height: 1.5;\n  height: 100%;\n  overflow-x: hidden;\n}\n@media (max-width: 767.98px) {\n  body {\n    font-size: 14px;\n  }\n}\n@media (max-width: 575.98px) {\n  body {\n    font-size: 13px;\n  }\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\na {\n  color: #2e3842;\n  cursor: pointer;\n  -webkit-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n  text-decoration: none;\n}\na:hover {\n  color: #09e5ab;\n  -webkit-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n  text-decoration: none;\n}\na:focus {\n  outline: 0;\n}\n\n.green .intro_text a:hover {\n  color: #09e5ab;\n  -webkit-transition: all 0.2s ease;\n  -ms-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 16px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: #272b41;\n  font-weight: 500;\n}\n\n.h1,\nh1 {\n  font-size: 2.25rem;\n}\n@media (max-width: 767.98px) {\n  .h1,\n  h1 {\n    font-size: 32px;\n  }\n}\n@media (max-width: 575.98px) {\n  .h1,\n  h1 {\n    font-size: 28px;\n  }\n}\n\n.h2,\nh2 {\n  font-size: 30px;\n}\n@media (max-width: 767.98px) {\n  .h2,\n  h2 {\n    font-size: 28px;\n  }\n}\n@media (max-width: 575.98px) {\n  .h2,\n  h2 {\n    font-size: 24px;\n  }\n}\n\n.h3,\nh3 {\n  font-size: 1.5rem;\n}\n@media (max-width: 767.98px) {\n  .h3,\n  h3 {\n    font-size: 22px;\n  }\n}\n@media (max-width: 575.98px) {\n  .h3,\n  h3 {\n    font-size: 20px;\n  }\n}\n\n.h4,\nh4 {\n  font-size: 18px;\n}\n@media (max-width: 767.98px) {\n  .h4,\n  h4 {\n    font-size: 16px;\n  }\n}\n@media (max-width: 575.98px) {\n  .h4,\n  h4 {\n    font-size: 16px;\n  }\n}\n\n.h5,\nh5 {\n  font-size: 1rem;\n}\n@media (max-width: 767.98px) {\n  .h5,\n  h5 {\n    font-size: 14px;\n  }\n}\n@media (max-width: 575.98px) {\n  .h5,\n  h5 {\n    font-size: 14px;\n  }\n}\n\n.h6,\nh6 {\n  font-size: 14px;\n}\n@media (max-width: 767.98px) {\n  .h6,\n  h6 {\n    font-size: 12px;\n  }\n}\n@media (max-width: 575.98px) {\n  .h6,\n  h6 {\n    font-size: 12px;\n  }\n}\n\n.btn-primary {\n  background-color: #00d0f1;\n  border: 1px solid #00d0f1;\n}\n.btn-primary:hover {\n  background-color: #09dca4;\n  border: 1px solid #09dca4;\n}\n\n.container-fluid {\n  padding: 0 30px;\n}\n@media (max-width: 1199.98px) {\n  .container-fluid {\n    padding: 0 20px;\n  }\n}\n@media (max-width: 991.98px) {\n  .container-fluid {\n    padding: 0 20px;\n  }\n}\n@media (max-width: 767.98px) {\n  .container-fluid {\n    padding: 0 15px;\n  }\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.text-muted {\n  color: #757575 !important;\n}\n\n.dropdown-menu {\n  background-color: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  font-size: 14px;\n  border-radius: 3px;\n  -webkit-box-shadow: inherit;\n  -moz-box-shadow: inherit;\n  box-shadow: inherit;\n  transform-origin: left top 0;\n  -webkit-transform-origin: left top 0;\n  -ms-transform-origin: left top 0;\n}\n\n@media (max-width: 1399.98px) {\n  .row.row-grid {\n    margin-left: -8px;\n    margin-right: -8px;\n  }\n}\n@media (max-width: 1399.98px) {\n  .row.row-grid > div {\n    padding-right: 8px;\n    padding-left: 8px;\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n}\n@media (max-width: 1199.98px) {\n  .row.row-grid > div {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n@media (max-width: 849.98px) {\n  .row.row-grid > div {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n@media (max-width: 767.98px) {\n  .row.row-grid > div {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n@media (max-width: 575.98px) {\n  .row.row-grid > div {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n\n.text-sm {\n  font-size: 14px !important;\n}\n\n.material-icons {\n  font-family: \"Material Icons\";\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  display: inline-block;\n  line-height: 1;\n  text-transform: none;\n  letter-spacing: normal;\n  word-wrap: normal;\n  white-space: nowrap;\n  direction: ltr;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  -moz-osx-font-smoothing: grayscale;\n  font-feature-settings: \"liga\";\n}\n\n.small,\nsmall {\n  font-size: 80%;\n  font-weight: 400;\n}\n\na {\n  color: #2e3842;\n}\na:hover {\n  color: #09dca4;\n}\na:hover,\na:focus,\na.active {\n  outline: none;\n  text-decoration: none;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus {\n  box-shadow: 0 0 0px 1000px white inset !important;\n  -webkit-box-shadow: 0 0 0px 1000px white inset !important;\n}\ninput[type=\"text\"],\ninput[type=\"password\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\ninput,\nbutton,\na {\n  -webkit-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n\nbutton:focus {\n  outline: 0;\n}\n\n.btn:focus,\n.btn.focus {\n  box-shadow: inherit;\n}\n\n.form-control {\n  border-color: #dcdcdc;\n  color: #333333;\n  font-size: 15px;\n  min-height: 46px;\n  padding: 6px 15px;\n}\n.form-control:focus {\n  border-color: #bbb;\n  box-shadow: none;\n  outline: 0 none;\n}\n.form-control::-webkit-input-placeholder,\n.form-control::-moz-placeholder,\n.form-control:-ms-input-placeholder,\n.form-control::-ms-input-placeholder,\n.form-control::placeholder {\n  color: #858585;\n  font-size: 14px;\n}\n.form-control::placeholder {\n  color: #858585;\n  font-size: 14px;\n}\n\n.table .form-control {\n  font-size: 14px;\n  min-height: 38px;\n}\n\n.list-group-item {\n  border: 1px solid #f0f0f0;\n}\n\n@media (max-width: 991.98px) {\n  .container {\n    max-width: 100%;\n  }\n}\n\n.form-custom {\n  position: relative;\n}\n.form-custom i {\n  color: #dd2d4e;\n  position: absolute;\n  top: 35%;\n  right: 15px;\n}\n\n/*** default values ***/\n/***** custom values *****/\n/***** Grid Values *****/\n/** Extends **/\n.upload-wrap,\n.login-page .login-right,\n.listing-day,\n.doctor-action,\n.doc-times,\n.css-equal-heights,\n.css-equal-content {\n  display: flex;\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n}\n\n.css-equal-content {\n  color: red;\n  float: left;\n}\n\n.time-slot li .timing,\n.consultation-types a,\n.coming-soon-info,\n.widget-setcount .step-icon,\n.widget-setcount .step-box,\n.signup-arrow,\n.why-choose-icon span,\n.about-contact-icon span,\n.pricing-icon span,\n.plan-choose-info,\n.product-custom .cart-icon,\n.section-search-pharmacy .banner-wrapper2 .search-box1 form,\n.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two,\n.facts-section-sixteen\n  .facts-section-all\n  .facts-content-all\n  ul\n  li\n  .facts-sixteen-img\n  .facts-content-sixteen\n  .facts-content-one,\n.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-sixteen-img,\n.facts-section-sixteen .facts-section-all .facts-content-all ul li,\n.item.item-fifteen .doctor-profile-widget .doc-pro-img .doctor-amount .fav-icon,\n.doc-content-fift .rate-fifteen ul li,\n.doc-content-fift .rate-fifteen ul,\n.doc-content-fift .rate-fifteen .rate-four,\n.Patients-section-fifteen .service-patient-inflict .clients-fifteen-span,\n.Patients-section-fifteen .service-patient-inflict .service-patient-inflictimg,\n.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg a .playicon span,\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content,\n.section-header-thirteen,\n.main-wrapper.home-twelve.home-thirteen\n  .choose-us-section-thirteen\n  ul\n  li\n  .choose-us-content-thirteen\n  .chooseus-contents,\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  p\n  i,\n.main-wrapper.home-twelve.home-thirteen\n  .services-section-thirteen\n  .service-thirteen-main\n  .service-thirteen-all,\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content,\n.testi-img .testi-icon,\n.faq-wrap ul li a span,\n.count-box .count-icon,\n.center-img .center-service span,\n.main-wrapper.home-ten\n  .specialities-section-one\n  .specialities-block\n  ul\n  li\n  .specialities-img\n  .hexogen,\n.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item,\n.book-section .book-best-doctors .book-header .img-overlay,\n.browse-section .brower-box > div .brower-img,\n.clinic-specialities .special-box:hover .special-body,\n.doctor-category .pop-box .body-section,\n.doctor-category .pop-box .top-section i,\n.doctor-category .pop-box .top-section,\n.doctor-widget-one .clinic-booking .btn-primary-light,\n.view-icons a,\n.voice-call-avatar,\n.toggle-password-sub,\n.pass-group .toggle-password,\n.login-content-info .account-content .social-login-btn .btn,\n.increment-decrement .input-groups input[type=\"button\"],\n.profile-pic-upload .cam-col,\n.step-list ul li a,\n.call-box .call-wrapper .call-items,\n.chat-attachment-item,\n.chat-window .chat-cont-right .chat-header .media .media-img-wrap,\n.chat-window .chat-cont-right .chat-header,\n.chat-window,\n.signature,\n.btn.btn-danger.trash,\n.time-slot.time-slot-blk li .timing,\n.visits span.visit-rsn:before,\n.hours-info .btn.btn-danger.trash,\n.blogs-section .blog-wrapper .wrap-content .date-cart,\n.partners-slider li a,\n.work-info .work-icon span,\n.specialities-section-one .specialities-img span,\n.specialities-section-one .specialities-item,\n.profile-widget .fav-btn,\n.section-specialities .specialities-slider .speicality-item .speicality-img span,\n.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul li a,\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-fift-selects\n  .social-icon\n  ul\n  li\n  a,\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .user-details-fift\n  ul\n  li\n  .contact-fifteen\n  .contact-form-fift,\n.footer-contacts .footer-wrap .footer-icon,\n.footer-three .social-icon ul li a,\n.footer-one .footer-top .footer-widget .footer-contact-info .footer-address p,\n.header.header-fourteen .header-nav .header-navbar-rht li.searchbar-fourteen a,\n.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.searchbar-fourteen,\n.header.header-ten .main-menu-wrapper .main-nav .register-btn,\n.header.header-ten .main-menu-wrapper .main-nav li .btn.log-btn,\n.header.header-ten .main-menu-wrapper .main-nav li .btn.reg-btn,\n.header-one .main-menu-wrapper .main-nav .register-btn,\n.header-one .main-menu-wrapper .main-nav li .btn.log-btn,\n.header-one .main-menu-wrapper .main-nav li .btn.reg-btn,\n.header.custom .header-navbar-rht.right-menu .header-contact-img i,\n.header .header-nav,\n.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone,\n.brower-box a,\n.clinic-slider .profile-widget .brower-box .arrow,\n.browse-slider .profile-widget .brower-box .arrow,\n.book-slider .profile-widget .brower-box .arrow,\n.clinic-slider .profile-widget .brower-box a,\n.browse-slider .profile-widget .brower-box a,\n.book-slider .profile-widget .brower-box a,\n.slick-dots .slick-dots li,\n.dot-slider .slick-dots li,\n.align-center {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n\n.form-group-flex,\n.otp-info,\n.otp-box .form-group,\n.signup-option-btns .signup-btn-info,\n.booking-list,\n.doc-content-fift .fift-bottom-content,\n.doc-content-fift .rate-fifteen,\n.services-section-fifteen .doctor-profile-widget-fifteen .doc-content-bottom .doc-content-split,\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  .our-doctor-content-inner,\n.store-item .store-content .price-tag,\n.testi-users,\n.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay,\n.doctor-filter-inner,\n.booking-doctor-details,\n.faq-patients-count,\n.doc-pro-info,\n.footer-three .footer-bottom .copyright .footer-language,\n.header.header-ten .header-nav,\n.header-one .header-nav {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n}\n\n.terms-btn .btn,\n.otp-sec p,\n.testimonial-slider .slick-prev,\n.testimonial-slider .slick-next,\n.special-item .special-icon a,\n.doctor-profile-widget.doc-grid .favourite-btn .favourite-icon,\n.doctor-widget-one .favourite-btn .favourite-icon,\n.doctor-filter-sort .nav li a,\n.faq-info .accordion-button:after,\n.reviews-ratings span,\n.slide-nav-1 button.owl-next,\n.slide-nav-1 button.owl-prev,\n.slide-nav-2 button.owl-next,\n.slide-nav-2 button.owl-prev {\n  display: inline-flex;\n  display: -webkit-inline-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n\n.widget-setcount ul,\n.onboarding-content .increment-decrement .input-groups input[type=\"button\"],\n.relative-form,\n.option-set,\n.select-gender-option,\n.onboarding-contents,\n.opt-resend,\n.set-path,\n.prefer-box,\n.call-lable.verify-lable.verify-options,\n.call-lable.verify-lable.verify-lable,\n.call-lable,\n.consult-option,\n.save-detail,\n.upload-pic.patient-photo-upload,\n.upload-pic,\n.onboarding-content-box.content-wrap,\n.onboarding-progress,\n.on-board-wizard ul li a,\n#onboard-slider .owl-dots,\n.right-panel,\n.left-panel,\n.onboard-wrapper,\n.full-slide-home .slick-slide .slide-image,\n.full-slide-home .slick-slide > div > .col-12,\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul,\n.banner-wrapper .search-box-3 form,\n.map-listing .profile-widget,\n.doctor-widget-one .doc-info-left,\n.doctor-widget-one,\n.clinic-services,\n.doc-info-left,\n.doctor-widget,\n.call-timing,\n.call-details,\n.password-strength,\n.increment-decrement .input-groups,\n.login-bottom-copyright,\n.custom-increment .input-group1,\nchat-attachment-list,\n.chat-msg-attachments,\n.chat-window .chat-msg-info,\n.chat-window .chat-cont-right .chat-body .media.sent .media-body,\n.chat-window .chat-cont-right .chat-header .chat-options,\n.chat-window .chat-cont-left .chat-users-list a.media .media-body,\n.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend,\n.chat-window .chat-cont-left .chat-header,\n.patient-graph-col .graph-box .graph-status-result,\n.patient-graph-col .graph-box,\n.patient-graph-box,\n.patient-dashboard-top,\n.change-avatar,\n.profile-info-widget,\n.dash-card .dash-widget,\n.upload-wrap,\n.review-listing > ul li .comment .comment-body .meta-data .review-count,\n.review-listing > ul li .comment,\n.appointments .appointment-list,\n.appointment-list .profile-info-widget,\n.booking-device,\n.success-page-cont,\n.booking-doc-info,\n.work-info,\n.section-search .banner-wrapper .search-box form,\n.footer-two .footer-top .footer-widget .footer-contact-info .footer-address,\n.footer-one .footer-top .footer-widget .footer-contact-info .footer-address,\n.footer .footer-top .footer-widget .footer-contact-info .footer-address,\n.header.header-ten .main-menu-wrapper .main-nav,\n.header-one .main-menu-wrapper .main-nav,\n.header .header-nav .header-navbar-rht .has-arrow .user-header,\n.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item,\n.header .header-nav .main-nav,\n.header .header-nav,\n.avatar .avatar-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.success-btn .btn,\n.terms-section .terms-content .terms-text.terms-list p,\n.error-content .btn,\n.way-inner-header .btn,\n.breadcrumb-bar-two .page-breadcrumb ol,\n.booking-btn .btn,\n.doctor-search-section.doctor-search-eleven .banner-header .btn,\n.breadcrumb-bar-one .page-breadcrumb ol,\n.specialities-section-one .specialities-btn .btn,\n.footer-one .social-icon ul li a,\n.footer-one .social-icon ul,\n.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul li a,\n.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.booking-date,\n.consultation-types,\n.contact-card .card-body,\n.signup-info,\n.testimonial-info,\n.about-contact,\n.pricing-header-info,\n.booking-doctor-right p,\n.booking-doctor-left,\n.faq-wrap ul li a,\n.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name,\n.count-box,\n.doctor-widget-one .clini-infos ul li,\n.doctor-widget-one .doc-location,\n.doctor-filter-sort,\n.doctor-filter-option,\n.doctor-filter-availability,\n.filter-grid h4 a,\n.booking-range .btn,\n.booking-date.choose-date-book,\n.articles-info,\n.doc-pro-location p,\n.footer-contacts .footer-wrap,\n.footer-one .footer-top .footer-widget.footer-menu ul li a,\n.flag-dropdown .dropdown-menu .dropdown-item,\n.flag-dropdown .dropdown-toggle {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n}\n\n.success-dashboard-link a,\n.custom_radio,\n.booking-date-list ul li span,\n.center-img .center-service,\n.doctor-widget-one .doc-name,\n.login-content-info .account-content .login-back a,\n.back-link a,\n.articles-content .articles-list li,\n.reviews-ratings p {\n  display: inline-flex;\n  display: -webkit-inline-flex;\n  align-items: center;\n  -webkit-align-items: center;\n}\n\n.widget-setcount ul,\n.booking-list {\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n}\n\n.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item,\n.chat-window .chat-cont-right .chat-body .media.sent .media-body,\n.specialities-section-one .specialities-item {\n  flex-direction: column;\n}\n\n.flag-dropdown .dropdown-toggle {\n  justify-content: start;\n  -webkit-justify-content: start;\n}\n\n.widget-setcount ul,\n.relative-form,\n.prefer-box,\n.onboarding-content-box.content-wrap,\n.left-panel {\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n}\n\n.terms-section .terms-content .terms-text.terms-list p,\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: start;\n}\n\n.chat-window .chat-cont-right .chat-header,\n.chat-window .chat-cont-left .chat-users-list a.media .media-body,\n.chat-window .chat-cont-left .chat-header,\n.listing-day,\n.header.header-ten .menu-header,\n.header-one .menu-header,\n.header .header-nav .menu-header,\n.header .header-nav {\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n\n.store-tab,\n.doctor-divison .pat-background,\n.doctor-divison .doc-background,\n.login-bottom-copyright,\n.custom-increment.cart .input-group1,\n.btn-file,\n.chat-attachment-item,\n.chat-window .chat-cont-right .chat-header .chat-options > a,\n.success-cont i,\n.hours-info .btn.btn-danger.trash,\n.profile-widget .fav-btn,\n.section-specialities .specialities-slider .speicality-item .speicality-img span,\n.header .header-nav .header-navbar-rht li,\n.avatar .avatar-title,\n.btn-icon {\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n\n.increment-decrement .input-groups,\n.login-page .login-right,\n.btn-file,\n.chat-window .chat-msg-info,\n.chat-window .chat-cont-right .chat-header .chat-options > a,\n.chat-window .chat-cont-right .chat-header .media,\n.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend,\n.chat-window .chat-cont-left .chat-header,\n.signature,\n.change-avatar,\n.dash-card .dash-widget,\n.btn.btn-danger.trash,\n.appointments .appointment-action,\n.success-cont i,\n.success-page-cont,\n.header.header-ten .menu-header,\n.header-one .menu-header,\n.header .header-nav .header-navbar-rht .has-arrow.logged-item .nav-link,\n.header .header-nav .header-navbar-rht .has-arrow .logged-item .nav-link,\n.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item,\n.header .header-nav .header-navbar-rht li,\n.header .header-nav .menu-header,\ntable.table td h2.table-avatar,\ntable.table td h2 .table-avatar,\n.avatar .avatar-title,\n.btn-icon {\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n}\n\n.listing-day {\n  -webkit-box-align: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n}\n\n.doctor-divison .pat-background,\n.doctor-divison .doc-background,\n.btn-file,\n.chat-window .chat-cont-right .chat-header .chat-options > a,\n.chat-window .chat-cont-left .chat-header .chat-compose,\n.appointments .appointment-action,\n.success-cont i,\n.profile-widget .fav-btn,\n.section-specialities .specialities-slider .speicality-item .speicality-img span,\n.footer .footer-top .footer-widget .footer-about-content .social-icon ul li a,\n.footer .footer-top .footer-widget .footer-about-content .social-icon ul,\n.header .header-nav .header-navbar-rht .has-arrow.logged-item .nav-link,\n.header .header-nav .header-navbar-rht .has-arrow .logged-item .nav-link,\n.header .header-nav .header-navbar-rht li,\ntable.table td h2.table-avatar,\ntable.table td h2 .table-avatar,\n.avatar-group,\n.btn-icon {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.widget-setcount ul,\n.onboarding-content .increment-decrement .input-groups input[type=\"button\"],\n.relative-form,\n.option-set,\n.select-gender-option,\n.onboarding-contents,\n.opt-resend,\n.set-path,\n.prefer-box,\n.call-lable.verify-lable.verify-options,\n.call-lable.verify-lable.verify-lable,\n.call-lable,\n.consult-option,\n.save-detail,\n.upload-pic.patient-photo-upload,\n.upload-pic,\n.onboarding-content-box.content-wrap,\n.onboarding-progress,\n.on-board-wizard ul li a,\n#onboard-slider .owl-dots,\n.right-panel,\n.left-panel,\n.onboard-wrapper,\n.full-slide-home .slick-slide .slide-image,\n.full-slide-home .slick-slide > div > .col-12,\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul,\n.banner-wrapper .search-box-3 form,\n.map-listing .profile-widget,\n.doctor-widget-one .doc-info-left,\n.doctor-widget-one,\n.clinic-services,\n.doc-info-left,\n.doctor-widget,\n.call-timing,\n.call-details,\n.password-strength,\n.increment-decrement .input-groups,\n.login-bottom-copyright,\n.custom-increment .input-group1,\nchat-attachment-list,\n.chat-msg-attachments,\n.chat-window .chat-msg-info,\n.chat-window .chat-cont-right .chat-body .media.sent .media-body,\n.chat-window .chat-cont-right .chat-header .chat-options,\n.chat-window .chat-cont-left .chat-users-list a.media .media-body,\n.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend,\n.chat-window .chat-cont-left .chat-header,\n.patient-graph-col .graph-box .graph-status-result,\n.patient-graph-col .graph-box,\n.patient-graph-box,\n.patient-dashboard-top,\n.change-avatar,\n.profile-info-widget,\n.dash-card .dash-widget,\n.upload-wrap,\n.review-listing > ul li .comment .comment-body .meta-data .review-count,\n.review-listing > ul li .comment,\n.appointments .appointment-list,\n.appointment-list .profile-info-widget,\n.booking-device,\n.success-page-cont,\n.booking-doc-info,\n.work-info,\n.section-search .banner-wrapper .search-box form,\n.footer-two .footer-top .footer-widget .footer-contact-info .footer-address,\n.footer-one .footer-top .footer-widget .footer-contact-info .footer-address,\n.footer .footer-top .footer-widget .footer-contact-info .footer-address,\n.header.header-ten .main-menu-wrapper .main-nav,\n.header-one .main-menu-wrapper .main-nav,\n.header .header-nav .header-navbar-rht .has-arrow .user-header,\n.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item,\n.header .header-nav .main-nav,\n.header .header-nav,\n.avatar .avatar-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.payment-radio,\n.custom_radio,\n.custom_check,\n.slick-slider {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.right-panel,\n.section-search-pharmacy .banner-wrapper2 .search-box1 form,\n.full-slide-home .slick-slide > div > .col-12,\n.clinic-services,\n.chat-window .chat-msg-info,\n.patient-graph-col .graph-box .graph-status-result,\n.patient-graph-col .graph-box,\n.appointments .appointment-list,\n.schedule-nav .nav-tabs,\n.post-left ul,\n.header.header-ten .header-nav,\n.header-one .header-nav,\n.header .header-nav,\n.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone {\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item,\n.chat-window .chat-cont-right .chat-body .media.sent .media-body,\n.specialities-section-one .specialities-item {\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent .media-body,\n.patient-graph-col .graph-box .graph-status-result {\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent .media-body,\n.patient-graph-col .graph-box .graph-status-result {\n  -webkit-box-align: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n}\n\n.upload-wrap,\n.day-week-month-col ul,\n.payment-menthods ul,\n.step-list ul,\n.header-top ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.col {\n  width: auto;\n  padding-left: 15px;\n  padding-right: 15px;\n  float: left;\n  position: relative;\n  min-height: 1px;\n}\n@media (min-width: 320px) {\n  .col.col-xs-12 {\n    width: 100%;\n  }\n  .col.col-xs-11 {\n    width: 91.66666667%;\n  }\n  .col.col-xs-10 {\n    width: 83.33333333%;\n  }\n  .col.col-xs-9 {\n    width: 75%;\n  }\n  .col.col-xs-8 {\n    width: 66.66666667%;\n  }\n  .col.col-xs-7 {\n    width: 58.33333333%;\n  }\n  .col.col-xs-6 {\n    width: 50%;\n  }\n  .col.col-xs-5 {\n    width: 41.66666667%;\n  }\n  .col.col-xs-4 {\n    width: 33.33333333%;\n  }\n  .col.col-xs-3 {\n    width: 25%;\n  }\n  .col.col-xs-2 {\n    width: 16.66666667%;\n  }\n  .col.col-xs-1 {\n    width: 8.33333333%;\n  }\n}\n@media (min-width: 568px) {\n  .col.col-sm-12 {\n    width: 100%;\n  }\n  .col.col-sm-11 {\n    width: 91.66666667%;\n  }\n  .col.col-sm-10 {\n    width: 83.33333333%;\n  }\n  .col.col-sm-9 {\n    width: 75%;\n  }\n  .col.col-sm-8 {\n    width: 66.66666667%;\n  }\n  .col.col-sm-7 {\n    width: 58.33333333%;\n  }\n  .col.col-sm-6 {\n    width: 50%;\n  }\n  .col.col-sm-5 {\n    width: 41.66666667%;\n  }\n  .col.col-sm-4 {\n    width: 33.33333333%;\n  }\n  .col.col-sm-3 {\n    width: 25%;\n  }\n  .col.col-sm-2 {\n    width: 16.66666667%;\n  }\n  .col.col-sm-1 {\n    width: 8.33333333%;\n  }\n}\n@media (min-width: 768px) {\n  .col.col-md-12 {\n    width: 100%;\n  }\n  .col.col-md-11 {\n    width: 91.66666667%;\n  }\n  .col.col-md-10 {\n    width: 83.33333333%;\n  }\n  .col.col-md-9 {\n    width: 75%;\n  }\n  .col.col-md-8 {\n    width: 66.66666667%;\n  }\n  .col.col-md-7 {\n    width: 58.33333333%;\n  }\n  .col.col-md-6 {\n    width: 50%;\n  }\n  .col.col-md-5 {\n    width: 41.66666667%;\n  }\n  .col.col-md-4 {\n    width: 33.33333333%;\n  }\n  .col.col-md-3 {\n    width: 25%;\n  }\n  .col.col-md-2 {\n    width: 16.66666667%;\n  }\n  .col.col-md-1 {\n    width: 8.33333333%;\n  }\n}\n@media (min-width: 1024px) {\n  .col.col-lg-12 {\n    width: 100%;\n  }\n  .col.col-lg-11 {\n    width: 91.66666667%;\n  }\n  .col.col-lg-10 {\n    width: 83.33333333%;\n  }\n  .col.col-lg-9 {\n    width: 75%;\n  }\n  .col.col-lg-8 {\n    width: 66.66666667%;\n  }\n  .col.col-lg-7 {\n    width: 58.33333333%;\n  }\n  .col.col-lg-6 {\n    width: 50%;\n  }\n  .col.col-lg-5 {\n    width: 41.66666667%;\n  }\n  .col.col-lg-4 {\n    width: 33.33333333%;\n  }\n  .col.col-lg-3 {\n    width: 25%;\n  }\n  .col.col-lg-2 {\n    width: 16.66666667%;\n  }\n  .col.col-lg-1 {\n    width: 8.33333333%;\n  }\n}\n\n/******* COMPONENTS ******/\n.view-btn {\n  color: #0de0fe;\n  font-size: 13px;\n  border: 2px solid #0de0fe;\n  text-align: center;\n  display: block;\n  font-weight: 500;\n  padding: 6px;\n}\n.view-btn:hover,\n.view-btn:focus {\n  background-color: #0de0fe;\n  color: #ffffff;\n}\n\n.book-btn {\n  background-color: #0de0fe;\n  border: 2px solid #0de0fe;\n  color: #ffffff;\n  font-size: 13px;\n  text-align: center;\n  display: block;\n  font-weight: 500;\n  padding: 6px;\n}\n.book-btn:hover,\n.book-btn:focus {\n  background-color: #01cae4;\n  border-color: #01cae4;\n  color: #ffffff;\n}\n\n.submit-btn-bottom {\n  margin-bottom: 30px;\n}\n@media (max-width: 767.98px) {\n  .submit-btn-bottom {\n    margin-bottom: 20px;\n  }\n}\n@media (max-width: 575.98px) {\n  .submit-btn-bottom {\n    margin-bottom: 0.9375rem;\n  }\n}\n\n.bg-info-light {\n  background-color: rgba(2, 182, 179, 0.12) !important;\n  color: #1db9aa !important;\n}\n\n.bg-primary-light {\n  background-color: rgba(17, 148, 247, 0.12) !important;\n  color: #2196f3 !important;\n}\n\n.bg-danger-light {\n  background-color: rgba(242, 17, 54, 0.12) !important;\n  color: #e63c3c !important;\n}\n\n.bg-warning-light {\n  background-color: rgba(255, 152, 0, 0.12) !important;\n  color: #f39c12 !important;\n}\n\n.bg-success-light {\n  background-color: rgba(15, 183, 107, 0.12) !important;\n  color: #26af48 !important;\n}\n\n.bg-purple-light {\n  background-color: rgba(197, 128, 255, 0.12) !important;\n  color: #c580ff !important;\n}\n\n.bg-default-light {\n  background-color: rgba(40, 52, 71, 0.12) !important;\n  color: #283447 !important;\n}\n\n.change-photo-btn {\n  background-color: #20c0f3;\n  color: #ffffff;\n  cursor: pointer;\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  position: relative;\n  text-align: center;\n  width: 220px;\n  -webkit-transition: 0.3s;\n  -ms-transition: 0.3s;\n  transition: 0.3s;\n  border-radius: 50px;\n  margin: 0 auto;\n  padding: 10px 15px;\n}\n\n.btn-icon {\n  text-align: center;\n  font-size: 10px;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  position: absolute;\n  top: 3px;\n  right: 3px;\n}\n\n.btn-facebook {\n  background-color: #3a559f;\n  color: #ffffff;\n  font-size: 13px;\n  padding: 8px 12px;\n}\n\n.btn-google {\n  background-color: #dd4b39;\n  color: #ffffff;\n  font-size: 13px;\n  padding: 8px 12px;\n}\n\n.view-inv-btn {\n  font-size: 16px;\n  font-weight: 700;\n  padding: 12px 30px;\n}\n@media (max-width: 767.98px) {\n  .view-inv-btn {\n    font-size: 14px;\n    padding: 10px 30px;\n  }\n}\n\n.banner-btn {\n  background: #1c5b90;\n  border-radius: 130px;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 20px 30px;\n  width: 100%;\n}\n.banner-btn:hover {\n  background: #10defd;\n  color: #ffffff;\n}\n\n.book-btn1 {\n  background-color: #0de0fe;\n  border: 2px solid #0de0fe;\n  color: #ffffff;\n  font-size: 16px;\n  text-align: center;\n  font-weight: 500;\n  padding: 6px 10px;\n}\n.book-btn1:hover {\n  background-color: #01cae4;\n  border-color: #01cae4;\n  color: #ffffff;\n}\n\n.search-btn {\n  width: 100%;\n  margin-top: 15px;\n}\n\n.mouse-cursor {\n  position: fixed;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n  border-radius: 50%;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  visibility: hidden;\n}\n\n.cursor-inner {\n  margin-left: -4px;\n  margin-top: -4px;\n  width: 10px;\n  height: 10px;\n  z-index: 10000001;\n  background: #0e82fd !important;\n  -webkit-transition:\n    width 0.3s ease-in-out,\n    height 0.3s ease-in-out,\n    margin 0.3s ease-in-out,\n    opacity 0.3s ease-in-out;\n  transition:\n    width 0.3s ease-in-out,\n    height 0.3s ease-in-out,\n    margin 0.3s ease-in-out,\n    opacity 0.3s ease-in-out;\n}\n.cursor-inner.cursor-hover {\n  margin-left: -20px;\n  margin-top: -20px;\n  width: 40px;\n  height: 40px;\n  background: #0e82fd !important;\n  opacity: 0.1;\n}\n\n.cursor-outer {\n  margin-left: -15px;\n  margin-top: -15px;\n  width: 30px;\n  height: 30px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  z-index: 10000000;\n  opacity: 0.5;\n  border: 2px solid #0e82fd;\n  transform: all 0.08s ease-out;\n  -webkit-transform: all 0.08s ease-out;\n  -ms-transform: all 0.08s ease-out;\n}\n.cursor-outer.cursor-hover {\n  opacity: 0;\n}\n\n.mim_tm_all_wrap[data-magic-cursor=\"hide\"] .mouse-cursor {\n  display: none;\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n  z-index: -1111;\n}\n\n.progress-wrap {\n  position: fixed;\n  right: 25px;\n  bottom: 25px;\n  height: 35px;\n  width: 35px;\n  cursor: pointer;\n  display: block;\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 2px rgba(75, 64, 237, 0.2);\n  z-index: 99;\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: all 200ms linear;\n  transition: all 200ms linear;\n  transform: translateY(15px);\n  -webkit-transform: translateY(15px);\n  -moz-transform: translateY(15px);\n  -ms-transform: translateY(15px);\n  -o-transform: translateY(15px);\n}\n.progress-wrap.active-progress {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n.progress-wrap::after {\n  position: absolute;\n  content: \"\\f062\";\n  font-family: \"FontAwesome\";\n  text-align: center;\n  line-height: 35px;\n  font-size: 17px;\n  color: #0e82fd;\n  left: 0;\n  top: 0;\n  height: 35px;\n  width: 35px;\n  cursor: pointer;\n  display: block;\n  z-index: 1;\n  -webkit-transition: all 200ms linear;\n  transition: all 200ms linear;\n}\n.progress-wrap svg path {\n  fill: none;\n}\n.progress-wrap svg.progress-circle path {\n  stroke: #0e82fd;\n  stroke-width: 4;\n  box-sizing: border-box;\n  -webkit-transition: all 200ms linear;\n  transition: all 200ms linear;\n}\n\n.check {\n  display: block;\n  margin: 0;\n  padding: 0;\n  width: 0;\n  height: 0;\n  visibility: hidden;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n}\n.check:checked + .checktoggle {\n  background-color: #008f64;\n  border: 1px solid #008f64;\n}\n.check:checked + .checktoggle:after {\n  background-color: #ffffff;\n  left: 100%;\n  transform: translate(calc(-100% - 5px), -50%);\n  -webkit-transform: translate(calc(-100% - 5px), -50%);\n  -ms-transform: translate(calc(-100% - 5px), -50%);\n}\n\n.checktoggle {\n  background-color: #ff3535;\n  border: 1px solid #ff3535;\n  border-radius: 12px;\n  cursor: pointer;\n  display: block;\n  font-size: 0;\n  height: 24px;\n  margin-bottom: 0;\n  position: relative;\n  width: 42px;\n}\n.checktoggle:after {\n  content: \" \";\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translate(5px, -50%);\n  -webkit-transform: translate(5px, -50%);\n  -ms-transform: translate(5px, -50%);\n  width: 14px;\n  height: 14px;\n  background-color: #ffffff;\n  border-radius: 50%;\n  transition:\n    left 300ms ease,\n    transform 300ms ease;\n}\n\n.status-toggle .check:checked + .checktoggle {\n  background-color: #28a745;\n  border: 1px solid #28a745;\n}\n.status-toggle .check:checked + .checktoggle:after {\n  transform: translate(calc(-100% - 2px), -50%);\n  -webkit-transform: translate(calc(-100% - 2px), -50%);\n  -ms-transform: translate(calc(-100% - 2px), -50%);\n}\n.status-toggle .checktoggle {\n  width: 41px;\n  height: 21px;\n}\n.status-toggle .checktoggle::after {\n  width: 17px;\n  height: 17px;\n  transform: translate(2px, -50%);\n  -webkit-transform: translate(2px, -50%);\n  -ms-transform: translate(2px, -50%);\n}\n\n.status-tog .checktoggle {\n  height: 28px;\n  width: 50px;\n  border-radius: 999px;\n  background-color: #f3f4f6;\n  border-color: #f3f4f6;\n}\n.status-tog .checktoggle:before {\n  content: \" \";\n  display: block;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  background-image: url(../images/icons/check.svg);\n  background-repeat: no-repeat;\n  background-size: 11px 20px;\n  width: 20px;\n  height: 20px;\n  transform: translate(3px, -50%);\n}\n.status-tog .checktoggle:after {\n  width: 24px;\n  height: 24px;\n  background-image: url(../images/icons/x-icon.svg);\n  background-repeat: no-repeat;\n  background-size: 12px 21px;\n  transform: translate(1px, -50%);\n  background-position: center;\n  box-shadow:\n    0px 1px 2px rgba(0, 0, 0, 0.1),\n    0px 1px 1px rgba(0, 0, 0, 0.06);\n}\n.status-tog .check:checked + .checktoggle:before {\n  content: \" \";\n  display: block;\n  position: absolute;\n  left: 0;\n  background-image: url(../images/icons/x-icon.svg);\n  background-repeat: no-repeat;\n  background-size: 13px 21px;\n  width: 20px;\n  height: 20px;\n  filter: brightness(0) invert(1);\n}\n.status-tog .check:checked + .checktoggle:after {\n  background-image: url(../images/icons/check.svg);\n  background-repeat: no-repeat;\n  background-size: 12px 21px;\n  transform: translate(calc(-100% - 1px), -50%);\n  background-position: center;\n}\n\n.bootstrap-tagsinput {\n  display: block;\n  border-radius: 5px;\n  background: #ffffff;\n  border: 1px solid #e4e4e8;\n  height: 46px;\n  margin: 0;\n  padding: 4px 10px 0 10px;\n  width: 100%;\n  box-shadow: none;\n  overflow-y: auto;\n}\n.bootstrap-tagsinput .tag {\n  margin-right: 5px;\n  margin-bottom: 2px;\n  color: #a9a9a9;\n  background: #f4f4f4 !important;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 5px;\n}\n.bootstrap-tagsinput .tag:hover {\n  color: #a9a9a9;\n}\n.bootstrap-tagsinput .tag [data-role=\"remove\"] {\n  position: relative;\n  left: 7px;\n  cursor: pointer;\n}\n.bootstrap-tagsinput .tag [data-role=\"remove\"]:after {\n  content: \"x\";\n  margin: 0;\n  padding: 0px 2px;\n}\n.bootstrap-tagsinput input {\n  line-height: 36px;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.bootstrap-tagsinput input:focus-visible {\n  border: 1px solid transparent;\n}\n\n/****** LAYOUT ******/\n.btn.focus,\n.btn:focus {\n  box-shadow: unset;\n}\n.btn.btn-rounded {\n  border-radius: 50px;\n}\n\n.btn-white {\n  background-color: #ffffff;\n  border: 1px solid #cccccc;\n  color: #272b41;\n}\n\n.bg-primary,\n.badge-primary {\n  background-color: #09e5ab !important;\n}\n\na.bg-primary:focus,\na.bg-primary:hover,\nbutton.bg-primary:focus,\nbutton.bg-primary:hover {\n  background-color: #09dca4 !important;\n}\n\n.bg-success,\n.badge-success {\n  background-color: #00e65b !important;\n}\n\na.bg-success:focus,\na.bg-success:hover,\nbutton.bg-success:focus,\nbutton.bg-success:hover {\n  background-color: #00cc52 !important;\n}\n\n.bg-info,\n.badge-info {\n  background-color: #009efb !important;\n}\n\na.bg-info:focus,\na.bg-info:hover,\nbutton.bg-info:focus,\nbutton.bg-info:hover {\n  background-color: #028ee1 !important;\n}\n\n.bg-warning,\n.badge-warning {\n  background-color: #ffbc34 !important;\n}\n\na.bg-warning:focus,\na.bg-warning:hover,\nbutton.bg-warning:focus,\nbutton.bg-warning:hover {\n  background-color: #e9ab2e !important;\n}\n\n.bg-danger,\n.badge-danger {\n  background-color: #ff0100 !important;\n}\n\na.bg-danger:focus,\na.bg-danger:hover,\nbutton.bg-danger:focus,\nbutton.bg-danger:hover {\n  background-color: #e63333 !important;\n}\n\n.bg-white {\n  background-color: #ffffff;\n}\n\n.bg-purple,\n.badge-purple {\n  background-color: #9368e9 !important;\n}\n\n.text-primary {\n  color: #09e5ab !important;\n}\n\n.dropdown-menu li > a.text-primary {\n  color: #09e5ab !important;\n}\n.dropdown-menu li > a.text-success {\n  color: #00cc52 !important;\n}\n.dropdown-menu li > a.text-danger {\n  color: #ff0100 !important;\n}\n.dropdown-menu li > a.text-info {\n  color: #009efb !important;\n}\n.dropdown-menu li > a.text-warning {\n  color: #ffbc34 !important;\n}\n.dropdown-menu li > a.text-purple {\n  color: #7460ee !important;\n}\n\n.text-success {\n  color: #00cc52 !important;\n}\n\n.text-danger {\n  color: #ff0100 !important;\n}\n\n.text-info {\n  color: #009efb !important;\n}\n\n.text-warning {\n  color: #ffbc34 !important;\n}\n\n.text-purple {\n  color: #7460ee !important;\n}\n\n.text-muted {\n  color: #757575 !important;\n}\n\n.btn-primary {\n  background-color: #00d0f1;\n  border: 1px solid #00d0f1;\n}\n.btn-primary:focus,\n.btn-primary:hover,\n.btn-primary:active,\n.btn-primary.active {\n  color: #ffffff;\n  background-color: #09dca4;\n  border-color: #09dca4;\n}\n.btn-primary:focus .open > .dropdown-toggle.btn-primary,\n.btn-primary:hover .open > .dropdown-toggle.btn-primary,\n.btn-primary:active .open > .dropdown-toggle.btn-primary,\n.btn-primary.active .open > .dropdown-toggle.btn-primary {\n  background-color: #09dca4;\n  border: 1px solid #09dca4;\n}\n.btn-primary.active.focus .open > .dropdown-toggle.btn-primary.focus,\n.btn-primary.active.focus .open > .dropdown-toggle.btn-primary:focus,\n.btn-primary.active.focus .open > .dropdown-toggle.btn-primary:hover,\n.btn-primary.active:focus .open > .dropdown-toggle.btn-primary.focus,\n.btn-primary.active:focus .open > .dropdown-toggle.btn-primary:focus,\n.btn-primary.active:focus .open > .dropdown-toggle.btn-primary:hover,\n.btn-primary.active:hover .open > .dropdown-toggle.btn-primary.focus,\n.btn-primary.active:hover .open > .dropdown-toggle.btn-primary:focus,\n.btn-primary.active:hover .open > .dropdown-toggle.btn-primary:hover,\n.btn-primary .focus.focus .open > .dropdown-toggle.btn-primary.focus,\n.btn-primary .focus.focus .open > .dropdown-toggle.btn-primary:focus,\n.btn-primary .focus.focus .open > .dropdown-toggle.btn-primary:hover,\n.btn-primary .focus:focus .open > .dropdown-toggle.btn-primary.focus,\n.btn-primary .focus:focus .open > .dropdown-toggle.btn-primary:focus,\n.btn-primary .focus:focus .open > .dropdown-toggle.btn-primary:hover,\n.btn-primary .focus:hover .open > .dropdown-toggle.btn-primary.focus,\n.btn-primary .focus:hover .open > .dropdown-toggle.btn-primary:focus,\n.btn-primary .focus:hover .open > .dropdown-toggle.btn-primary:hover {\n  background-color: #09dca4;\n  border: 1px solid #09dca4;\n}\n.btn-primary:active:focus,\n.btn-primary:active:hover {\n  background-color: #09dca4;\n  border: 1px solid #09dca4;\n}\n.btn-primary .active:not(:disabled):not(.disabled),\n.btn-primary:active:not(:disabled):not(.disabled) {\n  background-color: #09dca4;\n  border-color: #09dca4;\n  color: #ffffff;\n}\n.btn-primary .active:focus:not(:disabled):not(.disabled),\n.btn-primary:active:focus:not(:disabled):not(.disabled) {\n  box-shadow: unset;\n}\n.btn-primary .show > .btn-primary.dropdown-toggle {\n  background-color: #09dca4;\n  border-color: #09dca4;\n  color: #ffffff;\n}\n.btn-primary .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.btn-primary.disabled,\n.btn-primary:disabled {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n  color: #ffffff;\n}\n\n.btn-secondary.active:focus :not(:disabled):not(.disabled),\n.btn-secondary:active:focus :not(:disabled):not(.disabled) {\n  box-shadow: unset;\n}\n\n.show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.show > .btn-success.dropdown-toggle {\n  background-color: #00cc52;\n  border-color: #00cc52;\n  color: #ffffff;\n}\n.show > .btn-success.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.show > .btn-info.dropdown-toggle {\n  background-color: #028ee1;\n  border-color: #028ee1;\n  color: #ffffff;\n}\n.show > .btn-info.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.show > .btn-warning.dropdown-toggle {\n  background-color: #e9ab2e;\n  border-color: #e9ab2e;\n  color: #ffffff;\n}\n.show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.show > .btn-danger.dropdown-toggle {\n  background-color: #e63333;\n  border-color: #e63333;\n  color: #ffffff;\n}\n.show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.show > .btn-light.dropdown-toggle:focus,\n.show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.show > .btn-outline-primary.dropdown-toggle {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n}\n.show > .btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: none;\n}\n.show > .btn-outline-success.dropdown-toggle {\n  background-color: #00e65b;\n  border-color: #00e65b;\n}\n.show > .btn-outline-success.dropdown-toggle:focus {\n  box-shadow: none;\n}\n.show > .btn-outline-info.dropdown-toggle {\n  background-color: #009efb;\n  border-color: #009efb;\n}\n.show > .btn-outline-info.dropdown-toggle:focus {\n  box-shadow: none;\n}\n.show > .btn-outline-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n}\n.show > .btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: none;\n}\n.show > .btn-outline-danger.dropdown-toggle {\n  color: #212529;\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n}\n.show > .btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: none;\n}\n\n.btn-success {\n  background-color: #00e65b;\n  border: 1px solid #00e65b;\n}\n.btn-success:hover,\n.btn-success:focus .btn-success.active,\n.btn-success:active {\n  background-color: #00cc52;\n  border: 1px solid #00cc52;\n  color: #ffffff;\n}\n.btn-success .open > .dropdown-toggle.btn-success {\n  background-color: #00cc52;\n  border: 1px solid #00cc52;\n  color: #ffffff;\n}\n.btn-success .open > .dropdown-toggle.btn-success.focus,\n.btn-success .open > .dropdown-toggle.btn-success:hover,\n.btn-success .open > .dropdown-toggle.btn-success:focus {\n  background-color: #00cc52;\n  border: 1px solid #00cc52;\n}\n.btn-success.active:focus,\n.btn-success.active.focus,\n.btn-success.active:hover,\n.btn-success.focus,\n.btn-success:active:focus,\n.btn-success:active:hover {\n  background-color: #00cc52;\n  border: 1px solid #00cc52;\n}\n.btn-success.active:not(:disabled):not(.disabled),\n.btn-success:active:not(:disabled):not(.disabled) {\n  background-color: #00cc52;\n  border-color: #00cc52;\n  color: #ffffff;\n}\n.btn-success.active:focus:not(:disabled):not(.disabled),\n.btn-success:active:focus:not(:disabled):not(.disabled) {\n  box-shadow: unset;\n}\n.btn-success.disabled,\n.btn-success:disabled {\n  background-color: #00e65b;\n  border-color: #00e65b;\n  color: #ffffff;\n}\n\n.btn-info {\n  background-color: #009efb;\n  border: 1px solid #009efb;\n}\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:active,\n.btn-info.active {\n  background-color: #028ee1;\n  border: 1px solid #028ee1;\n}\n.btn-info.active:focus,\n.btn-info.active.focus,\n.btn-info.active:hover,\n.btn-info.focus,\n.btn-info:active:focus,\n.btn-info:active:hover {\n  background-color: #028ee1;\n  border: 1px solid #028ee1;\n}\n.btn-info.active:not(:disabled):not(.disabled),\n.btn-info:active:not(:disabled):not(.disabled) {\n  background-color: #028ee1;\n  border-color: #028ee1;\n  color: #ffffff;\n}\n.btn-info.active:not(:disabled):not(.disabled):focus,\n.btn-info:active:not(:disabled):not(.disabled):focus {\n  box-shadow: unset;\n}\n.btn-info.disabled,\n.btn-info:disabled {\n  background-color: #009efb;\n  border-color: #009efb;\n  color: #ffffff;\n}\n\n.btn-warning {\n  background-color: #ffbc34;\n  border: 1px solid #ffbc34;\n}\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning:active,\n.btn-warning.active {\n  background-color: #e9ab2e;\n  border: 1px solid #e9ab2e;\n}\n.btn-warning.active:focus,\n.btn-warning.active.focus,\n.btn-warning.active:hover,\n.btn-warning.focus,\n.btn-warning:active:focus,\n.btn-warning:active:hover {\n  background-color: #e9ab2e;\n  border: 1px solid #e9ab2e;\n}\n.btn-warning.active:not(:disabled):not(.disabled),\n.btn-warning:active:not(:disabled):not(.disabled) {\n  background-color: #e9ab2e;\n  border-color: #e9ab2e;\n  color: #ffffff;\n}\n.btn-warning.active:not(:disabled):not(.disabled):focus,\n.btn-warning:active:not(:disabled):not(.disabled):focus {\n  box-shadow: unset;\n}\n.btn-warning.disabled,\n.btn-warning:disabled {\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n  color: #ffffff;\n}\n\n.btn-danger {\n  background-color: #ff0100;\n  border: 1px solid #ff0100;\n}\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active,\n.btn-danger.active {\n  background-color: #e63333;\n  border: 1px solid #e63333;\n}\n.btn-danger.active:focus,\n.btn-danger.active.focus,\n.btn-danger.active:hover,\n.btn-danger.focus,\n.btn-danger:active:focus,\n.btn-danger:active:hover {\n  background-color: #e63333;\n  border: 1px solid #e63333;\n}\n.btn-danger.active:not(:disabled):not(.disabled),\n.btn-danger:active:not(:disabled):not(.disabled) {\n  background-color: #e63333;\n  border-color: #e63333;\n  color: #ffffff;\n}\n.btn-danger.active:not(:disabled):not(.disabled):focus,\n.btn-danger:active:not(:disabled):not(.disabled):focus {\n  box-shadow: unset;\n}\n.btn-danger.disabled,\n.btn-danger:disabled {\n  background-color: #ff0100;\n  border-color: #ff0100;\n  color: #ffffff;\n}\n\n.open > .dropdown-toggle.btn-info {\n  background-color: #028ee1;\n  border: 1px solid #028ee1;\n}\n.open > .dropdown-toggle.btn-info.focus,\n.open > .dropdown-toggle.btn-info:focus,\n.open > .dropdown-toggle.btn-info:hover {\n  background-color: #028ee1;\n  border: 1px solid #028ee1;\n}\n.open > .dropdown-toggle.btn-warning {\n  background-color: #e9ab2e;\n  border: 1px solid #e9ab2e;\n}\n.open > .dropdown-toggle.btn-warning.focus,\n.open > .dropdown-toggle.btn-warning:focus,\n.open > .dropdown-toggle.btn-warning:hover {\n  background-color: #e9ab2e;\n  border: 1px solid #e9ab2e;\n}\n.open > .dropdown-toggle.btn-danger {\n  background-color: #e63333;\n  border: 1px solid #e63333;\n}\n.open > .dropdown-toggle.btn-danger.focus,\n.open > .dropdown-toggle.btn-danger:focus,\n.open > .dropdown-toggle.btn-danger:hover {\n  background-color: #e63333;\n  border: 1px solid #e63333;\n}\n\n.btn-light.active:focus:not(:disabled):not(.disabled),\n.btn-light:active:focus:not(:disabled):not(.disabled),\n.btn-dark.active:focus:not(:disabled):not(.disabled),\n.btn-dark:active:focus:not(:disabled):not(.disabled) {\n  box-shadow: unset;\n}\n\n.btn-outline-primary {\n  color: #09e5ab;\n  border-color: #09e5ab;\n}\n.btn-outline-primary:hover {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n}\n.btn-outline-primary.focus,\n.btn-outline-primary:focus {\n  box-shadow: none;\n}\n.btn-outline-primary.disabled,\n.btn-outline-primary:disabled {\n  color: #09e5ab;\n  background-color: transparent;\n}\n.btn-outline-primary:not(:disabled):not(.disabled).active,\n.btn-outline-primary:not(:disabled):not(.disabled):active {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n}\n\n.btn-outline-success {\n  color: #00e65b;\n  border-color: #00e65b;\n}\n.btn-outline-success:hover {\n  background-color: #00e65b;\n  border-color: #00e65b;\n}\n.btn-outline-success.focus,\n.btn-outline-success:focus {\n  box-shadow: none;\n}\n.btn-outline-success.disabled,\n.btn-outline-success:disabled {\n  color: #00e65b;\n  background-color: transparent;\n}\n.btn-outline-success:not(:disabled):not(.disabled).active,\n.btn-outline-success:not(:disabled):not(.disabled):active {\n  background-color: #00e65b;\n  border-color: #00e65b;\n}\n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\n.btn-outline-success:not(:disabled):not(.disabled):active:focus {\n  box-shadow: none;\n}\n\n.btn-outline-info {\n  color: #009efb;\n  border-color: #009efb;\n}\n.btn-outline-info:hover {\n  color: #ffffff;\n  background-color: #009efb;\n  border-color: #009efb;\n}\n.btn-outline-info.disabled,\n.btn-outline-info:disabled {\n  background-color: transparent;\n  color: #009efb;\n}\n.btn-outline-info:focus,\n.btn-outline-info.focus {\n  box-shadow: none;\n}\n.btn-outline-info:not(:disabled):not(.disabled).active,\n.btn-outline-info:not(:disabled):not(.disabled):active {\n  background-color: #009efb;\n  border-color: #009efb;\n}\n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\n.btn-outline-info:not(:disabled):not(.disabled):active:focus {\n  box-shadow: none;\n}\n\n.btn-outline-warning {\n  color: #ffbc34;\n  border-color: #ffbc34;\n}\n.btn-outline-warning:hover {\n  color: #212529;\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n}\n.btn-outline-warning.disabled,\n.btn-outline-warning:disabled {\n  background-color: transparent;\n  color: #ffbc34;\n}\n.btn-outline-warning:focus,\n.btn-outline-warning.focus {\n  box-shadow: none;\n}\n.btn-outline-warning:not(:disabled):not(.disabled).active,\n.btn-outline-warning:not(:disabled):not(.disabled):active {\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n}\n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus {\n  box-shadow: none;\n}\n\n.btn-outline-danger {\n  color: #ff0100;\n  border-color: #ff0100;\n}\n.btn-outline-danger:hover {\n  color: #212529;\n  background-color: #ff0100;\n  border-color: #ff0100;\n}\n.btn-outline-danger.disabled,\n.btn-outline-danger:disabled {\n  background-color: transparent;\n  color: #ff0100;\n}\n.btn-outline-danger:focus,\n.btn-outline-danger.focus {\n  box-shadow: none;\n}\n.btn-outline-danger:not(:disabled):not(.disabled).active,\n.btn-outline-danger:not(:disabled):not(.disabled):active {\n  background-color: #ff0100;\n  border-color: #ff0100;\n}\n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus {\n  box-shadow: none;\n}\n\n.btn-outline-light {\n  color: #ababab;\n  border-color: #e6e6e6;\n}\n.btn-outline-light.disabled,\n.btn-outline-light:disabled {\n  color: #ababab;\n}\n\n.pagination > .active > a,\n.pagination > .active > a:hover,\n.pagination > .active > a:focus,\n.pagination > .active > span,\n.pagination > .active > span:hover,\n.pagination > .active > span:focus {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n}\n.pagination > .active > a,\n.pagination > .active > span {\n  color: #20c0f3;\n}\n.pagination > li > a,\n.pagination > li > span {\n  color: #20c0f3;\n}\n\n.page-link:hover {\n  color: #20c0f3;\n}\n.page-link:focus {\n  box-shadow: unset;\n}\n\n.page-item.active .page-link {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n}\n\n.dropdown-menu {\n  background-color: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-shadow: inherit;\n  font-size: 14px;\n  border-radius: 3px;\n  transform-origin: left top 0;\n  -webkit-transform-origin: left top 0;\n  -ms-transform-origin: left top 0;\n}\n\n.dropdown-item.active,\n.dropdown-item:active {\n  background-color: #0de0fe;\n}\n\n.navbar-nav__.open--.dropdown-menu {\n  border: 0;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  background-color: #ffffff;\n}\n\n.btn-light {\n  border-color: #e6e6e6;\n  color: #a6a6a6;\n}\n\n.bootstrap-datetimepicker-widget table td.active,\n.bootstrap-datetimepicker-widget table td.active:hover {\n  background-color: #20c0f3;\n  text-shadow: unset;\n}\n.bootstrap-datetimepicker-widget table td.today::before {\n  border-bottom-color: #20c0f3;\n}\n\n.bg-info-light {\n  background-color: rgba(2, 182, 179, 0.12) !important;\n  color: #1db9aa !important;\n}\n\n.bg-primary-light {\n  background-color: rgba(17, 148, 247, 0.12) !important;\n  color: #2196f3 !important;\n}\n\n.bg-danger-light {\n  background-color: rgba(242, 17, 54, 0.12) !important;\n  color: #e63c3c !important;\n}\n\n.bg-warning-light {\n  background-color: rgba(255, 152, 0, 0.12) !important;\n  color: #f39c12 !important;\n}\n\n.bg-success-light {\n  background-color: rgba(15, 183, 107, 0.12) !important;\n  color: #26af48 !important;\n}\n\n.bg-purple-light {\n  background-color: rgba(197, 128, 255, 0.12) !important;\n  color: #c580ff !important;\n}\n\n.bg-default-light {\n  background-color: rgba(40, 52, 71, 0.12) !important;\n  color: #283447 !important;\n}\n\n.text-xs {\n  font-size: 12px !important;\n}\n\n.text-sm {\n  font-size: 14px !important;\n}\n\n.text-lg {\n  font-size: 20px !important;\n}\n\n.text-xl {\n  font-size: 24px !important;\n}\n\n.avatar {\n  position: relative;\n  display: inline-block;\n  width: 3rem;\n  height: 3rem;\n}\n.avatar > img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.avatar .avatar-title {\n  width: 100%;\n  height: 100%;\n  background-color: #20c0f3;\n  color: #ffffff;\n}\n.avatar.avatar-online::before {\n  width: 25%;\n  height: 25%;\n  border-radius: 50%;\n  content: \"\";\n  border: 2px solid #ffffff;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  background-color: #00e65b;\n}\n.avatar.avatar-offline::before {\n  width: 25%;\n  height: 25%;\n  border-radius: 50%;\n  content: \"\";\n  border: 2px solid #ffffff;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  background-color: #ff0100;\n}\n.avatar.avatar-away::before {\n  width: 25%;\n  height: 25%;\n  border-radius: 50%;\n  content: \"\";\n  border: 2px solid #ffffff;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  background-color: #ffbc34;\n}\n.avatar .border {\n  border-width: 3px !important;\n}\n.avatar .rounded {\n  border-radius: 6px !important;\n}\n.avatar .avatar-title {\n  font-size: 18px;\n}\n.avatar .avatar-xs {\n  width: 1.65rem;\n  height: 1.65rem;\n}\n.avatar .avatar-xs .border {\n  border-width: 2px !important;\n}\n.avatar .avatar-xs .rounded {\n  border-radius: 4px !important;\n}\n.avatar .avatar-xs .avatar-title {\n  font-size: 12px;\n}\n.avatar .avatar-xs.avatar-away::before,\n.avatar .avatar-xs.avatar-offline::before,\n.avatar .avatar-xs.avatar-online::before {\n  border-width: 1px;\n}\n\n.avatar-sm {\n  width: 2.5rem;\n  height: 2.5rem;\n}\n.avatar-sm .border {\n  border-width: 3px !important;\n}\n.avatar-sm .rounded {\n  border-radius: 4px !important;\n}\n.avatar-sm .avatar-title {\n  font-size: 15px;\n}\n.avatar-sm.avatar-away::before,\n.avatar-sm.avatar-offline::before,\n.avatar-sm.avatar-online::before {\n  border-width: 2px;\n}\n\n.avatar-lg {\n  width: 3.75rem;\n  height: 3.75rem;\n}\n.avatar-lg .border {\n  border-width: 3px !important;\n}\n.avatar-lg .rounded {\n  border-radius: 8px !important;\n}\n.avatar-lg .avatar-title {\n  font-size: 24px;\n}\n.avatar-lg.avatar-away::before,\n.avatar-lg.avatar-offline::before,\n.avatar-lg.avatar-online::before {\n  border-width: 3px;\n}\n\n.avatar-xl {\n  width: 5rem;\n  height: 5rem;\n}\n.avatar-xl .border {\n  border-width: 4px !important;\n}\n.avatar-xl .rounded {\n  border-radius: 8px !important;\n}\n.avatar-xl .avatar-title {\n  font-size: 28px;\n}\n.avatar-xl.avatar-away::before,\n.avatar-xl.avatar-offline::before,\n.avatar-xl.avatar-online::before {\n  border-width: 4px;\n}\n\n.avatar-xxl {\n  width: 5.125rem;\n  height: 5.125rem;\n}\n@media (min-width: 768px) {\n  .avatar-xxl {\n    width: 8rem;\n    height: 8rem;\n  }\n}\n.avatar-xxl .border {\n  border-width: 6px !important;\n}\n@media (min-width: 768px) {\n  .avatar-xxl .border {\n    border-width: 4px !important;\n  }\n}\n.avatar-xxl .rounded {\n  border-radius: 8px !important;\n}\n@media (min-width: 768px) {\n  .avatar-xxl .rounded {\n    border-radius: 12px !important;\n  }\n}\n.avatar-xxl .avatar-title {\n  font-size: 30px;\n}\n@media (min-width: 768px) {\n  .avatar-xxl .avatar-title {\n    font-size: 42px;\n  }\n}\n.avatar-xxl.avatar-away::before,\n.avatar-xxl.avatar-offline::before,\n.avatar-xxl.avatar-online::before {\n  border-width: 4px;\n}\n@media (min-width: 768px) {\n  .avatar-xxl.avatar-away::before,\n  .avatar-xxl.avatar-offline::before,\n  .avatar-xxl.avatar-online::before {\n    border-width: 4px;\n  }\n}\n\n.avatar-group .avatar + .avatar {\n  margin-left: -0.75rem;\n}\n.avatar-group .avatar:hover {\n  z-index: 1;\n}\n.avatar-group .avatar-xs + .avatar-xs {\n  margin-left: -0.40625rem;\n}\n.avatar-group .avatar-sm + .avatar-sm {\n  margin-left: -0.625rem;\n}\n.avatar-group .avatar-lg + .avatar-lg {\n  margin-left: -1rem;\n}\n.avatar-group .avatar-xl + .avatar-xl {\n  margin-left: -1.28125rem;\n}\n\n.avatar-xs {\n  width: 1.65rem;\n  height: 1.65rem;\n}\n\n.react-tel-input .form-control {\n  position: relative;\n  font-size: 14px;\n  letter-spacing: 0.01rem;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  padding-left: 48px;\n  margin-left: 0;\n  background: #ffffff;\n  border: 1px solid #cacaca;\n  border-radius: 5px;\n  line-height: 25px;\n  height: 35px;\n  outline: none;\n  width: 350px !important;\n}\n\n.select2-results__option {\n  padding: 6px 15px;\n}\n\n.select2-container .select2-selection--single {\n  border: 1px solid #dcdcdc;\n  height: 46px;\n}\n.select2-container .select2-selection--single .select2-selection__rendered {\n  padding-right: 30px;\n  padding-left: 15px;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n  height: 44px;\n  right: 7px;\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\n  border-color: #dcdcdc transparent transparent;\n  border-style: solid;\n  border-width: 6px 6px 0;\n  height: 0;\n  margin-left: -10px;\n  margin-top: -2px;\n  width: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n.select2-container--default .select2-selection--single .select2-selection__rendered {\n  color: #272b41;\n  font-size: 15px;\n  font-weight: normal;\n  line-height: 44px;\n}\n.select2-container--default.select2-container--open\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  border-color: transparent transparent #dcdcdc;\n  border-width: 0 6px 6px;\n}\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #20c0f3;\n}\n.select2-container--default .select2-selection--multiple {\n  border: 1px solid #dcdcdc;\n  min-height: 46px;\n}\n\n.select2-dropdown {\n  border-color: #dcdcdc;\n}\n\n.breadcrumb-bar {\n  background-color: #15558d;\n  padding: 15px 0;\n}\n@media (max-width: 767.98px) {\n  .breadcrumb-bar {\n    height: auto;\n  }\n}\n.breadcrumb-bar .breadcrumb-title {\n  color: #ffffff;\n  font-size: 22px;\n  font-weight: 700;\n  margin: 5px 0 0;\n}\n@media (max-width: 767.98px) {\n  .breadcrumb-bar .breadcrumb-title {\n    font-size: 18px;\n  }\n}\n.breadcrumb-bar .page-breadcrumb ol {\n  background-color: transparent;\n  font-size: 12px;\n  margin-bottom: 0;\n  padding: 0;\n}\n.breadcrumb-bar .page-breadcrumb ol li.active {\n  color: #ffffff;\n}\n.breadcrumb-bar .page-breadcrumb ol li a {\n  color: #ffffff;\n}\n.breadcrumb-bar .page-breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  color: #ffffff;\n  font-size: 10px;\n}\n\n.form-focus {\n  height: 50px;\n  position: relative;\n}\n.form-focus .focus-label {\n  font-size: 14px;\n  font-weight: 400;\n  pointer-events: none;\n  transform: translate3d(0, 22px, 0) scale(1);\n  -webkit-transform: translate3d(0, 22px, 0) scale(1);\n  -ms-transform: translate3d(0, 22px, 0) scale(1);\n  transform-origin: left top;\n  -webkit-transform-origin: left top;\n  -ms-transform-origin: left top;\n  -webkit-transition: 240ms;\n  -ms-transition: 240ms;\n  transition: 240ms;\n  z-index: 1;\n  color: #b8b8b8;\n  margin-bottom: 0;\n  position: absolute;\n  top: -8px;\n  left: 12px;\n}\n.form-focus.focused .focus-label {\n  opacity: 1;\n  top: -18px;\n  font-size: 12px;\n  z-index: 1;\n}\n.form-focus.focused .form-control::-webkit-input-placeholder {\n  color: #bbb;\n}\n.form-focus .form-control {\n  height: 50px;\n  padding: 21px 12px 6px;\n}\n.form-focus .form-control:focus ~ .focus-label,\n.form-focus .form-control:-webkit-autofill ~ .focus-label {\n  opacity: 1;\n  font-weight: 400;\n  top: -18px;\n  font-size: 12px;\n  z-index: 1;\n}\n.form-focus .form-control::-webkit-input-placeholder {\n  color: transparent;\n  -webkit-transition: 240ms;\n  -ms-transition: 240ms;\n  transition: 240ms;\n}\n.form-focus .form-control:focus::-webkit-input-placeholder {\n  transition: none;\n}\n.form-focus.select-focus .focus-label {\n  opacity: 1;\n  font-weight: 300;\n  top: -20px;\n  font-size: 12px;\n  z-index: 1;\n}\n.form-focus .select2-container .select2-selection--single {\n  border: 1px solid #e3e3e3;\n  height: 50px;\n}\n.form-focus .select2-container .select2-selection--single .select2-selection__rendered {\n  padding-right: 30px;\n  padding-left: 15px;\n}\n.form-focus .select2-container--default .select2-selection--single .select2-selection__arrow {\n  height: 48px;\n  right: 7px;\n}\n.form-focus .select2-container--default .select2-selection--single .select2-selection__arrow b {\n  border-color: #cccccc transparent transparent;\n  border-style: solid;\n  border-width: 6px 6px 0;\n  height: 0;\n  margin-left: -10px;\n  margin-top: -2px;\n  width: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n.form-focus .select2-container--default .select2-selection--single .select2-selection__rendered {\n  color: #676767;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 38px;\n}\n.form-focus\n  .select2-container--default.select2-container--open\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  border-color: transparent transparent #e3e3e3;\n  border-width: 0 6px 6px;\n}\n.form-focus .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #fc6075;\n}\n\n#loader {\n  background-color: #ffffff;\n  z-index: 999999;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.loader {\n  display: inline-block;\n  height: 50px;\n  margin-left: -25px;\n  margin-top: -25px;\n  width: 50px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n.loader span {\n  -webkit-animation: loader 1.3s linear infinite;\n  animation: loader 1.3s linear infinite;\n  background-color: #20c0f3;\n  border-radius: 100%;\n  display: inline-block;\n  height: 50px;\n  position: absolute;\n  width: 50px;\n}\n.loader span:last-child {\n  animation-delay: -0.8s;\n  -webkit-animation-delay: -0.8s;\n}\n\n@keyframes loader {\n  0% {\n    transform: scale(0, 0);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1, 1);\n    opacity: 0;\n  }\n}\n@-webkit-keyframes loader {\n  0% {\n    -webkit-transform: scale(0, 0);\n    opacity: 0.5;\n  }\n  100% {\n    -webkit-transform: scale(1, 1);\n    opacity: 0;\n  }\n}\ntable.table {\n  color: #272b41;\n  max-width: 100%;\n  margin-bottom: 0;\n  width: 100%;\n}\ntable.table thead {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.03);\n}\ntable.table thead tr th {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\ntable.table tbody tr {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\ntable.table tbody tr:last-child {\n  border-color: transparent;\n}\ntable.table.table-center td,\ntable.table.table-center th {\n  vertical-align: middle;\n}\ntable.table > tbody > tr > th {\n  border-top: 0;\n  padding: 10px 8px;\n}\ntable.table .no-border > tbody > tr > th {\n  border-top: 0;\n  padding: 10px 8px;\n}\ntable.table .no-border > tbody > tfoot > tr > th,\ntable.table .no-border > tbody > tfoot > tr > td,\ntable.table .no-border > tbody thead > tr > th,\ntable.table .no-border > tbody thead > tr > td {\n  border-top: 0;\n  padding: 10px 8px;\n}\ntable.table .dataTable {\n  border-collapse: collapse !important;\n}\ntable .table-striped thead tr {\n  border-color: transparent;\n}\ntable .table-striped tbody tr {\n  border-color: transparent;\n}\ntable .table-striped tbody tr:nth-of-type(even) {\n  background-color: rgba(255, 255, 255, 0.3);\n}\ntable .table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(235, 235, 235, 0.4);\n}\ntable .table-striped > tbody > tr:nth-of-type(2n + 1) {\n  background-color: #f8f9fa;\n}\ntable .table-bordered {\n  border: 1px solid rgba(0, 0, 0, 0.05) !important;\n}\ntable .table-bordered th,\ntable .table-bordered td {\n  border-color: rgba(0, 0, 0, 0.05);\n}\ntable .table-nowrap td,\ntable .table-nowrap th {\n  white-space: nowrap;\n}\ntable.table td h2 {\n  display: inline-block;\n  font-size: inherit;\n  font-weight: 400;\n  vertical-align: middle;\n  margin: 0;\n  padding: 0;\n}\ntable.table td h2 .table-avatar {\n  font-size: inherit;\n  font-weight: 400;\n  vertical-align: middle;\n  white-space: nowrap;\n  margin: 0;\n  padding: 0;\n}\ntable.table td h2 a {\n  color: #272b41;\n}\ntable.table td h2 a:hover {\n  color: #09dca4;\n}\ntable.table td h2 span {\n  color: #888888;\n  display: block;\n  font-size: 12px;\n  margin-top: 3px;\n}\ntable.table td h2.table-avatar {\n  font-size: inherit;\n  font-weight: 400;\n  vertical-align: middle;\n  white-space: nowrap;\n  margin: 0;\n  padding: 0;\n}\ntable .table-hover tbody tr:hover {\n  background-color: #f7f7f7;\n}\ntable .table-hover tbody tr:hover td {\n  color: #474648;\n}\n\n.table-hover tbody tr:hover {\n  background-color: #f7f7f7;\n}\n.table-hover tbody tr:hover td {\n  color: #474648;\n}\n\n.card-table card-body {\n  padding: 0;\n}\n.card-table card-body .table > thead > tr > th {\n  border-top: 0;\n}\n.card-table card-body .table tr th,\n.card-table card-body .table tr td {\n  border-top: 1px solid #e2e5e8;\n  padding: 1rem 0.75rem;\n  white-space: nowrap;\n}\n.card-table card-body .table tr th:first-child,\n.card-table card-body .table tr td:first-child {\n  padding-left: 1.5rem;\n}\n.card-table card-body .table tr th:last-child,\n.card-table card-body .table tr td:last-child {\n  padding-right: 1.5rem;\n}\n\n.card-table .card-body {\n  padding: 0;\n}\n.card-table .card-body .table > thead > tr > th {\n  border-top: 0;\n}\n.card-table .card-body .table tr th,\n.card-table .card-body .table tr td {\n  border-top: 1px solid #e2e5e8;\n  white-space: nowrap;\n  padding: 1rem 0.75rem;\n}\n.card-table .card-body .table tr th:first-child,\n.card-table .card-body .table tr td:first-child {\n  padding-left: 1.5rem;\n}\n.card-table .card-body .table tr th:last-child,\n.card-table .card-body .table tr td:last-child {\n  padding-right: 1.5rem;\n}\n\n.slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.slick-list {\n  position: relative;\n  display: block;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n}\n.slick-list:focus {\n  outline: none;\n}\n\n.slick-list.dragging {\n  cursor: pointer;\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n  transform: translate3d(0, 0, 0);\n  -webkit-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n  display: block;\n  margin: auto;\n  position: relative;\n  top: 0;\n  left: 0;\n}\n.slick-track:before {\n  display: table;\n  content: \"\";\n}\n.slick-track:after {\n  display: table;\n  content: \"\";\n  clear: both;\n}\n\n.slick-loading .slick-track {\n  visibility: hidden;\n}\n.slick-loading .slick-slide {\n  visibility: hidden;\n}\n\n.slick-slide {\n  display: none;\n  float: left;\n  height: 100%;\n  min-height: 1px;\n}\n.slick-slide img {\n  display: block;\n}\n.slick-slide.slick-loading img {\n  display: none;\n}\n.slick-slide.dragging img {\n  pointer-events: none;\n}\n\n[dir=\"rtl\"] .slick-slide {\n  float: right;\n}\n\n.slick-initialized .slick-slide {\n  display: block;\n}\n\n.slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n  border: 1px solid transparent;\n}\n\n.slick-arrow.slick-hidden {\n  display: none;\n}\n\n.slick-prev,\n.slick-next {\n  font-size: 0;\n  line-height: 0;\n  display: block;\n  width: 40px;\n  height: 40px;\n  background: #ffffff;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: #ffffff;\n  -webkit-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n  position: absolute;\n  top: 50%;\n  padding: 0;\n  transform: translate(0, -50%);\n  -webkit-transform: translate(0, -50%);\n  -ms-transform: translate(0, -50%);\n  -webkit-box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);\n  box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);\n  border-radius: 100%;\n}\n.slick-prev:hover,\n.slick-prev:focus,\n.slick-next:hover,\n.slick-next:focus {\n  background-color: #0de0fe;\n  color: #ffffff;\n  opacity: 1;\n  outline: none;\n  -webkit-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.slick-prev:hover:before,\n.slick-prev:focus:before,\n.slick-next:hover:before,\n.slick-next:focus:before {\n  color: #ffffff;\n  opacity: 1;\n}\n.slick-prev.slick-disabled:before,\n.slick-next.slick-disabled:before {\n  opacity: 0.25;\n}\n.slick-prev:before,\n.slick-next:before {\n  font-family: \"slick\";\n  font-size: 20px;\n  line-height: 1;\n  opacity: 0.75;\n  color: #383838;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.slick-prev {\n  left: 0;\n  z-index: 1;\n}\n@media (max-width: 767.98px) {\n  .slick-prev {\n    left: -10px;\n  }\n}\n.slick-prev:before {\n  content: \"←\";\n}\n\n[dir=\"rtl\"] .slick-prev {\n  right: -25px;\n  left: auto;\n}\n[dir=\"rtl\"] .slick-prev:before {\n  content: \"→\";\n}\n\n.slick-next {\n  right: 0;\n}\n@media (max-width: 767.98px) {\n  .slick-next {\n    right: -10px;\n  }\n}\n@media (max-width: 575.98px) {\n  .slick-next {\n    right: 0px;\n  }\n}\n.slick-next:before {\n  content: \"→\";\n}\n\n[dir=\"rtl\"] .slick-next {\n  right: auto;\n  left: -25px;\n}\n[dir=\"rtl\"] .slick-next:before {\n  content: \"←\";\n}\n\n.dot-slider .slick-slide {\n  height: 600px;\n}\n@media (max-width: 991.98px) {\n  .dot-slider .slick-slide {\n    height: 375px;\n  }\n}\n@media (max-width: 767.98px) {\n  .dot-slider .slick-slide {\n    height: 100%;\n  }\n}\n.dot-slider .slick-slide img {\n  width: 100%;\n}\n.dot-slider .profile-widget {\n  padding: 0;\n  border: none;\n}\n@media (max-width: 991.98px) {\n  .dot-slider .profile-widget {\n    margin-bottom: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .dot-slider .profile-widget {\n    margin-bottom: 0;\n  }\n}\n.dot-slider .slick-dots {\n  width: unset;\n  position: absolute;\n  top: 30%;\n  right: 50px;\n  bottom: unset;\n}\n.dot-slider .slick-dots li {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  margin: 8px 0;\n}\n.dot-slider .slick-dots li.slick-active button {\n  background-color: #1860ca;\n}\n.dot-slider .slick-dots li button {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background-color: #ffffff;\n}\n\n.slick-dots li button {\n  font-size: 0;\n  line-height: 0;\n  display: block;\n  width: 20px;\n  height: 5px;\n  padding: 0;\n  cursor: pointer;\n  color: transparent;\n  border: 0;\n  outline: none;\n  background: #c0c0c0;\n}\n.slick-dots .slick-dots {\n  width: unset;\n  position: absolute;\n  top: 30%;\n  right: 50px;\n  bottom: unset;\n}\n.slick-dots .slick-dots li {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  margin: 8px 0;\n}\n.slick-dots .slick-dots li button {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background-color: #ffffff;\n}\n.slick-dots .slick-dots li button:hover,\n.slick-dots .slick-dots li button:focus {\n  outline: none;\n}\n.slick-dots .slick-dots li button:hover::before,\n.slick-dots .slick-dots li button:focus::before {\n  opacity: 1;\n}\n.slick-dots .slick-dots li.slick-active button {\n  background-color: #1860ca;\n  background-color: #0de0fe;\n}\n.slick-dots .slick-dots li.slick-active button:before {\n  opacity: 1;\n  color: #0de0fe;\n}\n\n.clinic-slider .slick-prev,\n.browse-slider .slick-prev,\n.book-slider .slick-prev {\n  right: 80px;\n  left: unset;\n  top: 0;\n  width: 35px;\n  height: 35px;\n  border-radius: 5px 12px 5px 12px;\n  background-color: #e74e84;\n  transform: translateX(0%) rotate(-45deg);\n  -webkit-transform: translateX(0%) rotate(-45deg);\n  -ms-transform: translateX(0%) rotate(-45deg);\n  z-index: 999;\n}\n.clinic-slider .slick-prev:before,\n.browse-slider .slick-prev:before,\n.book-slider .slick-prev:before {\n  content: \"\";\n  transform: rotate(180deg);\n  -webkit-transform: rotate(180deg);\n  font-family: \"slick\";\n  font-size: 10px;\n  line-height: 1;\n  opacity: 0.75;\n  color: #ffffff;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border: solid #ffffff;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  padding: 3px;\n}\n.clinic-slider .slick-prev:hover,\n.browse-slider .slick-prev:hover,\n.book-slider .slick-prev:hover {\n  background-color: #ff4877;\n}\n.clinic-slider .slick-next,\n.browse-slider .slick-next,\n.book-slider .slick-next {\n  right: 15px;\n  left: unset;\n  top: 0;\n  width: 35px;\n  height: 35px;\n  border-radius: 5px 12px 5px 12px;\n  background-color: #e74e84;\n  transform: translateX(0%) rotate(-45deg);\n  -webkit-transform: translateX(0%) rotate(-45deg);\n  -ms-transform: translateX(0%) rotate(-45deg);\n  z-index: 999;\n}\n.clinic-slider .slick-next:before,\n.browse-slider .slick-next:before,\n.book-slider .slick-next:before {\n  content: \"\";\n  font-family: \"slick\";\n  font-size: 10px;\n  line-height: 1;\n  opacity: 0.75;\n  color: #ffffff;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border: solid #ffffff;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  padding: 3px;\n  transform: rotate(0deg);\n  -webkit-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n}\n.clinic-slider .slick-next:hover,\n.browse-slider .slick-next:hover,\n.book-slider .slick-next:hover {\n  background-color: #ff4877;\n}\n.clinic-slider .slick-list,\n.browse-slider .slick-list,\n.book-slider .slick-list {\n  padding-top: 50px;\n}\n.clinic-slider .slick-slide,\n.browse-slider .slick-slide,\n.book-slider .slick-slide {\n  display: block;\n  margin-left: 0;\n  width: 280px;\n  padding: 10px 10px 0;\n}\n.clinic-slider .profile-widget,\n.browse-slider .profile-widget,\n.book-slider .profile-widget {\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  border-radius: 0;\n}\n.clinic-slider .profile-widget .brower-box,\n.browse-slider .profile-widget .brower-box,\n.book-slider .profile-widget .brower-box {\n  background: #ffffff;\n  border: 1px solid #f2f2f2;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 44px rgba(238, 238, 238, 0.25);\n  border-radius: 10px;\n  margin: 0;\n  padding: 30px;\n  -webkit-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.clinic-slider .profile-widget .brower-box:hover,\n.browse-slider .profile-widget .brower-box:hover,\n.book-slider .profile-widget .brower-box:hover {\n  background-color: #1860ca;\n  -webkit-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.clinic-slider .profile-widget .brower-box:hover a,\n.browse-slider .profile-widget .brower-box:hover a,\n.book-slider .profile-widget .brower-box:hover a {\n  background-color: #ffffff;\n}\n.clinic-slider .profile-widget .brower-box:hover .img-fluid,\n.browse-slider .profile-widget .brower-box:hover .img-fluid,\n.book-slider .profile-widget .brower-box:hover .img-fluid {\n  display: none;\n}\n.clinic-slider .profile-widget .brower-box:hover .img-fluid.hover,\n.browse-slider .profile-widget .brower-box:hover .img-fluid.hover,\n.book-slider .profile-widget .brower-box:hover .img-fluid.hover {\n  display: block;\n}\n.clinic-slider .profile-widget .brower-box:hover h4,\n.browse-slider .profile-widget .brower-box:hover h4,\n.book-slider .profile-widget .brower-box:hover h4 {\n  color: #ffffff;\n}\n.clinic-slider .profile-widget .brower-box:hover p,\n.browse-slider .profile-widget .brower-box:hover p,\n.book-slider .profile-widget .brower-box:hover p {\n  color: #ffffff;\n}\n.clinic-slider .profile-widget .brower-box:hover p span,\n.browse-slider .profile-widget .brower-box:hover p span,\n.book-slider .profile-widget .brower-box:hover p span {\n  color: #ffffff;\n}\n.clinic-slider .profile-widget .brower-box:hover a.arrow,\n.browse-slider .profile-widget .brower-box:hover a.arrow,\n.book-slider .profile-widget .brower-box:hover a.arrow {\n  background-color: #2868c8;\n}\n.clinic-slider .profile-widget .brower-box a,\n.browse-slider .profile-widget .brower-box a,\n.book-slider .profile-widget .brower-box a {\n  height: 85px;\n  width: 85px;\n  background-color: #1860ca;\n  border-radius: 50% 50% 50% 50%/60% 60% 35% 35%;\n  margin: 0 auto 15px;\n  transform: rotate(180deg);\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n}\n.clinic-slider .profile-widget .brower-box img,\n.browse-slider .profile-widget .brower-box img,\n.book-slider .profile-widget .brower-box img {\n  width: 70px;\n  transform: rotate(180deg);\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n}\n.clinic-slider .profile-widget .brower-box .img-fluid.hover,\n.browse-slider .profile-widget .brower-box .img-fluid.hover,\n.book-slider .profile-widget .brower-box .img-fluid.hover {\n  display: none;\n}\n.clinic-slider .profile-widget .brower-box h4,\n.browse-slider .profile-widget .brower-box h4,\n.book-slider .profile-widget .brower-box h4 {\n  color: #000000;\n  font-size: 20px;\n  margin-bottom: 13px;\n}\n.clinic-slider .profile-widget .brower-box p,\n.browse-slider .profile-widget .brower-box p,\n.book-slider .profile-widget .brower-box p {\n  margin-bottom: 20px;\n}\n.clinic-slider .profile-widget .brower-box .arrow,\n.browse-slider .profile-widget .brower-box .arrow,\n.book-slider .profile-widget .brower-box .arrow {\n  background-color: #0ce0ff;\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  transform: unset;\n  margin: 0 auto;\n}\n.clinic-slider .profile-widget .brower-box .arrow i,\n.browse-slider .profile-widget .brower-box .arrow i,\n.book-slider .profile-widget .brower-box .arrow i {\n  color: #ffffff;\n}\n\n.brower-box {\n  text-align: center;\n  border-radius: 10px;\n  border: 6px solid #ffffff;\n  background-color: #ffffff;\n  margin-bottom: 20px;\n}\n.brower-box h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #2264c5;\n}\n.brower-box p {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e74e84;\n  margin: 0;\n}\n.brower-box p span {\n  color: #000000;\n}\n.brower-box a {\n  height: 85px;\n  width: 85px;\n  background-color: #1860ca;\n  border-radius: 50% 50% 50% 50%/60% 60% 35% 35%;\n  margin: 0 auto 15px;\n  transform: rotate(180deg);\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n}\n\n.aval-slider .slick-slide {\n  display: block;\n  margin-left: 0;\n  padding: 10px;\n  width: 280px;\n}\n.aval-slider .slick-list {\n  padding: 50px 0;\n}\n@media (max-width: 767.98px) {\n  .aval-slider .slick-list {\n    padding: 30px 0;\n  }\n}\n.aval-slider .slick-prev {\n  left: 5px;\n  width: 35px;\n  height: 35px;\n}\n.aval-slider .slick-prev:before {\n  font-family: \"slick\";\n  font-size: 10px;\n  line-height: 1;\n  opacity: 0.75;\n  color: #1860ca;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border: solid #1860ca;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  padding: 3px;\n  content: \"\";\n  transform: rotate(140deg);\n  -webkit-transform: rotate(140deg);\n  -ms-transform: rotate(140deg);\n}\n.aval-slider .slick-next {\n  right: 5px;\n  width: 35px;\n  height: 35px;\n}\n.aval-slider .slick-next:before {\n  font-family: \"slick\";\n  font-size: 10px;\n  line-height: 1;\n  opacity: 0.75;\n  color: #1860ca;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border: solid #1860ca;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  padding: 3px;\n  content: \"\";\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n}\n\n.content {\n  min-height: 200px;\n  padding: 80px 0 60px;\n}\n@media (max-width: 991.98px) {\n  .content {\n    padding: 60px 0 40px;\n  }\n}\n@media (max-width: 767.98px) {\n  .content {\n    padding: 50px 0 30px;\n  }\n}\n\n.top-space {\n  padding-top: 140px;\n}\n\n.account-page .content.top-space {\n  padding-top: 140px;\n}\n\n.card {\n  border: 1px solid #f0f0f0;\n  margin-bottom: 1.875rem;\n}\n@media (max-width: 767.98px) {\n  .card {\n    margin-bottom: 20px;\n  }\n}\n@media (max-width: 575.98px) {\n  .card {\n    margin-bottom: 0.9375rem;\n  }\n}\n.card .card-header {\n  background-color: #ffffff;\n  border-bottom: 1px solid #f0f0f0;\n}\n@media (max-width: 575.98px) {\n  .card .card-header {\n    padding: 0.75rem 1.25rem;\n  }\n}\n.card .card-header .card-title {\n  margin-bottom: 0;\n}\n\n.card-body {\n  padding: 1.5rem;\n}\n@media (max-width: 575.98px) {\n  .card-body {\n    padding: 1.25rem;\n  }\n}\n\n.card-title {\n  margin-bottom: 15px;\n}\n\n.card-header {\n  border-bottom: 1px solid #f0f0f0;\n  padding: 1rem 1.5rem;\n}\n@media (max-width: 575.98px) {\n  .card-header {\n    padding: 0.75rem 1.25rem;\n  }\n}\n\n.card-footer {\n  background-color: #ffffff;\n  border-top: 1px solid #f0f0f0;\n  padding: 1rem 1.5rem;\n}\n@media (max-width: 575.98px) {\n  .card-footer {\n    padding: 0.75rem 1.25rem;\n  }\n}\n\n.custom-modal .modal-content {\n  border: 0;\n  border-radius: 10px;\n}\n.custom-modal .modal-content .modal-header {\n  padding: 1.25rem;\n}\n.custom-modal .modal-content .modal-header .modal-title {\n  font-size: 20px;\n}\n.custom-modal .close {\n  background-color: #a0a0a0;\n  color: #ffffff;\n  font-size: 17px;\n  height: 20px;\n  line-height: 20px;\n  opacity: 1;\n  width: 20px;\n  z-index: 99;\n  border-radius: 50%;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: 26px;\n  right: 20px;\n}\n.custom-modal .modal-body {\n  padding: 1.25rem;\n}\n.custom-modal .modal-footer {\n  padding: 1.25rem;\n}\n.custom-modal .modal-footer .btn-outline {\n  margin: 0.25rem auto;\n}\n\n.custom-medicalrecord-modal .modal-content .modal-header {\n  border-color: #e5e5e5;\n  margin: 1.5rem 1.5rem 0 1.5rem;\n  padding: 0 0 1rem;\n}\n.custom-medicalrecord-modal .modal-content .form-control,\n.custom-medicalrecord-modal .modal-content .bootstrap-tagsinput {\n  background-color: #f5f5f7;\n  border-color: #f5f5f7;\n}\n.custom-medicalrecord-modal .modal-content .select2-container .select2-selection--single {\n  background-color: #f5f5f7;\n  border-color: #f5f5f7;\n}\n.custom-medicalrecord-modal .modal-content .upload-medical-records {\n  position: relative;\n}\n.custom-medicalrecord-modal .modal-content .upload-medical-records input[type=\"file\"] {\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone {\n  min-height: 180px;\n}\n.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone h5 {\n  color: #7c7c7c;\n  margin-bottom: 3px;\n}\n.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone h6 {\n  color: #7c7c7c;\n  margin-bottom: 3px;\n}\n.custom-medicalrecord-modal .modal-content .upload-medical-records .dropzone h6 span {\n  text-decoration: underline;\n}\n\n.header .header-nav {\n  background-color: #ffffff;\n  border: 0;\n  border-bottom: 1px solid #f0f0f0;\n  position: relative;\n  height: 85px;\n  margin-bottom: 0;\n  padding: 0;\n}\n@media (max-width: 1199.98px) {\n  .header .header-nav {\n    padding: 0 20px;\n  }\n}\n@media (max-width: 575.98px) {\n  .header .header-nav {\n    padding: 0 15px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .navbar-header {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n  }\n}\n@media (max-width: 575.98px) {\n  .header .header-nav .navbar-header {\n    width: 100%;\n  }\n}\n.header .header-nav .navbar-header .bar-icon {\n  display: inline-block;\n  width: 31px;\n}\n.header .header-nav .navbar-header .bar-icon span {\n  background-color: #0de0fe;\n  display: block;\n  float: left;\n  height: 3px;\n  margin-bottom: 7px;\n  width: 31px;\n  border-radius: 2px;\n}\n.header .header-nav .navbar-header .bar-icon span:nth-child(2) {\n  width: 16px;\n}\n.header .header-nav .navbar-header .bar-icon span:nth-child(3) {\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .navbar-header {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n  }\n}\n@media (max-width: 575.98px) {\n  .header .header-nav .navbar-header {\n    width: 100%;\n  }\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .main-menu-wrapper {\n    order: 3;\n    width: 260px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    z-index: 1060;\n    transform: translateX(-260px);\n    -webkit-transform: translateX(-260px);\n    -ms-transform: translateX(-260px);\n    -webkit-transition: all 0.4s;\n    -ms-transition: all 0.4s;\n    transition: all 0.4s;\n    background-color: #15558d;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n  }\n}\n.header .header-nav .menu-header {\n  background-color: #ffffff;\n  height: 60px;\n  border-bottom: 1px solid #f0f0f0;\n  display: none;\n  padding: 0 20px;\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .menu-header {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n}\n.header .header-nav .menu-header .menu-logo img {\n  height: 40px;\n}\n.header .header-nav .menu-header .menu-close {\n  font-size: 18px;\n}\n.header .header-nav .main-nav {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .main-nav {\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: 0;\n    list-style: none;\n    padding: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .main-nav ul {\n    background-color: #3474ac;\n    display: none;\n    list-style: none;\n    padding-left: 0;\n    margin: 0;\n  }\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav > .has-submenu > .submenu > .has-submenu > .submenu::before {\n    top: 20px;\n    margin-left: -35px;\n    box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);\n    border-color: transparent #ffffff #ffffff transparent;\n  }\n}\n.header .header-nav .main-nav > .has-submenu.active .submenu li.active > a {\n  color: #09dca4;\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav > .has-submenu.active .submenu li.active > a {\n    color: #09dca4;\n  }\n}\n.header .header-nav .main-nav > .has-submenu.active > a {\n  color: #09dca4;\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav > .has-submenu.active > a {\n    color: #09dca4;\n  }\n}\n@media (max-width: 1199.98px) {\n  .header .header-nav .main-nav > li {\n    margin-right: 20px;\n  }\n}\n@media (max-width: 1999.98px) {\n  .header .header-nav .main-nav > li {\n    margin-right: 30px;\n  }\n}\n@media (max-width: 1399.98px) {\n  .header .header-nav .main-nav > li {\n    margin-right: 16px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .main-nav > li {\n    border-bottom: 1px solid #1663a6;\n    margin: 0;\n  }\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav > li > a {\n    line-height: 85px;\n    padding: 0 !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .main-nav > li > a {\n    line-height: 1.5;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 500;\n    padding: 15px 20px !important;\n  }\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav > li > a > i {\n    font-size: 12px;\n    margin-left: 3px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .main-nav > li > a > i {\n    float: right;\n    margin-top: 5px;\n  }\n}\n.header .header-nav .main-nav > li.active > a {\n  color: #09dca4;\n}\n.header .header-nav .main-nav > li .submenu li {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav > li .submenu li:first-child a {\n    border-top: 0;\n  }\n}\n.header .header-nav .main-nav > li .submenu li a {\n  display: block;\n  clear: both;\n  white-space: nowrap;\n  font-size: 14px;\n  color: #2d3b48;\n  width: 100%;\n  border-top: 1px solid #f0f0f0;\n  -webkit-transition: all 0.35s ease;\n  -ms-transition: all 0.35s ease;\n  transition: all 0.35s ease;\n  padding: 10px 15px;\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .main-nav > li .submenu li a {\n    border-top: 0;\n    color: #ffffff;\n    padding: 10px 15px 10px 35px;\n  }\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav > li .submenu li .submenu {\n    left: 100%;\n    top: 0;\n    margin-top: 10px;\n  }\n}\n.header .header-nav .main-nav > li .submenu li .submenu li {\n  position: relative;\n}\n.header .header-nav .main-nav > li .submenu li .submenu li a {\n  display: block;\n  clear: both;\n  white-space: nowrap;\n  font-size: 14px;\n  color: #2d3b48;\n  width: 100%;\n  border-top: 1px solid #f0f0f0;\n  padding: 10px 15px;\n  -webkit-transition: all 0.35s ease;\n  -ms-transition: all 0.35s ease;\n  transition: all 0.35s ease;\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .main-nav > li .submenu li .submenu li a {\n    border-top: 0;\n    color: #ffffff;\n    padding: 10px 15px 10px 45px;\n  }\n}\n.header .header-nav .main-nav > li .submenu li .submenu li .has-submenu > a::after {\n  content: \"\\f054\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n  font-size: 13px;\n  position: absolute;\n  top: 12px;\n  right: 15px;\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav > li .submenu > li .submenu {\n    left: 100%;\n    top: 0;\n    margin-top: 10px;\n  }\n}\n.header .header-nav .main-nav > li .submenu > li.has-submenu > a::after {\n  content: \"\\f054\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n  font-size: 13px;\n  position: absolute;\n  top: 12px;\n  right: 15px;\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .main-nav > li .submenu > li.has-submenu > a::after {\n    content: \"\\f078\";\n  }\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav > li:last-child {\n    margin-right: 0;\n  }\n}\n@media (min-width: 992px) {\n  .header\n    .header-nav\n    .main-nav\n    > li.has-submenu:hover\n    > .submenu\n    > li.has-submenu:hover\n    > .submenu {\n    visibility: visible;\n    opacity: 1;\n    margin-top: -1px;\n    margin-right: 0;\n  }\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav li {\n    display: block;\n    position: relative;\n  }\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav li > ul {\n    background-color: #ffffff;\n    display: block;\n    font-size: 14px;\n    min-width: 200px;\n    opacity: 0;\n    visibility: hidden;\n    z-index: 1000;\n    -webkit-transition: all 0.2s ease;\n    -ms-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n    transform: translateY(20px);\n    -webkit-transform: translateY(20px);\n    -ms-transform: translateY(20px);\n    position: absolute;\n    top: 100%;\n    left: 0;\n    margin: 0;\n    padding: 0;\n    border-radius: 5px;\n    -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n    -moz-box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n  }\n}\n.header .header-nav .main-nav li a {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n}\n.header .header-nav .main-nav li.login-link {\n  display: none;\n}\n@media (max-width: 575.98px) {\n  .header .header-nav .main-nav li.login-link {\n    display: block;\n  }\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav li .submenu a:hover {\n    color: #09dca4 !important;\n    letter-spacing: 0.5px;\n    padding-left: 20px !important;\n  }\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav li .submenu::before {\n    border: 7px solid #ffffff;\n    border-color: transparent transparent #ffffff #ffffff;\n    content: \"\";\n    transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n    -ms-transform-origin: 0 0;\n    transform: rotate(135deg);\n    -webkit-transform: rotate(135deg);\n    -ms-transform: rotate(135deg);\n    position: absolute;\n    top: 2px;\n    left: 45px;\n    -webkit-box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\n    -moz-box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\n    box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\n  }\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .main-nav li + li {\n    margin-left: 0;\n  }\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav li.has-submenu:hover > .submenu {\n    visibility: visible;\n    opacity: 1;\n    margin-top: 0;\n    transform: translateY(0);\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n  }\n}\n.header .header-nav .main-nav .has-submenu.active > a {\n  color: #09dca4;\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav .has-submenu.active > a {\n    color: #09dca4;\n  }\n}\n.header .header-nav .main-nav .has-submenu.active .submenu li.active > a {\n  color: #09dca4;\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav .has-submenu.active .submenu li.active > a {\n    color: #09dca4;\n  }\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav .has-submenu:hover > .submenu {\n    visibility: visible;\n    opacity: 1;\n    margin-top: 0;\n    transform: translateY(0);\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n  }\n}\n.header .header-nav .main-nav .has-submenu > .submenu__ > .has-submenu--.submenu::before {\n  top: 20px;\n  margin-left: -35px;\n  border-color: transparent #ffffff #ffffff transparent;\n  -webkit-box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);\n  box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);\n}\n.header .header-nav .logo {\n  display: inline-block;\n  margin-right: 30px;\n  width: 160px;\n}\n@media (max-width: 1199.98px) {\n  .header .header-nav .logo {\n    margin-right: 21px;\n  }\n}\n@media (max-width: 575.98px) {\n  .header .header-nav .logo {\n    width: 100%;\n    text-align: center;\n    margin-right: 0;\n  }\n}\n@media (max-width: 575.98px) {\n  .header .header-nav .logo img {\n    height: 40px;\n  }\n}\n.header .header-nav .header-navbar-rht {\n  margin: 0 0 0 auto;\n  padding: 0;\n}\n@media (max-width: 575.98px) {\n  .header .header-nav .header-navbar-rht {\n    display: none;\n  }\n}\n.header .header-nav .header-navbar-rht li {\n  padding-right: 20px;\n}\n.header .header-nav .header-navbar-rht li:last-child {\n  padding-right: 0px;\n}\n.header .header-nav .header-navbar-rht li .dropdown-menu {\n  border: 0;\n  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n}\n@media (min-width: 992px) {\n  .header .header-nav .header-navbar-rht li .dropdown-menu {\n    min-width: 200px;\n    visibility: hidden;\n    opacity: 0;\n    display: block;\n    margin: 0;\n    padding: 0;\n    border-radius: 5px;\n    transform: translateY(20px);\n    -webkit-transform: translateY(20px);\n    -ms-transform: translateY(20px);\n  }\n}\n.header .header-nav .header-navbar-rht li .dropdown-menu::before {\n  content: \"\";\n  border: 7px solid #ffffff;\n  border-color: transparent transparent #ffffff #ffffff;\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  position: absolute;\n  top: -5px;\n  right: 17px;\n  -webkit-box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\n  box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\n}\n.header .header-nav .header-navbar-rht li .dropdown-menu .dropdown-item {\n  border-top: 1px solid #f0f0f0;\n  padding: 10px 15px;\n}\n.header .header-nav .header-navbar-rht li .dropdown-menu .dropdown-item:first-child {\n  border-top: 0;\n  border-radius: 5px 5px 0 0;\n}\n.header .header-nav .header-navbar-rht li .dropdown-menu .dropdown-item:last-child {\n  border-radius: 0 0 5px 5px;\n}\n.header .header-nav .header-navbar-rht li .dropdown-menu a:hover {\n  color: #09dca4;\n  letter-spacing: 0.5px;\n  padding-left: 20px;\n  background-color: #ffffff;\n}\n.header .header-nav .header-navbar-rht li a.header-login {\n  border: 2px solid #09e5ab;\n  text-align: center;\n  font-size: 15px;\n  color: #09e5ab;\n  text-transform: uppercase;\n  font-weight: 500;\n  border-radius: 4px;\n  padding: 10px 15px !important;\n}\n.header .header-nav .header-navbar-rht li a.header-login:hover {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n  color: #ffffff;\n}\n.header .header-nav .header-navbar-rht li .header-contact-img {\n  display: inline-block;\n}\n.header .header-nav .header-navbar-rht li .header-contact-img i {\n  color: rgba(0, 0, 0, 0.5);\n  font-size: 30px;\n}\n.header .header-nav .header-navbar-rht li .header-contact-detail {\n  display: inline-block;\n  padding-left: 10px;\n}\n.header .header-nav .header-navbar-rht li .header-contact-detail p.contact-header {\n  color: #484848;\n  font-size: 13px;\n  font-weight: 400;\n  margin-bottom: 2px;\n  text-align: left;\n}\n.header .header-nav .header-navbar-rht li .header-contact-detail p.contact-info-header {\n  color: #000000;\n  font-weight: 500;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n.header .header-nav .header-navbar-rht li .header-contact-detail p.contact-info-header.white-font {\n  color: #ffffff;\n}\n@media (min-width: 992px) {\n  .header .header-nav .header-navbar-rht li.show > .dropdown-menu {\n    visibility: visible;\n    opacity: 1;\n    margin-top: 0;\n    transform: translateY(0);\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n  }\n}\n.header .header-nav .header-navbar-rht li .dropdown-menu.show {\n  visibility: visible;\n  opacity: 1;\n  margin-top: 0;\n  transform: translateY(0);\n  -webkit-transform: translateY(0);\n  -ms-transform: translateY(0);\n  -webkit-transition: all 0.2s ease;\n  -ms-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n@media (min-width: 992px) {\n  .header .header-nav .header-navbar-rht li .dropdown-menu {\n    min-width: 200px;\n    visibility: hidden;\n    opacity: 0;\n    display: block;\n    transform: translateY(20px);\n    -webkit-transform: translateY(20px);\n    -ms-transform: translateY(20px);\n    border-radius: 5px;\n    margin: 0;\n    padding: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .header .header-nav .header-navbar-rht li.contact-item {\n    display: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .header .header-nav .header-navbar-rht li.contact-item {\n    display: none;\n  }\n}\n.header .header-nav .header-navbar-rht .dropdown-toggle::after {\n  display: none;\n}\n.header .header-nav .header-navbar-rht .dropdown-menu {\n  min-width: 200px;\n  padding: 0;\n}\n.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item {\n  border-top: 1px solid #e3e3e3;\n  padding: 10px 15px;\n}\n.header .header-nav .header-navbar-rht .dropdown-menu .dropdown-item:hover {\n  color: #0e82fd;\n}\n.header .header-nav .header-navbar-rht .has-arrow .dropdown-toggle:after {\n  border-top: 0;\n  border-left: 0;\n  border-bottom: 2px solid #757575;\n  border-right: 2px solid #757575;\n  content: \"\";\n  height: 8px;\n  display: inline-block;\n  pointer-events: none;\n  width: 8px;\n  vertical-align: 2px;\n  margin-left: 10px;\n  transform-origin: 66% 66%;\n  -webkit-transform-origin: 66% 66%;\n  -ms-transform-origin: 66% 66%;\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -webkit-transition: all 0.15s ease-in-out;\n  -ms-transition: all 0.15s ease-in-out;\n  transition: all 0.15s ease-in-out;\n}\n.header .header-nav .header-navbar-rht .has-arrow .dropdown-toggle[aria-expanded=\"true\"]:after {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n  -ms-transform: rotate(-135deg);\n}\n.header .header-nav .header-navbar-rht .has-arrow .dropdown-toggle .user-img {\n  display: inline-block;\n  position: relative;\n}\n.header .header-nav .header-navbar-rht .has-arrow .dropdown-toggle .user-img > img {\n  height: 31px;\n  object-fit: cover;\n  width: 31px;\n}\n.header .header-nav .header-navbar-rht .has-arrow .user-header {\n  padding: 10px 15px;\n}\n.header .header-nav .header-navbar-rht .has-arrow .user-header .user-text {\n  margin-left: 10px;\n}\n.header .header-nav .header-navbar-rht .has-arrow .user-header .user-text h6 {\n  font-size: 15px;\n  margin-bottom: 2px;\n}\n.header .header-nav .header-navbar-rht .has-arrow .logged-item .nav-link {\n  font-size: 14px;\n  line-height: 85px;\n  padding: 0 10px;\n}\n.header .header-nav .header-navbar-rht .has-arrow.logged-item .nav-link {\n  font-size: 14px;\n  line-height: 85px;\n  padding: 0 10px;\n}\n.header .header-nav .header-navbar-rht .view-cart-header {\n  position: relative;\n}\n.header .header-nav .header-navbar-rht .view-cart-header a#cart {\n  position: relative;\n  font-size: 18px;\n  color: #6b7280;\n}\n.header .header-nav .header-navbar-rht .view-cart-header a#cart:hover {\n  color: #0e82fd;\n}\n.header .header-nav .header-navbar-rht .noti-nav .nav-link {\n  font-size: 18px;\n  color: #6b7280;\n}\n.header .header-nav .header-navbar-rht .noti-nav .nav-link .badge {\n  background-color: #0e82fd;\n  border-radius: 2px;\n  color: #ffffff;\n  font-size: 10px;\n  font-style: normal;\n  text-align: center;\n  position: absolute;\n  top: 19px;\n  right: -6px;\n  padding: 0 5px;\n  width: 15px;\n  height: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 0;\n  font-weight: normal;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu {\n  min-width: 370px;\n  padding: 0;\n  font-weight: normal;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .topnav-dropdown-header {\n  border-bottom: 1px solid #eef1fe;\n  height: 44px;\n  line-height: 44px;\n  padding-left: 15px;\n  padding-right: 15px;\n  font-weight: 500;\n  display: flex;\n  justify-content: space-between;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .noti-content {\n  height: 260px;\n  width: 420px;\n  overflow-y: auto;\n  position: relative;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .notification-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu ul.notification-list > li {\n  margin-top: 0;\n  border-bottom: 1px solid #f5f5f5;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu ul.notification-list > li a {\n  display: block;\n  padding: 10px 15px;\n  border-radius: 2px;\n  width: 100%;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu ul.notification-list > li a:hover {\n  letter-spacing: normal;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .media:last-child {\n  border-bottom: none;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .media > .avatar {\n  margin-right: 10px;\n  width: auto;\n  height: auto;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .media > .avatar > img {\n  width: 46px;\n  height: 46px;\n  border-radius: 5px;\n  margin-right: 8px;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .media-body {\n  width: 100%;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .media-body h6 {\n  margin-bottom: 3px;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .noti-title {\n  color: #0e82fd;\n}\n.header .header-nav .header-navbar-rht .noti-nav .dropdown-menu .notification-time {\n  font-size: 12px;\n  line-height: 1.35;\n  float: right;\n}\n.header .nav-transparent {\n  background-color: transparent !important;\n  border-bottom: 0 !important;\n}\n@media (min-width: 992px) {\n  .header .nav-transparent .white-font > li > a {\n    color: #ffffff;\n  }\n}\n.header.custom {\n  background-color: transparent;\n  border-bottom: 0 !important;\n}\n.header.custom .no-border {\n  border: none !important;\n}\n@media (min-width: 992px) {\n  .header.custom .white-font > li > a {\n    color: #ffffff;\n  }\n}\n.header.custom .header-navbar-rht.right-menu .header-contact-img i {\n  width: 30px;\n  background-color: #ffffff;\n  height: 30px;\n  border-radius: 50%;\n  font-size: 11px;\n  color: #1860ca;\n  border: 2px solid #acc9f5;\n}\n.header.custom .header-navbar-rht.right-menu .header-contact-detail p.contact-info-header {\n  color: #ffffff;\n}\n.header.custom .header-navbar-rht.right-menu li {\n  border-right: 0;\n}\n.header.custom .header-navbar-rht.right-menu li a.header-login {\n  width: 120px;\n  padding: 10px !important;\n}\n.header.custom .header-navbar-rht.right-menu li:last-child {\n  border-right: 0;\n  padding: 0;\n}\n.header.header-five .no-border {\n  border: none !important;\n}\n.header.header-five .main-menu-wrapper {\n  margin-left: 40px !important;\n}\n@media (max-width: 991.98px) {\n  .header.header-five .main-menu-wrapper {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 992px) {\n  .header.header-five .main-menu-wrapper .main-nav .has-submenu.active > a {\n    color: #28daf4;\n  }\n}\n.header.header-five .main-menu-wrapper .main-nav .has-submenu.active > a:after {\n  content: \"\";\n  width: 70px;\n  background: #28daf4;\n  height: 2px;\n  z-index: 9;\n  position: absolute;\n  bottom: 25px;\n  left: -7px;\n}\n.header.header-five .main-menu-wrapper .main-nav.blue-font > li > a {\n  color: #2a85d1;\n  text-transform: uppercase;\n}\n.header.header-five .header-navbar-rht li a.header-login.white-bg {\n  background-color: #ffffff;\n  color: #28daf4 !important;\n  border: 1px solid #28daf4;\n  font-size: 12px;\n}\n.header .user-menu {\n  float: right;\n  position: relative;\n  z-index: 99;\n  margin: 0;\n}\n.header .user-menu.nav li a {\n  color: #ffffff;\n  font-size: 14px;\n  line-height: 58px;\n  height: 60px;\n  padding: 0 15px;\n}\n.header .user-menu.nav li a:hover,\n.header .user-menu.nav li a:focus {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n.header .user-menu.nav li a:hover i,\n.header .user-menu.nav li a:focus i {\n  color: #ffffff;\n}\n.header .user-menu.nav li a.mobile_btn {\n  border: 0;\n  position: relative;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n}\n.header.header-four .header-nav {\n  background-color: #2264c5;\n  border: none;\n}\n@media (min-width: 992px) {\n  .header.header-four .main-nav .has-submenu.active > a {\n    color: #ffffff;\n    border-top: 3px solid #e74e84;\n  }\n}\n@media (min-width: 992px) {\n  .header.header-four .main-nav > li > a {\n    line-height: 80px;\n    color: #ffffff;\n  }\n}\n.header.header-four .nav-item {\n  line-height: 60px;\n  align-items: center;\n  display: flex !important;\n}\n.header.header-four .nav-item a.header-login {\n  border: 2px solid #ffffff;\n  border-radius: 30px;\n  text-align: center;\n  font-size: 14px;\n  color: #ffffff;\n  text-transform: uppercase;\n  font-weight: 500;\n  line-height: 20px;\n  padding: 10px 15px !important;\n}\n.header.header-four .nav-item a.header-login:hover {\n  background-color: #10defd;\n  border: 2px solid #10defd;\n}\n.header.header-four .nav-item a.header-login i {\n  font-size: 14px;\n  margin: 0;\n  margin-right: 3px;\n}\n.header.header-trans {\n  position: fixed;\n  display: block;\n  width: 100%;\n  z-index: 9999;\n  background: transparent;\n}\n.header.header-trans .header-nav {\n  background: transparent;\n  border-bottom: none;\n}\n.header.header-trans .main-menu-wrapper {\n  margin-left: auto;\n}\n@media (max-width: 1399.98px) {\n  .header.header-trans .main-menu-wrapper {\n    margin-right: auto;\n    margin-left: unset;\n  }\n}\n.header.header-trans .header-navbar-rht li {\n  height: 20px;\n  padding-right: 15px;\n}\n@media (max-width: 1399.98px) {\n  .header.header-trans .header-navbar-rht li {\n    padding-right: 5px;\n  }\n}\n.header.header-trans .header-navbar-rht li .header-contact-img i {\n  color: #1c5b90;\n  font-size: 14px;\n}\n.header.header-trans .header-navbar-rht li .header-contact-detail p.contact-info-header {\n  color: #1c5b90;\n}\n.header.header-trans .header-navbar-rht li:last-child {\n  border-right: 0;\n  padding-left: 15px;\n}\n@media (max-width: 1199.98px) {\n  .header.header-trans .header-navbar-rht li:last-child {\n    padding-left: 0;\n  }\n}\n.header.header-trans .header-navbar-rht li a.header-login {\n  text-align: center;\n  font-size: 13px;\n  color: #ffffff;\n  text-transform: uppercase;\n  background: #1c5b91;\n  box-shadow: 0px 4px 4px rgba(189, 189, 189, 0.25);\n  border-radius: 47px;\n  border: 0;\n}\n.header.header-trans .header-navbar-rht li a.header-login.white-bg {\n  background-color: #ffffff;\n  color: #2264c5;\n}\n.header.header-trans .header-navbar-rht li a.header-login:hover {\n  background-color: #1c5b91;\n  color: #ffffff;\n}\n\n.header-one {\n  width: 100%;\n  z-index: 1040;\n  -webkit-transition: all 0.3s ease 0s;\n  -ms-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n  background-color: transparent;\n  box-shadow: 0px 4px 4px rgba(198, 198, 198, 0.25);\n}\n.header-one .header-nav .main-nav .has-submenu.active .submenu li.active > a {\n  color: #0e82fd;\n}\n.header-one.min-header {\n  width: 100%;\n  z-index: 1040;\n  -webkit-transition: all 0.3s ease 0s;\n  -ms-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n  background-color: transparent;\n}\n.header-one.header-fixed {\n  position: fixed;\n  display: block;\n  width: 100%;\n  z-index: 9999;\n  background: #f2f6f6;\n  box-shadow: inherit;\n}\n.header-one.header-space .header-nav {\n  height: 80px;\n}\n.header-one .header-nav {\n  background-color: transparent;\n  border: 0;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  height: 100px;\n  -webkit-transition: all 0.5s ease;\n  -ms-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n@media (max-width: 991.98px) {\n  .header-one .header-nav {\n    height: 70px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header-one .header-nav {\n    margin: 0;\n    padding: 0 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .header-one .header-nav .menu-header {\n    height: 70px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header-one .header-nav .main-menu-wrapper {\n    background-color: #0e82fd;\n  }\n}\n@media (max-width: 991.98px) {\n  .header-one .navbar-header {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    width: 100%;\n  }\n}\n.header-one .navbar-header #mobile_btn {\n  display: none;\n  margin-right: 30px;\n}\n@media (max-width: 991.98px) {\n  .header-one .navbar-header #mobile_btn {\n    display: inline-block;\n    margin: 0;\n    padding: 0 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .header-one .navbar-header #mobile_btn {\n    margin-right: 0;\n  }\n}\n.header-one .navbar-header #mobile_btn .bar-icon {\n  display: inline-block;\n  width: 31px;\n}\n.header-one .navbar-header #mobile_btn .bar-icon span {\n  background-color: #0e82fd;\n  display: block;\n  float: left;\n  height: 3px;\n  margin-bottom: 7px;\n  width: 31px;\n  border-radius: 2px;\n  -webkit-transition: ease all 0.5s;\n  -ms-transition: ease all 0.5s;\n  transition: ease all 0.5s;\n  position: relative;\n}\n.header-one .navbar-header #mobile_btn .bar-icon span:nth-child(2) {\n  width: 16px;\n}\n.header-one .navbar-header #mobile_btn .bar-icon span:nth-child(3) {\n  margin-bottom: 0;\n}\n.header-one .main-menu-wrapper {\n  margin: 0;\n  padding: 0;\n}\n.header-one .main-menu-wrapper .main-nav {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n@media (max-width: 991.98px) {\n  .header-one .main-menu-wrapper .main-nav ul {\n    background-color: #e6f1ff;\n    display: none;\n    list-style: none;\n    margin: 0;\n    padding-left: 0;\n  }\n}\n.header-one .main-menu-wrapper .main-nav li .btn {\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 7px 8px !important;\n  border: 1px solid #0e82fd;\n  border-radius: 6px;\n}\n.header-one .main-menu-wrapper .main-nav li .btn:hover {\n  color: #0e82fd;\n  border: 1px solid #0e82fd;\n}\n.header-one .main-menu-wrapper .main-nav li .btn i {\n  font-size: 15px;\n  margin-right: 5px;\n  margin-left: 0;\n}\n.header-one .main-menu-wrapper .main-nav li .btn.reg-btn {\n  min-width: 108px;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  color: #1f2937;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.header-one .main-menu-wrapper .main-nav li .btn.reg-btn:hover {\n  color: #ffffff;\n  background-color: #0e82fd;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.header-one .main-menu-wrapper .main-nav li .btn.log-btn {\n  min-width: 87px;\n  color: #ffffff;\n  background-color: #0e82fd;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.header-one .main-menu-wrapper .main-nav li .btn.log-btn:hover {\n  color: #0e82fd;\n  background-color: #ffffff;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 50px #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.header-one .main-menu-wrapper .main-nav li a {\n  font-size: 15px;\n  font-weight: 500;\n  color: #1f2937;\n  display: block;\n}\n@media (max-width: 1199.98px) {\n  .header-one .main-menu-wrapper .main-nav li a {\n    font-size: 14px;\n  }\n}\n.header-one .main-menu-wrapper .main-nav li.login-link {\n  display: none;\n}\n@media (max-width: 991.98px) {\n  .header-one .main-menu-wrapper .main-nav li.login-link {\n    display: block;\n  }\n}\n@media (min-width: 992px) {\n  .header-one .main-menu-wrapper .main-nav li > ul {\n    background: #ffffff;\n    box-shadow: 0px 4px 4px rgba(196, 196, 196, 0.25);\n    border-radius: 0px 0px 6px 5px;\n    display: block;\n    font-size: 14px;\n    min-width: 200px;\n    opacity: 0;\n    margin: 0;\n    padding: 0;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    -webkit-transition: all 0.2s ease;\n    -ms-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n    transform: translateY(20px);\n    -webkit-transform: translateY(20px);\n    -ms-transform: translateY(20px);\n    visibility: hidden;\n    z-index: 1000;\n  }\n}\n@media (min-width: 992px) {\n  .header-one .main-menu-wrapper .main-nav li {\n    display: block;\n    position: relative;\n  }\n}\n.header-one .main-menu-wrapper .main-nav .register-btn {\n  margin-right: 10px;\n}\n.header-one .main-menu-wrapper .main-nav .register-btn:last-child {\n  margin-right: 0;\n}\n@media (max-width: 991.98px) {\n  .header-one .main-menu-wrapper .main-nav .register-btn {\n    display: none;\n  }\n}\n@media (min-width: 992px) {\n  .header-one .main-menu-wrapper .main-nav > li {\n    margin-right: 8px;\n  }\n}\n@media (min-width: 1200.98px) {\n  .header-one .main-menu-wrapper .main-nav > li {\n    margin-right: 20px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header-one .main-menu-wrapper .main-nav > li {\n    border-bottom: 1px solid #e6f1ff;\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .header-one .main-menu-wrapper .main-nav > li > a i {\n    float: right;\n    margin-top: 5px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header-one .main-menu-wrapper .main-nav > li > a {\n    line-height: 1.5;\n    padding: 15px 20px !important;\n    color: #ffffff !important;\n    font-size: 14px;\n    background: transparent !important;\n    border-radius: 0 !important;\n  }\n}\n.header-one .main-menu-wrapper .main-nav > li:last-child {\n  margin-right: 0;\n}\n.header-one .main-menu-wrapper .main-nav > li.active > a {\n  color: #0e82fd !important;\n}\n@media (max-width: 991.98px) {\n  .header-one .main-menu-wrapper .main-nav > li.active > a {\n    color: #ffffff !important;\n  }\n}\n.header-one .main-menu-wrapper .main-nav > li > a {\n  position: relative;\n}\n.header-one .main-menu-wrapper .main-nav > li > a:hover {\n  color: #0e82fd;\n}\n@media (min-width: 992px) {\n  .header-one .main-menu-wrapper .main-nav > li > a {\n    padding: 23px 0 28px !important;\n    line-height: normal;\n  }\n}\n.header-one .main-menu-wrapper .main-nav > li > a > i {\n  font-size: 10px;\n  margin-left: 6px;\n}\n.header-one .main-menu-wrapper .main-nav > li.searchbar a {\n  color: #6b7280;\n}\n.header-one .main-menu-wrapper .main-nav > li.searchbar a i {\n  font-size: 16px;\n}\n@media (max-width: 1199.98px) {\n  .header-one .main-menu-wrapper .main-nav > li.searchbar {\n    display: none;\n  }\n}\n.header-one .main-menu-wrapper .main-nav > li.has-submenu .submenu .has-submenu .submenu::before {\n  top: 20px;\n  margin-left: -35px;\n  box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);\n  border-color: transparent #ffffff #ffffff transparent;\n}\n@media (min-width: 992px) {\n  .header-one .main-menu-wrapper .main-nav > li.has-submenu:hover > .submenu {\n    visibility: visible;\n    opacity: 1;\n    margin-top: 0;\n    transform: translateY(0);\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n  }\n  .header-one\n    .main-menu-wrapper\n    .main-nav\n    > li.has-submenu:hover\n    > .submenu\n    > li.has-submenu:hover\n    .submenu {\n    visibility: visible;\n    opacity: 1;\n    margin-top: 0;\n    margin-right: 0;\n  }\n}\n.header-one .main-menu-wrapper .main-nav > li .submenu li {\n  position: relative;\n}\n.header-one .main-menu-wrapper .main-nav > li .submenu li a {\n  display: block;\n  padding: 10px 15px;\n  clear: both;\n  white-space: nowrap;\n  font-size: 14px;\n  color: #2d3b48;\n  -webkit-transition: all 0.35s ease;\n  -ms-transition: all 0.35s ease;\n  transition: all 0.35s ease;\n  width: 100%;\n  position: relative;\n  border-top: 1px solid #f0f0f0;\n}\n.header-one .main-menu-wrapper .main-nav > li .submenu li a.active {\n  color: #0e82fd;\n}\n.header-one .main-menu-wrapper .main-nav > li .submenu li a:hover {\n  color: #0e82fd !important;\n}\n@media (max-width: 991.98px) {\n  .header-one .main-menu-wrapper .main-nav > li .submenu li a {\n    padding: 10px 15px 10px 35px;\n  }\n}\n.header-one .main-menu-wrapper .main-nav > li .submenu > li.has-submenu > a::after {\n  content: \"\\f054\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 700;\n  position: absolute;\n  top: 12px;\n  right: 15px;\n  font-size: 13px;\n}\n@media (min-width: 992px) {\n  .header-one .main-menu-wrapper .main-nav > li .submenu > li .inner-submenu {\n    left: 100%;\n    top: 0;\n    margin-top: 10px;\n  }\n}\n@media (min-width: 992px) {\n  .header-one .main-menu-wrapper .main-nav > li .submenu::before {\n    border: 7px solid #ffffff;\n    border-color: transparent transparent #ffffff #ffffff;\n    box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\n    content: \"\";\n    position: absolute;\n    top: 2px;\n    left: 45px;\n    -webkit-transform-origin: 0 0;\n    transform-origin: 0 0;\n    transform: rotate(135deg);\n    -webkit-transform: rotate(135deg);\n    -ms-transform: rotate(135deg);\n  }\n}\n@media (max-width: 991.98px) {\n  .header-one .main-menu-wrapper .main-nav {\n    padding: 0;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .header-one .main-menu-wrapper {\n    order: 3;\n    width: 260px;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n    z-index: 1060;\n    -webkit-transition: all 0.4s;\n    -ms-transition: all 0.4s;\n    transition: all 0.4s;\n    transform: translateX(-260px);\n    -webkit-transform: translateX(-260px);\n    -ms-transform: translateX(-260px);\n    background-color: #09e5ab;\n  }\n}\n.header-one .logo {\n  display: inline-block;\n  margin-right: 0;\n}\n@media (max-width: 991.98px) {\n  .header-one .logo.navbar-brand {\n    width: 100%;\n    text-align: center;\n    margin: 0;\n    padding: 0;\n  }\n}\n.header-one .header-nav .header-navbar-rht {\n  margin: 0;\n  padding: 0;\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 600;\n  margin-right: 2px;\n}\n.header-one .header-nav .header-navbar-rht li {\n  margin-right: 10px;\n}\n.header-one .header-nav .header-navbar-rht li .btn {\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 15px;\n  padding: 6px 12px;\n  border: 1px solid #09e5ab;\n  border-radius: 6px;\n}\n.header-one .header-nav .header-navbar-rht li .btn:hover {\n  color: #09e5ab;\n  border: 1px solid #09e5ab;\n}\n.header-one .header-nav .header-navbar-rht li .btn i {\n  margin-right: 5px;\n}\n.header-one .header-nav .header-navbar-rht li .btn.reg-btn {\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  color: #1f2937;\n  box-shadow: inset 0 0 0 0 #09e5ab;\n}\n.header-one .header-nav .header-navbar-rht li .btn.reg-btn:hover {\n  color: #ffffff;\n  background-color: #09e5ab;\n  border: 1px solid #09e5ab;\n}\n.header-one .header-nav .header-navbar-rht li:last-child {\n  margin-right: 0;\n}\n@media (max-width: 991.98px) {\n  .header-one .header-nav .header-navbar-rht {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .header-one .header-nav .header-navbar-rht {\n    display: none;\n  }\n}\n.header-one .menu-header {\n  background-color: #ffffff;\n  height: 72px;\n  padding: 0 15px;\n  border-bottom: 2px solid #0e82fd;\n  display: none;\n}\n.header-one .menu-header .menu-close {\n  font-size: 20px;\n}\n.header-one .menu-header .menu-close i {\n  color: #0e82fd;\n}\n.header-one .menu-header .menu-close i:hover {\n  color: #000000;\n}\n@media (max-width: 991.98px) {\n  .header-one .menu-header {\n    display: flex;\n  }\n}\n\n.togglesearch {\n  position: absolute;\n  top: 74px;\n  right: 8%;\n  width: 280px;\n  display: none;\n  z-index: 999;\n  background: #ffffff;\n  padding: 10px 10px;\n  border-radius: 5px;\n  box-shadow: 0 2px 8px rgba(183, 183, 183, 0.25);\n}\n.togglesearch input[type=\"text\"] {\n  width: 182px;\n  padding: 5px 10px;\n  border: 1px solid #0e82fd;\n  outline: none;\n  height: 39px;\n  border-radius: 5px 0 0 5px;\n}\n.togglesearch button {\n  background: #0e82fd;\n  color: #ffffff;\n  border: 1px solid #0e82fd;\n  outline: none;\n  cursor: pointer;\n  border-radius: 0 5px 5px 0;\n  padding: 10px 12px;\n  font-size: 14px;\n}\n\n.sidebar-overlay {\n  background-color: rgba(0, 0, 0, 0.6);\n  display: none;\n  height: 100%;\n  width: 100%;\n  z-index: 1040;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n@media (max-width: 991.98px) {\n  .sidebar-overlay.opened {\n    display: block;\n  }\n}\n\n.menu-opened .main-menu-wrapper {\n  transform: translateX(0) !important;\n  -webkit-transform: translateX(0) !important;\n  -ms-transform: translateX(0) !important;\n}\n\nhtml.menu-opened body {\n  overflow: hidden;\n}\n\n#mobile_btn {\n  display: none;\n  margin-right: 30px;\n}\n@media (max-width: 991.98px) {\n  #mobile_btn {\n    display: inline-block;\n  }\n}\n@media (max-width: 575.98px) {\n  #mobile_btn {\n    margin-right: 0;\n    z-index: 99;\n    position: absolute;\n    left: 0;\n    padding: 0;\n  }\n}\n\n.header-two .header-nav .navbar-header #mobile_btn,\n.header-eight .header-nav .navbar-header #mobile_btn,\n.custom .header-nav .navbar-header #mobile_btn {\n  margin-left: 15px;\n}\n\n@media (max-width: 575.98px) {\n  .navbar-brand.logo {\n    width: 100%;\n    text-align: center;\n    margin-right: 0;\n  }\n}\n@media (max-width: 575.98px) {\n  .navbar-brand.logo img {\n    height: 40px;\n  }\n}\n\n.header-top {\n  display: flex;\n  background: #09e5ab;\n  color: #ffffff;\n  padding: 8px 30px;\n}\n@media (max-width: 991.98px) {\n  .header-top {\n    display: none;\n  }\n}\n.header-top ul {\n  display: flex;\n}\n.header-top ul li {\n  padding-right: 25px;\n  font-size: 13px;\n}\n.header-top ul li .top-icon {\n  margin-right: 5px;\n}\n.header-top ul li:last-child {\n  padding-right: 0;\n}\n.header-top .right-top {\n  margin-left: auto;\n}\n\n.login-header-info {\n  position: fixed;\n  top: 0;\n  left: 0;\n  box-shadow: unset;\n  background: #ffffff;\n  border-bottom: 2px solid #f1f1f3;\n  width: 100%;\n  z-index: 11;\n}\n@media (max-width: 991.98px) {\n  .login-header-info {\n    display: none;\n  }\n}\n.login-header-info .header-nav {\n  height: 83px;\n  margin: 0;\n  padding: 0 30px;\n}\n@media (max-width: 991.98px) {\n  .login-header-info .header-nav {\n    height: 70px;\n    margin: 0;\n    padding: 0 20px;\n  }\n}\n@media (max-width: 767.98px) {\n  .login-header-info .header-nav {\n    margin: 0;\n    padding: 0 15px;\n  }\n}\n.login-header-info .header-nav .main-nav li a {\n  font-size: 15px;\n  font-weight: 500;\n  color: #6b7280;\n}\n.login-header-info .header-nav .main-nav li a:hover {\n  color: #0e82fd;\n}\n.login-header-info .header-navbar-rht {\n  display: none;\n}\n@media (max-width: 991.98px) {\n  .login-header-info .header-navbar-rht {\n    display: inherit;\n  }\n}\n@media (max-width: 767.98px) {\n  .login-header-info .header-navbar-rht {\n    display: none;\n  }\n}\n.login-header-info .flag-dropdown {\n  margin: 0;\n  padding: 18px 0;\n}\n@media (max-width: 991.98px) {\n  .login-header-info .flag-dropdown {\n    margin: 0;\n    padding: 12px 0;\n  }\n}\n\n.flag-dropdown .dropdown-toggle {\n  color: #1f2937 !important;\n  font-size: 14px !important;\n  padding: 11px 15px;\n  min-width: 146px;\n  background: #ffffff;\n  border: 1px solid #e4e4e8;\n  border-radius: 8px;\n  position: relative;\n  display: flex !important;\n}\n.flag-dropdown .dropdown-toggle.show + .dropdown-menu {\n  visibility: visible;\n  opacity: 1;\n  margin-top: 0;\n  border-radius: 0 0 5px 5px;\n  transform: translateY(0);\n  -webkit-transform: translateY(0);\n  -ms-transform: translateY(0);\n}\n.flag-dropdown .dropdown-toggle:after {\n  border-top: 0;\n  border-left: 0;\n  border-bottom: 2px solid #000000;\n  border-right: 2px solid #000000;\n  content: \"\";\n  height: 8px;\n  display: inline-block;\n  pointer-events: none;\n  -webkit-transform-origin: 66% 66%;\n  -ms-transform-origin: 66% 66%;\n  transform-origin: 66% 66%;\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -webkit-transition: all 0.15s ease-in-out;\n  -ms-transition: all 0.15s ease-in-out;\n  transition: all 0.15s ease-in-out;\n  width: 8px;\n  vertical-align: 2px;\n  margin-left: 0;\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n.flag-dropdown .dropdown-toggle:after:hover {\n  border-bottom: 2px solid #000000;\n  border-right: 2px solid #000000;\n}\n.flag-dropdown .dropdown-toggle .flag-img {\n  margin-right: 10px;\n  border-radius: 50px;\n  width: 20px;\n}\n.flag-dropdown.show + .dropdown-menu {\n  visibility: visible;\n  opacity: 1;\n  margin-top: 0;\n  border-radius: 0 0 5px 5px;\n  transform: translateY(0);\n  -webkit-transform: translateY(0);\n  -ms-transform: translateY(0);\n}\n.flag-dropdown .dropdown-menu {\n  border-radius: 5px;\n  margin: 0;\n  padding: 0;\n  min-width: 200px;\n  visibility: hidden;\n  opacity: 0;\n  top: 100%;\n  left: auto !important;\n  right: 0 !important;\n  -webkit-transition: all 0.2s ease;\n  -ms-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  display: block;\n  transform: translateY(40px);\n  -webkit-transform: translateY(40px);\n  -ms-transform: translateY(40px);\n}\n.flag-dropdown .dropdown-menu .dropdown-item {\n  font-size: 14px !important;\n  color: #000000;\n  margin: 0;\n  padding: 10px 15px;\n  font-weight: 600;\n}\n.flag-dropdown .dropdown-menu .dropdown-item img {\n  margin-right: 10px;\n  width: 20px;\n}\n.flag-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #000000 14px !important;\n}\n.flag-dropdown .dropdown-toggle[aria-expanded=\"true\"]:after {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n  -ms-transform: rotate(-135deg);\n}\n\n.main-nav li .flag-dropdown .submenu::before {\n  display: none;\n}\n\n.flag-dropdown .dropdown-menu .dropdown-item.active,\n.flag-dropdown .dropdown-menu .dropdown-item:active {\n  color: #ffffff;\n  background-color: #09e5ab;\n}\n\n.noti-nav .nav-link {\n  font-size: 18px;\n  color: #6b7280;\n}\n.noti-nav .nav-link .badge {\n  background-color: #0e82fd;\n  border-radius: 2px;\n  color: #ffffff;\n  font-size: 10px;\n  font-style: normal;\n  text-align: center;\n  position: absolute;\n  top: 19px;\n  right: -6px;\n  padding: 0 5px;\n  width: 15px;\n  height: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 0;\n  font-weight: normal;\n}\n\n.noti-nav .dropdown-menu {\n  min-width: 420px;\n  padding: 0;\n}\n\n.main-nav li.megamenu > ul {\n  width: 100%;\n}\n\n.megamenu-wrapper {\n  padding: 25px 25px 0;\n}\n\n.single-demo {\n  transition: 0.4s;\n  margin-bottom: 25px;\n}\n\n.single-demo:hover {\n  transform: translateY(-20px);\n}\n\n.header\n  .main-menu-wrapper\n  .main-nav\n  > li\n  .submenu\n  li\n  .single-demo.active\n  .demo-info\n  .inner-demo-img {\n  color: #1c5b91;\n}\n\n.header.header-sixteen\n  .main-menu-wrapper\n  .main-nav\n  > li\n  .submenu\n  li\n  .single-demo.active\n  .demo-info\n  .inner-demo-img {\n  color: #1c5b91;\n}\n\n.header.header-thirteen\n  .main-menu-wrapper\n  .main-nav\n  > li\n  .submenu\n  li\n  .single-demo.active\n  .demo-info\n  .inner-demo-img {\n  color: #1c5b91;\n}\n\n.header.header-twelve\n  .main-menu-wrapper\n  .main-nav\n  > li\n  .submenu\n  li\n  .single-demo.active\n  .demo-info\n  .inner-demo-img {\n  color: #1c5b91;\n}\n\n.single-demo.active .demo-img {\n  box-shadow:\n    0px 4.8px 24.4px -12px rgba(19, 16, 34, 0.1),\n    0px 4px 13px -2px rgba(19, 16, 34, 0.06);\n}\n\n.single-demo:hover .demo-info {\n  opacity: 1;\n  bottom: -30px;\n}\n\n.demo-info {\n  /* position: absolute;\n  bottom: -30px; */\n  width: 100%;\n  margin: 0 auto;\n  text-align: center;\n  z-index: 1;\n  /* opacity: 0; */\n  transition: 0.4s;\n  margin-top: 10px;\n}\n\n@media (min-width: 992px) {\n  .header .header-nav .main-nav li .submenu a.inner-demo-img:hover {\n    padding-left: 0 !important;\n  }\n}\n@media (min-width: 992px) {\n  .header .header-nav .main-nav > li.megamenu {\n    position: unset;\n  }\n}\n\n.single-demo a {\n  padding: 0 !important;\n}\n\n@media (min-width: 992px) {\n  .header .header-nav .main-nav li > ul.mega-submenu {\n    padding: 0;\n    border: 0;\n    display: block;\n    opacity: 0;\n    visibility: hidden;\n    min-width: 250px;\n    transform: scaleY(0);\n    -webkit-transform: scaleY(0);\n    -moz-transform: scaleY(0);\n    -ms-transform: scaleY(0);\n    -o-transform: scaleY(0);\n    transform-origin: center top 0;\n    -webkit-transform-origin: center top 0;\n    -moz-transform-origin: center top 0;\n    -ms-transform-origin: center top 0;\n    -o-transform-origin: center top 0;\n    transition: all 0.3s ease-in-out 0s;\n    -webkit-transition: all 0.3s ease-in-out 0s;\n    -moz-transition: all 0.3s ease-in-out 0s;\n    -ms-transition: all 0.3s ease-in-out 0s;\n    -o-transition: all 0.3s ease-in-out 0s;\n    box-shadow: 0 16px 50px rgba(0, 0, 0, 0.08);\n    -webkit-box-shadow: 0 16px 50px rgba(0, 0, 0, 0.08);\n    -moz-box-shadow: 0 16px 50px rgba(0, 0, 0, 0.08);\n    -ms-box-shadow: 0 16px 50px rgba(0, 0, 0, 0.08);\n    -o-box-shadow: 0 16px 50px rgba(0, 0, 0, 0.08);\n    border-radius: 0px;\n    -webkit-border-radius: 0px;\n    -moz-border-radius: 0px;\n  }\n  .header .header-nav .main-nav li.has-submenu:hover > .submenu {\n    opacity: 1;\n    visibility: visible;\n    transform: scaleY(1);\n    -webkit-transform: scaleY(1);\n    -moz-transform: scaleY(1);\n    -ms-transform: scaleY(1);\n    -o-transform: scaleY(1);\n  }\n  .header .header-nav .main-nav li .submenu.mega-submenu::before {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .megamenu-wrapper {\n    padding: 0;\n  }\n  .demo-img {\n    display: none;\n  }\n  .demo-info {\n    opacity: 1;\n    position: relative;\n    bottom: 0;\n    text-align: left;\n    margin-top: 0;\n  }\n  .single-demo a {\n    padding: 10px 15px 10px 35px !important;\n  }\n  .single-demo:hover .demo-info {\n    bottom: 0;\n  }\n  .single-demo .demo-info a {\n    padding: 10px 15px 10px 35px;\n  }\n  .single-demo:hover {\n    transform: translateY(0);\n  }\n  .single-demo:hover .demo-info {\n    bottom: 0;\n  }\n  .single-demo {\n    margin-bottom: 0;\n  }\n}\n.header.header-ten {\n  width: 100%;\n  z-index: 1040;\n  -webkit-transition: all 0.3s ease 0s;\n  -ms-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n  background-color: transparent;\n  box-shadow: 0px 4px 4px rgba(198, 198, 198, 0.25);\n}\n.header.header-ten .header-nav .main-nav .has-submenu.active .submenu li.active > a {\n  color: #0e82fd;\n}\n.header.header-ten.min-header {\n  width: 100%;\n  z-index: 1040;\n  -webkit-transition: all 0.3s ease 0s;\n  -ms-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n  background-color: transparent;\n}\n.header.header-ten.header-fixed {\n  display: block;\n  width: 100%;\n  z-index: 9999;\n  background: #0e82fd;\n  box-shadow: inherit;\n  position: relative;\n}\n.header.header-ten.header-space {\n  background: #0e82fd;\n  position: fixed;\n}\n.header.header-ten.header-space .header-nav {\n  height: 80px;\n}\n.header.header-ten .header-nav {\n  background-color: transparent;\n  border: 0;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  -webkit-transition: all 0.5s ease;\n  -ms-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .header-nav {\n    height: 70px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .header-nav {\n    margin: 0;\n    padding: 0 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .header-nav .menu-header {\n    height: 70px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .header-nav .main-menu-wrapper {\n    background-color: #0e82fd;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .navbar-header {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    width: 100%;\n  }\n}\n.header.header-ten .navbar-header #mobile_btn {\n  display: none;\n  margin-right: 30px;\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .navbar-header #mobile_btn {\n    display: inline-block;\n    margin: 0;\n    padding: 0 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .header.header-ten .navbar-header #mobile_btn {\n    margin-right: 0;\n  }\n}\n.header.header-ten .navbar-header #mobile_btn .bar-icon {\n  display: inline-block;\n  width: 31px;\n}\n.header.header-ten .navbar-header #mobile_btn .bar-icon span {\n  background-color: #ffffff;\n  display: block;\n  float: left;\n  height: 3px;\n  margin-bottom: 7px;\n  width: 31px;\n  border-radius: 2px;\n  -webkit-transition: ease all 0.5s;\n  -ms-transition: ease all 0.5s;\n  transition: ease all 0.5s;\n  position: relative;\n}\n.header.header-ten .navbar-header #mobile_btn .bar-icon span:nth-child(2) {\n  width: 16px;\n}\n.header.header-ten .navbar-header #mobile_btn .bar-icon span:nth-child(3) {\n  margin-bottom: 0;\n}\n.header.header-ten .main-menu-wrapper {\n  margin: 0;\n  padding: 0;\n}\n.header.header-ten .main-menu-wrapper .main-nav {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .main-menu-wrapper .main-nav ul {\n    background-color: #e6f1ff;\n    display: none;\n    list-style: none;\n    margin: 0;\n    padding-left: 0;\n  }\n}\n.header.header-ten .main-menu-wrapper .main-nav li .btn {\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 7px 8px !important;\n  border: 1px solid #0e82fd;\n  border-radius: 6px;\n}\n.header.header-ten .main-menu-wrapper .main-nav li .btn:hover {\n  color: #0e82fd;\n  border: 1px solid #0e82fd;\n  background: transparent;\n}\n.header.header-ten .main-menu-wrapper .main-nav li .btn i {\n  font-size: 15px;\n  margin-right: 5px;\n  margin-left: 0;\n}\n.header.header-ten .main-menu-wrapper .main-nav li .btn.reg-btn {\n  min-width: 108px;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  color: #1f2937;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.header.header-ten .main-menu-wrapper .main-nav li .btn.reg-btn:hover {\n  color: #ffffff;\n  background-color: #0e82fd;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.header.header-ten .main-menu-wrapper .main-nav li .btn.log-btn {\n  min-width: 87px;\n  color: #ffffff;\n  background-color: #0e82fd;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.header.header-ten .main-menu-wrapper .main-nav li .btn.log-btn:hover {\n  color: #0e82fd;\n  background-color: #ffffff;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 50px #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.header.header-ten .main-menu-wrapper .main-nav li a {\n  font-size: 15px;\n  font-weight: 500;\n  color: #ffffff;\n  display: block;\n}\n@media (max-width: 1199.98px) {\n  .header.header-ten .main-menu-wrapper .main-nav li a {\n    font-size: 14px;\n  }\n}\n.header.header-ten .main-menu-wrapper .main-nav li.login-link {\n  display: none;\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .main-menu-wrapper .main-nav li.login-link {\n    display: block;\n  }\n}\n@media (min-width: 992px) {\n  .header.header-ten .main-menu-wrapper .main-nav li > ul {\n    background: #ffffff;\n    box-shadow: 0px 4px 4px rgba(196, 196, 196, 0.25);\n    border-radius: 0px 0px 6px 5px;\n    display: block;\n    font-size: 14px;\n    min-width: 200px;\n    opacity: 0;\n    margin: 0;\n    padding: 0;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    -webkit-transition: all 0.2s ease;\n    -ms-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n    transform: translateY(20px);\n    -webkit-transform: translateY(20px);\n    -ms-transform: translateY(20px);\n    visibility: hidden;\n    z-index: 1000;\n  }\n}\n@media (min-width: 992px) {\n  .header.header-ten .main-menu-wrapper .main-nav li {\n    display: block;\n    position: relative;\n  }\n}\n.header.header-ten .main-menu-wrapper .main-nav .register-btn {\n  margin-right: 10px;\n}\n.header.header-ten .main-menu-wrapper .main-nav .register-btn:last-child {\n  margin-right: 0;\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .main-menu-wrapper .main-nav .register-btn {\n    display: none;\n  }\n}\n@media (min-width: 992px) {\n  .header.header-ten .main-menu-wrapper .main-nav > li {\n    margin-right: 8px;\n  }\n}\n@media (min-width: 1200.98px) {\n  .header.header-ten .main-menu-wrapper .main-nav > li {\n    margin-right: 20px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .main-menu-wrapper .main-nav > li {\n    border-bottom: 1px solid #e6f1ff;\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .main-menu-wrapper .main-nav > li > a i {\n    float: right;\n    margin-top: 5px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .main-menu-wrapper .main-nav > li > a {\n    line-height: 1.5;\n    padding: 15px 20px !important;\n    color: #ffffff !important;\n    font-size: 14px;\n    background: transparent !important;\n    border-radius: 0 !important;\n  }\n}\n.header.header-ten .main-menu-wrapper .main-nav > li:last-child {\n  margin-right: 0;\n}\n.header.header-ten .main-menu-wrapper .main-nav > li.active > a {\n  color: #1c5b91 !important;\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .main-menu-wrapper .main-nav > li.active > a {\n    color: #ffffff !important;\n  }\n}\n.header.header-ten .main-menu-wrapper .main-nav > li > a {\n  position: relative;\n}\n.header.header-ten .main-menu-wrapper .main-nav > li > a:hover {\n  color: #09e5ab;\n}\n@media (min-width: 992px) {\n  .header.header-ten .main-menu-wrapper .main-nav > li > a {\n    padding: 10px 0 !important;\n    line-height: normal;\n  }\n}\n.header.header-ten .main-menu-wrapper .main-nav > li > a > i {\n  font-size: 10px;\n  margin-left: 6px;\n}\n.header.header-ten .main-menu-wrapper .main-nav > li.searchbar a {\n  color: #6b7280;\n}\n.header.header-ten .main-menu-wrapper .main-nav > li.searchbar a i {\n  font-size: 20px;\n  color: #ffffff;\n}\n@media (max-width: 1199.98px) {\n  .header.header-ten .main-menu-wrapper .main-nav > li.searchbar {\n    display: none;\n  }\n}\n.header.header-ten\n  .main-menu-wrapper\n  .main-nav\n  > li.has-submenu\n  .submenu\n  .has-submenu\n  .submenu::before {\n  top: 20px;\n  margin-left: -35px;\n  box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);\n  border-color: transparent #ffffff #ffffff transparent;\n}\n@media (min-width: 992px) {\n  .header.header-ten .main-menu-wrapper .main-nav > li.has-submenu:hover > .submenu {\n    visibility: visible;\n    opacity: 1;\n    margin-top: 0;\n    transform: translateY(0);\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n  }\n  .header.header-ten\n    .main-menu-wrapper\n    .main-nav\n    > li.has-submenu:hover\n    > .submenu\n    > li.has-submenu:hover\n    .submenu {\n    visibility: visible;\n    opacity: 1;\n    margin-top: 0;\n    margin-right: 0;\n  }\n}\n.header.header-ten .main-menu-wrapper .main-nav > li .submenu li {\n  position: relative;\n}\n.header.header-ten .main-menu-wrapper .main-nav > li .submenu li a {\n  display: block;\n  padding: 10px 15px;\n  clear: both;\n  white-space: nowrap;\n  font-size: 14px;\n  color: #2d3b48;\n  -webkit-transition: all 0.35s ease;\n  -ms-transition: all 0.35s ease;\n  transition: all 0.35s ease;\n  width: 100%;\n  position: relative;\n  border-top: 1px solid #f0f0f0;\n}\n.header.header-ten .main-menu-wrapper .main-nav > li .submenu li a.active {\n  color: #0e82fd;\n}\n.header.header-ten .main-menu-wrapper .main-nav > li .submenu li a:hover {\n  color: #0e82fd !important;\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .main-menu-wrapper .main-nav > li .submenu li a {\n    padding: 10px 15px 10px 35px;\n  }\n}\n.header.header-ten .main-menu-wrapper .main-nav > li .submenu > li.has-submenu > a::after {\n  content: \"\\f054\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 700;\n  position: absolute;\n  top: 12px;\n  right: 15px;\n  font-size: 13px;\n}\n@media (min-width: 992px) {\n  .header.header-ten .main-menu-wrapper .main-nav > li .submenu > li .inner-submenu {\n    left: 100%;\n    top: 0;\n    margin-top: 10px;\n  }\n}\n@media (min-width: 992px) {\n  .header.header-ten .main-menu-wrapper .main-nav > li .submenu::before {\n    border: 7px solid #ffffff;\n    border-color: transparent transparent #ffffff #ffffff;\n    box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\n    content: \"\";\n    position: absolute;\n    top: 2px;\n    left: 45px;\n    -webkit-transform-origin: 0 0;\n    transform-origin: 0 0;\n    transform: rotate(135deg);\n    -webkit-transform: rotate(135deg);\n    -ms-transform: rotate(135deg);\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .main-menu-wrapper .main-nav {\n    padding: 0;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .main-menu-wrapper {\n    order: 3;\n    width: 260px;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n    z-index: 1060;\n    -webkit-transition: all 0.4s;\n    -ms-transition: all 0.4s;\n    transition: all 0.4s;\n    transform: translateX(-260px);\n    -webkit-transform: translateX(-260px);\n    -ms-transform: translateX(-260px);\n    background-color: #09e5ab;\n  }\n}\n.header.header-ten .logo {\n  display: inline-block;\n  margin-right: 0;\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .logo.navbar-brand {\n    width: 100%;\n    text-align: center;\n    margin: 0;\n    padding: 0;\n  }\n}\n.header.header-ten .header-nav .header-navbar-rht {\n  margin: 0;\n  padding: 0;\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 600;\n  margin-right: 2px;\n}\n.header.header-ten .header-nav .header-navbar-rht li {\n  margin-right: 10px;\n  padding-right: 0;\n}\n.header.header-ten .header-nav .header-navbar-rht li .btn {\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 15px;\n  padding: 10px 12px;\n  border: 1px solid transparent;\n  border-radius: 35px;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  transition: all 0.7s;\n}\n.header.header-ten .header-nav .header-navbar-rht li .btn:hover {\n  color: #0e82fd;\n  border: 1px solid #ffffff;\n  box-shadow: inset 0 0 0 50px #ffffff;\n}\n.header.header-ten .header-nav .header-navbar-rht li .btn i {\n  margin-right: 8px;\n}\n.header.header-ten .header-nav .header-navbar-rht li .btn.reg-btn {\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  color: #1f2937;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n}\n.header.header-ten .header-nav .header-navbar-rht li .btn.reg-btn:hover {\n  color: #ffffff;\n  background-color: #0e82fd;\n  border: 1px solid #ffffff;\n  box-shadow: inset 0 0 0 50px #0e82fd;\n}\n.header.header-ten .header-nav .header-navbar-rht li:last-child {\n  margin-right: 0;\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .header-nav .header-navbar-rht {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .header.header-ten .header-nav .header-navbar-rht {\n    display: none;\n  }\n}\n.header.header-ten .menu-header {\n  background-color: #ffffff;\n  height: 72px;\n  padding: 0 15px;\n  border-bottom: 2px solid #0e82fd;\n  display: none;\n}\n.header.header-ten .menu-header .menu-close {\n  font-size: 20px;\n}\n.header.header-ten .menu-header .menu-close i {\n  color: #0e82fd;\n}\n.header.header-ten .menu-header .menu-close i:hover {\n  color: #000000;\n}\n@media (max-width: 991.98px) {\n  .header.header-ten .menu-header {\n    display: flex;\n  }\n}\n\n.header.header-ten .header-nav .main-nav > li.megamenu {\n  position: unset;\n}\n\n.header-trans.header-eleven .header-nav {\n  border-bottom: 0;\n}\n@media (max-width: 575.98px) {\n  .header-trans.header-eleven .header-nav .navbar-header #mobile_btn {\n    left: 15px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .header-trans.header-eleven .header-nav .main-nav > li {\n    margin-right: 17px;\n  }\n}\n.header-trans.header-eleven .header-nav .main-nav > li > a {\n  color: #ffffff;\n}\n.header-trans.header-eleven .header-nav .main-nav > li.has-submenu.active > a {\n  color: #0ce0ff;\n}\n.header-trans.header-eleven .header-nav .main-nav > li.submenu a:hover {\n  color: #0ce0ff;\n}\n.header-trans.header-eleven .header-navbar-rht li {\n  border-right: 0;\n  padding-right: 0;\n}\n.header-trans.header-eleven .header-navbar-rht li a.header-login {\n  background: #0ce0ff;\n  border-radius: 5px;\n  font-size: 16px;\n  font-weight: normal;\n  padding: 13px 15px !important;\n  text-transform: none;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  -webkit-transition: all 0.7s;\n  -ms-transition: all 0.7s;\n  transition: all 0.7s;\n}\n.header-trans.header-eleven .header-navbar-rht li a.header-login:hover {\n  background: #ffffff;\n  color: #1c5b91;\n  box-shadow: inset 0 60px 0 0 #ffffff;\n  -webkit-transition: all 0.7s;\n  -ms-transition: all 0.7s;\n  transition: all 0.7s;\n}\n.header-trans.header-eleven .header-navbar-rht li a.header-login.white-bg {\n  color: #1c5b91;\n  box-shadow: inset 0 0 0 0 #1c5b91;\n  -webkit-transition: all 0.7s;\n  -ms-transition: all 0.7s;\n  transition: all 0.7s;\n}\n.header-trans.header-eleven .header-navbar-rht li a.header-login.white-bg:hover {\n  background: #1c5b91;\n  color: #ffffff;\n  box-shadow: inset 0 60px 0 0 #1c5b91;\n  -webkit-transition: all 0.7s;\n  -ms-transition: all 0.7s;\n  transition: all 0.7s;\n}\n\n.header.header-fourteen.header-twelve .header-nav {\n  background-color: transparent;\n  border-bottom: none;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 0;\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen.header-twelve .header-nav .logo {\n    margin-right: 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen.header-twelve .header-nav {\n    justify-content: start;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-twelve .header-nav {\n    justify-content: space-between;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-twelve .header-nav .main-menu-wrapper {\n    background-color: #f8fbff;\n  }\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen.header-twelve .header-nav .main-menu-wrapper .main-nav li {\n    margin-right: 10px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-twelve .header-nav .main-menu-wrapper .main-nav li {\n    border-bottom: 1px solid #ffffff;\n  }\n}\n.header.header-fourteen.header-twelve .header-nav .main-menu-wrapper .main-nav li a {\n  color: #1f2937;\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-twelve .header-nav .main-menu-wrapper .main-nav li .submenu {\n    background-color: #f8fbff;\n  }\n}\n.header.header-fourteen.header-twelve .header-nav .main-menu-wrapper .main-nav li .submenu a {\n  color: #1f2937;\n}\n.header.header-fourteen.header-twelve .header-nav .main-menu-wrapper .main-nav li.active a {\n  color: #0e82fd;\n  font-weight: 700;\n}\n.header.header-fourteen.header-twelve\n  .header-nav\n  .main-menu-wrapper\n  .main-nav\n  li.active\n  .submenu\n  a {\n  color: #1f2937;\n  font-weight: 500;\n}\n.header.header-fourteen.header-twelve\n  .header-nav\n  .main-menu-wrapper\n  .main-nav\n  li.active\n  .submenu\n  a.active {\n  color: #2dd4bf;\n  font-weight: 500;\n}\n.header.header-fourteen.header-twelve\n  .header-nav\n  .main-menu-wrapper\n  .main-nav\n  li.active\n  .submenu\n  a {\n  color: #1f2937;\n}\n.header.header-fourteen.header-twelve .header-nav .header-navbar-rht {\n  padding: 0;\n  margin: 0;\n}\n.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li {\n  padding: 0 10px 0 0;\n}\n.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.login-link {\n  display: none;\n}\n.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.searchbar-fourteen {\n  background: #f6f7f5;\n  border: 1px solid #e7e8e6;\n  width: 38px;\n  height: 38px;\n  border-radius: 35px;\n  padding: 0;\n  transition: 0.5s;\n}\n.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.searchbar-fourteen:hover {\n  background: #1c5b91;\n  transition: 0.5s;\n}\n.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.searchbar-fourteen a {\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0));\n}\n.header.header-fourteen.header-twelve .header-nav .header-navbar-rht li.login-in-fourteen .reg-btn {\n  background: transparent;\n  color: #1f2937;\n  box-shadow: none;\n  border: none;\n  font-size: 15px;\n  font-weight: 600;\n  padding: 10px 12px;\n  transition: 0.5s;\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen.header-twelve\n    .header-nav\n    .header-navbar-rht\n    li.login-in-fourteen\n    .reg-btn {\n    padding: 10px 5px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-twelve\n    .header-nav\n    .header-navbar-rht\n    li.login-in-fourteen\n    .reg-btn {\n    padding: 10px 12px;\n  }\n}\n.header.header-fourteen.header-twelve\n  .header-nav\n  .header-navbar-rht\n  li.login-in-fourteen\n  .reg-btn:hover {\n  background: #0e82fd;\n  color: #ffffff;\n  transition: 0.5s;\n}\n.header.header-fourteen.header-twelve\n  .header-nav\n  .header-navbar-rht\n  li.login-in-fourteen\n  .reg-btn.reg-btn-fourteen {\n  background: #0e82fd;\n  color: #ffffff;\n  transition: 0.5s;\n  border: 1px solid #0e82fd;\n  font-size: 15px;\n  font-weight: 600;\n}\n.header.header-fourteen.header-twelve\n  .header-nav\n  .header-navbar-rht\n  li.login-in-fourteen\n  .reg-btn.reg-btn-fourteen:hover {\n  background: #ffffff;\n  color: #0e82fd;\n  transition: 0.5s;\n}\n.header.header-fourteen.header-fixed {\n  position: fixed;\n  display: block;\n  width: 100%;\n  z-index: 9999;\n  box-shadow: inherit;\n}\n\n.header.header-fourteen.header-twelve.header-thirteen {\n  background-color: #ffffff;\n}\n.header.header-fourteen.header-twelve.header-thirteen\n  .header-nav\n  .header-navbar-rht\n  li.login-in-fourteen\n  .reg-btn-thirteen {\n  display: flex;\n}\n.header.header-fourteen.header-twelve.header-thirteen\n  .header-nav\n  .header-navbar-rht\n  li.login-in-fourteen\n  .reg-btn-thirteen\n  span {\n  padding: 8px 20px;\n  border: 1px solid #0e82fd;\n  background: #0e82fd;\n  color: #ffffff;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n  transition: all 0.5s;\n}\n.header.header-fourteen.header-twelve.header-thirteen\n  .header-nav\n  .header-navbar-rht\n  li.login-in-fourteen\n  .reg-btn-thirteen\n  .user-icon-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  border: 1px solid #0e82fd;\n  background: #0f78e7;\n  color: #ffffff;\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n  transition: all 0.5s;\n}\n.header.header-fourteen.header-twelve.header-thirteen\n  .header-nav\n  .header-navbar-rht\n  li.login-in-fourteen\n  .reg-btn-thirteen:hover\n  span,\n.header.header-fourteen.header-twelve.header-thirteen\n  .header-nav\n  .header-navbar-rht\n  li.login-in-fourteen\n  .reg-btn-thirteen:hover\n  .user-icon-header {\n  background: #ffffff;\n  color: #0e82fd;\n}\n\n.header.header-fourteen .header-nav {\n  background-color: transparent;\n  border-bottom: none;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 0;\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen .header-nav .logo {\n    margin-right: 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen .header-nav {\n    justify-content: start;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen .header-nav {\n    justify-content: space-between;\n  }\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu {\n    margin-right: 10px;\n  }\n}\n.header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu a {\n  color: #ffffff;\n}\n.header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu .submenu a {\n  color: #1f2937;\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu .submenu a {\n    color: #ffffff;\n  }\n}\n.header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu.active a {\n  color: #2dd4bf;\n  font-weight: 700;\n}\n.header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu.active .submenu a {\n  color: #1f2937;\n  font-weight: 500;\n}\n.header.header-fourteen\n  .header-nav\n  .main-menu-wrapper\n  .main-nav\n  .has-submenu.active\n  .submenu\n  a.active {\n  color: #2dd4bf;\n  font-weight: 500;\n}\n.header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu.active .submenu a {\n  color: #1f2937;\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen .header-nav .main-menu-wrapper .main-nav .has-submenu.active .submenu a {\n    color: #ffffff;\n  }\n}\n.header.header-fourteen .header-nav .header-navbar-rht {\n  padding: 0;\n  margin: 0;\n}\n.header.header-fourteen .header-nav .header-navbar-rht li {\n  padding: 0 10px 0 0;\n}\n.header.header-fourteen .header-nav .header-navbar-rht li.login-link {\n  display: none;\n}\n.header.header-fourteen .header-nav .header-navbar-rht li.searchbar-fourteen a {\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n  background: #ffffff;\n  border: 1px solid #e7e8e6;\n  width: 38px;\n  height: 38px;\n  border-radius: 35px;\n  padding: 0;\n  transition: 0.5s;\n}\n.header.header-fourteen .header-nav .header-navbar-rht li.searchbar-fourteen a:hover {\n  background: #1c5b91;\n  color: #ffffff;\n  border: 1px solid #1c5b91;\n  transition: 0.5s;\n}\n.header.header-fourteen .header-nav .header-navbar-rht li.searchbar-fourteen a:hover a {\n  color: #ffffff;\n}\n.header.header-fourteen .header-nav .header-navbar-rht li.login-in-fourteen .reg-btn {\n  background: transparent;\n  color: #ffffff;\n  box-shadow: none;\n  border: none;\n  font-size: 15px;\n  font-weight: 600;\n  padding: 10px 12px;\n  transition: 0.5s;\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen .header-nav .header-navbar-rht li.login-in-fourteen .reg-btn {\n    padding: 10px 5px;\n  }\n}\n.header.header-fourteen .header-nav .header-navbar-rht li.login-in-fourteen .reg-btn:hover {\n  background: #2dd4bf;\n  color: #1e5d8a;\n  transition: 0.5s;\n}\n.header.header-fourteen\n  .header-nav\n  .header-navbar-rht\n  li.login-in-fourteen\n  .reg-btn.reg-btn-fourteen {\n  background: #2dd4bf;\n  color: #1e5d8a;\n  transition: 0.5s;\n  font-size: 15px;\n  font-weight: 600;\n}\n.header.header-fourteen\n  .header-nav\n  .header-navbar-rht\n  li.login-in-fourteen\n  .reg-btn.reg-btn-fourteen:hover {\n  background: #ffffff;\n  color: #1e5d8a;\n  transition: 0.5s;\n}\n.header.header-fixed {\n  position: fixed;\n  display: block;\n  width: 100%;\n  z-index: 9999;\n  box-shadow: inherit;\n}\n\n@media (max-width: 1199.98px) {\n  .header.header-fourteen.header-fifteen .header-nav .logo {\n    margin-right: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-fifteen .header-nav {\n    justify-content: space-between;\n  }\n}\n@media (max-width: 1399.98px) {\n  .header.header-fourteen.header-fifteen .header-nav .main-menu-wrapper .main-nav li {\n    margin-right: 20px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen.header-fifteen .header-nav .main-menu-wrapper .main-nav li {\n    margin-right: 5px;\n  }\n}\n.header.header-fourteen.header-fifteen .header-nav .main-menu-wrapper .main-nav li a {\n  color: #1f2937;\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-fifteen .header-nav .main-menu-wrapper .main-nav li a {\n    color: #ffffff;\n  }\n}\n.header.header-fourteen.header-fifteen .header-nav .header-navbar-rht .login-in-fourteen .reg-btn {\n  padding: 18px 15px;\n  background: #0ce0ff;\n  color: #ffffff;\n  border-radius: 10px;\n  font-size: 14px;\n}\n@media (max-width: 1399.98px) {\n  .header.header-fourteen.header-fifteen\n    .header-nav\n    .header-navbar-rht\n    .login-in-fourteen\n    .reg-btn {\n    padding: 13px 10px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen.header-fifteen\n    .header-nav\n    .header-navbar-rht\n    .login-in-fourteen\n    .reg-btn {\n    padding: 10px 5px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-fifteen\n    .header-nav\n    .header-navbar-rht\n    .login-in-fourteen\n    .reg-btn {\n    padding: 13px 10px;\n  }\n}\n.header.header-fourteen.header-fifteen\n  .header-nav\n  .header-navbar-rht\n  .login-in-fourteen\n  .reg-btn.reg-btn-fourteen {\n  background: #ffaf14;\n  color: #ffffff;\n}\n\n.header.header-fourteen.header-sixteen {\n  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen.header-sixteen .header-nav .logo {\n    margin-right: 30px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-sixteen .header-nav .logo {\n    margin-right: 0;\n  }\n}\n@media (max-width: 1399.98px) {\n  .header.header-fourteen.header-sixteen .header-nav {\n    justify-content: start;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-sixteen .header-nav {\n    justify-content: space-between;\n  }\n}\n.header.header-fourteen.header-sixteen .header-nav .bar-icon span {\n  background: #0e82fd;\n}\n.header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li:last-child {\n  margin-right: 30px;\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li:last-child {\n    margin-right: 10px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li {\n    margin-right: 10px;\n  }\n}\n.header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li a {\n  color: #1f2937;\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li a {\n    color: #ffffff;\n  }\n}\n.header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li .submenu a {\n  color: #1f2937;\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li .submenu a {\n    color: #ffffff;\n  }\n}\n.header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav li.active a {\n  color: #3b9cf6;\n  font-weight: 700;\n}\n.header.header-fourteen.header-sixteen\n  .header-nav\n  .main-menu-wrapper\n  .main-nav\n  li.active\n  .submenu\n  a {\n  color: #1f2937;\n  font-weight: 500;\n}\n.header.header-fourteen.header-sixteen\n  .header-nav\n  .main-menu-wrapper\n  .main-nav\n  li.active\n  .submenu\n  a.active {\n  color: #3b9cf6;\n  font-weight: 500;\n}\n.header.header-fourteen.header-sixteen\n  .header-nav\n  .main-menu-wrapper\n  .main-nav\n  li.active\n  .submenu\n  a {\n  color: #1f2937;\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-sixteen\n    .header-nav\n    .main-menu-wrapper\n    .main-nav\n    li.active\n    .submenu\n    a {\n    color: #ffffff;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav .searchbar {\n    display: none;\n  }\n}\n.header.header-fourteen.header-sixteen .header-nav .main-menu-wrapper .main-nav .searchbar a i {\n  font-size: 18px;\n  color: #6b7280;\n}\n.header.header-fourteen.header-sixteen\n  .header-nav\n  .main-menu-wrapper\n  .main-nav\n  .searchbar\n  a\n  i:hover {\n  color: #1c5b91;\n}\n.header.header-fourteen.header-sixteen .header-nav .header-navbar-rht .login-in-sixteen .reg-btn {\n  padding: 12px 14px;\n  background: #0e82fd;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  color: #ffffff;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  -webkit-transition: all 0.7s;\n  -ms-transition: all 0.7s;\n  transition: all 0.7s;\n}\n.header.header-fourteen.header-sixteen\n  .header-nav\n  .header-navbar-rht\n  .login-in-sixteen\n  .reg-btn:hover {\n  background: #ffffff;\n  color: #1c5b91;\n  -webkit-transition: all 0.7s;\n  -ms-transition: all 0.7s;\n  transition: all 0.7s;\n  box-shadow: inset 0 60px 0 0 #ffffff;\n}\n@media (max-width: 1399.98px) {\n  .header.header-fourteen.header-sixteen .header-nav .header-navbar-rht .login-in-sixteen .reg-btn {\n    padding: 13px 10px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .header.header-fourteen.header-sixteen .header-nav .header-navbar-rht .login-in-sixteen .reg-btn {\n    padding: 10px 5px;\n  }\n}\n@media (max-width: 991.98px) {\n  .header.header-fourteen.header-sixteen .header-nav .header-navbar-rht .login-in-sixteen .reg-btn {\n    padding: 13px 10px;\n  }\n}\n.header.header-fourteen.header-sixteen\n  .header-nav\n  .header-navbar-rht\n  .login-in-sixteen\n  .reg-btn.reg-btn-sixteen {\n  background: transparent;\n  color: #1f2937;\n  border: none;\n  font-weight: 600;\n  box-shadow: inset 0 0 0 0 #1c5b91;\n  -webkit-transition: all 0.7s;\n  -ms-transition: all 0.7s;\n  transition: all 0.7s;\n}\n.header.header-fourteen.header-sixteen\n  .header-nav\n  .header-navbar-rht\n  .login-in-sixteen\n  .reg-btn.reg-btn-sixteen:hover {\n  background: #1c5b91;\n  color: #ffffff;\n  box-shadow: inset 0 60px 0 0 #1c5b91;\n  -webkit-transition: all 0.7s;\n  -ms-transition: all 0.7s;\n  transition: all 0.7s;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #f0f0f0;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs {\n    border-bottom: 0;\n    position: relative;\n    background-color: #ffffff;\n    border: 1px solid #dddddd;\n    padding: 5px 0;\n    border-radius: 3px;\n  }\n}\n.nav-tabs > li > a {\n  margin-right: 0;\n  color: #888888;\n  border-radius: 3px;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs > li > a {\n    border-width: 2px;\n    border-left-color: transparent;\n  }\n}\n.nav-tabs > li > a:hover,\n.nav-tabs > li > a:focus {\n  border-color: transparent;\n  color: #272b41;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs > li > a:hover,\n  .nav-tabs > li > a:focus {\n    background-color: #fafafa;\n  }\n}\n@media (max-width: 767.98px) {\n  .nav-tabs > li > a.active {\n    border-color: transparent transparent transparent #20c0f3 !important;\n    border-left-width: 2px;\n  }\n}\n.nav-tabs > li.open:not(.active) > a,\n.nav-tabs > li.open:not(.active) > a:hover,\n.nav-tabs > li.open:not(.active) > a:focus {\n  background-color: #fafafa;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs .nav-item {\n    margin-bottom: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .nav-tabs .nav-item.show .nav-link {\n    border-color: transparent transparent transparent #20c0f3 !important;\n    border-left-width: 2px;\n  }\n}\n.nav-tabs .nav-link {\n  border-radius: 0;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs .nav-link {\n    border-width: 2px;\n  }\n}\n.nav-tabs .nav-link:focus,\n.nav-tabs .nav-link:hover {\n  background-color: #eeeeee;\n  border-color: transparent;\n  color: #272b41;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs.nav-justified {\n    border-bottom: 1px solid #dddddd;\n  }\n}\n.nav-tabs.nav-justified > li > a {\n  margin-bottom: 0;\n  border-radius: 0;\n}\n.nav-tabs.nav-justified > li > a:hover,\n.nav-tabs.nav-justified > li > a:focus {\n  border-bottom-color: #dddddd;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs.nav-justified > li > a.active {\n    border-color: transparent transparent transparent #20c0f3;\n    border-left-width: 2px !important;\n  }\n}\n.nav-tabs.nav-justified.nav-tabs-solid > li > a {\n  color: #272b41;\n}\n.nav-tabs.nav-justified.nav-tabs-top {\n  border-bottom: 1px solid #dddddd;\n}\n.nav-tabs.nav-justified.nav-tabs-top > li > a,\n.nav-tabs.nav-justified.nav-tabs-top > li > a:hover,\n.nav-tabs.nav-justified.nav-tabs-top > li > a:focus {\n  border-width: 2px 0 0 0;\n}\n.nav-tabs.nav-tabs-top > li {\n  margin-bottom: 0;\n}\n.nav-tabs.nav-tabs-top > li > a {\n  border-width: 2px 0 0 0;\n}\n.nav-tabs.nav-tabs-top > li > a.open {\n  border-top-color: #dddddd;\n}\n.nav-tabs.nav-tabs-top > li > a:hover,\n.nav-tabs.nav-tabs-top > li > a:focus {\n  border-width: 2px 0 0 0;\n  border-top-color: #dddddd;\n}\n.nav-tabs.nav-tabs-top > li > a.active,\n.nav-tabs.nav-tabs-top > li > a.active:hover,\n.nav-tabs.nav-tabs-top > li > a.active:focus {\n  border-top-color: #20c0f3;\n}\n.nav-tabs.nav-tabs-top > li + li > a {\n  margin-left: 1px;\n}\n.nav-tabs.nav-tabs-bottom > li > a.active,\n.nav-tabs.nav-tabs-bottom > li > a.active:hover,\n.nav-tabs.nav-tabs-bottom > li > a.active:focus {\n  border-bottom-width: 2px;\n  border-color: transparent;\n  border-bottom-color: #20c0f3;\n  background-color: transparent;\n  -webkit-transition: none 0s ease 0s;\n  -ms-transition: none 0s ease 0s;\n  transition: none 0s ease 0s;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs.nav-tabs-bottom > li > a.active,\n  .nav-tabs.nav-tabs-bottom > li > a.active:hover,\n  .nav-tabs.nav-tabs-bottom > li > a.active:focus {\n    background-color: #f5f5f5;\n  }\n}\n@media (max-width: 767.98px) {\n  .nav-tabs .nav-tabs-justified {\n    border-bottom: 1px solid #dddddd;\n  }\n}\n.nav-tabs .nav-tabs-justified > li > a {\n  border-radius: 0;\n  margin-bottom: 0;\n}\n.nav-tabs .nav-tabs-justified > li > a:hover,\n.nav-tabs .nav-tabs-justified > li > a:focus {\n  border-bottom-color: #dddddd;\n}\n.nav-tabs .nav-tabs-justified > li > a.active,\n.nav-tabs .nav-tabs-justified > li > a.active:focus,\n.nav-tabs .nav-tabs-justified > li > a.active:hover {\n  border-width: 0 0 0 2px;\n  border-left-color: #20c0f3;\n}\n.nav-tabs .nav-tabs-justified.nav-tabs-solid > li > a {\n  border-color: transparent;\n}\n.nav-tabs .nav-tabs-justified.nav-tabs-top {\n  border-bottom: 1px solid #dddddd;\n}\n.nav-tabs .nav-tabs-justified.nav-tabs-top > li a,\n.nav-tabs .nav-tabs-justified.nav-tabs-top > li a:hover,\n.nav-tabs .nav-tabs-justified.nav-tabs-top > li a:focus {\n  border-width: 2px 0 0 0;\n}\n.nav-tabs.nav-tabs-solid {\n  background-color: #fafafa;\n  border: 0;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs.nav-tabs-solid {\n    padding: 5px;\n  }\n}\n.nav-tabs.nav-tabs-solid > li {\n  margin-bottom: 0;\n}\n.nav-tabs.nav-tabs-solid > li a {\n  color: #272b41;\n}\n.nav-tabs.nav-tabs-solid > li a.active,\n.nav-tabs.nav-tabs-solid > li a.active:hover,\n.nav-tabs.nav-tabs-solid > li a.active:focus {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n  color: #ffffff;\n}\n.nav-tabs.nav-tabs-solid > li > a {\n  border-color: transparent;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs.nav-tabs-solid > li > a {\n    border-left-width: 0 !important;\n  }\n}\n.nav-tabs.nav-tabs-solid > li > a:hover,\n.nav-tabs.nav-tabs-solid > li > a:focus {\n  background-color: #f5f5f5;\n}\n.nav-tabs.nav-tabs-solid > li > a.active,\n.nav-tabs.nav-tabs-solid > li > a.active:hover,\n.nav-tabs.nav-tabs-solid > li > a.active:focus {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n  color: #ffffff;\n}\n.nav-tabs.nav-tabs-solid .active > a,\n.nav-tabs.nav-tabs-solid .active a:hover,\n.nav-tabs.nav-tabs-solid .active a:focus {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n  color: #ffffff;\n}\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded {\n  border-radius: 50px;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs.nav-tabs-solid.nav-tabs-rounded {\n    border-radius: 5px;\n  }\n}\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a {\n  border-radius: 50px;\n}\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {\n  border-radius: 50px;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,\n  .nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,\n  .nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {\n    border-color: transparent transparent transparent #20c0f3 !important;\n    border-left-width: 2px;\n  }\n}\n@media (max-width: 767.98px) {\n  .nav-tabs.nav-tabs-solid.nav-tabs-rounded {\n    border-radius: 5px;\n  }\n}\n.nav-tabs.nav-tabs-solid > .open:not(.active) > a {\n  background-color: #f5f5f5;\n  border-color: transparent;\n}\n@media (max-width: 767.98px) {\n  .nav-tabs .nav-link.active {\n    border-color: transparent transparent transparent #20c0f3 !important;\n    border-left-width: 2px;\n  }\n}\n\n.tab-content {\n  padding-top: 20px;\n}\n\n.card-header-tabs {\n  border-bottom: 0;\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-duration: 0.6s;\n  transition-property: opacity;\n}\n.carousel-fade .carousel-item.active {\n  opacity: 1;\n}\n.carousel-fade .carousel-item-next {\n  transform: translateX(0);\n  -webkit-transform: translateX(0);\n  -ms-transform: translateX(0);\n  transform: translate3d(0, 0, 0);\n  -webkit-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n}\n.carousel-fade .carousel-item-next .carousel-item-left {\n  opacity: 1;\n}\n.carousel-fade .carousel-item-prev {\n  transform: translateX(0);\n  -webkit-transform: translateX(0);\n  -ms-transform: translateX(0);\n  transform: translate3d(0, 0, 0);\n  -webkit-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n}\n.carousel-fade .carousel-item-prev .carousel-item-right {\n  opacity: 1;\n}\n.carousel-fade .active {\n  transform: translateX(0);\n  -webkit-transform: translateX(0);\n  -ms-transform: translateX(0);\n  transform: translate3d(0, 0, 0);\n  -webkit-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n}\n.carousel-fade .active .carousel-item-left,\n.carousel-fade .active .carousel-item-right {\n  opacity: 0;\n  transform: translateX(0);\n  -webkit-transform: translateX(0);\n  -ms-transform: translateX(0);\n  transform: translate3d(0, 0, 0);\n  -webkit-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n}\n\n.carousel-item {\n  height: 75vh;\n  min-height: 350px;\n  background: no-repeat center center scroll;\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n  z-index: -1 !important;\n}\n\n.divider .carousel-caption {\n  position: absolute;\n  top: 110px;\n  right: 0;\n  bottom: 20px;\n  left: 5%;\n}\n\n.carousel-caption {\n  z-index: 10;\n  padding-bottom: 20px;\n  color: #ffffff;\n  position: absolute;\n  top: 110px;\n  right: 0;\n  bottom: 20px;\n  left: 15%;\n}\n.carousel-caption span {\n  font-size: 32px;\n  font-weight: 700;\n  color: rgb(46, 56, 66);\n}\n.carousel-caption h2 {\n  font-size: 54px;\n  font-weight: 700;\n  color: rgb(30, 92, 146);\n}\n.carousel-caption p {\n  font-size: 18px;\n  font-weight: 700;\n  color: rgb(46, 56, 66);\n}\n\n@media (max-width: 991.98px) {\n  .carousel-inner {\n    height: 430px;\n  }\n}\n@media (max-width: 767.98px) {\n  .carousel-inner {\n    height: 200px;\n  }\n}\n\n.slide-nav-1 button.owl-next,\n.slide-nav-1 button.owl-prev,\n.slide-nav-2 button.owl-next,\n.slide-nav-2 button.owl-prev,\n.slide-nav-3 button.owl-next,\n.slide-nav-3 button.owl-prev,\n.slide-nav-4 button.owl-next,\n.slide-nav-4 button.owl-prev {\n  width: 34px;\n  height: 34px;\n  background: #10defd;\n  text-shadow: none;\n  top: 4px;\n  cursor: pointer;\n  border: 0;\n  color: #ffffff;\n  margin-bottom: 15px;\n  border-radius: 8px;\n  transform: rotate(-44deg);\n  -webkit-transform: rotate(-44deg);\n  -ms-transform: rotate(-44deg);\n}\n@media (max-width: 767.98px) {\n  .slide-nav-1 button.owl-next,\n  .slide-nav-1 button.owl-prev,\n  .slide-nav-2 button.owl-next,\n  .slide-nav-2 button.owl-prev,\n  .slide-nav-3 button.owl-next,\n  .slide-nav-3 button.owl-prev,\n  .slide-nav-4 button.owl-next,\n  .slide-nav-4 button.owl-prev {\n    width: 28px;\n    height: 28px;\n  }\n}\n\n.owl-theme .owl-dots,\n.owl-nav button {\n  margin-top: 30px;\n}\n@media (max-width: 767.98px) {\n  .owl-theme .owl-dots,\n  .owl-nav button {\n    margin-top: 10px;\n  }\n}\n\n.custom-arrow {\n  transform: rotate(44deg);\n  -webkit-transform: rotate(44deg);\n  -ms-transform: rotate(44deg);\n}\n\n.owl-nav button.owl-next {\n  margin-left: 20px;\n}\n\n.footer {\n  background-color: #15558d;\n}\n.footer.footer-one .footer-bottom .copyright .copyright-text p {\n  color: #6b7280;\n}\n@media (max-width: 767.98px) {\n  .footer.footer-one .footer-bottom .copyright .copyright-text p {\n    text-align: center;\n  }\n}\n.footer .footer-top {\n  padding: 40px 0;\n}\n@media (max-width: 991.98px) {\n  .footer .footer-top {\n    padding-bottom: 10px;\n  }\n}\n.footer .footer-top .footer-title {\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0 0 30px;\n  text-transform: capitalize;\n}\n@media (max-width: 767.98px) {\n  .footer .footer-top .footer-title {\n    font-size: 18px;\n  }\n}\n@media (max-width: 575.98px) {\n  .footer .footer-top .footer-title {\n    font-size: 18px;\n  }\n}\n@media (max-width: 991.98px) {\n  .footer .footer-top .footer-widget {\n    margin-bottom: 30px;\n  }\n}\n.footer .footer-top .footer-widget.footer-menu ul {\n  list-style: none;\n  outline: none;\n  margin: 0;\n  padding: 0;\n}\n.footer .footer-top .footer-widget.footer-menu ul li {\n  margin-bottom: 10px;\n  position: relative;\n}\n.footer .footer-top .footer-widget.footer-menu ul li:last-child {\n  margin-bottom: 0;\n}\n.footer .footer-top .footer-widget.footer-menu ul li a {\n  color: #ffffff;\n  font-size: 15px;\n  padding-left: 20px;\n  position: relative;\n  -webkit-transition: all 0.4s ease 0s;\n  -ms-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n.footer .footer-top .footer-widget.footer-menu ul li a:hover {\n  color: #ffffff;\n  letter-spacing: 0.5px;\n  padding-left: 30px;\n}\n.footer .footer-top .footer-widget.footer-menu ul li a::before {\n  content: \"\\f101\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n  margin-right: 5px;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.footer .footer-top .footer-widget .footer-logo {\n  margin: 0 0 30px;\n}\n.footer .footer-top .footer-widget .footer-about-content p {\n  color: #ffffff;\n}\n.footer .footer-top .footer-widget .footer-about-content p:last-child {\n  margin-bottom: 0;\n}\n.footer .footer-top .footer-widget .footer-about-content .social-icon ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.footer .footer-top .footer-widget .footer-about-content .social-icon ul li {\n  margin-right: 15px;\n}\n.footer .footer-top .footer-widget .footer-about-content .social-icon ul li:last-child {\n  margin-right: 0;\n}\n.footer .footer-top .footer-widget .footer-about-content .social-icon ul li a {\n  color: #ffffff;\n  font-size: 20px;\n  -webkit-transition: all 0.4s ease 0s;\n  -ms-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n.footer .footer-top .footer-widget .footer-about-content .social-icon ul li a:hover {\n  color: #09e5ab;\n}\n.footer .footer-top .footer-widget .footer-contact-info {\n  color: #ffffff;\n  font-size: 15px;\n}\n.footer .footer-top .footer-widget .footer-contact-info .footer-address span {\n  margin-right: 20px;\n}\n.footer .footer-top .footer-widget .footer-contact-info .footer-address span i.fa-map-marker-alt {\n  font-size: 20px;\n}\n.footer .footer-top .footer-widget .footer-contact-info .footer-address p {\n  margin: 0 0 1rem;\n}\n.footer .footer-top .footer-widget .footer-contact-info p i {\n  margin-right: 15px;\n}\n.footer .footer-bottom .copyright {\n  border-top: 1px solid #1663a6;\n  padding: 30px 0;\n}\n.footer .footer-bottom .copyright .copyright-text p {\n  font-size: 15px;\n  color: #ffffff;\n}\n.footer .footer-bottom .copyright .copyright-text p a {\n  color: #1f2937;\n  font-weight: 500;\n  -webkit-transition: all 0.4s ease 0s;\n  -ms-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n.footer .footer-bottom .copyright .copyright-text p a:hover {\n  color: #0e82fd;\n}\n.footer .footer-bottom .copyright .copyright-text p.title {\n  font-weight: 400;\n  margin: 10px 0 0;\n}\n.footer .footer-bottom .copyright .policy-menu {\n  font-size: 14px;\n  text-align: right;\n  margin: 0;\n  padding: 0;\n}\n@media (max-width: 767.98px) {\n  .footer .footer-bottom .copyright .policy-menu {\n    margin-top: 10px;\n    text-align: left;\n  }\n}\n.footer .footer-bottom .copyright .policy-menu li {\n  display: inline-block;\n  margin-right: 15px;\n}\n.footer .footer-bottom .copyright .policy-menu li:last-child {\n  margin-right: 0;\n}\n.footer .footer-bottom .copyright .policy-menu li a {\n  color: #ffffff;\n}\n.footer .footer-bottom .copyright .policy-menu li a:hover,\n.footer .footer-bottom .copyright .policy-menu li a:focus {\n  color: #0e82fd;\n}\n.footer .footer-bottom .copyright .policy-menu li::after {\n  color: #ffffff;\n  content: \"|\";\n  font-weight: 300;\n  position: relative;\n  left: 10px;\n}\n.footer .footer-bottom .copyright .policy-menu li:last-child::after {\n  content: \"\";\n}\n\n.footer-one {\n  background: #f2f6f6;\n}\n.footer-one .footer-top {\n  margin: 0;\n  padding: 50px 0;\n}\n@media (max-width: 991.98px) {\n  .footer-one .footer-top {\n    margin: 0;\n    padding: 40px 0 10px;\n  }\n}\n@media (max-width: 767.98px) {\n  .footer-one .footer-top {\n    margin: 0;\n    padding: 40px 0 0;\n  }\n}\n.footer-one .footer-top .footer-widget .footer-logo {\n  margin-bottom: 20px;\n}\n.footer-one .footer-top .footer-widget .footer-about-content {\n  max-width: 272px;\n}\n.footer-one .footer-top .footer-widget .footer-about-content p {\n  margin-bottom: 0;\n  font-size: 14px;\n  color: #6b7280;\n}\n.footer-one .footer-top .footer-widget.footer-menu ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.footer-one .footer-top .footer-widget .footer-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 25px;\n}\n@media (max-width: 991.98px) {\n  .footer-one .footer-top .footer-widget {\n    margin-bottom: 30px;\n  }\n}\n@media (max-width: 767.98px) {\n  .footer-one .footer-top .footer-widget {\n    margin-bottom: 25px;\n  }\n}\n.footer-one .footer-top .footer-widget.footer-menu ul li {\n  margin-bottom: 15px;\n}\n.footer-one .footer-top .footer-widget.footer-menu ul li:last-child {\n  margin-bottom: 0;\n}\n.footer-one .footer-top .footer-widget.footer-menu ul li a {\n  color: #6b7280;\n  position: relative;\n  overflow: hidden;\n  background: url(../images/footer-arrow.png) no-repeat -10px;\n  -webkit-transition: all 0.5s ease-in-out;\n  -ms-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  padding-left: 0;\n  font-size: 14px;\n}\n.footer-one .footer-top .footer-widget.footer-menu ul li a:hover {\n  color: #0e82fd;\n  background: url(../images/footer-arrow.png) no-repeat 4px;\n  padding-left: 20px;\n  -webkit-transition: all 0.5s ease-in-out;\n  -ms-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n}\n.footer-one .footer-top .footer-widget.footer-menu ul li a::before {\n  display: none;\n}\n.footer-one .footer-top .footer-widget .footer-contact-info .footer-address {\n  margin-bottom: 15px;\n}\n.footer-one .footer-top .footer-widget .footer-contact-info .footer-address p {\n  margin-bottom: 0;\n  color: #6b7280;\n  font-size: 14px;\n}\n.footer-one .footer-top .footer-widget .footer-contact-info .footer-address p i {\n  font-size: 16px;\n  color: #9ca3af;\n  margin-right: 10px;\n}\n.footer-one .footer-bottom .copyright {\n  border-top: 1px solid #e5e7eb;\n  margin: 0;\n  padding: 30px 0;\n}\n.footer-one .footer-bottom .copyright .policy-menu {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  text-align: right;\n}\n.footer-one .footer-bottom .copyright .policy-menu li {\n  display: inline-block;\n  margin-right: 25px;\n  color: #1f2937;\n  font-weight: 500;\n}\n@media (max-width: 767.98px) {\n  .footer-one .footer-bottom .copyright .policy-menu li {\n    display: block;\n    margin-right: 0;\n    margin-bottom: 8px;\n    text-align: center;\n    margin-top: 10px;\n  }\n  .footer-one .footer-bottom .copyright .policy-menu li:last-child {\n    margin-bottom: 0;\n  }\n}\n.footer-one .footer-bottom .copyright .policy-menu li::after {\n  font-size: 15px;\n  color: #6b7280;\n  content: \"|\";\n  font-weight: 500;\n  position: relative;\n  left: 15px;\n}\n@media (max-width: 767.98px) {\n  .footer-one .footer-bottom .copyright .policy-menu li::after {\n    display: none;\n  }\n}\n.footer-one .footer-bottom .copyright .policy-menu li:last-child::after {\n  content: \"\";\n}\n.footer-one .footer-bottom .copyright .policy-menu li a {\n  color: #6b7280;\n}\n.footer-one .footer-bottom .copyright .policy-menu li a:hover {\n  color: #0e82fd;\n}\n@media (max-width: 991.98px) {\n  .footer-one .footer-bottom .copyright {\n    margin: 0;\n    padding: 25px 0;\n  }\n}\n\n.subscribe-form {\n  position: relative;\n  margin-bottom: 20px;\n}\n.subscribe-form .form-control {\n  font-weight: 500;\n  font-size: 14px;\n  min-height: 46px;\n  color: #6b7280;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px 0px 0px 6px;\n  margin: 0;\n  padding: 6px 112px 6px 15px;\n}\n@media (max-width: 991.98px) {\n  .subscribe-form .form-control {\n    padding-right: 180px;\n  }\n}\n@media (max-width: 767.98px) {\n  .subscribe-form .form-control {\n    min-height: 46px;\n    padding-right: 145px;\n  }\n}\n.subscribe-form .form-control::placeholder {\n  font-weight: 500;\n  font-size: 14px;\n  color: #6b7280;\n}\n.subscribe-form .btn {\n  font-weight: normal;\n  margin: 0;\n  padding: 11px 16px;\n  font-size: 15px;\n  font-weight: 600;\n  border-radius: 0 6px 6px 0;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n  color: #ffffff;\n  background: #0e82fd;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #ffffff;\n}\n.subscribe-form .btn:hover {\n  color: #0e82fd;\n  border-color: #0e82fd;\n  background: #ffffff;\n  box-shadow: inset 0 0 0 50px #ffffff;\n  -webkit-transition: 0.5s;\n  -ms-transition: 0.5s;\n  transition: 0.5s;\n}\n@media (max-width: 767.98px) {\n  .subscribe-form .btn {\n    font-size: 14px;\n  }\n}\n\n.subscribe-content p {\n  max-width: 360px;\n  margin-bottom: 0;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.footer-two {\n  background-color: #15558d;\n}\n.footer-two .footer-top {\n  padding: 40px 0;\n}\n@media (max-width: 991.98px) {\n  .footer-two .footer-top {\n    padding-bottom: 10px;\n  }\n}\n.footer-two .footer-top .footer-title {\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0 0 30px;\n  text-transform: capitalize;\n}\n@media (max-width: 767.98px) {\n  .footer-two .footer-top .footer-title {\n    font-size: 18px;\n  }\n}\n@media (max-width: 575.98px) {\n  .footer-two .footer-top .footer-title {\n    font-size: 18px;\n  }\n}\n@media (max-width: 991.98px) {\n  .footer-two .footer-top .footer-widget {\n    margin-bottom: 30px;\n  }\n}\n.footer-two .footer-top .footer-widget.footer-menu ul {\n  list-style: none;\n  outline: none;\n  margin: 0;\n  padding: 0;\n}\n.footer-two .footer-top .footer-widget.footer-menu ul li {\n  margin-bottom: 10px;\n  position: relative;\n}\n.footer-two .footer-top .footer-widget.footer-menu ul li:last-child {\n  margin-bottom: 0;\n}\n.footer-two .footer-top .footer-widget.footer-menu ul li a {\n  color: #ffffff;\n  font-size: 15px;\n  padding-left: 20px;\n  position: relative;\n  -webkit-transition: all 0.4s ease 0s;\n  -ms-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n.footer-two .footer-top .footer-widget.footer-menu ul li a:hover {\n  color: #ffffff;\n  letter-spacing: 0.5px;\n  padding-left: 30px;\n}\n.footer-two .footer-top .footer-widget.footer-menu ul li a::before {\n  content: \"\\f101\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n  margin-right: 5px;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.footer-two .footer-top .footer-widget .footer-logo {\n  margin: 0 0 30px;\n}\n.footer-two .footer-top .footer-widget .footer-about-content {\n  max-width: inherit;\n}\n.footer-two .footer-top .footer-widget .footer-about-content p {\n  color: #ffffff;\n  margin-bottom: 15px;\n}\n.footer-two .footer-top .footer-widget .footer-about-content p:last-child {\n  margin-bottom: 0;\n}\n.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul li {\n  margin-right: 15px;\n}\n.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul li:last-child {\n  margin-right: 0;\n}\n.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul li a {\n  color: #ffffff;\n  font-size: 20px;\n  -webkit-transition: all 0.4s ease 0s;\n  -ms-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n.footer-two .footer-top .footer-widget .footer-about-content .social-icon ul li a:hover {\n  color: #09e5ab;\n}\n.footer-two .footer-top .footer-widget .footer-contact-info {\n  color: #ffffff;\n  font-size: 15px;\n}\n.footer-two .footer-top .footer-widget .footer-contact-info .footer-address span {\n  margin-right: 20px;\n}\n.footer-two\n  .footer-top\n  .footer-widget\n  .footer-contact-info\n  .footer-address\n  span\n  i.fa-map-marker-alt {\n  font-size: 20px;\n}\n.footer-two .footer-top .footer-widget .footer-contact-info .footer-address p {\n  margin: 0;\n}\n.footer-two .footer-top .footer-widget .footer-contact-info p i {\n  margin-right: 15px;\n}\n.footer-two .footer-bottom .copyright {\n  border-top: 1px solid #1663a6;\n  padding: 30px 0;\n}\n.footer-two .footer-bottom .copyright .copyright-text p {\n  color: #ffffff;\n  font-size: 15px;\n}\n.footer-two .footer-bottom .copyright .copyright-text p a {\n  color: #09e5ab;\n  -webkit-transition: all 0.4s ease 0s;\n  -ms-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n.footer-two .footer-bottom .copyright .copyright-text p a:hover {\n  color: #ffffff;\n}\n.footer-two .footer-bottom .copyright .copyright-text p.title {\n  font-weight: 400;\n  margin: 10px 0 0;\n}\n.footer-two .footer-bottom .copyright .policy-menu {\n  font-size: 14px;\n  text-align: right;\n  margin: 0;\n  padding: 0;\n}\n@media (max-width: 767.98px) {\n  .footer-two .footer-bottom .copyright .policy-menu {\n    margin-top: 10px;\n    text-align: left;\n  }\n}\n.footer-two .footer-bottom .copyright .policy-menu li {\n  display: inline-block;\n  margin-right: 15px;\n}\n.footer-two .footer-bottom .copyright .policy-menu li:last-child {\n  margin-right: 0;\n}\n.footer-two .footer-bottom .copyright .policy-menu li a {\n  color: #ffffff;\n}\n.footer-two .footer-bottom .copyright .policy-menu li a:hover,\n.footer-two .footer-bottom .copyright .policy-menu li a:focus {\n  color: #09e5ab;\n}\n.footer-two .footer-bottom .copyright .policy-menu li::after {\n  color: #ffffff;\n  content: \"|\";\n  font-weight: 300;\n  position: relative;\n  left: 10px;\n}\n.footer-two .footer-bottom .copyright .policy-menu li:last-child::after {\n  content: \"\";\n}\n\n.footer-three {\n  background: #ffffff;\n}\n.footer-three .footer-top {\n  margin: 0;\n  padding: 30px 0;\n}\n.footer-three .footer-widget .footer-title {\n  color: #0071dc;\n  margin: 0 0 15px;\n}\n.footer-three .footer-widget .footer-about-content p {\n  font-size: 13px;\n  color: #000000;\n  margin-bottom: 28px;\n}\n.footer-three .footer-menu ul li {\n  margin: 0 0 10px;\n}\n.footer-three .footer-menu ul li a {\n  color: #000000;\n  font-size: 16px;\n  background: none;\n}\n.footer-three .footer-menu ul li a:hover {\n  background: none;\n  padding-left: 0;\n}\n@media (max-width: 1199.98px) {\n  .footer-three .footer-menu ul li a {\n    font-size: 15px;\n  }\n}\n@media (max-width: 767.98px) {\n  .footer-three .footer-menu ul li a {\n    font-size: 14px;\n  }\n}\n.footer-three .footer-link {\n  margin-bottom: 20px !important;\n}\n.footer-three .social-icon ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.footer-three .social-icon ul li {\n  display: inline-block;\n  margin-right: 10px;\n}\n.footer-three .social-icon ul li:last-child {\n  margin-right: 0;\n}\n.footer-three .social-icon ul li a {\n  width: 45px;\n  height: 45px;\n  color: #ffffff;\n  background: #0071dc;\n  border: 1px solid #0071dc;\n  border-radius: 50%;\n  font-size: 18px;\n  -webkit-transition: all 0.4s ease 0s;\n  -ms-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n.footer-three .social-icon ul li a:hover {\n  background: #3b9cf6;\n  color: #ffffff;\n}\n@media (max-width: 1199.98px) {\n  .footer-three .social-icon ul li a {\n    width: 35px;\n    height: 35px;\n    font-size: 14px;\n  }\n}\n.footer-three .footer-bottom .copyright {\n  border-top: 1px solid #d9d9d9;\n}\n.footer-three .footer-bottom .copyright .copyright-menu p {\n  color: #000000;\n  margin: 0;\n}\n@media (max-width: 991.98px) {\n  .footer-three .footer-bottom .copyright .copyright-menu {\n    margin: 0 0 15px;\n  }\n}\n@media (max-width: 767.98px) {\n  .footer-three .footer-bottom .copyright .footer-language > img {\n    margin: 0 0 15px;\n  }\n}\n.footer-three .footer-bottom .copyright .footer-language .footer-select {\n  width: 164px;\n  position: relative;\n}\n.footer-three .footer-bottom .copyright .footer-language .footer-select .select-icon {\n  position: absolute;\n  top: 55%;\n  left: 14px;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  z-index: 9;\n  color: #999999;\n}\n.footer-three\n  .footer-bottom\n  .copyright\n  .footer-language\n  .footer-select\n  .select2-container\n  .select2-selection--single {\n  border: 1px solid #d9d9d9;\n  border-radius: 100px;\n}\n.footer-three\n  .footer-bottom\n  .copyright\n  .footer-language\n  .footer-select\n  .select2-container\n  .select2-selection--single\n  .select2-selection__rendered {\n  padding-left: 30px;\n}\n.footer-three\n  .footer-bottom\n  .copyright\n  .footer-language\n  .footer-select\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__rendered {\n  color: #999999;\n  font-weight: 500;\n}\n@media (max-width: 767.98px) {\n  .footer-three .footer-bottom .copyright .footer-language {\n    display: block;\n  }\n}\n\n.footer-one .social-icon ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.footer-one .social-icon ul li {\n  margin-right: 15px;\n}\n.footer-one .social-icon ul li:last-child {\n  margin-right: 0;\n}\n.footer-one .social-icon ul li a {\n  color: #6b7280;\n  font-size: 20px;\n  -webkit-transition: all 0.4s ease 0s;\n  -ms-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n.footer-one .social-icon ul li a:hover {\n  color: #0e82fd;\n}\n\n.footer.footer-one.footer-ten {\n  background: #f8fafc;\n  position: relative;\n}\n.footer.footer-one.footer-ten .footer-ten-bg img {\n  position: absolute;\n}\n.footer.footer-one.footer-ten .footer-ten-bg img:nth-child(1) {\n  left: 0;\n}\n.footer.footer-one.footer-ten .footer-ten-bg img:nth-child(2) {\n  right: 0;\n  bottom: 0;\n}\n.footer.footer-one.footer-ten .footer-ten-bg img:nth-child(3) {\n  left: 50%;\n  transform: translate(-50%, 100%);\n}\n.footer.footer-one.footer-ten .footer-details {\n  padding-bottom: 50px;\n  border-bottom: 1px solid #e2e8f0;\n  margin-bottom: 50px;\n}\n.footer.footer-one.footer-ten .footer-top .footer-widget.footer-menu ul {\n  list-style: disc;\n  padding-left: 15px;\n}\n.footer.footer-one.footer-ten .footer-top .footer-widget .footer-about-content p {\n  padding-bottom: 24px;\n}\n.footer.footer-one.footer-ten .mail-note {\n  color: #6b7280;\n}\n.footer.footer-one.footer-ten .footer-map {\n  border-radius: 35px;\n  overflow: hidden;\n}\n.footer.footer-one.footer-ten .footer-map img {\n  width: 100%;\n}\n.footer.footer-one.footer-ten .footer-bottom {\n  background: #ffffff;\n}\n.footer.footer-one.footer-ten .footer-bottom .copyright {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n.footer.footer-one.footer-ten .footer-bottom .copyright .policy-menu li a {\n  color: #6b7280;\n  font-weight: 400;\n}\n.footer.footer-one.footer-ten .footer-bottom .copyright .policy-menu li a:hover {\n  color: #0e82fd;\n}\n\n.footer.footer-eleven {\n  background: #1b5a90;\n}\n.footer.footer-eleven .footer-top {\n  padding: 50px 0 35px;\n}\n.footer.footer-eleven .footer-top .footer-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 10px;\n}\n.footer.footer-eleven .footer-top .footer-content p {\n  color: #ffffff;\n  margin: 0 0 25px;\n}\n.footer.footer-eleven .footer-top .subscribe-form {\n  margin-bottom: 25px;\n}\n.footer.footer-eleven .footer-top .subscribe-form .form-control {\n  min-height: 59px;\n  margin: 0;\n  padding: 10px 112px 10px 15px;\n  border-radius: 10px;\n}\n.footer.footer-eleven .footer-top .subscribe-form .form-control::placeholder {\n  color: #2b3d51;\n}\n.footer.footer-eleven .footer-top .subscribe-form .btn {\n  margin-right: 10px;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: normal;\n  padding: 6px 23px;\n}\n@media (max-width: 767.98px) {\n  .footer.footer-eleven .footer-top .footer-payment {\n    margin: 0 0 15px 0;\n  }\n}\n.footer.footer-eleven .footer-top .footer-payment h6 {\n  font-size: 16px;\n  margin: 0 0 15px;\n  color: #ffffff;\n}\n.footer.footer-eleven .footer-bottom .copyright {\n  border-top: 1px solid #4183bb;\n  padding: 25px 0;\n}\n.footer.footer-eleven .footer-bottom .copyright .copyright-text p {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .footer.footer-eleven .footer-bottom .copyright .copyright-text p {\n    margin-bottom: 10px;\n  }\n}\n.footer.footer-eleven .footer-bottom .copyright .copyright-text p a {\n  color: #0ce0ff;\n}\n.footer.footer-eleven .footer-bottom .copyright .policy-menu li {\n  font-size: 16px;\n}\n@media (max-width: 575.98px) {\n  .footer.footer-eleven .footer-bottom .copyright .policy-menu li {\n    margin: 0 10px 10px 0;\n  }\n}\n.footer.footer-eleven .footer-bottom .copyright .policy-menu li::after {\n  color: rgba(255, 255, 255, 0.15);\n}\n.footer.footer-eleven .footer-bottom .copyright .policy-menu li a:hover {\n  color: #0ce0ff;\n}\n@media (max-width: 1399.98px) {\n  .footer.footer-eleven .footer-bottom .copyright .policy-menu li {\n    font-size: 15px;\n  }\n}\n.footer.footer-eleven .social-icon {\n  margin: 0 0 25px;\n}\n.footer.footer-eleven .social-icon ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  text-align: right;\n}\n@media (max-width: 767.98px) {\n  .footer.footer-eleven .social-icon ul {\n    text-align: left !important;\n  }\n}\n.footer.footer-eleven .social-icon ul li {\n  display: inline-block;\n  margin: 0 20px 0 0;\n}\n.footer.footer-eleven .social-icon ul li a {\n  color: #ffffff;\n  font-size: 20px;\n}\n.footer.footer-eleven .social-icon ul li a:hover {\n  color: #0ce0ff;\n}\n.footer.footer-eleven .social-icon ul li:last-child {\n  margin-right: 0;\n}\n.footer.footer-eleven .footer-widget.footer-menu {\n  margin: 0 0 25px;\n}\n.footer.footer-eleven .footer-widget.footer-menu ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.footer.footer-eleven .footer-widget.footer-menu ul li {\n  display: inline-block;\n  margin: 0 45px 0 0;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-eleven .footer-widget.footer-menu ul li {\n    margin: 0 9px 0 0;\n  }\n}\n@media (max-width: 575.98px) {\n  .footer.footer-eleven .footer-widget.footer-menu ul li {\n    margin: 0 10px 10px 0;\n  }\n}\n.footer.footer-eleven .footer-widget.footer-menu ul li a {\n  font-size: 16px;\n  padding-left: 0;\n  color: #ffffff;\n}\n.footer.footer-eleven .footer-widget.footer-menu ul li a:hover {\n  color: #0ce0ff;\n}\n.footer.footer-eleven .footer-widget.footer-menu ul li a::before {\n  content: none !important;\n}\n.footer.footer-eleven .footer-widget.footer-menu ul li:last-child {\n  margin-right: 0;\n}\n\n.footer-language {\n  position: relative;\n  width: 173px;\n  float: right;\n}\n@media (max-width: 767.98px) {\n  .footer-language {\n    float: left !important;\n  }\n}\n.footer-language .select2-container .select2-selection--single {\n  border: 1px solid #ffffff;\n  background-color: transparent;\n  border-radius: 10px;\n  height: 44px;\n}\n.footer-language .select2-container .select2-selection--single .select2-selection__rendered {\n  padding-left: 34px;\n  color: #ffffff;\n}\n.footer-language .icon-lang {\n  position: absolute;\n  top: 50%;\n  left: 10px;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  color: #ffffff;\n  line-height: 0;\n}\n\n.footer-contacts {\n  margin: 0 0 26px;\n}\n.footer-contacts .footer-wrap {\n  background: rgba(240, 244, 246, 0.16);\n  backdrop-filter: blur(50px);\n  border-radius: 10px;\n  margin: 0 0 24px;\n  padding: 15px;\n}\n.footer-contacts .footer-wrap .footer-icon {\n  width: 55px;\n  height: 55px;\n  background: #ffffff;\n  border-radius: 100px;\n  margin: 0 15px 0 0;\n  flex-shrink: 0;\n  color: #0ce0ff;\n  font-size: 24px;\n}\n.footer-contacts .footer-wrap .footer-info h6 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0 0 10px;\n}\n.footer-contacts .footer-wrap .footer-info p {\n  margin: 0;\n  color: #ffffff;\n}\n\n.footer-one.footer-fourteen.footer-twelve {\n  background: #f9fafb;\n  padding: 0;\n}\n@media (max-width: 991.98px) {\n  .footer-one.footer-fourteen.footer-twelve .footer-bottom .copyright .policy-menu {\n    text-align: start;\n  }\n  .footer-one.footer-fourteen.footer-twelve .footer-bottom .copyright .policy-menu li {\n    margin-right: 4px;\n    font-weight: 400;\n  }\n  .footer-one.footer-fourteen.footer-twelve .footer-bottom .copyright .policy-menu li::after {\n    left: 5px;\n  }\n  .footer-one.footer-fourteen.footer-twelve .footer-bottom .copyright .policy-menu li a {\n    font-size: 14px;\n  }\n}\n\n.footer.footer-thirteen {\n  background: #ffffff;\n  background-image: url(../images/bg/Map-thirteen.png);\n  background-repeat: no-repeat;\n  background-position: center;\n  position: relative;\n}\n.footer.footer-thirteen .footer-top {\n  margin: 0;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-thirteen .footer-top {\n    margin: 0;\n    padding: 50px 0;\n  }\n}\n.footer.footer-thirteen .footer-top .footer-widget .footer-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 22px;\n}\n.footer.footer-thirteen .footer-top .footer-widget ul li {\n  margin-bottom: 4px;\n}\n.footer.footer-thirteen .footer-top .footer-widget ul li a {\n  color: #6b7280;\n  font-size: 14px;\n  font-weight: 400;\n  padding-left: 0;\n}\n.footer.footer-thirteen .footer-top .footer-widget ul li a::before {\n  content: \"\";\n}\n.footer.footer-thirteen .footer-top .footer-widget ul li a:hover {\n  color: #0e82fd;\n  padding-left: 10px;\n}\n.footer.footer-thirteen .footer-top .footer-widget ul li:first-child a {\n  font-weight: 600;\n}\n.footer.footer-thirteen .footer-top .footer-menu-thirteen {\n  margin-top: 43px;\n}\n.footer.footer-thirteen .footer-top .footer-menu-thirteen .footer-title {\n  display: none;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-thirteen .footer-top .footer-menu-thirteen {\n    margin-top: 0;\n  }\n  .footer.footer-thirteen .footer-top .footer-menu-thirteen .footer-title {\n    display: block;\n  }\n}\n.footer.footer-thirteen .footer-top .footer-contents-thirteen-main {\n  margin: 60px 0 0 0;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-thirteen .footer-top .footer-contents-thirteen-main {\n    margin: 20px 0 0 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .footer.footer-thirteen .footer-top .footer-contents-thirteen-main .footer-thirt-inner {\n    margin-bottom: 10px;\n  }\n}\n.footer.footer-thirteen .footer-top .footer-contents-thirteen-main .footer-thirt-inner h4 {\n  font-weight: 600;\n  color: #00438a;\n  margin-bottom: 6px;\n}\n.footer.footer-thirteen .footer-top .footer-contents-thirteen-main .footer-thirt-inner p {\n  font-size: 14px;\n  color: rgba(147, 163, 180, 0.8);\n  font-weight: 400;\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-thirteen .footer-top .footer-contents-thirteen-main .footer-thirt-inner p {\n    margin-bottom: 10px;\n  }\n}\n.footer.footer-thirteen .footer-top .footer-contents-thirteen-main .subscribe-form {\n  margin-bottom: 0;\n  max-width: 430px;\n}\n@media (max-width: 1299.98px) {\n  .footer.footer-thirteen .footer-top .footer-contents-thirteen-main .subscribe-form {\n    max-width: 385px;\n  }\n}\n.footer.footer-thirteen .footer-top .footer-contents-thirteen-main .subscribe-form .form-control {\n  min-height: 56px;\n  border: 1px solid #aab4ee;\n  border-radius: 10px;\n  padding: 10px 112px 10px 15px;\n}\n.footer.footer-thirteen\n  .footer-top\n  .footer-contents-thirteen-main\n  .subscribe-form\n  .form-control::placeholder {\n  color: #bec4d9;\n  font-size: 14px;\n  font-weight: 600;\n}\n.footer.footer-thirteen .footer-top .footer-contents-thirteen-main .subscribe-form .btn {\n  padding: 17px 40px;\n  right: -45%;\n  border-radius: 10px;\n}\n@media (max-width: 1299.98px) {\n  .footer.footer-thirteen .footer-top .footer-contents-thirteen-main .subscribe-form .btn {\n    padding: 17px 30px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .footer.footer-thirteen .footer-top .footer-contents-thirteen-main .subscribe-form .btn {\n    padding: 10px 19px;\n    right: 6px;\n  }\n}\n.footer.footer-thirteen .footer-bottom .copyright {\n  border-top: 1px solid rgba(52, 52, 52, 0.1);\n  padding: 20px 0;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-thirteen .footer-bottom .copyright {\n    text-align: center;\n  }\n}\n@media (max-width: 991.98px) {\n  .footer.footer-thirteen .footer-bottom .copyright .copyright-img {\n    margin-bottom: 15px;\n  }\n}\n@media (max-width: 991.98px) {\n  .footer.footer-thirteen .footer-bottom .copyright .copyright-text {\n    margin-bottom: 15px;\n  }\n}\n.footer.footer-thirteen .footer-bottom .copyright .copyright-text p {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: 0.005em;\n  text-align: center;\n  color: #6b7280;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-thirteen .footer-bottom .copyright .copyright-menu {\n    margin-bottom: 15px;\n  }\n}\n@media (max-width: 991.98px) {\n  .footer.footer-thirteen .footer-bottom .copyright .copyright-menu ul {\n    text-align: center;\n  }\n}\n.footer.footer-thirteen .footer-bottom .copyright .copyright-menu ul li a {\n  color: #00438a;\n  font-size: 18px;\n}\n.footer.footer-thirteen .footer-bottom .copyright .copyright-menu ul li a:hover {\n  color: #0e82fd;\n}\n.footer.footer-thirteen .footer-bg-icon img {\n  position: absolute;\n  z-index: 0;\n}\n.footer.footer-thirteen .footer-bg-icon img:nth-child(1) {\n  bottom: 20%;\n  left: 0;\n}\n.footer.footer-thirteen .footer-bg-icon img:nth-child(2) {\n  top: 20%;\n  right: -7%;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-thirteen .footer-bg-icon img:nth-child(2) {\n    display: none;\n  }\n}\n\n.footer-one.footer-fourteen {\n  background: #ffffff;\n  padding: 200px 0 0 0;\n}\n.footer-one.footer-fourteen .footer-top {\n  padding: 80px 0 50px 0;\n}\n@media (max-width: 991.98px) {\n  .footer-one.footer-fourteen .footer-top {\n    padding: 50px 0 10px 0;\n  }\n}\n.footer-one.footer-fourteen .footer-top .footer-widget .subscribe-form .form-control {\n  border: 1px solid #e5e7eb;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 6px 0px 0px 6px;\n}\n\n.footer.footer-fifteen {\n  position: relative;\n  padding: 52px 0 0 0;\n  background-color: #ffffff;\n  background-image: url(../images/footer-fift-bg.png);\n  background-position: top left;\n  background-repeat: no-repeat;\n  background-size: 50% 100%;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-fifteen {\n    background-image: none;\n    background-color: #0e82fd;\n  }\n}\n.footer.footer-fifteen .footer-top-fifteen {\n  padding: 0;\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .footer-fifteen-image {\n  margin-bottom: 10px;\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen p {\n  color: #ffffff;\n  margin-bottom: 25px;\n  line-height: 27px;\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .subscribe-fifteen {\n  font-size: 18px;\n  color: #ffffff;\n  margin-bottom: 10px;\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .subscribe-form-fifteen {\n  width: 83%;\n  margin-bottom: 25px;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-left-fifteen\n  .subscribe-form-fifteen\n  .form-control {\n  border-radius: 10px;\n  min-height: 55px;\n  font-weight: 400;\n  font-size: 16px;\n  padding: 10px 130px 10px 10px;\n}\n@media (max-width: 767.98px) {\n  .footer.footer-fifteen\n    .footer-top-fifteen\n    .footer-left-fifteen\n    .subscribe-form-fifteen\n    .form-control {\n    font-size: 14px;\n  }\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-left-fifteen\n  .subscribe-form-fifteen\n  .form-control::placeholder {\n  color: #2b3d51;\n  font-weight: 400;\n  font-size: 16px;\n}\n@media (max-width: 767.98px) {\n  .footer.footer-fifteen\n    .footer-top-fifteen\n    .footer-left-fifteen\n    .subscribe-form-fifteen\n    .form-control::placeholder {\n    font-size: 14px;\n  }\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .subscribe-form-fifteen .btn {\n  padding: 10px 15px;\n  background: #0ce0ff;\n  border-radius: 5px;\n  border: none;\n  right: 6px;\n}\n@media (max-width: 767.98px) {\n  .footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .subscribe-form-fifteen .btn {\n    padding: 10px 10px;\n  }\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .subscribe-form-fifteen .btn:hover {\n  background: #0e82fd;\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  color: #ffffff;\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .subscribe-fifteentwo {\n  font-size: 16px;\n  color: #ffffff;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-fifteen .footer-top-fifteen .footer-left-fifteen .footer-fifteen-image-2 {\n    margin-bottom: 15px;\n  }\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen {\n  margin-left: 18px;\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen .subscribe-fifteenthree {\n  font-size: 18px;\n  color: #1f2937;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen .subscribe-fifteenthree {\n    color: #ffffff;\n  }\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul li {\n  margin: 0 25px 25px 0;\n  text-decoration: underline;\n  line-height: 19px;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul li {\n    margin: 0 15px 15px 0;\n    text-decoration: none;\n  }\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul li:last-child {\n  margin-right: 0;\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul li a {\n  color: #6b7280;\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul li a:hover {\n  color: #1c5b91;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen ul li a {\n    color: #ffffff;\n  }\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen p {\n  color: #6b7280;\n}\n@media (max-width: 991.98px) {\n  .footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen p {\n    color: #ffffff;\n  }\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen .user-details-fift ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen .user-details-fift ul li {\n  text-decoration: none;\n  margin: 0 15px 0 0;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .user-details-fift\n  ul\n  li\n  .contact-fifteen {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  border: 1px solid #e5e5eb;\n  border-radius: 10px;\n  background: #ffffff;\n  margin: 0 0 15px 0;\n  padding: 10px;\n  overflow: hidden;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .user-details-fift\n  ul\n  li\n  .contact-fifteen\n  .contact-form-fift {\n  width: 35px;\n  height: 35px;\n  border-radius: 100px;\n  background: #0e82fd;\n  font-size: 17px;\n  color: #ffffff;\n  margin-right: 7px;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .user-details-fift\n  ul\n  li\n  .contact-fifteen\n  .contact-content-fift\n  h6 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n@media (max-width: 1399.98px) {\n  .footer.footer-fifteen\n    .footer-top-fifteen\n    .footer-right-fifteen\n    .user-details-fift\n    ul\n    li\n    .contact-fifteen\n    .contact-content-fift\n    h6 {\n    font-size: 14px;\n  }\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .user-details-fift\n  ul\n  li\n  .contact-fifteen\n  .contact-content-fift\n  span {\n  color: #707070;\n  margin-bottom: 0;\n  font-size: 13px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen .footer-fift-selects {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 25px;\n}\n@media (max-width: 479.98px) {\n  .footer.footer-fifteen .footer-top-fifteen .footer-right-fifteen .footer-fift-selects {\n    display: block;\n  }\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-fift-selects\n  .footer-select {\n  display: inline-block;\n}\n@media (max-width: 479.98px) {\n  .footer.footer-fifteen\n    .footer-top-fifteen\n    .footer-right-fifteen\n    .footer-fift-selects\n    .footer-select {\n    margin-bottom: 15px;\n  }\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-fift-selects\n  .footer-select\n  img {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  z-index: 9;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-fift-selects\n  .footer-select\n  .select2-container\n  .select2-selection--single {\n  border: 1px solid #e5e5eb;\n  border-radius: 10px;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-fift-selects\n  .footer-select\n  .select2-selection__rendered {\n  padding-left: 43px;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-fift-selects\n  .footer-select\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow {\n  right: 1px;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-fift-selects\n  .footer-select\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  border-color: #000000 transparent transparent;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-fift-selects\n  .social-icon\n  ul\n  li {\n  margin: 0 10px 0 0;\n  text-decoration: none;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-fift-selects\n  .social-icon\n  ul\n  li\n  a {\n  width: 44px;\n  height: 43px;\n  border-radius: 100px;\n  background: #0e82fd;\n  color: #ffffff;\n  font-size: 18px;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-fift-selects\n  .social-icon\n  ul\n  li\n  a:hover {\n  background: #0ce0ff;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-bottom.footer-bottom-fifteen\n  .copyright {\n  border-top: 1px solid #e5e5eb;\n  padding: 25px 0 25px 0;\n}\n@media (max-width: 767.98px) {\n  .footer.footer-fifteen\n    .footer-top-fifteen\n    .footer-right-fifteen\n    .footer-bottom.footer-bottom-fifteen\n    .copyright\n    .copyright-text {\n    text-align: center;\n    margin-bottom: 10px;\n  }\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-bottom.footer-bottom-fifteen\n  .copyright\n  .copyright-text\n  p {\n  margin-bottom: 0;\n  font-size: 14px;\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-bottom.footer-bottom-fifteen\n  .copyright\n  .copyright-menu\n  .policy-menu {\n  justify-content: end;\n}\n@media (max-width: 767.98px) {\n  .footer.footer-fifteen\n    .footer-top-fifteen\n    .footer-right-fifteen\n    .footer-bottom.footer-bottom-fifteen\n    .copyright\n    .copyright-menu\n    .policy-menu {\n    justify-content: center;\n  }\n}\n.footer.footer-fifteen\n  .footer-top-fifteen\n  .footer-right-fifteen\n  .footer-bottom.footer-bottom-fifteen\n  .copyright\n  .copyright-menu\n  .policy-menu\n  li {\n  text-decoration: none;\n  margin: 0 10px 0 0;\n}\n@media (max-width: 1199.98px) {\n  .footer.footer-fifteen\n    .footer-top-fifteen\n    .footer-right-fifteen\n    .footer-bottom.footer-bottom-fifteen\n    .copyright\n    .copyright-menu\n    .policy-menu\n    li {\n    margin: 0 15px 15px 0;\n  }\n}\n\n.footer.footer-one.footer-sixteen {\n  background: #ffffff;\n  border-top: 1px solid #e2e2e2;\n  position: relative;\n  background-image: url(../images/map-bg.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: top center;\n}\n.footer.footer-one.footer-sixteen .footer-top .footer-widget .footer-about-content {\n  max-width: none;\n  margin-bottom: 30px;\n}\n.footer.footer-one.footer-sixteen .footer-top .footer-widget .subscribe-form {\n  margin-bottom: 0;\n}\n.footer.footer-one.footer-sixteen .footer-top .footer-widget .subscribe-form .btn {\n  border: 1px solid #1c5b91;\n  background: #1c5b91;\n}\n.footer.footer-one.footer-sixteen .footer-top .footer-widget .subscribe-form .btn:hover {\n  border: 1px solid #0e82fd;\n}\n.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-text p {\n  margin-bottom: 0;\n}\n@media (max-width: 575.98px) {\n  .footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-text {\n    margin-bottom: 10px;\n  }\n}\n.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n@media (max-width: 767.98px) {\n  .footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul {\n    justify-content: center;\n  }\n}\n.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul li {\n  margin-right: 10px;\n}\n.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul li:last-child {\n  margin-right: 0;\n}\n.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul li a {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #1f2937;\n  color: #ffffff;\n  font-size: 12px;\n}\n.footer.footer-one.footer-sixteen .footer-bottom .copyright .copyright-menu ul li a:hover {\n  background: #0e82fd;\n}\n\n/****** PAGES ******/\n.section-search {\n  background: #f9f9f9 url(../images/search-bg.png) no-repeat bottom center;\n  min-height: 530px;\n  background-size: 100% auto;\n  position: relative;\n  background-blend-mode: Darken;\n  padding: 160px 0 80px 0;\n}\n@media (max-width: 991.98px) {\n  .section-search {\n    min-height: 330px;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-search {\n    background: #f9f9f9;\n    padding: 100px 0 50px 0;\n  }\n}\n@media (max-width: 479.98px) {\n  .section-search {\n    min-height: 410px;\n    padding: 100px 15px 30px 15px;\n  }\n}\n.section-search .banner-wrapper {\n  max-width: 800px;\n  width: 100%;\n  margin: 0 auto;\n}\n@media (max-width: 991.98px) {\n  .section-search .banner-wrapper {\n    max-width: 720px;\n  }\n}\n.section-search .banner-wrapper .banner-header {\n  margin: 0 0 30px;\n}\n.section-search .banner-wrapper .banner-header h1 {\n  font-size: 40px;\n  font-weight: 600;\n  margin: 0 0 10px;\n}\n@media (max-width: 991.98px) {\n  .section-search .banner-wrapper .banner-header h1 {\n    font-size: 34px;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-search .banner-wrapper .banner-header h1 {\n    font-size: 32px;\n  }\n}\n@media (max-width: 575.98px) {\n  .section-search .banner-wrapper .banner-header h1 {\n    font-size: 28px;\n  }\n}\n.section-search .banner-wrapper .banner-header p {\n  color: #757575;\n  font-size: 20px;\n  margin: 0;\n}\n@media (max-width: 767.98px) {\n  .section-search .banner-wrapper .banner-header p {\n    font-size: 16px;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-search .banner-wrapper .search-box {\n    max-width: 535px;\n    margin: 0 auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-search .banner-wrapper .search-box form {\n    -ms-flex-direction: column;\n    flex-direction: column;\n    word-wrap: break-word;\n    background-clip: border-box;\n  }\n}\n@media (max-width: 575.98px) {\n  .section-search .banner-wrapper .search-box form {\n    display: block;\n  }\n}\n.section-search .banner-wrapper .search-box .form-control {\n  border: 1px solid #cccccc;\n  border-radius: 5px;\n  padding-left: 35px;\n  -webkit-box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.075);\n  -moz-box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.075);\n}\n.section-search .banner-wrapper .search-box .form-control::placeholder {\n  font-size: 14px;\n}\n.section-search .banner-wrapper .search-box .search-location {\n  -ms-flex: 0 0 240px;\n  flex: 0 0 240px;\n  margin-right: 12px;\n  position: relative;\n  width: 240px;\n}\n@media (max-width: 767.98px) {\n  .section-search .banner-wrapper .search-box .search-location {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    width: 100%;\n  }\n}\n@media (max-width: 575.98px) {\n  .section-search .banner-wrapper .search-box .search-location {\n    width: 100% !important;\n    -ms-flex: none;\n    flex: none;\n  }\n}\n.section-search .banner-wrapper .search-box .search-location .form-control {\n  background: #ffffff url(../images/location.png) no-repeat 10px center;\n}\n.section-search .banner-wrapper .search-box .search-info {\n  -ms-flex: 0 0 490px;\n  flex: 0 0 490px;\n  margin-right: 12px;\n  position: relative;\n  width: 490px;\n}\n@media (max-width: 991.98px) {\n  .section-search .banner-wrapper .search-box .search-info {\n    -ms-flex: 0 0 410px;\n    flex: 0 0 410px;\n    width: 410px;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-search .banner-wrapper .search-box .search-info {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    width: 100%;\n  }\n}\n@media (max-width: 575.98px) {\n  .section-search .banner-wrapper .search-box .search-info {\n    width: 100% !important;\n    -ms-flex: none;\n    flex: none;\n  }\n}\n.section-search .banner-wrapper .search-box .search-info .form-control {\n  background: #ffffff url(../images/search.png) no-repeat 10px center;\n}\n.section-search .banner-wrapper .search-box .search-btn {\n  width: 46px;\n  -ms-flex: 0 0 46px;\n  flex: 0 0 46px;\n  height: 46px;\n}\n@media (max-width: 767.98px) {\n  .section-search .banner-wrapper .search-box .search-btn {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    min-height: 46px;\n    width: 100%;\n  }\n}\n.section-search .banner-wrapper .search-box .search-btn span {\n  display: none;\n  font-weight: 500;\n}\n@media (max-width: 767.98px) {\n  .section-search .banner-wrapper .search-box .search-btn span {\n    display: inline-block;\n    margin-left: 5px;\n    text-transform: uppercase;\n  }\n}\n.section-search .banner-wrapper .search-box .form-text {\n  color: #757575;\n  font-size: 13px;\n}\n.section-search .banner-wrapper .search-box .search-location {\n  -ms-flex: 0 0 240px;\n  flex: 0 0 240px;\n  margin-right: 12px;\n  position: relative;\n  width: 240px;\n}\n@media (max-width: 767.98px) {\n  .section-search .banner-wrapper .search-box .search-location {\n    flex: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-search .banner-wrapper .search-box {\n    max-width: 535px;\n    margin: 0 auto;\n  }\n}\n\n.section-header {\n  margin-bottom: 60px;\n}\n.section-header h5 {\n  font-weight: 600;\n  font-size: 18px;\n  color: #0e82fd;\n  margin-bottom: 10px;\n}\n.section-header h2 {\n  font-size: 36px;\n  font-weight: 500;\n  margin: 0;\n}\n@media (max-width: 767.98px) {\n  .section-header h2 {\n    font-size: 30px;\n  }\n}\n@media (max-width: 575.98px) {\n  .section-header h2 {\n    font-size: 24px;\n  }\n}\n.section-header .sub-title {\n  color: #757575;\n  font-size: 16px;\n  max-width: 600px;\n  margin: 15px auto 0;\n}\n@media (max-width: 767.98px) {\n  .section-header .sub-title {\n    font-size: 14px;\n  }\n}\n@media (max-width: 575.98px) {\n  .section-header .sub-title {\n    font-size: 14px;\n  }\n}\n.section-header p {\n  color: #757575;\n  font-size: 16px;\n  margin: 15px 0 0 0;\n}\n@media (max-width: 767.98px) {\n  .section-header p {\n    font-size: 15px;\n  }\n}\n@media (max-width: 575.98px) {\n  .section-header p {\n    font-size: 15px;\n  }\n}\n\n.section-specialities {\n  background-color: #ffffff;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .section-specialities {\n    padding: 50px 0;\n  }\n}\n@media (max-width: 479.98px) {\n  .section-specialities {\n    background-color: #ffffff;\n    padding: 30px 0;\n  }\n}\n.section-specialities .specialities-slider .slick-slide {\n  display: block;\n}\n@media (max-width: 767.98px) {\n  .section-specialities .specialities-slider .slick-slide {\n    margin-right: 15px;\n  }\n}\n@media (max-width: 479.98px) {\n  .section-specialities .specialities-slider .slick-slide {\n    margin-right: 10px;\n  }\n}\n.section-specialities .specialities-slider .slick-dots {\n  margin-top: 44px;\n  position: unset;\n}\n.section-specialities .specialities-slider .speicality-item p {\n  font-size: 16px;\n  font-weight: 500;\n  margin: 30px 0 0;\n}\n@media (max-width: 767.98px) {\n  .section-specialities .specialities-slider .speicality-item p {\n    font-size: 14px;\n  }\n}\n@media (max-width: 575.98px) {\n  .section-specialities .specialities-slider .speicality-item p {\n    font-size: 14px;\n  }\n}\n.section-specialities .specialities-slider .speicality-item .speicality-img {\n  position: relative;\n  height: 150px;\n  border-radius: 100%;\n  width: 150px;\n  background: #ffffff;\n  -webkit-box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);\n  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);\n}\n@media (max-width: 479.98px) {\n  .section-specialities .specialities-slider .speicality-item .speicality-img {\n    width: 120px;\n    height: 120px;\n  }\n}\n.section-specialities .specialities-slider .speicality-item .speicality-img img {\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  position: absolute;\n  top: 50%;\n  right: 0;\n  left: 0;\n  margin: 0 auto;\n}\n@media (max-width: 479.98px) {\n  .section-specialities .specialities-slider .speicality-item .speicality-img img {\n    width: 50px;\n  }\n}\n.section-specialities .specialities-slider .speicality-item .speicality-img span {\n  border-radius: 50%;\n  padding: 5px;\n  background-color: #ffffff;\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n  -webkit-box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);\n  box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);\n}\n.section-specialities .specialities-slider .speicality-item .speicality-img span i {\n  font-size: 15px;\n  color: #0de0fe;\n}\n\n.section-specialities .specialities-slider .slick-slide {\n  display: block;\n  padding: 0 12px;\n}\n\n.slick-dots {\n  display: block;\n  width: 100%;\n  list-style: none;\n  text-align: center;\n  position: absolute;\n  bottom: -25px;\n  margin: 0;\n  padding: 0;\n}\n.slick-dots li {\n  position: relative;\n  display: inline-block;\n  width: 20px;\n  height: 5px;\n  cursor: pointer;\n  margin: 0 5px;\n  padding: 0;\n}\n.slick-dots li button {\n  font-size: 0;\n  line-height: 0;\n  display: block;\n  width: 20px;\n  height: 5px;\n  cursor: pointer;\n  color: transparent;\n  border: 0;\n  outline: none;\n  background: #c0c0c0;\n  padding: 0;\n}\n.slick-dots li button:hover,\n.slick-dots li button:focus {\n  outline: none;\n}\n.slick-dots li button:hover:before,\n.slick-dots li button:focus:before {\n  opacity: 1;\n}\n.slick-dots li button:before {\n  display: none;\n  font-family: \"slick\";\n  font-size: 76px;\n  line-height: 20px;\n  width: 20px;\n  height: 20px;\n  content: \"-\";\n  text-align: center;\n  opacity: 0.25;\n  color: #000000;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.slick-dots li.slick-active button {\n  background-color: #0de0fe;\n}\n.slick-dots li.slick-active button:before {\n  opacity: 1;\n  color: #0de0fe;\n}\n.slick-dots li.slick-active button .slick-slide {\n  outline: none !important;\n}\n\n.section-doctor {\n  background-color: #f8f9fa;\n  padding: 80px 0;\n}\n@media (max-width: 767.98px) {\n  .section-doctor {\n    padding: 50px 0;\n  }\n}\n.section-doctor .profile-widget {\n  -webkit-box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);\n  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.section-doctor .section-header {\n  margin: 0 0 30px;\n}\n.section-doctor .section-header p {\n  margin-top: 10px;\n}\n@media (max-width: 991.98px) {\n  .section-doctor .about-content {\n    margin-bottom: 30px;\n  }\n}\n.section-doctor .about-content p {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 26px;\n  margin: 0;\n}\n.section-doctor .about-content p + p {\n  margin-top: 20px;\n}\n.section-doctor .about-content a {\n  background-color: #0de0fe;\n  color: #ffffff;\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 500;\n  min-width: 150px;\n  margin: 30px 0 0;\n  padding: 15px 20px;\n  text-align: center;\n  border-radius: 4px;\n}\n@media (max-width: 767.98px) {\n  .section-doctor .about-content a {\n    padding: 12px 20px;\n  }\n}\n.section-doctor .about-content a:hover,\n.section-doctor .about-content a:focus {\n  background-color: #01cae4;\n  border-color: #01cae4;\n  color: #ffffff;\n}\n@media (max-width: 767.98px) {\n  .section-doctor .doctor-slider {\n    margin-top: 25px;\n  }\n}\n.section-doctor .doctor-slider .slick-slide {\n  display: block;\n  width: 280px;\n  margin-bottom: 0;\n  padding: 10px;\n}\n\n.profile-widget {\n  background-color: #ffffff;\n  border: 1px solid #f0f0f0;\n  position: relative;\n  margin-bottom: 30px;\n  padding: 15px;\n  border-radius: 4px;\n  -webkit-transition: all 0.3s ease 0s;\n  -ms-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n.profile-widget .fav-btn {\n  background-color: #ffffff;\n  width: 30px;\n  height: 30px;\n  color: #2e3842;\n  opacity: 0;\n  visibility: hidden;\n  z-index: 99;\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  transform: translate3d(100%, 0, 0);\n  -webkit-transform: translate3d(100%, 0, 0);\n  -ms-transform: translate3d(100%, 0, 0);\n  border-radius: 3px;\n}\n.profile-widget:hover .fav-btn {\n  opacity: 1;\n  visibility: visible;\n  transform: translate3d(0, 0, 0);\n  -webkit-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n}\n.profile-widget:hover .fav-btn:hover {\n  background-color: #fb1612;\n  color: #ffffff;\n  transform: translate3d(0, 0, 0);\n  -webkit-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n}\n.profile-widget .verified {\n  color: #28a745;\n  margin-left: 3px;\n}\n.profile-widget .rating {\n  color: #757575;\n  font-size: 14px;\n  margin-bottom: 15px !important;\n}\n.profile-widget .rating i {\n  font-size: 14px;\n}\n.profile-widget .doc-img {\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  border-radius: 4px;\n}\n.profile-widget .doc-img img {\n  border-radius: 4px;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  width: 100%;\n}\n.profile-widget .doc-img:hover img {\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n.profile-widget .pro-content {\n  padding: 15px 0 0;\n}\n.profile-widget .pro-content .title {\n  font-size: 17px;\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n.profile-widget .pro-content .title a {\n  display: inline-block;\n}\n.profile-widget .pro-content p.speciality {\n  font-size: 13px;\n  color: #757575;\n  margin-bottom: 5px;\n  min-height: 40px;\n}\n.profile-widget .pro-content .rating {\n  list-style: none;\n  width: 100%;\n  margin: 0 0 7px;\n  padding: 0;\n}\n.profile-widget .pro-content .rating i {\n  color: #dedfe0;\n}\n.profile-widget .pro-content .rating i.filled {\n  color: #f4c150;\n}\n.profile-widget .pro-content .available-info {\n  font-size: 13px;\n  color: #757575;\n  font-weight: 400;\n  list-style: none;\n  margin: auto auto 15px;\n  padding: 0;\n}\n.profile-widget .pro-content .available-info li i {\n  width: 22px;\n}\n.profile-widget .pro-content .available-info li + li {\n  margin-top: 5px;\n}\n.profile-widget .pro-content .row.row-sm {\n  margin-left: -3px;\n  margin-right: -3px;\n}\n.profile-widget .pro-content .row.row-sm > div {\n  padding-left: 3px;\n  padding-right: 3px;\n}\n\n.section-features {\n  background-color: #ffffff;\n  padding: 80px 0;\n}\n@media (max-width: 767.98px) {\n  .section-features {\n    padding: 50px 0;\n  }\n}\n@media (max-width: 479.98px) {\n  .section-features {\n    background-color: #ffffff;\n    padding: 30px 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-features .features-img {\n    text-align: center;\n    margin: 0 auto;\n  }\n}\n.section-features .features-slider .slick-slide {\n  margin-right: 62px;\n}\n.section-features .features-slider .slick-center {\n  opacity: 1;\n  transform: scale(1.2);\n  -webkit-transform: scale(1.2);\n  -ms-transform: scale(1.2);\n}\n.section-features .features-slider .slick-list {\n  padding: 16px 50px !important;\n}\n.section-features .features-slider .slick-dots {\n  margin-top: 44px;\n  position: unset;\n}\n@media (max-width: 767.98px) {\n  .section-features .features-slider .slick-dots {\n    text-align: center;\n    margin: 0 auto;\n  }\n}\n.section-features .features-slider .feature-item img {\n  box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);\n  height: 115px;\n  object-fit: cover;\n  width: 115px;\n  border-radius: 100%;\n}\n.section-features .features-slider .feature-item p {\n  font-weight: 500;\n  margin: 20px 0 0;\n}\n\n.section-blogs {\n  background-color: #f8f9fa;\n  padding: 80px 0;\n}\n@media (max-width: 767.98px) {\n  .section-blogs {\n    padding: 50px 0;\n  }\n}\n@media (max-width: 479.98px) {\n  .section-blogs {\n    padding: 30px 0;\n  }\n}\n.section-blogs .view-all .btn {\n  margin-top: 20px;\n  font-size: 16px;\n  font-weight: 700;\n  padding: 12px 30px;\n}\n\n.rating {\n  list-style: none;\n  width: 100%;\n  margin: 0 0 7px;\n  padding: 0;\n}\n.rating i {\n  color: #dedfe0;\n}\n.rating i.filled {\n  color: #f4c150;\n  padding: 0 2px;\n}\n\n.home-tile-section {\n  background-color: #f8f9fa;\n  padding: 80px 0;\n}\n@media (max-width: 767.98px) {\n  .home-tile-section {\n    padding: 50px 0;\n  }\n}\n@media (max-width: 479.98px) {\n  .home-tile-section {\n    padding: 30px 0;\n  }\n}\n.home-tile-section .doctor-book-card {\n  position: relative;\n  max-width: 100%;\n  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.0431372549);\n  overflow: hidden;\n  margin: 0 auto;\n}\n@media (max-width: 575.98px) {\n  .home-tile-section .doctor-book-card {\n    margin-bottom: 0.9375rem;\n  }\n}\n.home-tile-section .doctor-book-card img {\n  vertical-align: middle;\n  border-radius: 0.25rem;\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n}\n.home-tile-section .doctor-book-card .doctor-book-card-content {\n  color: #f1f1f1;\n  width: 100%;\n  height: 100%;\n  border-radius: 0.25rem;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  padding: 20px;\n}\n.home-tile-section .doctor-book-card .doctor-book-card-content > div {\n  width: 100%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n.home-tile-section .doctor-book-card .doctor-book-card-content .book-btn1 {\n  font-size: 14px;\n}\n.home-tile-section .doctor-book-card .tile-card-content-1 {\n  background: rgba(13, 13, 13, 0.33);\n}\n.home-tile-section .doctor-book-card h3 {\n  text-shadow: 2px 4px 3px rgba(0, 0, 0, 0.3);\n  color: #ffffff;\n}\n.home-tile-section .doctor-book-card:hover img {\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n\n.banner-section {\n  background: #f2f6f6;\n  padding: 100px 0 30px;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n.banner-section::after {\n  content: \"\";\n  background: url(../images/banner-bg.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n\n.banner-shapes {\n  position: relative;\n}\n.banner-shapes .banner-shape-left {\n  position: absolute;\n  top: 600px;\n  left: 0;\n}\n.banner-shapes .banner-shape-right {\n  position: absolute;\n  top: 30px;\n  left: 0;\n  transform: rotate(180deg);\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n}\n\n.banner-content {\n  padding-bottom: 80px;\n  position: relative;\n}\n.banner-content h1 {\n  font-weight: 600;\n  font-size: 48px;\n  margin-bottom: 25px;\n}\n.banner-content h1 span {\n  color: #0e82fd;\n}\n@media (max-width: 991.98px) {\n  .banner-content h1 {\n    font-size: 36px;\n  }\n}\n@media (max-width: 767.98px) {\n  .banner-content h1 {\n    font-size: 28px;\n    margin-bottom: 20px;\n  }\n}\n.banner-content .header-icon {\n  position: absolute;\n  right: -30px;\n  top: -15px;\n}\n@media (max-width: 1199.98px) {\n  .banner-content .header-icon {\n    display: none;\n  }\n}\n.banner-content p {\n  font-weight: 500;\n  font-size: 18px;\n  margin-bottom: 25px;\n}\n@media (max-width: 767.98px) {\n  .banner-content p {\n    font-size: 16px;\n    margin-bottom: 20px;\n  }\n}\n.banner-content .btn {\n  font-weight: 500;\n  border-radius: 8px;\n  margin: 0;\n  padding: 12px 15px;\n  min-width: 200px;\n  display: inline-block;\n  background-color: #0e82fd;\n  border: 1px solid #0e82fd;\n  color: #ffffff;\n  font-size: 18px;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  -webkit-transition: 0.5s;\n  -ms-transition: 0.5s;\n  transition: 0.5s;\n}\n.banner-content .btn:hover {\n  color: #0e82fd;\n  border-color: #0e82fd;\n  background-color: #ffffff;\n  box-shadow: inset 0 0 0 50px #ffffff;\n  -webkit-transition: 0.5s;\n  -ms-transition: 0.5s;\n  transition: 0.5s;\n}\n@media (max-width: 991.98px) {\n  .banner-content .btn {\n    font-size: 16px;\n    margin: 0;\n    padding: 10px 15px;\n    min-width: 190px;\n  }\n}\n@media (max-width: 767.98px) {\n  .banner-content .btn {\n    font-size: 15px;\n    margin: 0;\n    padding: 9px 15px;\n    min-width: 170px;\n  }\n}\n@media (max-width: 991.98px) {\n  .banner-content {\n    text-align: center;\n    padding-bottom: 40px;\n  }\n}\n\n.banner-arrow-img {\n  position: absolute;\n  left: 220px;\n  top: 180px;\n}\n@media (max-width: 1199.98px) {\n  .banner-arrow-img {\n    display: none;\n  }\n}\n\n.search-box-one {\n  min-width: 800px;\n  background: #ffffff;\n  border: 1px solid #f0f0f0;\n  box-shadow: 0px 3px 53px rgba(197, 197, 197, 0.2);\n  border-radius: 7px;\n  margin: 0;\n  padding: 13px 15px;\n  display: table;\n  position: relative;\n  z-index: 1;\n}\n.search-box-one form {\n  float: left;\n  width: 100%;\n}\n.search-box-one input:hover,\n.search-box-one input:focus {\n  background-color: #ffffff !important;\n}\n@media (max-width: 991.98px) {\n  .search-box-one {\n    min-width: 100%;\n    width: 100%;\n  }\n}\n@media (max-width: 767.98px) {\n  .search-box-one {\n    margin: 0;\n    padding: 0px 15px 15px;\n  }\n}\n\n.search-box-one .form-control:hover,\n.search-box-one .form-control:focus {\n  background-color: #ffffff !important;\n}\n\n.search-input {\n  width: 25%;\n  float: left;\n  display: table-cell;\n  vertical-align: middle;\n  position: relative;\n}\n.search-input.search-line {\n  width: 35%;\n}\n.search-input.search-line::before {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  width: 1px;\n  height: 44px;\n  background: #e3e4e8;\n  content: \"\";\n  z-index: 1;\n}\n@media (max-width: 767.98px) {\n  .search-input.search-line::before {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .search-input.search-line {\n    width: 100%;\n  }\n}\n.search-input.search-map-line {\n  width: 26%;\n}\n.search-input.search-map-line::before {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  width: 1px;\n  height: 44px;\n  background: #e3e4e8;\n  content: \"\";\n  z-index: 1;\n}\n@media (max-width: 767.98px) {\n  .search-input.search-map-line::before {\n    display: none;\n  }\n}\n.search-input.search-map-line input {\n  padding: 0px 36px 0px 36px;\n}\n@media (max-width: 767.98px) {\n  .search-input.search-map-line input {\n    padding: 0px 25px 0px 25px;\n  }\n}\n.search-input.search-map-line > i {\n  left: 10px;\n}\n@media (max-width: 767.98px) {\n  .search-input.search-map-line > i {\n    left: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .search-input.search-map-line {\n    width: 100%;\n  }\n}\n.search-input input {\n  height: 40px;\n  padding: 0 10px 0 25px;\n  border: 0;\n}\n.search-input input::placeholder {\n  color: #8c97b0;\n}\n.search-input.search-calendar-line input {\n  padding: 0 36px 0 36px;\n}\n@media (max-width: 767.98px) {\n  .search-input.search-calendar-line input {\n    padding: 0px 25px 0px 25px;\n  }\n}\n.search-input.search-calendar-line > i {\n  left: 10px;\n}\n@media (max-width: 767.98px) {\n  .search-input.search-calendar-line > i {\n    left: 0;\n  }\n}\n.search-input i {\n  position: absolute;\n  top: 50%;\n  right: inherit;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  color: #8894ae;\n  font-size: 18px;\n}\n.search-input .current-loc-icon {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  margin-top: 0px;\n  color: #8894ae;\n  font-size: 18px;\n  line-height: 0;\n}\n.search-input .current-loc-icon i {\n  position: unset;\n  transform: unset;\n}\n.search-input > i.bficon {\n  right: inherit;\n  left: 0;\n  z-index: 1;\n}\n@media (max-width: 767.98px) {\n  .search-input {\n    width: 100%;\n  }\n}\n\n.form-search-btn {\n  float: right;\n  padding-top: 4px;\n}\n.form-search-btn .btn {\n  font-size: 15px;\n  font-weight: 500;\n  min-width: 97px;\n  padding: 7px 15px;\n  border-radius: 10px;\n  background-color: #0e82fd;\n  border: 1px solid #0e82fd;\n  color: #ffffff;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  -webkit-transition: 0.5s;\n  -ms-transition: 0.5s;\n  transition: 0.5s;\n}\n.form-search-btn .btn:hover {\n  color: #0e82fd;\n  border-color: #0e82fd;\n  background-color: #ffffff;\n  box-shadow: inset 0 0 0 50px #ffffff;\n  -webkit-transition: 0.5s;\n  -ms-transition: 0.5s;\n  transition: 0.5s;\n}\n@media (max-width: 767.98px) {\n  .form-search-btn {\n    float: left;\n  }\n}\n\n.banner-img {\n  position: relative;\n}\n.banner-img .banner-img1 {\n  position: absolute;\n  top: 260px;\n  left: -40px;\n  -webkit-animation: float 2s ease-in-out infinite;\n  animation: float 2s ease-in-out infinite;\n}\n.banner-img .banner-img2 {\n  position: absolute;\n  top: 200px;\n  right: 20px;\n  -webkit-animation: mover 3s infinite alternate;\n  animation: mover 3s infinite alternate;\n}\n.banner-img .banner-img3 {\n  position: absolute;\n  top: 500px;\n  right: -50px;\n  -webkit-animation: mover 1s infinite alternate;\n  animation: mover 1s infinite alternate;\n}\n@keyframes float {\n  0% {\n    transform: translateY(0px);\n    -webkit-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-15px);\n    -webkit-transform: translateY(-15px);\n    -ms-transform: translateY(-15px);\n  }\n  100% {\n    transform: translateY(0px);\n    -webkit-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n  }\n}\n@-webkit-keyframes mover {\n  0% {\n    transform: translateY(0px);\n    -webkit-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n  }\n  100% {\n    transform: translateY(-15px);\n    -webkit-transform: translateY(-15px);\n    -ms-transform: translateY(-15px);\n  }\n}\n@keyframes mover {\n  0% {\n    transform: translateY(0px);\n    -webkit-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n  }\n  100% {\n    transform: translateY(-15px);\n    -webkit-transform: translateY(-15px);\n    -ms-transform: translateY(-15px);\n  }\n}\n@media (max-width: 991.98px) {\n  .banner-img {\n    display: none;\n  }\n}\n\n.specialities-section-one {\n  background-color: #ffffff;\n  margin: 0;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .specialities-section-one {\n    margin: 0;\n    padding: 40px 0;\n  }\n}\n.specialities-section-one .specialities-slider-one .item {\n  margin-bottom: 50px;\n}\n@media (max-width: 767.98px) {\n  .specialities-section-one .specialities-slider-one .item {\n    margin-bottom: 40px;\n  }\n}\n.specialities-section-one .specialities-slider-one .owl-stage-outer {\n  margin-left: -10px;\n}\n.specialities-section-one .specialities-slider-one .owl-item img {\n  width: auto;\n}\n.specialities-section-one .specialities-item {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 8px;\n  height: 196px;\n  margin: 15px 0 0 10px;\n  padding: 30px;\n  cursor: pointer;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.specialities-section-one .specialities-item:hover {\n  background: #ffffff;\n  border-color: #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.specialities-section-one .specialities-item:hover .specialities-img span {\n  background: #0e82fd;\n  border: #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.specialities-section-one .specialities-item:hover .specialities-img span img {\n  filter: invert(1) brightness(100);\n  transform: rotateY(360deg);\n  -webkit-transform: rotateY(360deg);\n  -ms-transform: rotateY(360deg);\n  -webkit-transition: 0.4s;\n  -ms-transition: 0.4s;\n  transition: 0.4s;\n}\n.specialities-section-one .specialities-item p {\n  font-weight: 600;\n  font-size: 16px;\n  color: #2f353c;\n  margin-bottom: 0;\n}\n.specialities-section-one .specialities-img {\n  padding-bottom: 18px;\n}\n.specialities-section-one .specialities-img span {\n  background: #f2f6f6;\n  border: 1px solid #f2f6f6;\n  width: 90px;\n  height: 90px;\n  border-radius: 50%;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.specialities-section-one .specialities-img span img {\n  width: auto;\n  -webkit-transition: 0.4s;\n  -ms-transition: 0.4s;\n  transition: 0.4s;\n}\n.specialities-section-one .specialities-btn {\n  text-align: center;\n}\n.specialities-section-one .specialities-btn .btn {\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 15px;\n  min-width: 170px;\n  padding: 11px 15px;\n  background: #0e82fd;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  color: #ffffff;\n  -webkit-transition: 0.5s;\n  -ms-transition: 0.5s;\n  transition: 0.5s;\n}\n.specialities-section-one .specialities-btn .btn:hover {\n  color: #0e82fd;\n  background: #ffffff;\n  border-color: #0e82fd;\n  box-shadow: inset 0 0 0 50px #ffffff;\n  -webkit-transition: 0.5s;\n  -ms-transition: 0.5s;\n  transition: 0.5s;\n}\n@media (max-width: 767.98px) {\n  .specialities-section-one .specialities-btn .btn {\n    font-size: 14px;\n    min-width: 190px;\n  }\n}\n\n.section-header-one {\n  margin-bottom: 60px;\n}\n.section-header-one h2 {\n  font-size: 40px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .section-header-one h2 {\n    font-size: 34px;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-header-one h2 {\n    font-size: 26px;\n  }\n}\n.section-header-one .section-title {\n  display: inline-block;\n  position: relative;\n}\n.section-header-one .section-title::before {\n  content: \"\";\n  background: url(../images/icons/header-icon.svg);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: right;\n  position: absolute;\n  top: -5px;\n  right: -30px;\n  width: 35px;\n  height: 20px;\n}\n@media (max-width: 767.98px) {\n  .section-header-one .section-title::before {\n    display: none;\n  }\n}\n.section-header-one h5 {\n  font-weight: 600;\n  font-size: 18px;\n  color: #0e82fd;\n  margin-bottom: 10px;\n}\n@media (max-width: 991.98px) {\n  .section-header-one {\n    margin-bottom: 40px;\n  }\n}\n\n.slide-nav-1 button.owl-next,\n.slide-nav-1 button.owl-prev,\n.slide-nav-2 button.owl-next,\n.slide-nav-2 button.owl-prev {\n  width: 44px;\n  height: 44px;\n  font-size: 18px;\n  color: #1e3259;\n  background: #ffffff;\n  box-shadow: 0px 4px 14px rgba(141, 141, 141, 0.25);\n  text-shadow: none;\n  top: 0;\n  cursor: pointer;\n  border: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  margin-left: 15px;\n  border-radius: 50px;\n}\n\n.slide-nav-1 button.owl-next:hover,\n.slide-nav-1 button.owl-prev:hover,\n.slide-nav-2 button.owl-next:hover,\n.slide-nav-2 button.owl-prev:hover {\n  color: #ffffff;\n  background: #0e82fd;\n}\n\n.doctors-section {\n  background: #f2f6f6;\n  margin: 0;\n  padding: 80px 0;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n.doctors-section::after {\n  content: \"\";\n  background: url(../images/bg/doctor-shape-img1.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: left;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 213px;\n  height: 335px;\n  opacity: 0.5;\n  z-index: -1;\n}\n@media (max-width: 991.98px) {\n  .doctors-section::after {\n    display: none;\n  }\n}\n.doctors-section::before {\n  content: \"\";\n  background: url(../images/bg/doctor-shape-img2.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: right;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  opacity: 0.5;\n  width: 213px;\n  height: 335px;\n  z-index: -1;\n}\n@media (max-width: 991.98px) {\n  .doctors-section::before {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .doctors-section {\n    margin: 0;\n    padding: 40px 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctors-section .section-header-slider {\n    margin-bottom: 20px;\n  }\n}\n\n.doctor-shape-img {\n  position: relative;\n}\n.doctor-shape-img .doctor-shape-left {\n  position: absolute;\n  top: 0;\n  left: -35px;\n}\n.doctor-shape-img .doctor-shape-right {\n  position: absolute;\n  top: 230px;\n  right: 0;\n}\n@media (max-width: 991.98px) {\n  .doctor-shape-img {\n    display: none;\n  }\n}\n\n@-webkit-keyframes blinker {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n.doctor-profile-widget {\n  background: #ffffff;\n  border: 1px solid #e5e5e5;\n  border-radius: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.doc-pro-img {\n  position: relative;\n}\n\n.doctor-profile-img {\n  position: relative;\n  overflow: hidden;\n  border-radius: 8px 8px 0px 0px;\n}\n.doctor-profile-img img {\n  position: relative;\n  border-radius: 8px 8px 0px 0px;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  width: 100%;\n}\n.doctor-profile-img:hover img {\n  -webkit-transition: scale(1.15);\n  -ms-transition: scale(1.15);\n  transition: scale(1.15);\n}\n.doctor-profile-img:hover::before {\n  -webkit-animation: circle 1s;\n  animation: circle 1s;\n}\n.doctor-profile-img::before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 2;\n  display: block;\n  content: \"\";\n  width: 0;\n  height: 0;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 100%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  opacity: 0;\n}\n\n@-webkit-keyframes circle {\n  0% {\n    opacity: 1;\n  }\n  40% {\n    opacity: 1;\n  }\n  100% {\n    width: 200%;\n    height: 200%;\n    opacity: 0;\n  }\n}\n@keyframes circle {\n  0% {\n    opacity: 1;\n  }\n  40% {\n    opacity: 1;\n  }\n  100% {\n    width: 200%;\n    height: 200%;\n    opacity: 0;\n  }\n}\n.doctor-amount {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n.doctor-amount span {\n  font-weight: 500;\n  font-size: 15px;\n  color: #2c2c2c;\n  padding: 6px 12px;\n  background: #ffffff;\n  border-radius: 8px;\n}\n\n.doc-content {\n  padding: 20px;\n}\n@media (max-width: 767.98px) {\n  .doc-content {\n    padding: 15px;\n  }\n}\n\n.doc-pro-info {\n  padding-bottom: 15px;\n}\n.doc-pro-info .doc-pro-name a {\n  font-weight: 600;\n  font-size: 20px;\n}\n.doc-pro-info .doc-pro-name a:hover {\n  color: #0e82fd;\n}\n@media (max-width: 1399.98px) {\n  .doc-pro-info .doc-pro-name a {\n    font-size: 18px;\n  }\n}\n.doc-pro-info .doc-pro-name p {\n  color: #9ca3af;\n  font-size: 12px;\n  margin-bottom: 0;\n}\n\n.reviews-ratings p {\n  color: #9ca3af;\n  font-size: 10px;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.reviews-ratings span {\n  margin: 0 4px 0 0;\n  padding: 2px 3px;\n  min-width: 46px;\n  color: #ffffff;\n  font-size: 12px;\n  background: #ffbc11;\n  border-radius: 6px;\n}\n.reviews-ratings span i {\n  margin-right: 6px;\n}\n\n.doc-pro-location p {\n  margin-bottom: 0;\n}\n.doc-pro-location p i {\n  margin-right: 8px;\n  font-size: 20px;\n  color: #d1d5db;\n}\n\n.work-section {\n  background: #f2f6f6;\n  margin: 0;\n  padding: 80px 0 0;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n.work-section::after {\n  content: \"\";\n  background: url(../images/bg/doctor-shape-img1.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: left;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 213px;\n  height: 335px;\n  opacity: 0.5;\n  z-index: -1;\n}\n@media (max-width: 991.98px) {\n  .work-section::after {\n    display: none;\n  }\n}\n.work-section::before {\n  content: \"\";\n  background: url(../images/bg/doctor-shape-img2.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: right;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  opacity: 0.5;\n  width: 213px;\n  height: 335px;\n  z-index: -1;\n}\n@media (max-width: 991.98px) {\n  .work-section::before {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .work-section {\n    margin: 0;\n    padding: 40px 0 20px;\n  }\n}\n\n.work-img-info {\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .work-img-info {\n    display: none;\n  }\n}\n.work-img-info .work-img {\n  position: absolute;\n  bottom: 0;\n}\n\n.work-details {\n  padding-left: 60px;\n}\n@media (max-width: 1199.98px) {\n  .work-details {\n    padding-left: 20px;\n  }\n}\n\n.work-info {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: start;\n  margin-bottom: 35px;\n}\n@media (max-width: 991.98px) {\n  .work-info {\n    margin-bottom: 20px;\n  }\n}\n.work-info .work-icon {\n  margin-right: 20px;\n}\n.work-info .work-icon span {\n  min-width: 70px;\n  height: 70px;\n  background: #e0e7ff;\n  border-radius: 10px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n  transform: rotate(0);\n  -webkit-transform: rotate(0);\n  -ms-transform: rotate(0);\n}\n.work-info .work-icon span img {\n  transform: rotate(0);\n  -webkit-transform: rotate(0);\n  -ms-transform: rotate(0);\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.work-info:hover .work-icon span {\n  background: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n  transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n}\n.work-info:hover .work-icon span img {\n  transform: rotate(-90deg);\n  -webkit-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.work-info .work-content h5 {\n  font-weight: 600;\n  font-size: 18px;\n  color: #1f2937;\n  margin-bottom: 14px;\n}\n@media (max-width: 767.98px) {\n  .work-info .work-content h5 {\n    margin-bottom: 10px;\n  }\n}\n.work-info .work-content p {\n  font-size: 16px;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .work-info .work-content p {\n    font-size: 14px;\n  }\n}\n\n.work-section {\n  background: #f2f6f6;\n  margin: 0;\n  padding: 80px 0 0;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n.work-section::after {\n  content: \"\";\n  background: url(../images/bg/doctor-shape-img1.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: left;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 213px;\n  height: 335px;\n  opacity: 0.5;\n  z-index: -1;\n}\n@media (max-width: 991.98px) {\n  .work-section::after {\n    display: none;\n  }\n}\n.work-section::before {\n  content: \"\";\n  background: url(../images/bg/doctor-shape-img2.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: right;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  opacity: 0.5;\n  width: 213px;\n  height: 335px;\n  z-index: -1;\n}\n@media (max-width: 991.98px) {\n  .work-section::before {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .work-section {\n    margin: 0;\n    padding: 40px 0 20px;\n  }\n}\n\n.work-img-info {\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .work-img-info {\n    display: none;\n  }\n}\n.work-img-info .work-img {\n  position: absolute;\n  bottom: 0;\n}\n\n.work-details {\n  padding-left: 60px;\n}\n@media (max-width: 1199.98px) {\n  .work-details {\n    padding-left: 20px;\n  }\n}\n\n.work-info {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: start;\n  margin-bottom: 35px;\n}\n@media (max-width: 991.98px) {\n  .work-info {\n    margin-bottom: 20px;\n  }\n}\n.work-info .work-icon {\n  margin-right: 20px;\n}\n.work-info .work-icon span {\n  min-width: 70px;\n  height: 70px;\n  background: #e0e7ff;\n  border-radius: 10px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n  transform: rotate(0);\n  -webkit-transform: rotate(0);\n  -ms-transform: rotate(0);\n}\n.work-info .work-icon span img {\n  transform: rotate(0);\n  -webkit-transform: rotate(0);\n  -ms-transform: rotate(0);\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.work-info:hover .work-icon span {\n  background: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n  transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n}\n.work-info:hover .work-icon span img {\n  transform: rotate(-90deg);\n  -webkit-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.work-info .work-content h5 {\n  font-weight: 600;\n  font-size: 18px;\n  color: #1f2937;\n  margin-bottom: 14px;\n}\n@media (max-width: 767.98px) {\n  .work-info .work-content h5 {\n    margin-bottom: 10px;\n  }\n}\n.work-info .work-content p {\n  font-size: 16px;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .work-info .work-content p {\n    font-size: 14px;\n  }\n}\n\n.articles-section {\n  background-color: #ffffff;\n  margin: 0;\n  padding: 80px 0 55px;\n}\n@media (max-width: 991.98px) {\n  .articles-section {\n    margin: 0;\n    padding: 40px 0 15px;\n  }\n}\n\n.articles-grid {\n  border: 2px solid #ededed;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 25px;\n}\n\n.articles-info .articles-left {\n  margin-right: 20px;\n}\n.articles-info .articles-left .articles-img {\n  position: relative;\n  overflow: hidden;\n  border-radius: 8px;\n  width: 205px;\n  height: 180px;\n}\n.articles-info .articles-left .articles-img img {\n  position: relative;\n  border-radius: 8px;\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  width: 100%;\n}\n.articles-info .articles-left .articles-img:hover img {\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n.articles-info .articles-left .articles-img:hover::before {\n  -webkit-animation: circle 1s;\n  animation: circle 1s;\n}\n.articles-info .articles-left .articles-img::before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 2;\n  display: block;\n  content: \"\";\n  width: 0;\n  height: 0;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 100%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  opacity: 0;\n}\n@media (max-width: 1199.98px) {\n  .articles-info .articles-left .articles-img {\n    width: 100%;\n    height: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .articles-info .articles-left {\n    margin: 0 0 20px 0;\n    padding: 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .articles-info {\n    display: block;\n    text-align: center;\n  }\n}\n\n.articles-content .articles-list {\n  margin-bottom: 10px;\n}\n.articles-content .articles-list li {\n  margin-right: 15px;\n}\n.articles-content .articles-list li:last-child {\n  margin-right: 0;\n}\n.articles-content .articles-list li i {\n  font-size: 18px;\n  margin-right: 8px;\n}\n@media (max-width: 1199.98px) {\n  .articles-content .articles-list {\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n  }\n}\n.articles-content h4 {\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 10px;\n  max-width: 320px;\n}\n@media (max-width: 991.98px) {\n  .articles-content h4 {\n    max-width: inherit;\n  }\n}\n.articles-content h4 a:hover {\n  color: #0e82fd;\n}\n.articles-content p {\n  margin-bottom: 16px;\n}\n.articles-content .btn {\n  font-weight: 500;\n  font-size: 15px;\n  color: #0e82fd;\n  background: #ffffff;\n  border: 2px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  border-radius: 6px;\n  min-width: 112px;\n  padding: 7px 12px;\n  -webkit-transition: 0.5s;\n  -ms-transition: 0.5s;\n  transition: 0.5s;\n}\n.articles-content .btn:hover {\n  color: #ffffff;\n  border-color: #0e82fd;\n  background: #0e82fd;\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  -webkit-transition: 0.5s;\n  -ms-transition: 0.5s;\n  transition: 0.5s;\n}\n@media (max-width: 767.98px) {\n  .articles-content .btn {\n    font-size: 14px;\n  }\n}\n\n.app-section {\n  background-color: #ffffff;\n  margin: 0;\n  padding: 20px 0 80px;\n}\n@media (max-width: 1199.98px) {\n  .app-section {\n    margin: 0;\n    padding: 0 0 80px;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-section {\n    margin: 0;\n    padding: 20px 0 40px;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-section {\n    margin: 0;\n    padding: 0px 0 40px;\n  }\n}\n\n.app-bg {\n  background: #0e82fd;\n  background-image: url(../images/app-bg.png);\n  background-position: right top;\n  background-repeat: no-repeat;\n  border-radius: 25px;\n  padding: 40px 0 0 50px;\n}\n@media (max-width: 1199.98px) {\n  .app-bg {\n    margin: 0;\n    padding: 30px;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-bg {\n    margin: 0;\n    padding: 40px 0;\n    background-image: inherit;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-bg {\n    margin: 0;\n    padding: 30px 0;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .app-content {\n    text-align: center;\n  }\n}\n\n.app-header {\n  padding-bottom: 40px;\n}\n.app-header h5 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 10px;\n}\n@media (max-width: 991.98px) {\n  .app-header h5 {\n    font-size: 22px;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-header h5 {\n    font-size: 18px;\n  }\n}\n.app-header h2 {\n  font-size: 40px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 0;\n  max-width: 565px;\n}\n@media (max-width: 991.98px) {\n  .app-header h2 {\n    font-size: 34px;\n    max-width: 100%;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-header h2 {\n    font-size: 26px;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-header {\n    padding-bottom: 30px;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-header {\n    padding-bottom: 20px;\n  }\n}\n\n.app-scan {\n  padding-bottom: 40px;\n}\n.app-scan p {\n  font-weight: 500;\n  color: #ffffff;\n  margin-bottom: 10px;\n}\n@media (max-width: 991.98px) {\n  .app-scan {\n    padding-bottom: 30px;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-scan {\n    padding-bottom: 20px;\n  }\n}\n\n.google-imgs a {\n  margin-right: 24px;\n}\n.google-imgs a:last-child {\n  margin-right: 0;\n}\n@media (max-width: 767.98px) {\n  .google-imgs a img {\n    width: 120px;\n  }\n}\n@media (max-width: 767.98px) {\n  .google-imgs a {\n    margin-right: 14px;\n  }\n}\n\n.mobile-img {\n  position: relative;\n  bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .mobile-img {\n    display: none;\n  }\n}\n@media (max-width: 1440.98px) {\n  .mobile-img img {\n    max-width: 450px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .mobile-img img {\n    max-width: 370px;\n  }\n}\n\n.faq-section {\n  background-color: #ffffff;\n  position: relative;\n  overflow: hidden;\n  margin: 0;\n  padding: 0 0 140px;\n}\n@media (max-width: 1199.98px) {\n  .faq-section {\n    margin: 0;\n    padding: 0 0 80px;\n  }\n}\n@media (max-width: 991.98px) {\n  .faq-section {\n    margin: 0;\n    padding: 0 0 40px;\n  }\n}\n\n.faq-img {\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .faq-img {\n    text-align: center;\n    margin-bottom: 80px;\n  }\n}\n@media (max-width: 767.98px) {\n  .faq-img {\n    margin-bottom: 70px;\n  }\n}\n\n.faq-patients-count {\n  background: #ffffff;\n  box-shadow:\n    0px 100px 80px rgba(0, 0, 0, 0.03),\n    0px 64.81px 46.85px rgba(0, 0, 0, 0.0228),\n    0px 38.52px 25.48px rgba(0, 0, 0, 0.0182),\n    0px 20px 13px rgba(0, 0, 0, 0.015),\n    0px 8.15px 6.52px rgba(0, 0, 0, 0.0118),\n    0px 1.85px 3.15px rgba(0, 0, 0, 0.0072);\n  border-radius: 10px;\n  padding: 15px;\n  min-width: 222px;\n  position: absolute;\n  bottom: -40px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n@media (max-width: 991.98px) {\n  .faq-patients-count {\n    justify-content: start;\n    -webkit-justify-content: start;\n    -ms-flex-pack: start;\n    box-shadow: none;\n    border: 1px solid #f3f3f3;\n  }\n}\n\n.faq-smile-img {\n  margin-right: 15px;\n}\n\n.faq-patients-content h4 {\n  font-weight: 700;\n  font-size: 24px;\n  margin-bottom: 3px;\n}\n@media (max-width: 767.98px) {\n  .faq-patients-content h4 {\n    font-size: 20px;\n  }\n}\n.faq-patients-content p {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .faq-patients-content p {\n    font-size: 16px;\n  }\n}\n@media (max-width: 991.98px) {\n  .faq-patients-content {\n    text-align: left;\n  }\n}\n\n.faq-info .accordion-item {\n  background: #f8f8f8;\n  border: 0;\n  border-radius: 0;\n  margin: 0 0 24px;\n  padding: 15px;\n}\n.faq-info .accordion-item:last-child {\n  margin-bottom: 0;\n}\n.faq-info .accordion-item .accordion-body {\n  margin-top: 15px;\n  padding: 15px 0 0;\n  border-top: 1px solid #e2e8f0;\n}\n@media (max-width: 767.98px) {\n  .faq-info .accordion-item {\n    margin-bottom: 20px;\n  }\n}\n.faq-info .accordion-header {\n  position: relative;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n.faq-info .accordion-button {\n  font-size: 16px;\n  font-weight: 500;\n  color: #1f2937;\n  background: transparent;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  position: relative;\n  cursor: pointer;\n}\n.faq-info .accordion-button:hover {\n  border: 0;\n}\n.faq-info .accordion-button:after {\n  content: \"\\e9b1\";\n  font-family: \"feather\";\n  font-size: 20px;\n  background: none;\n  color: #0e82fd;\n  background: #ffffff;\n  width: 32px;\n  height: 32px;\n  border-radius: 5px;\n}\n@media (max-width: 767.98px) {\n  .faq-info .accordion-button:after {\n    position: absolute;\n    right: 0;\n  }\n}\n.faq-info .accordion-button:not(.collapsed)::after {\n  content: \"\\e996\";\n  color: #ffffff;\n  background: #0e82fd;\n}\n@media (max-width: 767.98px) {\n  .faq-info .accordion-button {\n    font-size: 14px;\n    padding-right: 30px;\n    line-height: 24px;\n  }\n}\n.faq-info .accordion-content p {\n  color: #6b7280;\n  margin-bottom: 0;\n}\n\n.partners-section {\n  background-color: #ffffff;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .partners-section {\n    padding: 40px 0;\n  }\n}\n.partners-section .owl-nav {\n  display: none;\n}\n\n.partners-slider {\n  list-style: none;\n}\n.partners-slider li a {\n  background: #ffffff;\n  border: 2px solid #f5f5f5;\n  padding: 14px 20px;\n  text-align: center;\n  height: 79px;\n  border-radius: 10px;\n}\n\n@media (max-width: 767.98px) {\n  .partners-slider.owl-carousel .owl-item img {\n    width: auto;\n    margin: 0 auto;\n    height: auto;\n  }\n}\n\n.footer-1.footer {\n  background-color: #f2f6f6;\n}\n.footer-1.footer .footer-top .footer-title {\n  color: #1f2937;\n}\n.footer-1.footer .footer-top .footer-widget.footer-menu ul li a {\n  color: #6b7280;\n  position: relative;\n  overflow: hidden;\n  background: url(../images/footer-arrow.png) no-repeat -20px 20px;\n  -webkit-transition: all 0.5s ease-in-out;\n  -ms-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n}\n.footer-1.footer .footer-top .footer-widget .footer-about-content p {\n  color: #6b7280;\n}\n.footer-1.footer .footer-top .footer-widget .footer-contact-info {\n  color: #6b7280;\n}\n.footer-1.footer .subscribe-form {\n  position: relative;\n}\n.footer-1.footer .subscribe-form .form-control {\n  font-weight: 500;\n  font-size: 14px;\n  min-height: 46px;\n  color: #6b7280;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px 0px 0px 6px;\n  margin: 0;\n  padding: 6px 112px 6px 15px;\n}\n.footer-1.footer .subscribe-form .btn {\n  font-weight: normal;\n  margin: 0;\n  padding: 11px 16px;\n  font-size: 15px;\n  font-weight: 600;\n  border-radius: 0 6px 6px 0;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n\ni svg {\n  font-size: 16px;\n  width: 16px;\n}\n\n.doctor-widget .rating i {\n  padding-right: 3px;\n}\n\n.blog {\n  border: 1px solid #f0f0f0;\n  background-color: #ffffff;\n  position: relative;\n  border-radius: 4px;\n  margin: 0 0 30px;\n  padding: 1.5rem;\n}\n@media (max-width: 575.98px) {\n  .blog {\n    padding: 1.25rem;\n  }\n}\n.blog .blog-image {\n  margin: 0 0 30px;\n  overflow: hidden;\n}\n.blog .blog-image img {\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n}\n.blog .blog-image a:hover img {\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n.blog .blog-title {\n  font-size: 22px;\n  margin: 0 0 10px;\n}\n@media (max-width: 767.98px) {\n  .blog .blog-title {\n    font-size: 20px;\n  }\n}\n@media (max-width: 575.98px) {\n  .blog .blog-title {\n    font-size: 18px;\n  }\n}\n.blog .blog-title a {\n  color: #272b41;\n}\n.blog .blog-title a:hover {\n  color: #20c0f3;\n}\n.blog .blog-content {\n  position: relative;\n}\n.blog .blog-content p {\n  color: #666;\n  font-size: 14px;\n  margin: 0 0 30px;\n}\n.blog .blog-content .entry-meta {\n  color: #757575;\n  font-size: 14px;\n  list-style: none;\n  margin: 0 0 15px;\n  padding: 0;\n}\n.blog .blog-content .entry-meta li {\n  display: inline-block;\n  margin-right: 15px;\n}\n.blog .blog-content .entry-meta li:last-child {\n  margin-right: 0;\n}\n.blog.grid-blog {\n  padding: 20px;\n}\n.blog.grid-blog .blog-title {\n  font-size: 18px;\n  min-height: 43px;\n  margin: 0 0 5px;\n}\n@media (max-width: 767.98px) {\n  .blog.grid-blog .blog-title {\n    min-height: inherit;\n  }\n}\n.blog.grid-blog .blog-content p {\n  margin: 0 0 15px;\n}\n.blog.grid-blog .blog-info {\n  margin: 0 0 15px;\n}\n.blog.grid-blog .blog-image {\n  margin: 0 0 20px;\n}\n.blog.grid-blog .entry-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin-bottom: 0 !important;\n}\n.blog.grid-blog .entry-meta li {\n  margin: 0 0 10px;\n}\n.blog.grid-blog .entry-meta li:last-child {\n  flex: 0 0 100px;\n  max-width: 100px;\n}\n.blog.grid-blog .post-author {\n  width: 189px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.blog.grid-blog .post-author a:hover {\n  color: #20c0f3;\n}\n\n.blog-image,\n.blog-image > a,\n.blog-image img {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: auto;\n}\n\n.read-more {\n  display: inline-block;\n  font-size: 16px;\n  padding: 0;\n  color: #20c0f3;\n  text-decoration: underline;\n  font-weight: 700;\n}\n@media (max-width: 575.98px) {\n  .read-more {\n    font-size: 14px;\n  }\n}\n\n.blog-info {\n  color: #757575;\n  font-size: 14px;\n  margin: 0 0 15px;\n}\n.blog-info a {\n  color: #757575;\n}\n.blog-info a:hover {\n  color: #757575;\n}\n.blog-info i {\n  color: #20c0f3;\n  font-size: 14px;\n  margin-right: 5px;\n}\n@media (max-width: 575.98px) {\n  .blog-info i {\n    font-size: 14px;\n  }\n}\n\n.blog-pagination .pagination {\n  margin: 0 0 30px;\n}\n.blog-pagination .pagination li a {\n  font-weight: 600;\n  color: #2e3842;\n  border-radius: inherit !important;\n  border-color: #f0f0f0;\n  margin: 0 10px 0 0;\n  padding: 12px 20px;\n}\n.blog-pagination .pagination li.disabled a {\n  border-color: #f0f0f0;\n}\n.blog-pagination .pagination li.active a {\n  background: #20c0f3;\n  border-color: transparent;\n  color: #ffffff;\n}\n\n.post-left ul {\n  list-style: none;\n  display: flex;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n}\n.post-left ul li {\n  margin-bottom: 5px;\n  margin-right: 20px;\n}\n@media (max-width: 575.98px) {\n  .post-left ul li {\n    margin-right: 10px;\n  }\n}\n.post-left ul li:last-child {\n  margin-right: 0;\n}\n@media (max-width: 575.98px) {\n  .post-left ul li:last-child {\n    margin-right: 10px;\n  }\n}\n\n.post-author a {\n  display: flex;\n  align-items: center;\n}\n\n.video {\n  position: relative;\n  padding-bottom: 56%;\n  height: 0;\n  overflow: hidden;\n}\n.video iframe,\n.video object,\n.video embed {\n  width: 100%;\n  height: 100%;\n  border: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.latest-posts {\n  margin: 0;\n  padding: 0;\n}\n.latest-posts li {\n  display: table;\n  width: 100%;\n  margin: 0 0 20px;\n}\n.latest-posts li:last-child {\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n  border-bottom: none;\n}\n\n.post-thumb {\n  width: 80px;\n  float: left;\n  overflow: hidden;\n  border-radius: 4px;\n}\n.post-thumb a img {\n  border-radius: 4px;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n}\n.post-thumb a:hover img {\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n\n.post-info {\n  margin-left: 95px;\n}\n.post-info h4 {\n  font-size: 15px;\n  margin: 0 0 5px;\n}\n.post-info h4 a {\n  color: #272b41;\n}\n.post-info h4 a:hover {\n  color: #20c0f3;\n}\n.post-info p {\n  color: #757575;\n  font-size: 12px;\n  margin: 0;\n}\n.post-info p i {\n  color: #20c0f3;\n  font-size: 14px;\n  margin-right: 4px;\n}\n\n.category-widget .categories {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.category-widget .categories li {\n  margin: 0 0 20px;\n}\n.category-widget .categories li:last-child {\n  border-bottom: none;\n  margin: 0;\n  padding: 0;\n}\n.category-widget .categories li a {\n  color: #2e3842;\n  font-size: 15px;\n  font-weight: 500;\n}\n.category-widget .categories li a span {\n  float: right;\n  color: #757575;\n}\n.category-widget .categories li a:hover {\n  color: #20c0f3;\n}\n\n.category-widget .categories > li > a > i {\n  color: #20c0f3;\n  font-size: 18px;\n  margin-right: 10px;\n}\n\n.tags-widget .card-body {\n  padding-bottom: 1rem;\n}\n\n.tags {\n  list-style: none;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n}\n.tags li {\n  float: left;\n}\n\n.tag {\n  background-color: #ffffff;\n  color: #272b41;\n  position: relative;\n  font-size: 14px;\n  border: 1px solid #cccccc;\n  display: inline-block;\n  border-radius: 4px;\n  margin: 0 0.5rem 0.5rem 0;\n  padding: 5px 10px;\n}\n.tag:hover {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n  color: #ffffff;\n}\n\n.comment-by {\n  display: block;\n  font-size: 14px;\n  line-height: 21px;\n  margin: 0 0 10px;\n}\n\n.comments-list .comment-block p {\n  font-size: 14px;\n  margin: 0 0 5px;\n}\n\n/*-----------------\n\tBlog Details\n-----------------------*/\n.blog-view .blog-title {\n  font-size: 24px;\n}\n@media (max-width: 767.98px) {\n  .blog-view .blog-title {\n    font-size: 22px;\n  }\n}\n@media (max-width: 575.98px) {\n  .blog-view .blog-title {\n    font-size: 20px;\n  }\n}\n.blog-view .blog-info {\n  border: 0;\n  margin: 0 0 20px;\n  padding: 0;\n}\n\n.blog-content p:last-child {\n  margin: 0;\n}\n\n.social-share {\n  float: left;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.social-share > li {\n  display: inline-block;\n  float: left;\n  margin-left: 10px;\n  text-align: center;\n}\n.social-share > li:first-child {\n  margin-left: 0;\n}\n.social-share > li a:hover {\n  background-color: #20c0f3;\n  color: #ffffff;\n  border-color: #20c0f3;\n}\n.social-share > li > a {\n  border: 1px solid #dfdfdf;\n  color: #666;\n  display: inline-block;\n  font-size: 22px;\n  height: 40px;\n  line-height: 40px;\n  width: 40px;\n}\n\n.blog-reply > a {\n  color: #999;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.blog-date {\n  color: #999;\n  font-size: 12px;\n}\n\n.blog-comments .comments-list {\n  list-style: none;\n  position: relative;\n  margin: 0;\n  padding: 0;\n}\n.blog-comments .comments-list li {\n  clear: both;\n  padding-left: 80px;\n}\n@media (max-width: 575.98px) {\n  .blog-comments .comments-list li {\n    padding: 10px 0 0 50px;\n  }\n}\n.blog-comments .comments-list li .comment {\n  margin: 0 0 20px;\n}\n.blog-comments .comments-list li .comment-author {\n  position: absolute;\n  left: 0;\n}\n.blog-comments .comments-list li img.avatar {\n  height: 58px;\n  width: 58px;\n  border-radius: 58px;\n}\n@media (max-width: 575.98px) {\n  .blog-comments .comments-list li img.avatar {\n    height: 40px;\n    width: 40px;\n    border-radius: 40px;\n  }\n}\n.blog-comments .comment-btn {\n  color: #20c0f3;\n  display: inline-block;\n  font-weight: 500;\n  font-size: 15px;\n}\n\n.blog-author-name {\n  color: #272b41;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.new-comment label {\n  font-weight: 500;\n}\n\n.comment-submit .btn {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n  font-size: 18px;\n  padding: 8px 26px;\n  color: #ffffff;\n  border-radius: 0;\n}\n\n.about-author-img {\n  background-color: #ffffff;\n  height: 100px;\n  overflow: hidden;\n  position: absolute;\n  width: 100px;\n}\n@media (max-width: 575.98px) {\n  .about-author-img {\n    height: 60px;\n    width: 60px;\n  }\n}\n\n.author-details {\n  margin: 0 0 0 120px;\n}\n@media (max-width: 575.98px) {\n  .author-details {\n    margin-left: 80px;\n  }\n}\n.author-details .blog-author-name {\n  display: inline-block;\n  margin: 0 0 10px;\n}\n\n.about-author {\n  min-height: 100px;\n}\n\n.post-author img {\n  width: 28px;\n  margin-right: 5px;\n  border-radius: 100%;\n}\n\n.blogs-section {\n  padding: 50px 0;\n  background-color: #ffffff;\n}\n@media (max-width: 767.98px) {\n  .blogs-section {\n    padding: 30px 0;\n  }\n}\n.blogs-section .blog-wrapper {\n  background: #ffffff;\n  border: 1px solid #e8eeff;\n  box-sizing: border-box;\n  border-radius: 10px 10px 0px 0px;\n  margin-bottom: 30px;\n}\n.blogs-section .blog-wrapper .wrap-image img {\n  width: 100%;\n  border-radius: 10px 10px 0px 0px;\n}\n.blogs-section .blog-wrapper .wrap-content {\n  padding: 10px;\n}\n.blogs-section .blog-wrapper .wrap-content .sp-title {\n  font-size: 13px;\n  color: #2264c5;\n  font-weight: 600;\n  margin-right: 5px;\n}\n.blogs-section .blog-wrapper .wrap-content .post-author a {\n  display: flex;\n  align-items: center;\n}\n.blogs-section .blog-wrapper .wrap-content .post-author a img {\n  width: 20px;\n  flex: 0 0 20px;\n  margin: 0 5px;\n}\n.blogs-section .blog-wrapper .wrap-content .post-author a span {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000000;\n}\n.blogs-section .blog-wrapper .wrap-content .date-cart {\n  background-color: #1860ca;\n  font-size: 28px;\n  color: #ffffff;\n  font-weight: 600;\n  line-height: 1.2;\n  text-align: center;\n  width: 65px;\n  height: 60px;\n  flex-direction: column;\n  position: absolute;\n  right: 25px;\n  margin: -40px 0 0;\n  padding: 10px 8px;\n}\n@media (max-width: 991.98px) {\n  .blogs-section .blog-wrapper .wrap-content .date-cart {\n    font-size: 26px;\n  }\n}\n@media (max-width: 767.98px) {\n  .blogs-section .blog-wrapper .wrap-content .date-cart {\n    font-size: 22px;\n    width: 60px;\n    height: 55px;\n    padding: 5px;\n  }\n}\n.blogs-section .blog-wrapper .wrap-content .date-cart span {\n  font-size: 11px;\n  font-weight: 500;\n}\n@media (max-width: 767.98px) {\n  .blogs-section .blog-wrapper .wrap-content .date-cart span {\n    font-size: 10px;\n  }\n}\n.blogs-section .blog-wrapper .wrap-content-body {\n  margin-top: 10px;\n}\n@media (max-width: 767.98px) {\n  .blogs-section .blog-wrapper .wrap-content-body h3 {\n    font-size: 17px;\n  }\n}\n.blogs-section .blog-wrapper .wrap-content-body h3 a {\n  font-size: 18px;\n  font-weight: 500;\n  color: #000000;\n  line-height: 1.5;\n}\n@media (max-width: 767.98px) {\n  .blogs-section .blog-wrapper .wrap-content-body h3 a {\n    font-size: 17px;\n  }\n}\n.blogs-section .blog-wrapper .wrap-content-body p {\n  font-size: 12px;\n  color: #000000;\n}\n.blogs-section .blog-wrapper .wrap-content-body a.read-txt {\n  width: 110px;\n  padding: 10px;\n  background: #0ce0ff;\n  border-radius: 30px;\n  display: block;\n  text-align: center;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n}\n.blogs-section .blog-wrapper .wrap-content-body a.read-txt:hover {\n  background-color: #0e82fd;\n}\n.blogs-section .view-btn {\n  background-color: #20c0f3;\n  font-size: 16px;\n  color: #ffffff;\n  font-weight: 700;\n  border-radius: 30px;\n  border: 1px solid #20c0f3;\n  padding: 6px 20px;\n}\n@media (max-width: 767.98px) {\n  .blogs-section .view-btn {\n    font-size: 14px;\n  }\n}\n.blogs-section .view-btn:hover {\n  background-color: #0e82fd;\n  border: 1px solid #0e82fd;\n}\n\n.our-blog-section {\n  padding: 60px 0;\n  background: #ffffff;\n}\n@media (max-width: 991.98px) {\n  .our-blog-section {\n    padding: 40px 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .our-blog-section {\n    padding: 30px 0;\n  }\n}\n.our-blog-section .our-blogs {\n  display: block;\n  transition: 0.6s;\n  border-radius: 10px 10px 0px 0px;\n  overflow: hidden;\n}\n.our-blog-section .our-blogs .blogs-img {\n  position: relative;\n  transition: 0.6s;\n}\n.our-blog-section .our-blogs .blogs-img .blogs-overlay {\n  align-items: center;\n  background: #ffffff;\n  border-radius: 30px 0px 0px 30px;\n  padding: 5px;\n  position: absolute;\n  right: 0;\n  bottom: 10px;\n  transition: 0.6s;\n}\n.our-blog-section .our-blogs .blogs-img .blogs-overlay img {\n  height: 35px;\n  width: 35px !important;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n.our-blog-section .our-blogs .blogs-img .blogs-overlay .blogs-writter {\n  display: none;\n}\n.our-blog-section .our-blogs .blogs-info {\n  background: #ffffff;\n  border: 1px solid #e8eeff;\n  padding: 15px;\n}\n.our-blog-section .our-blogs .blogs-info span {\n  color: #20c0f3;\n}\n.our-blog-section .our-blogs .blogs-info h4 {\n  color: #000000;\n  line-height: 28px;\n}\n.our-blog-section .our-blogs .blogs-info h4:hover {\n  color: #1c5b91;\n}\n.our-blog-section .our-blogs .blogs-info p {\n  font-size: 13px;\n}\n.our-blog-section .our-blogs .blogs-nav {\n  border: 1px solid #e8eeff;\n  padding: 10px;\n  border-top: 0;\n}\n.our-blog-section .our-blogs .blogs-nav .blogs-btn {\n  background: #1c5b90;\n  border-radius: 30px;\n  color: #ffffff;\n  padding: 8px 10px;\n  display: block;\n  width: 110px;\n  text-align: center;\n  font-size: 12px;\n}\n.our-blog-section .our-blogs .blogs-nav .blogs-btn:hover {\n  background-color: #0e82fd;\n}\n.our-blog-section .our-blogs:hover .blogs-img .blogs-overlay .blogs-writter {\n  display: block;\n}\n\n.blogs-time {\n  color: #17418e !important;\n}\n\n.booking-doc-info .booking-doc-img {\n  width: 80px;\n  margin-right: 15px;\n}\n@media (max-width: 767.98px) {\n  .booking-doc-info .booking-doc-img {\n    width: 75px;\n  }\n}\n@media (max-width: 575.98px) {\n  .booking-doc-info .booking-doc-img {\n    width: 70px;\n  }\n}\n.booking-doc-info .booking-doc-img img {\n  height: 80px;\n  width: 80px;\n  object-fit: cover;\n  border-radius: 4px;\n}\n@media (max-width: 767.98px) {\n  .booking-doc-info .booking-doc-img img {\n    height: 75px;\n    width: 75px;\n  }\n}\n@media (max-width: 575.98px) {\n  .booking-doc-info .booking-doc-img img {\n    height: 70px;\n    width: 70px;\n  }\n}\n\n.schedule-widget {\n  min-height: 100px;\n  border-radius: 4px;\n}\n.schedule-widget .schedule-header {\n  border-bottom: 1px solid #f0f0f0;\n  padding: 10px 20px;\n  border-radius: 4px 4px 0 0;\n}\n.schedule-widget .schedule-header h4 {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 3px 0 0;\n}\n\n.day-slot ul {\n  float: left;\n  list-style: none;\n  position: relative;\n  width: 100%;\n  margin: auto -5px 0 -5px;\n  padding: 0;\n}\n.day-slot ul li {\n  float: left;\n  padding-left: 5px;\n  padding-right: 5px;\n  text-align: center;\n  width: 14.28%;\n}\n.day-slot ul li span {\n  display: block;\n  font-size: 18px;\n  text-transform: uppercase;\n}\n@media (max-width: 767.98px) {\n  .day-slot ul li span {\n    font-size: 16px;\n    text-transform: unset;\n  }\n}\n.day-slot ul li span.slot-date {\n  display: block;\n  color: #757575;\n  font-size: 14px;\n}\n.day-slot ul li small.slot-year {\n  color: #757575;\n  font-size: 14px;\n}\n@media (max-width: 767.98px) {\n  .day-slot ul li small.slot-year {\n    display: none;\n  }\n}\n.day-slot ul li.left-arrow {\n  text-align: center;\n  width: 20px !important;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  position: absolute;\n  top: 50%;\n  left: 0;\n  padding: 0;\n}\n@media (max-width: 991.98px) {\n  .day-slot ul li.left-arrow {\n    left: -10px;\n  }\n}\n.day-slot ul li.right-arrow {\n  text-align: center;\n  width: 20px !important;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  position: absolute;\n  top: 50%;\n  right: -11px;\n  padding: 0;\n}\n\n.schedule-cont {\n  padding: 20px;\n}\n\n.time-slot ul {\n  list-style: none;\n  margin: auto -5px 0 -5px;\n  padding: 0;\n}\n.time-slot ul li {\n  float: left;\n  padding-left: 5px;\n  padding-right: 5px;\n  width: 14.28%;\n}\n.time-slot ul li .timing {\n  background-color: #e9e9e9;\n  border: 1px solid #e9e9e9;\n  border-radius: 3px;\n  color: #757575;\n  display: block;\n  font-size: 14px;\n  margin-bottom: 10px;\n  padding: 5px 5px;\n  text-align: center;\n  position: relative;\n}\n.time-slot ul li .timing:hover {\n  background-color: #ffffff;\n}\n.time-slot ul li .timing:last-child {\n  margin-bottom: 0;\n}\n.time-slot ul li .timing.selected {\n  background-color: #42c0fb;\n  border: 1px solid #42c0fb;\n  color: #ffffff;\n}\n.time-slot ul li .timing.selected::before {\n  color: #ffffff;\n  content: \"\\f00c\";\n  font-family: \"Font Awesome 5 Free\";\n  font-size: 12px;\n  font-weight: 900;\n  position: absolute;\n  top: 6px;\n  right: 6px;\n}\n@media (max-width: 991.98px) {\n  .time-slot ul li .timing.selected::before {\n    display: none;\n  }\n}\n\n.schedule-list {\n  border-bottom: 1px solid #cfcfcf;\n  margin-bottom: 50px;\n  padding-bottom: 50px;\n}\n.schedule-list:last-child {\n  border-bottom: 0;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.submit-section.proceed-btn {\n  margin: 0 0 30px;\n}\n@media (max-width: 767.98px) {\n  .submit-section.proceed-btn {\n    margin-bottom: 20px;\n  }\n}\n\n.tab-content.schedule-cont .card-title {\n  margin-bottom: 10px;\n}\n\n.doc-slot-list {\n  background-color: #d9534f;\n  border: 1px solid #d43f3a;\n  color: #ffffff;\n  font-size: 14px;\n  margin: 10px 10px 0 0;\n  padding: 6px 15px;\n  border-radius: 4px;\n}\n.doc-slot-list a {\n  color: #e48784;\n  display: inline-block;\n  margin-left: 5px;\n}\n.doc-slot-list a:hover {\n  color: #ffffff;\n}\n\n.schedule-nav .nav-tabs {\n  border: 0 !important;\n}\n.schedule-nav .nav-tabs li {\n  display: inline-block;\n  margin: 5px 15px 5px 0;\n}\n@media (max-width: 479.98px) {\n  .schedule-nav .nav-tabs li {\n    display: block;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    margin-right: 0;\n  }\n}\n.schedule-nav .nav-tabs li:last-child {\n  margin-right: 0;\n}\n.schedule-nav .nav-tabs li a.active {\n  background: #ff4877;\n  border: 1px solid #ff4877 !important;\n  color: #ffffff;\n}\n.schedule-nav .nav-tabs > li > a {\n  border: 1px solid #dcddea;\n  text-transform: uppercase;\n  border-radius: 4px;\n  padding: 6px 15px;\n}\n\n.hours-info .form-control {\n  min-height: auto;\n}\n.hours-info .btn.btn-danger.trash {\n  height: 38px;\n  width: 100%;\n}\n\n.add-more a {\n  color: #20c0f3;\n}\n\n.edit-link {\n  color: #20c0f3;\n  font-size: 16px;\n  margin-top: 4px;\n}\n@media (max-width: 575.98px) {\n  .edit-link {\n    font-size: 14px;\n    margin-top: 2px;\n  }\n}\n\n.submit-section .submit-btn {\n  padding: 12px 30px;\n  font-weight: 600;\n  font-size: 16px;\n  min-width: 120px;\n}\n@media (max-width: 767.98px) {\n  .submit-section .submit-btn {\n    padding: 10px 20px;\n    font-size: 15px;\n    min-width: 105px;\n  }\n}\n\n.success-card .card-body {\n  padding: 50px 20px;\n}\n\n.success-cont {\n  text-align: center;\n}\n.success-cont i {\n  color: #ffffff;\n  width: 60px;\n  height: 60px;\n  border: 2px solid #09e5ab;\n  font-size: 30px;\n  margin-bottom: 30px;\n  background-color: #09e5ab;\n  border-radius: 50%;\n}\n.success-cont h3 {\n  font-size: 24px;\n}\n@media (max-width: 767.98px) {\n  .success-cont h3 {\n    font-size: 22px;\n  }\n}\n.success-cont p {\n  margin-bottom: 30px;\n}\n.success-cont strong {\n  font-weight: 700;\n}\n\n@media (max-width: 575.98px) {\n  .booking-schedule.schedule-widget {\n    overflow-x: auto;\n  }\n}\n@media (max-width: 575.98px) {\n  .booking-schedule.schedule-widget > div {\n    width: 730px;\n  }\n}\n@media (max-width: 575.98px) {\n  .booking-schedule .day-slot ul {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n}\n@media (max-width: 575.98px) {\n  .booking-schedule .day-slot ul li {\n    -ms-flex: 0 0 100px;\n    flex: 0 0 100px;\n    width: 100px;\n  }\n}\n@media (max-width: 575.98px) {\n  .booking-schedule .day-slot ul li.right-arrow {\n    right: -20px;\n  }\n}\n@media (max-width: 575.98px) {\n  .booking-schedule .time-slot ul {\n    display: flex;\n  }\n}\n@media (max-width: 575.98px) {\n  .booking-schedule .time-slot ul li {\n    -ms-flex: 0 0 100px;\n    flex: 0 0 100px;\n    width: 100px;\n  }\n}\n@media (max-width: 767.98px) {\n  .booking-schedule .time-slot ul li .timing span {\n    display: block;\n  }\n}\n@media (max-width: 575.98px) {\n  .booking-schedule .time-slot ul li .timing span {\n    display: inline-block;\n  }\n}\n\n.visits .visit-btns {\n  color: #272b41;\n  background-color: #ffffff;\n  width: 80%;\n  margin-bottom: 10px;\n  display: block;\n  outline: unset;\n  cursor: pointer;\n}\n.visits input:checked ~ .visit-rsn {\n  background-color: #09e5ab;\n  color: #ffffff;\n  border-radius: 4px;\n}\n.visits input:checked ~ .visit-rsn:before {\n  opacity: 1;\n}\n.visits input:disabled ~ .visit-rsn {\n  background-color: #e30303;\n  color: #ffffff;\n  border-radius: 5px;\n}\n.visits input.form-check-input {\n  opacity: 0;\n  visibility: hidden;\n  margin-left: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.visits .form-check-input {\n  opacity: 0;\n}\n.visits span.visit-rsn {\n  background: #f3f9ff;\n  border: 0;\n  border-radius: 5px;\n  color: #64627c;\n  display: inline-block;\n  font-size: 14px;\n  margin-bottom: 0px;\n  text-align: center;\n  position: relative;\n  font-weight: 600;\n  min-width: 133px;\n  width: 100%;\n  padding: 13px 5px;\n}\n.visits span.visit-rsn:before {\n  color: #09e5ab;\n  background-color: #ffffff;\n  content: \"\\f00c\";\n  font-family: \"Font Awesome 5 Free\";\n  font-size: 10px;\n  font-weight: 900;\n  border-radius: 50px;\n  width: 18px;\n  height: 18px;\n  opacity: 0;\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n}\n\n.back-link {\n  padding-bottom: 30px;\n}\n.back-link a {\n  font-size: 15px;\n  color: #959595;\n}\n.back-link a:hover {\n  color: #09e5ab;\n}\n.back-link a i {\n  margin-right: 10px;\n}\n@media (max-width: 767.98px) {\n  .back-link {\n    padding-bottom: 25px;\n  }\n}\n\n.booking-header {\n  padding-bottom: 25px;\n}\n.booking-header .booking-title {\n  font-weight: 500;\n  font-size: 18px;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .booking-header {\n    padding-bottom: 20px;\n  }\n}\n\n.booking-date.choose-date-book {\n  padding-bottom: 30px;\n}\n.booking-date.choose-date-book p {\n  color: #8c8c8c;\n  margin: 0 10px 0 0;\n  padding: 0;\n  margin-right: 10px;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .booking-date.choose-date-book p {\n    margin: 0 0 10px 0;\n    padding: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .booking-date.choose-date-book {\n    display: block;\n    padding-bottom: 20px;\n  }\n}\n\n.booking-date-slider {\n  padding-bottom: 30px;\n}\n\n.booking-range .btn {\n  background: #ffffff;\n  border: 1px solid #e4e4e8;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: normal;\n  color: #4a4a4a;\n  margin: 0;\n  padding: 10px 15px;\n}\n@media (max-width: 767.98px) {\n  .booking-range .btn {\n    font-size: 13px;\n    margin: 0;\n    padding: 10px;\n    position: relative;\n  }\n}\n.booking-range img {\n  margin-right: 10px;\n}\n.booking-range i {\n  font-size: 16px;\n  margin-left: 10px;\n  color: #5b5b5b;\n}\n\n.booking-device-img {\n  margin-right: 15px;\n}\n.booking-device-img img {\n  max-width: inherit;\n}\n\n.booking-doctor-info h3 {\n  font-weight: 500;\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n.booking-doctor-info .device-text {\n  margin-bottom: 12px;\n}\n.booking-doctor-info .btn {\n  font-weight: 500;\n  font-size: 14px;\n  margin: 0;\n  padding: 4px 10px;\n  min-width: 109px;\n  color: #0e82fd;\n  background: #ffffff;\n  border: 2px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  border-radius: 6px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.booking-doctor-info .btn:hover {\n  color: #ffffff;\n  background: #0e82fd;\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  border: 2px solid #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n\n.time-slot.time-slot-blk {\n  text-align: center;\n}\n.time-slot.time-slot-blk h4 {\n  font-weight: 500;\n  font-size: 16px;\n  margin-bottom: 20px;\n}\n.time-slot.time-slot-blk ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.time-slot.time-slot-blk ul li {\n  display: block;\n  margin-bottom: 15px;\n  float: inherit;\n  width: 100%;\n}\n.time-slot.time-slot-blk li:last-child {\n  margin-bottom: 0;\n}\n.time-slot.time-slot-blk li .timing {\n  background: #f5f5f5;\n  border: 2px solid #f3f3f3;\n  border-radius: 8px;\n  color: #595959;\n  margin: 0;\n  padding: 10px 15px;\n  text-align: center;\n  position: relative;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.time-slot.time-slot-blk li .timing:hover {\n  background: #ffffff;\n  box-shadow: inset 0 0 0 50px #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.time-slot.time-slot-blk li .timing.active {\n  background: #0e82fd;\n  border: 2px solid #0e82fd;\n  color: #ffffff;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n}\n.time-slot.time-slot-blk li .timing.active:hover {\n  background: #0e82fd;\n  border: 2px solid #0e82fd;\n  color: #ffffff;\n  box-shadow: inset 0 0 0 50px #0e82fd;\n}\n.time-slot.time-slot-blk li .timing i {\n  margin-right: 4px;\n}\n.time-slot.time-slot-blk li .load-more-timings a {\n  font-weight: 500;\n  text-decoration: underline;\n  color: #0e82fd;\n}\n.time-slot.time-slot-blk li .load-more-timings a:hover {\n  color: #000000;\n}\n.time-slot.time-slot-blk .time-slot-open {\n  display: none;\n}\n@media (max-width: 991.98px) {\n  .time-slot.time-slot-blk {\n    padding-bottom: 15px;\n  }\n}\n\n.date-slider {\n  text-align: center;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.date-slider .slick-slide {\n  display: block;\n  margin: 0;\n  padding: 0 5px;\n}\n.date-slider li h4 {\n  font-weight: 500;\n  font-size: 16px;\n  color: #b9b9b9;\n  margin-bottom: 5px;\n}\n@media (max-width: 1199.98px) {\n  .date-slider li h4 {\n    font-size: 13px;\n  }\n}\n@media (max-width: 991.98px) {\n  .date-slider li h4 {\n    font-size: 16px;\n  }\n}\n.date-slider li p {\n  color: #d4d4d4;\n  margin-bottom: 0;\n}\n.date-slider li.active h4 {\n  color: #000000;\n}\n.date-slider li.active p {\n  color: #aaaaaa;\n}\n.date-slider .slick-prev:before {\n  content: \" \\e92f\";\n}\n.date-slider .slick-next:before {\n  content: \" \\e930\";\n}\n\n.date-slider .slick-prev,\n.date-slider .slick-next {\n  background: transparent;\n  color: #000000;\n  line-height: normal;\n  box-shadow: none;\n  width: 30px;\n  height: 30px;\n}\n\n.date-slider .slick-prev:hover,\n.date-slider .slick-prev:focus,\n.date-slider .slick-next:hover,\n.date-slider .slick-next:focus {\n  background-color: transparent;\n  color: #09e5ab;\n  opacity: 1;\n}\n\n.date-slider .slick-prev:hover:before,\n.date-slider .slick-prev:focus:before,\n.date-slider .slick-next:hover:before,\n.date-slider .slick-next:focus:before {\n  color: #09e5ab;\n}\n\n.date-slider .slick-prev:before,\n.date-slider .slick-next:before {\n  font-family: \"feather\";\n  font-size: 26px;\n}\n\n.date-slider .slick-prev {\n  left: -12px;\n}\n\n.date-slider .slick-next {\n  right: -12px;\n}\n\n.content.content-space {\n  padding: 80px 0px;\n}\n@media (max-width: 991.98px) {\n  .content.content-space {\n    padding: 50px 0px;\n  }\n}\n\n.prime-btn {\n  background-color: #0e82fd;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #ffffff;\n}\n.prime-btn:hover {\n  color: #0e82fd;\n  background-color: #ffffff;\n  border-color: #0e82fd;\n  box-shadow: inset 0 0 0 50px #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.prime-btn:hover i {\n  color: #0e82fd;\n}\n\n.attachment-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  background: #ffffff;\n  border: 1px solid #e4e4e8;\n  border-radius: 8px;\n  padding: 6px 15px;\n}\n\n.attachment-img {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.attachment-icon {\n  font-size: 24px;\n  color: #9d9d9d;\n  margin-right: 12px;\n}\n\n.attachment-content p {\n  color: #54595e;\n  margin-bottom: 0;\n}\n.attachment-content span {\n  font-size: 12px;\n  color: #54595e;\n}\n\n.attachment-close a {\n  font-size: 22px;\n  color: #abb5be;\n}\n.attachment-close a:hover {\n  color: #0e82fd;\n}\n\n.paitent-appointment .form-group {\n  margin-bottom: 25px;\n}\n.paitent-appointment .form-group .form-group-title {\n  font-weight: 500;\n  margin-bottom: 10px;\n  display: block;\n}\n.paitent-appointment .form-group .form-group-title i {\n  font-size: 16px;\n}\n.paitent-appointment .form-group .form-group-title span {\n  font-weight: 400;\n  font-size: 12px;\n  color: #a3a3a3;\n}\n.paitent-appointment .form-group .custom_radio {\n  margin-bottom: 0;\n  padding-left: 25px;\n}\n.paitent-appointment .form-control::placeholder {\n  font-weight: 500;\n  color: #9e9e9e;\n}\n.paitent-appointment textarea.form-control {\n  resize: none;\n  min-height: 100px;\n}\n.paitent-appointment .characters-text {\n  font-size: 12px;\n  color: #9e9e9e;\n  text-align: right;\n  margin-top: 8px;\n  margin-bottom: 0;\n}\n\n.form-group-flex .btn {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  font-size: 14px;\n  color: #292929;\n  padding: 3px 5px;\n  margin-bottom: 10px;\n  min-width: 60px;\n  background: #e0efff;\n  border: 1px solid #e0efff;\n  border-radius: 4px;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  -webkit-transition: 0.7s;\n  -moz-transition: 0.7s;\n  -o-transition: 0.7s;\n  transition: 0.7s;\n}\n.form-group-flex .btn:hover {\n  color: #ffffff;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  -webkit-transition: 0.7s;\n  -moz-transition: 0.7s;\n  -o-transition: 0.7s;\n  transition: 0.7s;\n}\n.form-group-flex .btn i {\n  font-size: 16px;\n  margin-right: 2px;\n}\n\n.widget-profile {\n  background-color: #ffffff;\n  border-bottom: 1px solid #f0f0f0;\n}\n.widget-profile .profile-info-widget {\n  display: block !important;\n  text-align: center !important;\n}\n.widget-profile .profile-info-widget .booking-doc-img {\n  display: inline-block;\n  width: auto;\n  background-color: #f7f7f7;\n  margin: 0 0 15px !important;\n  padding: 8px;\n  border-radius: 50%;\n}\n.widget-profile .profile-info-widget .booking-doc-img img {\n  height: 120px !important;\n  width: 120px !important;\n  border-radius: 50% !important;\n}\n.widget-profile.pat-widget-profile .profile-info-widget .booking-doc-img {\n  padding: 0;\n}\n.widget-profile.pat-widget-profile .profile-info-widget .booking-doc-img img {\n  height: 100px !important;\n  width: 100px !important;\n  border-radius: 50%;\n}\n\n.appointment-list .profile-info-widget {\n  margin-right: auto;\n  text-align: left;\n}\n@media (max-width: 479.98px) {\n  .appointment-list .profile-info-widget {\n    text-align: center;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n}\n@media (max-width: 479.98px) {\n  .appointment-list .profile-info-widget .booking-doc-img {\n    margin: 0 0 15px;\n  }\n}\n.appointment-list .profile-info-widget .booking-doc-img img {\n  height: 120px;\n  object-fit: cover;\n  width: 120px;\n  border-radius: 4px;\n}\n@media (max-width: 479.98px) {\n  .appointment-list .profile-info-widget .booking-doc-img img {\n    height: 100px;\n    width: 100px;\n    border-radius: 50%;\n  }\n}\n@media (max-width: 479.98px) {\n  .appointment-list .profile-det-info {\n    margin-bottom: 15px;\n  }\n}\n\n.appointments .appointment-list {\n  background-color: #ffffff;\n  border: 1px solid #f0f0f0;\n  margin: 0 0 20px;\n  padding: 20px;\n  border-radius: 4px;\n}\n.appointments .appointment-list:last-child {\n  margin-bottom: 30px;\n}\n@media (max-width: 991.98px) {\n  .appointments .appointment-list {\n    display: block;\n  }\n}\n@media (max-width: 479.98px) {\n  .appointments .appointment-list {\n    text-align: center;\n  }\n}\n@media (max-width: 479.98px) {\n  .appointments .appointment-list .profile-det-info {\n    margin-bottom: 15px;\n  }\n}\n@media (max-width: 991.98px) {\n  .appointments .appointment-action {\n    margin-top: 10px;\n  }\n}\n@media (max-width: 479.98px) {\n  .appointments .appointment-action {\n    margin-top: 0;\n  }\n}\n.appointments .appointment-action a {\n  font-size: 13px;\n}\n.appointments .appointment-action a + a {\n  margin-left: 5px;\n}\n\n.info-details {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.info-details li {\n  margin-bottom: 10px;\n}\n.info-details li:last-child {\n  margin-bottom: 0;\n}\n.info-details li .title {\n  color: #272b41;\n  font-weight: 500;\n}\n.info-details li .text {\n  color: #757575;\n  display: block;\n  font-size: 16px;\n  overflow: hidden;\n}\n\n.clinic-direction {\n  color: #757575;\n  font-size: 14px;\n  margin-bottom: 25px;\n}\n.clinic-direction a {\n  color: #09e5ab;\n  font-weight: 500;\n}\n\n.doctor-action {\n  margin-bottom: 15px;\n}\n@media (max-width: 767.98px) {\n  .doctor-action {\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n  }\n}\n.doctor-action a + a {\n  margin-left: 8px;\n}\n.doctor-action .fav-btn:hover {\n  background-color: #fb1612;\n  border-color: #fb1612;\n  color: #ffffff;\n}\n\n.msg-btn:hover,\n.msg-btn:focus {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n  color: #ffffff;\n}\n\ncall-btn:hover,\ncall-btn:focus {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n  color: #ffffff;\n}\n\n@media (max-width: 767.98px) {\n  .user-tabs {\n    margin-top: 1.5rem;\n  }\n}\n@media (max-width: 767.98px) {\n  .user-tabs .nav-tabs {\n    border-bottom: 0;\n    position: relative;\n    background-color: #ffffff;\n    padding: 5px 0;\n    border: 1px solid #dddddd;\n    border-radius: 3px;\n  }\n}\n.user-tabs .nav-tabs > li > a {\n  border: 0;\n  border-bottom: 3px solid transparent;\n  color: #3e3e3e;\n  font-weight: 700;\n  padding: 20px;\n}\n.user-tabs .nav-tabs > li > a:hover {\n  background-color: unset;\n  color: #20c0f3;\n}\n@media (max-width: 767.98px) {\n  .user-tabs .nav-tabs > li > a {\n    border-left: 2px solid transparent;\n    border-bottom: 0;\n    padding: 0.5rem 1rem;\n  }\n}\n@media (max-width: 767.98px) {\n  .user-tabs .nav-tabs.nav-justified {\n    border-bottom: 1px solid #dddddd;\n  }\n}\n@media (max-width: 767.98px) {\n  .user-tabs .nav-tabs .nav-item {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n  }\n}\n@media (max-width: 479.98px) {\n  .user-tabs .nav-tabs .nav-item {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n  }\n}\n.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active,\n.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:hover,\n.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:focus {\n  border-bottom-width: 3px;\n  color: #20c0f3;\n}\n@media (max-width: 767.98px) {\n  .user-tabs .nav-tabs.nav-tabs-bottom > li > a.active,\n  .user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:hover,\n  .user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:focus {\n    border-left-width: 2px;\n    color: #20c0f3;\n  }\n}\n.user-tabs .med-records {\n  display: inline-block;\n  min-width: 130px;\n}\n@media (max-width: 575.98px) {\n  .user-tabs .med-records {\n    min-width: 110px;\n  }\n}\n\n.widget {\n  margin-bottom: 30px;\n}\n\n.widget-title {\n  margin-bottom: 15px;\n}\n\n.experience-box {\n  position: relative;\n}\n\n.experience-list {\n  list-style: none;\n  position: relative;\n  margin: 0;\n  padding: 0;\n}\n.experience-list::before {\n  background: #dddddd;\n  bottom: 0;\n  content: \"\";\n  width: 2px;\n  position: absolute;\n  top: 8px;\n  left: 8px;\n}\n.experience-list li {\n  position: relative;\n}\n.experience-list li:last-child .experience-content {\n  margin-bottom: 0;\n}\n.experience-list > li .experience-user {\n  background: #ffffff;\n  height: 10px;\n  width: 10px;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  margin: 0;\n  padding: 0;\n}\n.experience-list > li .experience-content {\n  background-color: #ffffff;\n  position: relative;\n  margin: 0 0 20px 40px;\n  padding: 0;\n}\n.experience-list > li .experience-content .timeline-content {\n  color: #757575;\n}\n.experience-list > li .experience-content .timeline-content a.name {\n  font-weight: 500;\n}\n.experience-list > li .time {\n  color: #757575;\n  display: block;\n  font-size: 13px;\n}\n\n.experience-user .avatar {\n  height: 32px;\n  line-height: 32px;\n  width: 32px;\n  margin: 0;\n}\n\n.before-circle {\n  background-color: rgba(32, 192, 243, 0.2);\n  height: 12px;\n  width: 12px;\n  border: 2px solid #20c0f3;\n  border-radius: 50%;\n}\n\n.exp-year {\n  color: #20c0f3;\n  margin-bottom: 2px;\n}\n\n.exp-title {\n  font-size: 16px;\n}\n@media (max-width: 767.98px) {\n  .exp-title {\n    font-size: 14px;\n  }\n}\n\n.awards-widget .experience-list > li:last-child p {\n  margin-bottom: 0;\n}\n\n.service-list {\n  margin-bottom: 30px;\n}\n.service-list:last-child {\n  border-bottom: 0;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n.service-list ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.service-list ul li {\n  float: left;\n  padding-left: 25px;\n  position: relative;\n  width: 33%;\n  margin: 6px 0;\n}\n@media (max-width: 767.98px) {\n  .service-list ul li {\n    width: 50%;\n  }\n}\n@media (max-width: 575.98px) {\n  .service-list ul li {\n    width: 100%;\n  }\n}\n.service-list ul li::before {\n  color: #cccccc;\n  content: \"\\f30b\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n  position: absolute;\n  left: 0;\n}\n\n.location-list {\n  border: 1px solid #f0f0f0;\n  border-radius: 4px;\n  padding: 20px;\n}\n.location-list + .location-list {\n  margin-top: 20px;\n}\n.location-list .consult-price {\n  font-size: 20px;\n  font-weight: 500;\n  color: #272b41;\n}\n\n.clinic-content .clinic-name {\n  font-size: 18px;\n  font-weight: 500;\n  margin-bottom: 3px;\n}\n.clinic-content .clinic-direction a {\n  display: inline-block;\n  margin-top: 8px;\n}\n\n.timings-days {\n  font-weight: 700;\n  color: #272b41;\n  margin-bottom: 5px;\n}\n\n.timings-times span {\n  display: block;\n}\n.timings-times span:last-child {\n  margin-bottom: 1rem;\n}\n\n.review-listing {\n  border-bottom: 1px solid #f5f7fc;\n  margin-top: 20px;\n  padding-bottom: 30px;\n}\n.review-listing > ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.review-listing > ul li + li {\n  margin-top: 20px;\n  border-top: 1px dashed #f0f0f0;\n  padding-top: 20px;\n}\n.review-listing > ul li .comment {\n  margin-bottom: 30px;\n}\n.review-listing > ul li .comment:last-child {\n  margin-bottom: 0;\n}\n.review-listing > ul li .comment .comment-body {\n  margin-left: 16px;\n}\n.review-listing > ul li .comment .comment-body .meta-data {\n  position: relative;\n  margin-bottom: 10px;\n}\n.review-listing > ul li .comment .comment-body .meta-data span {\n  display: block;\n  font-size: 16px;\n  color: #757575;\n}\n.review-listing > ul li .comment .comment-body .meta-data span.comment-author {\n  font-weight: 600;\n  color: #272b41;\n  text-transform: capitalize;\n}\n.review-listing > ul li .comment .comment-body .meta-data span.comment-date {\n  font-size: 14px;\n}\n@media (max-width: 767.98px) {\n  .review-listing > ul li .comment .comment-body .meta-data span.comment-date {\n    margin-bottom: 5px;\n  }\n}\n.review-listing > ul li .comment .comment-body .meta-data .review-count {\n  width: auto;\n  position: absolute;\n  top: 3px;\n  right: 0;\n}\n@media (max-width: 767.98px) {\n  .review-listing > ul li .comment .comment-body .meta-data .review-count {\n    position: unset;\n  }\n}\n.review-listing > ul li .comment .comment-body .comment-content {\n  color: #757575;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  font-size: 14px;\n}\n.review-listing > ul li .comment .comment-body .comment-reply .comment-btn {\n  color: #20c0f3;\n  display: inline-block;\n  font-weight: 500;\n  font-size: 15px;\n}\n.review-listing > ul li .comments-reply {\n  list-style: none;\n  margin-left: 65px;\n  padding: 0;\n}\n@media (max-width: 479.98px) {\n  .review-listing > ul li .comments-reply {\n    margin-left: 0;\n  }\n}\n.review-listing .recommend-btn {\n  float: right;\n  color: #757575;\n  font-size: 14px;\n  padding: 5px 0;\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .review-listing .recommend-btn {\n    float: none;\n  }\n}\n.review-listing .recommend-btn a {\n  border: 1px solid rgba(128, 137, 150, 0.4);\n  display: inline-block;\n  color: #757575;\n  -webkit-transition: all 0.3s;\n  -ms-transition: all 0.3s;\n  transition: all 0.3s;\n  border-radius: 4px;\n  margin: 0 3px;\n  padding: 4px 12px;\n}\n.review-listing .recommend-btn a.like-btn:hover {\n  background-color: #28a745;\n  border: 1px solid #28a745;\n  color: #ffffff;\n}\n.review-listing .recommend-btn a.dislike-btn:hover {\n  background-color: #dc3545;\n  border: 1px solid #dc3545;\n  color: #ffffff;\n}\n.review-listing .recommend-btn a i {\n  font-size: 16px;\n}\n@media (max-width: 479.98px) {\n  .review-listing .recommend-btn span {\n    display: block;\n    margin-bottom: 10px;\n  }\n}\n\n.recommended {\n  color: #28a745;\n  font-size: 15px;\n  font-weight: 500;\n  margin: 0;\n}\n\n.all-feedback {\n  margin-top: 20px;\n}\n\n.star-rating {\n  direction: rtl;\n}\n.star-rating input[type=\"radio\"] {\n  display: none;\n}\n.star-rating input[type=\"radio\"]:checked ~ label {\n  color: #f2b600;\n}\n.star-rating label {\n  color: #bbb;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0;\n  -webkit-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n.star-rating label:hover,\n.star-rating label:hover ~ label {\n  color: #f2b600;\n}\n\n.terms-accept a {\n  color: #20c0f3;\n  font-weight: 500;\n}\n\n.business-widget {\n  background-color: #fcfcfc;\n  border: 1px solid #f0f0f0;\n  margin-bottom: 0;\n  padding: 20px;\n}\n\n.listing-day {\n  color: #000000;\n  margin-bottom: 10px;\n}\n.listing-day:last-child {\n  margin-bottom: 0;\n}\n.listing-day.current {\n  border-bottom: 1px solid #dddddd;\n  padding-bottom: 13px;\n  margin-bottom: 13px;\n}\n.listing-day.current .day {\n  font-weight: 700;\n}\n.listing-day .day {\n  font-weight: 500;\n}\n.listing-day .day span {\n  display: block;\n  font-weight: normal;\n}\n\n.time-items {\n  color: #757575;\n}\n.time-items > span {\n  display: block;\n  text-align: right;\n}\n.time-items > span.open-status {\n  margin-bottom: 3px;\n}\n\n.dropzone .dz-preview.dz-error:hover .dz-error-message {\n  display: none;\n}\n\n.upload-wrap .upload-images + .upload-images {\n  margin-left: 20px;\n}\n\n.upload-images {\n  position: relative;\n  width: 80px;\n}\n.upload-images img {\n  height: 80px;\n  width: auto;\n  border-radius: 4px;\n}\n\n.contact-card .card-body {\n  padding-bottom: 0.625rem;\n}\n\n.custom_price_cont {\n  margin-top: 20px;\n}\n\n.btn.btn-danger.trash {\n  height: 46px;\n  width: 46px;\n}\n@media (max-width: 767.98px) {\n  .btn.btn-danger.trash {\n    margin-bottom: 20px;\n  }\n}\n\n.add-more a {\n  color: #20c0f3;\n}\n\n.bootstrap-tagsinput {\n  border-color: #dcdcdc;\n  box-shadow: inherit;\n  min-height: 46px;\n  width: 100%;\n  border-radius: 0;\n}\n.bootstrap-tagsinput.focus {\n  border-color: #bbb;\n}\n.bootstrap-tagsinput .tag {\n  background-color: #20c0f3;\n  color: #6b7280;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: normal;\n  margin-right: 2px;\n  border-radius: 0;\n  padding: 8px 15px;\n}\n\n.services-card .bootstrap-tagsinput input {\n  width: 160px;\n}\n\n.submit-section .submit-btn {\n  font-weight: 700;\n  font-size: 16px;\n  min-width: 120px;\n  padding: 12px 30px;\n}\n.submit-section .submit-btn + .submit-btn {\n  margin-left: 15px;\n}\n@media (max-width: 767.98px) {\n  .submit-section .submit-btn {\n    font-size: 15px;\n    min-width: 105px;\n    padding: 10px 20px;\n  }\n}\n\n.profile-sidebar {\n  background-color: #ffffff;\n  border: 1px solid #f0f0f0;\n  margin-bottom: 30px;\n  overflow: hidden;\n  border-radius: 4px;\n}\n@media (max-width: 767.98px) {\n  .profile-sidebar {\n    margin-bottom: 20px !important;\n  }\n}\n.profile-sidebar .pro-widget-content {\n  border-bottom: 1px solid #f0f0f0;\n  margin: 0;\n  padding: 20px;\n  text-align: center;\n}\n.profile-sidebar .dashboard-menu ul {\n  color: #757575;\n  font-size: 14px;\n  line-height: 17px;\n  list-style: none;\n  text-transform: capitalize;\n  margin: 0;\n  padding: 0;\n}\n.profile-sidebar .dashboard-menu ul li {\n  line-height: inherit;\n}\n.profile-sidebar .dashboard-menu ul li a i {\n  font-size: 16px;\n  margin-right: 10px;\n  width: 16px;\n}\n.profile-sidebar .dashboard-menu ul li a span,\n.profile-sidebar .dashboard-menu ul li a i {\n  display: inline-block;\n  vertical-align: middle;\n}\n.profile-sidebar .dashboard-menu ul li .unread-msg {\n  background-color: #09e5ab;\n  color: #272b41;\n  font-size: 10px;\n  font-style: normal;\n  text-align: center;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  border-radius: 2px;\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  padding: 0 5px;\n}\n.profile-sidebar .dashboard-menu > ul > li {\n  border-bottom: 1px solid #f0f0f0;\n  position: relative;\n}\n.profile-sidebar .dashboard-menu > ul > li:last-child {\n  border-bottom: 0;\n}\n.profile-sidebar .dashboard-menu > ul > li a {\n  color: #757575;\n  display: block;\n  padding: 16px 20px;\n}\n.profile-sidebar .dashboard-menu > ul > li:hover > a {\n  color: #0de0fe;\n}\n.profile-sidebar .dashboard-menu > ul > li.active > a {\n  color: #0de0fe;\n}\n\n@media (max-width: 1199.98px) {\n  .dash-card .dash-widget {\n    -ms-flex-direction: column;\n    flex-direction: column;\n    text-align: center;\n  }\n}\n@media (max-width: 991.98px) {\n  .dash-card .dash-widget {\n    flex-direction: unset;\n    text-align: left;\n  }\n}\n.dash-card .dash-widget .circle-bar {\n  margin-right: 15px;\n}\n@media (max-width: 1199.98px) {\n  .dash-card .dash-widget .circle-bar {\n    margin: 0 0 15px;\n  }\n}\n@media (max-width: 991.98px) {\n  .dash-card .dash-widget .circle-bar {\n    margin: 0 15px 0 0;\n  }\n}\n.dash-card .dash-widget .circle-bar > div {\n  display: inline-block;\n  position: relative;\n  text-align: center;\n}\n.dash-card .dash-widget .circle-bar > div img {\n  text-align: center;\n  margin: 0 auto;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  position: absolute;\n  top: 50%;\n  right: 0;\n  left: 0;\n}\n.dash-card .dash-widget .circle-bar > div canvas {\n  width: 90px !important;\n  height: 90px !important;\n}\n.dash-card .dash-widget.dct-border-rht {\n  border-right: 1px solid #f0f0f0;\n}\n@media (max-width: 991.98px) {\n  .dash-card .dash-widget.dct-border-rht {\n    border-bottom: 1px solid #f0f0f0;\n    border-right: 0;\n    margin-bottom: 20px;\n    padding-bottom: 15px;\n  }\n}\n.dash-card .dash-widget h6 {\n  font-size: 16px;\n  font-weight: 400;\n}\n@media (max-width: 767.98px) {\n  .dash-card .dash-widget h6 {\n    font-size: 15px;\n  }\n}\n.dash-card .dash-widget h3 {\n  font-size: 24px;\n  margin-bottom: 5px;\n}\n@media (max-width: 767.98px) {\n  .dash-card .dash-widget h3 {\n    font-size: 20px;\n  }\n}\n.dash-card .dash-widget p {\n  color: #757575;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .dash-card .dash-widget p {\n    font-size: 13px;\n  }\n}\n.dash-card .row {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n.dash-card .row > div {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.appointment-tab {\n  margin-bottom: 30px;\n}\n@media (max-width: 767.98px) {\n  .appointment-tab {\n    margin-bottom: 20px;\n  }\n}\n.appointment-tab .nav-tabs {\n  background-color: #ffffff;\n  border: 1px solid #f0f0f0;\n  border-radius: 0.25rem 0.25rem 0 0 !important;\n  border-bottom: 0;\n  padding: 1.5rem;\n}\n@media (max-width: 767.98px) {\n  .appointment-tab .nav-tabs {\n    padding: 1.5rem;\n  }\n}\n.appointment-tab .tab-content {\n  padding-top: 0;\n}\n.appointment-tab .card {\n  border-radius: 0;\n}\n\n.profile-det-info {\n  overflow: hidden;\n}\n.profile-det-info h3 {\n  font-size: 17px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.profile-det-info .patient-details h5 {\n  color: #757575;\n  font-size: 13px;\n  font-weight: normal;\n  margin-bottom: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.profile-det-info .patient-details h5 i {\n  width: 18px;\n}\n\n.profile-info-widget {\n  text-align: left;\n}\n.profile-info-widget .booking-doc-img {\n  margin-right: 15px;\n}\n.profile-info-widget .booking-doc-img img {\n  height: 90px;\n  width: 90px;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n.change-avatar .profile-img {\n  margin-right: 15px;\n}\n.change-avatar .profile-img img {\n  height: 100px;\n  width: 100px;\n  object-fit: cover;\n  border-radius: 4px;\n}\n@media (max-width: 575.98px) {\n  .change-avatar .profile-img img {\n    height: 80px;\n    width: 80px;\n  }\n}\n.change-avatar .change-photo-btn {\n  margin: 0 0 10px;\n  width: 150px;\n}\n.change-avatar .change-photo-btn input.upload {\n  bottom: 0;\n  cursor: pointer;\n  filter: alpha(opacity=0);\n  opacity: 0;\n  width: 220px;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n}\n\n.dropzone {\n  background-color: #fbfbfb;\n  border: 2px dashed rgba(0, 0, 0, 0.1);\n}\n\n.profile-image img {\n  margin-bottom: 1.5rem;\n}\n\n.biller-info,\n.billing-info {\n  margin-bottom: 15px;\n}\n\n.add-more-item {\n  margin-bottom: 10px;\n}\n.add-more-item a {\n  color: #0de0fe;\n  font-weight: 500;\n}\n\n.signature-wrap {\n  float: right;\n  margin-bottom: 20px;\n  text-align: center;\n  width: 220px;\n}\n\n.signature {\n  border: 2px dashed #cccccc;\n  color: #272b41;\n  cursor: pointer;\n  height: 85px;\n  margin-bottom: 15px;\n  width: 100%;\n  border-radius: 4px;\n}\n.signature:hover {\n  background-color: #fcfcfc;\n}\n.signature .sign-name {\n  width: 100%;\n  float: right;\n}\n\n.pat-widget-profile .pro-widget-content {\n  padding: 0 0 20px;\n}\n.pat-widget-profile .booking-date li {\n  font-size: 14px;\n}\n.pat-widget-profile .booking-date li span {\n  font-size: 14px;\n}\n\n.add-new-btn {\n  background-color: #0de0fe;\n  color: #ffffff;\n  display: inline-block;\n  font-weight: 500;\n  margin: 0 0 20px;\n  padding: 10px 20px;\n  border-radius: 30px;\n}\n.add-new-btn:focus,\n.add-new-btn:hover,\n.add-new-btn.active {\n  background-color: #0de0fe;\n  color: #ffffff;\n}\n\n.patient-info {\n  margin-top: 15px;\n}\n.patient-info ul {\n  list-style: none;\n  font-size: 0.875rem;\n  margin: 0;\n  padding: 0;\n}\n.patient-info ul li {\n  position: relative;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #272b41;\n  text-transform: capitalize;\n}\n.patient-info ul li + li {\n  margin-top: 15px;\n}\n.patient-info ul li i {\n  width: 18px;\n}\n.patient-info ul li span {\n  color: #757575;\n  float: right;\n  font-weight: 400;\n}\n\n.profile-sidebar {\n  background-color: #ffffff;\n  border: 1px solid #f0f0f0;\n  margin-bottom: 30px;\n  overflow: hidden;\n  border-radius: 4px;\n}\n\n.pro-widget-content {\n  border-bottom: 1px solid #f0f0f0;\n  text-align: center;\n  padding: 20px;\n}\n\n.profile-info-widget {\n  text-align: left;\n}\n.profile-info-widget .booking-doc-img {\n  margin-right: 15px;\n}\n.profile-info-widget .booking-doc-img img {\n  height: 90px;\n  width: 90px;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n.profile-det-info {\n  overflow: hidden;\n}\n.profile-det-info h3 {\n  font-size: 17px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.patient-details h5 {\n  color: #757575;\n  font-size: 13px;\n  font-weight: normal;\n  margin-bottom: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.patient-details h5 i {\n  width: 18px;\n}\n\n.dashboard-menu ul {\n  color: #757575;\n  font-size: 14px;\n  line-height: 17px;\n  list-style: none;\n  text-transform: capitalize;\n  margin: 0;\n  padding: 0;\n}\n.dashboard-menu ul li {\n  line-height: inherit;\n}\n.dashboard-menu ul li a i {\n  font-size: 16px;\n  margin-right: 10px;\n  width: 16px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.dashboard-menu ul li a span {\n  display: inline-block;\n  vertical-align: middle;\n}\n.dashboard-menu > ul > li {\n  border-bottom: 1px solid #f0f0f0;\n  position: relative;\n}\n.dashboard-menu > ul > li :last-child {\n  border-bottom: 0;\n}\n.dashboard-menu > ul > li > a {\n  color: #757575;\n  display: block;\n  padding: 16px 20px;\n}\n.dashboard-menu > ul > li:hover > a,\n.dashboard-menu > ul > li.active > a {\n  color: #0de0fe;\n}\n\n.unread-msg {\n  background-color: #09e5ab;\n  color: #272b41;\n  font-size: 10px;\n  font-style: normal;\n  text-align: center;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  padding: 0 5px;\n  border-radius: 2px;\n}\n\n.patient-dashboard-top > div {\n  width: 100%;\n}\n.patient-dashboard-top h6 {\n  font-size: 18px;\n  margin-bottom: 0;\n}\n.patient-dashboard-top h6 sub {\n  font-size: 12px;\n}\n\n.patient-graph-col .graph-box {\n  background: #7289de;\n  border-bottom: 8px solid #6a5dee;\n  width: 100%;\n  margin: 15px 0;\n  padding: 22px;\n}\n.patient-graph-col .graph-box.pink-graph {\n  background-color: #ffa69e;\n  border-bottom: 8px solid #ffa69e;\n}\n.patient-graph-col .graph-box.sky-blue-graph {\n  background-color: #a9d4ff;\n  border-bottom: 8px solid #8ec4ff;\n}\n.patient-graph-col .graph-box.orange-graph {\n  background-color: #ffb88e;\n  border-bottom: 8px solid #ffb88e;\n}\n.patient-graph-col .graph-box h4 {\n  color: #ffffff;\n  margin-bottom: 15px;\n  text-align: center;\n}\n.patient-graph-col .graph-box > div {\n  width: 100%;\n}\n.patient-graph-col .graph-box .graph-img {\n  text-align: center;\n  margin: 0 auto;\n  width: 100%;\n}\n.patient-graph-col .graph-box .graph-status-result h3 {\n  color: #ffffff;\n  margin-bottom: 0;\n  line-height: 0.9;\n  width: 100%;\n}\n.patient-graph-col .graph-box .graph-status-result span.graph-update-date {\n  color: #ffffff;\n  font-weight: 500;\n  opacity: 0.7;\n  text-align: center;\n  width: 100%;\n}\n\n.chat-page .footer {\n  display: none;\n}\n\n.chat-window {\n  position: relative;\n}\n.chat-window .chat-cont-left {\n  border-right: 1px solid #f0f0f0;\n  -ms-flex: 0 0 35%;\n  flex: 0 0 35%;\n  max-width: 35%;\n  z-index: 4;\n  position: relative;\n  left: 0;\n}\n@media (max-width: 1199.98px) {\n  .chat-window .chat-cont-left {\n    -ms-flex: 0 0 40%;\n    flex: 0 0 40%;\n    max-width: 40%;\n  }\n}\n@media (max-width: 991.98px) {\n  .chat-window .chat-cont-left {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n    transition:\n      left 0.3s ease-in-out 0s,\n      right 0.3s ease-in-out 0s;\n    width: 100%;\n    border-right: 0;\n  }\n}\n@media (max-width: 479.98px) {\n  .chat-window .chat-cont-left a.media .media-body > div:first-child .user-name,\n  .chat-window .chat-cont-left a.media .media-body > div:first-child .user-last-chat {\n    max-width: 160px;\n  }\n}\n.chat-window .chat-cont-left .chat-header {\n  background-color: #ffffff;\n  border-bottom: 1px solid #f0f0f0;\n  color: #272b41;\n  height: 72px;\n  padding: 0 15px;\n}\n.chat-window .chat-cont-left .chat-header span {\n  font-size: 20px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n.chat-window .chat-cont-left .chat-header .chat-compose {\n  color: #8a8a8a;\n}\n.chat-window .chat-cont-left .chat-search {\n  background-color: #f5f5f6;\n  border-bottom: 1px solid #f3f3f3;\n  padding: 10px 15px;\n  width: 100%;\n}\n.chat-window .chat-cont-left .chat-search .input-group {\n  width: 100%;\n}\n.chat-window .chat-cont-left .chat-search .input-group .form-control {\n  background-color: #ffffff;\n  padding-left: 36px;\n  border-radius: 50px;\n}\n.chat-window .chat-cont-left .chat-search .input-group .form-control:focus {\n  border-color: #cccccc;\n  box-shadow: none;\n}\n.chat-window .chat-cont-left .chat-search .input-group .form-control::placeholder {\n  font-size: 14px;\n}\n.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend {\n  color: #666;\n  pointer-events: none;\n  z-index: 4;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 15px;\n}\n.chat-window .chat-cont-left .chat-users-list {\n  background-color: #ffffff;\n}\n.chat-window .chat-cont-left .chat-users-list a.media {\n  border-bottom: 1px solid #f0f0f0;\n  padding: 10px 15px;\n  -webkit-transition: all 0.2s ease 0s;\n  -ms-transition: all 0.2s ease 0s;\n  transition: all 0.2s ease 0s;\n}\n.chat-window .chat-cont-left .chat-users-list a.media:last-child {\n  border-bottom: 0;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap {\n  margin-right: 15px;\n  position: relative;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap .avatar {\n  height: 45px;\n  width: 45px;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap .status {\n  height: 10px;\n  width: 10px;\n  border: 2px solid #ffffff;\n  position: absolute;\n  right: 4px;\n  bottom: 7px;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #272b41;\n  text-transform: capitalize;\n}\n@media (max-width: 1399.98px) {\n  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {\n    max-width: 180px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {\n    max-width: 150px;\n  }\n}\n@media (max-width: 767.98px) {\n  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {\n    max-width: 250px;\n  }\n}\n@media (max-width: 479.98px) {\n  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {\n    max-width: 160px;\n  }\n}\n.chat-window\n  .chat-cont-left\n  .chat-users-list\n  a.media\n  .media-body\n  > div:first-child\n  .user-last-chat {\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #8a8a8a;\n  font-size: 14px;\n  line-height: 24px;\n}\n@media (max-width: 1399.98px) {\n  .chat-window\n    .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-last-chat {\n    max-width: 180px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .chat-window\n    .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-last-chat {\n    max-width: 150px;\n  }\n}\n@media (max-width: 767.98px) {\n  .chat-window\n    .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-last-chat {\n    max-width: 250px;\n  }\n}\n@media (max-width: 479.98px) {\n  .chat-window\n    .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-last-chat {\n    max-width: 160px;\n  }\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:last-child {\n  text-align: right;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:last-child .last-chat-time {\n  color: #8a8a8a;\n  font-size: 13px;\n}\n.chat-window .chat-cont-left .chat-users-list a.media:hover {\n  background-color: #f5f5f6;\n}\n.chat-window\n  .chat-cont-left\n  .chat-users-list\n  a.media.read-chat\n  .media-body\n  > div:last-child\n  .last-chat-time {\n  color: #8a8a8a;\n}\n.chat-window .chat-cont-left .chat-users-list a.media.active {\n  background-color: #f5f5f6;\n}\n.chat-window .chat-scroll {\n  min-height: 300px;\n  max-height: calc(100vh - 224px);\n  overflow-y: auto;\n}\n.chat-window .chat-cont-right {\n  -ms-flex: 0 0 65%;\n  flex: 0 0 65%;\n  max-width: 65%;\n}\n@media (max-width: 1199.98px) {\n  .chat-window .chat-cont-right {\n    -ms-flex: 0 0 60%;\n    flex: 0 0 60%;\n    max-width: 60%;\n  }\n}\n@media (max-width: 991.98px) {\n  .chat-window .chat-cont-right {\n    opacity: 0;\n    visibility: hidden;\n    position: absolute;\n    top: 0;\n    right: -100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n    transition:\n      left 0.3s ease-in-out 0s,\n      right 0.3s ease-in-out 0s;\n    width: 100%;\n  }\n}\n.chat-window .chat-cont-right .chat-header {\n  background-color: #ffffff;\n  border-bottom: 1px solid #f0f0f0;\n  height: 72px;\n  padding: 0 15px;\n}\n@media (max-width: 991.98px) {\n  .chat-window .chat-cont-right .chat-header {\n    justify-content: start;\n    -webkit-justify-content: start;\n    -ms-flex-pack: start;\n  }\n}\n.chat-window .chat-cont-right .chat-header .back-user-list {\n  display: none;\n  margin-right: 5px;\n  margin-left: -7px;\n}\n@media (max-width: 991.98px) {\n  .chat-window .chat-cont-right .chat-header .back-user-list {\n    display: block;\n  }\n}\n.chat-window .chat-cont-right .chat-header .media .media-img-wrap {\n  position: relative;\n  margin-right: 15px;\n}\n.chat-window .chat-cont-right .chat-header .media .media-img-wrap .avatar {\n  height: 50px;\n  width: 50px;\n}\n.chat-window .chat-cont-right .chat-header .media .media-img-wrap .status {\n  border: 2px solid #ffffff;\n  height: 10px;\n  width: 10px;\n  position: absolute;\n  right: 3px;\n  bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .chat-window .chat-cont-right .chat-header .media .media-body {\n    display: none;\n  }\n}\n.chat-window .chat-cont-right .chat-header .media .media-body .user-name {\n  color: #272b41;\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n.chat-window .chat-cont-right .chat-header .media .media-body .user-status {\n  color: #666;\n  font-size: 14px;\n}\n@media (max-width: 991.98px) {\n  .chat-window .chat-cont-right .chat-header .chat-options {\n    margin-left: auto;\n  }\n}\n.chat-window .chat-cont-right .chat-header .chat-options > a {\n  border-radius: 50%;\n  height: 30px;\n  color: #8a8a8a;\n  margin-left: 10px;\n  width: 30px;\n}\n.chat-window .chat-cont-right .chat-body {\n  background-color: #f5f5f6;\n}\n.chat-window .chat-cont-right .chat-body ul.list-unstyled {\n  width: 100%;\n  margin: 0 auto;\n  padding: 15px;\n}\n.chat-window .chat-cont-right .chat-body .media .avatar {\n  height: 30px;\n  width: 30px;\n}\n.chat-window .chat-cont-right .chat-body .media .media-body {\n  margin-left: 20px;\n}\n.chat-window .chat-cont-right .chat-body .media .media-body .msg-box > div {\n  display: inline-block;\n  position: relative;\n  border-radius: 0.25rem;\n  padding: 10px 15px;\n}\n.chat-window .chat-cont-right .chat-body .media .media-body .msg-box > div p {\n  color: #272b41;\n  margin-bottom: 0;\n}\n.chat-window .chat-cont-right .chat-body .media .media-body .msg-box + .msg-box {\n  margin-top: 5px;\n}\n.chat-window .chat-cont-right .chat-body .media.received {\n  margin-bottom: 20px;\n}\n.chat-window .chat-cont-right .chat-body .media.received .media-body {\n  position: relative;\n}\n.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box > div {\n  background-color: #ffffff;\n}\n.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box > div .chat-time {\n  color: rgba(50, 65, 72, 0.4);\n}\n.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box:first-child:before {\n  border-bottom: 6px solid transparent;\n  border-right: 6px solid #ffffff;\n  border-top: 6px solid transparent;\n  content: \"\";\n  height: 0;\n  width: 0;\n  position: absolute;\n  top: 8px;\n  right: auto;\n  left: -6px;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box {\n  padding-left: 50px;\n  position: relative;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box:first-child:before {\n  border-bottom: 6px solid transparent;\n  border-left: 6px solid #e3e3e3;\n  border-top: 6px solid transparent;\n  content: \"\";\n  height: 0;\n  width: 0;\n  position: absolute;\n  top: 8px;\n  right: -6px;\n  left: auto;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-time {\n  color: rgba(50, 65, 72, 0.4);\n}\n.chat-window .chat-cont-right .chat-body .media:last-child {\n  margin-bottom: 0;\n}\n.chat-window .chat-cont-right .chat-body .media.sent {\n  margin-bottom: 20px;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body {\n  margin-left: 0;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div {\n  background-color: #e3e3e3;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div p {\n  color: #272b41;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info {\n  flex-direction: row-reverse;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info li {\n  padding-left: 16px;\n  padding-right: 0;\n  position: relative;\n}\n.chat-window\n  .chat-cont-right\n  .chat-body\n  .media.sent\n  .media-body\n  .msg-box\n  > div\n  .chat-msg-attachments {\n  flex-direction: row-reverse;\n}\n.chat-window\n  .chat-cont-right\n  .chat-body\n  .media.sent\n  .media-body\n  .msg-box\n  > div:hover\n  .chat-msg-actions {\n  opacity: 1;\n}\n.chat-window .chat-cont-right .chat-body .chat-date {\n  font-size: 14px;\n  margin: 1.875rem 0;\n  overflow: hidden;\n  position: relative;\n  text-align: center;\n  text-transform: capitalize;\n}\n.chat-window .chat-cont-right .chat-body .chat-date:before {\n  background-color: #eef6ff;\n  content: \"\";\n  height: 1px;\n  margin-right: 28px;\n  width: 100%;\n  position: absolute;\n  top: 50%;\n  right: 50%;\n}\n.chat-window .chat-cont-right .chat-body .chat-date:after {\n  background-color: #eef6ff;\n  content: \"\";\n  height: 1px;\n  margin-left: 28px;\n  width: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n.chat-window .chat-cont-right .chat-footer {\n  background-color: #ffffff;\n  position: relative;\n  border-top: 1px solid #f0f0f0;\n  padding: 10px 15px;\n}\n.chat-window .chat-cont-right .chat-footer .input-group {\n  width: 100%;\n}\n.chat-window .chat-cont-right .chat-footer .input-group .form-control {\n  background-color: #f5f5f6;\n  border: none;\n  border-radius: 50px;\n}\n.chat-window .chat-cont-right .chat-footer .input-group .form-control:focus {\n  background-color: #f5f5f6;\n  border: none;\n  box-shadow: none;\n}\n.chat-window .chat-cont-right .chat-footer .input-group .form-control::placeholder {\n  font-size: 14px;\n}\n.chat-window .chat-cont-right .chat-footer .input-group .btn {\n  background-color: transparent;\n  border: none;\n  color: #9f9f9f;\n}\n.chat-window .chat-cont-right .chat-footer .input-group .btn.msg-send-btn {\n  background-color: #0de0fe;\n  border-color: #0de0fe;\n  color: #ffffff;\n  margin-left: 10px;\n  min-width: 46px;\n  font-size: 20px;\n  border-radius: 50%;\n}\n.chat-window .chat-cont-right .msg-typing {\n  width: auto;\n  height: 24px;\n  padding-top: 8px;\n}\n.chat-window .chat-cont-right .msg-typing span {\n  height: 8px;\n  width: 8px;\n  float: left;\n  margin: 0 1px;\n  background-color: #a0a0a0;\n  display: block;\n  opacity: 0.4;\n  border-radius: 50%;\n}\n.chat-window .chat-cont-right .msg-typing span:nth-of-type(1) {\n  animation: 1s blink infinite 0.33333s;\n}\n.chat-window .chat-cont-right .msg-typing span:nth-of-type(2) {\n  animation: 1s blink infinite 0.66666s;\n}\n.chat-window .chat-cont-right .msg-typing span:nth-of-type(3) {\n  animation: 1s blink infinite 0.99999s;\n}\n.chat-window .chat-msg-info {\n  clear: both;\n  list-style: none;\n  margin: 5px 0 0;\n  padding: 0;\n}\n.chat-window .chat-msg-info li {\n  font-size: 13px;\n  padding-right: 16px;\n  position: relative;\n}\n.chat-window .chat-msg-info li:not(:last-child):after {\n  content: \"\";\n  height: 4px;\n  width: 4px;\n  background: #d2dde9;\n  border-radius: 50%;\n  transform: translate(50%, -50%);\n  -webkit-transform: translate(50%, -50%);\n  -ms-transform: translate(50%, -50%);\n  position: absolute;\n  top: 50%;\n  right: 8px;\n}\n.chat-window .chat-msg-info li a {\n  color: #777;\n}\n.chat-window .chat-msg-info li a:hover {\n  color: #2c80ff;\n}\n@media (max-width: 991.98px) {\n  .chat-window.chat-slide .chat-cont-left {\n    left: -100%;\n  }\n}\n@media (max-width: 991.98px) {\n  .chat-window.chat-slide .chat-cont-right {\n    right: 0;\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.chat-seen i {\n  color: #00d285;\n  font-size: 16px;\n}\n\n.chat-msg-attachments {\n  width: 100%;\n  margin: 0 -1px;\n  padding: 4px 0;\n}\n.chat-msg-attachments > div {\n  margin: 0 1px;\n}\n\n.chat-attachment {\n  position: relative;\n  max-width: 130px;\n  overflow: hidden;\n  border-radius: 0.25rem;\n}\n.chat-attachment img {\n  max-width: 100%;\n}\n.chat-attachment:before {\n  background: #000000;\n  content: \"\";\n  opacity: 0.4;\n  -webkit-transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  transition: all 0.4s;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.chat-attachment:hover:before {\n  opacity: 0.6;\n}\n.chat-attachment:hover .chat-attach-caption {\n  opacity: 0;\n}\n.chat-attachment:hover .chat-attach-download {\n  opacity: 1;\n}\n\n.chat-attach-caption {\n  color: #ffffff;\n  padding: 7px 15px;\n  font-size: 13px;\n  opacity: 1;\n  -webkit-transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  transition: all 0.4s;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.chat-attach-download {\n  opacity: 0;\n  color: #ffffff;\n  width: 32px;\n  line-height: 32px;\n  background: rgba(255, 255, 255, 0.2);\n  text-align: center;\n  transform: translate(-50%, -50%);\n  -webkit-transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  transition: all 0.4s;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n.chat-attach-download:hover {\n  color: #495463;\n  background: #ffffff;\n}\n\nchat-attachment-list {\n  margin: -5px;\n}\nchat-attachment-list li {\n  width: 33.33%;\n  padding: 5px;\n}\n\n.chat-attachment-item {\n  border: 5px solid rgba(230, 239, 251, 0.5);\n  height: 100%;\n  min-height: 60px;\n  text-align: center;\n  font-size: 30px;\n}\n\n.chat-msg-actions {\n  opacity: 0;\n  z-index: 2;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  -webkit-transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  transition: all 0.4s;\n  position: absolute;\n  top: 50%;\n  left: -30px;\n}\n.chat-msg-actions > a {\n  color: #495463;\n  font-size: 24px;\n  padding: 0 10px;\n}\n.chat-msg-actions > a:hover {\n  color: #2c80ff;\n}\n\n@keyframes blink {\n  50% {\n    opacity: 1;\n  }\n}\n.btn-file {\n  font-size: 20px;\n  overflow: hidden;\n  position: relative;\n  vertical-align: middle;\n  padding: 0 0.75rem;\n}\n.btn-file input {\n  cursor: pointer;\n  filter: alpha(opacity=0);\n  font-size: 23px;\n  height: 100%;\n  margin: 0;\n  opacity: 0;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.incoming-btns {\n  margin-top: 20px;\n}\n\n.call-wrapper {\n  position: relative;\n  height: calc(100vh - 145px);\n}\n@media (max-width: 991.98px) {\n  .call-wrapper {\n    height: calc(100vh - 140px);\n  }\n}\n@media (max-width: 767.98px) {\n  .call-wrapper {\n    height: calc(100vh - 115px);\n  }\n}\n\n.call-page .footer {\n  display: none;\n}\n\n.dropdown-action .dropdown-toggle::after {\n  display: none;\n}\n\n.call-modal .modal-body {\n  padding: 40px;\n}\n.call-modal .modal-content {\n  border: 0;\n  border-radius: 10px;\n}\n\n/*-----------------\n\tIncoming call\n-----------------------*/\n.call-box .call-wrapper {\n  height: auto;\n  text-align: center;\n}\n.call-box .call-wrapper .call-user {\n  margin-bottom: 30px;\n}\n.call-box .call-wrapper .call-user h4 {\n  font-size: 24px;\n}\n.call-box .call-wrapper .call-user span {\n  display: block;\n  font-weight: 500;\n  text-align: center;\n}\n.call-box .call-wrapper .call-avatar {\n  margin-bottom: 30px;\n  cursor: pointer;\n  animation: ripple 2s infinite;\n}\n.call-box .call-wrapper .call-items .call-item {\n  background-color: rgba(255, 255, 255, 0.2);\n  border: 1px solid transparent;\n  border-radius: 100%;\n  color: #ffffff;\n  line-height: 0;\n  margin: 0 5px;\n  padding: 15px;\n}\n.call-box .call-wrapper .call-items .call-item:hover {\n  opacity: 0.9;\n}\n.call-box .call-wrapper .call-items .call-item:first-child,\n.call-box .call-wrapper .call-items .call-item:last-child {\n  margin-top: -30px;\n}\n.call-box .call-wrapper .call-items .call-item.call-end {\n  background: #f06060;\n  border: 1px solid #f06060;\n  color: #ffffff;\n  line-height: 0;\n  border-radius: 100%;\n  margin: 30px 20px 0;\n  padding: 20px;\n}\n.call-box .call-wrapper .call-items .call-item.call-start {\n  background: #55ce63;\n  border: 1px solid #55ce63;\n  color: #ffffff;\n  line-height: 0;\n  border-radius: 100%;\n  margin: 30px 20px 0;\n  padding: 20px;\n}\n.call-box.incoming-box .call-wrapper .call-items .call-item.call-start,\n.call-box.incoming-box .call-wrapper .call-items .call-item.call-end {\n  margin: 0 10px;\n}\n.call-box .call-avatar {\n  height: 140px;\n  max-width: 140px;\n  min-width: 140px;\n  position: relative;\n  width: 100%;\n  border: 10px solid #fafafa;\n  border-radius: 100%;\n}\n.call-box .btn {\n  background: rgba(0, 0, 0, 0);\n  -webkit-transition: all 0.3s ease 0s;\n  -ms-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n\n@-webkit-keyframes ripple {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);\n  }\n}\n@keyframes ripple {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);\n    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);\n    box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);\n  }\n}\n.chat-cont-right\n  .chat-body\n  .media.sent\n  .media-body\n  .msg-box\n  .chat-msg-info\n  li:not(:last-child)::after {\n  right: auto;\n  left: 8px;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  background: #aaa;\n}\n\n.view-cart-header {\n  position: relative;\n}\n.view-cart-header .dropdown-menu {\n  min-width: 320px !important;\n}\n.view-cart-header .shopping-cart {\n  padding: 15px;\n}\n.view-cart-header .shopping-cart.show-cart {\n  opacity: 1;\n  visibility: visible;\n}\n.view-cart-header .shopping-cart:after {\n  border: 7px solid #ffffff;\n  border-color: transparent transparent #ffffff #ffffff;\n  box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -ms-transform-origin: 0 0;\n}\n.view-cart-header .shopping-cart .booking-date {\n  display: block;\n  padding-bottom: 0;\n}\n.view-cart-header .shopping-cart .booking-date li span {\n  font-size: 14px;\n}\n.view-cart-header .shopping-cart-total {\n  float: right;\n}\n.view-cart-header .shopping-cart-items {\n  padding-top: 0px;\n}\n.view-cart-header .shopping-cart-items li {\n  display: block !important;\n  border-bottom: 1px solid #e4e4e4;\n  position: relative;\n  margin: 0 0 10px 0 !important;\n  padding: 0 0 14px;\n}\n.view-cart-header .shopping-cart-items li a {\n  padding-left: 0 !important;\n  letter-spacing: normal !important;\n}\n.view-cart-header .shopping-cart-items .close-icon {\n  cursor: pointer;\n  color: #6b7280;\n  position: absolute;\n  top: 10px;\n  right: 0;\n}\n.view-cart-header .shopping-cart-items img {\n  float: left;\n  width: 70px;\n  margin-right: 12px;\n  max-width: 100%;\n  height: auto;\n}\n.view-cart-header .shopping-cart-items .item-name {\n  display: block;\n  padding-top: 10px;\n  font-size: 14px;\n  padding-right: 20px;\n  color: #6b7280;\n  font-weight: normal;\n}\n.view-cart-header .shopping-cart-items .item-price {\n  margin-right: 8px;\n  color: #0e82fd;\n  font-size: 13px;\n  font-weight: normal;\n}\n.view-cart-header .shopping-cart-items .item-quantity {\n  color: #abb0be;\n  font-size: 13px;\n  font-weight: normal;\n}\n.view-cart-header .cart-icon {\n  color: #515783;\n  font-size: 24px;\n  margin-right: 7px;\n  float: left;\n}\n.view-cart-header .booking-date li {\n  display: block !important;\n  width: 100%;\n  margin: 0 0 10px;\n  padding: 0 !important;\n}\n.view-cart-header .booking-date li span {\n  float: right;\n}\n.view-cart-header .booking-total {\n  padding-top: 0;\n  text-align: center;\n}\n.view-cart-header .apt-btn {\n  font-size: 13px;\n  letter-spacing: normal !important;\n  padding: 7px 20px;\n}\n.view-cart-header .apt-btn:hover {\n  border-color: #0e82fd !important;\n  background-color: #0e82fd !important;\n  color: #ffffff !important;\n}\n\n.unread-msg1 {\n  background-color: #0e82fd;\n  border-radius: 2px;\n  color: #ffffff;\n  font-size: 10px;\n  font-style: normal;\n  text-align: center;\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  padding: 0 5px;\n}\n\n.custom-increment.cart button {\n  font-size: 10px;\n}\n.custom-increment.cart input[type=\"text\"] {\n  width: 60px;\n}\n.custom-increment button {\n  font-size: 14px;\n  height: 39px;\n  background: #dcdcdc;\n  color: #000000;\n  border: 0;\n  display: inline-block;\n}\n.custom-increment button.btn-danger {\n  border-radius: 4px 0px 0px 4px;\n}\n.custom-increment button:hover,\n.custom-increment button:focus,\n.custom-increment button:active {\n  background: #dcdcdc !important;\n  color: #000000 !important;\n  border: 0 !important;\n}\n.custom-increment button.btn-success {\n  border-radius: 0 4px 4px 0;\n}\n.custom-increment button.btn-danger {\n  border-radius: 4px 0px 0px 4px;\n}\n.custom-increment .input-group1 {\n  width: 100%;\n}\n.custom-increment input[type=\"text\"] {\n  border: 1px solid #dbdbdb;\n  border-radius: 0;\n  text-align: center;\n  width: 70%;\n  padding: 7px 15px;\n}\n.custom-increment input[type=\"text\"]:focus {\n  border-color: transparent;\n}\n\n.doc-review.review-listing {\n  margin: 0;\n}\n\n.review-listing.doc-review > ul > li {\n  background-color: #ffffff;\n  border: 1px solid #f0f0f0;\n  padding: 20px;\n}\n\n.account-page {\n  background-color: #ffffff;\n}\n.account-page .content {\n  padding: 50px 0;\n}\n@media (max-width: 767.98px) {\n  .account-page .content {\n    padding: 15px 0;\n  }\n}\n\n.login-right {\n  background-color: #ffffff;\n  border: 1px solid #f0f0f0;\n  border-radius: 4px;\n  padding: 25px;\n}\n@media (max-width: 767.98px) {\n  .login-right {\n    margin: 0 15px;\n    padding: 15px;\n  }\n}\n.login-right .dont-have {\n  color: #3d3d3d;\n  margin-top: 20px;\n  font-size: 13px;\n}\n.login-right .dont-have a {\n  color: #09dca4;\n}\n.login-right .inner-right-login {\n  max-width: 355px;\n  width: 100%;\n  margin: 0 auto;\n}\n.login-right .country-select .select-col .select2-container--default .select2-selection--single {\n  background-color: #ffffff;\n  border-radius: 10px 0 0 10px;\n  width: 79px;\n}\n.login-right\n  .country-select\n  .select-col\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__rendered {\n  color: #0de0fe;\n}\n.login-right\n  .country-select\n  .select-col\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  background-image: url(../../assets/images/icons/down-arrow-gray-dark.svg);\n}\n\n@media (max-width: 991.98px) {\n  .login-left {\n    display: none;\n  }\n}\n\n.login-header {\n  margin-bottom: 20px;\n}\n.login-header p {\n  margin-bottom: 0;\n}\n.login-header h3 {\n  font-size: 18px;\n  margin-bottom: 3px;\n}\n@media (max-width: 479.98px) {\n  .login-header h3 {\n    text-align: center;\n  }\n}\n.login-header h3 a {\n  color: #0de0fe;\n  float: right;\n  font-size: 15px;\n  margin-top: 2px;\n}\n@media (max-width: 479.98px) {\n  .login-header h3 a {\n    color: #0de0fe;\n    float: none;\n    font-size: 15px;\n    margin-top: 10px;\n    text-align: center;\n    display: block;\n  }\n}\n.login-header .logo-icon {\n  text-align: center;\n  margin: 40px auto 20px;\n}\n\n.login-btn {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.login-or {\n  color: #d4d4d4;\n  position: relative;\n  margin: 20px 0;\n  padding: 10px 0;\n}\n\n.or-line {\n  background-color: #e5e5e5;\n  height: 1px;\n  margin-bottom: 0;\n  margin-top: 0;\n  display: block;\n}\n\n.span-or {\n  background-color: #ffffff;\n  display: block;\n  margin-left: -20px;\n  text-align: center;\n  width: 42px;\n  position: absolute;\n  top: -3px;\n  left: 50%;\n}\n\n.forgot-link {\n  color: #3d3d3d;\n  display: inline-block;\n  font-size: 13px;\n  margin-bottom: 10px;\n  font-weight: 400;\n}\n\n.social-login .btn:hover,\n.social-login .social-login .btn:focus {\n  color: #ffffff;\n}\n\nspan.agree {\n  font-size: 16px;\n  margin-left: 6px;\n}\n\n.terms-and-policy span.terms {\n  color: #09dca4;\n}\n\n.terms-and-policy a {\n  color: #09dca4;\n}\n\n.login-page .login-right {\n  width: 100%;\n  position: relative;\n  font-family: \"Poppins\", sans-serif;\n  height: 100vh;\n  border: 0;\n  border-radius: 0;\n  padding: 0;\n}\n.login-page\n  .login-right\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__rendered {\n  color: #808080;\n}\n.login-page\n  .login-right\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  background-image: url(../../assets/images/icons/down-arrow-gray.svg);\n}\n.login-page .login-right .form-control {\n  color: #808080;\n}\n.login-page .search-location-input-box input {\n  background-image: url(../../assets/images/icons/search-icon.svg);\n  background-repeat: no-repeat;\n  background-position: 10px 50%;\n  background-size: 16px;\n  padding-left: 38px;\n  color: #948ca0;\n}\n\n.login-bottom-copyright {\n  color: #a4a4a4;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  padding-bottom: 25px;\n  width: 100%;\n  align-self: flex-end;\n  -webkit-align-self: flex-end;\n}\n\n.step-list {\n  text-align: center;\n  padding: 10px 0;\n}\n.step-list ul {\n  display: inline-block;\n}\n.step-list ul li {\n  float: left;\n  margin: 5px 0;\n  padding: 0 30px 0 0;\n}\n.step-list ul li:last-child {\n  padding-right: 0;\n}\n.step-list ul li a {\n  background-color: #e9f5f7;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #808080;\n}\n.step-list ul li a:hover,\n.step-list ul li a.active {\n  background-color: #0de0fe;\n  color: #ffffff;\n}\n.step-list ul li a.active-done {\n  background-color: #0de0fe;\n  color: #ffffff;\n  background-image: url(../../assets/images/icons/tick-icon.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 18px;\n  font-size: 0;\n}\n\n.profile-pic-col {\n  padding-top: 40px;\n  text-align: center;\n}\n.profile-pic-col h3 {\n  color: #000000;\n  font-size: 20px !important;\n}\n\n.profile-pic-upload {\n  width: 150px;\n  background: rgba(175, 213, 254, 0.4);\n  border-radius: 20px;\n  position: relative;\n  margin: 40px auto 0;\n  padding: 24px;\n}\n.profile-pic-upload input[type=\"file\"] {\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.profile-pic-upload .cam-col {\n  width: 70px;\n  height: 70px;\n  background-color: #ffffff;\n  border-radius: 70px;\n  overflow: hidden;\n  margin: 0 auto;\n}\n.profile-pic-upload span {\n  color: #000000;\n  font-size: 13px;\n  list-style: none;\n  display: inline-block;\n  margin-top: 15px;\n}\n\n.select-gender-col [type=\"radio\"]:checked,\n.select-gender-col [type=\"radio\"]:not(:checked) {\n  position: absolute;\n  left: -9999px;\n}\n.select-gender-col [type=\"radio\"]:checked + label,\n.select-gender-col [type=\"radio\"]:not(:checked) + label {\n  position: relative;\n  padding-left: 28px;\n  cursor: pointer;\n  line-height: 20px;\n  display: inline-block;\n  color: #666;\n}\n.select-gender-col [type=\"radio\"]:checked + label:before,\n.select-gender-col [type=\"radio\"]:not(:checked) + label:before {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 5px 20px 60px 10px rgba(0, 4, 107, 0.07);\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.select-gender-col [type=\"radio\"]:checked + label:after,\n.select-gender-col [type=\"radio\"]:not(:checked) + label:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  border-radius: 10px;\n  border: 2px solid #0de0fe;\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-transition: all 0.5s ease;\n  -ms-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n.select-gender-col [type=\"radio\"]:not(:checked) + label:after {\n  opacity: 0;\n}\n.select-gender-col [type=\"radio\"]:checked + label:after {\n  opacity: 1;\n}\n.select-gender-col .gender-icon {\n  position: relative;\n}\n.select-gender-col .gender-icon label {\n  text-align: center;\n  padding: 15px 20px !important;\n}\n.select-gender-col .gender-icon img {\n  max-height: 90px;\n}\n.select-gender-col span {\n  position: relative;\n  color: #000000;\n  display: inline-block;\n  margin-top: 10px;\n  font-size: 16px;\n  width: 100%;\n}\n.select-gender-col.payment-menthods-choose label {\n  min-width: 90px;\n  text-align: center;\n  color: #000000;\n  padding: 10px !important;\n}\n.select-gender-col.payment-menthods-choose label span.credit-card-option {\n  min-width: 192px;\n  font-size: 15px;\n}\n.select-gender-col.payment-menthods-choose label img {\n  position: relative;\n  max-width: 68px;\n}\n.select-gender-col.payment-menthods-choose [type=\"radio\"]:checked + label::after,\n.select-gender-col.payment-menthods-choose [type=\"radio\"]:not(:checked) + label::after {\n  border: 1px solid #0de0fe;\n}\n.select-gender-col label {\n  text-align: center;\n  padding: 15px 20px !important;\n}\n\n.pregnant-col .remember-me-col {\n  color: #000000;\n  font-size: 16px;\n}\n.pregnant-col .remember-me-col .custom_check .checkmark {\n  border-color: #0de0fe;\n}\n\n.step-process-col {\n  text-align: left;\n}\n\n.checklist-col span {\n  font-size: 16px;\n}\n.checklist-col .custom_check .checkmark {\n  width: 24px;\n  height: 24px;\n}\n.checklist-col .custom_check .checkmark:after {\n  left: 6px;\n  top: 3px;\n}\n.checklist-col .remember-me-col {\n  position: relative;\n  padding: 10px 0;\n}\n.checklist-col.pregnant-col .remember-me-col .custom_check {\n  padding-left: 25px;\n}\n.checklist-col.pregnant-col .remember-me-col .custom_check .checkmark {\n  border-color: #b4abca;\n}\n\n.otp-col {\n  color: #ffffff;\n}\n.otp-col h3 {\n  color: #ffffff;\n  font-size: 20px;\n  margin-bottom: 15px;\n}\n\n.dnt-recive-call {\n  color: #ffffff;\n}\n.dnt-recive-call a {\n  color: #ffffff;\n}\n\n.otp-box {\n  margin: 25px 0;\n}\n.otp-box .digit-group input {\n  width: 45px;\n  height: 45px;\n  background-color: rgba(245, 245, 245, 0.2);\n  border: none;\n  text-align: center;\n  font-size: 16px;\n  color: #ffffff;\n  box-shadow: 5px 20px 60px 10px rgba(0, 4, 107, 0.07);\n  border-radius: 8px;\n  color: #000000;\n  margin: 0 3px;\n}\n.otp-box .digit-group input:focus {\n  background-color: #ffffff;\n  border: 0;\n  outline: 0;\n}\n.otp-box .digit-group input[type=\"text\"].active {\n  background-color: #ffffff;\n  color: #000000;\n}\n.otp-box .splitter {\n  color: #ffffff;\n  font-size: 24px;\n  padding: 0 5px;\n}\n.otp-box .prompt {\n  font-size: 20px;\n  color: #ffffff;\n  margin: 0 0 20px;\n}\n\n.increment-decrement .input-groups {\n  border: 0;\n  background-color: transparent;\n  height: 35px;\n  margin-right: 0px;\n  display: block;\n}\n.increment-decrement .input-groups .quantity-field {\n  width: 40px;\n  text-align: center;\n  background-color: transparent;\n  float: left;\n  border: 0;\n}\n.increment-decrement .input-groups .quantity-field:focus {\n  border: 0;\n  outline: 0;\n}\n.increment-decrement .input-groups input[type=\"button\"] {\n  background-color: transparent;\n  font-size: 20px;\n  border: 1px solid #0de0fe;\n  border-radius: 4px;\n  height: 24px;\n  width: 24px;\n  margin-top: 0px;\n  line-height: 0;\n  padding: 0;\n  color: #0de0fe;\n}\n.increment-decrement .input-groups input[type=\"button\"]:focus-visible {\n  outline: 0;\n}\n.increment-decrement .input-groups input[type=\"button\"].button-minus {\n  float: left;\n}\n.increment-decrement .input-groups input[type=\"button\"].button-plus {\n  float: right;\n}\n\n.country-select {\n  position: relative;\n}\n.country-select .select-col {\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.country-select .select-col .flagstrap {\n  height: 100%;\n}\n.country-select .select-col .btn-info.dropdown-toggle {\n  border: 0;\n  color: #0de0fe;\n  border-radius: 10px 0px 0px 10px;\n  background-color: #ffffff;\n  height: 100%;\n  font-size: 0;\n  width: 79px;\n  text-align: left;\n  padding: 0 12px;\n}\n.country-select .select-col .btn-info.dropdown-toggle:after {\n  background-image: url(../../assets/images/icons/down-arrow-gray-dark.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  width: 14px;\n  height: 7px;\n  border: 0;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  position: absolute;\n  top: 50%;\n  right: 10px;\n}\n.country-select .select-col .btn-info.dropdown-toggle span {\n  font-size: 0;\n}\n.country-select .select-col .dropdown-menu {\n  font-size: 0;\n  width: 79px;\n  min-width: inherit;\n  margin-top: 0;\n  border-radius: 10px;\n  padding: 0;\n}\n.country-select .select-col .dropdown-menu li {\n  margin: 14px 13px;\n}\n.country-select .select-col .dropdown-menu li:first-child {\n  display: none;\n}\n.country-select .select-col .dropdown-menu li a {\n  display: inline-block;\n  cursor: pointer;\n}\n.country-select .select-col .flagstrap-icon.flagstrap-in,\n.country-select .select-col .flagstrap-icon.flagstrap-ng,\n.country-select .select-col .flagstrap-icon.flagstrap-gb,\n.country-select .select-col .flagstrap-icon.flagstrap-us {\n  background-image: url(../../assets/images/flags/in.png);\n  background-position: center;\n  width: 33px;\n  height: 22px;\n  background-size: cover;\n  border-radius: 4px;\n}\n.country-select .select-col .flagstrap-icon.flagstrap-ng {\n  background-image: url(../../assets/images/flags/ng.png);\n}\n.country-select .select-col .flagstrap-icon.flagstrap-gb {\n  background-image: url(../../assets/images/flags/gb.png);\n}\n.country-select .select-col .flagstrap-icon.flagstrap-us {\n  background-image: url(../../assets/images/flags/us.png);\n}\n.country-select .number-col input {\n  padding-left: 96px;\n}\n\n.location-text h5 {\n  color: #000000;\n  margin-top: 5px;\n}\n\n.location-search {\n  margin: 12px 0;\n}\n\n.skip-now-col {\n  margin-top: 5px;\n}\n.skip-now-col a {\n  color: #000000;\n  font-size: 12px;\n}\n\n.sort-by-col .select2-container .select2-selection--single {\n  border-color: #e8eeff;\n  border-radius: 10px;\n  width: 160px;\n}\n.sort-by-col .select2-container--default .select2-selection--single .select2-selection__arrow b {\n  background-image: url(../../assets/images/icons/down-arrow-gray.svg);\n}\n\n.premium-text {\n  font-size: 18px;\n}\n\n.plan-details {\n  list-style: none;\n  margin: 0;\n  padding: 4px 0 0;\n}\n.plan-details li {\n  position: relative;\n  min-width: 35%;\n}\n.plan-details li span {\n  color: #b4abca;\n  display: inline-block;\n  margin-bottom: 3px;\n  font-size: 15px;\n}\n\n.plan-chooser-col {\n  background-color: rgba(175, 213, 254, 0.4);\n  border-radius: 20px;\n  margin: 0 0 28px;\n  padding: 5px 20px;\n}\n.plan-chooser-col .memeber-img {\n  border-radius: 15px;\n  margin-bottom: 10px;\n  width: 100%;\n}\n.plan-chooser-col .memeber-img img {\n  border-radius: 15px;\n}\n.plan-chooser-col .subscription-list {\n  margin: 15px 0;\n}\n\n.memeber-details h4 {\n  margin-bottom: 0;\n}\n\n.payment-menthods ul {\n  text-align: center;\n}\n.payment-menthods ul li {\n  display: inline-block;\n  margin: 0;\n  padding: 6px;\n}\n\n.card-choose-col {\n  max-width: 325px;\n  margin: 0 auto;\n}\n\n.day-week-month-col ul li {\n  float: left;\n}\n.day-week-month-col ul li:first-child a {\n  border-radius: 4px 0 0 4px !important;\n}\n.day-week-month-col ul li:last-child a {\n  border-radius: 0px 4px 4px 0px !important;\n}\n.day-week-month-col ul li a {\n  background-color: #9d9d9d;\n  border: 1px solid transparent;\n  color: #64627c;\n  display: inline-block;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  padding: 10px 20px;\n}\n.day-week-month-col ul li a.active {\n  border-color: #536cf1;\n  color: #536cf1;\n  border-radius: 0 !important;\n}\n.day-week-month-col ul li a:first-child.active {\n  border-color: #536cf1;\n}\n.day-week-month-col ul li a:last-child.active {\n  border-color: #536cf1;\n}\n\n.login-body {\n  background: #ffffff;\n}\n\n.login-content-info {\n  margin: 0;\n  padding: 160px 0 60px;\n}\n.login-content-info .account-content {\n  position: relative;\n}\n.login-content-info .account-content .login-shapes {\n  position: relative;\n}\n.login-content-info .account-content .login-shapes .shape-img-left {\n  position: absolute;\n  top: 0;\n  left: -70px;\n}\n.login-content-info .account-content .login-shapes .shape-img-right {\n  position: absolute;\n  top: 150px;\n  left: -70px;\n}\n@media (max-width: 991.98px) {\n  .login-content-info .account-content .login-shapes .shape-img-right {\n    top: 67px;\n  }\n}\n@media (max-width: 767.98px) {\n  .login-content-info .account-content .login-shapes {\n    display: none;\n  }\n}\n.login-content-info .account-content .account-info {\n  position: relative;\n  z-index: 1;\n}\n.login-content-info .account-content .account-info .btn {\n  width: 100%;\n  color: #ffffff;\n  background: #0e82fd;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n  font-weight: 600;\n  padding: 10px 15px;\n}\n@media (max-width: 767.98px) {\n  .login-content-info .account-content .account-info .btn {\n    padding: 8px 15px;\n  }\n}\n.login-content-info .account-content .account-info .btn:hover {\n  color: #0e82fd;\n  background: #ffffff;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 50px #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.login-content-info .account-content .account-info .form-control {\n  font-size: 14px;\n}\n.login-content-info .account-content .account-info .back-btn-light .btn {\n  color: #000000;\n  background-color: #f9f9f9;\n  border: 1px solid #f9f9f9;\n  box-shadow: inset 0 0 0 0 #ffffff;\n}\n.login-content-info .account-content .account-info .back-btn-light .btn:hover {\n  color: #000;\n  background-color: #ffffff;\n  border: 1px solid #dcdcdc;\n  box-shadow: inset 0 0 0 50px #ffffff;\n}\n.login-content-info .account-content .account-info .back-btn-light .btn i {\n  margin-right: 10px;\n}\n.login-content-info .account-content .login-back {\n  padding-bottom: 50px;\n}\n.login-content-info .account-content .login-back a {\n  font-size: 15px;\n  color: #959595;\n}\n.login-content-info .account-content .login-back a:hover {\n  color: #0e82fd;\n}\n.login-content-info .account-content .login-back a i {\n  margin-right: 10px;\n}\n@media (max-width: 991.98px) {\n  .login-content-info .account-content .login-back {\n    padding-bottom: 30px;\n  }\n}\n@media (max-width: 767.98px) {\n  .login-content-info .account-content .login-back {\n    padding-bottom: 20px;\n  }\n}\n.login-content-info .account-content .login-verify-img {\n  padding-bottom: 50px;\n}\n@media (max-width: 991.98px) {\n  .login-content-info .account-content .login-verify-img {\n    padding-bottom: 30px;\n  }\n}\n@media (max-width: 767.98px) {\n  .login-content-info .account-content .login-verify-img {\n    padding-bottom: 20px;\n  }\n}\n.login-content-info .account-content .login-title {\n  padding-bottom: 50px;\n}\n.login-content-info .account-content .login-title h3 {\n  font-size: 30px;\n  margin-bottom: 10px;\n  font-weight: 600;\n  color: #1f2937;\n}\n@media (max-width: 991.98px) {\n  .login-content-info .account-content .login-title h3 {\n    font-size: 26px;\n  }\n}\n@media (max-width: 767.98px) {\n  .login-content-info .account-content .login-title h3 {\n    font-size: 20px;\n  }\n}\n.login-content-info .account-content .login-title p {\n  color: #71717a;\n  margin-bottom: 10px;\n}\n.login-content-info .account-content .login-title span {\n  color: #040404;\n  font-weight: 500;\n}\n.login-content-info .account-content .login-title span a {\n  color: #0e82fd;\n  text-decoration: underline;\n}\n.login-content-info .account-content .login-title span a:hover {\n  text-decoration: none;\n}\n@media (max-width: 991.98px) {\n  .login-content-info .account-content .login-title {\n    padding-bottom: 30px;\n  }\n}\n@media (max-width: 767.98px) {\n  .login-content-info .account-content .login-title {\n    padding-bottom: 20px;\n  }\n}\n.login-content-info .account-content .login-or {\n  font-size: 16px;\n  color: #818181;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  padding-top: 10px;\n  position: relative;\n}\n.login-content-info .account-content .or-line {\n  background-color: #efefef;\n  height: 1px;\n  margin-bottom: 0;\n  margin-top: 0;\n  display: block;\n}\n.login-content-info .account-content .span-or {\n  background-color: #ffffff;\n  display: block;\n  position: absolute;\n  top: -3px;\n  left: 50%;\n  margin-left: -20px;\n  text-align: center;\n  width: 42px;\n}\n.login-content-info .account-content .social-login-btn {\n  margin-bottom: 20px;\n}\n.login-content-info .account-content .social-login-btn .btn {\n  font-weight: 500;\n  font-size: 14px;\n  color: #000000;\n  background: #ffffff;\n  border: 1px solid #e4e4e8;\n  padding: 11px 15px;\n  border-radius: 8px;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.login-content-info .account-content .social-login-btn .btn:hover {\n  color: #ffffff;\n  background: #0e82fd;\n  border: 1px solid #0e82fd;\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.login-content-info .account-content .social-login-btn .btn img {\n  margin-right: 15px;\n}\n@media (max-width: 991.98px) {\n  .login-content-info {\n    margin: 0;\n    padding: 40px 0 40px;\n  }\n}\n.login-content-info .form-group {\n  margin-bottom: 20px;\n}\n.login-content-info .form-group label {\n  color: #000000;\n  display: inline-block;\n  margin-bottom: 10px;\n}\n\n.pass-group {\n  position: relative;\n}\n.pass-group .toggle-password {\n  font-size: 16px;\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  color: #797979;\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n}\n.pass-group .toggle-password:hover {\n  background-color: #f3f3f3;\n}\n\n.toggle-password-sub {\n  font-size: 16px;\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  color: #797979;\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n}\n.toggle-password-sub:hover {\n  background-color: #f3f3f3;\n}\n\n#passwordInfo,\n#passwordInfos {\n  font-size: 12px;\n  font-weight: normal;\n  margin-top: 15px;\n}\n\n.poor-active span.active#poor,\n.poor-active span.active#poors {\n  background: #ff0000;\n}\n\n.avg-active span.active#poor,\n.avg-active span.active#poors,\n.avg-active span.active#weak,\n.avg-active span.active#weaks {\n  background: #ffb54a;\n}\n\n.strong-active span.active#poor,\n.strong-active span.active#weak,\n.strong-active span.active#strong,\n.strong-active span.active#poors,\n.strong-active span.active#weaks,\n.strong-active span.active#strongs {\n  background: #0e82fd;\n}\n\n.heavy-active span.active#poor,\n.heavy-active span.active#weak,\n.heavy-active span.active#strong,\n.heavy-active span.active#heavy,\n.heavy-active span.active#poors,\n.heavy-active span.active#weaks,\n.heavy-active span.active#strongs,\n.heavy-active span.active#heavys {\n  background: #159f46;\n}\n\ninput[type=\"password\"]::-ms-reveal,\ninput[type=\"password\"]::-ms-clear {\n  display: none;\n}\n\n.password-strength {\n  margin-top: 15px;\n}\n.password-strength span {\n  width: 100%;\n  height: 6px;\n  background: #e4e6ef;\n  margin-right: 10px;\n  border-radius: 30px;\n}\n.password-strength span:last-child {\n  margin-right: 0;\n}\n\n.weak-pass .password-strength span {\n  background: #ff0000;\n}\n\n.pass-checked {\n  position: absolute;\n  top: 55%;\n  right: 46px;\n  transform: translateY(-50%);\n  color: #4caf50;\n  opacity: 0;\n}\n.pass-checked.active {\n  opacity: 1;\n}\n\n.password-info {\n  margin-top: 15px;\n}\n\n.password-info p {\n  color: #9e9e9e;\n  margin-bottom: 0;\n}\n\n.login-success-icon {\n  padding-bottom: 18px;\n}\n.login-success-icon i {\n  font-size: 40px;\n  color: #00cc45;\n}\n\n.modal-open .main-wrapper {\n  -webkit-filter: blur(1px);\n  -moz-filter: blur(1px);\n  -o-filter: blur(1px);\n  -ms-filter: blur(1px);\n  filter: blur(1px);\n}\n\n.call-main-row {\n  overflow: auto;\n  padding-bottom: inherit;\n  padding-top: inherit;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.call-main-wrapper {\n  display: table;\n  height: 100%;\n  table-layout: fixed;\n  width: 100%;\n}\n\n.call-view {\n  display: table-cell;\n  height: 100%;\n  float: none;\n  position: static;\n  vertical-align: top;\n  width: 75%;\n  padding: 0;\n}\n\n.call-window {\n  display: table;\n  height: 100%;\n  table-layout: fixed;\n  width: 100%;\n  background-color: #ffffff;\n  border: 1px solid #f0f0f0;\n}\n\n.fixed-header {\n  background-color: #ffffff;\n  border-bottom: 1px solid #f0f0f0;\n  padding: 10px 15px;\n}\n.fixed-header .navbar {\n  border: 0 none;\n  min-height: auto;\n  margin: 0;\n  padding: 0;\n}\n.fixed-header .user-info a {\n  color: #272b41;\n  font-weight: 500;\n}\n.fixed-header .custom-menu {\n  margin: 0 0 1px;\n}\n\n.typing-text {\n  color: #20c0f3;\n  font-size: 12px;\n  text-transform: lowercase;\n}\n\n.last-seen {\n  color: #888888;\n  display: block;\n  font-size: 12px;\n}\n\n.custom-menu {\n  margin-top: 6px;\n}\n.custom-menu.nav > li > a {\n  color: #bbb;\n  font-size: 26px;\n  line-height: 32px;\n  margin-left: 15px;\n  padding: 0;\n}\n.custom-menu.navbar-nav > li > a:hover,\n.custom-menu.navbar-nav > li > a:focus {\n  background-color: transparent;\n}\n.custom-menu .dropdown-menu {\n  left: auto;\n  right: 0;\n}\n\n.call-contents {\n  display: table-row;\n  height: 100%;\n}\n\n.call-content-wrap {\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n\n.voice-call-avatar {\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -ms-flex: 2;\n  flex: 2;\n}\n.voice-call-avatar .call-avatar {\n  width: 150px;\n  height: 150px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  background-color: #ffffff;\n  margin: 15px;\n  padding: 3px;\n  border-radius: 100%;\n}\n@media (max-width: 767.98px) {\n  .voice-call-avatar .call-avatar {\n    height: 100px;\n    width: 100px;\n  }\n}\n@media (max-width: 575.98px) {\n  .voice-call-avatar .call-avatar {\n    height: 80px;\n    width: 80px;\n  }\n}\n.voice-call-avatar .call-timing-count {\n  padding: 5px;\n}\n.voice-call-avatar .username {\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.call-duration {\n  display: inline-block;\n  font-size: 30px;\n  margin-top: 4px;\n  position: absolute;\n  left: 0;\n}\n@media (max-width: 767.98px) {\n  .call-duration {\n    font-size: 24px;\n  }\n}\n@media (max-width: 575.98px) {\n  .call-duration {\n    display: block;\n    margin-top: 0;\n    margin-bottom: 10px;\n    position: inherit;\n  }\n}\n\n.call-footer {\n  background-color: #ffffff;\n  border-top: 1px solid #f0f0f0;\n  padding: 15px;\n}\n\n.call-icons {\n  text-align: center;\n  position: relative;\n}\n.call-icons .call-items {\n  list-style: none;\n  display: inline-block;\n  border-radius: 5px;\n  margin: 0;\n  padding: 0;\n}\n.call-icons .call-items .call-item {\n  display: inline-block;\n  text-align: center;\n  margin-right: 5px;\n}\n.call-icons .call-items .call-item:last-child {\n  margin-right: 0;\n}\n.call-icons .call-items .call-item a {\n  color: #777;\n  border: 1px solid #dddddd;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  display: inline-block;\n  font-size: 20px;\n  border-radius: 50px;\n}\n.call-icons .call-items .call-item a i {\n  width: 18px;\n  height: 18px;\n}\n.call-icons .call-items li.end-call-new {\n  display: inline-block;\n  text-align: center;\n  margin-right: 5px;\n}\n.call-icons .call-items li.end-call-new a {\n  background-color: #f06060;\n  color: #ffffff;\n  display: inline-block;\n  line-height: 10px;\n  text-transform: uppercase;\n  border-radius: 50px;\n  padding: 8px 25px;\n}\n\n.user-video {\n  overflow: auto;\n  z-index: 10;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.user-video img,\n.user-video video {\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  max-height: 100%;\n  display: block;\n  margin: 0 auto;\n}\n\n.my-video {\n  z-index: 99;\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n}\n.my-video ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.my-video ul li {\n  float: left;\n  width: 120px;\n  margin-right: 10px;\n}\n@media (max-width: 767.98px) {\n  .my-video ul li {\n    width: 50px;\n  }\n}\n.my-video ul li img {\n  border: 3px solid #ffffff;\n  border-radius: 6px;\n}\n\n.end-call {\n  position: absolute;\n  top: 7px;\n  right: 0;\n}\n@media (max-width: 575.98px) {\n  .end-call {\n    margin-top: 10px;\n    position: inherit;\n  }\n}\n.end-call a {\n  background-color: #f06060;\n  color: #ffffff;\n  display: inline-block;\n  line-height: 10px;\n  text-transform: uppercase;\n  padding: 8px 25px;\n  border-radius: 50px;\n}\n\n.call-users {\n  z-index: 99;\n  position: absolute;\n  right: 20px;\n  bottom: 20px;\n}\n.call-users ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.call-users ul li {\n  float: left;\n  width: 80px;\n  margin-left: 10px;\n}\n@media (max-width: 767.98px) {\n  .call-users ul li {\n    width: 50px;\n  }\n}\n.call-users ul li img {\n  background-color: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  padding: 2px;\n}\n.call-users ul li a:hover .call-mute {\n  display: block;\n}\n\n.call-mute {\n  width: 80px;\n  height: 80px;\n  background-color: rgba(0, 0, 0, 0.5);\n  text-align: center;\n  line-height: 80px;\n  font-size: 30px;\n  color: #ffffff;\n  display: none;\n  border: 3px solid transparent;\n  border-radius: 6px;\n  position: absolute;\n  top: 0;\n}\n@media (max-width: 767.98px) {\n  .call-mute {\n    font-size: 20px;\n    height: 50px;\n    line-height: 50px;\n    width: 50px;\n  }\n}\n\n.call-details {\n  margin: 10px 0 0;\n}\n\n.call-info {\n  margin-left: 10px;\n  width: 100%;\n}\n\n.call-user-details,\n.call-timing {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.call-description {\n  white-space: nowrap;\n  vertical-align: bottom;\n}\n\n.call-timing {\n  color: #727272;\n  font-size: 14px;\n  margin-top: 1px;\n  overflow: hidden;\n  white-space: pre;\n}\n\n.content-full {\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n\n.video-window .fixed-header {\n  margin: 0;\n  padding: 0;\n}\n.video-window .fixed-header .nav > li > a {\n  padding: 18px 15px;\n}\n\n.user-img {\n  display: inline-block;\n  position: relative;\n}\n\nspan.call-duration.float-end {\n  display: inline-block;\n  font-size: 22px;\n  margin-top: 0px;\n  color: #40dda4;\n  position: absolute;\n  right: 0;\n  left: unset;\n}\n\n.toggle-voice-video {\n  display: inline-block;\n  font-size: 30px;\n  margin-top: 4px;\n  position: absolute;\n  left: 0;\n}\n.toggle-voice-video .switch {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 34px;\n}\n.toggle-voice-video .switch input {\n  display: none;\n}\n.toggle-voice-video .slider {\n  cursor: pointer;\n  background-color: #2196f3;\n  -webkit-transition: 0.4s;\n  -ms-transition: 0.4s;\n  transition: 0.4s;\n  border-radius: 34px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.toggle-voice-video .slider:before {\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  background-color: #ffffff;\n  -webkit-transition: 0.4s;\n  -ms-transition: 0.4s;\n  transition: 0.4s;\n  border-radius: 50%;\n  position: absolute;\n  bottom: 4px;\n  left: 4px;\n}\n.toggle-voice-video .slider:after {\n  content: \"VOICE\";\n  color: #ffffff;\n  display: block;\n  font-size: 10px;\n  font-family: Verdana, sans-serif;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n.toggle-voice-video input:checked + .slider {\n  background-color: #2ab934;\n}\n.toggle-voice-video input:checked + .slider:before {\n  transform: translateX(55px);\n  -webkit-transform: translateX(55px);\n  -ms-transform: translateX(55px);\n}\n.toggle-voice-video input:checked + .slider:after {\n  content: \"VIDEO\";\n}\n.toggle-voice-video input:focus + .slider {\n  box-shadow: 0 0 1px #2196f3;\n}\n\n.map-page .footer {\n  display: none;\n}\n.map-page .header {\n  z-index: 1030;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n}\n.map-page .content {\n  padding-top: 115px;\n}\n@media (max-width: 991.98px) {\n  .map-page .content {\n    padding-top: 100px;\n  }\n}\n\n.map-right {\n  height: 100%;\n  min-height: 100%;\n  padding-right: 30px;\n  z-index: 1029;\n  position: fixed;\n  top: 115px;\n  right: 0;\n  bottom: 0;\n}\n@media (max-width: 1199.98px) {\n  .map-right {\n    height: 450px;\n    position: static;\n    min-height: inherit;\n    margin-bottom: 30px;\n    padding-right: 15px;\n  }\n}\n.map-right .available-info {\n  margin-bottom: 0;\n}\n\n.map-listing {\n  height: calc(100vh - 145px);\n  width: 100%;\n}\n@media (max-width: 1199.98px) {\n  .map-listing {\n    height: 450px;\n  }\n}\n.map-listing .profile-widget {\n  width: 200px !important;\n  border: 0;\n  margin-bottom: 0;\n  padding: 0;\n}\n\n.view-icons {\n  display: inline-flex;\n  float: right;\n}\n.view-icons a {\n  background-color: #ffffff;\n  border: 1px solid #dddddd;\n  color: #212529;\n  font-size: 20px;\n  text-align: center;\n  margin-left: 10px;\n  width: 44px;\n  height: 44px;\n  border-radius: 4px;\n  padding: 4px 10px;\n}\n.view-icons a:hover {\n  border-color: #20c0f3;\n  color: #20c0f3;\n}\n.view-icons a.active {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n  color: #ffffff;\n}\n\n.breadcrumb-bar {\n  background-color: #15558d;\n  padding: 15px 0;\n}\n\n.page-breadcrumb ol {\n  background-color: transparent;\n  font-size: 12px;\n  margin-bottom: 0;\n  padding: 0;\n}\n.page-breadcrumb ol li a {\n  color: #ffffff;\n}\n.page-breadcrumb ol li.active {\n  color: #ffffff;\n}\n.page-breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  color: #ffffff;\n  font-size: 10px;\n}\n\n.breadcrumb-bar-one {\n  background: #f2f6f6;\n  background-repeat: no-repeat;\n  padding-top: 70px;\n  min-height: 300px;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n.breadcrumb-bar-one::after {\n  content: \"\";\n  background: url(../images/banner-bg.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n.breadcrumb-bar-one .inner-banner {\n  margin: 0;\n  padding: 70px 0;\n}\n.breadcrumb-bar-one .inner-banner .breadcrumb-title {\n  font-weight: 600;\n  font-size: 48px;\n  margin-bottom: 6px;\n}\n@media (max-width: 991.98px) {\n  .breadcrumb-bar-one .inner-banner .breadcrumb-title {\n    font-size: 36px;\n  }\n}\n@media (max-width: 767.98px) {\n  .breadcrumb-bar-one .inner-banner .breadcrumb-title {\n    font-size: 26px;\n  }\n}\n@media (max-width: 767.98px) {\n  .breadcrumb-bar-one .inner-banner {\n    margin: 0;\n    padding: 50px 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .breadcrumb-bar-one {\n    padding-top: 40px;\n    min-height: 260px;\n  }\n}\n@media (max-width: 767.98px) {\n  .breadcrumb-bar-one {\n    min-height: auto;\n  }\n}\n.breadcrumb-bar-one .page-breadcrumb ol {\n  background-color: transparent;\n  font-weight: 500;\n  margin: 0;\n  padding: 0;\n}\n.breadcrumb-bar-one .page-breadcrumb ol li a {\n  font-weight: 500;\n  color: #4b5563;\n}\n.breadcrumb-bar-one .page-breadcrumb ol li.active {\n  color: #1f2937;\n}\n@media (max-width: 767.98px) {\n  .breadcrumb-bar-one .page-breadcrumb ol {\n    font-size: 15px;\n  }\n}\n.breadcrumb-bar-one .page-breadcrumb .breadcrumb a:hover {\n  color: #09e5ab;\n}\n.breadcrumb-bar-one .page-breadcrumb .breadcrumb-item + .breadcrumb-item {\n  font-weight: 500;\n  color: #1f2937;\n  padding-left: 10px;\n}\n.breadcrumb-bar-one .breadcrumb-item + .breadcrumb-item::before {\n  content: \"/\";\n  font-family: \"feather\";\n  float: left;\n  padding-right: 10px;\n  color: #9ca3af;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.sort-by {\n  float: right;\n}\n\n.sort-title {\n  color: #ffffff;\n  font-size: 14px;\n  margin-right: 10px;\n}\n\n.sortby-fliter {\n  display: inline-block;\n  width: 120px;\n}\n\n.cal-icon {\n  position: relative;\n  width: 100%;\n}\n.cal-icon:after {\n  color: #979797;\n  content: \"\\f073\";\n  display: block;\n  font-family: \"Font Awesome 5 Free\";\n  font-size: 16px;\n  font-weight: 400;\n  margin: auto;\n  position: absolute;\n  top: 10px;\n  right: 15px;\n}\n\n.custom_check {\n  color: #666;\n  display: inline-block;\n  position: relative;\n  font-size: 14px;\n  font-size: 0.9375rem;\n  padding-left: 30px;\n  margin-bottom: 10px;\n  cursor: pointer;\n}\n.custom_check input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n.custom_check input:checked ~ .checkmark {\n  background-color: #ffffff;\n}\n.custom_check input:checked ~ .checkmark:after {\n  display: block;\n}\n.custom_check .checkmark {\n  height: 20px;\n  width: 20px;\n  border: 1px solid #dcdcdc;\n  background-color: #ffffff;\n  border-radius: 3px;\n  -webkit-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.custom_check .checkmark::after {\n  content: \"\\f00c\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n  display: none;\n  color: #0de0fe;\n  font-size: 11px;\n  position: absolute;\n  top: 0;\n  left: 4px;\n}\n\n.custom_radio {\n  color: #555;\n  display: inline-block;\n  position: relative;\n  font-size: 14px;\n  font-size: 15px;\n  padding-left: 30px;\n  margin-bottom: 10px;\n  cursor: pointer;\n}\n.custom_radio input {\n  position: absolute;\n  opacity: 0;\n}\n.custom_radio input:checked ~ .checkmark:after {\n  opacity: 1;\n}\n.custom_radio .checkmark {\n  height: 20px;\n  width: 20px;\n  background-color: #ffffff;\n  border: 1px solid #cccccc;\n  border-radius: 50%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.custom_radio .checkmark:after {\n  display: block;\n  content: \"\";\n  opacity: 0;\n  width: 12px;\n  height: 12px;\n  background: #ff9b44;\n  border-radius: 50%;\n  -webkit-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  position: absolute;\n  top: 3px;\n  left: 3px;\n}\n\n.radio_input .custom_radio + .custom_radio {\n  margin-left: 15px;\n}\n\n.filter-widget {\n  margin-bottom: 20px;\n}\n.filter-widget h4 {\n  font-size: 1rem;\n  margin-bottom: 15px;\n}\n.filter-widget .custom_check {\n  line-height: 18px;\n}\n\n.btn-search .btn {\n  background-color: #0de0fe;\n  border: 1px solid #0de0fe;\n  color: #ffffff;\n  height: 46px;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n@media (max-width: 767.98px) {\n  .doctor-widget {\n    -ms-flex-direction: column;\n    flex-direction: column;\n    text-align: center;\n  }\n}\n.doctor-widget .doc-name {\n  font-size: 20px;\n  font-weight: 500;\n  margin-bottom: 3px;\n}\n@media (max-width: 767.98px) {\n  .doctor-widget .doc-name {\n    font-size: 18px;\n  }\n}\n.doctor-widget .rating i {\n  font-size: 14px;\n}\n.doctor-widget .average-rating {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n@media (max-width: 767.98px) {\n  .doc-info-left {\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n}\n\n.doc-info-right {\n  margin-left: auto;\n  -ms-flex: 0 0 200px;\n  flex: 0 0 200px;\n  max-width: 200px;\n}\n@media (max-width: 767.98px) {\n  .doc-info-right {\n    margin-left: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n\n.doctor-img {\n  -ms-flex: 0 0 150px;\n  flex: 0 0 150px;\n  margin-right: 20px;\n  width: 150px;\n}\n@media (max-width: 767.98px) {\n  .doctor-img {\n    margin: 0 auto 20px;\n  }\n}\n.doctor-img img {\n  border-radius: 5px;\n}\n\n.doc-department {\n  color: #20c0f3;\n  font-size: 14px;\n  margin-bottom: 8px;\n}\n.doc-department img {\n  width: 19px;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.doc-location {\n  color: #757575;\n  font-size: 14px;\n  margin-bottom: 25px;\n}\n.doc-location a {\n  color: #09e5ab;\n  font-weight: 500;\n}\n\n.doc-speciality {\n  font-size: 14px;\n  color: #757575;\n  margin-bottom: 15px;\n}\n\n.clinic-details {\n  margin-bottom: 15px;\n}\n.clinic-details h5 {\n  font-weight: normal;\n  color: #757575;\n  margin-bottom: 25px;\n}\n.clinic-details ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.clinic-details ul li {\n  display: inline-block;\n  padding-right: 5px;\n}\n.clinic-details ul li:last-child {\n  padding-right: 0;\n}\n.clinic-details ul li a {\n  display: inline-block;\n}\n.clinic-details ul li a img {\n  width: 40px;\n  border-radius: 5px;\n}\n\n.clinic-services {\n  color: #272b41;\n  font-size: 13px;\n}\n@media (max-width: 767.98px) {\n  .clinic-services {\n    display: none;\n  }\n}\n.clinic-services span {\n  border: 1px solid #cccccc;\n  display: inline-block;\n  font-size: 12px;\n  padding: 3px 10px;\n  border-radius: 4px;\n}\n.clinic-services span + span {\n  margin-left: 5px;\n}\n\n.clini-infos {\n  margin-bottom: 15px;\n}\n.clini-infos ul {\n  font-size: 14px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.clini-infos ul li {\n  display: block;\n  line-height: 30px;\n  color: #4e4852;\n}\n.clini-infos ul li i {\n  font-size: 15px;\n  min-width: 20px;\n}\n\n.clinic-booking a {\n  background-color: #ffffff;\n  border: 2px solid #20c0f3;\n  color: #20c0f3;\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 1px;\n  text-align: center;\n  text-transform: capitalize;\n  width: 100%;\n  padding: 10px 15px;\n  border-radius: 4px;\n}\n.clinic-booking a + a {\n  margin-top: 15px;\n}\n.clinic-booking a.view-pro-btn:hover,\n.clinic-booking a.view-pro-btn:focus {\n  background: #20c0f3;\n  color: #ffffff;\n}\n.clinic-booking a.apt-btn {\n  background: #20c0f3;\n  color: #ffffff;\n}\n@media (max-width: 479.98px) {\n  .clinic-booking a.apt-btn {\n    width: 100%;\n  }\n}\n.clinic-booking a.apt-btn:hover,\n.clinic-booking a.apt-btn:focus {\n  background-color: #0db9f2;\n  border-color: #0db9f2;\n  color: #ffffff;\n}\n@media (max-width: 479.98px) {\n  .clinic-booking a.view-pro-btn {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n}\n\n.load-more {\n  margin-bottom: 30px;\n}\n\n.filter-contents {\n  border: 2px solid #f3f4f6;\n  border-radius: 10px;\n}\n@media (max-width: 991.98px) {\n  .filter-contents {\n    margin-bottom: 24px;\n  }\n}\n\n.filter-header {\n  background: #f2f6f6;\n  border-radius: 10px 10px 0px 0px;\n  padding: 15px 20px;\n}\n.filter-header .filter-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.filter-details {\n  padding: 20px;\n}\n\n.filter-grid {\n  padding-bottom: 25px;\n}\n.filter-grid h4 {\n  margin-bottom: 0;\n}\n.filter-grid h4 a {\n  font-weight: 600;\n  font-size: 16px;\n  color: #1f2937;\n  position: relative;\n}\n.filter-grid h4 a:hover {\n  color: #272b41;\n}\n.filter-grid h4 a::before {\n  content: \"\\e92e\";\n  font-family: \"feather\";\n  color: #1f2937;\n  border-radius: 50%;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  font-size: 16px;\n  font-weight: 500;\n  position: absolute;\n  right: 0;\n  line-height: normal;\n}\n.filter-grid h4 a:not(.collapsed)::before {\n  content: \"\\e931\";\n  font-family: \"feather\";\n  border-radius: 50%;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.filter-collapse {\n  padding-top: 20px;\n}\n.filter-collapse ul {\n  padding: 0;\n  margin: 0;\n  list-style: 0;\n}\n.filter-collapse ul li {\n  display: block;\n  margin-bottom: 10px;\n}\n.filter-collapse ul li:last-child {\n  margin-bottom: 0;\n}\n.filter-collapse ul li .custom_check {\n  padding-left: 26px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #6b7280;\n  margin-bottom: 0;\n}\n.filter-collapse ul li .custom_check.custom_check .checkmark {\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  height: 17px;\n  width: 17px;\n  top: 3px;\n}\n.filter-collapse ul li .custom_check input:checked ~ .checkmark {\n  background: #ffffff;\n  border-color: #0e82fd;\n}\n.filter-collapse ul li .custom_check .checkmark::after {\n  content: \"\";\n  background: #0e82fd;\n  width: 10px;\n  height: 10px;\n  top: 3px;\n  left: 3px;\n  border-radius: 3px;\n}\n.filter-collapse ul li .custom_check .online-icon {\n  font-size: 20px;\n  margin-right: 10px;\n  margin-left: 5px;\n}\n\n.rating_custom_check {\n  width: 100%;\n}\n.rating_custom_check .rating {\n  width: 100%;\n}\n.rating_custom_check .rating .rating-count {\n  font-weight: 500;\n  float: right;\n  color: #9ca3af;\n}\n\n.filter-content-slider p {\n  color: #1f2937;\n  margin-bottom: 15px;\n}\n.filter-content-slider p span {\n  float: right;\n}\n\n.price-wrapper {\n  margin: 15px 0 0;\n  font-size: 14px;\n}\n.price-wrapper h6 {\n  font-size: 14px;\n  font-weight: 500;\n  color: #6b7280;\n  margin-bottom: 0;\n}\n.price-wrapper h6 span {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.slider-wrapper .ui-slider-handle {\n  background: #0e82fd;\n  border: 0;\n  border-radius: 50%;\n  box-shadow: 0px 4px 4px rgba(124, 124, 124, 0.25);\n  width: 18px;\n  height: 18px;\n  box-shadow: 0 0px 0px 4px #0e82fd;\n  width: 12px;\n  height: 12px;\n  background: #ffffff;\n  margin: 0;\n}\n\n#price-range.ui-slider-horizontal {\n  height: 6px;\n  border: 0;\n  border-radius: 25px;\n  background: #e9ecf1;\n}\n\n.ui-widget-header {\n  background: #0e82fd;\n}\n\n.filter-btn .btn {\n  font-weight: 600;\n  font-size: 15px;\n  padding: 7px 15px;\n  border-radius: 6px;\n}\n\n.doctor-filter-info {\n  padding-bottom: 30px;\n}\n@media (max-width: 767.98px) {\n  .doctor-filter-info {\n    display: none;\n  }\n}\n\n.doctors-found {\n  padding-bottom: 12px;\n}\n.doctors-found p {\n  font-weight: 500;\n  font-size: 16px;\n  margin-bottom: 0;\n}\n.doctors-found p span {\n  color: #1f2937;\n}\n@media (max-width: 1399.98px) {\n  .doctors-found p {\n    font-size: 14px;\n  }\n}\n\n.doctor-filter-availability p {\n  font-weight: 600;\n  color: #4b5563;\n  margin-right: 6px;\n  margin-bottom: 0;\n}\n\n.doctor-filter-option {\n  flex-shrink: 0;\n}\n\n.doctor-filter-sort {\n  padding-right: 15px;\n}\n.doctor-filter-sort:last-child {\n  padding-right: 0;\n}\n.doctor-filter-sort p {\n  color: #8c97b0;\n  margin-right: 15px;\n  margin-bottom: 0;\n}\n.doctor-filter-sort .filter-today {\n  margin-right: 0;\n}\n.doctor-filter-sort .filter-today i {\n  font-size: 18px;\n  margin-right: 10px;\n}\n.doctor-filter-sort .nav li {\n  margin-right: 8px;\n}\n.doctor-filter-sort .nav li:last-child {\n  margin-right: 0;\n}\n.doctor-filter-sort .nav li a {\n  width: 32px;\n  height: 32px;\n  background: #ffffff;\n  border: 2px solid #f3f4f6;\n  border-radius: 7px;\n  color: #6b7280;\n}\n.doctor-filter-sort .nav li a:hover {\n  background: #0e82fd;\n  border: 2px solid #0e82fd;\n  color: #ffffff;\n}\n.doctor-filter-sort .nav li a:hover img {\n  filter: invert(1) brightness(100);\n}\n.doctor-filter-sort .nav li a.active {\n  background: #0e82fd;\n  border: 2px solid #0e82fd;\n  color: #ffffff;\n}\n.doctor-filter-sort .nav li a.active img {\n  filter: invert(1) brightness(100);\n}\n\n.doctor-filter-select {\n  width: 94px;\n}\n.doctor-filter-select .select2-container .select2-selection--single {\n  background-color: #f2f6f6;\n  border: 1px solid #f3f4f6;\n  height: 32px;\n}\n.doctor-filter-select\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__rendered {\n  line-height: 32px;\n  padding-left: 10px;\n  font-weight: 600;\n  color: #1f2937;\n}\n.doctor-filter-select\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow {\n  height: 30px;\n}\n\n.doctor-card {\n  border: 2px solid #f3f4f6;\n  border-radius: 10px;\n}\n\n.doctor-widget-one .doc-name {\n  margin-bottom: 4px;\n  font-size: 20px;\n}\n.doctor-widget-one .doc-name a {\n  color: #1f2937;\n}\n.doctor-widget-one .doc-name i {\n  margin-left: 8px;\n  font-size: 16px;\n  color: #22c550;\n}\n@media (max-width: 991.98px) {\n  .doctor-widget-one .doc-name {\n    font-size: 18px;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-widget-one {\n    text-align: center;\n    flex-direction: column;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-widget-one .doc-info-left {\n    flex-direction: column;\n  }\n}\n.doctor-widget-one .doctor-img {\n  -ms-flex: 0 0 164px;\n  flex: 0 0 164px;\n  margin-right: 20px;\n  width: 164px;\n  height: 164px;\n  border-radius: 10px;\n  position: relative;\n  overflow: hidden;\n}\n.doctor-widget-one .doctor-img img {\n  width: 164px;\n  height: 164px;\n  border-radius: 10px;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n}\n.doctor-widget-one .doctor-img:hover img {\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n@media (max-width: 767.98px) {\n  .doctor-widget-one .doctor-img {\n    margin: 0 auto 20px;\n    padding: 0;\n  }\n}\n.doctor-widget-one .favourite-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 1;\n}\n.doctor-widget-one .favourite-btn .favourite-icon {\n  background-color: #ffffff;\n  border: 1px solid #edf1f1;\n  width: 30px;\n  height: 30px;\n  font-size: 14px;\n  border-radius: 50px;\n  color: #9ca3af;\n  -webkit-transition: all 0.4s ease 0s;\n  -ms-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n.doctor-widget-one .favourite-btn .favourite-icon:hover {\n  color: #fb1612;\n}\n.doctor-widget-one .favourite-btn .favourite-icon.favourite {\n  animation: size 0.4s;\n  color: #ff3333;\n}\n.doctor-widget-one .doc-speciality {\n  font-size: 12px;\n  color: #9ca3af;\n  margin-bottom: 20px;\n}\n.doctor-widget-one .clinic-details {\n  padding-bottom: 14px;\n}\n.doctor-widget-one .doc-info-cont .reviews-ratings p {\n  font-size: 12px;\n}\n.doctor-widget-one .doc-info-cont .reviews-ratings p span {\n  font-size: 14px;\n  margin: 0 4px 0 0;\n  padding: 2px 5px;\n}\n.doctor-widget-one .doc-location {\n  font-weight: 500;\n  margin-bottom: 14px;\n}\n.doctor-widget-one .doc-location:last-child {\n  margin-bottom: 0;\n}\n.doctor-widget-one .doc-location span {\n  color: #1f2937;\n  margin-right: 3px;\n}\n.doctor-widget-one .doc-location i {\n  margin-right: 10px;\n  font-size: 18px;\n  color: #9ca3af;\n}\n@media (max-width: 767.98px) {\n  .doctor-widget-one .doc-location i {\n    margin: 0 0 5px 0;\n    padding: 0;\n  }\n}\n.doctor-widget-one .doc-location a {\n  font-weight: 500;\n  color: #0e82fd;\n  margin-left: 8px;\n}\n.doctor-widget-one .doc-location a:hover {\n  color: #000000;\n}\n@media (max-width: 767.98px) {\n  .doctor-widget-one .doc-location {\n    flex-direction: column;\n  }\n}\n.doctor-widget-one .doc-info-right {\n  margin-left: auto;\n  -ms-flex: 0 0 240px;\n  flex: 0 0 240px;\n  max-width: 240px;\n}\n@media (max-width: 991.98px) {\n  .doctor-widget-one .doc-info-right {\n    -ms-flex: 0 0 270px;\n    flex: 0 0 270px;\n    max-width: 270px;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-widget-one .doc-info-right {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n    margin-left: 0;\n  }\n}\n.doctor-widget-one .doc-info-details {\n  margin-left: auto;\n  max-width: 230px;\n}\n@media (max-width: 767.98px) {\n  .doctor-widget-one .doc-info-details {\n    margin: 0 auto 0;\n    padding: 0;\n  }\n}\n.doctor-widget-one .clini-infos {\n  margin-bottom: 15px;\n}\n.doctor-widget-one .clini-infos ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.doctor-widget-one .clini-infos ul li {\n  color: #6b7280;\n  margin-bottom: 8px;\n}\n.doctor-widget-one .clini-infos ul li:last-child {\n  margin-bottom: 0;\n}\n.doctor-widget-one .clini-infos ul li .available-date {\n  border-radius: 5px;\n  padding: 3px 15px;\n  font-weight: normal;\n}\n.doctor-widget-one .clini-infos ul li .available-today {\n  background: #dcfce5;\n  color: #22c550;\n  font-weight: 500;\n}\n.doctor-widget-one .clini-infos ul li .available-tomorrow {\n  background: #fff6d8;\n  color: #f3db00;\n}\n.doctor-widget-one .clini-infos ul li .available-icon {\n  font-size: 18px;\n  color: #9ca3af;\n  margin-right: 10px;\n}\n.doctor-widget-one .clini-infos ul li .votes {\n  font-size: 12px;\n  color: #9ca3af;\n  margin-left: 5px;\n}\n.doctor-widget-one .clini-infos ul li .available-info-icon {\n  font-size: 14px;\n  color: #9ca3af;\n  margin-left: 5px;\n}\n@media (max-width: 767.98px) {\n  .doctor-widget-one .clini-infos ul li {\n    display: block;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-widget-one .clini-infos {\n    margin: 20px 0 15px 0;\n    padding: 0;\n  }\n}\n.doctor-widget-one .clinic-booking .btn {\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 14px;\n  border: 2px solid #09e5ab;\n  padding: 6px 15px;\n}\n.doctor-widget-one .clinic-booking .btn-primary-light {\n  color: #09e5ab;\n  background: #ffffff;\n  box-shadow: inset 0 0 0 0 #09e5ab;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n  margin-top: 8px;\n}\n.doctor-widget-one .clinic-booking .btn-primary-light:hover {\n  color: #ffffff;\n  background: #09e5ab;\n  box-shadow: inset 0 0 0 50px #09e5ab;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.doctor-widget-one .clinic-booking.book-appoint .btn-primary {\n  color: #fff;\n  background-color: #0e82fd;\n  border: 2px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #fff;\n}\n.doctor-widget-one .clinic-booking.book-appoint .btn-primary:hover {\n  color: #0e82fd;\n  background-color: #ffffff;\n  border-color: #0e82fd;\n  box-shadow: inset 0 0 0 50px #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.doctor-widget-one .clinic-booking.book-appoint .btn-primary-light {\n  color: #0e82fd;\n  background: #ffffff;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  border: 2px solid #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.doctor-widget-one .clinic-booking.book-appoint .btn-primary-light:hover {\n  color: #fff;\n  background-color: #0e82fd;\n  border: 2px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #fff;\n}\n\n.doctor-profile-widget.doc-grid {\n  margin-bottom: 24px;\n}\n.doctor-profile-widget.doc-grid .doc-pro-img .doctor-profile-img {\n  margin: 15px 15px 0;\n}\n.doctor-profile-widget.doc-grid .doc-pro-img .doctor-profile-img img {\n  border-radius: 10px;\n}\n.doctor-profile-widget.doc-grid .doc-pro-img .favourite-btn {\n  top: 15px;\n  right: 25px;\n}\n.doctor-profile-widget.doc-grid .doc-pro-img .reviews-ratings {\n  position: absolute;\n  top: 15px;\n  left: 25px;\n}\n.doctor-profile-widget.doc-grid .doc-pro-img .reviews-ratings p span {\n  min-width: 52px;\n  font-size: 14px;\n  margin: 0;\n  padding: 2px 3px;\n}\n.doctor-profile-widget.doc-grid .doc-content {\n  padding: 15px;\n}\n.doctor-profile-widget.doc-grid .doc-content .review-price p {\n  font-weight: 500;\n  font-size: 18px;\n  color: #28283c;\n}\n.doctor-profile-widget.doc-grid .doc-content .review-price p span {\n  font-size: 13px;\n  color: #6b7280;\n}\n@media (max-width: 1399.98px) {\n  .doctor-profile-widget.doc-grid .doc-content .review-price p {\n    font-size: 14px;\n  }\n}\n.doctor-profile-widget.doc-grid .doc-content .doc-pro-name {\n  width: 100%;\n  overflow: hidden;\n}\n.doctor-profile-widget.doc-grid .doc-content .doc-pro-name h4 {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-right: 2px;\n}\n.doctor-profile-widget.doc-grid .doc-content .doc-pro-name h4 a {\n  margin-right: 6px;\n}\n.doctor-profile-widget.doc-grid .doc-content .doc-pro-name h4 i {\n  color: #22c550;\n}\n.doctor-profile-widget.doc-grid .doc-content .doc-pro-location p {\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n.doctor-profile-widget.doc-grid .doc-content .doc-pro-location p:last-child {\n  margin-bottom: 0;\n}\n.doctor-profile-widget.doc-grid .doc-content .doc-pro-location p i {\n  color: #9ca3af;\n  font-size: 18px;\n}\n.doctor-profile-widget.doc-grid .doc-content .doc-pro-location p span {\n  color: #1f2937;\n  margin-right: 2px;\n}\n.doctor-profile-widget.doc-grid .favourite-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 1;\n}\n.doctor-profile-widget.doc-grid .favourite-btn .favourite-icon {\n  background-color: #ffffff;\n  border: 1px solid #edf1f1;\n  width: 30px;\n  height: 30px;\n  font-size: 14px;\n  border-radius: 50px;\n  color: #484848;\n  -webkit-transition: all 0.4s ease 0s;\n  -ms-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n.doctor-profile-widget.doc-grid .favourite-btn .favourite-icon:hover {\n  color: #fb1612;\n}\n.doctor-profile-widget.doc-grid .favourite-btn .favourite-icon.favourite {\n  animation: size 0.4s;\n  color: #ff3333;\n}\n\n.filter-collapse .more-view {\n  color: #0e82fd;\n}\n\n.more-view {\n  color: #0e82fd;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.fill-more {\n  height: 97px;\n  overflow: hidden;\n  border-bottom: 1px solid #f3f4f6;\n  margin-bottom: 10px !important;\n}\n\n.apply-btn .btn-primary {\n  color: #fff;\n  background-color: #0e82fd;\n  border: 2px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  display: grid;\n}\n.apply-btn .btn-primary:hover {\n  color: #0e82fd;\n  background-color: #ffffff;\n  border-color: #0e82fd;\n  box-shadow: inset 0 0 0 50px #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.apply-btn .btn-outline-primary {\n  color: #0e82fd;\n  background: #ffffff;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  border: 2px solid #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n  display: grid;\n}\n.apply-btn .btn-outline-primary:hover {\n  color: #ffffff;\n  background-color: #0e82fd;\n  border: 2px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #ffffff;\n}\n\n.map-right {\n  height: 100%;\n  min-height: 100%;\n  padding-right: 30px;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1029;\n  display: none;\n}\n.map-right .available-info {\n  margin-bottom: 0;\n}\n@media (max-width: 1199.98px) {\n  .map-right {\n    position: static;\n    height: 450px;\n  }\n}\n.map-right.grid-list-map {\n  display: block;\n  padding-right: 0px;\n  top: 80px;\n}\n\n.map-listing {\n  height: calc(100vh - 0px);\n  width: 100%;\n}\n.map-listing .profile-widget {\n  width: 320px;\n  padding: 0;\n  border: 0;\n  margin-bottom: 0;\n}\n@media (max-width: 1199.98px) {\n  .map-listing {\n    height: 450px;\n  }\n}\n\n.info-widget {\n  border-bottom: 1px solid #f0f0f0;\n  padding-bottom: 30px;\n  margin-bottom: 30px;\n}\n\n.card-label > label {\n  background-color: #ffffff;\n  color: #959595;\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 500;\n  margin: 6px auto auto 8px;\n  padding: 0 7px;\n}\n@media (max-width: 991.98px) {\n  .card-label > label {\n    font-size: 12px;\n  }\n}\n.card-label > input {\n  background-color: #ffffff;\n  border: 1px solid #dbdbdb;\n  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);\n  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);\n  display: block;\n  height: 50px;\n  margin-top: -13px;\n  -webkit-transition: border-color 0.3s;\n  -ms-transition: border-color 0.3s;\n  transition: border-color 0.3s;\n  width: 100%;\n  border-radius: 4px;\n  padding: 5px 15px 0;\n}\n\n.exist-customer a {\n  color: #20c0f3;\n  font-weight: 500;\n}\n\n.payment-widget .payment-list + .payment-list {\n  margin-bottom: 15px;\n}\n\n.payment-radio {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 700;\n  color: #272b41;\n  text-transform: capitalize;\n}\n.payment-radio input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n.payment-radio .checkmark {\n  width: 19px;\n  height: 19px;\n  border: 2px solid #dddddd;\n  border-radius: 50%;\n  -webkit-transition: all 0.3s;\n  -ms-transition: all 0.3s;\n  transition: all 0.3s;\n  margin: 3px 0 0 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.payment-radio .checkmark::after {\n  content: \"\";\n  width: 9px;\n  height: 9px;\n  background-color: #20c0f3;\n  opacity: 0;\n  visibility: hidden;\n  transform: scale(0.1);\n  -webkit-transform: scale(0.1);\n  -ms-transform: scale(0.1);\n  border-radius: 50%;\n  -webkit-transition: all 0.3s;\n  -ms-transition: all 0.3s;\n  transition: all 0.3s;\n  position: absolute;\n  top: 3px;\n  left: 3px;\n}\n.payment-radio input:checked ~ .checkmark {\n  border-color: #20c0f3;\n}\n.payment-radio input:checked ~ .checkmark::after {\n  opacity: 1;\n  visibility: visible;\n  transform: scale(1);\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n}\n\n.booking-date {\n  list-style: none;\n  padding: 0;\n}\n.booking-date li {\n  position: relative;\n  font-size: 14px;\n  font-weight: 500;\n  color: #272b41;\n  text-transform: capitalize;\n  margin-bottom: 15px;\n}\n.booking-date li span {\n  float: right;\n  color: #757575;\n  font-weight: 400;\n  font-size: 15px;\n}\n\n.booking-fee {\n  list-style: none;\n  padding: 0;\n}\n.booking-fee li {\n  position: relative;\n  font-size: 14px;\n  font-weight: 500;\n  color: #272b41;\n  text-transform: capitalize;\n  margin-bottom: 15px;\n}\n.booking-fee li span {\n  float: right;\n  color: #757575;\n  font-weight: 400;\n  font-size: 15px;\n}\n\n.booking-total {\n  border-top: 1px solid #e4e4e4;\n  margin-top: 20px;\n  padding-top: 20px;\n}\n.booking-total ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.booking-total ul li span {\n  font-size: 18px;\n  font-weight: 700;\n  color: #272b41;\n}\n@media (max-width: 767.98px) {\n  .booking-total ul li span {\n    font-size: 14px;\n  }\n}\n.booking-total ul li .total-cost {\n  color: #20c0f3;\n  font-size: 16px;\n  float: right;\n}\n@media (max-width: 767.98px) {\n  .booking-total ul li .total-cost {\n    font-size: 14px;\n  }\n}\n\n#calendar-events {\n  background-color: #fcfcfc;\n}\n\n.calendar-events {\n  border: 1px solid transparent;\n  cursor: move;\n  padding: 10px 15px;\n}\n.calendar-events:hover {\n  border-color: #e9e9e9;\n  background-color: #ffffff;\n}\n.calendar-events i {\n  margin-right: 8px;\n}\n\n.calendar {\n  float: left;\n  margin-bottom: 0;\n}\n\n.fc-toolbar.fc-header-toolbar {\n  margin-bottom: 1.5rem;\n}\n@media (max-width: 479.98px) {\n  .fc-toolbar.fc-header-toolbar .fc-right {\n    margin-bottom: 10px;\n  }\n}\n@media (max-width: 479.98px) {\n  .fc-toolbar.fc-header-toolbar .fc-left {\n    margin-bottom: 10px;\n  }\n}\n.fc-toolbar h2 {\n  font-size: 18px;\n  font-weight: 600;\n  font-family: \"Roboto\", sans-serif;\n  line-height: 30px;\n  text-transform: uppercase;\n}\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active,\n.fc-toolbar .ui-state-hover,\n.fc-toolbar button:hover,\n.fc-toolbar button:focus {\n  z-index: 0;\n}\n\n.none-border .modal-footer {\n  border-top: none;\n}\n\n.fc-day-grid-event .fc-time {\n  font-family: \"Roboto\", sans-serif;\n}\n\n.fc-day {\n  background: #ffffff;\n}\n\n.fc th.fc-widget-header {\n  background: #eeeeee;\n  font-size: 14px;\n  line-height: 20px;\n  text-transform: uppercase;\n  padding: 10px 0;\n}\n\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n  border-color: #f3f3f3;\n}\n.fc-unthemed .fc-today {\n  background: #ffffff;\n}\n\n.fc-basic-view .fc-day-number,\n.fc-basic-view .fc-week-number {\n  padding: 2px 5px;\n}\n.fc-basic-view td.fc-week-number span {\n  padding-right: 8px;\n  font-weight: 700;\n  font-family: \"Roboto\", sans-serif;\n}\n.fc-basic-view td.fc-day-number {\n  padding-right: 8px;\n  font-weight: 700;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.fc-button {\n  background: #f1f1f1;\n  border: none;\n  color: #797979;\n  text-transform: capitalize;\n  box-shadow: none !important;\n  border-radius: 3px !important;\n  height: auto !important;\n  margin: 0 3px !important;\n  padding: 6px 12px !important;\n}\n\n.fc-text-arrow {\n  font-family: inherit;\n  font-size: 16px;\n}\n\n.fc-state-hover {\n  background: #f3f3f3;\n}\n\n.fc-state-highlight {\n  background: #f0f0f0;\n}\n\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n  background-color: #20c0f3 !important;\n  color: #ffffff !important;\n  text-shadow: none !important;\n}\n\n.fc-cell-overlay {\n  background: #f0f0f0;\n}\n\n.fc-event {\n  border: none;\n  color: #ffffff !important;\n  cursor: move;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  margin: 1px 7px;\n  padding: 5px 5px;\n}\n\n.event-form .input-group .form-control {\n  height: 40px;\n}\n\n.comp-header {\n  margin-bottom: 1.875rem;\n}\n.comp-header .comp-title {\n  color: #272b41;\n}\n\n.line {\n  background-color: #20c0f3;\n  height: 2px;\n  margin: 0;\n  width: 60px;\n}\n\n.comp-buttons .btn {\n  margin-bottom: 5px;\n}\n\n.pagination-box .pagination {\n  margin-top: 0;\n}\n\n.comp-dropdowns .btn-group {\n  margin-bottom: 5px;\n}\n\n.progress-example .progress {\n  margin-bottom: 1.5rem;\n}\n\n.progress-xs {\n  height: 4px;\n}\n\n.progress-sm {\n  height: 15px;\n}\n\n@media (max-width: 575.98px) {\n  .progress-lg .page-link {\n    font-size: 16px;\n    padding: 0.5rem 0.625rem;\n  }\n}\n\n.progress.progress-sm {\n  height: 6px;\n}\n.progress.progress-md {\n  height: 8px;\n}\n.progress.progress-lg {\n  height: 18px;\n}\n\n.row.row-sm {\n  margin-left: -3px;\n  margin-right: -3px;\n}\n.row.row-sm > div {\n  padding-left: 3px;\n  padding-right: 3px;\n}\n\n@media (max-width: 575.98px) {\n  .pagination-lg .page-link {\n    font-size: 16px;\n    padding: 0.5rem 0.625rem;\n  }\n}\n\n.custom-edit-service textarea.form-control {\n  min-height: 200px;\n}\n.custom-edit-service .service-upload {\n  border: 1px solid #dcdcdc;\n  border-radius: 0.25rem;\n  text-align: center;\n  background-color: #ffffff;\n  position: relative;\n  margin: 0 0 30px;\n  padding: 70px 0;\n}\n.custom-edit-service .service-upload i {\n  font-size: 50px;\n  color: #858585;\n}\n.custom-edit-service .service-upload span {\n  font-size: 15px;\n  color: #858585;\n  margin-top: 14px;\n  display: block;\n}\n.custom-edit-service .service-upload input[type=\"file\"] {\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.upload-wrap li {\n  margin: 10px;\n  list-style: none;\n}\n.upload-wrap li:first-child {\n  margin-left: 0;\n}\n\n.invoice-content {\n  background-color: #ffffff;\n  border: 1px solid #f0f0f0;\n  margin-bottom: 30px;\n  border-radius: 4px;\n  padding: 30px;\n}\n@media (max-width: 575.98px) {\n  .invoice-content {\n    padding: 1.25rem;\n  }\n}\n\n.invoice-item .invoice-logo {\n  margin-bottom: 30px;\n}\n.invoice-item .invoice-logo img {\n  width: auto;\n  max-height: 52px;\n}\n.invoice-item .invoice-text {\n  padding-top: 42px;\n  padding-bottom: 36px;\n}\n.invoice-item .invoice-text h2 {\n  color: #272b41;\n  font-size: 36px;\n  font-weight: 600;\n}\n.invoice-item .invoice-details {\n  text-align: right;\n  color: #757575;\n  font-weight: 500;\n}\n@media (max-width: 767.98px) {\n  .invoice-item .invoice-details {\n    text-align: left;\n  }\n}\n.invoice-item .invoice-details strong {\n  color: #272b41;\n}\n.invoice-item .invoice-details-two {\n  text-align: left;\n}\n.invoice-item .customer-text {\n  font-size: 18px;\n  color: #272b41;\n  font-weight: 700;\n  margin-bottom: 8px;\n  display: block;\n}\n@media (max-width: 767.98px) {\n  .invoice-item .customer-text {\n    font-size: 16px;\n  }\n}\n\n.invoice-info {\n  margin-bottom: 30px;\n}\n.invoice-info p {\n  margin-bottom: 0;\n}\n.invoice-info.invoice-info2 {\n  text-align: right;\n}\n@media (max-width: 767.98px) {\n  .invoice-info.invoice-info2 {\n    text-align: left;\n  }\n}\n.invoice-info h5 {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.invoice-table tr th,\n.invoice-table tr td,\n.invoice-table-two tr th,\n.invoice-table-two tr td {\n  color: #272b41;\n  font-weight: 700;\n  line-height: inherit;\n  padding: 10px 20px;\n}\n.invoice-table tr td,\n.invoice-table-two tr td {\n  color: #757575;\n  font-weight: 500;\n}\n\n.invoice-table-two {\n  margin-bottom: 0;\n}\n.invoice-table-two tr th,\n.invoice-table-two tr td {\n  border-top: 0;\n}\n.invoice-table-two tr td {\n  text-align: right;\n}\n\n.other-info {\n  margin-top: 10px;\n}\n\n.terms-text {\n  margin-bottom: 20px;\n}\n.terms-text h4 {\n  font-size: 24px;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n.terms-text p {\n  color: #666;\n  display: inline-block;\n  font-size: 16px;\n}\n\n.account-card {\n  border-radius: 10px;\n  font-size: 16px;\n  text-align: center;\n  margin: 0 0 30px;\n  padding: 10px;\n}\n.account-card span {\n  font-size: 24px;\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.info-list {\n  margin-bottom: 10px;\n}\n.info-list .title {\n  color: #272b41;\n  font-weight: 500;\n}\n.info-list .text {\n  color: #757575;\n  display: block;\n  overflow: hidden;\n}\n\n.banner-wrapper {\n  max-width: 800px;\n  width: 100%;\n  margin: 0 auto;\n}\n@media (max-width: 991.98px) {\n  .banner-wrapper {\n    max-width: 720px;\n  }\n}\n.banner-wrapper .search-box-3 {\n  background: #1e5c92;\n  border-radius: 10px;\n  position: absolute;\n  margin: -50px 0 0;\n  padding: 40px 20px;\n}\n@media (max-width: 991.98px) {\n  .banner-wrapper .search-box-3 {\n    display: none;\n  }\n}\n.banner-wrapper .search-box-3 .search-location {\n  -ms-flex: 0 0 240px;\n  flex: 0 0 240px;\n  margin-right: 12px;\n  position: relative;\n  width: 240px;\n}\n.banner-wrapper .search-box-3 .search-location .form-control {\n  background: #ffffff url(../images/location.png) no-repeat 10px center;\n}\n.banner-wrapper .search-box-3 .form-group {\n  margin-bottom: 0px;\n}\n.banner-wrapper .search-box-3 .form-control {\n  border: 1px solid #cccccc;\n  box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.08);\n  border-radius: 5px;\n  padding-left: 35px;\n}\n.banner-wrapper .search-box-3 .search-info {\n  -ms-flex: 0 0 490px;\n  flex: 0 0 490px;\n  margin-right: 12px;\n  position: relative;\n  width: 490px;\n}\n.banner-wrapper .search-box-3 .search-info .form-control {\n  background: #ffffff url(../images/search.png) no-repeat 10px center;\n}\n.banner-wrapper .search-box-3 .form-control {\n  background: #ffffff url(../images/search.png) no-repeat 10px center;\n}\n.banner-wrapper .search-box-3 .search-btn {\n  width: 46px;\n  -ms-flex: 0 0 46px;\n  flex: 0 0 46px;\n  height: 46px;\n}\n.banner-wrapper .search-box-3 .search-btn span {\n  display: none;\n  font-weight: 500;\n}\n\n.btn-search {\n  background: #ffffff;\n  border: 1px solid #ffffff;\n  color: #1e5c92;\n}\n\n.form-custom i {\n  color: #dd2d4e;\n  position: absolute;\n  top: 35%;\n  right: 15px;\n}\n\n.doctor-search-form select {\n  border: 1px solid rgba(16, 222, 253, 0.1);\n  box-shadow: 0px 4px 4px rgba(237, 237, 237, 0.25);\n  border-radius: 5px;\n}\n\n.doctor-search-form input {\n  border: 1px solid rgba(16, 222, 253, 0.1);\n  box-shadow: 0px 4px 4px rgba(237, 237, 237, 0.25);\n  border-radius: 5px;\n}\n\n.doctor-search-form input,\n.doctor-search-form select {\n  background: #ffffff;\n  border-radius: 130px;\n  min-height: 60px;\n  border: 0;\n}\n\n.doctor-search-section {\n  padding-top: 95px;\n  position: relative;\n  background: url(../images/banner-2.jpg);\n  background-position: 50% 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  z-index: 1;\n}\n@media (max-width: 991.98px) {\n  .doctor-search-section {\n    padding-top: 85px;\n  }\n}\n.doctor-search-section .doctor-search {\n  padding-bottom: 15px;\n}\n@media (max-width: 991.98px) {\n  .doctor-search-section .doctor-search {\n    padding: 30px 0;\n  }\n}\n.doctor-search-section .banner-header h2 {\n  color: #186db5;\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 54px;\n}\n@media (max-width: 767.98px) {\n  .doctor-search-section .banner-header h2 {\n    font-size: 26px;\n    line-height: 40px;\n  }\n}\n.doctor-search-section .doctor-search-form select,\n.doctor-search-section .doctor-search-form input {\n  border: 1px solid rgba(16, 222, 253, 0.1);\n  box-shadow: 0px 4px 4px rgba(237, 237, 237, 0.25);\n  border-radius: 5px;\n}\n@media (max-width: 991.98px) {\n  .doctor-search-section .dr-img {\n    display: none;\n  }\n}\n\n.clinics-section {\n  padding: 60px 0 40px;\n  background: #ffffff;\n}\n@media (max-width: 991.98px) {\n  .clinics-section {\n    padding: 40px 0 25px;\n  }\n}\n@media (max-width: 767.98px) {\n  .clinics-section {\n    padding: 30px 0 10px;\n  }\n}\n.clinics-section .clinic-item:hover .clinics-card .clinics-img:after {\n  background: rgba(45, 226, 253, 0.9);\n  transition: all 0.5s;\n}\n.clinics-section .clinic-item:hover .clinics-icon {\n  transform: translate(0, -180%);\n  -webkit-transform: translate(0, -180%);\n  -ms-transform: translate(0, -180%);\n}\n.clinics-section .clinic-item:hover .clinics-icon i {\n  color: #1c5b90;\n  background: #ffffff;\n}\n.clinics-section .clinics-card {\n  position: relative;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.clinics-section .clinics-card .clinics-img {\n  position: relative;\n}\n.clinics-section .clinics-card .clinics-img:after {\n  content: \"\";\n  background: rgba(28, 91, 144, 0.9);\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.clinics-section .clinics-card .clinics-info {\n  margin: 0 auto;\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  left: 0;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n}\n.clinics-section .clinics-card .clinics-info img {\n  width: 60px !important;\n  margin: auto;\n  margin-bottom: 10px;\n}\n.clinics-section .clinics-card .clinics-info span {\n  font-weight: 600;\n  font-size: 18px;\n  color: #ffffff;\n}\n.clinics-section .clinics-icon {\n  transform: translate(0, -50%);\n  -webkit-transform: translate(0, -50%);\n  -ms-transform: translate(0, -50%);\n  -webkit-transition: all 0.3s ease 0s;\n  -ms-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n.clinics-section .clinics-icon i {\n  border-radius: 50%;\n  height: 35px;\n  width: 35px;\n  text-align: center;\n  line-height: 35px;\n  background: #10defd;\n  color: #ffffff;\n  margin: auto;\n  display: block;\n}\n\n.section-heading {\n  margin-bottom: 30px;\n}\n@media (max-width: 767.98px) {\n  .section-heading {\n    margin-bottom: 15px;\n  }\n}\n.section-heading h2 {\n  font-weight: 700;\n  font-size: 26px;\n  color: #1c5b90;\n}\n@media (max-width: 767.98px) {\n  .section-heading h2 {\n    font-size: 20px;\n  }\n}\n.section-heading p {\n  font-size: 14px;\n  color: #757578;\n  margin-bottom: 0;\n}\n.section-heading.bg-area h2 {\n  color: #ffffff;\n}\n.section-heading.bg-area p {\n  color: #ffffff;\n}\n\n.specialities-section {\n  padding: 80px 0 55px;\n  position: relative;\n  background: url(../images/specialist-bg.jpg);\n  background-position: 50% 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  z-index: 1;\n}\n@media (max-width: 991.98px) {\n  .specialities-section {\n    padding: 60px 0 35px;\n  }\n}\n@media (max-width: 767.98px) {\n  .specialities-section {\n    padding: 40px 0 15px;\n  }\n}\n.specialities-section:after {\n  content: \"\";\n  background: rgba(25, 69, 107, 0.9);\n  z-index: -1;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.specialities-section .specialist-card {\n  background: #ffffff;\n  box-shadow: 0px 4px 24px rgba(183, 183, 183, 0.25);\n  border-radius: 163px;\n  align-items: center;\n  margin: 0 0 25px;\n  padding: 15px;\n}\n.specialities-section .specialist-card:hover {\n  background: #e0f2ff;\n}\n.specialities-section .specialist-card:hover .specialist-img {\n  background: #10defd;\n  transition: all 0.5s;\n}\n.specialities-section .specialist-card:hover .specialist-nav i {\n  background: #10defd;\n  color: #ffffff;\n}\n.specialities-section .specialist-card .specialist-img {\n  background: #1b5d92;\n  height: 55px;\n  width: 55px;\n  border-radius: 50%;\n  -webkit-transition: all 0.3s ease 0s;\n  -ms-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n  margin: 0 10px 0 0;\n  padding: 10px;\n}\n.specialities-section .specialist-card .specialist-info p {\n  font-weight: 500;\n  color: #000000;\n  margin-bottom: 0;\n}\n.specialities-section .specialist-card .specialist-info h4 {\n  font-weight: 600;\n  color: #274782;\n  margin-bottom: 0;\n}\n.specialities-section .specialist-card .specialist-nav i {\n  border-radius: 50%;\n  height: 35px;\n  width: 35px;\n  text-align: center;\n  line-height: 35px;\n  background: #ffffff;\n  box-shadow: 0px 4px 24px rgba(183, 183, 183, 0.25);\n  color: #d84153;\n  margin: auto;\n  display: block;\n  -webkit-transition: all 0.3s ease 0s;\n  -ms-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n\n.shapes {\n  position: absolute;\n  width: 100%;\n}\n@media (max-width: 991.98px) {\n  .shapes {\n    display: none;\n  }\n}\n.shapes .shape-1 {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.shapes .shape-2 {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.shapes .shape-3 {\n  position: absolute;\n  top: -110px;\n  left: 0;\n}\n.shapes .shape-4 {\n  position: absolute;\n  top: -110px;\n  right: 0;\n}\n\n.our-doctors-section {\n  padding: 60px 0;\n  background: #ffffff;\n}\n@media (max-width: 991.98px) {\n  .our-doctors-section {\n    padding: 40px 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .our-doctors-section {\n    padding: 30px 0;\n  }\n}\n.our-doctors-section .our-doctors-card {\n  background: rgba(232, 246, 255, 0.4);\n  border: 1px solid rgba(231, 237, 255, 0.5);\n  border-radius: 10px;\n  padding: 10px;\n}\n.our-doctors-section .our-doctors-card .doctors-header {\n  position: relative;\n}\n.our-doctors-section .our-doctors-card .doctors-header img {\n  border-radius: 10px 10px 0 0;\n}\n.our-doctors-section .our-doctors-card .doctors-header .img-overlay {\n  background: #1b5d92;\n  border-radius: 110px;\n  padding: 5px 10px;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 14px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n.our-doctors-section .our-doctors-card .doctors-body {\n  background: #ffffff;\n  border-radius: 0px 0px 10px 10px;\n  padding: 10px;\n}\n.our-doctors-section .our-doctors-card .doctors-body .rating {\n  font-size: 12px;\n}\n.our-doctors-section .our-doctors-card .doctors-body .rating i.filled {\n  color: #ffc001;\n}\n.our-doctors-section .our-doctors-card .doctors-body .rating .average-ratings {\n  background: #1c5b90;\n  border-radius: 70px;\n  color: #ffffff;\n  padding: 1px 15px;\n  margin-left: 10px;\n}\n.our-doctors-section .our-doctors-card .doctors-body h4 {\n  color: #1c1c1c;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n.our-doctors-section .our-doctors-card .doctors-body h4:hover {\n  color: #0e82fd;\n}\n.our-doctors-section .our-doctors-card .doctors-body p {\n  font-weight: 500;\n  margin-bottom: 0;\n  font-size: 11px;\n}\n.our-doctors-section .our-doctors-card .doctors-body .location {\n  padding: 20px 0;\n}\n.our-doctors-section .our-doctors-card .doctors-body .location p {\n  font-size: 13px;\n  color: #000000;\n}\n.our-doctors-section .our-doctors-card .doctors-body .location p i {\n  color: #1c5b90;\n}\n.our-doctors-section .our-doctors-card .doctors-body .view-btn {\n  background: #e8f6ff;\n  border: 1px solid #e8f6ff;\n  box-sizing: border-box;\n  border-radius: 30px;\n  color: rgba(41, 68, 129, 0.9);\n  padding: 10px 0;\n}\n.our-doctors-section .our-doctors-card .doctors-body .view-btn:hover {\n  background-color: #0e82fd;\n  color: #ffffff;\n}\n.our-doctors-section .our-doctors-card .doctors-body .book-btn {\n  background: #10defd;\n  border-radius: 30px;\n  padding: 10px 0;\n  border: 0;\n}\n.our-doctors-section .our-doctors-card .doctors-body .book-btn:hover {\n  background-color: #0e82fd;\n}\n\n.clinic-features-section {\n  position: relative;\n  background: url(../images/featured-bg.jpg);\n  background-position: 50% 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  padding: 60px 0;\n}\n@media (max-width: 991.98px) {\n  .clinic-features-section {\n    padding: 40px 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .clinic-features-section {\n    padding: 30px 0;\n  }\n}\n.clinic-features-section .clinic-features {\n  position: relative;\n}\n.clinic-features-section .clinic-features img {\n  border-radius: 10px;\n}\n.clinic-features-section .clinic-feature-overlay {\n  text-align: center;\n  width: 100%;\n  position: absolute;\n  bottom: 20px;\n}\n.clinic-features-section .clinic-feature-overlay .img-overlay {\n  background: #20c0f3;\n  border-radius: 60px;\n  padding: 10px 15px;\n  text-transform: uppercase;\n  color: #e6f4fd;\n  font-weight: 600;\n  min-width: 150px;\n  display: inline-block;\n}\n.clinic-features-section .clinic-feature-overlay .img-overlay:hover {\n  background-color: #0e82fd;\n}\n\n.section-search-3 {\n  position: relative;\n  background: url(../images/banner-3.jpg);\n  background-position: 50% 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  z-index: 1;\n  min-height: 450px;\n  padding-top: 85px;\n}\n.section-search-3:after {\n  content: \"\";\n  background: rgba(24, 96, 202, 0.9);\n  z-index: -1;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.section-search-3 .banner-info {\n  padding: 130px 0 190px;\n}\n@media (max-width: 991.98px) {\n  .section-search-3 .banner-info {\n    padding: 60px 0 130px;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-search-3 .banner-info {\n    padding: 20px 0 100px;\n  }\n}\n@media (max-width: 479.98px) {\n  .section-search-3 .banner-info {\n    padding: 20px 0 70px;\n  }\n}\n.section-search-3 .banner-info .header-banner h2 {\n  color: #ffffff;\n  font-weight: 600;\n  line-height: 40px;\n}\n.section-search-3 .banner-info .header-banner h2 .header-highlight {\n  font-weight: 700;\n  color: #ffffff;\n}\n.section-search-3 .banner-info .header-banner p {\n  font-size: 17px;\n  color: #ffffff;\n}\n.section-search-3 .doctor-search {\n  padding-bottom: 15px;\n}\n@media (max-width: 991.98px) {\n  .section-search-3 .doctor-search {\n    padding: 30px 0;\n  }\n}\n.section-search-3 .doctor-search .doctor-search-form.trans .form-control {\n  color: #ffffff;\n}\n.section-search-3 .doctor-search .doctor-search-form.trans input,\n.section-search-3 .doctor-search .doctor-search-form.trans select {\n  background-color: transparent;\n  border: 2px solid #c2d6f3 !important;\n  border-radius: 130px;\n  min-height: 60px;\n  border: 0;\n  box-shadow: 0px 4px 4px rgba(237, 237, 237, 0.25);\n  border-radius: 5px;\n}\n.section-search-3 .doctor-search .doctor-search-form.trans input::placeholder,\n.section-search-3 .doctor-search .doctor-search-form.trans select::placeholder {\n  color: #ffffff;\n}\n.section-search-3 .doctor-search .doctor-search-form.trans .form-custom i {\n  color: #ffffff;\n}\n.section-search-3 .doctor-search .doctor-search-form.trans .banner-btn {\n  background-color: #13a5e5;\n}\n.section-search-3 .doctor-search .doctor-search-form.trans .banner-btn:hover {\n  background-color: #1c5b91;\n}\n@media (max-width: 991.98px) {\n  .section-search-3 .doctor-search .doctor-search-form.trans .banner-btn {\n    padding: 18px 30px;\n  }\n}\n\n.doctor-category {\n  position: relative;\n  margin-top: -130px;\n  z-index: 9;\n  padding: 60px 0;\n}\n@media (max-width: 767.98px) {\n  .doctor-category {\n    padding: 40px 0 10px;\n    margin-top: -110px;\n  }\n}\n.doctor-category .pop-box {\n  background-color: #ffffff;\n  padding: 15px 15px 0;\n  border-radius: 5px;\n  box-shadow: 0px 4px 44px rgba(219, 219, 219, 0.25);\n}\n@media (max-width: 767.98px) {\n  .doctor-category .pop-box {\n    margin-bottom: 30px;\n  }\n}\n.doctor-category .pop-box .top-section {\n  background-color: #e5f6fd;\n  padding: 20px;\n  min-height: 150px;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n}\n.doctor-category .pop-box .top-section i {\n  background-color: #ffffff;\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  font-size: 30px;\n  color: #20c0f3;\n  border: 5px solid #f5f8f9;\n}\n.doctor-category .pop-box .top-section.three {\n  background-color: #ffe0e7;\n}\n.doctor-category .pop-box .top-section.three i {\n  color: #ffaabd;\n}\n.doctor-category .pop-box .top-section.two {\n  background-color: #fff1c9;\n}\n.doctor-category .pop-box .top-section.two i {\n  color: #ffbd07;\n}\n.doctor-category .pop-box .body-section {\n  padding: 20px;\n  min-height: 200px;\n  flex-direction: column;\n}\n.doctor-category .pop-box .body-section h3 {\n  color: #2467ca;\n  font-weight: 600;\n  font-size: 24px;\n}\n@media (max-width: 991.98px) {\n  .doctor-category .pop-box .body-section h3 {\n    font-size: 20px;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-category .pop-box .body-section h3 {\n    font-size: 18px;\n  }\n}\n.doctor-category .pop-box .body-section p {\n  color: #1c5b91;\n  font-weight: 500;\n}\n.doctor-category .pop-box .body-section .book-btn {\n  width: 150px;\n  margin: 0 auto;\n  border-radius: 30px;\n  background: #2467ca;\n  border: 1px solid #2467ca;\n}\n.doctor-category .pop-box .body-section .book-btn:hover {\n  background: #1c5b91;\n  border-color: #1c5b91;\n}\n\n.section-header-three {\n  margin-bottom: 60px;\n}\n@media (max-width: 767.98px) {\n  .section-header-three {\n    margin-bottom: 40px;\n  }\n}\n@media (max-width: 479.98px) {\n  .section-header-three {\n    margin-bottom: 30px;\n  }\n}\n.section-header-three h2 {\n  color: #2868c8;\n  font-weight: 700;\n  font-size: 30px;\n  position: relative;\n  display: inline-block;\n}\n@media (max-width: 991.98px) {\n  .section-header-three h2 {\n    font-size: 28px;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-header-three h2 {\n    font-size: 24px;\n  }\n}\n@media (max-width: 479.98px) {\n  .section-header-three h2 {\n    font-size: 15px;\n  }\n}\n.section-header-three h2:before {\n  content: \"\";\n  width: 13px;\n  height: 13px;\n  background: #1c5b91;\n  border-radius: 50%;\n  box-shadow: 15px 0px 0px -2px #1c5b91;\n  position: absolute;\n  top: 12px;\n  left: -40px;\n}\n.section-header-three h2:after {\n  width: 13px;\n  height: 13px;\n  content: \"\";\n  background: #1c5b91;\n  border-radius: 50%;\n  box-shadow: -15px 0px 0px -2px #1c5b91;\n  position: absolute;\n  top: 12px;\n  right: -40px;\n}\n.section-header-three h2 img {\n  margin: 2px 5px 5px;\n}\n.section-header-three p {\n  color: #757575;\n  font-size: 16px;\n  max-width: 600px;\n  margin: 15px auto 0;\n}\n@media (max-width: 767.98px) {\n  .section-header-three p {\n    font-size: 14px;\n  }\n}\n@media (max-width: 479.98px) {\n  .section-header-three p {\n    font-size: 11px;\n  }\n}\n\n.clinic-specialities {\n  background: url(../images/special-banner.jpg);\n  padding: 60px 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n@media (max-width: 767.98px) {\n  .clinic-specialities {\n    padding: 40px 0;\n  }\n}\n.clinic-specialities .special-box {\n  background-color: #ffffff;\n  border-radius: 10px;\n  height: 160px;\n  cursor: pointer;\n  margin-bottom: 30px;\n  transition: all 0.7s;\n}\n.clinic-specialities .special-box .special-body {\n  padding: 20px;\n  transition: all 0.5s;\n}\n.clinic-specialities .special-box .special-body img {\n  width: 50px;\n  margin-bottom: 15px;\n}\n.clinic-specialities .special-box .special-body h4 {\n  font-size: 16px;\n  margin: 0;\n  font-weight: 500;\n}\n@media (max-width: 479.98px) {\n  .clinic-specialities .special-box .special-body h4 {\n    font-size: 15px;\n  }\n}\n.clinic-specialities .special-box .special-body .spc-book {\n  background-color: #ffffff;\n  padding: 10px 15px;\n  min-width: 120px;\n  color: #1c5b91;\n  border-radius: 30px;\n  font-size: 14px;\n  font-weight: 600;\n  display: none;\n}\n.clinic-specialities .special-box .special-body .spc-book i {\n  background-color: #1c5b91;\n  color: #ffffff;\n  border-radius: 50%;\n  width: 12px;\n  height: 12px;\n  font-size: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.clinic-specialities .special-box .special-footer {\n  border-top: 1px solid #eaeaea;\n  width: 100%;\n  margin: 0;\n  padding: 15px;\n}\n.clinic-specialities .special-box .special-footer .doc-count {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1c71ef;\n}\n@media (max-width: 479.98px) {\n  .clinic-specialities .special-box .special-footer .doc-count {\n    font-size: 13px;\n  }\n}\n.clinic-specialities .special-box .special-footer .doc-count span {\n  color: #6b7280;\n  font-weight: 500;\n}\n.clinic-specialities .special-box .special-footer .clin-count {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1c71ef;\n}\n@media (max-width: 479.98px) {\n  .clinic-specialities .special-box .special-footer .clin-count {\n    font-size: 13px;\n  }\n}\n.clinic-specialities .special-box .special-footer .clin-count span {\n  color: #6b7280;\n  font-weight: 500;\n}\n.clinic-specialities .special-box:hover {\n  background-color: #1c71ef;\n  -webkit-transition: all 0.7s;\n  -ms-transition: all 0.7s;\n  transition: all 0.7s;\n}\n.clinic-specialities .special-box:hover .special-body {\n  height: 100%;\n  flex-direction: column;\n}\n.clinic-specialities .special-box:hover .special-body h4 {\n  color: #ffffff;\n}\n.clinic-specialities .special-box:hover .spc-book {\n  margin-top: 10px;\n  display: block;\n}\n.clinic-specialities .special-box:hover img {\n  display: none;\n}\n.clinic-specialities .special-box:hover .special-footer {\n  display: none;\n}\n\n.view-all-more .btn {\n  background: #1b5d92;\n  border-radius: 30px;\n  border-color: #1b5d92;\n  margin: 20px 0 0;\n  padding: 9px 30px;\n}\n@media (max-width: 479.98px) {\n  .view-all-more .btn {\n    font-size: 14px;\n    padding: 6px 20px;\n  }\n}\n.view-all-more .btn:hover {\n  background-color: #0e82fd;\n  border: 1px solid #0e82fd;\n}\n\n.browse-section {\n  background-color: #e5f6fd;\n  padding: 60px 0;\n}\n@media (max-width: 767.98px) {\n  .browse-section {\n    padding: 40px 0;\n  }\n}\n.browse-section .brower-box {\n  text-align: center;\n  border-radius: 10px;\n  border: 6px solid #ffffff;\n  background-color: #ffffff;\n  margin-bottom: 20px;\n}\n.browse-section .brower-box > div {\n  border-radius: 15px;\n  background-color: #e5f6fd;\n  height: 100%;\n  padding: 15px;\n}\n.browse-section .brower-box > div .brower-img {\n  background-color: #1c71ef;\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  margin: 0 auto 20px;\n}\n.browse-section .brower-box > div .brower-img img {\n  width: auto;\n}\n.browse-section .brower-box > div h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #2264c5;\n}\n.browse-section .brower-box > div p {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e74e84;\n  margin: 0;\n}\n\n@media (max-width: 767.98px) {\n  .doctor-divison .d-flex {\n    display: block !important;\n  }\n}\n.doctor-divison .doc-background {\n  background: url(../images/shapes/doctor-bg.jpg);\n  background-position: center;\n  min-height: 350px;\n  background-size: cover;\n  padding: 40px 30px;\n  flex-direction: column;\n  position: relative;\n  z-index: 1;\n}\n@media (max-width: 991.98px) {\n  .doctor-divison .doc-background {\n    min-height: 250px;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-divison .doc-background {\n    padding: 20px 15px;\n    min-height: 200px;\n  }\n}\n.doctor-divison .doc-background::before {\n  content: \"\";\n  background: rgba(61, 59, 59, 0.84);\n  z-index: -1;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.doctor-divison h3 {\n  font-size: 28px;\n  color: #ffffff;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n@media (max-width: 991.98px) {\n  .doctor-divison h3 {\n    font-size: 20px;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-divison h3 {\n    font-size: 16px;\n  }\n}\n@media (max-width: 479.98px) {\n  .doctor-divison h3 {\n    font-size: 14px;\n    margin-bottom: 15px;\n  }\n}\n.doctor-divison p {\n  font-size: 14px;\n  color: #ffffff;\n  margin-bottom: 30px;\n}\n@media (max-width: 991.98px) {\n  .doctor-divison p {\n    font-size: 12px;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-divison p {\n    font-size: 11px;\n  }\n}\n@media (max-width: 479.98px) {\n  .doctor-divison p {\n    font-size: 10px;\n    margin-bottom: 20px;\n  }\n}\n.doctor-divison .doc-bok-btn {\n  font-size: 14px;\n  padding: 6px 12px;\n  color: #ffffff;\n  background-color: #1c71ef;\n  border-radius: 30px;\n  width: 100px;\n  text-align: center;\n}\n@media (max-width: 479.98px) {\n  .doctor-divison .doc-bok-btn {\n    font-size: 12px;\n    padding: 5px 10px;\n  }\n}\n.doctor-divison .doc-bok-btn:hover {\n  color: #1c71ef;\n  background: #ffffff;\n}\n.doctor-divison .pat-background {\n  background: url(../images/shapes/doctor-right-bg.jpg);\n  background-position: center;\n  min-height: 350px;\n  background-size: cover;\n  padding: 40px 30px;\n  flex-direction: column;\n  position: relative;\n  z-index: 1;\n}\n@media (max-width: 991.98px) {\n  .doctor-divison .pat-background {\n    min-height: 250px;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-divison .pat-background {\n    padding: 20px 15px;\n    min-height: 200px;\n  }\n}\n.doctor-divison .pat-background.pat-background::before {\n  content: \"\";\n  background: rgba(28, 113, 239, 0.9);\n  z-index: -1;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.doctor-divison .pat-background .doc-bok-btn {\n  background-color: #1b5d92;\n}\n.doctor-divison .pat-background .doc-bok-btn:hover {\n  color: #1c71ef;\n  background: #ffffff;\n}\n\n.book-section {\n  background: url(../images/special-banner.jpg);\n  padding: 60px 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n@media (max-width: 767.98px) {\n  .book-section {\n    padding: 40px 0;\n  }\n}\n.book-section .book-best-doctors {\n  margin-bottom: 30px;\n}\n.book-section .book-best-doctors .book-header img {\n  border-radius: 10px 10px 0px 0px;\n  width: 100%;\n}\n.book-section .book-best-doctors .book-header .img-overlay {\n  background: #13a5e5;\n  border-radius: 50%;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 14px;\n  width: 25px;\n  height: 25px;\n  position: absolute;\n  top: 10px;\n  right: 20px;\n}\n.book-section .book-best-doctors .book-header .img-overlay i {\n  font-size: 12px;\n}\n.book-section .book-best-doctors .doctors-body {\n  background-color: #ffffff;\n  padding: 0;\n  box-shadow: 0px -6px 54px rgba(152, 152, 152, 0.25);\n  border-radius: 0;\n}\n.book-section .book-best-doctors .doctors-body .inner-section {\n  padding: 15px 15px 0;\n}\n.book-section .book-best-doctors .doctors-body .inner-section > span {\n  color: #e74e84;\n  font-size: 14px;\n}\n@media (max-width: 767.98px) {\n  .book-section .book-best-doctors .doctors-body .inner-section > span {\n    font-size: 12px;\n  }\n}\n.book-section .book-best-doctors .doctors-body .rating {\n  font-size: 12px;\n}\n.book-section .book-best-doctors .doctors-body .rating i {\n  font-size: 10px;\n  color: #dfdfdf;\n  margin-bottom: 10px;\n}\n.book-section .book-best-doctors .doctors-body .rating i.filled {\n  color: #fed35d;\n}\n.book-section .book-best-doctors .doctors-body .rating .average-ratings {\n  background-color: #fed35d;\n  font-size: 11px;\n  font-weight: 700;\n}\n@media (max-width: 991.98px) {\n  .book-section .book-best-doctors .doctors-body .rating .average-ratings {\n    font-size: 10px;\n    margin: 0 0 0 7px;\n    padding: 1px 8px;\n  }\n}\n.book-section .book-best-doctors .doctors-body h4 {\n  color: #22396b;\n  text-transform: uppercase;\n  font-size: 20px;\n  margin-bottom: 5px;\n  font-weight: 600;\n}\n@media (max-width: 991.98px) {\n  .book-section .book-best-doctors .doctors-body h4 {\n    font-size: 18px;\n  }\n}\n@media (max-width: 479.98px) {\n  .book-section .book-best-doctors .doctors-body h4 {\n    font-size: 16px;\n  }\n}\n.book-section .book-best-doctors .doctors-body p {\n  font-size: 12px;\n  font-weight: 600;\n}\n.book-section .book-best-doctors .loc-details {\n  background-color: #f6faff;\n  margin: 15px 0 0;\n  padding: 15px 10px 0;\n}\n.book-section .book-best-doctors .loc-details .d-flex {\n  margin-bottom: 15px;\n}\n.book-section .book-best-doctors .loc-details img {\n  color: #22396b;\n  width: auto;\n  margin-right: 10px;\n}\n@media (max-width: 479.98px) {\n  .book-section .book-best-doctors .loc-details img {\n    margin-right: 6px;\n  }\n}\n.book-section .book-best-doctors .available-info {\n  font-weight: 500;\n  font-size: 11px;\n  text-transform: uppercase;\n  clear: both;\n  display: block;\n  margin: 0;\n  color: #757575;\n}\n@media (max-width: 479.98px) {\n  .book-section .book-best-doctors .available-info {\n    font-size: 11px;\n  }\n}\n.book-section .book-best-doctors .data-info {\n  font-weight: 400;\n  font-size: 11px;\n  color: #2264c5;\n}\n@media (max-width: 479.98px) {\n  .book-section .book-best-doctors .data-info {\n    font-size: 10px;\n  }\n}\n.book-section .book-best-doctors .amt-txt {\n  color: #1c5b91;\n  font-size: 18px;\n  font-weight: 600;\n}\n@media (max-width: 991.98px) {\n  .book-section .book-best-doctors .amt-txt {\n    font-size: 16px;\n  }\n}\n@media (max-width: 479.98px) {\n  .book-section .book-best-doctors .amt-txt {\n    font-size: 14px;\n  }\n}\n.book-section .book-best-doctors .book-btn {\n  font-size: 14px;\n  padding: 6px 12px;\n  color: #ffffff;\n  background-color: #1c71ef;\n  border-radius: 30px;\n  width: 100px;\n  text-align: center;\n  float: right;\n  border: none;\n}\n@media (max-width: 479.98px) {\n  .book-section .book-best-doctors .book-btn {\n    font-size: 12px;\n    padding: 5px 10px;\n    width: 80px;\n  }\n}\n.book-section .book-best-doctors .book-btn:hover {\n  background-color: #1c5b91;\n}\n\n.average-ratings {\n  background: #1c5b90;\n  border-radius: 70px;\n  color: #ffffff;\n  margin: 0 0 0 10px;\n  padding: 1px 15px;\n}\n\n.latest-blog {\n  background-color: #f4fcff;\n  padding: 60px 0 30px;\n}\n@media (max-width: 767.98px) {\n  .latest-blog {\n    padding: 40px 0 10px;\n  }\n}\n.latest-blog .blog-wrap {\n  margin-bottom: 30px;\n  background-color: #ffffff;\n  border-radius: 10px 10px 0px 0px;\n}\n.latest-blog .blog-wrap img {\n  border-radius: 10px;\n  width: 100%;\n}\n.latest-blog .blog-wrap .blog-wrap-body {\n  padding: 20px 15px;\n  background-color: #ffffff;\n}\n.latest-blog .blog-wrap .blog-wrap-body h3 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n@media (max-width: 991.98px) {\n  .latest-blog .blog-wrap .blog-wrap-body h3 {\n    font-size: 18px;\n  }\n}\n@media (max-width: 479.98px) {\n  .latest-blog .blog-wrap .blog-wrap-body h3 {\n    font-size: 16px;\n  }\n}\n.latest-blog .blog-wrap .blog-wrap-body h3 a:hover {\n  color: #1c5b91;\n}\n.latest-blog .blog-wrap .blog-wrap-body p {\n  font-size: 14px;\n  color: #737373;\n}\n@media (max-width: 479.98px) {\n  .latest-blog .blog-wrap .blog-wrap-body p {\n    font-size: 12px;\n  }\n}\n.latest-blog .blog-wrap .blog-wrap-body .blog-footer {\n  border-top: 1px solid #1b70ee;\n  padding: 15px 0 0;\n}\n.latest-blog .blog-wrap .blog-wrap-body .blog-footer .read-txt {\n  color: #1b70ee;\n  font-size: 14px;\n  font-weight: 600;\n}\n@media (max-width: 479.98px) {\n  .latest-blog .blog-wrap .blog-wrap-body .blog-footer .read-txt {\n    font-size: 12px;\n  }\n}\n.latest-blog .blog-wrap .blog-wrap-body .blog-footer .read-txt i {\n  margin: 2px 6px;\n  position: absolute;\n  top: 3px;\n}\n.latest-blog .blog-wrap .blog-wrap-body .blog-footer .cal-txt {\n  color: #1b70ee;\n  font-size: 14px;\n  font-weight: 600;\n}\n@media (max-width: 479.98px) {\n  .latest-blog .blog-wrap .blog-wrap-body .blog-footer .cal-txt {\n    font-size: 12px;\n  }\n}\n.latest-blog .blog-wrap .blog-wrap-body .blog-footer .cal-txt i {\n  margin: 2px 6px;\n}\n\n.browse-section.brower-category {\n  padding: 60px 0;\n  background: url(../images/slider/banner-02.jpg);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n@media (max-width: 991.98px) {\n  .browse-section.brower-category {\n    padding: 40px 0 20px;\n  }\n}\n.browse-section.brower-category .heading-wrapper h1 {\n  color: #e5f6fd;\n}\n.browse-section.brower-category .brower-box {\n  text-align: center;\n  border-radius: 10px;\n  border: 6px solid #ffffff;\n  background-color: #ffffff;\n  margin-bottom: 20px;\n}\n.browse-section.brower-category .brower-box > div {\n  background-color: #f2f7ff;\n  border-radius: 20px 20px 0px 0px;\n}\n.browse-section.brower-category .brower-box > div .brower-img {\n  background-color: #28daf4;\n  margin-bottom: 40px;\n}\n.browse-section.brower-category .brower-box > div h4 {\n  color: #28daf4;\n}\n\n.doctor-divison.provider-select .doc-background {\n  background: url(../images/shapes/doctor-bg.jpg);\n  background-size: cover;\n  padding: 60px 30px;\n}\n.doctor-divison.provider-select .doc-background::before {\n  background: rgba(242, 247, 255, 0.94);\n}\n@media (max-width: 991.98px) {\n  .doctor-divison.provider-select .doc-background {\n    padding: 40px 30px;\n  }\n}\n.doctor-divison.provider-select .doc-background h3 {\n  color: #2357a6;\n}\n.doctor-divison.provider-select .doc-background p {\n  color: #4b4b4b;\n}\n.doctor-divison.provider-select .pat-background {\n  background: url(../images/shapes/doctor-right-bg.jpg);\n  background-size: cover;\n  padding: 60px 30px;\n}\n.doctor-divison.provider-select .pat-background::before {\n  background: rgba(40, 218, 244, 0.9);\n}\n@media (max-width: 991.98px) {\n  .doctor-divison.provider-select .pat-background {\n    padding: 40px 30px;\n  }\n}\n.doctor-divison.provider-select .pat-background a {\n  background-color: #0ce0ff;\n}\n\n.blogs-section.blog-container {\n  padding: 60px 0;\n}\n@media (max-width: 991.98px) {\n  .blogs-section.blog-container {\n    padding: 40px 0 10px;\n  }\n}\n.blogs-section.blog-container .blog-wrapper .date-cart {\n  top: 50px;\n  right: 25px;\n}\n.blogs-section.blog-container .blog-wrapper .wrap-content-body h3 a {\n  color: #1860ca;\n}\n.blogs-section.blog-container .blog-wrapper .wrap-content-body .sp-title {\n  color: #28daf4;\n  font-size: 14px;\n}\n\n.main-wrapper.home-ten {\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-ten {\n    font-size: 15px;\n  }\n}\n.main-wrapper.home-ten a:hover {\n  color: #0e82fd;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .faq-img {\n    display: none;\n  }\n}\n.main-wrapper.home-ten h1,\n.main-wrapper.home-ten h2,\n.main-wrapper.home-ten h3,\n.main-wrapper.home-ten h4,\n.main-wrapper.home-ten h5,\n.main-wrapper.home-ten h6 {\n  text-transform: capitalize;\n}\n.main-wrapper.home-ten .row-gap {\n  row-gap: 24px;\n}\n.main-wrapper.home-ten .banner-section {\n  background: url(../images/bg/home-10-banner.png);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100% 101%;\n  background-clip: padding-box;\n  padding: 10px 0 30px;\n  height: 745px;\n  overflow: visible;\n}\n.main-wrapper.home-ten .banner-section .banner-content {\n  margin-top: 60px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .banner-section .banner-content {\n    margin-top: 50px;\n  }\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-ten .banner-section .banner-content {\n    margin-top: 30px;\n  }\n}\n.main-wrapper.home-ten .banner-section::after {\n  display: none;\n}\n.main-wrapper.home-ten .banner-section h6 {\n  font-size: 16px;\n  margin-bottom: 0;\n  text-transform: capitalize;\n  color: #ffffff;\n  font-weight: 400;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .banner-section h6 {\n    margin-bottom: 10px;\n  }\n}\n.main-wrapper.home-ten .banner-section h1 {\n  color: #ffffff;\n  max-width: 410px;\n  line-height: 70px;\n  font-weight: 400;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .banner-section h1 {\n    max-width: 100%;\n    font-size: 30px;\n    line-height: normal;\n  }\n}\n.main-wrapper.home-ten .banner-section h1 span {\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 60px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .banner-section h1 span {\n    font-size: 34px;\n  }\n}\n.main-wrapper.home-ten .banner-section p {\n  color: #ccfbf1;\n  max-width: 502px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .banner-section p {\n    max-width: 100%;\n  }\n}\n.main-wrapper.home-ten .banner-section .btn {\n  border-radius: 35px;\n  padding: 14px 40px;\n  min-width: 205px;\n  border: 3px solid #ffffff;\n  font-size: 20px;\n}\n@media (max-width: 568px) {\n  .main-wrapper.home-ten .banner-section .btn {\n    border-radius: 35px;\n    padding: 5px 10px;\n    min-width: auto;\n    border: 1px solid #ffffff;\n    font-size: 14px;\n  }\n}\n.main-wrapper.home-ten .banner-section .btn.plan-btn {\n  background-color: #ffffff;\n  margin-right: 10px;\n  color: #0e82fd;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n}\n.main-wrapper.home-ten .banner-section .btn.plan-btn:hover {\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  color: #ffffff;\n}\n.main-wrapper.home-ten .banner-section .btn:hover {\n  border-color: #ffffff;\n}\n.main-wrapper.home-ten .banner-section .banner-img {\n  position: relative;\n}\n.main-wrapper.home-ten .banner-section .banner-img img:nth-child(2) {\n  position: absolute;\n  left: -228px;\n  z-index: -1;\n  animation: beat 2.5s ease-in-out infinite;\n}\n@keyframes beat {\n  from {\n    transform: scale(1.1);\n  }\n  50% {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(1.1);\n  }\n}\n.main-wrapper.home-ten .banner-section .search-box-one.search-ten {\n  border-radius: 35px;\n  min-width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 30px;\n}\n@media (max-width: 1399.98px) {\n  .main-wrapper.home-ten .banner-section .search-box-one.search-ten {\n    margin-top: -27px;\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .banner-section .search-box-one.search-ten {\n    margin-top: 0px;\n  }\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-ten .banner-section .search-box-one.search-ten {\n    margin-top: 0px;\n  }\n}\n.main-wrapper.home-ten .banner-section .search-box-one.search-ten .search-title {\n  padding-bottom: 24px;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.main-wrapper.home-ten .banner-section .search-box-one.search-ten .search-title h5 {\n  font-weight: 700;\n}\n.main-wrapper.home-ten .banner-section .search-box-one.search-ten .search-input-ten {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.main-wrapper.home-ten .banner-section .search-box-one.search-ten .search-input-ten .form-group {\n  width: 100%;\n}\n.main-wrapper.home-ten\n  .banner-section\n  .search-box-one.search-ten\n  .search-input-ten\n  .form-group\n  .form-control {\n  min-height: 40px;\n}\n.main-wrapper.home-ten .banner-section .search-box-one.search-ten .search-input-ten span {\n  width: 40px;\n  height: 40px;\n  background: #f0fdfa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n}\n.main-wrapper.home-ten .banner-section .search-box-one.search-ten .form-search-btn.search-btn-ten {\n  padding-top: 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten\n    .banner-section\n    .search-box-one.search-ten\n    .form-search-btn.search-btn-ten {\n    width: 100%;\n  }\n}\n.main-wrapper.home-ten\n  .banner-section\n  .search-box-one.search-ten\n  .form-search-btn.search-btn-ten\n  .btn {\n  min-width: 100%;\n  padding: 10px 50px;\n  font-size: 14px;\n  border: 1px solid #0e82fd;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten\n    .banner-section\n    .search-box-one.search-ten\n    .form-search-btn.search-btn-ten\n    .btn {\n    min-width: auto;\n    padding: 10px 0;\n    font-size: 14px;\n    width: 100%;\n  }\n}\n.main-wrapper.home-ten .section-header-one {\n  margin-bottom: 50px;\n  text-align: center;\n}\n.main-wrapper.home-ten .section-header-one h2 {\n  font-size: 40px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0;\n}\n.main-wrapper.home-ten .section-header-one h2 span {\n  color: #0e82fd;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .section-header-one h2 {\n    font-size: 34px;\n  }\n}\n@media (max-width: 767.98px) {\n  .main-wrapper.home-ten .section-header-one h2 {\n    font-size: 26px;\n  }\n}\n.main-wrapper.home-ten .section-header-one .section-title {\n  display: inline-block;\n  position: relative;\n}\n.main-wrapper.home-ten .section-header-one .section-title::before {\n  display: none !important;\n}\n.main-wrapper.home-ten .section-header-one h5 {\n  font-weight: 600;\n  font-size: 18px;\n  color: #0e82fd;\n  margin-bottom: 10px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .section-header-one {\n    margin-bottom: 40px;\n  }\n}\n.main-wrapper.home-ten .specialities-section-one {\n  position: relative;\n}\n.main-wrapper.home-ten .specialities-section-one .floating-bg img {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  animation: beat 1.5s ease-in-out infinite;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .specialities-section-one .floating-bg img {\n    display: none;\n  }\n}\n.main-wrapper.home-ten .specialities-section-one .specialities-block ul {\n  list-style: none;\n  display: flex;\n  padding: 0;\n  flex-wrap: wrap;\n}\n.main-wrapper.home-ten .specialities-section-one .specialities-block ul li {\n  margin-right: 24px;\n  width: calc(20% - 24px);\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .specialities-section-one .specialities-block ul li {\n    width: 45%;\n    margin: 0 10px 20px;\n  }\n}\n@media (max-width: 568px) {\n  .main-wrapper.home-ten .specialities-section-one .specialities-block ul li {\n    width: 100%;\n    margin: 0 0 40px;\n  }\n}\n.main-wrapper.home-ten .specialities-section-one .specialities-block ul li:last-child {\n  margin-right: 0;\n}\n.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item {\n  background: #ffffff;\n  border: none;\n  border-radius: 35px;\n  height: 195px;\n  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.03);\n  margin: 0;\n  padding: 20px;\n  cursor: pointer;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.main-wrapper.home-ten\n  .specialities-section-one\n  .specialities-block\n  ul\n  li\n  .specialities-item:hover {\n  background: #ffffff;\n  border-color: #0e82fd;\n  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.main-wrapper.home-ten\n  .specialities-section-one\n  .specialities-block\n  ul\n  li\n  .specialities-item:hover\n  .specialities-img\n  .hexogen {\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.main-wrapper.home-ten\n  .specialities-section-one\n  .specialities-block\n  ul\n  li\n  .specialities-item:hover\n  .specialities-img\n  .hexogen\n  img {\n  transform: rotateY(360deg);\n  -webkit-transform: rotateY(360deg);\n  -ms-transform: rotateY(360deg);\n  -webkit-transition: 0.4s;\n  -ms-transition: 0.4s;\n  transition: 0.4s;\n}\n.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-item p {\n  font-weight: 600;\n  font-size: 16px;\n  color: #2f353c;\n  margin-bottom: 0;\n  max-width: 180px;\n  text-align: center;\n}\n.main-wrapper.home-ten .specialities-section-one .specialities-block ul li .specialities-img {\n  padding-bottom: 18px;\n}\n.main-wrapper.home-ten\n  .specialities-section-one\n  .specialities-block\n  ul\n  li\n  .specialities-img\n  .hexogen {\n  background: #ffffff;\n  border: none;\n  width: 87px;\n  height: 100px;\n  background-image: url(\"../images/icons/hex-shape.png\");\n  background-repeat: no-repeat;\n  background-position: center;\n  border-radius: 0;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.main-wrapper.home-ten\n  .specialities-section-one\n  .specialities-block\n  ul\n  li\n  .specialities-img\n  .hexogen\n  img {\n  width: auto;\n  -webkit-transition: 0.4s;\n  -ms-transition: 0.4s;\n  transition: 0.4s;\n}\n.main-wrapper.home-ten .service-section {\n  padding: 80px 0;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n.main-wrapper.home-ten .service-section::after {\n  content: \"\";\n  background: url(../images/bg/service-bg.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: top;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n.main-wrapper.home-ten .listing-card {\n  background-color: #ffffff;\n  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.03);\n  border-radius: 35px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n}\n.main-wrapper.home-ten .listing-card .listing-img {\n  position: relative;\n  margin: 0 0 20px 0;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.main-wrapper.home-ten .listing-card .listing-img img {\n  position: relative;\n  border-radius: 20px;\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  width: 100%;\n}\n.main-wrapper.home-ten .listing-card .listing-img:hover img {\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n.main-wrapper.home-ten .listing-card .listing-img:hover::before {\n  -webkit-animation: circle 1s;\n  animation: circle 1s;\n}\n.main-wrapper.home-ten .listing-card .listing-img::before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 2;\n  display: block;\n  content: \"\";\n  width: 0;\n  height: 0;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 100%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  opacity: 0;\n}\n.main-wrapper.home-ten .listing-card .listing-img .fav-item {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n.main-wrapper.home-ten .listing-card .listing-img .fav-item .fav-icon {\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.main-wrapper.home-ten .listing-card .listing-img .fav-item .fav-icon i {\n  color: #a29fc0;\n}\n.main-wrapper.home-ten .listing-card .listing-img .fav-item.selected .fav-icon {\n  background-color: #0e82fd;\n}\n.main-wrapper.home-ten .listing-card .listing-img .fav-item.selected .fav-icon i {\n  color: #ffffff;\n}\n.main-wrapper.home-ten .listing-card .listing-content .listing-details .listing-title h3 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.main-wrapper.home-ten .listing-card .listing-content .listing-details .listing-profile-details {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-ten .listing-card .listing-content .listing-details .listing-profile-details {\n    align-items: start;\n    flex-direction: column;\n    gap: 15px;\n  }\n}\n.main-wrapper.home-ten\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-user {\n  display: flex;\n  align-items: center;\n}\n.main-wrapper.home-ten\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-user\n  .listing-profile-img {\n  height: 48px;\n  width: 48px;\n  overflow: hidden;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n.main-wrapper.home-ten\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-user\n  .listing-user-details\n  span {\n  color: #9ca3af;\n  font-size: 14px;\n}\n.main-wrapper.home-ten\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-user\n  .listing-user-details\n  h6 {\n  margin-bottom: 0;\n  font-weight: 400;\n  font-size: 16px;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-ten\n    .listing-card\n    .listing-content\n    .listing-details\n    .listing-profile-details\n    .listing-btn {\n    width: 100%;\n  }\n}\n.main-wrapper.home-ten\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-btn\n  .consult-btn {\n  padding: 6px 30px 6px 30px;\n  background-color: #0e82fd;\n  font-weight: 500;\n  font-size: 16px;\n  border-radius: 35px;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  transition: all 0.7s;\n  color: #ffffff;\n}\n.main-wrapper.home-ten\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-btn\n  .consult-btn:hover {\n  box-shadow: inset 0 0 0 50px #ffffff;\n  color: #0e82fd;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten\n    .listing-card\n    .listing-content\n    .listing-details\n    .listing-profile-details\n    .listing-btn\n    .consult-btn {\n    padding: 6px 12px 6px 12px;\n    font-size: 17px;\n  }\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-ten\n    .listing-card\n    .listing-content\n    .listing-details\n    .listing-profile-details\n    .listing-btn\n    .consult-btn {\n    width: 100%;\n  }\n}\n.main-wrapper.home-ten .need-to-know-section {\n  padding: 80px 0;\n  position: relative;\n}\n.main-wrapper.home-ten .need-to-know-section .floating-bg img {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  animation: beat 1.5s ease-in-out infinite;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .need-to-know-section .floating-bg {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .need-to-know-section {\n    padding: 60px 0;\n  }\n}\n.main-wrapper.home-ten .need-to-know-section .section-header-one {\n  text-align: left;\n  margin-bottom: 0;\n}\n.main-wrapper.home-ten .need-to-know-section .section-header-one ul {\n  padding: 30px 0;\n}\n.main-wrapper.home-ten .need-to-know-section .section-header-one ul li {\n  margin-right: 10px;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-ten .need-to-know-section .section-header-one ul li {\n    margin: 0 10px 10px 0;\n  }\n}\n.main-wrapper.home-ten .need-to-know-section .section-header-one ul li:last-child {\n  margin-right: 0;\n}\n.main-wrapper.home-ten .need-to-know-section .section-header-one ul li .tag-list {\n  padding: 10px 20px;\n  border-radius: 35px;\n  background: #f8fafc;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: capitalize;\n}\n.main-wrapper.home-ten .need-to-know-section .section-header-one ul li .tag-list.active {\n  background: #f1f5f9;\n  color: #0e82fd;\n}\n.main-wrapper.home-ten .need-to-know-section .section-header-one .need-to-know-content h3 {\n  margin-bottom: 34px;\n  font-weight: 600;\n}\n.main-wrapper.home-ten .need-to-know-section .section-header-one .need-to-know-content p {\n  line-height: 29px;\n  margin-bottom: 30px;\n}\n.main-wrapper.home-ten\n  .need-to-know-section\n  .section-header-one\n  .need-to-know-content\n  .need-to-know-content-btn {\n  border-radius: 35px;\n  padding: 10px 30px;\n  border: 2px solid #0e82fd;\n  font-size: 14px;\n  color: #0e82fd;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  transition: all 0.7s;\n}\n.main-wrapper.home-ten\n  .need-to-know-section\n  .section-header-one\n  .need-to-know-content\n  .need-to-know-content-btn:hover {\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  color: #ffffff;\n}\n.main-wrapper.home-ten .need-to-know-section .gallery-box-block {\n  display: flex;\n  gap: 10px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .need-to-know-section .gallery-box-block {\n    display: none !important;\n  }\n}\n.main-wrapper.home-ten .need-to-know-section .gallery-box-block .box-detail {\n  width: 195px;\n  height: 202px;\n  border-radius: 35px;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n.main-wrapper.home-ten .need-to-know-section .gallery-box-block .box-detail:last-child {\n  margin-bottom: 0;\n}\n.main-wrapper.home-ten .need-to-know-section .gallery-box-block .gallery-box-left {\n  padding-top: 30px;\n}\n.main-wrapper.home-ten .need-to-know-section.steps-to-follow .floating-bg img {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  animation: beat 1.5s ease-in-out infinite;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .need-to-know-section.steps-to-follow .floating-bg {\n    display: none;\n  }\n}\n.main-wrapper.home-ten .need-to-know-section.steps-to-follow .gallery-box-block {\n  display: flex;\n  gap: 24px;\n}\n.main-wrapper.home-ten .need-to-know-section.steps-to-follow .gallery-box-block .box-detail {\n  width: 240px;\n  height: 223px;\n  border-radius: 35px;\n  overflow: hidden;\n  margin-bottom: 24px;\n  padding: 30px;\n  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 1399.98px) {\n  .main-wrapper.home-ten .need-to-know-section.steps-to-follow .gallery-box-block .box-detail {\n    max-width: 210px;\n    max-height: 203px;\n  }\n}\n.main-wrapper.home-ten\n  .need-to-know-section.steps-to-follow\n  .gallery-box-block\n  .box-detail:last-child {\n  margin-bottom: 0;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.steps-to-follow\n  .gallery-box-block\n  .box-detail\n  .steps-list-box {\n  position: relative;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.steps-to-follow\n  .gallery-box-block\n  .box-detail\n  .steps-list-box\n  .steps-list-img {\n  width: 140px;\n  height: 60px;\n  margin: auto;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.steps-to-follow\n  .gallery-box-block\n  .box-detail\n  .steps-list-box\n  h6 {\n  font-weight: 600;\n  font-size: 18px;\n  margin: 10px 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: center;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.steps-to-follow\n  .gallery-box-block\n  .box-detail\n  .steps-list-box\n  p {\n  text-align: center;\n  margin-bottom: 0;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.steps-to-follow\n  .gallery-box-block\n  .box-detail\n  .steps-list-box\n  span {\n  color: #0e82fd;\n  font-weight: 700;\n  font-size: 30px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 12%);\n}\n.main-wrapper.home-ten .need-to-know-section.steps-to-follow .gallery-box-block .gallery-box-left {\n  padding-top: 30px;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.steps-to-follow\n  .section-header-one\n  .need-to-know-content {\n  margin-top: 50px;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.steps-to-follow\n  .section-header-one\n  .need-to-know-content\n  .need-to-know-content-btn {\n  border-radius: 35px;\n  padding: 10px 30px;\n  border: 3px solid #0e82fd;\n  font-size: 18px;\n  font-weight: 500;\n  color: #0e82fd;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  transition: all 0.7s;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten\n    .need-to-know-section.steps-to-follow\n    .section-header-one\n    .need-to-know-content\n    .need-to-know-content-btn {\n    font-size: 16px;\n  }\n}\n.main-wrapper.home-ten\n  .need-to-know-section.steps-to-follow\n  .section-header-one\n  .need-to-know-content\n  .need-to-know-content-btn:hover {\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  color: #ffffff;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.steps-to-follow\n  .section-header-one\n  .need-to-know-content\n  .need-to-know-content-btn.book-btn {\n  background-color: #0e82fd;\n  color: #ffffff;\n  box-shadow: inset 0 0 0 0 #ffffff;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.steps-to-follow\n  .section-header-one\n  .need-to-know-content\n  .need-to-know-content-btn.book-btn:hover {\n  box-shadow: inset 0 0 0 50px #ffffff;\n  color: #0e82fd;\n}\n.main-wrapper.home-ten .need-to-know-section.testimonial-section-ten {\n  background-color: #f8fafc;\n  background-image: url(\"../images/bg/map.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.main-wrapper.home-ten .need-to-know-section.testimonial-section-ten .floating-bg img {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  animation: beat 1.5s ease-in-out infinite;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .need-to-know-section.testimonial-section-ten .floating-bg {\n    display: none;\n  }\n}\n.main-wrapper.home-ten .need-to-know-section.testimonial-section-ten .section-header-one h2 {\n  margin-bottom: 30px;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.testimonial-section-ten\n  .section-header-one\n  .need-to-know-content\n  p {\n  margin-bottom: 30px;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.testimonial-section-ten\n  .section-header-one\n  .need-to-know-content\n  .patient-rating-block\n  .patient-rating\n  .circle-rating {\n  margin-bottom: 12px;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.testimonial-section-ten\n  .section-header-one\n  .need-to-know-content\n  .patient-rating-block\n  .patient-rating\n  .circle-rating\n  i {\n  color: #ffca42;\n  margin-right: 5px;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.testimonial-section-ten\n  .section-header-one\n  .need-to-know-content\n  .patient-rating-block\n  .patient-rating\n  .circle-rating\n  i:last-child {\n  margin-right: 0px;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.testimonial-section-ten\n  .section-header-one\n  .need-to-know-content\n  .patient-rating-block\n  .patient-rating\n  .circle-rating\n  span {\n  margin-left: 10px;\n  color: #9ca3af;\n  font-size: 14px;\n  font-weight: 600;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.testimonial-section-ten\n  .section-header-one\n  .need-to-know-content\n  .patient-rating-block\n  .patient-rating\n  h5 {\n  margin-bottom: 0;\n  color: #1e293b;\n}\n.main-wrapper.home-ten .need-to-know-section.testimonial-section-ten .testimonial-card {\n  color: #ffffff;\n  background-color: #ffffff;\n  padding: 20px;\n  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);\n  border-radius: 35px;\n  margin-bottom: 24px;\n}\n.main-wrapper.home-ten .need-to-know-section.testimonial-section-ten .testimonial-card:last-child {\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten\n    .need-to-know-section.testimonial-section-ten\n    .testimonial-card:last-child {\n    margin-bottom: 15px;\n  }\n}\n.main-wrapper.home-ten\n  .need-to-know-section.testimonial-section-ten\n  .testimonial-card\n  .testimonial-user-details {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.testimonial-section-ten\n  .testimonial-card\n  .testimonial-user-details\n  .testimonial-user-img {\n  width: 85px;\n  height: 85px;\n  overflow: hidden;\n  margin-right: 20px;\n  border-radius: 50%;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.testimonial-section-ten\n  .testimonial-card\n  .testimonial-user-details\n  .testimonial-user-name\n  .circle-rating\n  i {\n  color: #ffca42;\n}\n.main-wrapper.home-ten\n  .need-to-know-section.testimonial-section-ten\n  .testimonial-card\n  .testmonial-user-coments\n  p {\n  color: #6b7280;\n  font-size: 14px;\n  line-height: 20px;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.main-wrapper.home-ten .our-doctor-section {\n  padding: 80px 0;\n  position: relative;\n  background: #f8fafc;\n  z-index: 0;\n}\n.main-wrapper.home-ten .our-doctor-section .section-floating-bg {\n  z-index: -2;\n}\n.main-wrapper.home-ten .our-doctor-section .section-floating-bg img {\n  position: absolute;\n}\n.main-wrapper.home-ten .our-doctor-section .section-floating-bg img:nth-child(1) {\n  top: 0;\n  left: 0;\n}\n.main-wrapper.home-ten .our-doctor-section .section-floating-bg img:nth-child(2) {\n  bottom: 0;\n  right: 0;\n}\n.main-wrapper.home-ten .our-doctor-section .module-border-wrap {\n  background: #ffffff;\n  border-radius: 39px;\n  padding: 3px;\n  transition: all 0.5s;\n  position: relative;\n}\n.main-wrapper.home-ten .our-doctor-section .module-border-wrap:hover {\n  background-image: linear-gradient(to bottom, #8af0ff, #fff);\n  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);\n}\n.main-wrapper.home-ten .our-doctor-section .module-border-wrap .listing-card {\n  background-color: #ffffff;\n  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.03);\n  border-radius: 35px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.5s;\n}\n.main-wrapper.home-ten .our-doctor-section .module-border-wrap .listing-card .listing-img {\n  position: relative;\n  margin: 0 0 20px 0;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.main-wrapper.home-ten .our-doctor-section .module-border-wrap .listing-card .listing-img img {\n  position: relative;\n  border-radius: 20px;\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  width: 100%;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-img:hover\n  img {\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-img:hover::before {\n  -webkit-animation: circle 1s;\n  animation: circle 1s;\n}\n.main-wrapper.home-ten .our-doctor-section .module-border-wrap .listing-card .listing-img::before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 2;\n  display: block;\n  content: \"\";\n  width: 0;\n  height: 0;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 100%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  opacity: 0;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-img\n  .fav-item {\n  position: absolute;\n  top: 10px;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0 10px;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-img\n  .fav-item\n  .featured-rating {\n  background: #fbbf24;\n  border-radius: 6px;\n  color: #ffffff;\n  padding: 3px 5px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-img\n  .fav-item\n  .featured-rating\n  i,\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-img\n  .fav-item\n  .featured-rating\n  span {\n  font-size: 13px;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-img\n  .fav-item\n  .fav-icon {\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-img\n  .fav-item\n  .fav-icon\n  i {\n  color: #a29fc0;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-img\n  .fav-item.selected\n  .fav-icon {\n  background-color: #0e82fd;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-img\n  .fav-item.selected\n  .fav-icon\n  i {\n  color: #ffffff;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-title\n  h3 {\n  font-size: 20px;\n  font-weight: 600;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-category {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten\n    .our-doctor-section\n    .module-border-wrap\n    .listing-card\n    .listing-content\n    .listing-details\n    .listing-category {\n    flex-direction: column;\n  }\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-ten\n    .our-doctor-section\n    .module-border-wrap\n    .listing-card\n    .listing-content\n    .listing-details\n    .listing-category {\n    align-items: start;\n  }\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-category\n  .listing-category-tag {\n  padding: 5px 10px;\n  transition: all 0.5s;\n  font-size: 14px;\n  font-weight: 500;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-category\n  .listing-category-tag:hover {\n  transform: translateY(-5px);\n  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-category\n  .listing-category-tag.tag-green {\n  background: #ccfbf1;\n  color: #14b8a6;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-category\n  .listing-category-tag.tag-purple {\n  background: #ddd6fe;\n  color: #7c3aed;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-category\n  .listing-category-tag.tag-red {\n  background: #fdf2f8;\n  color: #ec4899;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details {\n  display: flex;\n  align-items: start;\n  justify-content: start;\n  flex-direction: column;\n  gap: 15px;\n  position: relative;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-floating-img {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n@media (max-width: 1399.98px) {\n  .main-wrapper.home-ten\n    .our-doctor-section\n    .module-border-wrap\n    .listing-card\n    .listing-content\n    .listing-details\n    .listing-profile-details\n    .listing-floating-img {\n    display: none;\n  }\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-user {\n  display: flex;\n  align-items: center;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-user\n  .listing-profile-img {\n  height: 48px;\n  width: 48px;\n  overflow: hidden;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-user\n  .listing-user-details\n  span {\n  color: #9ca3af;\n  font-size: 14px;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-user\n  .listing-user-details\n  h6 {\n  margin-bottom: 0;\n  font-weight: 600;\n  font-size: 20px;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-ten\n    .our-doctor-section\n    .module-border-wrap\n    .listing-card\n    .listing-content\n    .listing-details\n    .listing-profile-details\n    .listing-user\n    .listing-user-details\n    h6 {\n    font-size: 17px;\n  }\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-btn\n  .consult-btn {\n  padding: 6px 30px 6px 30px;\n  background-color: #0e82fd;\n  font-weight: 500;\n  font-size: 16px;\n  border-radius: 35px;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  transition: all 0.7s;\n  color: #ffffff;\n}\n.main-wrapper.home-ten\n  .our-doctor-section\n  .module-border-wrap\n  .listing-card\n  .listing-content\n  .listing-details\n  .listing-profile-details\n  .listing-btn\n  .consult-btn:hover {\n  box-shadow: inset 0 0 0 50px #ffffff;\n  color: #0e82fd;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-ten\n    .our-doctor-section\n    .module-border-wrap\n    .listing-card\n    .listing-content\n    .listing-details\n    .listing-profile-details\n    .listing-btn\n    .consult-btn {\n    font-size: 17px;\n  }\n}\n.main-wrapper.home-ten .book-appointment-section {\n  padding: 80px 0;\n  position: relative;\n}\n.main-wrapper.home-ten .book-appointment-section .book-appointment-ten {\n  padding: 50px;\n  background: #0e82fd;\n  border-radius: 35px;\n  position: relative;\n  overflow: hidden;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-ten .book-appointment-section .book-appointment-ten {\n    padding: 20px;\n  }\n}\n.main-wrapper.home-ten .book-appointment-section .book-appointment-ten .book-section-bg img {\n  position: absolute;\n}\n.main-wrapper.home-ten\n  .book-appointment-section\n  .book-appointment-ten\n  .book-section-bg\n  img:nth-child(1) {\n  left: 0;\n  bottom: 0;\n}\n.main-wrapper.home-ten\n  .book-appointment-section\n  .book-appointment-ten\n  .book-section-bg\n  img:nth-child(2) {\n  right: 0;\n  bottom: 6%;\n}\n.main-wrapper.home-ten\n  .book-appointment-section\n  .book-appointment-ten\n  .book-section-bg\n  img:nth-child(3) {\n  right: 160px;\n  top: 100px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .book-appointment-section .book-appointment-ten .book-section-bg {\n    display: none;\n  }\n}\n.main-wrapper.home-ten .book-appointment-section .book-appointment-ten h2 {\n  color: #ffffff;\n  margin-bottom: 24px;\n}\n.main-wrapper.home-ten .book-appointment-section .book-appointment-ten p {\n  max-width: 725px;\n  margin: auto;\n  margin-bottom: 50px;\n  color: #ffffff;\n}\n.main-wrapper.home-ten .book-appointment-section .book-appointment-ten .appointment-btn-group {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n}\n@media (max-width: 568px) {\n  .main-wrapper.home-ten .book-appointment-section .book-appointment-ten .appointment-btn-group {\n    flex-direction: column;\n  }\n}\n.main-wrapper.home-ten .book-appointment-section .book-appointment-ten .appointment-btn-group a {\n  padding: 14px 40px;\n  border-radius: 35px;\n  border: 2px solid #ffffff;\n  font-size: 18px;\n  font-weight: 500;\n  color: #ffffff;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  transition: all 0.7s;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .book-appointment-section .book-appointment-ten .appointment-btn-group a {\n    padding: 14px 20px;\n    border: 1px solid #ffffff;\n    font-size: 15px;\n  }\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-ten .book-appointment-section .book-appointment-ten .appointment-btn-group a {\n    padding: 10px 20px;\n  }\n}\n.main-wrapper.home-ten\n  .book-appointment-section\n  .book-appointment-ten\n  .appointment-btn-group\n  a:hover {\n  box-shadow: inset 0 0 0 50px #ffffff;\n  color: #0e82fd;\n}\n.main-wrapper.home-ten\n  .book-appointment-section\n  .book-appointment-ten\n  .appointment-btn-group\n  a.appointment-blue-btn {\n  background-color: #ffffff;\n  color: #0e82fd;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  border: 2px solid #ffffff;\n}\n.main-wrapper.home-ten\n  .book-appointment-section\n  .book-appointment-ten\n  .appointment-btn-group\n  a.appointment-blue-btn:hover {\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  color: #ffffff;\n}\n.main-wrapper.home-ten .pricing-section.pricing-section-ten {\n  position: relative;\n  z-index: 1;\n}\n.main-wrapper.home-ten .pricing-section.pricing-section-ten::after {\n  content: \"\";\n  background: url(../images/bg/pricing-bg.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: top;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n.main-wrapper.home-ten .pricing-section.pricing-section-ten .section-header-one h2 {\n  margin-bottom: 24px;\n}\n.main-wrapper.home-ten .pricing-section.pricing-section-ten .section-header-one .options-group {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 17px;\n}\n@media (max-width: 568px) {\n  .main-wrapper.home-ten .pricing-section.pricing-section-ten .section-header-one .options-group {\n    flex-direction: column;\n  }\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .section-header-one\n  .options-group\n  span {\n  color: #1f2937;\n  font-weight: 500;\n  font-size: 18px;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .section-header-one\n  .options-group\n  span\n  .discount-plan {\n  background: #ffc001;\n  border-radius: 35px;\n  color: #ffffff;\n  padding: 5px 10px;\n  font-size: 14px;\n}\n.main-wrapper.home-ten .pricing-section.pricing-section-ten .section-header-one .form-check {\n  width: 30px;\n  margin-bottom: 0;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .section-header-one\n  .form-check.form-switch {\n  padding: 0;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .section-header-one\n  .form-check.form-switch\n  .form-check-input {\n  transition: all 0.5s;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .section-header-one\n  .form-check\n  .form-check-input {\n  float: right !important;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .section-header-one\n  .form-check\n  .form-check-input:focus {\n  box-shadow: none !important;\n}\n.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card {\n  background: #ffffff;\n  border-radius: 35px;\n}\n.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card .pricing-btn {\n  margin-bottom: 30px;\n}\n.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card .pricing-btn .btn {\n  color: #0e82fd;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  padding: 14px 40px;\n  background: #ffffff;\n  border-radius: 35px;\n  transition: all 0.5s;\n  border: 2px solid #0e82fd;\n}\n.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card .pricing-btn .btn:hover {\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  color: #ffffff;\n  border: 2px solid #ffffff;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card\n  .pricing-info\n  .pricing-amount\n  span {\n  font-weight: 600;\n  color: #9ca3af;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card\n  .pricing-info\n  .pricing-list {\n  padding-bottom: 30px;\n  border-bottom: 1px solid #e2e8f0;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card\n  .pricing-info\n  .pricing-list\n  ul\n  li::before {\n  content: \"\\f21e\";\n  color: #0e82fd;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card\n  .pricing-info\n  .pricing-list.pricing-list-two {\n  border-bottom: none;\n  padding: 30px 0 0 0;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card\n  .pricing-info\n  .pricing-list.pricing-list-two\n  ul\n  li::before {\n  content: \"+\";\n}\n.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card.pricing-card-active {\n  background: #0e82fd;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card.pricing-card-active\n  .card-body\n  .pricing-header\n  .pricing-header-info {\n  position: relative;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card.pricing-card-active\n  .card-body\n  .pricing-header\n  .pricing-header-info\n  .pricing-tag\n  img {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card.pricing-card-active\n  .card-body\n  .pricing-header\n  .pricing-header-info\n  .pricing-title\n  h4 {\n  font-weight: 700;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card.pricing-card-active\n  .card-body\n  .pricing-info\n  .pricing-amount\n  span {\n  color: #ffffff;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card.pricing-card-active\n  .card-body\n  .pricing-info\n  .pricing-btn {\n  margin-bottom: 30px;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card.pricing-card-active\n  .card-body\n  .pricing-info\n  .pricing-btn\n  .btn {\n  color: #0e82fd;\n  box-shadow: inset 0 0 0 0px #0e82fd;\n  padding: 14px 40px;\n  border-radius: 35px;\n  transition: all 0.5s;\n  border: 2px solid #ffffff;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card.pricing-card-active\n  .card-body\n  .pricing-info\n  .pricing-btn\n  .btn:hover {\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  color: #ffffff;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card.pricing-card-active\n  .card-body\n  .pricing-info\n  .pricing-list {\n  padding-bottom: 30px;\n  border-bottom: 1px solid #f1f5f9;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card.pricing-card-active\n  .card-body\n  .pricing-info\n  .pricing-list\n  ul\n  li {\n  font-weight: 500;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card.pricing-card-active\n  .card-body\n  .pricing-info\n  .pricing-list\n  ul\n  li::before {\n  content: \"\\f21e\";\n  color: #ffffff;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card.pricing-card-active\n  .card-body\n  .pricing-info\n  .pricing-list.pricing-list-two {\n  border-bottom: none;\n  padding: 30px 0 0 0;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card.pricing-card-active\n  .card-body\n  .pricing-info\n  .pricing-list.pricing-list-two\n  ul\n  li::before {\n  content: \"+\";\n}\n.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card:hover {\n  background: #0e82fd;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card:hover\n  .pricing-amount\n  span {\n  color: #ffffff;\n}\n.main-wrapper.home-ten .pricing-section.pricing-section-ten .pricing-card:hover .pricing-list {\n  border-bottom: 1px solid #f1f5f9;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card:hover\n  .pricing-list\n  ul\n  li::before {\n  color: #ffffff;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card:hover\n  .pricing-list.pricing-list-two {\n  border-bottom: none;\n  padding: 30px 0 0 0;\n}\n.main-wrapper.home-ten\n  .pricing-section.pricing-section-ten\n  .pricing-card:hover\n  .pricing-list.pricing-list-two\n  ul\n  li::before {\n  content: \"+\";\n}\n.main-wrapper.home-ten .faq-section {\n  position: relative;\n}\n.main-wrapper.home-ten .faq-section .floating-bg img {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  animation: beat 1.5s ease-in-out infinite;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .faq-section .floating-bg {\n    display: none;\n  }\n}\n.main-wrapper.home-ten .faq-section.faq-section-ten {\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .faq-section.faq-section-ten {\n    padding: 60px 0;\n  }\n}\n.main-wrapper.home-ten .faq-section.faq-section-ten .faq-img {\n  border-radius: 35px;\n  overflow: hidden;\n}\n.main-wrapper.home-ten .faq-section.faq-section-ten .faq-img img {\n  width: 100%;\n}\n.main-wrapper.home-ten .faq-section.faq-section-ten .section-header-one {\n  text-align: start;\n}\n.main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-item {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 35px;\n  margin: 0 0 24px;\n  padding: 20px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-item {\n    padding: 10px;\n  }\n}\n.main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-item .accordion-content {\n  padding-left: 45px;\n}\n.main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-button {\n  font-weight: 600;\n}\n.main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-button::after {\n  display: none;\n}\n.main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-button::before {\n  content: \"\\e9b1\";\n  font-family: \"feather\";\n  font-size: 20px;\n  background: none;\n  color: #0e82fd;\n  background: #ffffff;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-right: 20px;\n  margin-right: 20px;\n  border-right: 1px solid #e2e8f0;\n}\n.main-wrapper.home-ten\n  .faq-section.faq-section-ten\n  .faq-info\n  .accordion-button:not(.collapsed)::after {\n  display: none;\n}\n.main-wrapper.home-ten\n  .faq-section.faq-section-ten\n  .faq-info\n  .accordion-button:not(.collapsed)::before {\n  content: \"\\e996\";\n  background: #ffffff;\n}\n.main-wrapper.home-ten .faq-section.faq-section-ten .faq-info .accordion-button .accordion-item {\n  border-radius: 35px;\n}\n\n@media (max-width: 568px) {\n  .content-btn-block {\n    flex-wrap: wrap;\n  }\n  .content-btn-block .need-to-know-content-btn {\n    margin-bottom: 10px !important;\n    width: 100%;\n    text-align: center;\n  }\n  .footer.footer-one.footer-ten .footer-bottom .copyright {\n    flex-direction: column;\n  }\n  .need-to-know-content .patient-rating {\n    margin-bottom: 15px;\n  }\n}\n.body-eleven {\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n}\n@media (max-width: 1199.98px) {\n  .body-eleven {\n    font-size: 15px;\n  }\n}\n\n.doctor-search-section.doctor-search-eleven {\n  background: url(../images/bg/banner-11-bg.png);\n  padding: 115px 0 300px;\n  background-position: bottom center;\n}\n.doctor-search-section.doctor-search-eleven .banner-header {\n  margin: 0 0 90px;\n}\n.doctor-search-section.doctor-search-eleven .banner-header p {\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n  margin: 0 0 10px;\n  padding: 0 0 0 30px;\n  position: relative;\n}\n.doctor-search-section.doctor-search-eleven .banner-header p::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 27px;\n  height: 2px;\n  background-color: #ffffff;\n}\n@media (max-width: 767.98px) {\n  .doctor-search-section.doctor-search-eleven .banner-header p {\n    font-size: 14px;\n  }\n}\n.doctor-search-section.doctor-search-eleven .banner-header h1 {\n  font-size: 50px;\n  color: #ffffff;\n  font-weight: 700;\n  margin: 0 0 25px;\n}\n@media (max-width: 1399.98px) {\n  .doctor-search-section.doctor-search-eleven .banner-header h1 {\n    font-size: 48px;\n  }\n}\n@media (max-width: 991.98px) {\n  .doctor-search-section.doctor-search-eleven .banner-header h1 {\n    font-size: 36px;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-search-section.doctor-search-eleven .banner-header h1 {\n    font-size: 24px;\n  }\n}\n@media (max-width: 991.98px) {\n  .doctor-search-section.doctor-search-eleven .banner-header {\n    margin: 0 0 60px;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-search-section.doctor-search-eleven .banner-header {\n    margin: 0 0 40px;\n  }\n}\n.doctor-search-section.doctor-search-eleven .banner-users h6 {\n  color: #000000;\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0 0 15px;\n}\n.doctor-search-section.doctor-search-eleven .banner-users h6 img {\n  margin: 0 10px 0 0;\n}\n@media (max-width: 767.98px) {\n  .doctor-search-section.doctor-search-eleven .banner-users h6 {\n    font-size: 14px;\n  }\n}\n.doctor-search-section.doctor-search-eleven .banner-users ul {\n  margin: 0;\n  padding: 0;\n}\n.doctor-search-section.doctor-search-eleven .banner-users ul li {\n  display: inline-block;\n  margin: 0 0 0 -23px;\n}\n.doctor-search-section.doctor-search-eleven .banner-users ul li:first-child {\n  margin: 0;\n}\n.doctor-search-section.doctor-search-eleven .banner-users ul li img {\n  width: 65px;\n  height: 65px;\n  border-radius: 50%;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);\n  border: 2px solid #ffffff;\n}\n@media (max-width: 767.98px) {\n  .doctor-search-section.doctor-search-eleven .banner-users ul li img {\n    width: 50px;\n    height: 50px;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-search-section.doctor-search-eleven .ban-bg .bg-01,\n  .doctor-search-section.doctor-search-eleven .ban-bg .bg-02 {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .doctor-search-section.doctor-search-eleven {\n    padding: 115px 0 200px;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-search-section.doctor-search-eleven {\n    padding: 115px 0 150px;\n  }\n}\n\n.z-index-1 {\n  z-index: -1 !important;\n}\n\n@media (max-width: 767.98px) {\n  .ban-bg {\n    display: none;\n  }\n}\n.ban-bg img {\n  position: absolute;\n  z-index: -1;\n}\n.ban-bg img.bg-01 {\n  left: 0;\n  top: 0;\n  animation: bouncing alternate infinite 2s;\n}\n.ban-bg img.bg-02 {\n  right: 0;\n  top: 0;\n  animation: bounce alternate infinite 2s;\n  z-index: -1;\n}\n.ban-bg img.bg-03 {\n  right: 10%;\n  bottom: 0;\n  animation: bounceup alternate infinite 2s;\n}\n@media (max-width: 767.98px) {\n  .ban-bg img.bg-03 {\n    width: 150px;\n  }\n}\n.ban-bg img.bg-04 {\n  bottom: 17%;\n  left: 2%;\n  z-index: -1;\n}\n@media (max-width: 1399.98px) {\n  .ban-bg img.bg-04 {\n    left: 1%;\n  }\n}\n.ban-bg img.bg-05 {\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  z-index: -1;\n}\n\n@keyframes bouncing {\n  to {\n    transform: translateX(5px);\n  }\n}\n@keyframes bounce {\n  to {\n    transform: translateX(-5px);\n  }\n}\n@keyframes bounceup {\n  to {\n    transform: translateY(-10px);\n  }\n}\n.btn-light-blue {\n  background: #0ce0ff;\n  color: #ffffff;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  border-radius: 10px;\n  font-weight: 500;\n  font-size: 18px;\n  padding: 13px 24px;\n  -webkit-transition: all 0.7s;\n  -ms-transition: all 0.7s;\n  transition: all 0.7s;\n}\n.btn-light-blue:hover {\n  background: #ffffff;\n  color: #1c5b91;\n  box-shadow: inset 0 60px 0 0 #ffffff;\n  -webkit-transition: all 0.7s;\n  -ms-transition: all 0.7s;\n  transition: all 0.7s;\n}\n@media (max-width: 767.98px) {\n  .btn-light-blue {\n    font-size: 15px;\n    padding: 10px 20px;\n  }\n}\n\n.sec-heading-eye {\n  margin: 0 0 50px;\n}\n.sec-heading-eye img {\n  margin: 0 0 15px;\n}\n.sec-heading-eye h2 {\n  font-size: 40px;\n  font-weight: 600;\n  color: #1b5a90;\n  margin: 0 0 15px;\n}\n.sec-heading-eye h2 span {\n  color: #1f2937;\n}\n@media (max-width: 991.98px) {\n  .sec-heading-eye h2 {\n    font-size: 34px;\n  }\n}\n@media (max-width: 767.98px) {\n  .sec-heading-eye h2 {\n    font-size: 26px;\n  }\n}\n.sec-heading-eye p {\n  font-size: 18px;\n  color: #6b7280;\n}\n@media (max-width: 991.98px) {\n  .sec-heading-eye p {\n    font-size: 16px;\n  }\n}\n@media (max-width: 991.98px) {\n  .sec-heading-eye {\n    margin-bottom: 30px;\n  }\n}\n\n.special-section {\n  position: relative;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .special-section {\n    padding: 40px 0;\n  }\n}\n\n.special-item {\n  margin: 0 0 50px;\n}\n.special-item .special-icon {\n  text-align: center;\n  margin: 0 auto 15px;\n  height: 45px;\n}\n.special-item .special-icon a {\n  width: 110px;\n  height: 110px;\n  background-color: #1b5a90;\n  border-radius: 100% 0px;\n  transform: rotate(45deg);\n  text-align: center;\n  margin: -70px 0 auto;\n}\n.special-item .special-icon a i {\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  color: #ffffff;\n}\n.special-item h6 {\n  font-weight: 500;\n  font-size: 18px;\n  margin: 0;\n  text-align: center;\n  color: #1f2937;\n}\n.special-item h6 a {\n  color: #1f2937;\n}\n.special-item h6 a:hover {\n  color: #1b5a90;\n}\n\n.owl-them .owl-nav .owl-prev,\n.owl-them .owl-nav .owl-next {\n  width: 40px;\n  height: 40px;\n  background: #ffffff !important;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 100px;\n  position: absolute;\n  top: 20%;\n  z-index: 1;\n}\n.owl-them .owl-nav .owl-prev:hover,\n.owl-them .owl-nav .owl-next:hover {\n  background: #1c5b91 !important;\n  color: #ffffff;\n}\n.owl-them .owl-nav .owl-prev {\n  left: -20px;\n}\n@media (max-width: 991.98px) {\n  .owl-them .owl-nav .owl-prev {\n    left: -10px;\n  }\n}\n.owl-them .owl-nav .owl-next {\n  right: -20px;\n}\n@media (max-width: 991.98px) {\n  .owl-them .owl-nav .owl-next {\n    right: -10px;\n  }\n}\n\n.owl-them .owl-dots {\n  text-align: center;\n}\n.owl-them .owl-dots .owl-dot {\n  margin: 0 5px 0 0;\n}\n.owl-them .owl-dots .owl-dot.active span {\n  background: #1b5a90;\n}\n.owl-them .owl-dots .owl-dot span {\n  width: 9px;\n  height: 9px;\n  line-height: 12px;\n  margin: 0;\n  background: #d1d5db;\n  border-radius: 50%;\n  display: block;\n  -webkit-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n\n.center-section {\n  position: relative;\n  padding: 0 0 80px;\n}\n@media (max-width: 991.98px) {\n  .center-section {\n    padding: 0 0 40px;\n  }\n}\n@media (max-width: 767.98px) {\n  .center-section {\n    padding: 0 0 16px;\n  }\n}\n\n.center-img {\n  position: relative;\n  margin: 0 20px 0 0;\n}\n.center-img .center-service {\n  position: absolute;\n  right: 0;\n  bottom: 30px;\n  background: #ffffff;\n  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);\n  border-radius: 100px;\n  padding: 15px;\n  text-align: left;\n}\n.center-img .center-service span {\n  width: 40px;\n  height: 40px;\n  background: #1b5a90;\n  color: #ffffff;\n  border-radius: 100px;\n  margin: 0 15px 0 0;\n  flex-shrink: 0;\n}\n.center-img .center-service h6 {\n  font-size: 16px;\n  font-weight: 500;\n  color: #1f2937;\n  margin: 0 0 5px;\n}\n.center-img .center-service p {\n  margin: 0;\n}\n@media (max-width: 991.98px) {\n  .center-img .center-service {\n    left: 50%;\n    transform: translateX(-50%);\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n  }\n}\n@media (max-width: 575.98px) {\n  .center-img .center-service {\n    width: 100%;\n  }\n}\n@media (max-width: 991.98px) {\n  .center-img {\n    text-align: center;\n    margin: 0 0 24px 0;\n  }\n}\n\n.center-info .sec-heading-eye {\n  margin: 0 0 15px;\n}\n.center-info p {\n  margin: 0 0 15px;\n}\n.center-info p::last-child {\n  margin: 0 0 15px;\n}\n\n.care-box span img {\n  margin: 0 0 15px;\n}\n.care-box h6 {\n  font-size: 16px;\n  font-weight: 500;\n  color: #1f2937;\n  margin: 0 0 15px;\n}\n.care-box a {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1b5a90;\n}\n.care-box a:hover {\n  color: #0e82fd;\n}\n.care-box a i {\n  margin: 0 0 0 5px;\n  font-size: 12px;\n}\n@media (max-width: 991.98px) {\n  .care-box {\n    margin-bottom: 24px;\n  }\n}\n\n.counter-section {\n  background: linear-gradient(90deg, #1b5a90 0%, #13a0ca 66.9%, #0ce0ff 106.51%);\n  padding: 80px 0 56px;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .counter-section {\n    padding: 40px 0 16px;\n  }\n}\n\n.bg-06 {\n  left: 0;\n  bottom: 0;\n}\n\n.bg-07 {\n  right: 0;\n  bottom: 0;\n}\n\n.count-box {\n  margin: 0 0 24px;\n}\n.count-box .count-icon {\n  width: 80px;\n  height: 80px;\n  background: #ffffff;\n  border-radius: 100px;\n  margin: 0 26px 0 0;\n  flex-shrink: 0;\n}\n.count-box h3 {\n  font-size: 36px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 15px;\n}\n@media (max-width: 991.98px) {\n  .count-box h3 {\n    font-size: 30px;\n  }\n}\n@media (max-width: 767.98px) {\n  .count-box h3 {\n    font-size: 24px;\n  }\n}\n.count-box p {\n  color: #ffffff;\n  margin: 0;\n}\n\n.eyeclinics-section {\n  padding: 80px 0;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .eyeclinics-section {\n    padding: 40px 0;\n  }\n}\n\n.bg-08 {\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n}\n\n.our-doctors-card.eye-doc {\n  margin: 0 0 50px;\n}\n.our-doctors-card.eye-doc .doctors-header {\n  overflow: hidden;\n}\n.our-doctors-card.eye-doc .doctors-header img {\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n}\n.our-doctors-card.eye-doc .doctors-header:hover img {\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n.our-doctors-card.eye-doc .doctors-body {\n  padding: 15px;\n}\n.our-doctors-card.eye-doc .doctors-body h4 {\n  font-weight: 600;\n  margin: 0 0 5px;\n}\n.our-doctors-card.eye-doc .doctors-body h4 a {\n  color: #1f2937;\n}\n.our-doctors-card.eye-doc .doctors-body h4 a:hover {\n  color: #1b5a90;\n}\n.our-doctors-card.eye-doc .doctors-body p {\n  margin: 0 0 5px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.our-doctors-card.eye-doc .doctors-body h6 {\n  font-size: 14px;\n  margin: 0 0 15px;\n}\n.our-doctors-card.eye-doc .doctors-body .rating i.filled {\n  color: #ffaf14;\n  padding: 0 2px;\n}\n.our-doctors-card.eye-doc .doctors-body .rating span {\n  font-size: 14px;\n  color: #000000;\n  margin: 0 0 0 8px;\n}\n@media (max-width: 991.98px) {\n  .our-doctors-card.eye-doc {\n    margin: 0 0 30px;\n  }\n}\n\n.facilities-section {\n  padding: 80px 0 56px;\n}\n@media (max-width: 991.98px) {\n  .facilities-section {\n    padding: 40px 0 16px;\n  }\n}\n\n.facility-box {\n  margin: 0 0 24px;\n}\n.facility-box .facility-img {\n  margin: 0 0 15px;\n}\n.facility-box .facility-img img {\n  width: 100%;\n}\n\n.our-blog-section.eye-blog {\n  background: linear-gradient(\n    88.66deg,\n    #d6eeff 1.08%,\n    #f9fdff 26.56%,\n    #ffffff 76.5%,\n    #e6fcff 98.92%\n  );\n}\n.our-blog-section.eye-blog .our-blogs {\n  border-bottom: 0;\n  border-radius: 0;\n  margin: 0 0 50px;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-img {\n  overflow: hidden;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-img .blog-inner-img {\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-img:hover .blog-inner-img {\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay {\n  background: rgba(255, 255, 255, 0.9);\n  padding: 10px;\n  border-radius: 0;\n  bottom: 0;\n  width: 100%;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name img {\n  height: 40px;\n  width: 40px !important;\n  margin-right: 5px;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name div {\n  width: 60%;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name div a {\n  margin: 0 0 5px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 16px;\n  font-weight: normal;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name div a:hover {\n  color: #0e82fd;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name div a a {\n  color: #1f2937;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-name div p {\n  font-size: 13px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin: 0;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-img .blogs-overlay .blog-cat {\n  background: #1b5a90;\n  font-weight: 500;\n  font-size: 13px;\n  padding: 4px 10px;\n  color: #ffffff;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-info h4 {\n  margin: 0 0 10px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-info h4 a {\n  color: #1f2937;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-info h4 a:hover {\n  color: #1b5a90;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-info p {\n  font-size: 16px;\n  color: #6b7280;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-info .blogs-btn {\n  font-weight: 500;\n  font-size: 14px;\n  color: #1b5a90;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-info .blogs-btn i {\n  margin: 0 0 0 5px;\n}\n.our-blog-section.eye-blog .our-blogs .blogs-info .blogs-btn:hover {\n  color: #0e82fd;\n}\n\n.appointment-section {\n  background-color: #1b5a90;\n  position: relative;\n  z-index: 1;\n  padding-top: 325px;\n}\n@media (max-width: 767.98px) {\n  .appointment-section {\n    padding-top: 0;\n  }\n}\n.appointment-section::before {\n  position: absolute;\n  top: -1px;\n  left: 0;\n  background: url(../images/bg/app-bg.jpg) no-repeat center top;\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  top: -1px;\n  z-index: -1;\n}\n@media (max-width: 767.98px) {\n  .appointment-section::before {\n    background: none;\n  }\n}\n\n.appointment-form {\n  padding: 80px 0;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .appointment-form {\n    padding: 40px 0;\n  }\n}\n\n.bg-09 {\n  bottom: 0;\n  right: 15%;\n}\n\n.bg-10 {\n  bottom: 0;\n  left: 3%;\n}\n\n.appointment-form .doctor-search-form .form-group {\n  margin: 0 0 15px;\n}\n.appointment-form .doctor-search-form .form-group .form-custom input,\n.appointment-form .doctor-search-form .form-group .form-custom select {\n  background: #2369a6;\n  box-shadow: none;\n  color: #ffffff;\n  border-radius: 0;\n  min-height: 50px;\n}\n.appointment-form .doctor-search-form .form-group .form-custom input::placeholder,\n.appointment-form .doctor-search-form .form-group .form-custom select::placeholder {\n  color: #ffffff;\n}\n.appointment-form\n  .doctor-search-form\n  .form-group\n  .form-custom\n  .select2-container\n  .select2-selection--single {\n  height: 50px;\n  background-color: #2369a6;\n  border-color: #2369a6;\n}\n.appointment-form\n  .doctor-search-form\n  .form-group\n  .form-custom\n  .select2-container\n  .select2-selection--single\n  .select2-selection__rendered {\n  color: #ffffff;\n}\n.appointment-form\n  .doctor-search-form\n  .form-group\n  .form-custom\n  .select2-container\n  .select2-selection--single\n  .select2-selection__rendered\n  .select2-results__option--highlighted[aria-selected] {\n  background-color: #2369a6;\n}\n.appointment-form .doctor-search-form .form-group .form-custom i {\n  color: #ffffff;\n}\n\n.app-btn {\n  border-radius: 100px;\n  margin: 35px 0 0;\n  padding: 11px 26px;\n}\n\n.faq-eye-section {\n  padding: 80px 0;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .faq-eye-section {\n    padding: 40px 0;\n  }\n}\n\n.faq-wrap ul {\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n.faq-wrap ul li {\n  list-style: none;\n}\n.faq-wrap ul li a {\n  background: #f0f4f6;\n  margin: 0 0 15px;\n  padding: 15px;\n  color: #1f2937;\n}\n.faq-wrap ul li a span {\n  width: 30px;\n  height: 30px;\n  background: #ffffff;\n  border-radius: 100px;\n  margin: 0 10px 0 0;\n  flex-shrink: 0;\n  color: #1f2937;\n}\n.faq-wrap ul li a.active {\n  background: #1b5a90;\n  color: #ffffff;\n}\n\n.faq-content img {\n  margin: 0 0 29px;\n}\n.faq-content p {\n  margin: 0 0 15px;\n}\n.faq-content p:last-child {\n  margin: 0;\n}\n\n.eye-testimonial-section {\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .eye-testimonial-section {\n    padding: 40px 0;\n  }\n}\n\n.testi-img {\n  position: relative;\n  margin: 43px 0 15px;\n}\n.testi-img img {\n  padding: 0 43px 0 0;\n}\n.testi-img .testi-icon {\n  width: 86px;\n  height: 86px;\n  background: #0ce0ff;\n  border-radius: 100px;\n  font-size: 16px;\n  color: #ffffff;\n  position: absolute;\n  top: -43px;\n  right: 0;\n}\n\n.testi-users {\n  margin: 0 43px 0 0;\n}\n.testi-users ul {\n  margin: 0;\n  padding: 0;\n}\n.testi-users ul li {\n  display: inline-block;\n  margin: 0 0 0 -23px;\n}\n.testi-users ul li:first-child {\n  margin: 0;\n}\n.testi-users ul li img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);\n  border: 2px solid #ffffff;\n}\n@media (max-width: 767.98px) {\n  .testi-users ul li img {\n    width: 50px;\n    height: 50px;\n  }\n}\n\n.testimonial-wrap {\n  position: relative;\n}\n.testimonial-wrap h4 {\n  margin: 0 0 30px;\n}\n.testimonial-wrap p {\n  margin: 0 0 30px;\n}\n.testimonial-wrap .testimonial-user h6 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 5px;\n}\n.testimonial-wrap .testimonial-user p {\n  font-size: 14px;\n  margin: 0;\n}\n.testimonial-wrap::before {\n  content: \"\";\n  background: url(\"../images/icons/test-line.svg\") no-repeat;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 84px;\n  height: 14px;\n}\n\n.slide-11 button {\n  background: transparent;\n  border: 0;\n  padding: 0;\n}\n.slide-11 button.owl-next {\n  margin: 0 0 0 10px;\n}\n\n.store-section {\n  padding: 80px 0;\n  position: relative;\n  background: #f0f4f7 url(\"../images/bg/store-bg.png\") no-repeat;\n  background-position: top right;\n}\n\n.store-tab {\n  margin: 0 0 35px;\n}\n.store-tab li {\n  display: inline-block;\n  margin: 0 0 15px 15px;\n}\n.store-tab li a {\n  padding: 10px 15px;\n  background: #ffffff;\n  border-radius: 100px;\n  color: #1f2937;\n  display: inline-block;\n}\n.store-tab li a.active,\n.store-tab li a:hover {\n  background: #1b5a90;\n  color: #ffffff;\n}\n\n.store-item {\n  margin: 0 0 50px;\n  padding: 15px;\n  background: #ffffff;\n}\n.store-item .store-img {\n  position: relative;\n  overflow: hidden;\n  margin: 0 0 15px;\n}\n.store-item .store-img img {\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n}\n.store-item .store-img .glass-cat {\n  background: #0ce0ff;\n  color: #ffffff;\n  font-size: 14px;\n  padding: 5px 10px;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.store-item .store-img:hover img {\n  transform: scale(1.1) rotate(0);\n  -webkit-transform: scale(1.1) rotate(0);\n  -ms-transform: scale(1.1) rotate(0);\n}\n.store-item .store-content .store-cat {\n  background: #1b5a90;\n  display: inline-block;\n  color: #ffffff;\n  font-size: 12px;\n  margin: 0 0 5px;\n  padding: 1px 5px;\n}\n.store-item .store-content h4 {\n  font-weight: 600;\n  margin: 0 0 5px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.store-item .store-content h4 a {\n  color: #1f2937;\n}\n.store-item .store-content h4 a:hover {\n  color: #1b5a90;\n}\n.store-item .store-content p {\n  margin: 0 0 15px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.store-item .store-content .price-tag h5 {\n  font-size: 22px;\n  font-weight: 600;\n  margin: 0;\n}\n.store-item .store-content .price-tag .color-selection {\n  margin: 0;\n  padding: 0;\n}\n.store-item .store-content .price-tag .color-selection li {\n  list-style: none;\n  display: inline-block;\n  margin-right: 5px;\n}\n.store-item .store-content .price-tag .color-selection li span i {\n  font-size: 16px;\n  outline: 1px solid #d9d9d9;\n  outline-offset: 3px;\n  border-radius: 50%;\n}\n.store-item .store-content .price-tag .color-selection li span.black-glass {\n  color: #131218;\n}\n.store-item .store-content .price-tag .color-selection li span.blue-glass {\n  color: #2369a6;\n}\n.store-item .store-content .price-tag .color-selection li span.gold-glass {\n  color: #ddbc5b;\n}\n.store-item .store-content .price-tag .color-selection li span.grey-glass {\n  color: #666666;\n}\n.store-item .store-content .price-tag .color-selection li span.sand-glass {\n  color: #fdeec3;\n}\n.store-item .store-content .price-tag .color-selection li span.green-glass {\n  color: #13c2c2;\n}\n.store-item .store-content .price-tag .color-selection li:last-child {\n  margin-right: 0;\n}\n\n.offer-section {\n  padding-top: 124px;\n}\n@media (max-width: 991.98px) {\n  .offer-section {\n    padding-top: 73px;\n  }\n}\n\n.offer-wrap {\n  background: radial-gradient(50% 50% at 50% 50%, #328cd9 0%, #1b5a90 100%);\n  margin: 0;\n  padding: 0 24px;\n}\n@media (max-width: 991.98px) {\n  .offer-wrap {\n    margin: 0 0 60px 0;\n    padding: 20px 24px !important;\n  }\n}\n.offer-wrap.flat-offer {\n  background: radial-gradient(50% 50% at 50% 50%, #97f0ff 0%, #0cbcda 100%);\n}\n@media (max-width: 991.98px) {\n  .offer-wrap.flat-offer {\n    margin-bottom: 0;\n  }\n}\n.offer-wrap.flat-offer .btn {\n  background: #1c5c92;\n}\n.offer-wrap.flat-offer .btn:hover {\n  color: #1c5c92;\n}\n.offer-wrap .off-img {\n  margin: -45px 0 24px;\n}\n@media (max-width: 767.98px) {\n  .offer-wrap .off-img {\n    text-align: center;\n  }\n}\n.offer-wrap .off-info {\n  position: relative;\n  text-align: center;\n}\n.offer-wrap .off-info h6 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 5px;\n}\n.offer-wrap .off-info p {\n  margin: 0 0 5px;\n  padding: 0 17px;\n  position: relative;\n  color: #ffffff;\n  display: inline-block;\n}\n.offer-wrap .off-info p::before {\n  content: \"\";\n  background: #ffffff;\n  width: 15px;\n  height: 1px;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n}\n.offer-wrap .off-info p::after {\n  content: \"\";\n  background: #ffffff;\n  width: 15px;\n  height: 1px;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n}\n.offer-wrap .off-info h5 {\n  color: #ffffff;\n  margin: 0 0 15px;\n}\n.offer-wrap .off-info .btn {\n  font-size: 16px;\n  padding: 3px 42px;\n  border-radius: 100px;\n}\n.offer-wrap .off-info::before,\n.offer-wrap .off-info::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 18px;\n  height: 85%;\n  border: 1px solid;\n  -webkit-transition: all 0.6s ease;\n  -ms-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.offer-wrap .off-info::before {\n  bottom: 0;\n  left: 0;\n  top: 8px;\n  border-top-color: #ffffff;\n  border-left-color: #ffffff;\n  border-bottom-color: #ffffff;\n  border-right-color: transparent;\n}\n.offer-wrap .off-info::after {\n  bottom: 0;\n  right: 0;\n  top: 8px;\n  border-top-color: #ffffff;\n  border-left-color: transparent;\n  border-bottom-color: #ffffff;\n  border-right-color: #ffffff;\n}\n\n.eye-testimonial-section .eye-testislider .owl-nav {\n  position: absolute;\n  margin-left: -472px;\n  margin-top: 26px;\n}\n\n.appointment-form .form-group .form-custom .timepicker1 {\n  background: none;\n  border: none;\n  padding: 0;\n}\n\n.appointment-form .form-group .form-custom .timepicker1 .rc-time-picker-input {\n  font-size: 15px;\n}\n\n.main-wrapper.home-twelve {\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-twelve {\n    font-size: 15px;\n  }\n}\n.main-wrapper.home-twelve .row-gap {\n  row-gap: 24px;\n}\n.main-wrapper.home-twelve a:hover {\n  color: #0e82fd;\n}\n.main-wrapper.home-twelve .banner-section-fourteen.banner-section-twelve {\n  background: #f9f9f9;\n  padding: 200px 0 80px 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .banner-section-fourteen.banner-section-twelve {\n    padding: 150px 0 50px 0;\n  }\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve .banner-section-fourteen.banner-section-twelve {\n    padding: 100px 0 50px 0;\n  }\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-section-twelve-bg\n  img {\n  position: absolute;\n  z-index: -1;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-section-twelve-bg\n  img:nth-child(1) {\n  left: 0;\n  bottom: 0;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-section-twelve-bg\n  img:nth-child(2) {\n  right: 0;\n  top: 100px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve\n    .banner-section-fourteen.banner-section-twelve\n    .banner-section-twelve-bg\n    img:nth-child(2) {\n    display: none;\n  }\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-img.banner-img-twelve {\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n  position: relative;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-img.banner-img-twelve\n  img:nth-child(2) {\n  animation: movers 1s ease infinite alternate;\n  animation-delay: 1s;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-img.banner-img-twelve\n  .banner-banner-img-twelve-bg\n  img {\n  position: absolute;\n  z-index: -1;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-img.banner-img-twelve\n  .banner-banner-img-twelve-bg\n  img:nth-child(1) {\n  bottom: 9%;\n  right: 46%;\n  animation: gelatine 2s infinite;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-img.banner-img-twelve\n  .banner-banner-img-twelve-bg\n  img:nth-child(2) {\n  left: 0;\n  animation: grow 2s ease infinite alternate;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-img.banner-img-twelve\n  .banner-banner-img-twelve-bg\n  img:nth-child(3) {\n  right: 48%;\n  top: -92px;\n  animation: movers 2s infinite alternate;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-img.banner-img-twelve\n  .banner-banner-img-twelve-bg\n  img:nth-child(4) {\n  bottom: 22%;\n  right: 30%;\n  animation: movers 2s infinite alternate;\n}\n@keyframes gelatine {\n  from,\n  to {\n    transform: scale(1, 1);\n  }\n  25% {\n    transform: scale(0.9, 1.1);\n  }\n  50% {\n    transform: scale(1.1, 0.9);\n  }\n  75% {\n    transform: scale(0.95, 1.05);\n  }\n}\n@keyframes grow {\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve\n    .banner-section-fourteen.banner-section-twelve\n    .banner-img.banner-img-twelve {\n    display: none;\n  }\n}\n.main-wrapper.home-twelve .banner-section-fourteen.banner-section-twelve .banner-content-fourteen {\n  margin: 0;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-content-fourteen\n  h1 {\n  color: #0e82fd;\n  max-width: 460px;\n  margin: 0 0 20px 0;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-content-fourteen\n  h1\n  span {\n  color: #1f2937;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve\n    .banner-section-fourteen.banner-section-twelve\n    .banner-content-fourteen\n    h1 {\n    margin: auto;\n  }\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-content-fourteen\n  .banner-btns-fourteen\n  .btn-primary {\n  background: transparent;\n  color: #0e82fd;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-content-fourteen\n  .banner-btns-fourteen\n  .btn-primary:hover {\n  background: #0e82fd;\n  color: #ffffff;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-content-fourteen\n  .banner-btns-fourteen\n  .btn-primary:nth-child(1) {\n  background: #0e82fd;\n  color: #ffffff;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-content-fourteen\n  .banner-btns-fourteen\n  .btn-primary:nth-child(1):hover {\n  background: transparent;\n  color: #0e82fd !important;\n  border: 1px solid #0e82fd;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .banner-content-fourteen\n  .banner-btns-fourteen\n  .btn-primary:nth-child(2):hover {\n  color: #ffffff;\n  border-color: #0e82fd;\n}\n.main-wrapper.home-twelve .banner-section-fourteen.banner-section-twelve .search-box-fourteen {\n  padding: 20px;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .search-box-fourteen\n  .form-block {\n  align-items: center;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .search-box-fourteen\n  .form-block\n  .search-input\n  label {\n  position: relative;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .search-box-fourteen\n  .form-block\n  .search-input\n  label::after {\n  position: absolute;\n  content: \"\\f274\";\n  font-family: \"Font Awesome 5 Free\";\n  color: #0e82fd;\n  font-weight: 900;\n  right: -24px;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .search-box-fourteen\n  .form-block\n  .search-input\n  label.location-icon::after {\n  position: absolute;\n  content: \"\\f3c5\";\n  font-family: \"Font Awesome 5 Free\";\n  color: #0e82fd;\n  font-weight: 900;\n  right: -24px;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .search-box-fourteen\n  .form-block\n  .search-input\n  .form-control::placeholder {\n  font-weight: 600;\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .search-box-fourteen\n  .form-block\n  .search-btn {\n  margin: 0;\n}\n@media (max-width: 767.98px) {\n  .main-wrapper.home-twelve\n    .banner-section-fourteen.banner-section-twelve\n    .search-box-fourteen\n    .form-block\n    .search-btn {\n    width: 100%;\n  }\n}\n.main-wrapper.home-twelve\n  .banner-section-fourteen.banner-section-twelve\n  .search-box-fourteen\n  .form-block\n  .search-btn\n  .btn.btn-primary {\n  padding: 14px 16px;\n}\n.main-wrapper.home-twelve .section-header-fourteen {\n  text-align: center;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .section-header-fourteen {\n    text-align: center !important;\n  }\n}\n.main-wrapper.home-twelve .section-header-fourteen .service-inner-fourteen {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  justify-content: center;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .section-header-fourteen .service-inner-fourteen {\n    justify-content: center !important;\n  }\n}\n.main-wrapper.home-twelve\n  .section-header-fourteen\n  .service-inner-fourteen\n  .service-inner-fourteen-one {\n  background: #0e82fd;\n  content: \"\";\n  width: 50px;\n  height: 3px;\n}\n.main-wrapper.home-twelve\n  .section-header-fourteen\n  .service-inner-fourteen\n  .service-inner-fourteen-two\n  h3 {\n  color: #0e82fd;\n  font-size: 14px;\n  margin: 0 0;\n  padding: 10px 20px;\n  border-radius: 100px;\n  font-weight: 400;\n  background: #e3f2f9;\n  z-index: 99;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-twelve\n    .section-header-fourteen\n    .service-inner-fourteen\n    .service-inner-fourteen-two\n    h3 {\n    font-size: 14px;\n  }\n}\n.main-wrapper.home-twelve\n  .section-header-fourteen\n  .service-inner-fourteen\n  .service-inner-fourteen-three {\n  background: #0e82fd;\n  content: \"\";\n  width: 50px;\n  height: 3px;\n}\n.main-wrapper.home-twelve .section-header-fourteen h2 {\n  color: #1f2937;\n  font-size: 40px;\n  font-weight: 600;\n  position: relative;\n  margin: 0 0 10px 0;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-twelve .section-header-fourteen h2 {\n    font-size: 32px;\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .section-header-fourteen h2 {\n    margin: 0 0 10px 0;\n  }\n}\n.main-wrapper.home-twelve .section-header-fourteen h2::before {\n  position: absolute;\n  flex-shrink: 0;\n  width: 120px;\n  height: 110px;\n  content: \"\";\n  background-image: url(\"../images/bg/header-after.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  transition: transform 0.2s ease-in-out;\n  top: -36px;\n  transform: translate(-50%, 0);\n  left: 50%;\n  z-index: -1;\n}\n.main-wrapper.home-twelve .section-header-fourteen p {\n  color: #6b7280;\n  font-size: 18px;\n  font-weight: 400;\n  margin: 0 0 50px 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .section-header-fourteen p {\n    margin: 0 0 35px 0;\n    font-size: 16px;\n  }\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve .section-header-fourteen p {\n    margin: 0 0 30px 0;\n  }\n}\n.main-wrapper.home-twelve .services-section-fourteen {\n  background: #f9fafb;\n  position: relative;\n}\n.main-wrapper.home-twelve .services-section-fourteen .floating-bg img {\n  position: absolute;\n}\n.main-wrapper.home-twelve .services-section-fourteen .floating-bg img:nth-child(1) {\n  right: 0;\n  top: 150px;\n}\n.main-wrapper.home-twelve .services-section-fourteen .floating-bg img:nth-child(2) {\n  left: 0;\n  bottom: 100px;\n}\n.main-wrapper.home-twelve .services-section-fourteen .our-services-list {\n  border-radius: 30px;\n  padding: 30px;\n  background: #ffffff;\n  text-align: center;\n  transition: all 0.5s;\n}\n.main-wrapper.home-twelve .services-section-fourteen .our-services-list .service-icon {\n  width: 140px;\n  height: 140px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #0e82fd;\n  margin: auto;\n  box-shadow: 0px 25px 50px rgba(14, 130, 253, 0.1);\n  border-radius: 30px;\n  -webkit-transition: 0.4s;\n  -ms-transition: 0.4s;\n  transition: 0.4s;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .services-section-fourteen .our-services-list .service-icon {\n    width: 120px;\n    height: 120px;\n  }\n}\n.main-wrapper.home-twelve .services-section-fourteen .our-services-list h4 {\n  margin: 0;\n  padding: 20px 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .services-section-fourteen .our-services-list h4 {\n    padding: 15px 0;\n    font-size: 22px;\n  }\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve .services-section-fourteen .our-services-list h4 {\n    font-size: 20px;\n  }\n}\n.main-wrapper.home-twelve .services-section-fourteen .our-services-list p {\n  color: #6b7280;\n  font-size: 14px;\n  text-align: center;\n  margin: 0;\n}\n.main-wrapper.home-twelve .services-section-fourteen .our-services-list:hover {\n  cursor: pointer;\n  background: #334155;\n  box-shadow: 0px 20px 50px rgba(51, 65, 85, 0.05);\n  transform: translateY(-10px);\n}\n.main-wrapper.home-twelve .services-section-fourteen .our-services-list:hover .service-icon {\n  transform: rotateY(360deg);\n  -webkit-transform: rotateY(360deg);\n  -ms-transform: rotateY(360deg);\n  background: #ffffff;\n}\n.main-wrapper.home-twelve .services-section-fourteen .our-services-list:hover .service-icon img {\n  filter: invert(1) brightness(100);\n}\n.main-wrapper.home-twelve .services-section-fourteen .our-services-list:hover h4,\n.main-wrapper.home-twelve .services-section-fourteen .our-services-list:hover p {\n  color: #ffffff;\n}\n.main-wrapper.home-twelve .blog-section-fourteen.our-doctor-twelve {\n  background: #f3f4f6;\n  position: relative;\n  z-index: 1;\n}\n.main-wrapper.home-twelve .blog-section-fourteen.our-doctor-twelve .floating-bg img {\n  position: absolute;\n}\n.main-wrapper.home-twelve .blog-section-fourteen.our-doctor-twelve .floating-bg img:nth-child(1) {\n  right: 0;\n  top: 150px;\n}\n.main-wrapper.home-twelve .blog-section-fourteen.our-doctor-twelve .floating-bg img:nth-child(2) {\n  left: 0;\n  bottom: 100px;\n}\n.main-wrapper.home-twelve .blog-section-fourteen.our-doctor-twelve .blog-inner-fourt-all {\n  border-radius: 40px;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main {\n  padding: 15px;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt {\n  text-align: center;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-right-img {\n  position: relative;\n  margin: 0 0 20px 0;\n  overflow: hidden;\n  border-radius: 30px;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-right-img\n  img {\n  position: relative;\n  border-radius: 30px;\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  width: 100%;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-right-img:hover\n  img {\n  transform: scale(1.2);\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content {\n  position: absolute;\n  top: auto;\n  bottom: 20px;\n  left: 50%;\n  transform: translate(-50%, 0);\n  padding: 8px 0;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 50px;\n  min-width: 180px;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content\n  img {\n  width: 35px;\n  height: 35px;\n  border-radius: 50px;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content\n  span {\n  font-size: 14px;\n  color: #0e82fd;\n  font-weight: 600;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content.content-pricing {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  bottom: auto;\n  left: auto;\n  transform: none;\n  min-width: 65px;\n  border-radius: 8px;\n  background: #ffffff;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content.content-pricing\n  span {\n  color: #1f2937;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-right-fourt-care {\n  display: block;\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0 0 10px 0;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-right-fourt-care\n  a:hover {\n  color: #0e82fd;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-articles-list {\n  margin: 0 0 20px 0;\n  justify-content: center;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-articles-list\n  li {\n  color: #6b7280;\n  font-size: 14px;\n  margin: 0 0px 0 0;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-articles-list\n  li\n  i {\n  color: #d1d5db;\n  margin-right: 6px;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-articles-list-two {\n  margin: 0 0 10px 0;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-articles-list-two\n  li {\n  background: #dbeffe;\n  color: #0e82fd;\n  margin: 0 10px 10px 0;\n  padding: 10px 15px;\n  border-radius: 8px;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-articles-list-two\n  li:last-child {\n  margin: 0 0 10px 0;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-list-ratings {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-list-ratings\n  i {\n  color: rgba(26, 84, 199, 0.15);\n  margin-right: 2px;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-list-ratings\n  i:last-child {\n  margin-right: 0;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-list-ratings\n  i.rated {\n  color: #ffc001;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-list-ratings\n  span {\n  color: #9ca3af;\n  font-size: 14px;\n  margin-left: 3px;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .btn-primary {\n  background: #0e82fd;\n  color: #ffffff;\n  border: 1px solid #0e82fd;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve\n    .blog-section-fourteen.our-doctor-twelve\n    .blog-inner-fourt-all\n    .blog-inner-fourt-main\n    .blog-inner-right-fourt\n    .btn-primary {\n    width: 100%;\n  }\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen.our-doctor-twelve\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .btn-primary:hover {\n  background: #ffffff;\n  color: #0e82fd;\n}\n.main-wrapper.home-twelve .clients-section-fourteen {\n  position: relative;\n  z-index: 1;\n  padding: 80px 0;\n  background: #f9fafb;\n}\n.main-wrapper.home-twelve .clients-section-fourteen .floating-bg img {\n  position: absolute;\n}\n.main-wrapper.home-twelve .clients-section-fourteen .floating-bg img:nth-child(1) {\n  right: 10px;\n  top: 50px;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-twelve .clients-section-fourteen {\n    padding: 80px 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-twelve .clients-section-fourteen {\n    padding: 50px 0;\n  }\n}\n.main-wrapper.home-twelve .clients-section-fourteen .section-header-fourteen {\n  text-align: start;\n}\n.main-wrapper.home-twelve .clients-section-fourteen .section-header-fourteen h2 {\n  display: inline-block;\n}\n.main-wrapper.home-twelve\n  .clients-section-fourteen\n  .section-header-fourteen\n  .service-inner-fourteen {\n  justify-content: start;\n}\n.main-wrapper.home-twelve .clients-section-fourteen .client-inner-main {\n  -webkit-animation: mover 2s infinite alternate;\n  animation: mover 2s infinite alternate;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .clients-section-fourteen .client-inner-main {\n    display: none;\n  }\n}\n.main-wrapper.home-twelve .clients-section-fourteen .feedback-slider-fourteen .owl-nav {\n  text-align: end;\n  margin-top: 40px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .clients-section-fourteen .feedback-slider-fourteen .owl-nav {\n    text-align: center;\n    margin-top: 10px;\n  }\n}\n.main-wrapper.home-twelve .clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-prev {\n  background: #e2e8f0;\n  border-radius: 8px;\n  width: 50px;\n  height: 50px;\n  color: #94a3b8;\n  text-shadow: none;\n  font-size: 24px;\n  border: none;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-prev {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n  }\n}\n.main-wrapper.home-twelve\n  .clients-section-fourteen\n  .feedback-slider-fourteen\n  .owl-nav\n  .owl-prev:hover {\n  background: #bfe0fe;\n  color: #1d7ed8;\n}\n.main-wrapper.home-twelve .clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-next {\n  background: #e2e8f0;\n  border-radius: 8px;\n  width: 50px;\n  height: 50px;\n  color: #94a3b8;\n  text-shadow: none;\n  font-size: 24px;\n  border: none;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-next {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n  }\n}\n.main-wrapper.home-twelve\n  .clients-section-fourteen\n  .feedback-slider-fourteen\n  .owl-nav\n  .owl-next:hover {\n  background: #bfe0fe;\n  color: #1d7ed8;\n}\n.main-wrapper.home-twelve .clients-section-fourteen .feedback-card {\n  border-radius: 30px;\n  margin: 0 0 0 0;\n  background: transparent;\n  border: none;\n}\n.main-wrapper.home-twelve .clients-section-fourteen .feedback-card .feedback-card-body {\n  padding: 0px;\n}\n.main-wrapper.home-twelve\n  .clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .feedback-inner-img {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  margin: 0 0 50px 0;\n  border: 2px solid #10b981;\n  border-radius: 40px;\n  padding: 20px;\n  gap: 20px;\n  max-width: 660px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve\n    .clients-section-fourteen\n    .feedback-card\n    .feedback-card-body\n    .feedback-inner-main\n    .feedback-inner-img {\n    margin: auto;\n    margin-bottom: 30px;\n  }\n}\n.main-wrapper.home-twelve\n  .clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .feedback-inner-img\n  h6 {\n  color: #1f2937;\n  font-size: 16px;\n}\n.main-wrapper.home-twelve\n  .clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .feedback-inner-img\n  img {\n  width: 100px;\n  height: 100px;\n  border-radius: 20px;\n}\n.main-wrapper.home-twelve\n  .clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .feedback-inner-img\n  h4 {\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0 0 5px 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve\n    .clients-section-fourteen\n    .feedback-card\n    .feedback-card-body\n    .feedback-inner-main\n    .feedback-inner-img\n    h4 {\n    font-size: 18px;\n  }\n}\n.main-wrapper.home-twelve\n  .clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .feedback-inner-img\n  h6 {\n  color: #94a3b8;\n  font-size: 16px;\n  margin: 0 0 20px 0;\n}\n.main-wrapper.home-twelve\n  .clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .feedback-inner-img\n  .rating-fourteen {\n  margin: 0 0 0 0;\n}\n.main-wrapper.home-twelve\n  .clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .feedback-inner-img\n  .rating-fourteen\n  .filled {\n  color: #ffc001;\n}\n.main-wrapper.home-twelve\n  .clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .feedback-inner-img\n  .rating-fourteen\n  i {\n  font-size: 18px;\n}\n.main-wrapper.home-twelve\n  .clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  p {\n  color: #6b7280;\n  font-size: 20px;\n  margin: 0 0 0 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve\n    .clients-section-fourteen\n    .feedback-card\n    .feedback-card-body\n    .feedback-inner-main\n    p {\n    font-size: 20px;\n    text-align: center;\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve\n    .clients-section-fourteen\n    .feedback-card\n    .feedback-card-body\n    .feedback-inner-main\n    p {\n    font-size: 17px;\n  }\n}\n.main-wrapper.home-twelve .home-twelve-pricing {\n  position: relative;\n  z-index: 1;\n  padding: 80px 0 80px 0;\n  background: #f3f4f6;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve {\n  height: 605px;\n  background: #ffffff;\n  border-radius: 30px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  transition: all 0.7s;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-bg img {\n  position: absolute;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-bg img:nth-child(1) {\n  bottom: 0;\n  left: 0;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-bg img:nth-child(2) {\n  bottom: 0;\n  right: 0;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-bg img:nth-child(3) {\n  top: 0;\n  right: 0;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .card-title {\n  margin-bottom: 0;\n  text-align: center;\n  margin-bottom: 40px;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .card-title h3 {\n  font-weight: 600;\n  font-size: 30px;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .card-title span {\n  color: #0e82fd;\n  font-size: 14px;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .price {\n  margin-bottom: 40px;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .price h2 {\n  color: #0e82fd;\n  font-style: 48px;\n  font-weight: 600;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .price h2 span {\n  font-size: 14px;\n  color: #6b7280;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .pack-details {\n  margin-bottom: 40px;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .pack-details ul {\n  list-style: none;\n  padding: 0;\n}\n.main-wrapper.home-twelve\n  .home-twelve-pricing\n  .price-card-twelve\n  .price-content\n  .pack-details\n  ul\n  li {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n  color: #6b7280;\n}\n.main-wrapper.home-twelve\n  .home-twelve-pricing\n  .price-card-twelve\n  .price-content\n  .pack-details\n  ul\n  li\n  i {\n  margin-right: 10px;\n  color: #0e82fd;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve .price-content .price-btn a {\n  min-width: 198px;\n  background: #0e82fd;\n  color: #ffffff;\n  border-radius: 6px;\n  text-align: center;\n  border: 1px solid #0e82fd;\n}\n.main-wrapper.home-twelve\n  .home-twelve-pricing\n  .price-card-twelve\n  .price-content\n  .price-btn\n  a:hover {\n  background: #ffffff;\n  color: #0e82fd;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve:hover,\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve.active {\n  cursor: pointer;\n  background: #1e293b;\n}\n.main-wrapper.home-twelve\n  .home-twelve-pricing\n  .price-card-twelve:hover\n  .price-content\n  .card-title\n  h3,\n.main-wrapper.home-twelve\n  .home-twelve-pricing\n  .price-card-twelve.active\n  .price-content\n  .card-title\n  h3 {\n  color: #ffffff;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve:hover .price h2,\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve.active .price h2 {\n  color: #ffffff;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve:hover .price h2 span,\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve.active .price h2 span {\n  color: #ffffff;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve:hover .pack-details,\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve.active .pack-details {\n  margin-bottom: 40px;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve:hover .pack-details ul li,\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve.active .pack-details ul li {\n  color: #ffffff;\n}\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve:hover .pack-details ul li i,\n.main-wrapper.home-twelve .home-twelve-pricing .price-card-twelve.active .pack-details ul li i {\n  color: #0e82fd;\n}\n.main-wrapper.home-twelve .blog-section-fourteen {\n  background: #f9fafb;\n  position: relative;\n  z-index: 1;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-right-fourt-care {\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-right-fourt-care:hover {\n  color: #0e82fd;\n}\n.main-wrapper.home-twelve\n  .blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content {\n  padding: 5px 15px 5px 5px;\n}\n.main-wrapper.home-twelve .blog-section-fourteen .blog-btn-sec .btn-view {\n  border: 1px solid #0e82fd;\n}\n.main-wrapper.home-twelve .blog-section-fourteen .blog-btn-sec .btn-view:hover {\n  box-shadow: inset 220px 0 0 0 #ffffff;\n  color: #0e82fd;\n}\n.main-wrapper.home-twelve .choose-us-fourteen {\n  background: #f3f4f6;\n  position: relative;\n  z-index: 1;\n}\n.main-wrapper.home-twelve .why-us-content .section-title {\n  align-items: start;\n}\n.main-wrapper.home-twelve .why-us-content .section-title h2 {\n  font-size: 60px;\n  font-weight: 500;\n}\n.main-wrapper.home-twelve .why-us-content .section-title p {\n  font-size: 18px;\n  font-weight: 500;\n  text-align: start;\n}\n@keyframes updown {\n  100% {\n    transform: translateY(-10px);\n  }\n}\n.main-wrapper.home-twelve .us-title h6 {\n  font-weight: 500;\n  font-size: 20px;\n}\n.main-wrapper.home-twelve .accordion-item:first-of-type {\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n}\n.main-wrapper.home-twelve .accordion-item {\n  background-color: transparent;\n  border: 0px solid rgba(0, 0, 0, 0.125);\n  border-radius: 20px;\n  margin: 5px 0px 15px 0px;\n}\n.main-wrapper.home-twelve .accordion-header button {\n  font-weight: 600;\n  font-size: 20px;\n  color: #333333;\n}\n.main-wrapper.home-twelve .accordion-header {\n  margin-bottom: 0;\n}\n.main-wrapper.home-twelve .accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve .accordion-item:first-of-type .accordion-button {\n    font-size: 16px;\n  }\n}\n.main-wrapper.home-twelve .accordion-item .accordion-button {\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  border-bottom-right-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve .accordion-item .accordion-button {\n    font-size: 16px;\n  }\n}\n.main-wrapper.home-twelve .accordion-button:not(.collapsed) {\n  background-color: #ffffff;\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n.main-wrapper.home-twelve .accordion-button:not(.collapsed) {\n  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.13);\n}\n.main-wrapper.home-twelve .shade {\n  box-shadow: -8px 13px 80px rgba(27, 41, 80, 0.1);\n  border-bottom-right-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n.main-wrapper.home-twelve .accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 1rem 1.25rem;\n  font-size: 1rem;\n  color: #212529;\n  text-align: left;\n  background-color: transparent;\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition:\n    color 0.15s ease-in-out,\n    background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out,\n    border-radius 0.15s ease;\n}\n.main-wrapper.home-twelve .accordion-button::after {\n  flex-shrink: 0;\n  width: 50px;\n  height: 50px;\n  content: \"\\f0d7\";\n  font-family: \"Font Awesome 5 Free\";\n  color: #0e82fd;\n  font-weight: 900;\n  transition: transform 0.2s ease-in-out;\n  position: absolute;\n  right: 15px;\n  background-size: auto;\n  background-image: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #dbeffe;\n  border-radius: 8px;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve .accordion-button::after {\n    width: 30px;\n    height: 30px;\n  }\n}\n.main-wrapper.home-twelve .accordion-button:not(.collapsed)::after {\n  transform: rotateX(180deg);\n  background-color: #0e82fd;\n  color: #ffffff;\n}\n.main-wrapper.home-twelve .accordion-button:focus {\n  z-index: 3;\n  border-color: #fff;\n  outline: 0;\n  box-shadow: none;\n}\n.main-wrapper.home-twelve .accordion-body {\n  padding: 0rem 6.25rem 1rem 6.26rem;\n  background: #ffffff;\n  border-bottom-right-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve .accordion-body {\n    padding: 0rem 2rem 1rem 6.26rem;\n  }\n}\n.main-wrapper.home-twelve .accordion-body h6 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #6b7280;\n}\n.main-wrapper.home-twelve .accordion-button::before {\n  flex-shrink: 0;\n  width: 42px;\n  height: 42px;\n  content: \"\";\n  background-image: url(\"../images/check.png\");\n  margin-right: 30px;\n  background-repeat: no-repeat;\n  transition: transform 0.2s ease-in-out;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve .accordion-button::before {\n    margin-right: 15px;\n  }\n}\n.main-wrapper.home-twelve .slide-nav-16 button.owl-next,\n.main-wrapper.home-twelve .slide-nav-16 button.owl-prev,\n.main-wrapper.home-twelve .slide-nav-15 button.owl-next,\n.main-wrapper.home-twelve .slide-nav-15 button.owl-prev {\n  background: #e2e8f0;\n  border-radius: 8px;\n  width: 50px;\n  height: 50px;\n  color: #94a3b8;\n  text-shadow: none;\n  font-size: 24px;\n  border: none;\n  position: absolute;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .slide-nav-16 button.owl-next,\n  .main-wrapper.home-twelve .slide-nav-16 button.owl-prev,\n  .main-wrapper.home-twelve .slide-nav-15 button.owl-next,\n  .main-wrapper.home-twelve .slide-nav-15 button.owl-prev {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n    margin: 0 10px 30px 0;\n  }\n}\n.main-wrapper.home-twelve .slide-nav-16 button.owl-next:hover,\n.main-wrapper.home-twelve .slide-nav-16 button.owl-prev:hover,\n.main-wrapper.home-twelve .slide-nav-15 button.owl-next:hover,\n.main-wrapper.home-twelve .slide-nav-15 button.owl-prev:hover {\n  background: #bfe0fe;\n  color: #1d7ed8;\n}\n.main-wrapper.home-twelve .slide-nav-16 button.owl-next,\n.main-wrapper.home-twelve .slide-nav-15 button.owl-next {\n  right: 15px;\n  top: 50%;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .slide-nav-16 button.owl-next,\n  .main-wrapper.home-twelve .slide-nav-15 button.owl-next {\n    z-index: 1;\n  }\n}\n.main-wrapper.home-twelve .slide-nav-16 button.owl-prev,\n.main-wrapper.home-twelve .slide-nav-15 button.owl-prev {\n  left: 15px;\n  top: 50%;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve .slide-nav-16 button.owl-prev,\n  .main-wrapper.home-twelve .slide-nav-15 button.owl-prev {\n    z-index: 1;\n  }\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve .slide-nav-15 button.owl-next,\n  .main-wrapper.home-twelve .slide-nav-15 button.owl-prev {\n    top: 43%;\n  }\n}\n\n.main-wrapper.home-twelve.home-thirteen .row-gap {\n  row-gap: 24px;\n}\n.main-wrapper.home-twelve.home-thirteen a:hover {\n  color: #0e82fd;\n}\n.main-wrapper.home-twelve.home-thirteen .common-padding {\n  margin: 0;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .common-padding {\n    margin: 0;\n    padding: 50px 0;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen .banner-section-thirteen {\n  position: relative;\n  background-image: url(\"../images/bg/home-13-banner.png\");\n  background-repeat: no-repeat;\n  background-size: 100% 80%;\n  background-position: top;\n  padding: 165px 0 0px 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .banner-section-thirteen {\n    background-image: none;\n    background-color: #0e82fd;\n    padding: 135px 0 0px 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-center-img img {\n    display: none;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content {\n  padding-bottom: 0;\n  text-align: center;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content {\n    padding-bottom: 40px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content h4 {\n  text-transform: uppercase;\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 20px;\n}\n@media (max-width: 767.98px) {\n  .main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content h4 {\n    font-size: 16px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content h1 {\n  text-transform: capitalize;\n  color: #ffffff;\n  margin-bottom: 20px;\n}\n.main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content p {\n  font-size: 20px;\n  color: #ffffff;\n  max-width: 570px;\n  margin: auto auto 20px auto;\n}\n@media (max-width: 767.98px) {\n  .main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-content p {\n    font-size: 16px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-content\n  .banner-btns-fourteen\n  .btn-primary {\n  padding: 20px 30px;\n  background: #ffffff;\n  color: #0e82fd;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  transition: all 0.7s;\n  box-shadow: inset 0 0 0 0 #ffffff;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .banner-content\n    .banner-btns-fourteen\n    .btn-primary {\n    padding: 15px 20px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-content\n  .banner-btns-fourteen\n  .btn-primary:hover {\n  background: #1c5b91;\n  color: #ffffff;\n  box-shadow: inset 0 100px 0 0 #1c5b91;\n  -webkit-transition: all 0.7s;\n  -ms-transition: all 0.7s;\n  transition: all 0.7s;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen {\n  margin: 0;\n  padding: 20px;\n  box-shadow: 0px 19.9607px 87.3282px rgba(32, 36, 138, 0.06);\n  border-radius: 10px;\n  min-width: 100%;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-title {\n  margin-bottom: 15px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-title\n  h5 {\n  font-weight: 600;\n  font-size: 24px;\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .search-title\n    h5 {\n    font-size: 20px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input {\n  margin-right: 24px;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .search-input {\n    margin-right: 17px;\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .search-input {\n    margin-bottom: 15px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input.search-line-thirteen {\n  width: 20%;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .search-input.search-line-thirteen {\n    width: 100%;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input.search-map-line-thirteen {\n  width: 19%;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .search-input.search-map-line-thirteen {\n    width: 100%;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input.search-calendar-line-thirteen {\n  width: 18%;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .search-input.search-calendar-line-thirteen {\n    width: 100%;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input.search-users-line-thirteen {\n  width: 18%;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .search-input.search-users-line-thirteen {\n    width: 100%;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input\n  .select2-container\n  .select2-selection--single\n  .select2-selection__rendered {\n  padding-left: 46px;\n  line-height: 56px;\n  font-size: 16px;\n  font-weight: 400;\n  color: #6b7280;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .search-input\n    .select2-container\n    .select2-selection--single\n    .select2-selection__rendered {\n    font-size: 14px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input\n  .select2-container--default\n  .select2-selection--single {\n  background: #f8fbff;\n  border: none;\n  border-radius: 4px;\n  height: 54px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow {\n  top: 5px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  border-color: #6b7280 transparent transparent;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input\n  i {\n  left: 20px;\n  z-index: 1;\n  font-size: 14px;\n  color: #d1d5db;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input\n  input {\n  padding: 0 10px 0 46px;\n  background: #f8fbff;\n  height: 54px;\n  min-height: 54px;\n  font-size: 15px;\n  color: #6b7280;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .search-input\n    input {\n    font-size: 14px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input\n  input:hover,\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .search-input\n  input:focus {\n  background-color: #f8fbff !important;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .form-search-btn {\n  padding-top: 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .form-search-btn {\n    float: none;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .search-box-one.search-box-thirteen\n  .form-search-btn\n  .btn {\n  min-width: auto;\n  padding: 14px 43px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n@media (max-width: 1399.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .form-search-btn\n    .btn {\n    padding: 14px 23px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .form-search-btn\n    .btn {\n    padding: 14px 14px;\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .search-box-one.search-box-thirteen\n    .form-search-btn\n    .btn {\n    width: 100%;\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .banner-section-thirteen .banner-section-thirteen-bg {\n    display: none;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-one {\n  position: absolute;\n  right: 50px;\n  bottom: 250px;\n  animation: elastic-spin 1s infinite ease;\n  z-index: -1;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-two {\n  position: absolute;\n  bottom: 350px;\n  left: 100px;\n  animation: elastic-spin 1s infinite ease;\n  z-index: -1;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-three {\n  position: absolute;\n  top: 350px;\n  left: 130px;\n  animation: elastic-spin 1s infinite ease;\n  z-index: -1;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-four {\n  position: absolute;\n  right: 130px;\n  bottom: 350px;\n  animation: elastic-spin 1s infinite ease;\n  z-index: -1;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-five {\n  position: absolute;\n  top: 600px;\n  right: 130px;\n  animation: elastic-spin 1s infinite ease;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-six {\n  position: absolute;\n  top: 500px;\n  right: 50%;\n  animation: elastic-spin 1s infinite ease;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-seven {\n  position: absolute;\n  top: 500px;\n  left: 80%;\n  animation: pulse 1s infinite ease-in-out alternate;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-eight {\n  position: absolute;\n  top: 350px;\n  left: 30%;\n  animation: pulse 1s infinite ease-in-out alternate;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-nine {\n  position: absolute;\n  top: 200px;\n  left: 15%;\n  animation: spin 3000ms linear infinite;\n  z-index: -1;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-ten {\n  position: absolute;\n  top: 150px;\n  right: 23%;\n  animation: elastic-spin 1s infinite ease;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-eleven {\n  position: absolute;\n  top: 20%;\n  right: 23%;\n  animation: spin 3000ms linear infinite;\n  z-index: -1;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-thirteen {\n  position: absolute;\n  top: 6%;\n  right: 5%;\n  animation: spin 3000ms linear infinite;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-fourteen {\n  position: absolute;\n  top: 8%;\n  right: 5%;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .banner-section-thirteen\n    .banner-section-thirteen-bg\n    .banner-section-thirteen-bg-fourteen {\n    display: none;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-fifteen {\n  position: absolute;\n  top: 17%;\n  right: 0;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-sixteen {\n  position: absolute;\n  top: 12%;\n  left: 0;\n  z-index: -1;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-seventeen\n  a {\n  position: absolute;\n  top: 65%;\n  left: 20%;\n  padding: 25px 30px;\n  background: #00e3ff;\n  color: #ffffff;\n  box-shadow: 0px 19.9607px 87.3282px rgba(32, 36, 138, 0.06);\n  border-radius: 10px;\n  font-size: 20px;\n  font-weight: 700;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-eighteen\n  a {\n  position: absolute;\n  top: 45%;\n  left: 23%;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.4);\n  color: #ffffff;\n  backdrop-filter: blur(8px);\n  border-radius: 10px;\n  font-size: 20px;\n  font-weight: 700;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-ninteen\n  a {\n  position: absolute;\n  top: 30%;\n  right: 24%;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.4);\n  color: #ffffff;\n  backdrop-filter: blur(8px);\n  border-radius: 10px;\n  font-size: 20px;\n  font-weight: 700;\n  z-index: -1;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bg-twenty {\n  position: absolute;\n  top: 56%;\n  left: 17%;\n  z-index: -1;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .banner-section-thirteen\n  .banner-section-thirteen-bg\n  .banner-section-thirteen-bgs {\n  position: absolute;\n  top: 56%;\n  right: 17%;\n}\n.main-wrapper.home-twelve.home-thirteen .services-section-thirteen {\n  padding: 80px 0 56px 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .services-section-thirteen {\n    margin: 0;\n    padding: 50px 0 26px 0;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen .services-section-thirteen .service-thirteen-main {\n  border-radius: 20px;\n  margin: 0 0 24px 0;\n  padding: 8px;\n  transition: 0.5s;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve.home-thirteen .services-section-thirteen .service-thirteen-main {\n    text-align: center;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .services-section-thirteen\n  .service-thirteen-main\n  .service-thirteen-all {\n  padding: 20px;\n  border-radius: 20px;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .services-section-thirteen\n    .service-thirteen-main\n    .service-thirteen-all {\n    display: block;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .services-section-thirteen\n  .service-thirteen-main\n  .service-thirteen-all\n  .service-img-thirteen {\n  margin-right: 15px;\n  position: relative;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .services-section-thirteen\n    .service-thirteen-main\n    .service-thirteen-all\n    .service-img-thirteen {\n    margin: 0 0 10px 0;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .services-section-thirteen\n  .service-thirteen-main\n  .service-thirteen-all\n  .service-img-thirteen\n  img {\n  max-width: 120px;\n  height: 120px;\n  border-radius: 100%;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .services-section-thirteen\n    .service-thirteen-main\n    .service-thirteen-all\n    .service-img-thirteen\n    img {\n    width: 120px;\n  }\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .services-section-thirteen\n    .service-thirteen-main\n    .service-thirteen-all\n    .service-img-thirteen\n    img {\n    width: 120px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .services-section-thirteen\n  .service-thirteen-main\n  .service-thirteen-all\n  .service-img-thirteen\n  .service-inner-img-third {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .services-section-thirteen\n  .service-thirteen-main\n  .service-thirteen-all\n  .service-inner-contents\n  h5 {\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 10px;\n  color: #1f2937;\n  text-transform: capitalize;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .services-section-thirteen\n  .service-thirteen-main\n  .service-thirteen-all\n  .service-inner-contents\n  p {\n  margin-bottom: 0;\n  font-size: 14px;\n  color: #6b7280;\n}\n.main-wrapper.home-twelve.home-thirteen .services-section-thirteen .service-thirteen-main:hover {\n  background: #ffffff;\n  box-shadow: 0px 11px 21px 10px rgba(14, 130, 253, 0.08);\n  transition: 0.5s;\n  transform: translateY(-10px);\n}\n.main-wrapper.home-twelve.home-thirteen\n  .services-section-thirteen\n  .service-thirteen-main:hover\n  .service-thirteen-all {\n  background: #ffffff;\n  border: 1px dashed #0e82fd;\n}\n.main-wrapper.home-twelve.home-thirteen .our-doctor-thirteen {\n  background: url(../images/cloud-bg.png);\n  background-repeat: no-repeat;\n  background-position: top center;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .our-doctor-thirteen {\n    background-color: #f8fbff;\n    background-image: none;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-thirteen-img\n  img {\n  height: 438px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .our-doctor-thirteen\n    .our-doctor-thirteen-all\n    .our-doctor-thirteen-img\n    img {\n    width: 100%;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content {\n  background: #ffffff;\n  box-shadow: 0px 19.9607px 87.3282px rgba(32, 36, 138, 0.06);\n  border-radius: 10px;\n  padding: 20px;\n  position: relative;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  a {\n  display: inline-block;\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  a:hover {\n  color: #0e82fd;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  .our-doctor-content-inner {\n  margin-bottom: 20px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  .our-doctor-content-inner\n  span {\n  padding: 5px 10px;\n  background: rgba(14, 130, 253, 0.1);\n  border-radius: 5px;\n  font-weight: 600;\n  color: #0e82fd;\n  font-size: 14px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  .our-doctor-content-inner\n  .reviews-ratings\n  p {\n  color: #d1d5db;\n  font-size: 12px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  .our-doctor-content-inner\n  .reviews-ratings\n  p\n  span {\n  background: none;\n  color: #6b7280;\n  font-size: 16px;\n  font-weight: 400;\n  margin: 0 4px 0 0;\n  padding: 0;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  .our-doctor-content-inner\n  .reviews-ratings\n  p\n  span\n  i {\n  color: #fbbf24;\n  background: transparent;\n  width: auto;\n  height: auto;\n  border-radius: 0;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  h6 {\n  color: #6b7280;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  p {\n  color: #6b7280;\n  font-size: 14px;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  p\n  i {\n  width: 24px;\n  height: 24px;\n  background: rgba(154, 154, 154, 0.1);\n  border-radius: 5px;\n  margin-right: 5px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-all\n  .our-doctor-content\n  .our-doctor-thirteen-imgone {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n.main-wrapper.home-twelve.home-thirteen .our-doctor-thirteen .our-doctor-thirteen-one img {\n  position: absolute;\n  z-index: 0;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-one\n  img:nth-child(1) {\n  left: 3%;\n  top: 45%;\n  animation: spin 2000ms linear infinite;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-one\n  img:nth-child(2) {\n  right: 7%;\n  bottom: 40%;\n  animation: spin 2000ms linear infinite;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-one\n  img:nth-child(3) {\n  right: 4%;\n  top: 20%;\n  animation: spin 2000ms linear infinite;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .our-doctor-thirteen\n  .our-doctor-thirteen-one\n  img:nth-child(4) {\n  left: 5%;\n  bottom: 30%;\n  animation: spin 2000ms linear infinite;\n}\n.main-wrapper.home-twelve.home-thirteen .choose-us-section-thirteen {\n  background: #f8fbff;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .choose-us-section-thirteen\n  .choose-us-inner-all\n  .choose-us-thirteen-img {\n  text-align: center;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .choose-us-section-thirteen\n    .choose-us-inner-all\n    .choose-us-thirteen-img {\n    display: none;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .choose-us-section-thirteen\n  .choose-us-inner-all\n  .choose-us-thirteen-img\n  img {\n  border-radius: 20px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .choose-us-section-thirteen\n  .choose-us-inner-all\n  .choose-us-thirteen-img\n  .choose-us-thirteen-imgone\n  img {\n  position: absolute;\n  z-index: 0;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .choose-us-section-thirteen\n  .choose-us-inner-all\n  .choose-us-thirteen-img\n  .choose-us-thirteen-imgone\n  img:nth-child(1) {\n  right: 4%;\n  bottom: 0%;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .choose-us-section-thirteen\n  .choose-us-inner-all\n  .choose-us-thirteen-img\n  .choose-us-thirteen-imgone\n  img:nth-child(2) {\n  left: -5%;\n  top: 7%;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .choose-us-section-thirteen\n    .choose-us-inner-all\n    .choose-us-thirteen-img\n    .choose-us-thirteen-imgone\n    img:nth-child(2) {\n    left: -20%;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen .choose-us-section-thirteen ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.main-wrapper.home-twelve.home-thirteen .choose-us-section-thirteen ul li {\n  margin-bottom: 20px;\n  transition: 0.5s;\n  padding: 15px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .choose-us-section-thirteen ul li {\n    padding: 20px;\n    margin-bottom: 20px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen .choose-us-section-thirteen ul li:last-child {\n  margin-bottom: 0;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .choose-us-section-thirteen\n  ul\n  li\n  .choose-us-content-thirteen {\n  display: flex;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .choose-us-section-thirteen\n    ul\n    li\n    .choose-us-content-thirteen {\n    display: block;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .choose-us-section-thirteen\n  ul\n  li\n  .choose-us-content-thirteen\n  .chooseus-contents {\n  min-width: 50px;\n  height: 50px;\n  background: rgba(160, 240, 253, 0.2);\n  border-radius: 10.8333px;\n  font-size: 24px;\n  color: #0e82fd;\n  margin-right: 16px;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .choose-us-section-thirteen\n    ul\n    li\n    .choose-us-content-thirteen\n    .chooseus-contents {\n    margin-bottom: 10px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .choose-us-section-thirteen\n  ul\n  li\n  .choose-us-content-thirteen\n  .chooseus-content-ryt\n  h5 {\n  font-size: 20px;\n  color: #1f2937;\n  font-weight: 600;\n  text-transform: capitalize;\n  margin-bottom: 16px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .choose-us-section-thirteen\n  ul\n  li\n  .choose-us-content-thirteen\n  .chooseus-content-ryt\n  p {\n  font-weight: 400;\n  letter-spacing: 0.2px;\n  text-transform: capitalize;\n  margin-bottom: 0;\n}\n.main-wrapper.home-twelve.home-thirteen .choose-us-section-thirteen ul li:hover {\n  transition: 0.5s;\n  transform: translateY(-10px);\n  box-shadow: 0px 11px 21px 10px rgba(14, 130, 253, 0.08);\n}\n.main-wrapper.home-twelve.home-thirteen .client-us-section-thirteen {\n  position: relative;\n}\n.main-wrapper.home-twelve.home-thirteen .client-us-section-thirteen .client-says-all {\n  display: flex;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-twelve.home-thirteen .client-us-section-thirteen .client-says-all {\n    display: block;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .client-us-section-thirteen\n  .client-says-all\n  .clients-says-content {\n  width: 50%;\n  padding: 70px 50px 50px 50px;\n  background: #0e82fd;\n  border-radius: 35px 0px 0px 35px;\n  position: relative;\n  z-index: -1;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .client-us-section-thirteen\n    .client-says-all\n    .clients-says-content {\n    width: 100%;\n    border-radius: 0;\n    padding: 50px 50px 50px 50px;\n  }\n}\n@media (max-width: 767.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .client-us-section-thirteen\n    .client-says-all\n    .clients-says-content {\n    padding: 25px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .client-us-section-thirteen\n  .client-says-all\n  .clients-says-content\n  p {\n  color: #ffffff;\n  font-size: 20px;\n  line-height: 33px;\n  letter-spacing: 0.2px;\n  text-transform: capitalize;\n  font-weight: 500;\n  margin-bottom: 24px;\n}\n@media (max-width: 1399.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .client-us-section-thirteen\n    .client-says-all\n    .clients-says-content\n    p {\n    font-size: 20px;\n    line-height: 28px;\n    margin-bottom: 13px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .client-us-section-thirteen\n  .client-says-all\n  .clients-says-content\n  h4 {\n  letter-spacing: 0.2px;\n  text-transform: capitalize;\n  color: #c4f7ff;\n  font-size: 20px;\n  font-weight: 600;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .client-us-section-thirteen\n  .client-says-all\n  .clients-says-content\n  .location-thirteen {\n  color: #f0f0f0;\n  font-size: 14px;\n  font-weight: 400;\n  text-transform: capitalize;\n  margin-bottom: 0;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .client-us-section-thirteen\n  .client-says-all\n  .clients-says-content\n  .client-says-imagesone\n  img {\n  position: absolute;\n  z-index: -1;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .client-us-section-thirteen\n  .client-says-all\n  .clients-says-content\n  .client-says-imagesone\n  img:nth-child(1) {\n  right: -3%;\n  bottom: -12%;\n  width: auto;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .client-us-section-thirteen\n  .client-says-all\n  .clients-says-content\n  .client-says-imagesone\n  img:nth-child(2) {\n  left: 0%;\n  top: 0%;\n  width: auto;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .client-us-section-thirteen\n  .client-says-all\n  .client-says-images {\n  width: 50%;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .client-us-section-thirteen\n  .client-says-all\n  .client-says-images\n  img {\n  width: auto;\n  border-radius: 0 35px 35px 0;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .client-us-section-thirteen\n    .client-says-all\n    .client-says-images {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .client-us-section-thirteen\n    .client-us-section-thirteenone {\n    display: none;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .client-us-section-thirteen\n  .client-us-section-thirteenone\n  img {\n  position: absolute;\n  z-index: 0;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .client-us-section-thirteen\n  .client-us-section-thirteenone\n  img:nth-child(1) {\n  left: 0%;\n  top: 15%;\n  width: auto;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .client-us-section-thirteen\n  .client-us-section-thirteenone\n  img:nth-child(2) {\n  right: -6%;\n  top: 22%;\n  width: auto;\n}\n.main-wrapper.home-twelve.home-thirteen .latest-articles-thirteen {\n  padding: 80px 0 56px 0;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .latest-articles-thirteen {\n    margin: 0;\n    padding: 50px 0 26px 0;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen .latest-articles-thirteen .articles-thirteen {\n  margin-bottom: 24px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .latest-articles-thirteen .articles-thirteen {\n    text-align: center;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .latest-articles-thirteen\n  .articles-thirteen\n  .articles-thirteen-img {\n  margin-bottom: 24px;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .latest-articles-thirteen\n  .articles-thirteen\n  .articles-thirteen-img\n  img {\n  border-radius: 20px;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .latest-articles-thirteen\n  .articles-thirteen\n  .articles-thirteen-img:hover\n  img {\n  border-radius: 20px;\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n.main-wrapper.home-twelve.home-thirteen\n  .latest-articles-thirteen\n  .articles-thirteen\n  .articles-thirteen-content\n  h6 {\n  padding: 2px 8px;\n  border-radius: 20px;\n  background: #eef6ff;\n  color: #0e82fd;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: capitalize;\n  margin-bottom: 10px;\n  display: inline-block;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .latest-articles-thirteen\n  .articles-thirteen\n  .articles-thirteen-content\n  a {\n  font-size: 20px;\n  font-weight: 500;\n  text-transform: capitalize;\n  color: #1f2937;\n  margin-bottom: 10px;\n  display: block;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .latest-articles-thirteen\n  .articles-thirteen\n  .articles-thirteen-content\n  a:hover {\n  color: #0e82fd;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .latest-articles-thirteen\n  .articles-thirteen\n  .articles-thirteen-content\n  p {\n  color: #6b7280;\n  font-weight: 400;\n  margin-bottom: 0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  width: 100%;\n  overflow: hidden;\n}\n.main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen {\n  background: url(../images/feedback-bg.png);\n  background-repeat: no-repeat;\n  background-position: top center;\n  position: relative;\n  z-index: 1;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen {\n    background-image: none;\n    background-color: #f8fbff;\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-all-img {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-main-content {\n    text-align: center;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-main-content h2 {\n  color: #1f2937;\n  font-size: 40px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-main-content h2 {\n    font-size: 34px;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-main-content p {\n  font-weight: 400;\n  color: #6b7280;\n  margin-bottom: 40px;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .feedback-section-thirteen\n  .feedback-main-content\n  .feedback-inner-img {\n  display: flex;\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .feedback-section-thirteen\n    .feedback-main-content\n    .feedback-inner-img {\n    justify-content: center;\n  }\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .feedback-section-thirteen\n    .feedback-main-content\n    .feedback-inner-img {\n    display: block;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen\n  .feedback-section-thirteen\n  .feedback-main-content\n  .feedback-inner-img\n  .feedback-inner-imgone {\n  margin-right: 26px;\n}\n@media (max-width: 575.98px) {\n  .main-wrapper.home-twelve.home-thirteen\n    .feedback-section-thirteen\n    .feedback-main-content\n    .feedback-inner-img\n    .feedback-inner-imgone {\n    margin: 0 0 10px 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-bg-icons {\n    display: none;\n  }\n}\n.main-wrapper.home-twelve.home-thirteen .feedback-section-thirteen .feedback-bg-icons img {\n  position: absolute;\n  z-index: 0;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .feedback-section-thirteen\n  .feedback-bg-icons\n  img:nth-child(1) {\n  right: 6%;\n  top: 40%;\n  width: auto;\n  animation: spin 3000ms linear infinite;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .feedback-section-thirteen\n  .feedback-bg-icons\n  img:nth-child(2) {\n  right: 11%;\n  top: 55%;\n  width: auto;\n  animation: spin 3000ms linear infinite;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .feedback-section-thirteen\n  .feedback-bg-icons\n  img:nth-child(3) {\n  right: 8%;\n  bottom: 10%;\n  width: auto;\n  animation: spin 3000ms linear infinite;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .feedback-section-thirteen\n  .feedback-bg-icons\n  img:nth-child(4) {\n  left: 15%;\n  bottom: 10%;\n  width: auto;\n  animation: spin 3000ms linear infinite;\n}\n.main-wrapper.home-twelve.home-thirteen\n  .feedback-section-thirteen\n  .feedback-bg-icons\n  img:nth-child(5) {\n  left: 6%;\n  top: 25%;\n  width: auto;\n  animation: spin 3000ms linear infinite;\n}\n\n.section-header-thirteen {\n  margin-bottom: 50px;\n}\n@media (max-width: 991.98px) {\n  .section-header-thirteen {\n    margin-bottom: 40px;\n  }\n}\n.section-header-thirteen .section-inner-thirteen {\n  margin-right: 15px;\n}\n.section-header-thirteen h2 {\n  font-size: 40px;\n  color: #1f2937;\n  font-weight: 700;\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .section-header-thirteen h2 {\n    font-size: 34px;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-header-thirteen h2 {\n    font-size: 28px;\n  }\n}\n\n.our-slider-thirteen .owl-dots,\n.client-says-thirteen .owl-dots {\n  text-align: center;\n  margin-top: 50px;\n}\n@media (max-width: 991.98px) {\n  .our-slider-thirteen .owl-dots,\n  .client-says-thirteen .owl-dots {\n    margin-top: 30px;\n  }\n}\n.our-slider-thirteen .owl-dots .owl-dot,\n.client-says-thirteen .owl-dots .owl-dot {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background: #f3f3f3;\n  margin-right: 15px;\n}\n@media (max-width: 991.98px) {\n  .our-slider-thirteen .owl-dots .owl-dot,\n  .client-says-thirteen .owl-dots .owl-dot {\n    width: 10px;\n    height: 10px;\n  }\n}\n.our-slider-thirteen .owl-dots .owl-dot.active,\n.client-says-thirteen .owl-dots .owl-dot.active {\n  width: 45px;\n  background: #0e82fd;\n  border-radius: 20px;\n}\n\n@keyframes pulse {\n  from {\n    transform: scale(0.8);\n  }\n  to {\n    transform: scale(1.2);\n  }\n}\n@keyframes elastic-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(720deg);\n  }\n}\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.owl-theme .owl-dots .owl-dot span {\n  display: none !important;\n}\n\n.main-wrapper.home-fourteen {\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-fourteen {\n    font-size: 15px;\n  }\n}\n\n.banner-section-fourteen {\n  position: relative;\n  padding: 100px 0 0 0;\n  background: #0e82fd;\n  z-index: 1;\n}\n@media (max-width: 1199.98px) {\n  .banner-section-fourteen {\n    padding: 100px 0 30px 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .banner-section-fourteen {\n    padding: 100px 0 50px 0;\n  }\n}\n.banner-section-fourteen .banner-content-fourteen {\n  margin: 116px 0 0 0;\n  padding: 0 0 40px 0;\n}\n@media (max-width: 1399.98px) {\n  .banner-section-fourteen .banner-content-fourteen {\n    margin: 50px 0 0 0;\n    padding: 0 0 40px 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .banner-section-fourteen .banner-content-fourteen {\n    margin: 10px 0 0 0;\n    padding: 0 0 40px 0;\n  }\n}\n.banner-section-fourteen .banner-content-fourteen h1 {\n  color: #ffffff;\n  letter-spacing: 0.005rem;\n  font-weight: 700;\n  width: 586px;\n  margin: 0 0 40px 0;\n}\n@media (max-width: 1199.98px) {\n  .banner-section-fourteen .banner-content-fourteen h1 {\n    width: auto;\n  }\n}\n.banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen {\n  display: flex;\n  justify-content: start;\n}\n@media (max-width: 991.98px) {\n  .banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen {\n    justify-content: center;\n  }\n}\n@media (max-width: 479.98px) {\n  .banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen {\n    flex-direction: column;\n  }\n}\n.banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primary {\n  background: #ffffff;\n  color: #0e82fd;\n  padding: 15px 20px;\n}\n@media (max-width: 991.98px) {\n  .banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primary {\n    padding: 15px 15px;\n  }\n}\n@media (max-width: 479.98px) {\n  .banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primary {\n    width: 100%;\n    margin: 0 0 10px 0;\n    padding: 15px 15px;\n  }\n}\n.banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primary:hover {\n  background: transparent;\n  box-shadow: none;\n  color: #ffffff;\n  border: 1px solid #ffffff;\n}\n.banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primarytwo {\n  background: transparent;\n  box-shadow: none;\n  color: #ffffff;\n  border: 1px solid #ffffff;\n  padding: 15px 20px;\n}\n@media (max-width: 991.98px) {\n  .banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primarytwo {\n    padding: 15px 15px;\n  }\n}\n.banner-section-fourteen .banner-content-fourteen .banner-btns-fourteen .btn-primarytwo:hover {\n  background: #ffffff;\n  color: #0e82fd;\n}\n.banner-section-fourteen .search-box-fourteen {\n  background: #ffffff;\n  box-shadow: -8px 6px 100px rgba(36, 58, 101, 0.1);\n  border-radius: 20px;\n  padding: 30px 41px 20px 41px;\n  gap: 10px;\n}\n.banner-section-fourteen .search-box-fourteen .form-block {\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  align-items: center;\n}\n@media (max-width: 768px) {\n  .banner-section-fourteen .search-box-fourteen .form-block {\n    flex-direction: column;\n  }\n}\n.banner-section-fourteen .search-box-fourteen .form-block .search-input {\n  margin: 0 15px 0 0;\n}\n@media (max-width: 768px) {\n  .banner-section-fourteen .search-box-fourteen .form-block .search-input {\n    width: 100%;\n  }\n}\n.banner-section-fourteen .search-box-fourteen .form-block .search-input input {\n  min-height: 40px;\n  padding: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n}\n.banner-section-fourteen .search-box-fourteen .form-block .search-input input::placeholder {\n  color: #1f2937;\n  font-weight: 600;\n}\n.banner-section-fourteen .search-box-fourteen .form-block .search-input .form-group {\n  margin-bottom: 0;\n}\n.banner-section-fourteen .search-box-fourteen .form-block .search-input label {\n  color: #6b7280;\n}\n.banner-section-fourteen .search-box-fourteen .search-btn {\n  width: auto;\n  margin: -8px 0 0 0;\n}\n@media (max-width: 768px) {\n  .banner-section-fourteen .search-box-fourteen .search-btn {\n    width: 100%;\n    margin: 0 0 0 0;\n  }\n}\n.banner-section-fourteen .search-box-fourteen .search-btn .btn-primary {\n  background: #0e82fd;\n  border: 1px solid #0e82fd;\n  -webkit-transition: 0.5s;\n  -ms-transition: 0.5s;\n  transition: 0.5s;\n  padding: 14px 16px;\n  font-weight: 600;\n}\n@media (max-width: 768px) {\n  .banner-section-fourteen .search-box-fourteen .search-btn .btn-primary {\n    width: 100%;\n  }\n}\n.banner-section-fourteen .search-box-fourteen .search-btn .btn-primary:hover {\n  background: #1c5b91;\n  box-shadow: inset 0 0 0 50px #1c5b91;\n  -webkit-transition: 0.5s;\n  -ms-transition: 0.5s;\n  transition: 0.5s;\n  border: 1px solid #1c5b91;\n}\n.banner-section-fourteen .banner-img-fourteen .banner-imgfourteen {\n  left: 30px;\n}\n@media (max-width: 1199.98px) {\n  .banner-section-fourteen .banner-img-fourteen .banner-imgfourteen {\n    top: 50px;\n  }\n}\n.banner-section-fourteen .banner-img-fourteen .banner-imgfourteen3 {\n  top: 380px;\n}\n@media (max-width: 1199.98px) {\n  .banner-section-fourteen .banner-img-fourteen .banner-imgfourteen3 {\n    top: 250px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .banner-section-fourteen .banner-img-fourteen .banner-img2 {\n    top: 100px;\n  }\n}\n.banner-section-fourteen .banner-img-fourteen .banner-imgfourteen4 {\n  position: absolute;\n  right: -120px;\n  bottom: 100px;\n  animation: spin 3000ms linear infinite;\n}\n@media (max-width: 1199.98px) {\n  .banner-section-fourteen .banner-img-fourteen .banner-imgfourteen4 {\n    top: 250px;\n  }\n}\n.banner-section-fourteen .banner-imgfourteen5 {\n  position: absolute;\n  top: 250px;\n  left: 86px;\n  animation: spin 3000ms linear infinite;\n}\n.banner-section-fourteen .banner-imgfourteen6 {\n  position: absolute;\n  bottom: 50px;\n  left: 65px;\n  animation: spin 3000ms linear infinite;\n  z-index: -1;\n}\n\n.services-section-fourteen {\n  padding: 80px 0;\n  background: #f8fafc;\n}\n@media (max-width: 1199.98px) {\n  .services-section-fourteen {\n    padding: 50px 0;\n  }\n}\n.services-section-fourteen .service-inner-fourt-all {\n  border-radius: 20px;\n  margin: 0 0 24px 0;\n}\n.services-section-fourteen .service-inner-fourt-all .service-inner-fourt-main {\n  padding: 20px;\n  border-radius: 20px;\n}\n.services-section-fourteen\n  .service-inner-fourt-all\n  .service-inner-fourt-main\n  .service-inner-right-fourt\n  .service-inner-right-img {\n  position: relative;\n  margin: 0 0 13px 0;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.services-section-fourteen\n  .service-inner-fourt-all\n  .service-inner-fourt-main\n  .service-inner-right-fourt\n  .service-inner-right-img\n  img {\n  position: relative;\n  border-radius: 20px;\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  width: 100%;\n}\n.services-section-fourteen\n  .service-inner-fourt-all\n  .service-inner-fourt-main\n  .service-inner-right-fourt\n  .service-inner-right-img:hover\n  img {\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n.services-section-fourteen\n  .service-inner-fourt-all\n  .service-inner-fourt-main\n  .service-inner-right-fourt\n  .service-inner-right-img:hover::before {\n  -webkit-animation: circle 1s;\n  animation: circle 1s;\n}\n.services-section-fourteen\n  .service-inner-fourt-all\n  .service-inner-fourt-main\n  .service-inner-right-fourt\n  .service-inner-right-img::before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 2;\n  display: block;\n  content: \"\";\n  width: 0;\n  height: 0;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 100%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  opacity: 0;\n}\n.services-section-fourteen\n  .service-inner-fourt-all\n  .service-inner-fourt-main\n  .service-inner-right-fourt\n  .service-inner-right-fourt-care {\n  color: #1f2937;\n  font-size: 22px;\n  font-weight: 600;\n  margin: 0 0 13px 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n}\n@media (max-width: 1199.98px) {\n  .services-section-fourteen\n    .service-inner-fourt-all\n    .service-inner-fourt-main\n    .service-inner-right-fourt\n    .service-inner-right-fourt-care {\n    font-size: 18px;\n  }\n}\n.services-section-fourteen\n  .service-inner-fourt-all\n  .service-inner-fourt-main\n  .service-inner-right-fourt\n  .service-inner-right-fourt-care:hover {\n  color: #1c5b91;\n}\n.services-section-fourteen\n  .service-inner-fourt-all\n  .service-inner-fourt-main\n  .service-inner-right-fourt\n  p {\n  color: #6b7280;\n  font-size: 14px;\n  margin: 0 0 10px 0;\n}\n.services-section-fourteen\n  .service-inner-fourt-all\n  .service-inner-fourt-main\n  .service-inner-right-fourt\n  .service-inner-right-fourt-caretwo {\n  color: #0e82fd;\n  font-size: 18px;\n  font-weight: 600;\n}\n@media (max-width: 1199.98px) {\n  .services-section-fourteen\n    .service-inner-fourt-all\n    .service-inner-fourt-main\n    .service-inner-right-fourt\n    .service-inner-right-fourt-caretwo {\n    font-size: 16px;\n  }\n}\n.services-section-fourteen\n  .service-inner-fourt-all\n  .service-inner-fourt-main\n  .service-inner-right-fourt\n  .service-inner-right-fourt-caretwo\n  i {\n  font-weight: 600;\n}\n.services-section-fourteen\n  .service-inner-fourt-all\n  .service-inner-fourt-main\n  .service-inner-right-fourt\n  .service-inner-right-fourt-caretwo:hover {\n  color: #1c5b91;\n}\n.services-section-fourteen .service-inner-img-fourt-all {\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .services-section-fourteen .service-inner-img-fourt-all .service-inner-img-fourt {\n    display: none;\n  }\n}\n.services-section-fourteen .service-inner-img-fourt-all .service-inner-img-fourtone {\n  position: absolute;\n  top: 0;\n  right: 65px;\n  animation: spin 3000ms linear infinite;\n}\n.services-section-fourteen .service-inner-img-fourt-all .service-inner-img-fourttwo {\n  position: absolute;\n  bottom: 0;\n  animation: spin 3000ms linear infinite;\n}\n.services-section-fourteen .service-inner-img-fourt-all .service-inner-img-fourtthree {\n  position: absolute;\n  top: 0;\n  left: 30px;\n  animation: spin 3000ms linear infinite;\n}\n.services-section-fourteen .btn-sec-fourteen {\n  text-align: end;\n}\n@media (max-width: 991.98px) {\n  .services-section-fourteen .btn-sec-fourteen {\n    text-align: center;\n  }\n}\n.services-section-fourteen .btn-sec-fourteen a {\n  padding: 15px 20px;\n  font-size: 15px;\n  color: #ffffff;\n  background: #0e82fd;\n  transition:\n    color 0.3s ease-in-out,\n    box-shadow 0.3s ease-in-out;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  border: 1px solid #0e82fd;\n  font-weight: 600;\n}\n@media (max-width: 991.98px) {\n  .services-section-fourteen .btn-sec-fourteen a {\n    padding: 12px 13px;\n  }\n}\n.services-section-fourteen .btn-sec-fourteen a:hover {\n  box-shadow: inset 165px 0 0 0 #1c5b91;\n  border-color: #1c5b91;\n}\n\n.team-section-fourteen {\n  position: relative;\n  padding: 80px 0 56px 0;\n}\n@media (max-width: 1199.98px) {\n  .team-section-fourteen {\n    padding: 50px 0;\n  }\n}\n.team-section-fourteen .articles-grid-fourteen {\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n  border-radius: 30px;\n}\n@media (max-width: 1199.98px) {\n  .team-section-fourteen .articles-grid-fourteen .articles-info {\n    text-align: start;\n  }\n}\n@media (max-width: 991.98px) {\n  .team-section-fourteen .articles-grid-fourteen .articles-info {\n    display: flex;\n    text-align: center;\n    flex-direction: column;\n  }\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-left\n  .articles-img-fourteen {\n  width: 206px;\n  height: 220px;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-left\n  .articles-img-fourteen\n  img {\n  height: 100%;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  a {\n  font-size: 20px;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 10px;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  a:hover {\n  color: #1c5b91;\n}\n@media (max-width: 1199.98px) {\n  .team-section-fourteen\n    .articles-grid-fourteen\n    .articles-info\n    .articles-right\n    .articles-content-fourteen\n    .articles-list {\n    justify-content: start;\n    -webkit-justify-content: start;\n  }\n}\n@media (max-width: 991.98px) {\n  .team-section-fourteen\n    .articles-grid-fourteen\n    .articles-info\n    .articles-right\n    .articles-content-fourteen\n    .articles-list {\n    justify-content: center;\n    -webkit-justify-content: center;\n  }\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  .articles-list\n  .Qualified-doctors-fourteen {\n  background: #dbeffe;\n  color: #0e82fd;\n  padding: 10px 15px;\n  border-radius: 8px;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  .articles-list\n  .Qualified-doctors-fourteentwo {\n  color: #6b7280;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  .articles-list\n  .Qualified-doctors-fourteenthree {\n  background: #f3f4f6;\n  padding: 10px 12px;\n  border-radius: 6px;\n  color: #1f2937;\n  font-weight: 600;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  .articles-list\n  .Qualified-doctors-fourteenfour\n  a {\n  border-radius: 6px;\n  background: #0e82fd;\n  color: #ffffff;\n  transition:\n    color 0.3s ease-in-out,\n    box-shadow 0.3s ease-in-out;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  font-size: 15px;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 0;\n  padding: 10px 12px;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  .articles-list\n  .Qualified-doctors-fourteenfour\n  a:hover {\n  box-shadow: inset 120px 0 0 0 #1c5b91;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  .rating-fourteen\n  .filled {\n  color: #ffc001;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  .rating-fourteen\n  i {\n  font-size: 18px;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  .rating-fourteen\n  .average-rating {\n  font-size: 14px;\n  color: #d1d5db;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  p {\n  color: #6b7280;\n  font-weight: 500;\n  margin: 0 0 10px 0;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  p\n  i {\n  color: #6b7280;\n  margin: 0 7px 0 0;\n}\n.team-section-fourteen\n  .articles-grid-fourteen\n  .articles-info\n  .articles-right\n  .articles-content-fourteen\n  p\n  span {\n  color: #1f2937;\n  font-weight: 500;\n}\n.team-section-fourteen .banner-imgfourteenseven {\n  position: absolute;\n  bottom: 50px;\n  left: 30px;\n  animation: spin 3000ms linear infinite;\n}\n.team-section-fourteen .banner-imgfourteeneight {\n  position: absolute;\n  top: 70px;\n  right: 50%;\n  animation: spin 3000ms linear infinite;\n}\n@media (max-width: 991.98px) {\n  .team-section-fourteen .banner-imgfourteeneight {\n    display: none;\n  }\n}\n.team-section-fourteen .banner-imgfourteennine {\n  position: absolute;\n  right: 50px;\n  bottom: 70px;\n  animation: spin 3000ms linear infinite;\n}\n\n.blog-section-fourteen {\n  position: relative;\n  padding: 80px 0;\n  background: #f2f6f6;\n}\n@media (max-width: 1199.98px) {\n  .blog-section-fourteen {\n    padding: 50px 0;\n  }\n}\n.blog-section-fourteen .blog-inner-fourt-all {\n  border-radius: 30px;\n}\n.blog-section-fourteen .blog-inner-fourt-all .blog-inner-fourt-main {\n  padding: 20px;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-right-img {\n  position: relative;\n  margin: 0 0 20px 0;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-right-img\n  .blog-inner-right-inner {\n  position: relative;\n  border-radius: 20px;\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  width: 100%;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-right-img\n  .blog-inner-right-inner:hover\n  img {\n  border-radius: 20px;\n  transform: scale(1.15);\n  -webkit-transform: scale(1.15);\n  -ms-transform: scale(1.15);\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content {\n  position: absolute;\n  top: 19px;\n  left: 19px;\n  padding: 5px 10px 5px 5px;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 50px;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content\n  img {\n  width: 35px;\n  height: 35px;\n  border-radius: 50px;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-top-content\n  span {\n  font-size: 14px;\n  color: #1f2937;\n  font-weight: 600;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-right-fourt-care {\n  display: block;\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0 0 18px 0;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-inner-right-fourt-care:hover {\n  color: #1c5b91;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-articles-list {\n  margin: 0 0 20px 0;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-articles-list\n  li {\n  color: #6b7280;\n  font-size: 16px;\n  margin: 0 20px 0 0;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-articles-list\n  li\n  i {\n  color: #d1d5db;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-articles-list-two {\n  margin: 0 0 10px 0;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-articles-list-two\n  li {\n  background: #dbeffe;\n  color: #0e82fd;\n  margin: 0 10px 10px 0;\n  padding: 10px 15px;\n  border-radius: 8px;\n}\n.blog-section-fourteen\n  .blog-inner-fourt-all\n  .blog-inner-fourt-main\n  .blog-inner-right-fourt\n  .blog-articles-list-two\n  li:last-child {\n  margin: 0 0 10px 0;\n}\n.blog-section-fourteen .blog-inner-fourt-all .blog-inner-fourt-main .blog-inner-right-fourt p {\n  color: #6b7280;\n  font-size: 14px;\n  margin: 0 0 0 0;\n}\n.blog-section-fourteen .blog-btn-sec {\n  margin: 24px 0 0 0;\n}\n.blog-section-fourteen .blog-btn-sec .btn-view {\n  padding: 15px 20px;\n  font-size: 15px;\n  color: #ffffff;\n  background: #0e82fd;\n  transition:\n    color 0.3s ease-in-out,\n    box-shadow 0.3s ease-in-out;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  font-weight: 600;\n  border: 1px solid #0e82fd;\n}\n@media (max-width: 991.98px) {\n  .blog-section-fourteen .blog-btn-sec .btn-view {\n    padding: 12px 13px;\n  }\n}\n.blog-section-fourteen .blog-btn-sec .btn-view:hover {\n  box-shadow: inset 220px 0 0 0 #1c5b91;\n  border-color: #1c5b91;\n}\n\n.choose-us-fourteen {\n  position: relative;\n  padding: 80px 0;\n}\n@media (max-width: 1199.98px) {\n  .choose-us-fourteen {\n    padding: 50px 0;\n  }\n}\n.choose-us-fourteen .you-get-list ul {\n  list-style: none;\n  padding: 0;\n}\n.choose-us-fourteen .you-get-list ul li {\n  margin-bottom: 30px;\n}\n.choose-us-fourteen .you-get-list ul li:last-child {\n  margin: 0;\n}\n.choose-us-fourteen .you-get-list ul li .get-list-content {\n  background-image: url(../images/chooseus-ryt-1.png);\n  background-repeat: no-repeat;\n  background-size: contain;\n  padding: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  transition: 0.5s;\n}\n@media (max-width: 1399.98px) {\n  .choose-us-fourteen .you-get-list ul li .get-list-content {\n    padding: 22px 30px 30px 30px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .choose-us-fourteen .you-get-list ul li .get-list-content {\n    background: #f2f6f6;\n    border-radius: 30px;\n  }\n}\n@media (max-width: 991.98px) {\n  .choose-us-fourteen .you-get-list ul li .get-list-content {\n    background: #f2f6f6;\n    border-radius: 30px;\n  }\n}\n@media (max-width: 575.98px) {\n  .choose-us-fourteen .you-get-list ul li .get-list-content {\n    flex-direction: column;\n  }\n}\n.choose-us-fourteen .you-get-list ul li .get-list-content.second-bg {\n  background-image: url(../images/chooseus-ryt-2.png);\n}\n@media (max-width: 1199.98px) {\n  .choose-us-fourteen .you-get-list ul li .get-list-content.second-bg {\n    background: #f2f6f6;\n    border-radius: 30px;\n  }\n}\n@media (max-width: 991.98px) {\n  .choose-us-fourteen .you-get-list ul li .get-list-content.second-bg {\n    background: #f2f6f6;\n    border-radius: 30px;\n  }\n}\n.choose-us-fourteen .you-get-list ul li .get-list-content:hover .get-icon {\n  background: #0e82fd;\n  transition: 0.5s;\n}\n.choose-us-fourteen .you-get-list ul li .get-list-content:hover .get-icon img {\n  filter: invert(0) brightness(100);\n  transition: 0.5s;\n}\n.choose-us-fourteen .you-get-list ul li .get-list-content .get-icon {\n  margin: 0 20px 0 0;\n  padding: 25px;\n  background: #ffffff;\n  border-radius: 20px;\n  transition: 0.5s;\n}\n@media (max-width: 575.98px) {\n  .choose-us-fourteen .you-get-list ul li .get-list-content .get-icon {\n    margin: 0 0 20px 0;\n    padding: 25px;\n  }\n}\n@media (max-width: 575.98px) {\n  .choose-us-fourteen .you-get-list ul li .get-list-content .get-icon-right {\n    text-align: center;\n  }\n}\n.choose-us-fourteen .you-get-list ul li .get-list-content .get-icon-right h3 {\n  font-weight: 600;\n  margin: 0 0 5px 0;\n}\n.choose-us-fourteen .you-get-list ul li .get-list-content .get-icon-right p {\n  color: #6b7280;\n  font-size: 14px;\n  margin: 0;\n  max-width: 412px;\n}\n.choose-us-fourteen .choose-us-right-main {\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .choose-us-fourteen .choose-us-right-main {\n    display: none;\n  }\n}\n.choose-us-fourteen .choose-us-right-main .banner-imgfourteenten {\n  position: absolute;\n  top: 150px;\n  right: 180px;\n  animation: spin 3000ms linear infinite;\n}\n@media (max-width: 1199.98px) {\n  .choose-us-fourteen .choose-us-right-main .banner-imgfourteenten {\n    right: 120px;\n  }\n}\n\n.clients-section-fourteen {\n  position: relative;\n  padding: 80px 0 150px 0;\n  background: #f2f6f6;\n}\n@media (max-width: 1199.98px) {\n  .clients-section-fourteen {\n    padding: 80px 0 100px 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .clients-section-fourteen {\n    padding: 50px 0;\n  }\n}\n.clients-section-fourteen .client-inner-main {\n  -webkit-animation: mover 2s infinite alternate;\n  animation: mover 2s infinite alternate;\n}\n@media (max-width: 991.98px) {\n  .clients-section-fourteen .client-inner-main {\n    display: none;\n  }\n}\n.clients-section-fourteen .feedback-slider-fourteen .owl-nav {\n  text-align: end;\n  margin-top: 40px;\n}\n@media (max-width: 991.98px) {\n  .clients-section-fourteen .feedback-slider-fourteen .owl-nav {\n    text-align: center;\n    margin-top: 10px;\n  }\n}\n.clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-prev {\n  background: #e2e8f0;\n  border-radius: 8px;\n  width: 50px;\n  height: 50px;\n  color: #94a3b8;\n  text-shadow: none;\n  font-size: 24px;\n  border: none;\n}\n@media (max-width: 991.98px) {\n  .clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-prev {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n  }\n}\n.clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-prev:hover {\n  background: #bfe0fe;\n  color: #1d7ed8;\n}\n.clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-next {\n  background: #e2e8f0;\n  border-radius: 8px;\n  width: 50px;\n  height: 50px;\n  color: #94a3b8;\n  text-shadow: none;\n  font-size: 24px;\n  border: none;\n}\n@media (max-width: 991.98px) {\n  .clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-next {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n  }\n}\n.clients-section-fourteen .feedback-slider-fourteen .owl-nav .owl-next:hover {\n  background: #bfe0fe;\n  color: #1d7ed8;\n}\n.clients-section-fourteen .feedback-card {\n  border-radius: 30px;\n  margin: 60px 0 0 0;\n}\n.clients-section-fourteen .feedback-card .feedback-card-body {\n  padding: 30px;\n}\n.clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .feedback-inner-img {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  margin: -85px 0 10px 0;\n}\n.clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .feedback-inner-img\n  h6 {\n  color: #1f2937;\n  font-size: 16px;\n}\n.clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .feedback-inner-img\n  img {\n  width: 100px;\n  height: 100px;\n  border-radius: 20px;\n}\n.clients-section-fourteen .feedback-card .feedback-card-body .feedback-inner-main .rating-fourteen {\n  margin: 0 0 15px 0;\n}\n.clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .rating-fourteen\n  .filled {\n  color: #ffc001;\n}\n.clients-section-fourteen\n  .feedback-card\n  .feedback-card-body\n  .feedback-inner-main\n  .rating-fourteen\n  i {\n  font-size: 18px;\n}\n.clients-section-fourteen .feedback-card .feedback-card-body .feedback-inner-main p {\n  color: #6b7280;\n  font-size: 16px;\n  margin: 0 0 20px 0;\n}\n.clients-section-fourteen .feedback-card .feedback-card-body .feedback-inner-main h4 {\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0 0 10px 0;\n}\n@media (max-width: 991.98px) {\n  .clients-section-fourteen .feedback-card .feedback-card-body .feedback-inner-main h4 {\n    font-size: 18px;\n  }\n}\n.clients-section-fourteen .feedback-card .feedback-card-body .feedback-inner-main h6 {\n  color: #94a3b8;\n  font-size: 16px;\n  margin: 0;\n}\n\n.contact-section-fourteen {\n  background: #f2f6f6;\n  margin: 0 0 -200px 0;\n}\n.contact-section-fourteen .contact-schedule-main {\n  background: #0e82fd;\n  border-radius: 30px;\n  position: relative;\n  box-shadow: 0px 30px 60px rgba(49, 46, 129, 0.2);\n}\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main {\n  padding: 95px 80px 95px 110px;\n}\n@media (max-width: 1399.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-left-main {\n    padding: 75px 80px 75px 90px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-left-main {\n    padding: 25px 40px 25px 50px;\n  }\n}\n@media (max-width: 991.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-left-main {\n    padding: 30px 10px 30px 10px;\n    text-align: center;\n  }\n}\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main h2 {\n  font-size: 40px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0 0 10px 0;\n}\n@media (max-width: 991.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-left-main h2 {\n    font-size: 36px;\n  }\n}\n@media (max-width: 767.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-left-main h2 {\n    font-size: 28px;\n  }\n}\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main p {\n  font-size: 24px;\n  color: #ffffff;\n  margin: 0 0 55px 0;\n}\n@media (max-width: 991.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-left-main p {\n    font-size: 20px;\n    margin: 0 0 30px 0;\n  }\n}\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul {\n  margin: 0;\n  padding: 0;\n}\n@media (max-width: 991.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-left-main ul {\n    justify-content: center;\n  }\n}\n@media (max-width: 575.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-left-main ul {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li {\n  list-style: none;\n  margin: 0 20px 0 0;\n}\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li:last-child {\n  margin: 0;\n}\n@media (max-width: 575.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li {\n    margin: 0 0 20px 0;\n    width: 100%;\n  }\n}\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li a {\n  background: #ffffff;\n  padding: 15px 20px;\n  border-radius: 6px;\n  color: #0e82fd;\n  border: 2px solid #ffffff;\n  display: inline-block;\n  font-weight: 600;\n}\n@media (max-width: 1399.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li a {\n    padding: 13px 14px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li a {\n    padding: 13px 8px;\n  }\n}\n@media (max-width: 575.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li a {\n    width: 100%;\n  }\n}\n.contact-section-fourteen .contact-schedule-main .scheduling-left-main ul li a:hover {\n  background: transparent;\n  border: 2px solid #ffffff;\n  color: #ffffff;\n}\n.contact-section-fourteen .contact-schedule-main .scheduling-right-main {\n  position: relative;\n  margin: -95px 0 0 0;\n}\n@media (max-width: 1399.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-right-main {\n    margin: -53px 27px 0 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-right-main {\n    display: none;\n  }\n}\n.contact-section-fourteen .contact-schedule-main .scheduling-right-main .scheduling-right-img {\n  position: absolute;\n  top: 40%;\n  left: 14px;\n  -webkit-animation: mover 2s infinite alternate;\n  animation: mover 2s infinite alternate;\n}\n@media (max-width: 991.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-right-main .scheduling-right-img {\n    display: none;\n  }\n}\n.contact-section-fourteen .contact-schedule-main .scheduling-right-main .scheduling-right-imgtwo {\n  position: absolute;\n  right: 15px;\n  bottom: 10%;\n  -webkit-animation: mover 2s infinite alternate;\n  animation: mover 2s infinite alternate;\n}\n@media (max-width: 991.98px) {\n  .contact-section-fourteen .contact-schedule-main .scheduling-right-main .scheduling-right-imgtwo {\n    display: none;\n  }\n}\n.contact-section-fourteen .contact-schedule-main .contact-inner-image {\n  position: absolute;\n  top: 0;\n  left: 135px;\n}\n@media (max-width: 991.98px) {\n  .contact-section-fourteen .contact-schedule-main .contact-inner-image {\n    display: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .section-header-fourteen {\n    text-align: center !important;\n  }\n}\n.section-header-fourteen .service-inner-fourteen {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n@media (max-width: 991.98px) {\n  .section-header-fourteen .service-inner-fourteen {\n    justify-content: center !important;\n  }\n}\n.section-header-fourteen .service-inner-fourteen .service-inner-fourteen-one {\n  background: #0e82fd;\n  content: \"\";\n  width: 50px;\n  height: 3px;\n}\n.section-header-fourteen .service-inner-fourteen .service-inner-fourteen-two h3 {\n  color: #0e82fd;\n  font-size: 30px;\n  margin: 0 20px;\n}\n@media (max-width: 1199.98px) {\n  .section-header-fourteen .service-inner-fourteen .service-inner-fourteen-two h3 {\n    font-size: 26px;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-header-fourteen .service-inner-fourteen .service-inner-fourteen-two h3 {\n    font-size: 22px;\n  }\n}\n.section-header-fourteen .service-inner-fourteen .service-inner-fourteen-three {\n  background: #0e82fd;\n  content: \"\";\n  width: 50px;\n  height: 3px;\n}\n.section-header-fourteen h2 {\n  color: #1f2937;\n  font-size: 40px;\n  font-weight: 600;\n  margin: 0 0 50px 0;\n}\n@media (max-width: 1199.98px) {\n  .section-header-fourteen h2 {\n    font-size: 32px;\n  }\n}\n@media (max-width: 991.98px) {\n  .section-header-fourteen h2 {\n    margin: 0 0 40px 0;\n    font-size: 28px;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-header-fourteen h2 {\n    font-size: 26px;\n  }\n}\n\n.slide-nav-14 button.owl-next,\n.slide-nav-14 button.owl-prev,\n.slide-nav-15 button.owl-next,\n.slide-nav-15 button.owl-prev {\n  background: #e2e8f0;\n  border-radius: 8px;\n  width: 50px;\n  height: 50px;\n  color: #94a3b8;\n  text-shadow: none;\n  font-size: 24px;\n  border: none;\n}\n@media (max-width: 991.98px) {\n  .slide-nav-14 button.owl-next,\n  .slide-nav-14 button.owl-prev,\n  .slide-nav-15 button.owl-next,\n  .slide-nav-15 button.owl-prev {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n    margin: 0 10px 30px 0;\n  }\n}\n.slide-nav-14 button.owl-next:hover,\n.slide-nav-14 button.owl-prev:hover,\n.slide-nav-15 button.owl-next:hover,\n.slide-nav-15 button.owl-prev:hover {\n  background: #bfe0fe;\n  color: #1d7ed8;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes mover {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(-10px);\n  }\n}\n.main-wrapper.home-fifteen {\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-fifteen {\n    font-size: 15px;\n  }\n}\n\n.banner-section-fifteen {\n  position: relative;\n  padding: 85px 0 0 0;\n  background-color: #ffffff;\n  z-index: 1;\n  background-image: url(../images/banner-fifteen.png);\n  background-repeat: no-repeat;\n  background-position: right top;\n  background-size: 36% 100%;\n}\n@media (max-width: 991.98px) {\n  .banner-section-fifteen {\n    background-image: none;\n  }\n}\n.banner-section-fifteen .banner-content-fifteen {\n  margin: 110px 0 0 0;\n  padding: 0 0 47px 0;\n}\n@media (max-width: 991.98px) {\n  .banner-section-fifteen .banner-content-fifteen {\n    margin: 35px 0 0 0;\n    padding: 0 0 47px 0;\n  }\n}\n.banner-section-fifteen .banner-content-fifteen h2 {\n  color: #1f2937;\n  text-transform: uppercase;\n  margin-bottom: 15px;\n  font-size: 24px;\n  font-weight: 600;\n}\n@media (max-width: 991.98px) {\n  .banner-section-fifteen .banner-content-fifteen h2 {\n    font-size: 20px;\n  }\n}\n@media (max-width: 767.98px) {\n  .banner-section-fifteen .banner-content-fifteen h2 {\n    font-size: 18px;\n  }\n}\n.banner-section-fifteen .banner-content-fifteen h1 {\n  color: #0e82fd;\n  margin-bottom: 15px;\n}\n.banner-section-fifteen .banner-content-fifteen .banner-btns-fifteen {\n  margin: 0 0 35px 0;\n}\n.banner-section-fifteen .banner-content-fifteen .banner-btns-fifteen .btn-primary {\n  font-weight: 600;\n  background: #0e82fd;\n  position: relative;\n  padding: 15px 30px;\n  margin-bottom: 15px;\n}\n@media (max-width: 479.98px) {\n  .banner-section-fifteen .banner-content-fifteen .banner-btns-fifteen .btn-primary {\n    width: 100%;\n  }\n}\n.banner-section-fifteen .banner-content-fifteen .banner-btns-fifteen .btn-primary:hover {\n  background: #0ce0ff;\n  box-shadow: inset 0 100px 0 0 #0ce0ff;\n  color: #ffffff;\n  border: 1px solid #0ce0ff;\n}\n.banner-section-fifteen .banner-content-fifteen .banner-btns-fifteen .btns-primarytwo {\n  background: #0ce0ff;\n  border: 1px solid #0ce0ff;\n}\n.banner-section-fifteen .banner-content-fifteen .banner-btns-fifteen .btns-primarytwo:hover {\n  background: #0e82fd;\n  box-shadow: inset 0 100px 0 0 #0e82fd;\n  border: 1px solid #0e82fd;\n}\n.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg {\n  position: relative;\n  display: inline-block;\n  margin-bottom: 15px;\n}\n.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 56, 115, 0.25);\n  z-index: 1;\n  border-radius: 10px;\n}\n.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg a img {\n  border-radius: 10px;\n}\n.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg a .playicon {\n  position: absolute;\n  top: 38%;\n  right: 44%;\n  z-index: 2;\n}\n.banner-section-fifteen .banner-content-fifteen .aboutus-companyimg a .playicon span {\n  width: 33px;\n  height: 33px;\n  background: #0e82fd;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);\n  border-radius: 50%;\n  color: #ffffff;\n  font-size: 10px;\n}\n.banner-section-fifteen .banner-content-fifteen .watch-video-fifteen {\n  display: flex;\n  align-items: center;\n  margin-bottom: 50px;\n}\n@media (max-width: 991.98px) {\n  .banner-section-fifteen .banner-content-fifteen .watch-video-fifteen {\n    justify-content: center;\n  }\n}\n.banner-section-fifteen .banner-content-fifteen .watch-video-fifteen img {\n  margin-right: 7px;\n}\n.banner-section-fifteen .banner-content-fifteen .watch-video-fifteen h6 {\n  color: #1f2937;\n  margin-bottom: 0;\n}\n.banner-section-fifteen .banner-content-fifteen .support-consult-main {\n  display: flex;\n}\n@media (max-width: 991.98px) {\n  .banner-section-fifteen .banner-content-fifteen .support-consult-main {\n    justify-content: center;\n  }\n}\n.banner-section-fifteen .banner-content-fifteen .support-consult-main .support-consult {\n  display: flex;\n  align-items: center;\n  margin-right: 25px;\n}\n@media (max-width: 479.98px) {\n  .banner-section-fifteen .banner-content-fifteen .support-consult-main .support-consult {\n    display: block;\n  }\n}\n.banner-section-fifteen .banner-content-fifteen .support-consult-main .support-consult:last-child {\n  margin-right: 0;\n}\n@media (max-width: 479.98px) {\n  .banner-section-fifteen\n    .banner-content-fifteen\n    .support-consult-main\n    .support-consult\n    .support-consult-img {\n    margin-bottom: 5px;\n  }\n}\n.banner-section-fifteen\n  .banner-content-fifteen\n  .support-consult-main\n  .support-consult\n  .support-consult-img\n  img {\n  padding: 10px;\n  background: #0e82fd;\n  border-radius: 5px;\n  margin-right: 7px;\n}\n.banner-section-fifteen\n  .banner-content-fifteen\n  .support-consult-main\n  .support-consult\n  .support-consult-right\n  h6 {\n  color: #1f2937;\n  margin-bottom: 0;\n}\n.banner-section-fifteen\n  .banner-content-fifteen\n  .support-consult-main\n  .support-consult\n  .support-consult-right\n  .rating-fifteen {\n  margin-bottom: 0;\n}\n.banner-section-fifteen\n  .banner-content-fifteen\n  .support-consult-main\n  .support-consult\n  .support-consult-right\n  .rating-fifteen\n  i.filled {\n  color: #ffc001;\n}\n.banner-section-fifteen\n  .banner-content-fifteen\n  .support-consult-main\n  .support-consult\n  .support-consult-right\n  span {\n  font-size: 14px;\n  color: #6b7280;\n}\n.banner-section-fifteen .banner-right-fifteen {\n  position: relative;\n  margin-top: 73px;\n}\n@media (max-width: 1399.98px) {\n  .banner-section-fifteen .banner-right-fifteen {\n    margin-top: 150px;\n  }\n}\n@media (max-width: 991.98px) {\n  .banner-section-fifteen .banner-right-fifteen {\n    display: none;\n  }\n}\n.banner-section-fifteen .banner-right-fifteen .banner-right-fifteenone {\n  position: absolute;\n  top: 100px;\n  left: -130px;\n  animation: mover 1s infinite alternate;\n}\n@media (max-width: 1399.98px) {\n  .banner-section-fifteen .banner-right-fifteen .banner-right-fifteenone {\n    top: 130px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .banner-section-fifteen .banner-right-fifteen .banner-right-fifteenone {\n    display: none;\n  }\n}\n.banner-section-fifteen .banner-right-fifteen .banner-right-fifteentwo {\n  position: absolute;\n  top: 77px;\n  left: 40px;\n  animation: spin 3000ms linear infinite;\n}\n.banner-section-fifteen .banner-right-fifteen .banner-right-fifteenthree {\n  position: absolute;\n  top: 250px;\n  right: -50px;\n  animation: spin 3000ms linear infinite;\n}\n.banner-section-fifteen .banner-right-fifteen .banner-right-fifteenfour {\n  position: absolute;\n  right: -150px;\n  bottom: 100px;\n}\n.banner-section-fifteen .banner-right-fifteen .banner-right-fifteenfive {\n  position: absolute;\n  top: 10px;\n  right: -50px;\n  animation: mover 1s infinite alternate;\n}\n.banner-section-fifteen .banner-right-fifteen .banner-right-fifteensix {\n  position: absolute;\n  bottom: 0;\n  left: -30px;\n}\n@media (max-width: 1199.98px) {\n  .banner-section-fifteen .banner-right-fifteen .banner-right-fifteensix {\n    display: none;\n  }\n}\n.banner-section-fifteen .banner-right-fifteen .banner-right-fifteenseven {\n  position: absolute;\n  top: 150px;\n  right: -70px;\n}\n.banner-section-fifteen .banner-right-fifteen .banner-right-fifteeneight {\n  position: absolute;\n  bottom: 40px;\n  left: 210px;\n  animation: mover 1s infinite alternate;\n}\n.banner-section-fifteen .banner-right-fifteennine {\n  position: absolute;\n  bottom: 40px;\n  left: 210px;\n}\n\n.services-section-fifteen {\n  position: relative;\n  padding: 80px 0 56px 0;\n}\n@media (max-width: 991.98px) {\n  .services-section-fifteen {\n    padding: 26px 0;\n    background: #f4f4f4;\n  }\n}\n.services-section-fifteen .service-bg-icon {\n  position: absolute;\n  top: 250px;\n  right: 40px;\n}\n.services-section-fifteen .doctor-profile-widget-fifteen {\n  margin-bottom: 24px;\n}\n.services-section-fifteen .doctor-profile-widget-fifteen .doc-pro-img .doctor-profile-img {\n  border-radius: 10px;\n  margin-bottom: 13px;\n}\n.services-section-fifteen .doctor-profile-widget-fifteen .doc-content-bottom .doc-content-split {\n  margin-bottom: 15px;\n}\n.services-section-fifteen .doctor-profile-widget-fifteen .doc-content-bottom .doc-content-split a {\n  color: #1f2937;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n.services-section-fifteen\n  .doctor-profile-widget-fifteen\n  .doc-content-bottom\n  .doc-content-split\n  a:hover {\n  color: #1b5d92;\n}\n.services-section-fifteen\n  .doctor-profile-widget-fifteen\n  .doc-content-bottom\n  .doc-content-split\n  span {\n  background: #0e82fd;\n  padding: 5px 10px;\n  border-radius: 5px;\n  font-family: 600;\n  font-size: 14px;\n  color: #ffffff;\n}\n.services-section-fifteen .doctor-profile-widget-fifteen .doc-content-bottom p {\n  color: #707070;\n  margin-bottom: 0;\n}\n\n.Patients-section-fifteen {\n  position: relative;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .Patients-section-fifteen {\n    padding: 50px 0;\n    text-align: center;\n  }\n}\n.Patients-section-fifteen .patient-fifteen-icon {\n  position: absolute;\n  top: 100px;\n  left: 0;\n  z-index: -1;\n}\n.Patients-section-fifteen .section-header-fifteenpatient {\n  margin-bottom: 25px;\n}\n.Patients-section-fifteen p {\n  margin-bottom: 25px;\n}\n.Patients-section-fifteen .service-patient-inflict {\n  text-align: center;\n}\n@media (max-width: 575.98px) {\n  .Patients-section-fifteen .service-patient-inflict {\n    margin-bottom: 15px;\n  }\n}\n.Patients-section-fifteen .service-patient-inflict .service-patient-inflictimg {\n  background: #e3fbff;\n  width: 196px;\n  height: 120px;\n  border-radius: 10px;\n  margin: auto auto 15px auto;\n}\n@media (max-width: 1399.98px) {\n  .Patients-section-fifteen .service-patient-inflict .service-patient-inflictimg {\n    width: 175px;\n  }\n}\n@media (max-width: 1199.98px) {\n  .Patients-section-fifteen .service-patient-inflict .service-patient-inflictimg {\n    width: 150px;\n  }\n}\n.Patients-section-fifteen .service-patient-inflict h6 {\n  color: #6b7280;\n  font-size: 18px;\n  font-weight: 400;\n  margin-bottom: 0;\n}\n.Patients-section-fifteen .service-patient-inflict .clients-fifteen-span {\n  margin-bottom: 5px;\n}\n.Patients-section-fifteen .service-patient-inflict .clients-fifteen-span h3 {\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0;\n}\n.Patients-section-fifteen .service-patient-inflict .clients-fifteen-span span {\n  font-weight: 600;\n  font-size: 24px;\n  color: #1f2937;\n}\n.Patients-section-fifteen .patients-left-front {\n  animation-duration: 5s;\n  animation-iteration-count: infinite;\n  transform-origin: bottom;\n}\n@media (max-width: 991.98px) {\n  .Patients-section-fifteen .patients-left-front {\n    display: none;\n  }\n}\n.Patients-section-fifteen .patients-left-front.patients-left-img {\n  animation-name: bounce-1;\n  animation-timing-function: linear;\n}\n\n.doctors-section-fifteen {\n  position: relative;\n  padding: 80px 0;\n  background: #f4f4f4;\n}\n@media (max-width: 991.98px) {\n  .doctors-section-fifteen {\n    padding: 50px 0;\n  }\n}\n.doctors-section-fifteen .doctor-fifteen-icon {\n  position: absolute;\n  top: 100px;\n  right: 0;\n}\n.doctors-section-fifteen .doctors-fifteen-icon {\n  position: absolute;\n  right: 200px;\n  bottom: 0;\n}\n\n.doc-content-fift {\n  padding: 15px;\n}\n.doc-content-fift a {\n  color: #1f2937;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 6px;\n  display: inline-block;\n}\n.doc-content-fift a:hover {\n  color: #0ce0ff;\n}\n.doc-content-fift p {\n  color: #6b7280;\n  margin-bottom: 10px;\n}\n.doc-content-fift p span {\n  color: #1f2937;\n}\n.doc-content-fift .rate-fifteen {\n  margin-bottom: 15px;\n}\n.doc-content-fift .rate-fifteen .rate-four {\n  padding: 5px 10px;\n  background: #0ce0ff;\n  border-radius: 5px;\n  color: #ffffff;\n}\n.doc-content-fift .rate-fifteen ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.doc-content-fift .rate-fifteen ul li {\n  width: 31px;\n  height: 27px;\n  background: #eeeef3;\n  color: #1f2937;\n  border-radius: 5px;\n  margin-right: 5px;\n}\n.doc-content-fift .rate-fifteen ul li:last-child {\n  margin-right: 0;\n}\n.doc-content-fift .rate-fifteen ul.fift-rate li {\n  padding: 5px;\n  width: auto;\n  height: auto;\n}\n.doc-content-fift .fift-bottom-content h3 {\n  color: #1f2937;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n.doc-content-fift .fift-bottom-content h3 span {\n  color: #6b7280;\n  text-decoration: line-through;\n  font-size: 18px;\n}\n.doc-content-fift .fift-bottom-content a {\n  padding: 10px 25px;\n  background: #0e82fd;\n  color: #ffffff;\n  border-radius: 5px;\n  margin-bottom: 0;\n  transition:\n    color 0.3s ease-in-out,\n    box-shadow 0.3s ease-in-out;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  font-size: 16px;\n}\n@media (max-width: 1199.98px) {\n  .doc-content-fift .fift-bottom-content a {\n    padding: 10px 5px;\n    font-size: 14px;\n  }\n}\n.doc-content-fift .fift-bottom-content a:hover {\n  box-shadow: inset 0 0 0 30px #2dd4bf;\n}\n\n.item.item-fifteen .doctor-profile-widget {\n  border: none;\n}\n.item.item-fifteen .doctor-profile-widget.doctor-profile-widget-fift {\n  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.15);\n  margin: 10px 0;\n}\n.item.item-fifteen .doctor-profile-widget.doctor-profile-widget-fift:first-child {\n  margin-left: 10px;\n}\n.item.item-fifteen .doctor-profile-widget.doctor-profile-widget-fift:last-child {\n  margin-right: 10px;\n}\n.item.item-fifteen .doctor-profile-widget .doc-pro-img .item-info {\n  position: absolute;\n  bottom: 15px;\n  left: 15px;\n}\n.item.item-fifteen .doctor-profile-widget .doc-pro-img .item-info h6 {\n  margin-bottom: 0;\n  background: #0e82fd;\n  border-radius: 5px;\n  padding: 10px;\n  color: #ffffff;\n}\n.item.item-fifteen .doctor-profile-widget .doc-pro-img .doctor-amount .fav-icon {\n  width: 40px;\n  height: 40px;\n  background: #ffffff;\n  border-radius: 50%;\n  font-size: 17px;\n}\n.item.item-fifteen .doctor-profile-widget .doc-pro-img .doctor-amount .fav-icon.fav-icon-fifteen {\n  background: #eeeef3;\n}\n.item.item-fifteen .doctor-profile-widget .doc-pro-img .doctor-amount .fav-icon.selected {\n  background: #0ce0ff;\n  color: #ffffff;\n}\n.item.item-fifteen .doctor-profile-widget .doc-pro-img.doc-pro-img-fifteen {\n  padding: 56px 0;\n  border-bottom: 1px solid #e5e5eb;\n}\n.item.item-fifteen\n  .doctor-profile-widget\n  .doc-pro-img.doc-pro-img-fifteen\n  .doctor-profile-img-fifteen {\n  width: 208px;\n  height: 208px;\n  margin: auto;\n}\n\n.pharmacy-section-fifteen {\n  position: relative;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .pharmacy-section-fifteen {\n    padding: 50px 0;\n  }\n}\n\n.feedback-section-fifteen {\n  position: relative;\n  padding: 40px 0 80px 0;\n}\n@media (max-width: 1199.98px) {\n  .feedback-section-fifteen {\n    padding: 0 0 80px 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .feedback-section-fifteen {\n    padding: 0 0 50px 0;\n  }\n}\n.feedback-section-fifteen .feedback-schedule-all {\n  background: linear-gradient(92.16deg, #61aeff 0.85%, #0e82fd 76.47%);\n  border-radius: 10px;\n}\n.feedback-section-fifteen .feedback-schedule-all .feedback-inner-main {\n  margin: -45px 0 0 30px;\n}\n@media (max-width: 1399.98px) {\n  .feedback-section-fifteen .feedback-schedule-all .feedback-inner-main {\n    margin: 0 0 0 30px;\n  }\n}\n@media (max-width: 991.98px) {\n  .feedback-section-fifteen .feedback-schedule-all .feedback-inner-main {\n    display: none;\n  }\n}\n.feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content {\n  padding: 50px 0;\n}\n@media (max-width: 991.98px) {\n  .feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content {\n    text-align: center;\n  }\n}\n.feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content .feedback-fift-img {\n  width: 66px;\n  height: 17px;\n  margin-bottom: 15px;\n}\n@media (max-width: 991.98px) {\n  .feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content .feedback-fift-img {\n    margin: auto auto 15px auto;\n  }\n}\n.feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content h3 {\n  color: #ffffff;\n  font-size: 28px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n@media (max-width: 767.98px) {\n  .feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content h3 {\n    font-size: 26px;\n  }\n}\n.feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content p {\n  color: #ffffff;\n  font-size: 18px;\n  margin-bottom: 15px;\n}\n.feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content a {\n  padding: 15px 43px;\n  background: #0ce0ff;\n  border-radius: 5px;\n  display: inline-block;\n  color: #ffffff;\n  transition:\n    color 0.5s ease-in-out,\n    box-shadow 0.3s ease-in-out;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n}\n.feedback-section-fifteen .feedback-schedule-all .feedback-fifteen-content a:hover {\n  box-shadow: inset 0 0 0 30px #2dd4bf;\n}\n\n.appointment-section-fifteen {\n  position: relative;\n  padding: 80px 0;\n  background-color: #0e82fd;\n  background-image: url(../images/book-appointment-bg.png);\n  background-position: top left;\n  background-repeat: no-repeat;\n  background-size: 58% 100%;\n}\n@media (max-width: 991.98px) {\n  .appointment-section-fifteen {\n    padding: 50px 0;\n    background-image: none;\n    text-align: center;\n  }\n}\n.appointment-section-fifteen .appointment-schedule-main h2 {\n  font-size: 40px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 10px;\n}\n@media (max-width: 991.98px) {\n  .appointment-section-fifteen .appointment-schedule-main h2 {\n    font-size: 34px;\n  }\n}\n@media (max-width: 767.98px) {\n  .appointment-section-fifteen .appointment-schedule-main h2 {\n    font-size: 28px;\n  }\n}\n.appointment-section-fifteen .appointment-schedule-main h6 {\n  font-size: 18px;\n  color: #ffffff;\n  margin-bottom: 25px;\n}\n.appointment-section-fifteen .appointment-schedule-main p {\n  color: #b0d6ff;\n}\n.appointment-section-fifteen .appointment-schedule-main ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n}\n@media (max-width: 991.98px) {\n  .appointment-section-fifteen .appointment-schedule-main ul {\n    justify-content: center;\n  }\n}\n@media (max-width: 575.98px) {\n  .appointment-section-fifteen .appointment-schedule-main ul {\n    flex-wrap: wrap;\n  }\n}\n.appointment-section-fifteen .appointment-schedule-main ul li {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin: 0 25px 25px 0;\n  padding: 15px;\n  background: #ffffff;\n  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n  width: 151px;\n}\n@media (max-width: 575.98px) {\n  .appointment-section-fifteen .appointment-schedule-main ul li {\n    width: 50%;\n    margin-right: 1px;\n  }\n}\n.appointment-section-fifteen .appointment-schedule-main ul li:last-child {\n  margin-right: 0;\n}\n.appointment-section-fifteen .appointment-schedule-main ul li .appointment-schedule-img {\n  position: relative;\n  margin-bottom: 20px;\n}\n.appointment-section-fifteen\n  .appointment-schedule-main\n  ul\n  li\n  .appointment-schedule-img\n  .appoint-inner-img {\n  position: absolute;\n  right: -20px;\n  bottom: -10px;\n}\n.appointment-section-fifteen .appointment-schedule-main ul li span {\n  font-weight: 400;\n  color: #1f2937;\n  display: inline-block;\n  font-size: 14px;\n}\n.appointment-section-fifteen .appointment-schedule-main a {\n  background: #0ce0ff;\n  padding: 15px 25px;\n  border-radius: 5px;\n  display: inline-block;\n  color: #ffffff;\n  transition:\n    color 0.3s ease-in-out,\n    box-shadow 0.3s ease-in-out;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n}\n.appointment-section-fifteen .appointment-schedule-main a:hover {\n  box-shadow: inset 0 0 0 50px #2dd4bf;\n}\n.appointment-section-fifteen .appointment-right-image {\n  animation-duration: 5s;\n  animation-iteration-count: infinite;\n  transform-origin: bottom;\n}\n@media (max-width: 991.98px) {\n  .appointment-section-fifteen .appointment-right-image {\n    display: none;\n  }\n}\n.appointment-section-fifteen .appointment-right-image.appoint-fift-img {\n  animation-name: bounce-1;\n  animation-timing-function: linear;\n}\n\n.about-us-section-fifteen {\n  position: relative;\n  padding: 80px 0;\n  background: #f4f4f4;\n}\n@media (max-width: 991.98px) {\n  .about-us-section-fifteen {\n    padding: 50px 0;\n  }\n}\n.about-us-section-fifteen .aboutus-img-main {\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .about-us-section-fifteen .aboutus-img-main {\n    display: none;\n  }\n}\n.about-us-section-fifteen .aboutus-img-main .aboutus-img-one {\n  position: absolute;\n  right: 45px;\n  bottom: 15px;\n  box-shadow: 0px 1px 25px rgba(0, 0, 0, 0.15);\n  animation: mover 1s infinite alternate;\n}\n.about-us-section-fifteen .vertical-slider {\n  position: static;\n}\n.about-us-section-fifteen .vertical-slider .aboutus-fifteen-main {\n  background: #ffffff;\n  box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.15);\n  padding: 15px;\n  border-radius: 10px;\n  margin: 0 0 15px 0;\n}\n.about-us-section-fifteen .vertical-slider .aboutus-fifteen-main .aboutus-profile-left {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  margin: 0 0 15px 0;\n}\n.about-us-section-fifteen\n  .vertical-slider\n  .aboutus-fifteen-main\n  .aboutus-profile-left\n  .aboutus-image {\n  margin-right: 7px;\n}\n.about-us-section-fifteen\n  .vertical-slider\n  .aboutus-fifteen-main\n  .aboutus-profile-left\n  .aboutus-image\n  img {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n}\n.about-us-section-fifteen .vertical-slider .aboutus-fifteen-main .aboutus-profile-left h6 {\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 7px;\n}\n.about-us-section-fifteen .vertical-slider .aboutus-fifteen-main .aboutus-profile-left span {\n  color: #6b7280;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n.about-us-section-fifteen .vertical-slider .aboutus-fifteen-main p {\n  margin-bottom: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.about-us-section-fifteen .vertical-slider .slick-list {\n  padding: 0 !important;\n}\n.about-us-section-fifteen .vertical-slider .slick-dots {\n  position: absolute;\n  bottom: 3%;\n  left: -42%;\n}\n@media (max-width: 991.98px) {\n  .about-us-section-fifteen .vertical-slider .slick-dots {\n    display: none !important;\n  }\n}\n.about-us-section-fifteen .vertical-slider .slick-dots li {\n  margin: 0;\n  height: 6px;\n}\n.about-us-section-fifteen .vertical-slider .slick-dots li.slick-active button {\n  background-color: #4c58a0;\n}\n.about-us-section-fifteen .vertical-slider .slick-arrow {\n  position: absolute;\n  bottom: 0;\n}\n.about-us-section-fifteen .vertical-slider .slick-prev {\n  position: absolute;\n  top: 95%;\n  left: 84%;\n  width: 45px;\n  height: 45px;\n  border-radius: 10px;\n}\n@media (max-width: 1399.98px) {\n  .about-us-section-fifteen .vertical-slider .slick-prev {\n    left: 80%;\n  }\n}\n@media (max-width: 1199.98px) {\n  .about-us-section-fifteen .vertical-slider .slick-prev {\n    left: 76%;\n  }\n}\n@media (max-width: 991.98px) {\n  .about-us-section-fifteen .vertical-slider .slick-prev {\n    top: 50%;\n    left: auto;\n  }\n}\n.about-us-section-fifteen .vertical-slider .slick-prev::before {\n  content: \"\\f053\";\n  font-family: \"FontAwesome\";\n  font-weight: 900;\n  font-size: 13px;\n}\n.about-us-section-fifteen .vertical-slider .slick-prev:hover {\n  background: #1c5b91;\n}\n.about-us-section-fifteen .vertical-slider .slick-next {\n  top: 95%;\n  width: 45px;\n  height: 45px;\n  border-radius: 10px;\n}\n@media (max-width: 991.98px) {\n  .about-us-section-fifteen .vertical-slider .slick-next {\n    top: 50%;\n  }\n}\n.about-us-section-fifteen .vertical-slider .slick-next::before {\n  content: \"\\f054\";\n  font-family: \"FontAwesome\";\n  font-weight: 900;\n  font-size: 13px;\n}\n.about-us-section-fifteen .vertical-slider .slick-next:hover {\n  background: #1c5b91;\n}\n.about-us-section-fifteen .vertical-slider .slick-current.aboutus-fifteen-main {\n  background: #0e82fd;\n}\n.about-us-section-fifteen\n  .vertical-slider\n  .slick-current.aboutus-fifteen-main\n  .aboutus-profile-left\n  h6 {\n  color: #ffffff;\n}\n.about-us-section-fifteen\n  .vertical-slider\n  .slick-current.aboutus-fifteen-main\n  .aboutus-profile-left\n  span {\n  color: #ffffff;\n}\n.about-us-section-fifteen .vertical-slider .slick-current.aboutus-fifteen-main p {\n  color: #ffffff;\n}\n\n.frequently-section-fifteen {\n  position: relative;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .frequently-section-fifteen {\n    padding: 50px 0;\n  }\n}\n.frequently-section-fifteen .items-fift {\n  border: 1px solid #e5e5eb;\n  border-radius: 10px;\n  padding: 30px;\n}\n.frequently-section-fifteen .items-fift a {\n  color: #1f2937;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 15px;\n  display: block;\n}\n.frequently-section-fifteen .items-fift p {\n  color: #6b7280;\n  font-weight: 400;\n  margin-bottom: 16px;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 5;\n  width: 100%;\n  overflow: hidden;\n}\n.frequently-section-fifteen .items-fift .line-arrow {\n  display: flex;\n  align-items: center;\n  color: #0e82fd;\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 0;\n}\n.frequently-section-fifteen .items-fift .line-arrow:hover {\n  color: #0ce0ff;\n}\n.frequently-section-fifteen .frequent-slider-fifteen .owl-nav {\n  text-align: end;\n}\n.frequently-section-fifteen .frequent-slider-fifteen .owl-nav .owl-prev,\n.frequently-section-fifteen .frequent-slider-fifteen .owl-nav .owl-next {\n  margin-top: 24px;\n}\n.frequently-section-fifteen .frequent-slider-fifteen .owl-dots {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n.frequently-section-fifteen .frequent-slider-fifteen .owl-dots .owl-dot {\n  width: 50px;\n  height: 6px;\n  background: #d9d9d9;\n}\n.frequently-section-fifteen .frequent-slider-fifteen .owl-dots .owl-dot:first-child {\n  border-radius: 10px 0 0 10px;\n}\n.frequently-section-fifteen .frequent-slider-fifteen .owl-dots .owl-dot:last-child {\n  border-radius: 0 10px 10px 0;\n}\n.frequently-section-fifteen .frequent-slider-fifteen .owl-dots .owl-dot.active {\n  background: #4c58a0;\n}\n@media (max-width: 575.98px) {\n  .frequently-section-fifteen .frequent-slider-fifteen .owl-dots {\n    display: none;\n  }\n}\n\n.section-header-fifteen {\n  margin-bottom: 50px;\n}\n.section-header-fifteen h2 {\n  color: #1f2937;\n  font-size: 40px;\n  font-weight: 600;\n}\n@media (max-width: 991.98px) {\n  .section-header-fifteen h2 {\n    font-size: 34px;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-header-fifteen h2 {\n    font-size: 28px;\n  }\n}\n.section-header-fifteen h2 span {\n  color: rgb(14, 130, 253);\n}\n.section-header-fifteen p {\n  color: #707070;\n  margin-bottom: 0;\n}\n\n.doctor-slider-fifteen .owl-nav {\n  text-align: center;\n}\n.doctor-slider-fifteen .owl-nav button.owl-prev,\n.doctor-slider-fifteen .owl-nav button.owl-next {\n  width: 45px;\n  height: 45px;\n  background: #ffffff;\n  font-size: 13px;\n  border-radius: 10px;\n  margin-top: 50px;\n}\n.doctor-slider-fifteen .owl-nav button.owl-prev:hover,\n.doctor-slider-fifteen .owl-nav button.owl-next:hover {\n  background: #eeeef3;\n}\n@media (max-width: 767.98px) {\n  .doctor-slider-fifteen .owl-nav button.owl-prev,\n  .doctor-slider-fifteen .owl-nav button.owl-next {\n    width: 35px;\n    height: 35px;\n  }\n}\n\n.pharmacy-slider-fifteen .owl-nav,\n.frequent-slider-fifteen .owl-nav {\n  text-align: center;\n}\n.pharmacy-slider-fifteen .owl-nav button.owl-prev,\n.pharmacy-slider-fifteen .owl-nav button.owl-next,\n.frequent-slider-fifteen .owl-nav button.owl-prev,\n.frequent-slider-fifteen .owl-nav button.owl-next {\n  width: 45px;\n  height: 45px;\n  background: #eeeef3;\n  font-size: 13px;\n  border-radius: 10px;\n  margin-top: 50px;\n}\n.pharmacy-slider-fifteen .owl-nav button.owl-prev:hover,\n.pharmacy-slider-fifteen .owl-nav button.owl-next:hover,\n.frequent-slider-fifteen .owl-nav button.owl-prev:hover,\n.frequent-slider-fifteen .owl-nav button.owl-next:hover {\n  background: #0ce0ff;\n}\n@media (max-width: 767.98px) {\n  .pharmacy-slider-fifteen .owl-nav button.owl-prev,\n  .pharmacy-slider-fifteen .owl-nav button.owl-next,\n  .frequent-slider-fifteen .owl-nav button.owl-prev,\n  .frequent-slider-fifteen .owl-nav button.owl-next {\n    width: 35px;\n    height: 35px;\n  }\n}\n\n.playicon {\n  position: absolute;\n  right: 61%;\n  top: 37%;\n}\n\n.playicon span {\n  width: 48px;\n  height: 48px;\n  background: #ff008a;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.modal-content-video {\n  padding: 0 !important;\n}\n\n.modal-content-video .modal-content {\n  background: #000;\n}\n\n.modal-content-video .modal-header {\n  border: 0;\n}\n\n.modal-content-video .modal-header button.close {\n  color: #fff;\n  opacity: 1;\n}\n\n.video-home video {\n  width: 100%;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes mover {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(-10px);\n  }\n}\n@keyframes movers {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(-10px);\n  }\n}\n@keyframes bounce-1 {\n  0% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-50px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n.frequent-slider-fifteen .owl-theme .owl-dots .owl-dot span {\n  display: none;\n}\n\n.footer-fift-selects .footer-select .select2-container {\n  width: 137.3333px !important;\n}\n\n.main-wrapper.home-sixteen {\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n}\n@media (max-width: 1199.98px) {\n  .main-wrapper.home-sixteen {\n    font-size: 15px;\n  }\n}\n\n.banner-section-sixteen {\n  position: relative;\n  padding: 85px 0 0 0;\n}\n.banner-section-sixteen .banner-content-sixteen {\n  padding: 100px 0 0 0;\n  z-index: 1;\n}\n@media (max-width: 991.98px) {\n  .banner-section-sixteen .banner-content-sixteen {\n    padding: 50px 0;\n  }\n}\n.banner-section-sixteen .banner-content-sixteen span {\n  font-size: 14px;\n  color: #0e82fd;\n  font-weight: 500;\n  text-transform: uppercase;\n  padding: 5px 10px;\n  background: rgba(14, 130, 253, 0.1);\n  margin-bottom: 10px;\n  display: inline-block;\n}\n.banner-section-sixteen .banner-content-sixteen h1 {\n  color: #515151;\n  margin-bottom: 26px;\n}\n.banner-section-sixteen .banner-content-sixteen p {\n  color: #9f9f9f;\n  font-size: 16px;\n  margin-bottom: 26px;\n}\n.banner-section-sixteen .banner-content-sixteen .banner-btns-sixteen .btn-primary {\n  padding: 10px 25px;\n  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: 700;\n}\n.banner-section-sixteen .banner-content-sixteen .banner-btns-sixteen .btn-primary:hover {\n  box-shadow: 0 0.5em 0.5em -0.4em var(--hover);\n  transform: translateY(-0.25em);\n}\n.banner-section-sixteen .banner-image-sixteen {\n  padding: 41px 0;\n  background-image: url(../images/banner-sixteen-bg.png);\n  background-repeat: no-repeat;\n  background-position: right top;\n  background-size: 75% 100%;\n}\n.banner-section-sixteen .banner-image-sixteen .banner-inner-img-sixteen {\n  position: relative;\n  z-index: 1;\n}\n.banner-section-sixteen .banner-image-sixteen .banner-inner-img-sixteen img {\n  margin-bottom: 20px;\n}\n.banner-section-sixteen .banner-image-sixteen .banner-inner-img-sixteen img:last-child {\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .banner-section-sixteen .banner-image-sixteen {\n    display: none;\n  }\n}\n.banner-section-sixteen .ban-sixteen-imgone {\n  position: absolute;\n  top: 100px;\n  right: 100px;\n  z-index: 0;\n}\n.banner-section-sixteen .ban-sixteen-imgtwo {\n  position: absolute;\n  top: 90px;\n  left: 0;\n  z-index: 0;\n}\n\n.services-section-sixteen {\n  position: relative;\n  padding: 80px 0;\n  background: #f8fbff;\n}\n@media (max-width: 991.98px) {\n  .services-section-sixteen {\n    padding: 50px 0;\n  }\n}\n.services-section-sixteen .discover-you-main {\n  text-align: center;\n}\n.services-section-sixteen .discover-you-main .discover-you-image {\n  width: 200px;\n  height: 200px;\n  background: rgba(14, 130, 253, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n  margin: auto auto 20px auto;\n}\n.services-section-sixteen .discover-you-main .discover-you-image img {\n  width: auto;\n}\n.services-section-sixteen .discover-you-main a {\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n.services-section-sixteen .discover-you-main a:hover {\n  color: #1c5b91;\n}\n.services-section-sixteen .discover-you-main p {\n  font-size: 14px;\n  color: #a2a2a2;\n  margin-bottom: 15px;\n}\n.services-section-sixteen .discover-you-main .discov-innner {\n  color: #0e82fd;\n  font-size: 14px;\n  font-weight: 500;\n}\n.services-section-sixteen .discover-you-main .discov-innner i {\n  font-size: 10px;\n}\n.services-section-sixteen .discover-you-main .discov-innner:hover {\n  color: #09dca4;\n}\n.services-section-sixteen .service-sixteen-icon {\n  position: absolute;\n  top: 75px;\n  left: 45px;\n  animation: mover 1s infinite alternate;\n}\n\n.treatment-section-sixteen {\n  position: relative;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .treatment-section-sixteen {\n    padding: 50px 0;\n  }\n}\n.treatment-section-sixteen .item.item-sixteen .doctor-profile-widget {\n  border: none;\n  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.03);\n  border-radius: 0;\n}\n.treatment-section-sixteen\n  .item.item-sixteen\n  .doctor-profile-widget\n  .doc-pro-img\n  .doctor-profile-img {\n  border-radius: 6px;\n}\n.treatment-section-sixteen .item.item-sixteen .doctor-profile-widget .doc-pro-img .doctor-amount {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n}\n.treatment-section-sixteen\n  .item.item-sixteen\n  .doctor-profile-widget\n  .doc-pro-img\n  .doctor-amount\n  span {\n  padding: 5px 10px;\n  border-radius: 0;\n  color: #0e82fd;\n  font-size: 14px;\n  font-weight: 600;\n}\n.treatment-section-sixteen .item.item-sixteen .doctor-profile-widget .doc-content .doc-pro-info {\n  align-items: start;\n  padding-bottom: 10px;\n}\n.treatment-section-sixteen\n  .item.item-sixteen\n  .doctor-profile-widget\n  .doc-content\n  .doc-pro-info\n  .doc-pro-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.treatment-section-sixteen\n  .item.item-sixteen\n  .doctor-profile-widget\n  .doc-content\n  .doc-pro-info\n  .reviews-ratings\n  p\n  span {\n  background: none;\n  color: #ffbc11;\n  font-size: 14px;\n  margin: 0 5px 0 0;\n}\n.treatment-section-sixteen\n  .item.item-sixteen\n  .doctor-profile-widget\n  .doc-content\n  .doc-pro-info\n  .reviews-ratings\n  p\n  span\n  i {\n  margin-right: 4px;\n}\n.treatment-section-sixteen\n  .item.item-sixteen\n  .doctor-profile-widget\n  .doc-content\n  .doc-pro-location\n  p\n  i {\n  font-size: 17px;\n}\n.treatment-section-sixteen .item.item-sixteen .doctor-profile-widget .btn-primary {\n  width: 100%;\n  border-radius: 0;\n  padding: 15px 20px;\n  background: rgba(14, 130, 253, 0.1);\n  color: #0e82fd;\n  text-transform: capitalize;\n  font-size: 20px;\n  font-weight: 600;\n  border: none;\n  box-shadow: inset 0 0 0 0 #ffffff;\n}\n@media (max-width: 767.98px) {\n  .treatment-section-sixteen .item.item-sixteen .doctor-profile-widget .btn-primary {\n    padding: 10px 20px;\n    font-size: 18px;\n  }\n}\n.treatment-section-sixteen .item.item-sixteen .doctor-profile-widget .btn-primary:hover {\n  background: #2dd4bf;\n  box-shadow: inset 0 100px 0 0 #2dd4bf;\n  color: #ffffff;\n}\n.treatment-section-sixteen .service-sixteen-icontwo {\n  position: absolute;\n  right: 25px;\n  bottom: 150px;\n  animation: mover 1s infinite alternate;\n}\n\n.features-section-sixteen {\n  position: relative;\n  padding: 80px 0;\n  background: #f8fbff;\n}\n@media (max-width: 991.98px) {\n  .features-section-sixteen {\n    padding: 50px 0;\n  }\n}\n.features-section-sixteen .feature-sixteen-main .feature-six-img {\n  position: relative;\n}\n.features-section-sixteen .feature-sixteen-main .feature-six-img::after {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  content: \"\";\n  transition: 0.5s;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.42) 100%);\n}\n.features-section-sixteen .feature-sixteen-main .feature-six-img .feature-content-six {\n  position: absolute;\n  bottom: 27px;\n  text-align: center;\n  width: 100%;\n  z-index: 1;\n  top: 82%;\n  transition: all 0.5s ease-out;\n}\n.features-section-sixteen\n  .feature-sixteen-main\n  .feature-six-img\n  .feature-content-six\n  .feature-content-one {\n  display: block;\n}\n.features-section-sixteen\n  .feature-sixteen-main\n  .feature-six-img\n  .feature-content-six\n  .feature-content-one\n  h5 {\n  font-size: 20px;\n  color: #ffffff;\n}\n.features-section-sixteen\n  .feature-sixteen-main\n  .feature-six-img\n  .feature-content-six\n  .feature-content-one\n  span {\n  color: #ffffff;\n}\n.features-section-sixteen\n  .feature-sixteen-main\n  .feature-six-img\n  .feature-content-six\n  .feature-content-two {\n  display: none;\n}\n.features-section-sixteen\n  .feature-sixteen-main\n  .feature-six-img\n  .feature-content-six\n  .feature-content-two\n  p {\n  color: #ffffff;\n  line-height: 30px;\n  font-size: 16px;\n  letter-spacing: -0.36px;\n  padding: 10px;\n}\n@media (max-width: 353.98px) {\n  .features-section-sixteen\n    .feature-sixteen-main\n    .feature-six-img\n    .feature-content-six\n    .feature-content-two\n    p {\n    line-height: 20px;\n  }\n}\n.features-section-sixteen\n  .feature-sixteen-main\n  .feature-six-img\n  .feature-content-six\n  .feature-content-two\n  span {\n  color: #ffffff;\n}\n.features-section-sixteen .feature-sixteen-main .feature-six-img:hover::after {\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);\n}\n.features-section-sixteen .feature-sixteen-main .feature-six-img:hover .feature-content-six {\n  top: 30%;\n}\n@media (max-width: 1399.98px) {\n  .features-section-sixteen .feature-sixteen-main .feature-six-img:hover .feature-content-six {\n    top: 10%;\n  }\n}\n.features-section-sixteen\n  .feature-sixteen-main\n  .feature-six-img:hover\n  .feature-content-six\n  .feature-content-one {\n  display: none;\n}\n.features-section-sixteen\n  .feature-sixteen-main\n  .feature-six-img:hover\n  .feature-content-six\n  .feature-content-two {\n  display: block;\n}\n\n.facts-section-sixteen {\n  position: relative;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .facts-section-sixteen {\n    padding: 50px 0;\n  }\n}\n.facts-section-sixteen .facts-section-all {\n  display: flex;\n}\n@media (max-width: 991.98px) {\n  .facts-section-sixteen .facts-section-all {\n    display: block;\n  }\n}\n.facts-section-sixteen .facts-section-all .facts-main-sixteen {\n  background: #0e82fd;\n  padding: 100px 30px;\n  width: 50%;\n}\n@media (max-width: 991.98px) {\n  .facts-section-sixteen .facts-section-all .facts-main-sixteen {\n    width: 100%;\n    padding: 60px 30px;\n    text-align: center;\n  }\n}\n.facts-section-sixteen .facts-section-all .facts-main-sixteen span {\n  font-size: 14px;\n  color: #ffffff;\n  font-weight: 500;\n  text-transform: uppercase;\n  padding: 5px 10px;\n  background: rgba(255, 255, 255, 0.3);\n  margin-bottom: 17px;\n  display: inline-block;\n}\n.facts-section-sixteen .facts-section-all .facts-main-sixteen h2 {\n  color: #ffffff;\n  margin-bottom: 15px;\n  font-size: 40px;\n}\n@media (max-width: 991.98px) {\n  .facts-section-sixteen .facts-section-all .facts-main-sixteen h2 {\n    font-size: 34px;\n  }\n}\n@media (max-width: 767.98px) {\n  .facts-section-sixteen .facts-section-all .facts-main-sixteen h2 {\n    font-size: 28px;\n  }\n}\n.facts-section-sixteen .facts-section-all .facts-main-sixteen p {\n  color: #ffffff;\n  font-size: 16px;\n  margin-bottom: 15px;\n}\n.facts-section-sixteen .facts-section-all .facts-main-sixteen a {\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n}\n.facts-section-sixteen .facts-section-all .facts-main-sixteen a i {\n  font-size: 10px;\n}\n.facts-section-sixteen .facts-section-all .facts-main-sixteen a:hover {\n  color: #09dca4;\n}\n.facts-section-sixteen .facts-section-all .facts-content-all {\n  width: 50%;\n}\n@media (max-width: 991.98px) {\n  .facts-section-sixteen .facts-section-all .facts-content-all {\n    width: 100%;\n  }\n}\n.facts-section-sixteen .facts-section-all .facts-content-all ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n}\n.facts-section-sixteen .facts-section-all .facts-content-all ul li {\n  width: 50%;\n  height: 167px;\n  padding: 20px 0;\n  border: 2px solid #f8fbff;\n  overflow: hidden;\n  position: relative;\n}\n@media (max-width: 575.98px) {\n  .facts-section-sixteen .facts-section-all .facts-content-all ul li {\n    width: 100%;\n  }\n}\n.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-sixteen-img {\n  flex-direction: column;\n  transition: all 0.5s;\n}\n.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-sixteen-img img {\n  margin-bottom: 25px;\n}\n.facts-section-sixteen\n  .facts-section-all\n  .facts-content-all\n  ul\n  li\n  .facts-sixteen-img\n  .facts-content-sixteen\n  .facts-content-one\n  h5 {\n  font-size: 18px;\n  font-weight: 700;\n  text-transform: capitalize;\n  color: #626262;\n  margin-bottom: 0;\n}\n.facts-section-sixteen\n  .facts-section-all\n  .facts-content-all\n  ul\n  li\n  .facts-sixteen-img\n  .facts-content-sixteen\n  .facts-content-one\n  h5\n  i {\n  font-size: 14px;\n  color: #0e82fd;\n}\n.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n  opacity: 0;\n  transition: opacity 0.25s;\n}\n.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two p {\n  color: #7d7d7d;\n  font-size: 14px;\n  letter-spacing: -0.36px;\n  padding: 0 20px;\n  text-align: center;\n  line-height: 30px;\n  margin-bottom: 0;\n}\n.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two:hover {\n  opacity: 1;\n}\n.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two:hover > * {\n  transform: translateY(0);\n}\n.facts-section-sixteen .facts-section-all .facts-content-all ul li .facts-content-two > * {\n  transform: translateY(20px);\n  transition: transform 0.25s;\n}\n.facts-section-sixteen\n  .facts-section-all\n  .facts-content-all\n  ul\n  li\n  .facts-content-two.facts-content-two-solid {\n  background: #ffffff;\n}\n\n.experts-section-sixteen {\n  position: relative;\n  padding: 80px 0;\n  background: linear-gradient(115.57deg, #464646 12.99%, rgba(0, 0, 0, 0.58) 66.18%);\n}\n@media (max-width: 991.98px) {\n  .experts-section-sixteen {\n    padding: 50px 0;\n  }\n}\n\n.pricing-section-sixteen {\n  position: relative;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .pricing-section-sixteen {\n    padding: 50px 0;\n  }\n}\n\n.testimonal-section-sixteen {\n  position: relative;\n  padding: 80px 0;\n  background: #f8fbff;\n}\n@media (max-width: 991.98px) {\n  .testimonal-section-sixteen {\n    padding: 50px 0;\n  }\n}\n\n.feedback-section-sixteen {\n  position: relative;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .feedback-section-sixteen {\n    padding: 50px 0;\n  }\n}\n.feedback-section-sixteen .feedback-schedule-all {\n  background: linear-gradient(90.79deg, #0e82fd 0%, #2cd9c5 100%);\n  backdrop-filter: blur(30.5px);\n  border-radius: 15px;\n  padding: 19px;\n}\n@media (max-width: 991.98px) {\n  .feedback-section-sixteen .feedback-schedule-all .feedback-inner-main {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content {\n    text-align: center;\n  }\n}\n.feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content h3 {\n  color: #ffffff;\n  font-size: 36px;\n  font-weight: 700;\n  text-transform: capitalize;\n  margin-bottom: 10px;\n}\n@media (max-width: 991.98px) {\n  .feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content h3 {\n    font-size: 34px;\n  }\n}\n@media (max-width: 767.98px) {\n  .feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content h3 {\n    font-size: 28px;\n  }\n}\n.feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content p {\n  color: #ffffff;\n  font-size: 20px;\n  margin-bottom: 30px;\n}\n@media (max-width: 991.98px) {\n  .feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content p {\n    font-size: 16px;\n  }\n}\n.feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content .feedback-btns {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n}\n@media (max-width: 991.98px) {\n  .feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content .feedback-btns {\n    justify-content: center;\n  }\n}\n@media (max-width: 575.98px) {\n  .feedback-section-sixteen .feedback-schedule-all .feedback-fifteen-content .feedback-btns {\n    display: block;\n    width: 100%;\n  }\n}\n.feedback-section-sixteen\n  .feedback-schedule-all\n  .feedback-fifteen-content\n  .feedback-btns\n  .btn-primary {\n  padding: 10px 25px;\n  box-shadow: 0px 10px 40px 10px rgba(0, 0, 0, 0.08);\n  border-radius: 5px;\n  background: #ffffff;\n  color: #0e82fd;\n  font-size: 16px;\n  font-weight: 700;\n  border: none;\n  transition: 0.5s;\n  margin-right: 10px;\n}\n.feedback-section-sixteen\n  .feedback-schedule-all\n  .feedback-fifteen-content\n  .feedback-btns\n  .btn-primary:hover {\n  background: #1c5b91;\n  color: #ffffff;\n  transition: 0.5s;\n}\n@media (max-width: 575.98px) {\n  .feedback-section-sixteen\n    .feedback-schedule-all\n    .feedback-fifteen-content\n    .feedback-btns\n    .btn-primary {\n    width: 100%;\n    margin: 0 0 10px 0;\n  }\n}\n.feedback-section-sixteen\n  .feedback-schedule-all\n  .feedback-fifteen-content\n  .feedback-btns\n  .btn-primarytwo {\n  padding: 10px 25px;\n  font-size: 16px;\n  margin-bottom: 0;\n  font-weight: 600;\n  color: #ffffff;\n  border-radius: 5px;\n  transition: 0.5s;\n}\n.feedback-section-sixteen\n  .feedback-schedule-all\n  .feedback-fifteen-content\n  .feedback-btns\n  .btn-primarytwo:hover {\n  background: #1c5b91;\n  color: #ffffff;\n  transition: 0.5s;\n}\n@media (max-width: 575.98px) {\n  .feedback-section-sixteen\n    .feedback-schedule-all\n    .feedback-fifteen-content\n    .feedback-btns\n    .btn-primarytwo {\n    width: 100%;\n  }\n}\n\n.section-header-sixteen {\n  margin-bottom: 50px;\n}\n.section-header-sixteen.section-header-sixteentwo h2 {\n  color: #ffffff;\n}\n.section-header-sixteen p {\n  color: #0e82fd;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  margin-bottom: 7px;\n}\n.section-header-sixteen h2 {\n  font-size: 40px;\n  font-weight: 600;\n  margin-bottom: 0;\n  color: #1f2937;\n  text-transform: capitalize;\n}\n@media (max-width: 991.98px) {\n  .section-header-sixteen h2 {\n    font-size: 34px;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-header-sixteen h2 {\n    font-size: 28px;\n  }\n}\n\n.discover-slider .owl-dots,\n.treatment-sixteen-slider .owl-dots,\n.features-slider-sixteen .owl-dots {\n  text-align: center;\n  margin-top: 60px;\n}\n.discover-slider .owl-dots .owl-dot,\n.treatment-sixteen-slider .owl-dots .owl-dot,\n.features-slider-sixteen .owl-dots .owl-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 100%;\n  background: #d9d9d9;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);\n  margin-right: 7px;\n}\n.discover-slider .owl-dots .owl-dot.active,\n.treatment-sixteen-slider .owl-dots .owl-dot.active,\n.features-slider-sixteen .owl-dots .owl-dot.active {\n  background: #0e82fd;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);\n}\n\n@keyframes mover {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(-10px);\n  }\n}\n.testi-img {\n  position: relative;\n  margin: 43px 0 15px;\n}\n.testi-img img {\n  padding: 0 43px 0 0;\n}\n.testi-img .testi-icon {\n  width: 86px;\n  height: 86px;\n  background: #0ce0ff;\n  border-radius: 100px;\n  font-size: 16px;\n  color: #ffffff;\n  position: absolute;\n  top: -43px;\n  right: 0;\n}\n\n.testi-users {\n  margin: 0 43px 0 0;\n}\n.testi-users ul {\n  margin: 0;\n  padding: 0;\n}\n.testi-users ul li {\n  display: inline-block;\n  margin: 0 0 0 -23px;\n}\n.testi-users ul li:first-child {\n  margin: 0;\n}\n.testi-users ul li img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);\n  border: 2px solid #ffffff;\n}\n@media (max-width: 767.98px) {\n  .testi-users ul li img {\n    width: 50px;\n    height: 50px;\n  }\n}\n\n.testimonial-wrap {\n  position: relative;\n}\n.testimonial-wrap h4 {\n  margin: 0 0 30px;\n}\n.testimonial-wrap p {\n  margin: 0 0 30px;\n}\n.testimonial-wrap .testimonial-user h6 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 5px;\n}\n.testimonial-wrap .testimonial-user p {\n  font-size: 14px;\n  margin: 0;\n}\n.testimonial-wrap::before {\n  content: \"\";\n  background: url(\"../images/icons/test-line.svg\") no-repeat;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 84px;\n  height: 14px;\n}\n\n.slide-11 button {\n  background: transparent;\n  border: 0;\n  padding: 0;\n}\n.slide-11 button.owl-next {\n  margin: 0 0 0 10px;\n}\n\n.slider.slider-sixteen {\n  position: relative;\n}\n.slider.slider-sixteen .testimonal-contents {\n  text-align: center;\n  background: #ffffff;\n  padding: 20px 0;\n  border-radius: 0px 0px 5px 5px;\n  opacity: 0.3;\n}\n.slider.slider-sixteen .testimonal-contents h5 {\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 500;\n}\n.slider.slider-sixteen .testimonal-contents span {\n  color: #0e82fd;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.005em;\n}\n\n.main-reviewimages {\n  height: auto;\n  width: 100%;\n}\n\n.main-reviewimages img {\n  opacity: 0.3;\n  border-radius: 5px px 0px 0px;\n}\n\n#slide-experts .active.center .main-reviewimages img,\n#slide-experts .active.center .testimonal-contents {\n  opacity: 1;\n}\n\n.test_img {\n  position: relative;\n  opacity: 1;\n  -webkit-transition: 0.4s ease all;\n  transition: 0.4s ease all;\n  margin: 0 -48px;\n  margin-top: 40px;\n}\n\n.slider.slider.slider-sixteen {\n  width: 100%;\n  margin: 0 auto;\n}\n\n#slide-testimonal .center .test_img:before {\n  content: none;\n  transition: 0.7s ease-in-out;\n}\n\n.test_img img {\n  border-radius: 24px;\n  overflow: hidden;\n  margin: 0 auto;\n  height: 100%;\n  object-fit: cover;\n}\n\n.custome_slides.owl-carousel .owl-item.active.center {\n  transform: scale(1);\n  margin-top: 0 !important;\n  position: relative;\n  z-index: 999;\n}\n\n.custome_slides.owl-carousel .owl-item {\n  transform: scale(0.7);\n  padding: 10px 0px;\n  transition: all 0.5s;\n}\n\n.services-section-sixteen .owl-theme .owl-dots .owl-dot span {\n  display: none;\n}\n\n.treatment-section-sixteen .owl-theme .owl-dots .owl-dot span {\n  display: none;\n}\n\n.features-section-sixteen .owl-theme .owl-dots .owl-dot span {\n  display: none;\n}\n\n.testimonal-section-sixteen .owl-carousel .owl-nav {\n  position: absolute;\n  margin-left: -472px;\n  margin-top: 26px;\n}\n\n.full-slide-home {\n  background: #e3e3e3;\n}\n.full-slide-home .slick-prev {\n  left: 30px;\n}\n.full-slide-home .slick-next {\n  right: 30px;\n}\n.full-slide-home .slick-slide .slide-image {\n  width: 100%;\n  min-height: 358px;\n  justify-content: center;\n  flex-direction: column;\n  padding: 70px 50px 70px 100px;\n  vertical-align: middle;\n  background-position: right;\n  background-size: contain;\n}\n.full-slide-home .slick-slide .slide-image h2 {\n  font-size: 36px;\n  font-weight: 500;\n}\n.full-slide-home .slick-slide .slide-image .slide-ul li {\n  color: #757575;\n  font-size: 13px;\n}\n.full-slide-home .slick-slide .slide-image .slide-ul li:before {\n  font-family: \"Font Awesome 5 Free\";\n  display: inline-block;\n  padding-right: 6px;\n  vertical-align: middle;\n  content: \"\\f192\";\n  color: #a2a1a1;\n  font-size: 10px;\n}\n\n.section-search-pharmacy {\n  min-height: inherit !important;\n  background: #ffffff;\n  padding: 40px 0;\n}\n.section-search-pharmacy .banner-wrapper2 {\n  margin: 0 auto;\n  max-width: 680px;\n  width: 100%;\n}\n.section-search-pharmacy .banner-wrapper2 .search-box1 .search-location1 {\n  margin-right: 12px;\n  position: relative;\n  width: 400px;\n  margin-bottom: 0;\n}\n.section-search-pharmacy .banner-wrapper2 .search-box1 .form-control {\n  border: 1px solid #cccccc;\n  box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.08);\n  border-radius: 5px;\n  padding-left: 35px;\n}\n.section-search-pharmacy .banner-wrapper2 .search-box1 .search-detect {\n  padding: 5px 9px 5px 28px;\n  font-size: 13px;\n  color: #757575;\n  border-radius: 5px;\n  background: #e3e3e3 url(../images/google-map.png) no-repeat 9px center;\n  cursor: pointer;\n  position: absolute;\n  top: 8px;\n  right: 5px;\n}\n.section-search-pharmacy .banner-wrapper2 .search-box1 .search-btn {\n  width: 46px;\n  -ms-flex: 0 0 46px;\n  flex: 0 0 46px;\n  height: 46px;\n  margin: 0;\n}\n.section-search-pharmacy .banner-wrapper2 .search-box1 .search-btn span {\n  display: none;\n  font-weight: 500;\n}\n\n.doctor-img1 {\n  margin-right: 20px;\n}\n\n.doc-info-right .clinic-booking a {\n  padding: 10px 15px;\n}\n\n.pharmacy-location,\n.pharmacy-title {\n  color: #2e3842;\n}\n\n.custom-short-by .sort-title {\n  color: #2e3842;\n}\n.custom-short-by > div {\n  margin-right: 20px;\n}\n.custom-short-by > div:first-child {\n  margin-right: 0;\n}\n\n.product-custom span.price {\n  font-size: 20px;\n  font-weight: 500;\n}\n.product-custom span.price-strike {\n  font-weight: 400;\n  text-decoration: line-through;\n  color: #999;\n}\n.product-custom .cart-icon {\n  font-size: 18px;\n  width: 40px;\n  height: 40px;\n  border-radius: 100px;\n  float: right;\n}\n.product-custom .profile-widget:hover .cart-icon {\n  color: #ffffff;\n  background-color: #0de0fe;\n}\n\n.product-description .doctor-img1 {\n  width: 40%;\n}\n.product-description .doc-info-cont {\n  width: 60%;\n}\n\n.clini-infos h2 b.strike {\n  text-decoration: line-through;\n  font-weight: 500;\n}\n\n.feature-product span {\n  padding-bottom: 10px;\n  display: inline-block;\n}\n.feature-product ul li {\n  padding: 3px 0;\n}\n\nul.benifits-col li i {\n  font-size: 20px;\n  margin-right: 20px;\n  color: #20c0f3;\n}\n\n.booking-date li span {\n  text-align: right;\n}\n.booking-date li span a {\n  color: #20c0f3;\n  font-size: 13px;\n  width: 100%;\n  display: inline-block;\n}\n\n.doctor-content {\n  background-color: #ffffff;\n  margin: 0;\n  padding: 140px 0 60px;\n}\n@media (max-width: 991.98px) {\n  .doctor-content {\n    margin: 0;\n    padding: 100px 0 40px;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-content {\n    margin: 0;\n    padding: 100px 0 20px;\n  }\n}\n.doctor-content.content {\n  margin: 0;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .doctor-content.content {\n    margin: 0;\n    padding: 40px 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .doctor-content.content {\n    margin: 0;\n    padding: 20px 0;\n  }\n}\n\n.back-link {\n  padding-bottom: 30px;\n}\n.back-link a {\n  font-size: 15px;\n  color: #959595;\n}\n.back-link a:hover {\n  color: #09e5ab;\n}\n.back-link a i {\n  margin-right: 10px;\n}\n@media (max-width: 767.98px) {\n  .back-link {\n    padding-bottom: 25px;\n  }\n}\n\n.paitent-header {\n  padding-bottom: 40px;\n}\n.paitent-header .paitent-title {\n  font-size: 22px;\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .paitent-header .paitent-title {\n    font-size: 20px;\n  }\n}\n@media (max-width: 767.98px) {\n  .paitent-header .paitent-title {\n    font-size: 18px;\n  }\n}\n@media (max-width: 991.98px) {\n  .paitent-header {\n    padding-bottom: 30px;\n  }\n}\n@media (max-width: 767.98px) {\n  .paitent-header {\n    padding-bottom: 20px;\n  }\n}\n\n.booking-header {\n  padding-bottom: 25px;\n}\n.booking-header .booking-title {\n  font-weight: 500;\n  font-size: 18px;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .booking-header {\n    padding-bottom: 20px;\n  }\n}\n\n.payment-form-group {\n  margin-bottom: 10px;\n}\n\n.payments-form .custom_radio {\n  font-weight: 500;\n  color: #000000;\n  padding-left: 26px;\n  margin-bottom: 0;\n}\n.payments-form .custom_radio input:checked ~ .checkmark {\n  border: 5px solid #0e82fd;\n}\n.payments-form .custom_radio .checkmark {\n  top: inherit;\n  border: 2px solid #9a9a9a;\n}\n.payments-form .custom_radio .checkmark:after {\n  top: -1px;\n  left: -1px;\n  background: #ffffff;\n  width: 0;\n  height: 0;\n}\n\n.card-label > label {\n  background-color: #ffffff;\n  color: #ababab;\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 500;\n  margin: 6px auto auto 8px;\n  padding: 0 7px;\n}\n.card-label > .form-control {\n  margin: -13px 0 0;\n  padding: 6px 15px 0;\n  min-height: 48px;\n}\n.card-label > .form-control::placeholder {\n  font-weight: 500;\n  color: #3c4758;\n}\n\n.booking-btn .btn {\n  min-width: 123px;\n  font-weight: 500;\n  margin: 0;\n  padding: 8px 10px;\n  border-radius: 5px;\n}\n.booking-btn .btn i {\n  font-size: 18px;\n  color: #ffffff;\n  position: relative;\n  left: 8px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.booking-btn .btn:hover i {\n  color: #0e82fd;\n  left: 12px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n@media (max-width: 767.98px) {\n  .booking-btn .btn {\n    min-width: 100px;\n    margin: 0;\n    padding: 7px 10px;\n  }\n}\n@media (max-width: 991.98px) {\n  .booking-btn {\n    padding-bottom: 25px;\n  }\n}\n\n.booking-card {\n  border: 2px solid #f4f4f4;\n  border-radius: 8px;\n  margin-bottom: 25px;\n}\n.booking-card .booking-card-body {\n  padding: 15px;\n}\n@media (max-width: 991.98px) {\n  .booking-card {\n    margin-bottom: 20px;\n  }\n}\n\n.booking-doctor-img {\n  width: 45px;\n  height: 45px;\n  margin-right: 15px;\n  border-radius: 50%;\n}\n.booking-doctor-img img {\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n}\n\n.booking-doctor-info h4 {\n  font-weight: 500;\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n.booking-doctor-info h4 a:hover {\n  color: #0e82fd;\n}\n.booking-doctor-info p {\n  color: #888888;\n  margin-bottom: 0;\n}\n\n.booking-doctor-right p {\n  margin-bottom: 0;\n}\n.booking-doctor-right i {\n  margin-right: 18px;\n  font-size: 20px;\n  color: #28a745;\n}\n.booking-doctor-right a {\n  font-weight: 500;\n  text-decoration: underline;\n  color: #0e82fd;\n}\n.booking-doctor-right a:hover {\n  color: #000000;\n}\n\n.booking-list-body {\n  padding-bottom: 5px !important;\n}\n.booking-list-body .booking-doctor-right {\n  padding-bottom: 10px;\n}\n\n.booking-date-list {\n  width: 300px;\n}\n.booking-date-list ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.booking-date-list ul li {\n  font-weight: 500;\n  color: #494949;\n  padding-bottom: 10px;\n}\n.booking-date-list ul li span {\n  font-weight: normal;\n  color: #777777;\n  float: right;\n  text-align: right;\n}\n.booking-date-list ul li span i {\n  font-size: 16px;\n  margin-right: 6px;\n}\n@media (max-width: 1399.98px) {\n  .booking-date-list {\n    width: 265px;\n  }\n}\n.booking-date-list.consultation-date-list {\n  width: 100%;\n}\n\n.proceed-btn {\n  text-align: right;\n}\n.proceed-btn .btn {\n  margin: 0;\n  padding: 8px 15px;\n  min-width: 209px;\n}\n@media (max-width: 767.98px) {\n  .proceed-btn .btn {\n    min-width: 200px;\n  }\n}\n@media (max-width: 991.98px) {\n  .proceed-btn {\n    padding-bottom: 0;\n  }\n}\n\n.custom_radio {\n  color: #8d8d8d;\n  position: relative;\n  font-size: 14px;\n  padding-left: 30px;\n  margin-bottom: 10px;\n  cursor: pointer;\n  user-select: none;\n}\n.custom_radio input {\n  position: absolute;\n  opacity: 0;\n}\n.custom_radio input:checked ~ .checkmark {\n  border: 1px solid #0e82fd;\n}\n.custom_radio input:checked ~ .checkmark:after {\n  transform: scale(1);\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  opacity: 1;\n  visibility: visible;\n}\n.custom_radio .checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  background-color: #ffffff;\n  border: 1px solid #aeaeb2;\n  border-radius: 50%;\n  -webkit-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n.custom_radio .checkmark:after {\n  display: block;\n  content: \"\";\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  opacity: 0;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: #0e82fd;\n  visibility: hidden;\n  transform: scale(0.1);\n  -webkit-transform: scale(0.1);\n  -ms-transform: scale(0.1);\n  -webkit-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\n.radio_input .custom_radio + .custom_radio {\n  margin-left: 15px;\n}\n\n.pricing-section {\n  background-color: #ffffff;\n  margin: 0;\n  padding: 80px 0 55px;\n}\n@media (max-width: 991.98px) {\n  .pricing-section {\n    margin: 0;\n    padding: 40px 0 15px;\n  }\n}\n@media (max-width: 767.98px) {\n  .pricing-section {\n    margin: 0;\n    padding: 40px 0 20px;\n  }\n}\n\n.pricing-inner-header {\n  margin-bottom: 80px;\n}\n@media (max-width: 991.98px) {\n  .pricing-inner-header {\n    margin-bottom: 40px;\n  }\n}\n\n.plan-choose-info {\n  padding-top: 15px;\n}\n.plan-choose-info label {\n  margin-bottom: 0;\n}\n.plan-choose-info .monthly-plan {\n  color: #0a0b0d;\n}\n.plan-choose-info .yearly-plan {\n  color: #6b7280;\n}\n.plan-choose-info .status-toggle {\n  margin: 0 20px;\n  padding: 0;\n}\n.plan-choose-info .checktoggle {\n  background-color: #0e82fd;\n  border: 1px solid #0e82fd;\n}\n.plan-choose-info .check:checked + .checktoggle {\n  background-color: #ffffff;\n  border: 1px solid #0e82fd;\n}\n.plan-choose-info .check:checked + .checktoggle:after {\n  background-color: #0e82fd;\n}\n.plan-choose-info .monthly-plan,\n.plan-choose-info .yearly-plan {\n  font-weight: 500;\n  font-size: 18px;\n}\n@media (max-width: 767.98px) {\n  .plan-choose-info .monthly-plan,\n  .plan-choose-info .yearly-plan {\n    font-size: 16px;\n  }\n}\n\n.pricing-card {\n  background: #f2f6f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 24px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card:hover {\n  background: #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card:hover .pricing-icon span {\n  background: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n  transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n}\n.pricing-card:hover .pricing-icon span img {\n  transform: rotate(-90deg);\n  -webkit-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card:hover .pricing-title p {\n  color: #eff0f7;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card:hover .pricing-title h4 {\n  color: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card:hover .pricing-header-text p {\n  color: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card:hover .pricing-amount h2 {\n  color: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card:hover .pricing-amount h2 span {\n  color: #d9dbe9;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card:hover .pricing-amount h6 {\n  color: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card:hover .pricing-list ul li {\n  color: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card:hover .pricing-list ul li:before {\n  color: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card:hover .pricing-btn .btn {\n  color: #ffffff;\n  border: 1px solid #3b9cf6;\n  box-shadow: inset 0 0 0 50px #3b9cf6;\n}\n.pricing-card .card-body {\n  margin: 0;\n  padding: 30px;\n}\n@media (max-width: 991.98px) {\n  .pricing-card .card-body {\n    margin: 0;\n    padding: 20px;\n  }\n}\n@media (max-width: 767.98px) {\n  .pricing-card .card-body {\n    margin: 0;\n    padding: 15px;\n  }\n}\n\n.pricing-card-active {\n  background: #0e82fd;\n}\n.pricing-card-active .pricing-icon span {\n  background: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n  transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n}\n.pricing-card-active .pricing-icon span img {\n  transform: rotate(-90deg);\n  -webkit-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card-active .pricing-title p {\n  color: #eff0f7;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card-active .pricing-title h4 {\n  color: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card-active .pricing-tag {\n  margin-left: auto;\n}\n.pricing-card-active .pricing-tag span {\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n  font-weight: 500;\n  border-radius: 10px;\n  padding: 12px 13px;\n}\n.pricing-card-active .pricing-header-text p {\n  color: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card-active .pricing-amount h2 {\n  color: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card-active .pricing-amount h2 span {\n  color: #d9dbe9;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card-active .pricing-amount h6 {\n  color: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card-active .pricing-list ul li {\n  color: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card-active .pricing-list ul li:before {\n  color: #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-card-active .pricing-btn .btn {\n  color: #ffffff;\n  border: 1px solid #3b9cf6;\n  box-shadow: inset 0 0 0 50px #3b9cf6;\n}\n\n.pricing-header {\n  padding-bottom: 15px;\n}\n\n.pricing-header-info {\n  padding-bottom: 15px;\n}\n\n.pricing-icon {\n  margin-right: 15px;\n}\n.pricing-icon span {\n  min-width: 70px;\n  height: 70px;\n  background: #ffffff;\n  border-radius: 16px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n  transform: rotate(0);\n  -webkit-transform: rotate(0);\n  -ms-transform: rotate(0);\n}\n.pricing-icon span img {\n  transform: rotate(0);\n  -webkit-transform: rotate(0);\n  -ms-transform: rotate(0);\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n\n.pricing-title p {\n  font-weight: 500;\n  font-size: 16px;\n  color: #6b7280;\n  margin-bottom: 0;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n@media (max-width: 767.98px) {\n  .pricing-title p {\n    font-size: 15px;\n  }\n}\n.pricing-title h4 {\n  font-size: 24px;\n  color: #1f2937;\n  margin-bottom: 0;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n@media (max-width: 767.98px) {\n  .pricing-title h4 {\n    font-size: 20px;\n  }\n}\n\n.pricing-header-text p {\n  color: #6b7280;\n  margin-bottom: 0;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n\n.pricing-amount {\n  padding-bottom: 20px;\n}\n.pricing-amount h2 {\n  font-weight: 700;\n  font-size: 30px;\n  color: #1f2937;\n  margin-bottom: 8px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-amount h2 span {\n  font-weight: 400;\n  font-size: 14px;\n  color: #9ca3af;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n@media (max-width: 991.98px) {\n  .pricing-amount h2 {\n    font-size: 40px;\n  }\n}\n@media (max-width: 767.98px) {\n  .pricing-amount h2 {\n    font-size: 30px;\n  }\n}\n.pricing-amount h6 {\n  font-weight: 500;\n  font-size: 20px;\n  color: #1f2937;\n  margin-bottom: 0;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n@media (max-width: 767.98px) {\n  .pricing-amount h6 {\n    font-size: 16px;\n  }\n}\n\n.pricing-list {\n  padding-bottom: 50px;\n}\n.pricing-list ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.pricing-list ul li {\n  position: relative;\n  font-size: 16px;\n  color: #6b7280;\n  padding-left: 25px;\n  margin-bottom: 10px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.pricing-list ul li:last-child {\n  margin-bottom: 0;\n}\n.pricing-list ul li:before {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  content: \"\\f058\";\n  font-family: \"Font Awesome 5 Free\";\n  font-size: 16px;\n  font-weight: 900;\n  color: #0e82fd;\n  border: 0;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n@media (max-width: 767.98px) {\n  .pricing-list ul li {\n    font-size: 14px;\n  }\n}\n@media (max-width: 991.98px) {\n  .pricing-list {\n    padding-bottom: 30px;\n  }\n}\n@media (max-width: 767.98px) {\n  .pricing-list {\n    padding-bottom: 20px;\n  }\n}\n\n.pricing-btn {\n  text-align: center;\n}\n.pricing-btn .btn {\n  font-weight: 600;\n  font-size: 14px;\n  margin: 0;\n  padding: 11px 15px;\n  min-width: 100%;\n  display: inline-block;\n  color: #ffffff;\n  border: 1px solid #0e82fd;\n  background: #0e82fd;\n}\n@media (max-width: 767.98px) {\n  .pricing-btn .btn {\n    margin: 0;\n    padding: 8px 15px;\n    font-size: 14px;\n  }\n}\n\n.breadcrumb-bar-two {\n  background: #f2f6f6;\n  background-repeat: no-repeat;\n  padding-top: 70px;\n  min-height: 300px;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n.breadcrumb-bar-two .inner-banner {\n  margin: 0;\n  padding: 70px 0;\n}\n.breadcrumb-bar-two .inner-banner .breadcrumb-title {\n  font-weight: 600;\n  font-size: 48px;\n  margin-bottom: 6px;\n}\n@media (max-width: 991.98px) {\n  .breadcrumb-bar-two .inner-banner .breadcrumb-title {\n    font-size: 36px;\n  }\n}\n@media (max-width: 767.98px) {\n  .breadcrumb-bar-two .inner-banner .breadcrumb-title {\n    font-size: 26px;\n  }\n}\n@media (max-width: 767.98px) {\n  .breadcrumb-bar-two .inner-banner {\n    margin: 0;\n    padding: 50px 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .breadcrumb-bar-two {\n    padding-top: 40px;\n    min-height: 260px;\n  }\n}\n@media (max-width: 767.98px) {\n  .breadcrumb-bar-two {\n    min-height: auto;\n  }\n}\n.breadcrumb-bar-two .page-breadcrumb ol {\n  background-color: transparent;\n  font-weight: 500;\n  margin: 0;\n  padding: 0;\n}\n.breadcrumb-bar-two .page-breadcrumb ol li a {\n  font-weight: 500;\n  color: #4b5563;\n}\n.breadcrumb-bar-two .page-breadcrumb ol li.active {\n  color: #1f2937;\n}\n@media (max-width: 767.98px) {\n  .breadcrumb-bar-two .page-breadcrumb ol {\n    font-size: 15px;\n  }\n}\n.breadcrumb-bar-two .page-breadcrumb .breadcrumb a:hover {\n  color: #0e82fd;\n}\n.breadcrumb-bar-two .page-breadcrumb .breadcrumb-item + .breadcrumb-item {\n  font-weight: 500;\n  color: #1f2937;\n  padding-left: 10px;\n}\n.breadcrumb-bar-two .breadcrumb-item + .breadcrumb-item::before {\n  content: \"/\";\n  font-family: \"feather\";\n  float: left;\n  padding-right: 10px;\n  color: #9ca3af;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.about-section {\n  background-color: #ffffff;\n  margin: 0;\n  padding: 80px 0;\n}\n.about-section .about-img-info {\n  padding-right: 30px;\n}\n.about-section .about-img-info .about-img {\n  border-radius: 8px;\n  margin-bottom: 25px;\n}\n.about-section .about-img-info .about-img:last-child {\n  margin-bottom: 0;\n}\n.about-section .about-img-info .about-img img {\n  border-radius: 8px;\n}\n.about-section .about-img-info .about-box {\n  background: #0e82fd;\n  border-radius: 8px;\n  margin: 15px 0 25px;\n  padding: 45px 10px;\n  text-align: center;\n}\n.about-section .about-img-info .about-box h4 {\n  font-weight: 600;\n  font-size: 20px;\n  color: #ffffff;\n  max-width: 208px;\n  margin: 0 auto 0;\n  padding: 0;\n}\n@media (max-width: 991.98px) {\n  .about-section .about-img-info {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .about-section {\n    margin: 0;\n    padding: 40px 0;\n  }\n}\n\n.section-inner-header {\n  margin-bottom: 40px;\n}\n.section-inner-header h6 {\n  font-weight: 500;\n  font-size: 16px;\n  color: #0e82fd;\n  margin-bottom: 15px;\n}\n@media (max-width: 767.98px) {\n  .section-inner-header h6 {\n    margin-bottom: 10px;\n  }\n}\n.section-inner-header h2 {\n  font-weight: 600;\n  font-size: 40px;\n  color: #1f2937;\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .section-inner-header h2 {\n    font-size: 32px;\n    max-width: inherit;\n  }\n}\n@media (max-width: 767.98px) {\n  .section-inner-header h2 {\n    font-size: 22px;\n  }\n}\n@media (max-width: 991.98px) {\n  .section-inner-header {\n    margin-bottom: 40px;\n  }\n}\n\n.about-inner-header {\n  margin-bottom: 30px;\n}\n@media (max-width: 767.98px) {\n  .about-inner-header {\n    margin-bottom: 20px;\n  }\n}\n\n.about-content-details {\n  padding-bottom: 25px;\n}\n.about-content-details p {\n  font-size: 16px;\n  color: #6b7280;\n  margin-bottom: 25px;\n}\n.about-content-details p:last-child {\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .about-content-details p {\n    font-size: 15px;\n    margin-bottom: 20px;\n  }\n}\n\n.about-contact-icon {\n  margin-right: 15px;\n}\n.about-contact-icon span {\n  width: 47px;\n  height: 47px;\n  border-radius: 50px;\n  color: #ffffff;\n  background: #0e82fd;\n}\n\n.about-contact-text p {\n  font-weight: 500;\n  font-size: 16px;\n  color: #6b7280;\n  margin-bottom: 5px;\n}\n@media (max-width: 767.98px) {\n  .about-contact-text p {\n    font-size: 14px;\n  }\n}\n.about-contact-text h4 {\n  color: #27272a;\n  font-weight: 600;\n  font-size: 20px;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .about-contact-text h4 {\n    font-size: 18px;\n  }\n}\n\n.why-choose-section {\n  background-color: #ffffff;\n  margin: 0;\n  padding: 0 0 55px;\n}\n@media (max-width: 991.98px) {\n  .why-choose-section {\n    margin: 0;\n    padding: 20px 0 15px;\n  }\n}\n@media (max-width: 767.98px) {\n  .why-choose-section {\n    margin: 0;\n    padding: 0 0 20px;\n  }\n}\n\n.why-choose-card {\n  border: 1px solid #f3f4f6;\n  border-radius: 8px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.why-choose-card:hover {\n  box-shadow: 0px 0px 111px rgba(0, 0, 0, 0.09);\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.why-choose-card:hover .why-choose-icon span img {\n  transform: rotateY(360deg);\n  -webkit-transform: rotateY(360deg);\n  -ms-transform: rotateY(360deg);\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.why-choose-card .card-body {\n  margin: 0;\n  padding: 25px;\n}\n@media (max-width: 991.98px) {\n  .why-choose-card .card-body {\n    margin: 0;\n    padding: 20px;\n  }\n}\n@media (max-width: 767.98px) {\n  .why-choose-card .card-body {\n    margin: 0;\n    padding: 15px;\n  }\n}\n\n.why-choose-icon {\n  padding-bottom: 24px;\n}\n.why-choose-icon span {\n  width: 80px;\n  height: 80px;\n  border-radius: 50px;\n  color: #ffffff;\n  background: #0e82fd;\n}\n.why-choose-icon span img {\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n@media (max-width: 767.98px) {\n  .why-choose-icon {\n    padding-bottom: 20px;\n  }\n}\n\n.why-choose-content h4 {\n  font-weight: 500;\n  font-size: 20px;\n  margin-bottom: 12px;\n}\n.why-choose-content p {\n  font-size: 16px;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .why-choose-content p {\n    font-size: 14px;\n  }\n}\n\n.way-section {\n  background-color: #ffffff;\n  margin: 0;\n  padding: 0 0 80px;\n}\n.way-section .way-bg {\n  background: #0e82fd;\n  border-radius: 25px;\n  position: relative;\n  overflow: hidden;\n}\n.way-section .way-bg .way-shapes-img {\n  position: relative;\n}\n.way-section .way-bg .way-shapes-img .way-shapes-left {\n  position: absolute;\n  top: 60px;\n  right: 200px;\n}\n.way-section .way-bg .way-shapes-img .way-shapes-right {\n  position: absolute;\n  right: 0;\n}\n@media (max-width: 991.98px) {\n  .way-section .way-bg .way-shapes-img {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .way-section .way-bg {\n    border-radius: 10px;\n  }\n}\n@media (max-width: 991.98px) {\n  .way-section {\n    margin: 0;\n    padding: 0 0 40px;\n  }\n}\n\n.way-inner-header {\n  margin: 0;\n  padding: 60px;\n}\n.way-inner-header h2 {\n  color: #ffffff;\n  margin-bottom: 29px;\n}\n.way-inner-header p {\n  font-weight: 500;\n  font-size: 16px;\n  color: #ffffff;\n  margin-bottom: 40px;\n}\n@media (max-width: 767.98px) {\n  .way-inner-header p {\n    margin-bottom: 15px;\n  }\n}\n.way-inner-header .btn {\n  font-weight: 600;\n  font-size: 15px;\n  padding: 11px 16px;\n  color: #3b9cf6;\n  background: #ffffff;\n  border: 1px solid #ffffff;\n  border-radius: 8px;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n}\n.way-inner-header .btn:hover {\n  color: #ffffff;\n  border: 1px solid #ffffff;\n  background: #0e82fd;\n  box-shadow: inset 0 0 0 50px #0e82fd;\n}\n@media (max-width: 767.98px) {\n  .way-inner-header .btn {\n    font-size: 14px;\n    margin: 0;\n    padding: 10px 15px;\n  }\n}\n@media (max-width: 991.98px) {\n  .way-inner-header {\n    margin: 0;\n    padding: 30px;\n  }\n}\n@media (max-width: 767.98px) {\n  .way-inner-header {\n    margin: 0;\n    padding: 20px;\n  }\n}\n\n.way-img {\n  position: relative;\n  top: 10px;\n}\n@media (max-width: 991.98px) {\n  .way-img {\n    display: none;\n  }\n}\n\n.professional-section {\n  margin: 0;\n  padding: 0 0 55px;\n  background: #ffffff;\n}\n.professional-section .doctor-profile-widget {\n  margin-bottom: 25px;\n}\n@media (max-width: 767.98px) {\n  .professional-section .doctor-profile-widget {\n    margin-bottom: 20px;\n  }\n}\n@media (max-width: 991.98px) {\n  .professional-section {\n    margin: 0;\n    padding: 0 0 15px;\n  }\n}\n@media (max-width: 767.98px) {\n  .professional-section {\n    margin: 0;\n    padding: 0 0 20px;\n  }\n}\n\n.testimonial-section {\n  background: #f2f6f6;\n  margin: 0;\n  padding: 80px 0;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n.testimonial-section::after {\n  content: \"\";\n  background: url(../images/bg/doctor-shape-img1.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: left;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 213px;\n  height: 335px;\n  opacity: 0.5;\n  z-index: -1;\n}\n@media (max-width: 991.98px) {\n  .testimonial-section::after {\n    display: none;\n  }\n}\n.testimonial-section::before {\n  content: \"\";\n  background: url(../images/bg/doctor-shape-img2.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: right;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  opacity: 0.5;\n  width: 213px;\n  height: 335px;\n  z-index: -1;\n}\n@media (max-width: 991.98px) {\n  .testimonial-section::before {\n    display: none;\n  }\n}\n.testimonial-section .testimonial-shape-img {\n  position: relative;\n}\n.testimonial-section .testimonial-shape-img .testimonial-shape-left {\n  position: absolute;\n  top: -30px;\n  left: -40px;\n  -webkit-animation-name: blinker;\n  -webkit-animation-duration: 0.6s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: ease-in-out;\n  -webkit-animation-direction: alternate;\n}\n.testimonial-section .testimonial-shape-img .testimonial-shape-left img {\n  width: 100px;\n}\n.testimonial-section .testimonial-shape-img .testimonial-shape-right {\n  position: absolute;\n  top: 60px;\n  right: 0;\n  -webkit-animation-name: blinker;\n  -webkit-animation-duration: 0.6s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: ease-in-out;\n  -webkit-animation-direction: alternate;\n}\n.testimonial-section .testimonial-shape-img .testimonial-shape-right img {\n  width: 100px;\n}\n@media (max-width: 991.98px) {\n  .testimonial-section .testimonial-shape-img {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .testimonial-section {\n    margin: 0;\n    padding: 40px 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .testimonial-info {\n    flex-direction: column;\n  }\n}\n\n.testimonial-img {\n  border-radius: 50%;\n  margin-right: 50px;\n  width: 220px;\n  -ms-flex: 0 0 220px;\n  flex: 0 0 220px;\n}\n@media (max-width: 767.98px) {\n  .testimonial-img {\n    margin: 0 0 30px 0;\n    padding: 0;\n    width: 200px;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n  }\n}\n.testimonial-img img {\n  border-radius: 50%;\n  width: 100%;\n}\n\n.testimonial-header {\n  margin-bottom: 25px;\n}\n\n.testimonial-details p {\n  font-size: 16px;\n  margin-bottom: 15px;\n}\n@media (max-width: 767.98px) {\n  .testimonial-details p {\n    font-size: 14px;\n  }\n}\n.testimonial-details h6 {\n  font-weight: normal;\n  font-size: 14px;\n  margin-bottom: 0;\n  color: #9ca3af;\n}\n.testimonial-details h6 span {\n  font-weight: 500;\n  font-size: 16px;\n  color: #1f2937;\n}\n\n.testimonial-grid {\n  margin: 0;\n  padding: 0 60px;\n}\n@media (max-width: 767.98px) {\n  .testimonial-grid {\n    margin: 0;\n    padding: 0 25px;\n  }\n}\n\n.testimonial-slider .slick-prev,\n.testimonial-slider .slick-next {\n  width: 44px;\n  height: 44px;\n  font-size: 0;\n  color: #1e3259;\n  background: #ffffff;\n  box-shadow: 0px 4px 14px rgba(141, 141, 141, 0.25);\n}\n.testimonial-slider .slick-prev:hover,\n.testimonial-slider .slick-next:hover {\n  color: #ffffff;\n  background: #0e82fd;\n}\n.testimonial-slider .slick-prev:focus,\n.testimonial-slider .slick-next:focus {\n  color: #ffffff;\n  background: #0e82fd;\n  opacity: 1;\n}\n.testimonial-slider .slick-prev:before {\n  font-family: \"Font Awesome 5 Free\";\n  content: \"\\f053\";\n  font-size: 16px;\n  font-weight: 900;\n}\n.testimonial-slider .slick-next:before {\n  font-family: \"Font Awesome 5 Free\";\n  content: \"\\f054\";\n  font-size: 16px;\n  font-weight: 900;\n}\n\n.faq-section-inner {\n  margin: 0;\n  padding: 80px 0 80px;\n}\n@media (max-width: 1199.98px) {\n  .faq-section-inner {\n    margin: 0;\n    padding: 80px 0 80px;\n  }\n}\n@media (max-width: 991.98px) {\n  .faq-section-inner {\n    margin: 0;\n    padding: 40px 0;\n  }\n}\n\n.faq-inner-page {\n  background-color: #ffffff;\n  margin: 0;\n  padding: 80px 0 55px;\n}\n\n.faq-inner-info .accordion-item {\n  margin-bottom: 25px;\n}\n.faq-inner-info .accordion-item:last-child {\n  margin-bottom: 25px;\n}\n\n.onboard-page {\n  overflow: hidden;\n}\n\n.right-panel-title {\n  background: #0c4f8a;\n  padding: 10px;\n  display: none;\n}\n\n.onboard-wrapper {\n  overflow: hidden;\n  height: 100vh;\n  background: #ffffff;\n}\n\n.left-panel {\n  background-color: #0c4f8a;\n  width: 25%;\n  padding: 45px;\n  height: 100vh;\n  overflow: auto;\n  flex-direction: column;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.left-panel::-webkit-scrollbar {\n  display: none;\n}\n@media (max-width: 991.98px) {\n  .left-panel {\n    display: none;\n  }\n}\n\n.right-panel {\n  width: 75%;\n  height: 100vh;\n  overflow: auto;\n  align-items: center;\n  justify-content: center;\n  padding: 0 15px;\n  flex-wrap: wrap;\n}\n.right-panel .select2-container .select2-selection--single {\n  border: 1px solid #e6e9f4;\n  height: 54px;\n  background: #f5f6fa;\n}\n.right-panel .select2-container .select2-selection--single:focus {\n  border-color: #09e5ab;\n  background-color: #ffffff;\n}\n.right-panel .select2-container--default .select2-selection--single .select2-selection__rendered {\n  font-size: 14px;\n  font-weight: 400;\n  font-weight: normal;\n  line-height: 54px;\n  color: #585858;\n}\n.right-panel .select2-container--default .select2-selection--single .select2-selection__arrow {\n  height: 54px;\n  right: 7px;\n}\n.right-panel .accordion-item:first-of-type {\n  margin-bottom: 16px;\n  border-radius: 6px;\n  overflow: hidden;\n}\n.right-panel .accordion-item:not(:first-of-type) {\n  border-top: 1px solid rgba(0, 0, 0, 0.125);\n  margin-bottom: 16px;\n  border-radius: 6px;\n  overflow: hidden;\n}\n.right-panel .accordion-button {\n  padding: 20px;\n}\n.right-panel .accordion-button::after {\n  transform: rotate(-90deg);\n}\n.right-panel .accordion-button:not(.collapsed)::after {\n  transform: rotate(0deg);\n}\n.right-panel .accordion-button:focus {\n  box-shadow: 8px 7px 14px -15px rgba(0, 0, 0, 0.4);\n}\n.right-panel .accordion-button:not(.collapsed) {\n  background-color: #ffffff;\n  color: #000000;\n}\n.right-panel .accordion-body {\n  padding: 1rem 1rem;\n}\n@media (max-width: 991.98px) {\n  .right-panel {\n    width: 100%;\n    height: auto;\n    padding: 0px;\n  }\n}\n\n.onboard-img {\n  margin: auto;\n  padding: 70px 0px 20px 0px;\n  animation: mymove 1s ease-in-out infinite alternate;\n  text-align: center;\n  width: 240px;\n}\n\n.onboard-content h3 {\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 21px;\n}\n.onboard-content p {\n  color: #ffffff;\n  font-weight: 200;\n  font-size: 13px;\n}\n\n.onboarding-slider {\n  margin-top: 10px;\n}\n\n#onboard-slider .owl-dots {\n  margin-top: 0px;\n  justify-content: center;\n}\n#onboard-slider .owl-nav {\n  display: none;\n}\n#onboard-slider.owl-theme .owl-dots .owl-dot span {\n  background-color: #09e5ab;\n  width: 15px;\n  height: 6px;\n  border-radius: 50px;\n  transition: 0.5s all;\n  margin: 5px 3px 0;\n  display: block;\n  position: relative;\n}\n#onboard-slider.owl-theme .owl-dots .owl-dot.active span {\n  background-color: #ffffff;\n  width: 50px;\n  border-radius: 50px;\n}\n\n.on-board-wizard {\n  position: sticky;\n  top: 65px;\n}\n.on-board-wizard ul {\n  list-style: none;\n  padding: 0px;\n}\n.on-board-wizard ul li a {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #f4f4f4;\n  box-shadow: 0px 4px 4px rgba(212, 237, 255, 0.25);\n  border-radius: 4px;\n  margin: 0 0 18px 0;\n  padding: 13px 5px 13px 8px;\n  transition: 0.1s ease-out;\n}\n.on-board-wizard ul li a:hover {\n  box-shadow: 8px 7px 14px -15px rgba(0, 0, 0, 0.4);\n}\n\n.onboarding-list h6 {\n  font-weight: 600;\n  font-size: 16px;\n  color: #000000;\n}\n.onboarding-list p {\n  font-weight: 300;\n  font-size: 13px;\n  color: #585858;\n  margin-bottom: 0px;\n}\n\nli:hover .onboarding-list h6 {\n  color: #000000;\n}\n\n.onboarding-progress {\n  margin-right: 20px;\n  min-width: 35px;\n  height: 35px;\n  background: #f4f4f4;\n  border-radius: 50px;\n  justify-content: center;\n  align-items: center;\n  color: #000000;\n}\n.onboarding-progress.active {\n  background: #10916f;\n  color: #ffffff;\n}\n.onboarding-progress span {\n  font-size: 13px;\n}\n\n.onboarding-title h2 {\n  font-weight: 500;\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n.onboarding-title h2 span {\n  color: #ff0202;\n}\n.onboarding-title h6 {\n  font-weight: 400;\n  font-size: 15px;\n  color: #585858;\n  margin-bottom: 25px;\n  line-height: 1.5;\n}\n.onboarding-title h6 span {\n  font-weight: 600;\n}\n.onboarding-title.profile-title {\n  margin-bottom: 35px;\n}\n.onboarding-title.pass-title {\n  margin-bottom: 32px;\n}\n\n.onboarding-content-box {\n  margin-top: 20px;\n  margin: 20px 0 0 0;\n  padding: 50px;\n  background: #ffffff;\n  box-shadow: 0px 24px 24px rgba(212, 237, 255, 0.3);\n  border-radius: 4px;\n  border: 1px solid #e6e9f4;\n}\n.onboarding-content-box.content-wrap {\n  flex-direction: column;\n  min-height: 580px;\n}\n.onboarding-content-box.lock-box {\n  padding: 70px;\n}\n\n.onboarding-btn a {\n  background: #09e5ab;\n  border-radius: 6px;\n  padding: 15px 50px;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 16px;\n  display: inline-block;\n  border: 1px solid #09e5ab;\n  transition: all 0.5s;\n}\n.onboarding-btn a:hover {\n  box-shadow: inset 0 60px 0 0 #10916f;\n  border-color: #10916f;\n}\n.onboarding-btn.Personalize-btn {\n  margin-top: 30px;\n}\n.onboarding-btn.Consultation-btn {\n  margin-top: 70px;\n}\n.onboarding-btn.Consultation-btn a:nth-child(2) {\n  background: #ffffff;\n  border-radius: 6px;\n  padding: 15px 50px;\n  color: #0c4f8a;\n  border: none;\n}\n.onboarding-btn.Consultation-btn a:nth-child(2):hover {\n  box-shadow: none;\n  color: #09e5ab;\n}\n.onboarding-btn.Consultation-btn.cost-btns {\n  margin-top: 40px;\n}\n.onboarding-btn.prefer-btn {\n  margin-top: 70px;\n}\n.onboarding-btn.pop-btn {\n  margin-top: 4px;\n}\n\n.passcode-wrap input,\n.passcode-wrap select,\n.passcode-wrap textarea {\n  background-color: #f5f6fa;\n  border: 1px solid #e6e9f4;\n  border-radius: 5px;\n  width: 60px;\n  height: 54px;\n  text-align: center;\n  color: #354052;\n  font-size: 20px;\n  font-weight: 500;\n  margin-right: 23px;\n}\n\n.passcode-wrap input:focus {\n  color: #354052;\n  border-color: #09e5ab;\n  background-color: #ffffff;\n  outline: none;\n}\n.passcode-wrap.mail-box input {\n  width: 100%;\n  text-align: unset;\n  font-size: 14px;\n  height: 54px;\n}\n.passcode-wrap.mail-box select {\n  width: 100%;\n  text-align: unset;\n  font-size: 14px;\n  font-weight: 400;\n  border: 1px solid #e6e9f4 !important;\n  outline: none;\n  color: #585858;\n  padding: 0px 10px;\n}\n.passcode-wrap.mail-box textarea {\n  width: 100%;\n  height: 145px;\n  text-align: unset;\n  font-size: 14px;\n  font-weight: 400;\n  border: 1px solid #e6e9f4;\n  outline: none;\n  resize: none;\n}\n.passcode-wrap select:focus {\n  color: #354052;\n  border-color: #09e5ab !important;\n  background-color: #ffffff;\n  outline: none;\n}\n.passcode-wrap.form-focus.focused .focus-label {\n  opacity: 1;\n  top: -31px;\n  font-size: 12px;\n  z-index: 1;\n  background: #ffffff;\n  padding: 0px 5px;\n  color: #5ec6cd;\n  font-weight: 400;\n}\n.passcode-wrap.form-focus .focus-label {\n  top: -4px;\n  color: #585858;\n}\n.passcode-wrap textarea:focus {\n  color: #354052;\n  border-color: #09e5ab;\n  background-color: #ffffff;\n  outline: none;\n}\n.passcode-wrap.form-floating > label {\n  color: #585858;\n  font-size: 14px;\n}\n\n.mail-icon {\n  background: url(\"../images/mail-box.png\") no-repeat 99% 50%;\n}\n\n.form-focus .focus-label span {\n  color: #f0142f;\n}\n\n.placeholder-style::placeholder {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 14px;\n  color: #585858;\n  opacity: 1;\n}\n.placeholder-style:-ms-input-placeholder {\n  color: #585858;\n}\n.placeholder-style::-ms-input-placeholder {\n  color: #585858;\n}\n\n.onboarding-lable {\n  font-family: \"Poppins\";\n  font-weight: 500;\n  font-size: 14px;\n}\n.onboarding-lable span {\n  color: #ff0202;\n}\n\n.upload-pic {\n  align-items: center;\n  border-radius: 10px;\n  height: 163px;\n  width: 183px;\n  position: relative;\n  justify-content: center;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px dashed #8f9bba;\n}\n.upload-pic img {\n  max-width: 100%;\n  border-radius: 10px;\n}\n.upload-pic h6 {\n  margin-top: 12px;\n  font-weight: 500;\n  font-size: 16px;\n  color: #8f9bba;\n}\n.upload-pic.patient-photo-upload {\n  align-items: center;\n  border-radius: 10px;\n  justify-content: center;\n  flex-direction: column;\n  overflow: hidden;\n  width: 265px;\n  height: 235px;\n  background: #f5f6fa;\n  border: none;\n}\n\n.upload-pics input[type=\"file\"] {\n  opacity: 0;\n  width: 40px;\n  height: 63px;\n  position: absolute;\n  cursor: pointer;\n  top: -15px;\n  right: 8px;\n  margin-right: 0px;\n}\n\n.photo-norms h5 {\n  color: #8f9bba;\n  font-weight: 400;\n  font-size: 14px;\n  margin-bottom: 35px;\n}\n\n.btn-profile img {\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  top: 11px;\n  right: 8px;\n  cursor: pointer;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.tog-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #f5f6fa;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n.tog-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  bottom: 4px;\n  background-color: #008f64;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  top: 4px;\n  left: 4px;\n}\n.tog-slider.round {\n  border-radius: 30px;\n  width: 56px;\n  height: 28px;\n  border: 2px solid #f3f3f3;\n}\n.tog-slider.round:before {\n  border-radius: 50%;\n}\n\ninput:checked + .tog-slider {\n  background-color: #008f64;\n}\ninput:checked + .tog-slider:before {\n  -webkit-transform: translateX(32px);\n  -ms-transform: translateX(32px);\n  transform: translateX(32px);\n  background: #ffffff;\n  left: -1px;\n}\n\n.save-card {\n  margin-left: 22px;\n}\n.save-card h5 {\n  font-weight: 500;\n  font-size: 14px;\n}\n.save-card h6 {\n  font-weight: 400;\n  font-size: 14px;\n  color: #8f9bba;\n}\n\n.save-detail {\n  padding: 25px 0 0;\n}\n\n.payment-icon {\n  position: relative;\n}\n.payment-icon img {\n  position: absolute;\n  top: 250px;\n}\n\n.avail-content {\n  margin-left: 15px;\n  margin-top: 4px;\n}\n.avail-content h6 {\n  color: #10916f;\n}\n\n.weekDays-selector input {\n  display: none !important;\n}\n.weekDays-selector input[type=\"checkbox\"] + label {\n  display: inline-block;\n  border-radius: 4px;\n  background: #ffffff;\n  padding: 8px 0px;\n  width: 60px;\n  margin-right: 3px;\n  line-height: 40px;\n  text-align: center;\n  cursor: pointer;\n  border: 1px solid #e6e9f4;\n  font-weight: 400;\n  font-size: 20px;\n}\n.weekDays-selector input[type=\"checkbox\"]:checked + label {\n  background: #f5f6fa;\n  color: #000000;\n}\n\n.consult-option {\n  position: relative;\n}\n\n.call-option {\n  position: relative;\n  width: 33%;\n  margin-right: 10px;\n}\n.call-option.file-option {\n  margin-right: 0px;\n  background: #f5f6fa;\n  border-radius: 10px;\n  border: 2px dashed #e6e9f4;\n  width: 100%;\n}\n.call-option.verify-account {\n  min-width: 242px;\n}\n\n.option-radio {\n  appearance: none;\n  display: none;\n}\n.option-radio:checked + .call-lable {\n  box-shadow: 0 0 0 60px #0c4f8a inset;\n  color: #ffffff;\n}\n.option-radio:checked + .call-lable img {\n  filter: brightness(0) invert(1);\n}\n\n.call-lable {\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition-duration: 0.5s;\n  margin-bottom: 0px;\n  font-size: 16px;\n  font-weight: 500;\n  width: 100%;\n  min-height: 75px;\n  text-align: center;\n  border: 1px solid #e6e9f4;\n  cursor: pointer;\n}\n.call-lable img {\n  margin-right: 6px;\n  margin-bottom: 5px;\n}\n.call-lable.verify-lable.verify-lable {\n  width: 100%;\n  height: 170px;\n  font-size: 14px;\n  font-weight: 400;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.call-lable.verify-lable.verify-options {\n  height: 105px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 0px;\n  border-radius: 5px;\n}\n\n.accordion-body .onboarding-title h2 {\n  font-size: 16px;\n}\n.accordion-body .onboarding-title h6 {\n  font-size: 14px;\n}\n\n.prefer-box {\n  border-radius: 4px;\n  box-shadow: 0px 4px 24px rgba(227, 227, 227, 0.25);\n  width: 100%;\n  padding: 36px;\n  color: #000000;\n  font-size: 16px;\n  font-weight: 400;\n  border: 1px solid #e6e9f4;\n}\n.prefer-box .right-sec i {\n  font-size: 16px;\n  color: #433489;\n}\n.prefer-box:hover {\n  box-shadow: 0px 0px 10px 3px rgb(212, 237, 255);\n}\n\n.verify-item {\n  margin-bottom: 15px;\n  font-size: 14px;\n  line-height: 1.8;\n}\n.verify-item::marker {\n  color: #0c4f8a;\n  font-size: 120%;\n}\n\n.verify-list {\n  padding: 0 0 0 20px;\n  margin-bottom: 0px;\n}\n.verify-list li:last-child {\n  margin-bottom: 0px;\n}\n\n.upload-sucess-note h6 {\n  color: #10906f;\n  font-weight: 400;\n  font-size: 16px;\n}\n.upload-sucess-note h6:nth-child(2) {\n  color: #3e45eb;\n  font-weight: 400;\n  font-size: 16px;\n  margin-top: 18px;\n}\n.upload-sucess-note h6:nth-child(2) i {\n  margin-left: 4px;\n  cursor: pointer;\n}\n\n.verify-box {\n  background: #fafdff;\n  padding: 16px;\n}\n\n.modal-content.id-pop-content {\n  border-radius: 10px;\n}\n\n.modal-header.id-pop-header {\n  border-bottom: none;\n  padding: 2rem 1rem 1rem 1rem;\n}\n\n.modal-footer.id-pop-footer {\n  border-top: none;\n  padding: 0.75rem 0rem 2rem 0rem;\n}\n\n.modal-body.id-pop-body {\n  padding: 1rem 3rem;\n}\n.modal-body.id-pop-body h2 {\n  font-weight: 500;\n  font-size: 28px;\n  margin-bottom: 14px;\n}\n.modal-body.id-pop-body p {\n  font-weight: 400;\n  font-size: 15px;\n  color: #585858;\n}\n.modal-body.id-pop-body h3 {\n  font-weight: 500;\n  font-size: 20px;\n}\n.modal-body.id-pop-body span {\n  font-weight: 500;\n  font-size: 20px;\n  color: #228fe0;\n  padding-bottom: 30px;\n  display: block;\n}\n\n.modal.show .modal-dialog.id-upload {\n  max-width: 600px;\n}\n\n.fade.fade-custom {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.set-path {\n  width: 100%;\n  height: 100vh;\n  align-items: center;\n  justify-content: center;\n}\n\n.lock-content img {\n  margin-bottom: 20px;\n}\n.lock-content h2 {\n  font-weight: 500;\n  font-size: 24px;\n}\n.lock-content h6 {\n  margin: 15px 0px 30px 0px;\n  font-weight: 400;\n  font-size: 16px;\n  color: #585858;\n}\n.lock-content a {\n  color: #ff0202;\n  font-weight: 600;\n  font-size: 16px;\n}\n.lock-content a:hover {\n  color: #000000;\n}\n\n.mail-icon2 {\n  background: url(../images/icons/phone.png) no-repeat 99% 50%;\n}\n\n.pass-icon {\n  background: url(../images/icons/password-duotone.svg) no-repeat 99% 50%;\n}\n\n.pass-icon-1 {\n  background: url(../images/icons/fluent-password.svg) no-repeat 99% 50%;\n}\n\n.form-group.pass-group {\n  margin-bottom: 2rem;\n}\n\n.method-btn a {\n  color: #0c4f8a;\n  font-weight: 500;\n  font-size: 14px;\n}\n.method-btn a:hover {\n  color: #09e5ab;\n}\n\n.code-title {\n  background: rgba(76, 218, 180, 0.1);\n  border-radius: 4px;\n  margin: 30px 0px;\n  padding: 12px 15px;\n}\n.code-title h6 {\n  color: #10916f;\n  font-weight: 400;\n  font-size: 15px;\n  margin-bottom: 0px;\n}\n\n.opt-resend {\n  padding-top: 30px;\n  position: relative;\n}\n.opt-resend a {\n  font-weight: 500;\n  font-size: 16px;\n  position: absolute;\n  left: 0px;\n}\n\n.upload-patient-btn {\n  position: relative;\n  margin-bottom: 15px;\n}\n.upload-patient-btn:hover .pic-upload-btn {\n  color: #09e5ab;\n}\n\n#patient-verified .modal-body.id-pop-body p {\n  font-size: 16px;\n  max-width: 280px;\n  margin: auto;\n}\n\n.upload-patient-pic {\n  padding: 10px 0px 30px 0px;\n}\n.upload-patient-pic input[type=\"file\"] {\n  opacity: 0;\n  max-width: 468px;\n  min-height: 60px;\n  cursor: pointer;\n  top: 0px;\n  left: 87px;\n  position: absolute;\n}\n\n.pic-upload-btn {\n  margin: auto;\n  padding: 20px;\n  background: #ffffff;\n  border: 1px solid #f4f4f4;\n  box-shadow: 0px 4px 10px rgba(225, 225, 225, 0.25);\n  border-radius: 5px;\n  cursor: pointer;\n  display: block;\n  max-width: 475px;\n  text-align: center;\n  z-index: 99999;\n}\n\n.onboarding-contents {\n  justify-content: center;\n}\n\n.uploads-report {\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.uploads-report a:nth-child(1) {\n  margin-bottom: 20px;\n}\n\n.select-gender-option [type=\"radio\"]:checked,\n.select-gender-option [type=\"radio\"]:not(:checked) {\n  position: absolute;\n  left: -9999px;\n}\n\n.select-gender-option [type=\"radio\"]:checked + label,\n.select-gender-col [type=\"radio\"]:not(:checked) + label {\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.select-gender-option label {\n  background: #ffffff;\n  box-shadow: 0px 4px 24px rgba(194, 194, 194, 0.25);\n  border-radius: 5px;\n  padding: 28px;\n  width: 100%;\n  text-align: center;\n  position: relative;\n}\n.select-gender-option [type=\"radio\"]:not(:checked) + label:after {\n  opacity: 0;\n}\n\n.select-gender-option [type=\"radio\"]:checked + label:after,\n.select-gender-option [type=\"radio\"]:not(:checked) + label:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: rgba(212, 237, 255, 0.25);\n  border: 2px solid #228fe0;\n  box-shadow: 0px 4px 24px rgba(34, 143, 224, 0.04);\n  border-radius: 5px;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n  border: 2px solid #0de0fe;\n}\n\n.login-header .form-focus .focus-label {\n  top: -6px;\n  color: #585858;\n}\n\n.relative-form {\n  position: relative;\n  background: #f5f6fa;\n  border: 1px solid #e6e9f4;\n  border-radius: 5px;\n  min-height: 54px;\n  padding: 6px 15px;\n  align-items: center;\n}\n.relative-form span {\n  color: #131523;\n}\n.relative-form .form-control::placeholder {\n  color: #131523;\n  font-weight: 400;\n  font-size: 14px;\n}\n.relative-form .btn {\n  border-radius: 6px;\n  padding: 5px 15px;\n  position: absolute;\n  top: 7px;\n  right: 7px;\n}\n\n.relative-file-upload {\n  color: #000;\n  padding: 11px 35px;\n  font-size: 14px;\n  margin-bottom: 0;\n  cursor: pointer;\n  position: absolute;\n  right: 4px;\n  -webkit-transition: 0.7s;\n  -moz-transition: 0.7s;\n  -o-transition: 0.7s;\n  transition: 0.7s;\n  background: #eeeeee;\n  border-radius: 4px;\n}\n.relative-file-upload:hover {\n  color: #ffffff;\n  background: #bdb8b8;\n  -webkit-transition: 0.5s;\n  -moz-transition: 0.5s;\n  -o-transition: 0.5s;\n  transition: 0.5s;\n}\n.relative-file-upload input[type=\"file\"] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  text-align: right;\n  filter: alpha(opacity=0);\n  opacity: 0;\n  outline: none;\n  background: #ffffff;\n  cursor: inherit;\n  display: block;\n}\n\n.onboarding-content .checklist-col .custom_check .checkmark {\n  width: 35px;\n}\n.onboarding-content .checklist-col .custom_check .checkmark:after {\n  left: 10px;\n  top: 3px;\n}\n.onboarding-content .checklist-col.pregnant-col .remember-me-col .custom_check .checkmark {\n  border-color: #228fe0;\n}\n.onboarding-content .checklist-col .remember-me-col {\n  border-bottom: 1px solid #f4f4f4;\n}\n.onboarding-content .custom_check .checkmark {\n  left: -10px;\n}\n.onboarding-content .custom_check .checkmark::after {\n  color: #ffffff;\n}\n.onboarding-content .custom_check input:checked ~ .checkmark {\n  background-color: #228fe0;\n}\n.onboarding-content .increment-decrement .input-groups input[type=\"button\"] {\n  background-color: transparent;\n  font-size: 20px;\n  border: 1px solid #228fe0;\n  border-radius: 4px;\n  height: 24px;\n  width: 35px;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  margin-top: 0px;\n  line-height: 0;\n  padding: 0px;\n  color: #228fe0;\n}\n\n.modal-footer.id-pop-footer.text-center {\n  justify-content: center;\n}\n\n@keyframes mymove {\n  to {\n    transform: translateY(-5px);\n  }\n}\n@media (max-width: 991.98px) {\n  .right-panel-title {\n    display: block;\n  }\n  .right-panel-title img {\n    max-width: 140px;\n  }\n  .onboarding-content-box.content-wrap {\n    min-height: auto;\n  }\n  .onboarding-list h6 {\n    font-size: 15px;\n  }\n  .onboarding-list p {\n    font-size: 13px;\n  }\n  .onboarding-progress span {\n    font-size: 12px;\n  }\n  .onboarding-title h2 {\n    font-weight: 450;\n    font-size: 22px;\n  }\n  .onboarding-title h6 {\n    font-size: 14px;\n  }\n  .onboarding-lable {\n    font-size: 13px;\n  }\n  .passcode-wrap.mail-box input {\n    font-size: 14px;\n    height: 50px;\n  }\n  .passcode-wrap.mail-box textarea {\n    height: 100px;\n  }\n  .passcode-wrap.form-focus .focus-label {\n    top: -8px;\n  }\n  .passcode-wrap input {\n    width: 77px;\n    height: 50px;\n    font-size: 24px;\n    font-weight: 400;\n  }\n  .right-panel .select2-container .select2-selection--single {\n    height: 50px;\n  }\n  .right-panel .select2-container--default .select2-selection--single .select2-selection__rendered {\n    line-height: 50px;\n  }\n  .right-panel .select2-container--default .select2-selection--single .select2-selection__arrow {\n    height: 50px;\n  }\n  .onboarding-btn {\n    margin-top: 75px;\n  }\n  .onboarding-btn a {\n    padding: 13px 45px;\n    font-size: 14px;\n  }\n  .onboarding-btn.step-2-btn {\n    margin-top: 50px;\n  }\n  .onboarding-btn.Consultation-btn.cost-btns {\n    margin-top: 10px;\n  }\n  .onboarding-content-box {\n    margin-top: 0px;\n    padding: 30px;\n  }\n  .method-btn a {\n    font-size: 12px;\n  }\n  .code-title {\n    padding: 10px 12px;\n    margin: 22px 0px;\n  }\n  .code-title h6 {\n    font-size: 14px;\n  }\n  .weekDays-selector input[type=\"checkbox\"] + label {\n    font-size: 16px;\n    padding: 14px 22px;\n  }\n  .onboard-wrapper {\n    height: auto;\n  }\n  .modal.show .modal-dialog.id-upload {\n    max-width: 400px;\n  }\n  .modal-header.id-pop-header {\n    padding: 5px;\n  }\n  .modal-body.id-pop-body {\n    padding: 5px;\n  }\n  .modal-body.id-pop-body h2 {\n    font-size: 20px;\n  }\n  .modal-body.id-pop-body p {\n    font-size: 12px;\n  }\n  .modal-footer.id-pop-footer {\n    border-top: none;\n    padding: 2px 0px 5px 0px;\n  }\n  .call-lable {\n    font-size: 14px;\n    width: 172px;\n  }\n  .call-lable.verify-lable.verify-lable {\n    height: 120px;\n  }\n  .upload-sucess-note h6 {\n    font-size: 14px;\n  }\n  .upload-sucess-note h6:nth-child(2) {\n    font-size: 14px;\n  }\n  .payment-icon img {\n    top: -168px;\n    right: 10px;\n  }\n  .tog-slider:before {\n    height: 12px;\n    width: 12px;\n  }\n  .tog-slider.round {\n    width: 50px;\n    height: 22px;\n  }\n  .save-card h6 {\n    font-size: 13px;\n    margin-bottom: 0px;\n  }\n  .prefer-box {\n    padding: 24px;\n    font-size: 14px;\n  }\n  .call-option {\n    width: max-content;\n  }\n  .onboard-page {\n    overflow: auto;\n  }\n  .on-board-wizard {\n    padding-top: 25px;\n    top: 50px;\n  }\n}\n@media (max-width: 575.98px) {\n  .onboarding-progress span {\n    font-size: 13px;\n  }\n  .onboarding-title {\n    text-align: center;\n  }\n  .onboarding-title h2 {\n    font-weight: 500;\n    font-size: 18px;\n  }\n  .onboarding-title h6 {\n    font-size: 14px;\n  }\n  .verify-box {\n    padding: 5px;\n  }\n  .verify-item {\n    font-size: 14px;\n    margin-bottom: 2px;\n  }\n  .onboarding-content-box {\n    padding: 20px;\n  }\n  .btn-profile img {\n    height: 30px;\n    width: 30px;\n  }\n  .upload-pic {\n    height: 100px;\n    width: 120px;\n  }\n  .upload-pic h6 {\n    font-size: 14px;\n  }\n  .passcode-wrap.mail-box input {\n    font-size: 10px;\n    height: 40px;\n  }\n  .passcode-wrap.mail-box textarea {\n    height: 90px;\n  }\n  .passcode-wrap.form-focus .focus-label {\n    top: -9px;\n  }\n  .passcode-wrap input {\n    width: 48px;\n    height: 43px;\n    font-size: 19px;\n    font-weight: 400;\n  }\n  .onboarding-btn {\n    margin-top: 10px;\n    text-align: center;\n  }\n  .onboarding-btn.Personalize-btn {\n    margin-top: 15px;\n    text-align: center;\n  }\n  .onboarding-btn a {\n    padding: 10px 30px;\n    font-size: 14px;\n    margin-top: 15px;\n  }\n  .onboarding-btn.step-2-btn {\n    margin-top: 25px;\n  }\n  .onboarding-btn.prefer-btn {\n    margin-top: 10px;\n  }\n  .onboarding-btn.Consultation-btn {\n    margin-top: 15px;\n  }\n  .on-board-wizard {\n    padding-left: 0px;\n  }\n  .right-panel .select2-container .select2-selection--single {\n    height: 43px;\n  }\n  .right-panel .select2-container--default .select2-selection--single .select2-selection__rendered {\n    line-height: 40px;\n    font-size: 14px;\n  }\n  .right-panel .select2-container--default .select2-selection--single .select2-selection__arrow {\n    height: 42px;\n  }\n  .right-panel .accordion-button {\n    padding: 20px;\n  }\n  .select2-results__option[aria-selected] {\n    font-size: 11px;\n  }\n  .consult-option {\n    flex-direction: column;\n    align-items: center;\n  }\n  .call-option {\n    margin-bottom: 20px;\n    margin-right: 0px;\n  }\n  .call-lable {\n    font-size: 14px;\n  }\n  .call-lable.verify-lable.verify-options {\n    width: 253px;\n    height: 118px;\n  }\n  .call-lable.verify-lable.verify-lable {\n    height: 100px;\n  }\n  .code-title {\n    margin: 10px 0px;\n  }\n  .code-title h6 {\n    font-size: 12px;\n  }\n  .weekDays-selector input[type=\"checkbox\"] + label {\n    padding: 12px 22px;\n    font-size: 14px;\n  }\n  .modal-body.id-pop-body h2 {\n    font-size: 18px;\n  }\n  .modal-body.id-pop-body p {\n    font-size: 14px;\n    margin-bottom: 0px;\n  }\n  .modal-body.id-pop-body span {\n    font-size: 18px;\n    padding-bottom: 10px;\n  }\n  .upload-pics input[type=\"file\"] {\n    height: 60px;\n  }\n  .photo-norms h5 {\n    margin-bottom: 0px;\n  }\n  .upload-sucess-note h6 {\n    font-size: 13px;\n  }\n  .payment-icon img {\n    top: -210px;\n  }\n  .prefer-box {\n    padding: 12px;\n    font-size: 14px;\n  }\n  .relative-file-upload {\n    padding: 9px 10px;\n  }\n  .opt-resend {\n    padding-top: 12px;\n    padding-bottom: 30px;\n  }\n  .opt-resend a {\n    font-size: 14px;\n    left: auto;\n    left: 0px;\n  }\n  .select-gender-option {\n    flex-direction: column;\n  }\n}\n.signup-option-btns .signup-btn-info {\n  width: 100%;\n  background: #f5f5f5;\n  border: 1px solid #e4e4e8;\n  border-radius: 8px;\n  margin: 0;\n  padding: 12px 15px;\n  margin-bottom: 20px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.signup-option-btns .signup-btn-info:hover {\n  background: #ffffff;\n  border: 1px solid #0e82fd;\n  box-shadow: 0px 22px 38px rgba(0, 0, 0, 0.12);\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.signup-option-btns .signup-btn-info:hover .signup-arrow {\n  background: #0e82fd;\n  color: #ffffff;\n  -webkit-transition: 0.4s;\n  -ms-transition: 0.4s;\n  transition: 0.4s;\n}\n.signup-option-btns .signup-btn-info:last-child {\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .signup-option-btns .signup-btn-info {\n    margin: 0;\n    padding: 10px;\n    margin-bottom: 20px;\n  }\n}\n\n.signup-info .signup-icon {\n  margin-right: 16px;\n}\n\n.signup-content {\n  text-align: left;\n}\n.signup-content h4 {\n  font-weight: 500;\n  font-size: 20px;\n  margin-bottom: 6px;\n}\n@media (max-width: 991.98px) {\n  .signup-content h4 {\n    font-size: 18px;\n  }\n}\n.signup-content p {\n  color: #71717a;\n  margin-bottom: 0;\n  font-size: 14px;\n}\n\n.signup-arrow {\n  width: 37px;\n  height: 37px;\n  background: #ffffff;\n  color: #000000;\n  font-size: 16px;\n  border-radius: 50px;\n  -webkit-transition: 0.4s;\n  -ms-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.terms-check-box label {\n  color: #838383;\n}\n.terms-check-box label a {\n  color: #525252;\n  text-decoration: underline;\n}\n.terms-check-box label a:hover {\n  color: #0e82fd;\n}\n\n.account-signup {\n  text-align: center;\n}\n.account-signup p {\n  color: #696969;\n  margin-bottom: 0;\n}\n.account-signup p a {\n  font-size: 14px;\n  font-weight: 500;\n  color: #0e82fd;\n  text-decoration: underline;\n}\n.account-signup p a:hover {\n  color: #0e82fd;\n  text-decoration: none;\n}\n\n.login-verify-img {\n  padding-bottom: 50px;\n}\n@media (max-width: 991.98px) {\n  .login-verify-img {\n    padding-bottom: 30px;\n  }\n}\n@media (max-width: 767.98px) {\n  .login-verify-img {\n    padding-bottom: 20px;\n  }\n}\n\n.otp-box .form-group {\n  margin-bottom: 30px;\n}\n@media (max-width: 767.98px) {\n  .otp-box .form-group {\n    margin-bottom: 20px;\n  }\n}\n.otp-box input {\n  width: 74px;\n  height: 74px;\n  background: #f9f9f9;\n  border: 2px solid #acacac;\n  border-radius: 8px;\n  text-align: center;\n  margin-right: 15px;\n  font-weight: 700;\n  font-size: 26px;\n  color: #000000;\n  outline: none;\n}\n.otp-box input:last-child {\n  margin-right: 0;\n}\n@media (max-width: 991.98px) {\n  .otp-box input {\n    width: 68px;\n    height: 68px;\n  }\n}\n@media (max-width: 767.98px) {\n  .otp-box input {\n    width: 60px;\n    height: 60px;\n    font-size: 24px;\n  }\n}\n\n.otp-info {\n  padding-bottom: 20px;\n}\n@media (max-width: 767.98px) {\n  .otp-info {\n    padding-bottom: 0;\n  }\n}\n\n.otp-code p {\n  color: #5b5b5b;\n  margin-bottom: 8px;\n}\n.otp-code a {\n  font-weight: 500;\n  color: #0e82fd;\n  text-decoration: underline;\n}\n.otp-code a:hover {\n  text-decoration: none;\n}\n\n.otp-sec p {\n  background: #f9f9f9;\n  border-radius: 4px;\n  color: #717171;\n  padding: 4px 7px;\n}\n.otp-sec p i {\n  font-size: 16px;\n  margin-right: 6px;\n}\n\n.forgot-link {\n  font-weight: 500;\n  color: #0e82fd;\n  margin-bottom: 10px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.forgot-link:hover {\n  color: #000000;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n\n.signup-code {\n  font-size: 11px;\n  color: #9e9e9e;\n  margin: 7px 0 0 0;\n  padding: 0;\n}\n\n.multistep-form #first {\n  display: block;\n}\n.multistep-form fieldset {\n  display: none;\n  width: 100%;\n}\n\n.widget-setcount {\n  padding-bottom: 40px;\n}\n.widget-setcount ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.widget-setcount ul li {\n  margin-right: 0;\n  margin-bottom: 10px;\n  position: relative;\n}\n.widget-setcount ul li:last-child {\n  margin-right: 0;\n}\n.widget-setcount ul li:last-child:before {\n  display: none;\n}\n.widget-setcount ul li:before {\n  position: absolute;\n  top: 50%;\n  right: -66px;\n  content: \"\";\n  width: 50px;\n  height: 2px;\n  background: #e0e0e0;\n}\n.widget-setcount ul .progress-activated:before {\n  background: #0e82fd;\n}\n.widget-setcount .step-icon {\n  width: 45px;\n  height: 45px;\n  background: #c9e3fe;\n  border-radius: 50px;\n  margin-right: 15px;\n}\n.widget-setcount .step-content p {\n  color: #e0e0e0;\n  margin-bottom: 5px;\n}\n.widget-setcount .step-content h4 {\n  font-weight: 500;\n  font-size: 16px;\n  color: #e0e0e0;\n  margin-bottom: 0;\n}\n.widget-setcount .progress-activated .step-icon {\n  background: #0e82fd;\n}\n.widget-setcount .progress-activated .step-content p {\n  color: #858585;\n}\n.widget-setcount .progress-activated .step-content h4 {\n  color: #000000;\n}\n.widget-setcount .progress-active .step-icon {\n  background: #0e82fd;\n}\n.widget-setcount .progress-active .step-content p {\n  color: #858585;\n}\n.widget-setcount .progress-active .step-content h4 {\n  color: #000000;\n}\n\n.form-check-box .custom_check {\n  margin-bottom: 0;\n}\n\n.form-check-box .custom_check .checkmark::after {\n  content: \"\";\n  background: #0e82fd;\n  width: 12px;\n  height: 12px;\n  top: 3px;\n  left: 3px;\n  border-radius: 3px;\n}\n\n/*.custom_check {\n\tcolor: $__congo_brown;\n\tdisplay: $__inline__block;\n\tposition: $__relative;\n\tfont-size: $__font__size__14;\n\tpadding-left: 30px;\n\tmargin-bottom: 10px;\n\tcursor: $__pointer;\n\tuser-select: $__none\n}\n.custom_check input {\n\tposition: $__absolute;\n\topacity: 0;\n\tcursor: $__pointer;\n}\n.custom_check input:checked ~ .checkmark {\n\tbackground-color: $__white;\n\tborder-color: $__misty_rose;\n}\n.custom_check .checkmark {\n\t@include position($__absolute, 0, null, null, 0);\n\theight: 20px;\n\twidth: 20px;\n\tborder: 1px solid $__white_shade;\n\tbackground-color: $__white;\n\tborder-radius: 3px;\n\t@include transition(all 0.3s ease-in-out);\n}\n.custom_check .checkmark::after {\n    content: \"\\f00c\";\n    font-family: $__fontawesome__family;\n    font-weight: $__bolder;\n\t@include position($__absolute, 50%, null, null, 4px);\n    display: $__none;\n    color: $__blue__14;\n    font-size: $__font__size__12;\n}\n.custom_check input:checked ~ .checkmark:after {\n\tdisplay: $__block;\n}\n*/\n.contact-section {\n  margin: 0;\n  padding: 80px 0 55px;\n}\n@media (max-width: 991.98px) {\n  .contact-section {\n    margin: 0;\n    padding: 40px 0 15px;\n  }\n}\n@media (max-width: 767.98px) {\n  .contact-section {\n    margin: 0;\n    padding: 40px 0 20px;\n  }\n}\n\n.contact-inner-header {\n  margin-bottom: 40px;\n}\n@media (max-width: 767.98px) {\n  .contact-inner-header {\n    margin-bottom: 30px;\n  }\n}\n\n.contact-card {\n  border: 2px solid #e9eaf6;\n  border-radius: 0;\n}\n.contact-card .card-body {\n  margin: 0;\n  padding: 30px;\n}\n@media (max-width: 991.98px) {\n  .contact-card .card-body {\n    margin: 0;\n    padding: 20px;\n  }\n}\n@media (max-width: 767.98px) {\n  .contact-card .card-body {\n    margin: 0;\n    padding: 15px;\n  }\n}\n\n.contact-icon {\n  color: #0e82fd;\n  font-size: 44px;\n  margin-right: 20px;\n}\n@media (max-width: 991.98px) {\n  .contact-icon {\n    font-size: 40px;\n    margin-right: 15px;\n  }\n}\n\n.contact-details h4 {\n  font-weight: 600;\n  font-size: 20px;\n  color: #0a0b0d;\n  margin-bottom: 8px;\n}\n@media (max-width: 991.98px) {\n  .contact-details h4 {\n    font-size: 18px;\n  }\n}\n.contact-details p {\n  font-size: 16px;\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .contact-details p {\n    font-size: 14px;\n  }\n}\n\n.contact-form-card {\n  background: #f8fbff;\n  border-radius: 10px;\n  border: 0;\n}\n.contact-form-card .card-body {\n  margin: 0;\n  padding: 30px;\n}\n@media (max-width: 991.98px) {\n  .contact-form-card .card-body {\n    margin: 0;\n    padding: 20px;\n  }\n}\n@media (max-width: 767.98px) {\n  .contact-form-card .card-body {\n    margin: 0;\n    padding: 15px;\n  }\n}\n.contact-form-card .form-group {\n  margin-bottom: 25px;\n}\n.contact-form-card .form-group label {\n  font-size: 12px;\n  color: #0a0b0d;\n  margin-bottom: 8px;\n}\n.contact-form-card .form-group .form-control {\n  font-weight: 500;\n  color: #6b7280;\n}\n.contact-form-card .form-group .form-control::placeholder {\n  font-weight: 500;\n  color: #6b7280;\n}\n.contact-form-card .form-group textarea.form-control {\n  min-height: 150px;\n  resize: none;\n}\n.contact-form-card .form-group-btn {\n  margin-top: 35px;\n}\n.contact-form-card .form-group-btn .btn {\n  border-radius: 5px;\n  min-width: 150px;\n  margin: 0;\n  padding: 10px 15px;\n  font-weight: 500;\n}\n\n.contact-map iframe {\n  width: 100%;\n  border: none;\n  height: 450px;\n}\n\n.error-section {\n  margin: 0;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .error-section {\n    margin: 0;\n    padding: 40px 0;\n  }\n}\n\n.error-img {\n  padding-bottom: 50px;\n}\n@media (max-width: 767.98px) {\n  .error-img {\n    padding-bottom: 25px;\n  }\n}\n\n.error-404-img {\n  position: relative;\n}\n\n.error-404-content {\n  width: 100%;\n  position: absolute;\n  bottom: 30px;\n}\n@media (max-width: 1399.98px) {\n  .error-404-content {\n    bottom: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .error-404-content {\n    position: static;\n    margin-top: 20px;\n  }\n}\n\n.error-content h2 {\n  font-weight: 600;\n  font-size: 38px;\n  color: #0a0b0d;\n  margin-bottom: 10px;\n}\n@media (max-width: 991.98px) {\n  .error-content h2 {\n    font-size: 32px;\n  }\n}\n@media (max-width: 767.98px) {\n  .error-content h2 {\n    font-size: 22px;\n  }\n}\n.error-content p {\n  font-weight: 500;\n  font-size: 16px;\n  color: #6b7280;\n  margin-bottom: 40px;\n}\n@media (max-width: 767.98px) {\n  .error-content p {\n    font-size: 14px;\n    margin-bottom: 20px;\n  }\n}\n.error-content .btn {\n  min-width: 246px;\n  font-size: 18px;\n  display: inline-block;\n  margin: 0;\n  padding: 13px 15px;\n}\n@media (max-width: 991.98px) {\n  .error-content .btn {\n    min-width: 230px;\n    font-size: 16px;\n    margin: 0;\n    padding: 10px 15px;\n  }\n}\n@media (max-width: 767.98px) {\n  .error-content .btn {\n    min-width: 150px;\n    font-size: 14px;\n    margin: 0;\n    padding: 8px 15px;\n  }\n}\n\n.coming-soon-count {\n  width: 104px;\n  height: 104px;\n  margin: 0 16px 0 0;\n  padding: 13px;\n  border-radius: 50px;\n  background: #0ce0ff;\n  flex-shrink: 0;\n}\n.coming-soon-count:last-child {\n  margin-right: 0;\n}\n.coming-soon-count h4 {\n  font-weight: 600;\n  font-size: 40px;\n  color: #ffffff;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .coming-soon-count h4 {\n    font-size: 20px;\n  }\n}\n.coming-soon-count p {\n  font-size: 18px;\n  color: #ffffff;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .coming-soon-count p {\n    font-size: 13px;\n  }\n}\n@media (max-width: 767.98px) {\n  .coming-soon-count {\n    width: 66px;\n    height: 66px;\n    margin: 0 10px 0 0;\n    padding: 8px;\n  }\n}\n\n.terms-section {\n  margin: 0;\n  padding: 80px 0;\n}\n@media (max-width: 991.98px) {\n  .terms-section {\n    margin: 0;\n    padding: 40px 0;\n  }\n}\n.terms-section .terms-content {\n  padding-bottom: 50px;\n}\n.terms-section .terms-content .terms-text {\n  padding-bottom: 24px;\n}\n.terms-section .terms-content .terms-text:last-child {\n  padding-bottom: 0;\n}\n.terms-section .terms-content .terms-text p {\n  font-size: 16px;\n  color: #6b7280;\n  margin-bottom: 24px;\n}\n.terms-section .terms-content .terms-text p:last-child {\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .terms-section .terms-content .terms-text p {\n    font-size: 14px;\n    margin-bottom: 20px;\n  }\n}\n.terms-section .terms-content .terms-text.terms-list p {\n  margin-bottom: 10px;\n}\n.terms-section .terms-content .terms-text.terms-list p i {\n  position: relative;\n  top: 4px;\n  margin-right: 8px;\n  color: #0e82fd;\n}\n@media (max-width: 991.98px) {\n  .terms-section .terms-content {\n    padding-bottom: 30px;\n  }\n}\n\n.terms-btn .btn-right-now {\n  font-weight: 500;\n  font-size: 16px;\n  margin: 0 15px 0 0;\n  padding: 5px 15px;\n  min-width: 149px;\n  border-radius: 8px;\n  color: #3f3f3f;\n  background: #f3f3f3;\n  border: 1px solid #f3f3f3;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.terms-btn .btn-right-now:hover {\n  color: #ffffff;\n  background: #0e82fd;\n  border-color: #0e82fd;\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n@media (max-width: 767.98px) {\n  .terms-btn .btn-right-now {\n    font-size: 14px;\n    min-width: 130px;\n    margin-right: 0;\n  }\n}\n.terms-btn .btn-primary {\n  padding: 5px 15px;\n  min-width: 166px;\n  font-weight: 600;\n}\n@media (max-width: 767.98px) {\n  .terms-btn .btn-primary {\n    min-width: 150px;\n  }\n}\n@media (max-width: 767.98px) {\n  .terms-btn {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.consultation-info {\n  padding-bottom: 25px;\n}\n.consultation-info p {\n  font-weight: 500;\n  font-size: 16px;\n  color: #000000;\n  margin-bottom: 20px;\n}\n@media (max-width: 991.98px) {\n  .consultation-info p {\n    margin-bottom: 15px;\n  }\n}\n\n.consultation-list ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.consultation-list ul li {\n  display: block;\n  margin-bottom: 15px;\n}\n.consultation-list ul li:last-child {\n  margin-bottom: 0;\n}\n\n.consultation-types a {\n  font-weight: 500;\n  font-size: 16px;\n  color: #6b6b6b;\n  background: #ffffff;\n  border: 1px solid #c2c2c2;\n  border-radius: 6px;\n  min-width: 413px;\n  margin: 0;\n  padding: 10px 15px;\n}\n.consultation-types a:hover {\n  color: #0e82fd;\n  background: #ffffff;\n  border: 1px solid #0e82fd;\n}\n.consultation-types a i {\n  font-size: 18px;\n  margin-right: 10px;\n}\n@media (max-width: 991.98px) {\n  .consultation-types a {\n    min-width: 300px;\n  }\n}\n@media (max-width: 767.98px) {\n  .consultation-types a {\n    font-size: 14px;\n    min-width: 250px;\n    margin: 0;\n    padding: 7px 15px;\n  }\n}\n.consultation-types span {\n  margin-left: 18px;\n  font-size: 20px;\n  color: #28a745;\n  display: none;\n}\n.consultation-types.active a {\n  color: #0e82fd;\n  background: #ffffff;\n  border: 1px solid #0e82fd;\n  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.07);\n}\n.consultation-types.active span {\n  display: block;\n}\n\n.booking-device-img {\n  margin-right: 15px;\n}\n\n.booking-doctor-info h3 {\n  font-weight: 500;\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n.booking-doctor-info .device-text {\n  margin-bottom: 12px;\n}\n.booking-doctor-info .btn {\n  font-weight: 500;\n  font-size: 14px;\n  margin: 0;\n  padding: 4px 10px;\n  min-width: 109px;\n  color: #0e82fd;\n  background: #ffffff;\n  border: 2px solid #0e82fd;\n  box-shadow: inset 0 0 0 0 #0e82fd;\n  border-radius: 6px;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.booking-doctor-info .btn:hover {\n  color: #ffffff;\n  background: #0e82fd;\n  box-shadow: inset 0 0 0 50px #0e82fd;\n  border: 2px solid #0e82fd;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n\n.app-images a {\n  margin-right: 8px;\n}\n.app-images a:last-child {\n  margin-right: 0;\n}\n\n.booking-date {\n  padding-bottom: 30px;\n}\n.booking-date p {\n  color: #8c8c8c;\n  margin: 0 10px 0 0;\n  padding: 0;\n  margin-right: 10px;\n  margin-bottom: 0;\n}\n@media (max-width: 767.98px) {\n  .booking-date p {\n    margin: 0 0 10px 0;\n    padding: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .booking-date {\n    display: block;\n    padding-bottom: 20px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .time-slot-card-body {\n    padding-bottom: 0 !important;\n  }\n}\n\n.booking-range .btn {\n  background: #ffffff;\n  border: 1px solid #e4e4e8;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: normal;\n  color: #4a4a4a;\n  margin: 0;\n  padding: 10px 15px;\n}\n@media (max-width: 767.98px) {\n  .booking-range .btn {\n    font-size: 13px;\n    margin: 0;\n    padding: 10px;\n    position: relative;\n  }\n}\n.booking-range img {\n  margin-right: 10px;\n}\n.booking-range i {\n  font-size: 16px;\n  margin-left: 10px;\n  color: #5b5b5b;\n}\n\n.booking-card {\n  border: 2px solid #f4f4f4;\n  border-radius: 8px;\n  margin-bottom: 25px;\n}\n\n.booking-date-slider {\n  padding-bottom: 30px;\n}\n\n.date-slider {\n  text-align: center;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.date-slider .slick-slide {\n  display: block;\n  margin: 0;\n  padding: 0 5px;\n}\n.date-slider li h4 {\n  font-weight: 500;\n  font-size: 16px;\n  color: #b9b9b9;\n  margin-bottom: 5px;\n}\n@media (max-width: 1199.98px) {\n  .date-slider li h4 {\n    font-size: 13px;\n  }\n}\n@media (max-width: 991.98px) {\n  .date-slider li h4 {\n    font-size: 16px;\n  }\n}\n.date-slider li p {\n  color: #d4d4d4;\n  margin-bottom: 0;\n}\n.date-slider li.active h4 {\n  color: #000000;\n}\n.date-slider li.active p {\n  color: #aaaaaa;\n}\n.date-slider .slick-prev:before {\n  content: \" \\e92f\";\n}\n.date-slider .slick-next:before {\n  content: \" \\e930\";\n}\n\n.date-slider .slick-prev,\n.date-slider .slick-next {\n  background: transparent;\n  color: #000000;\n  line-height: normal;\n}\n\n.date-slider .slick-prev:hover,\n.date-slider .slick-prev:focus,\n.date-slider .slick-next:hover,\n.date-slider .slick-next:focus {\n  background-color: transparent;\n  color: #09e5ab;\n  opacity: 1;\n}\n\n.date-slider .slick-prev:hover:before,\n.date-slider .slick-prev:focus:before,\n.date-slider .slick-next:hover:before,\n.date-slider .slick-next:focus:before {\n  color: #09e5ab;\n}\n\n.date-slider .slick-prev:before,\n.date-slider .slick-next:before {\n  font-family: \"feather\";\n  font-size: 26px;\n}\n\n.time-slot {\n  text-align: center;\n}\n.time-slot h4 {\n  font-weight: 500;\n  font-size: 16px;\n  margin-bottom: 20px;\n}\n.time-slot ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.time-slot ul li {\n  display: block;\n  margin-bottom: 15px;\n}\n.time-slot li:last-child {\n  margin-bottom: 0;\n}\n.time-slot li .timing {\n  background: #f5f5f5;\n  border: 2px solid #f3f3f3;\n  border-radius: 8px;\n  color: #595959;\n  margin: 0;\n  padding: 10px 15px;\n  text-align: center;\n  position: relative;\n  box-shadow: inset 0 0 0 0 #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.time-slot li .timing:hover {\n  background: #ffffff;\n  box-shadow: inset 0 0 0 50px #ffffff;\n  -webkit-transition: 0.7s;\n  -ms-transition: 0.7s;\n  transition: 0.7s;\n}\n.time-slot li .timing.active {\n  background: #09e5ab;\n  border: 2px solid #09e5ab;\n  color: #ffffff;\n  box-shadow: inset 0 0 0 0 #09e5ab;\n}\n.time-slot li .timing.active:hover {\n  background: #09e5ab;\n  border: 2px solid #09e5ab;\n  color: #ffffff;\n  box-shadow: inset 0 0 0 50px #09e5ab;\n}\n.time-slot li .timing i {\n  margin-right: 4px;\n}\n.time-slot li .load-more-timings a {\n  font-weight: 500;\n  text-decoration: underline;\n  color: #09e5ab;\n}\n.time-slot li .load-more-timings a:hover {\n  color: #000000;\n}\n.time-slot .time-slot-open {\n  display: none;\n}\n@media (max-width: 991.98px) {\n  .time-slot {\n    padding-bottom: 15px;\n  }\n}\n\n.success-content {\n  text-align: center;\n  padding-bottom: 40px;\n}\n.success-content h4 {\n  font-weight: 500;\n  font-size: 18px;\n  margin-bottom: 0;\n}\n@media (max-width: 991.98px) {\n  .success-content h4 {\n    font-size: 16px;\n  }\n}\n@media (max-width: 991.98px) {\n  .success-content {\n    padding-bottom: 30px;\n  }\n}\n\n.success-icon {\n  padding-bottom: 15px;\n}\n.success-icon i {\n  font-size: 50px;\n  color: #28a745;\n}\n@media (max-width: 991.98px) {\n  .success-icon i {\n    font-size: 36px;\n  }\n}\n\n.booking-success-info {\n  padding-bottom: 20px;\n}\n.booking-success-info .booking-doctor-img {\n  width: 90px;\n  height: 90px;\n  border-radius: 10px;\n  margin-right: 15px;\n}\n.booking-success-info .booking-doctor-img img {\n  width: 90px;\n  height: 90px;\n  border-radius: 10px;\n}\n.booking-success-info .booking-doctor-info p {\n  margin-bottom: 15px;\n}\n\n.success-btn {\n  text-align: center;\n  padding-bottom: 25px;\n}\n.success-btn .btn {\n  font-weight: 500;\n  padding: 8px 18px;\n}\n@media (max-width: 767.98px) {\n  .success-btn .btn {\n    display: flex;\n  }\n}\n.success-btn .btn-primary {\n  margin-right: 15px;\n}\n@media (max-width: 767.98px) {\n  .success-btn .btn-primary {\n    margin: 0 0 10px 0;\n    padding: 8px 18px;\n  }\n}\n.success-btn .btn-light {\n  color: #7c7c7c;\n  background: #f5f5f5;\n}\n\n.success-dashboard-link {\n  text-align: center;\n}\n.success-dashboard-link a {\n  font-weight: 500;\n  font-size: 15px;\n  color: #959595;\n}\n.success-dashboard-link a:hover {\n  color: #0e82fd;\n}\n.success-dashboard-link a i {\n  margin-right: 12px;\n  font-size: 16px;\n}\n@media (max-width: 767.98px) {\n  .success-dashboard-link a {\n    font-size: 14px;\n  }\n}\n\n/*# sourceMappingURL=custom.css.map */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
